// @ts-nocheck
/* eslint-disable */
/*! Copyright © Apple Inc. All rights reserved. See LICENSE for additional license information. */
(() => {
  "use strict";
  var t = {
      d: (e, i) => {
        for (var n in i) t.o(i, n) && !t.o(e, n) && Object.defineProperty(e, n, {enumerable: !0, get: i[n]});
      },
      o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
      r: (t) => {
        ("undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, {value: "Module"}),
          Object.defineProperty(t, "__esModule", {value: !0}));
      }
    },
    e = {};
  (t.r(e),
    t.d(e, {
      APPLICATION_IDENTIFIER: () => St,
      BROWSER_INFO: () => Mt,
      BROWSER_WINDOW_SIZE: () => Lt,
      DEVICE_IDENTIFIER: () => wt,
      MAP_VIEW: () => Et,
      SCREEN_SIZE: () => vt,
      TILES: () => Tt,
      URL: () => At,
      USER_SESSION: () => xt
    }));
  const i = {version: "5.78.158", build: "24.45-703", cdnBase: "//cdn.apple-mapkit.com", cdnVersion: "5.78.158"},
    n = () => {},
    o = (t, e) => t - e * Math.floor(t / e),
    s = (t) => Math.log2(t),
    a = (t, e, i) => Math.max(e, Math.min(t, i)),
    r = (t, e, i) => {
      const n = {constructor: {enumerable: !0, value: e}};
      return (
        Object.keys(i).forEach(function (t) {
          const e = Object.getOwnPropertyDescriptor(i, t);
          e && (n[t] = e);
        }),
        Object.create(t.prototype, n)
      );
    },
    l = (t, e) => Object.keys(e).some((i) => e[i] === t),
    h = (t, e, i) => {
      if (void 0 === t || ((i?.checkNull ?? 1) && null === t)) throw new Error(e || "Missing parameter");
    },
    c = (t, e, i) => {
      if (typeof t !== e) throw new TypeError(i || `Expected \`${e}\` but got \`${typeof t}\``);
      if ("number" === e && isNaN(t)) throw new TypeError(i || `Expected \`${e}\` but got \`NaN\``);
      if ("object" === e && t instanceof Array)
        throw new TypeError(i || "Expected a non-array object but got an array");
    },
    d = (t, e, i) => {
      if (!(t instanceof e)) throw new Error(i || "Unexpected object instance");
    },
    u = (t, e) => {
      if (!Array.isArray(t)) throw new Error(e || "Expected an array");
    },
    p = (t, e) =>
      null == t ? {} : (c(t, "object", e || "[MapKit] The `options` parameter is not a valid object."), t),
    m = (t, e, i) =>
      t.replace(/{{(.*?)}}/g, (t, n) => {
        const o = e[n];
        if (i && null == o) throw new Error("fillTemplate: Missing value for parameter: " + n);
        return o ?? "";
      }),
    g = (t, e) => {
      if (null === t || "object" != typeof t) return "";
      const i = [];
      for (const n of e || Object.keys(t)) {
        const e = t[n];
        e && i.push(`${encodeURIComponent(n)}=${encodeURIComponent(e)}`);
      }
      return i.join("&");
    },
    _ = () => Math.floor(1e15 * (9 * Math.random() + 1));
  class f {
    constructor(t, e, i) {
      var n;
      ((this.language = t.toLowerCase()),
        (this.region = e ? e.toUpperCase() : null),
        (this.script = i ? ((n = i) ? n[0].toUpperCase() + n.substr(1).toLowerCase() : n) : null));
    }
    get tag() {
      return this.region
        ? `${this.language}-${this.region}`
        : this.script
          ? `${this.language}-${this.script}`
          : this.language;
    }
    toString() {
      return `{ language: ${this.language}${this.region ? `, region: ${this.region}` : ""}${this.script ? `, script: ${this.script}` : ""} }`;
    }
    static parse(t) {
      let e, i;
      if (t && "string" == typeof t) {
        if (-1 !== t.indexOf("_")) return (console.warn("Invalid character: '_'"), null);
        const n = t.split("-"),
          o = n[0];
        if (o.length < 2 || o.length > 4) return (console.warn("Invalid language:", t), null);
        if (!(n.length < 4))
          return (console.warn("Don't know how to parse language tags with more than 3 parts:", t), null);
        for (let o = 1; o < n.length; o += 1) {
          const s = n[o];
          if (4 === s.length) i = s;
          else {
            if (!(s.length > 1 && s.length < 4)) return (console.warn("Don't know how to parse:", t), null);
            e = s;
          }
        }
        return new f(o, e, i);
      }
      return null;
    }
  }
  const y = (t, e) => {
      if (!t) return;
      const {language: i, region: n, script: o} = t;
      ((e[i] = e[i] || {regions: [], scripts: []}), n && e[i].regions.push(n), o && e[i].scripts.push(o));
    },
    v = {zh: {CN: "Hans", HK: "Hant", TW: "Hant"}},
    w = {
      "en-AU": "en-GB",
      "en-IE": "en-GB",
      "en-IN": "en-GB",
      "en-NZ": "en-GB",
      "en-SG": "en-GB",
      "en-ZA": "en-GB",
      "es-LA": "es-MX",
      "es-XL": "es-MX",
      "nn-NO": "nb-NO",
      "no-NO": "nb-NO",
      "vi-VI": "vi-VN",
      iw: "he-IL"
    },
    b = new (class {
      constructor(t) {
        ((this.supportMap = {}), (this.delegate = t));
        for (const t of this.delegate.supportedLocales) y(f.parse(t), this.supportMap);
      }
      bestMatch(t, e) {
        let i = f.parse(t),
          n = null;
        if (i && this.delegate.localesMap) {
          const t = this.delegate.localesMap;
          t[i.tag] ? (i = f.parse(t[i.tag])) : t[i.language] && (i = f.parse(t[i.language]));
        }
        return (
          (e = e || null),
          i &&
            (n = ((t, e, i) => {
              const {language: n, region: o, script: s} = t;
              let a = s;
              const r = i[n];
              if (!r) return null;
              if (o) {
                const i = r.regions.find((e) => e.toUpperCase() === t.region?.toUpperCase());
                if (i) return new f(n, i);
                const s = e[n];
                s && s[o.toUpperCase()] && (t.script = a = s[o.toUpperCase()]);
              }
              if (a) {
                const e = r.scripts.find((e) => e.toUpperCase() === t.script?.toUpperCase());
                return new f(n, null, e);
              }
              return new f(n);
            })(i, this.delegate.regionToScriptMap, this.supportMap)),
          n ? n.tag : e
        );
      }
    })({
      supportedLocales: [
        "ar",
        "ca",
        "cs",
        "da",
        "de",
        "el",
        "en",
        "en-AU",
        "en-GB",
        "es",
        "es-MX",
        "es-US",
        "fi",
        "fr",
        "fr-CA",
        "he",
        "hi",
        "hr",
        "hu",
        "id",
        "it",
        "ja",
        "ko",
        "ms",
        "nb",
        "nl",
        "pl",
        "pt",
        "pt-PT",
        "ro",
        "ru",
        "sk",
        "sl",
        "sv",
        "th",
        "tr",
        "uk",
        "vi",
        "zh-Hans",
        "zh-Hant",
        "zh-HK"
      ],
      regionToScriptMap: v,
      localesMap: w
    });
  function C(t) {
    if (t)
      return (
        (t.addEventListener = C.prototype.addEventListener),
        (t.removeEventListener = C.prototype.removeEventListener),
        (t.dispatchEvent = C.prototype.dispatchEvent),
        t
      );
  }
  ((C.prototype._listeners = void 0),
    (C.prototype.addEventListener = function (t, e, i) {
      ((i = i ?? null), this._listeners || (this._listeners = {}));
      const n = this._listeners[t] ?? [];
      this._listeners[t] = n;
      for (const {listener: t, thisObject: o} of n) if (t === e && o === i) return !1;
      return (n.push({thisObject: i, listener: e}), !0);
    }),
    (C.prototype.removeEventListener = function (t, e, i) {
      if (((i = i ?? null), !this._listeners)) return !1;
      if ("string" != typeof t) {
        for (const t in this._listeners) this.removeEventListener(t, e, i);
        return !1;
      }
      const n = this._listeners[t];
      if (!n) return !1;
      const o = n.findIndex(({listener: t, thisObject: n}) => (e === t && i === n) || (!e && i && i === n));
      return (o > -1 && n.splice(o, 1), 0 === n.length && delete this._listeners[t], o > -1);
    }),
    (C.prototype.dispatchEvent = function (t) {
      if (((t.target = this), !this._listeners)) return !0;
      const e = this._listeners[t.type];
      if (!e || t._stoppedPropagation) return !0;
      const i = e.slice(0);
      for (const {listener: e, thisObject: n} of i)
        if (("function" == typeof e ? e.call(n, t) : n || e.handleEvent.call(e, t), t._stoppedPropagation)) break;
      return !t.defaultPrevented;
    }));
  const k = {
      EventTarget: C,
      Event: class {
        constructor(t) {
          ((this.target = null), (this.type = t), (this.defaultPrevented = !1), (this._stoppedPropagation = !1));
        }
        stopPropagation() {
          this._stoppedPropagation = !0;
        }
        preventDefault() {
          this.defaultPrevented = !0;
        }
      }
    },
    M = {EventTarget: k.EventTarget, Event: k.Event},
    S = {
      Libraries: [],
      Events: {LOAD: "load", LOADEND: "loadend", LOAD_ERROR: "load-error"},
      jsModules: {mapkit: {}},
      _chunkLoaded: function (t, e) {
        Object.keys(t).forEach((e) => {
          "mapkit" !== e
            ? (this.jsModules[e] = t[e])
            : Object.keys(t.mapkit).forEach((e) => {
                this.jsModules.mapkit[e] = t.mapkit[e];
              });
        });
        const i = new M.Event(this.Events.LOAD);
        ((i.jsModules = t), this.dispatchEvent(i), e && e());
      },
      _dispatchLoadEndEvent: function (t) {
        const e = new M.Event(this.Events.LOADEND);
        ((e.libraryNames = t), this.dispatchEvent(e));
      }
    };
  M.EventTarget(S);
  const L = S;
  class A {
    constructor() {
      this.loggers = [];
    }
    appendLogger(t) {
      this.loggers.push(t);
    }
    _invoke(t, e) {
      if (this.loggers.length) for (const i of this.loggers) i[t] && i[t].apply(i, e);
      else ("error" !== t && "warn" !== t) || console[t].apply(console, e);
    }
    error() {
      this._invoke("error", Array.from(arguments));
    }
    warn() {
      this._invoke("warn", Array.from(arguments));
    }
    log() {
      this._invoke("log", Array.from(arguments));
    }
    info() {
      this._invoke("info", Array.from(arguments));
    }
    debug() {
      this._invoke("debug", Array.from(arguments));
    }
  }
  const E = new A();
  A.sharedLogger = E;
  const x = function (t) {
      return String.fromCharCode.apply(
        String,
        t.split("").map((t) => (t.codePointAt(0) + 242) % 255)
      );
    },
    T = Symbol(),
    I = Object.freeze({Highest: 0, High: 1, Medium: 2, Low: 3}),
    R = {[I.Highest]: 12, [I.High]: 12, [I.Medium]: 4, [I.Low]: 1},
    O = {[I.Highest]: [], [I.High]: [], [I.Medium]: [], [I.Low]: []},
    P = {[I.Highest]: 0, [I.High]: 0, [I.Medium]: 0, [I.Low]: 0},
    D = () => {
      for (const t of Object.values(I)) {
        if (O[t].length > 0) {
          const e = R[t];
          return P[t] === e ? null : O[t][0];
        }
        if (P[t] > 0) return null;
      }
      return null;
    },
    z = () => {
      for (const t of Object.values(I)) if (O[t].length > 0) return (O[t].shift(), !0);
      return !1;
    },
    N = () => {
      let t = D();
      for (; t; ) ((P[t.priority] += 1), z(), t._loaderWillStart.call(t), (t = D()));
    },
    F = (t) =>
      ((t) => {
        for (const e of Object.values(I)) {
          const i = O[e].indexOf(t);
          if (-1 !== i) return (O[e].splice(i, 1), !0);
        }
        return !1;
      })(t),
    U = (t) => {
      ((P[t.priority] -= 1), N());
    },
    G =
      ((() => {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
          const t = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
          (parseInt(t?.[1] ?? "0", 10), parseInt(t?.[2] ?? "0", 10), parseInt(t?.[3] ?? "0", 10));
        }
      })(),
      (t, e) => {
        if (!B(t)) throw new Error(e || "Expected an Element");
      }),
    B = (t) => t instanceof window.Node && t.nodeType === window.Node.ELEMENT_NODE,
    Z =
      (window.XMLHttpRequest,
      (t) => {
        const e = new window.XMLHttpRequest();
        return (e.addEventListener("load", t), e.addEventListener("error", t), e.addEventListener("timeout", t), e);
      }),
    W = () => document.createElement("canvas"),
    K = Object.freeze({Unscheduled: 0, Waiting: 1, Loading: 2, Canceled: 3, Succeeded: 4, Failed: 5});
  Object.freeze(Object.values(K));
  const H = class {
      constructor(t, e) {
        ((this._state = K.Unscheduled),
          (this._retries = 0),
          (this._unscheduled = !1),
          (this._delay = null),
          (this._timeoutId = void 0),
          (this.priority = t),
          (this._delegate = e),
          this._init(t, e));
      }
      _getDelegate() {
        return this._delegate;
      }
      _isUnscheduled() {
        return this._unscheduled;
      }
      get state() {
        return this._state;
      }
      schedule() {
        this._state === K.Unscheduled &&
          ((this._state = K.Waiting),
          ((t) => {
            (O[t.priority].push(t), N());
          })(this));
      }
      unschedule() {
        let t = !1;
        if (this._state === K.Waiting) t = F(this);
        else {
          if (this._state !== K.Loading) return !1;
          (U(this), (t = !0));
        }
        return (
          (this._unscheduled = t),
          (this._state = K.Canceled),
          "function" == typeof this._delegate.loaderDidCancel && this._delegate.loaderDidCancel(this),
          this._reset(),
          t
        );
      }
      _loaderWillStart() {
        ((this._state = K.Loading),
          "function" == typeof this._delegate.loaderWillStart && this._delegate.loaderWillStart(this));
      }
      _loaderDidSucceed(t) {
        ((this._state = K.Succeeded),
          U(this),
          "function" == typeof this._delegate.loaderDidSucceed && this._delegate.loaderDidSucceed(this, t),
          this._reset());
      }
      _loaderDidFail(t) {
        ((this._state = K.Failed),
          U(this),
          "function" == typeof this._delegate.loaderDidFail && this._delegate.loaderDidFail(this, t),
          this._reset());
      }
      _init(t, e) {
        ((this.priority = t),
          (this._state = K.Unscheduled),
          (this._delegate = e),
          (this._retries = 0),
          (this._timeoutId = void 0),
          (this._delay = null),
          (this._unscheduled = !1));
      }
      _reload(t) {
        if ((this._retries++, this._retries < 3)) {
          const t = this._delay ?? 1e4;
          this._timeoutId = setTimeout(() => this._loaderWillStart(), t);
        } else this._loaderDidFail(t);
      }
      _reset() {
        clearTimeout(this._timeoutId);
      }
    },
    j = class extends H {
      constructor(t, e, i) {
        (super(i?.priority ?? I.Highest, e),
          (this._origin = null),
          (this._headers = i?.headers ?? null),
          (this._xhr = null),
          (this._xhrData = void 0),
          (this._method = i?.method ?? "GET"),
          (this._retry = i?.retry ?? !1),
          (this._timeout = i?.timeout ?? 0),
          (this._withCredentials = i?.withCredentials ?? !1),
          (this._url = t),
          (this._delay = i?.delay ?? null));
      }
      get xhr() {
        return this._xhr;
      }
      get url() {
        return this._url;
      }
      get xhrData() {
        return this._xhrData;
      }
      unschedule() {
        return (this._xhr?.abort(), super.unschedule());
      }
      _loaderWillStart() {
        if (
          (super._loaderWillStart(),
          (this._xhr = Z(this)),
          this._xhr.open(this._method, this.url, !0),
          (this._xhr.timeout = this._timeout),
          (this._xhr.withCredentials = this._withCredentials),
          this._origin && (this._xhr.setDisableHeaderCheck(!0), this._xhr.setRequestHeader("Origin", this._origin)),
          this._headers)
        )
          for (const [t, e] of Object.entries(this._headers)) this._xhr.setRequestHeader(t, e);
        if ("POST" === this._method && !this._xhrData) {
          const t = this._getDelegate();
          if (((this._xhrData = t.getDataToSend?.(this._xhr)), !this._xhrData)) return;
        }
        this._xhr.send(this._xhrData);
      }
      handleEvent(t) {
        const e = t.target,
          i = t.type;
        if ("error" === i || "timeout" === i || 200 !== e.status)
          this._retry ? this._reload(e) : this._loaderDidFail(e);
        else if ("load" === i) this._loaderDidSucceed(e);
        else {
          const t = e.status ?? -1;
          console.log(`Unhandled XHR event type: ${i} status: ${t}`);
        }
      }
    },
    V = "function" == typeof ErrorEvent,
    q = function (t, e, i, n) {
      if (!V) return t.apply(e, i);
      try {
        return t.apply(e, i);
      } catch (t) {
        console.error(t);
        const e = new ErrorEvent("error", {
          message: t instanceof Error ? t.message : t instanceof Object ? t.toString() : "(Unknown error)",
          filename: t instanceof Error ? t.fileName || t.stack : "(Unknown filename)",
          lineno: t instanceof Error ? t.lineNumber : void 0,
          colno: t instanceof Error ? t.columnNumber : void 0,
          error: t
        });
        return (window.dispatchEvent(e), n);
      }
    },
    Y = (t) => Promise.all(t.map((t) => fetch(t, {mode: "no-cors", credentials: "include"}))).then(() => {});
  ((R[I.Highest] *= 10), (R[I.High] *= 10), (R[I.Medium] *= 10), (R[I.Low] *= 10));
  const X = {OK: 200, MULTIPLE_CHOICES: 300, BAD_REQUEST: 400, UNAUTHORIZED: 401, TOO_MANY_REQUESTS: 429},
    $ = [
      "language",
      "countryCode",
      "madabaBaseUrl",
      "authorizationCallback",
      "libraries",
      "logger",
      "_showMapsLogo",
      "_showLegalLink",
      "bootstrapTimeout",
      "_shadowDOMMode",
      "_showsTileInfo",
      "_distUrl",
      "_syrupUrl",
      "_uiBaseUrl",
      "_teamId",
      "_previewLoCSR",
      "_forcedRenderingMode",
      "_proxyPrefixes",
      "_shouldLogin",
      "_disableWebGLCheck"
    ],
    J = "R`ha\\aHe_";
  $.push(J);
  const Q = {READY: 0, PENDING: 1, ERROR: 2, UNINITIALIZED: 3},
    tt = {Initialized: "Initialized", Refreshed: "Refreshed"},
    et = Object.freeze({
      BadRequest: "Bad Request",
      Unauthorized: "Unauthorized",
      TooManyRequests: "Too Many Requests",
      MalformedResponse: "Malformed Response",
      Timeout: "Timeout",
      NetworkError: "Network Error",
      Unknown: "Unknown"
    }),
    it = "Bearer {{token}}",
    nt = {Apple: "Apple", AutoNavi: "AutoNavi"};
  let ot = !1;
  const st = new WeakMap(),
    at = window.location.hostname;
  class rt {
    constructor(t) {
      ((this.bootstrap = t), (this.countryCode = null));
    }
    setForcedCountryCode(t) {
      return (
        !t || at.endsWith(".apple.com") || at.endsWith(".autonavi.com") || console.error("[MapKit] Not allowed."),
        this.setForcedCountryCodeUnrestricted(t)
      );
    }
    setForcedCountryCodeUnrestricted(t) {
      t !== this.countryCode &&
        (t && (c(t, "string", "[MapKit] `countryCode` must be a string or `null`."), (t = t.toUpperCase())),
        (this.countryCode = t),
        t &&
          this.bootstrap._setLocaleWithCountryCode &&
          (delete this.bootstrap._setLocaleWithCountryCode, (this.bootstrap.language = "zh-" + this.countryCode)),
        this.bootstrap.ready && this.bootstrap._loadFromServer());
    }
  }
  function lt() {
    ((this._jwtTokensToCheck = []),
      (this.componentVersions = {}),
      (this.performanceMarkers = {}),
      (this.language = null),
      st.set(this, new rt(this)));
  }
  ((lt.ChangeStatus = tt),
    (lt.PROTOCOL = "https:"),
    (lt.TileProviders = nt),
    (lt.prototype = r(M.EventTarget, lt, {
      _c(t) {
        if (t !== T) throw new Error("Invalid key.");
        return st.get(this);
      },
      HTTP: X,
      ErrorStatus: et,
      TileProviders: nt,
      Events: {Initialized: "configuration-init", Changed: "configuration-change", Error: "error"},
      States: Q,
      state: Q.UNINITIALIZED,
      enableSourceMap: !1,
      authorizationCallback: null,
      tileProvider: null,
      _showMapsLogo: !0,
      _showLegalLink: !0,
      shadowDOMMode: void 0,
      _madabaBaseUrl: null,
      customMadabaUrl: !1,
      _madabaDomains: null,
      _accessKey: null,
      _accessToken: null,
      _distUrl: null,
      _syrupUrl: null,
      apiBaseUrl: null,
      apiBaseUrlOverride: null,
      types: {},
      _bootstrapRequestParams: null,
      _showsTileInfo: !1,
      _messagePrefix: "[MapKit] ",
      nonce: "",
      scriptBaseUrl: null,
      get distUrl() {
        return this._distUrl;
      },
      isDistUrlTrusted() {
        if (!this._distUrl) return !1;
        const t = new URL(this._distUrl, window.location.href);
        if (window.location.origin && t.origin === window.location.origin) return !0;
        if (this.scriptBaseUrl) {
          const e = new URL(this.scriptBaseUrl, window.location.href);
          if (e.origin && t.origin === e.origin) return !0;
        }
        return !1;
      },
      get buildTags() {
        let t = "";
        return (
          Object.keys(this.componentVersions).forEach((e) => (t += " (" + e + ": " + this.componentVersions[e] + ")")),
          t
        );
      },
      get _initMessagePrefix() {
        return this._messagePrefix + "mapkit.init(): ";
      },
      get proxyPrefixes() {
        return this._proxyPrefixes;
      },
      isProxyPrefixTrusted() {
        if (!this._proxyPrefixes) return !1;
        const t = new URL(this._proxyPrefixes[0], window.location.href);
        if (window.location.origin && t.origin === window.location.origin) return !0;
        if (this.scriptBaseUrl) {
          const e = new URL(this.scriptBaseUrl, window.location.href);
          if (e.origin && t.origin === e.origin) return !0;
        }
        return !1;
      },
      get withCredentials() {
        return this.proxyPrefixes && this.urlWithCredentials(this.proxyPrefixes[0]);
      },
      get distUrlWithCredentials() {
        return this._distUrl ? this.urlWithCredentials(this._distUrl) : !i.useLocalResources && this.withCredentials;
      },
      urlWithCredentials: function (t) {
        return /\bproxy\b.*\.geo\.apple\.com\b/.test(t);
      },
      get loginPromise() {
        return (
          this._loginPromise ||
            (this.withCredentials && this._shouldLogin
              ? (this._loginPromise = Y(this.proxyPrefixes))
              : (this._loginPromise = Promise.resolve())),
          this._loginPromise
        );
      },
      init: function (t, e) {
        (ot && performance.mark("mapkit-init-start"),
          h(t, this._initMessagePrefix + "`options` object is required.", {checkNull: !0}),
          c(t, "object", this._initMessagePrefix + "`options` object is invalid."));
        const i = {};
        if (
          (t.logger && E.appendLogger(t.logger),
          Object.keys(t).forEach((t) => {
            const e = -1 !== $.indexOf(x(t));
            (e ||
              -1 !== $.indexOf(t) ||
              console.warn(this._initMessagePrefix + "ignoring invalid option: `" + t + "`."),
              e && (i[x(t)] = t));
          }),
          e ||
            (this.authorizationCallback && void 0 === t.authorizationCallback) ||
            (h(t.authorizationCallback, this._initMessagePrefix + "`options` is missing `authorizationCallback`.", {
              checkNull: !0
            }),
            c(
              t.authorizationCallback,
              "function",
              this._initMessagePrefix + "`authorizationCallback` in `options` must be a function."
            )),
          t.language && c(t.language, "string", this._initMessagePrefix + "`language` in `options` must be a string."),
          this._userInitializedInit)
        )
          return void console.warn(this._initMessagePrefix + "already initialized; ignoring.");
        (e || (this._userInitializedInit = !0),
          void 0 !== t._previewLoCSR && t._previewLoCSR && (this._forcedRenderingMode = "HYBRID"),
          void 0 !== t._forcedRenderingMode && (this._forcedRenderingMode = t._forcedRenderingMode),
          void 0 !== t._proxyPrefixes && Array.isArray(t._proxyPrefixes) && (this._proxyPrefixes = t._proxyPrefixes),
          void 0 !== t._distUrl && (this._distUrl = t._distUrl),
          void 0 !== t._syrupUrl && (this._syrupUrl = t._syrupUrl),
          (this._shouldLogin = this.withCredentials),
          void 0 === t._shouldLogin || t._shouldLogin || (this._shouldLogin = !!t._shouldLogin),
          i[J] && void 0 !== t[i[J]] && (this[J] = t[i[J]]));
        const n = (this.state === Q.UNINITIALIZED || this.state === Q.ERROR) && t.authorizationCallback;
        (n && (this.state = Q.PENDING),
          t.authorizationCallback && (this.authorizationCallback = t.authorizationCallback),
          void 0 !== t.countryCode &&
            null === st.get(this).countryCode &&
            st.get(this).setForcedCountryCodeUnrestricted(t.countryCode),
          void 0 !== t.language ? (this.language = t.language) : this._l10n && (this._l10n.localeId = this.language),
          void 0 !== t._showMapsLogo && (this._showMapsLogo = !!t._showMapsLogo),
          void 0 !== t._showLegalLink && (this._showLegalLink = !!t._showLegalLink),
          void 0 !== t._shadowDOMMode && (this.shadowDOMMode = t._shadowDOMMode),
          t.bootstrapTimeout && (this._bootstrapTimeout = t.bootstrapTimeout),
          t.madabaBaseUrl && ((this._madabaBaseUrl = t.madabaBaseUrl), (this.customMadabaUrl = !0)),
          t._uiBaseUrl && ((this.uiBaseUrl = t._uiBaseUrl), (this.customUiBaseUrl = !0)),
          t._showsTileInfo && (this._showsTileInfo = t._showsTileInfo),
          t._teamId && (this.analyticsTeamId = t._teamId),
          void 0 !== t._disableWebGLCheck && (this._disableWebGLCheck = t._disableWebGLCheck),
          n &&
            (this.withCredentials && this._shouldLogin
              ? this.loginPromise.then(
                  () => {
                    this._loadFromServer();
                  },
                  () => {
                    this._loadFailed(
                      et.NetworkError,
                      "Initialization failed because of network error connecting to proxy."
                    );
                  }
                )
              : this._loadFromServer()),
          t.libraries);
        const o = new M.Event(this.Events.Initialized);
        this.dispatchEvent(o);
      },
      login() {
        this.withCredentials &&
          ((t) => {
            if (0 === t.length) return Promise.resolve();
            const e = window.open(t[0].replace(/\/proxy\?$/, "/login"), "_blank", "popup=yes,width=700,height=700");
            return new Promise((t, i) => {
              e || i();
              const n = (o) => {
                o.source === e && (window.removeEventListener("message", n), o.data && o.data.login ? t(void 0) : i());
              };
              window.addEventListener("message", n);
            }).then(() => {
              if (1 === t.length) return;
              const e = [].concat(t);
              return (e.shift(), Y(e));
            });
          })(this.proxyPrefixes).then(
            () => {
              this.reloadFromServer();
            },
            () => console.error("[MapKit] There is a problem triggering login popup.")
          );
      },
      reloadFromServer: function () {
        this._loadFromServer();
      },
      get accessKey() {
        return this._accessKey;
      },
      get accessToken() {
        return this._accessToken;
      },
      accessKeyMayBeExpired() {
        Date.now() > this.expiresAt && this.accessKeyHasExpired();
      },
      accessKeyHasExpired: function () {
        this._loadFromServer(I.Highest);
      },
      get ready() {
        return this.state === Q.READY;
      },
      get error() {
        return this.state === Q.ERROR;
      },
      _language: void 0,
      get language() {
        return this._language;
      },
      set language(t) {
        t !== this._language &&
          (delete this._setLocaleWithCountryCode,
          t
            ? (c(t, "string", "[MapKit] `language` must be a string or `null`."),
              "zh" === t.toLowerCase() &&
                (console.warn(
                  "[MapKit] `zh` is an ambiguous language ID. Please specify a script or reginal variant: `zh-Hans`, `zh-Hant`, or `zh-HK`."
                ),
                st.get(this).countryCode
                  ? (t = "zh-" + st.get(this).countryCode)
                  : (this._setLocaleWithCountryCode = !0)))
            : (t = this._getClientLanguage()),
          (this._language = b.bestMatch(t, "en")),
          this.state !== Q.UNINITIALIZED && this._l10n && (this._l10n.localeId = t));
      },
      get countryCode() {
        return st.get(this).countryCode;
      },
      get isAutoNavi() {
        return this.tileProvider === nt.AutoNavi || (this.state === Q.PENDING && "CN" === st.get(this).countryCode);
      },
      appendAuthOptions: function (t, e) {
        return (
          (e || (this.accessToken && !this.isAutoNavi)) &&
            ((t.headers = t.headers || {}), (t.headers.Authorization = m(it, {token: e || this.accessToken}))),
          t
        );
      },
      setL10n: function (t) {
        ((this._l10n = t), this.state !== Q.UNINITIALIZED && (this._l10n.localeId = this.language));
      },
      setPerformanceMarkers(t) {
        if (!t) return;
        const e = t.split(",").map((t) => t.trim());
        for (const t of e) this.performanceMarkers[t] = !0;
        ot = this.performanceMarkers.loading;
      },
      handleEvent(t) {
        switch (t.type) {
          case "visibilitychange":
            "visible" === document.visibilityState && this.ready && this.accessKeyMayBeExpired();
            break;
          case "online":
            this.ready ? this.accessKeyMayBeExpired() : this.error && this.reloadFromServer();
        }
      },
      loaderWillStart: function (t) {
        this._xhrLoader === t && (this.state = Q.PENDING);
      },
      loaderDidSucceed: function (t, e) {
        this._xhrLoader === t &&
          (this._requestDidLoad(e),
          ot && this.state === Q.PENDING && performance.measure("mapkit-init", "mapkit-init-start"),
          (this._xhrLoader = void 0));
      },
      loaderDidFail: function (t, e) {
        this._xhrLoader === t && (this._parseError(t._xhr), (this._xhrLoader = void 0));
      },
      _loadFromServer: function (t) {
        this._bootstrapRequestParams = {
          apiVersion: "2",
          countryCode: st.get(this).countryCode,
          mkjsVersion: i.version,
          poi: "1"
        };
        let e = "https://cdn.apple-mapkit.com/ma/bootstrap?" + g(this._bootstrapRequestParams);
        this.proxyPrefixes && (e = this.proxyPrefixes[0] + e);
        const n = {
          retry: !0,
          delay: 0,
          priority: t,
          timeout: this._bootstrapTimeout,
          withCredentials: this.withCredentials
        };
        (this.withCredentials &&
          /\bapple\.com\b/.test(this.proxyPrefixes[0]) &&
          !/\bapple\.com$/.test(window.location.hostname) &&
          console.warn(
            "[MapKit] Request with credentials may fail if the page is not hosted on the same domain as the proxy."
          ),
          q(this.authorizationCallback, null, [
            (t) => {
              (t && (this._checkJwtToken ? this._checkJwtToken(t) : this._jwtTokensToCheck.push(t)),
                this.appendAuthOptions(n, t),
                this.accessToken && (n.headers["X-Maps-Access-Token"] = m(it, {token: this.accessToken})));
              const i = new j(e, this, n);
              (this._xhrLoader && this._xhrLoader.unschedule(), i.schedule(), (this._xhrLoader = i));
            }
          ]));
      },
      _requestDidLoad: function (t) {
        const e = t.getResponseHeader("x-rid");
        if (!this._parseError(t, e))
          try {
            const i = JSON.parse(t.responseText);
            this._processLoadedData(i, e);
          } catch (t) {
            if ("SyntaxError" !== t.name) throw t;
            this._loadFailed(et.MalformedResponse, "Initialization failed because of incorrect server response.");
          }
      },
      _resetReloadTimer: function (t) {
        (clearTimeout(this._reloadTimerId),
          (this._reloadTimerId = setTimeout(() => {
            (delete this._reloadTimerId, this.accessKeyHasExpired());
          }, t)));
      },
      _loadSucceeded: function (t, e) {
        setTimeout(() => {
          this.state = Q.READY;
          const i = new M.Event(this.Events.Changed);
          ((i.status = t ? tt.Refreshed : tt.Initialized), (i.responseIdentifier = e), this.dispatchEvent(i));
        }, 0);
      },
      _loadFailed: function (t, e, i) {
        (console.error(this._messagePrefix + e),
          setTimeout(() => {
            ((this.state = Q.ERROR),
              clearTimeout(this._reloadTimerId),
              delete this._reloadTimerId,
              (this.expiresInSeconds = void 0),
              (this.expiresAt = void 0),
              (this.expiresIn = void 0));
            const n = new M.Event(this.Events.Error);
            ((n.status = t), (n.message = this._messagePrefix + e), (n.responseIdentifier = i), this.dispatchEvent(n));
          }, 0));
      },
      _processLoadedData: function (t, e) {
        const i = !!this._accessToken;
        (this._parseData(t),
          this.expiresInSeconds && this._resetReloadTimer(this.expiresIn),
          st.get(this).countryCode &&
            this._setLocaleWithCountryCode &&
            (delete this._setLocaleWithCountryCode, (this.language = "zh-" + st.get(this).countryCode)),
          document.addEventListener("visibilitychange", this),
          window.addEventListener("online", this),
          this._loadSucceeded(i, e));
      },
      _parseData: function (t) {
        let e;
        if (
          (t.apiBaseUrl,
          (st.get(this).countryCode = "unknown" !== t.countryCode ? t.countryCode : null),
          st.get(this).countryCode && "zh" === this.language && (this.language = "zh-" + st.get(this).countryCode),
          (this.environment = t.environment),
          (this.apiBaseUrl = this.apiBaseUrlOverride || t.apiBaseUrl),
          this.proxyPrefixes &&
            ((e = this.proxyPrefixes[this.proxyPrefixes.length - 1]), (this.apiBaseUrl = e + this.apiBaseUrl)),
          t.analytics)
        ) {
          const i = t.analytics;
          (this.proxyPrefixes && ((i.analyticsUrl = e + i.analyticsUrl), (i.errorUrl = e + i.errorUrl)),
            (this.analytics = i));
        }
        (t.authInfo && t.authInfo.team_id && (this.teamId = t.authInfo.team_id),
          t.locationShiftUrl &&
            (this.proxyPrefixes
              ? (this.locationShiftUrl = e + t.locationShiftUrl)
              : (this.locationShiftUrl = t.locationShiftUrl)),
          (this.expiresInSeconds = t.expiresInSeconds),
          (this.expiresIn = 1e3 * this.expiresInSeconds - 3e4),
          (this.expiresAt = Date.now() + this.expiresIn));
        const i = t.tileSources.some((t) => t.needsLocationShift);
        (t.accessKey && (this._accessKey = t.accessKey),
          t.authInfo && t.authInfo.access_token && (this._accessToken = t.authInfo.access_token),
          (this.tileProvider = i ? lt.TileProviders.AutoNavi : lt.TileProviders.Apple),
          (this._data = t),
          this.customUiBaseUrl || (this.uiBaseUrl = t.uiBaseUrl),
          this._parseMapData && this._parseMapData());
      },
      _parseError: function (t, e) {
        const i = t.status;
        let n, o;
        if (i >= X.OK && i < X.MULTIPLE_CHOICES) return !1;
        if (((this._userInitializedInit = !1), t.readyState !== t.DONE))
          ((o = et.Timeout),
            (n = "Initialization failed because the request timed out after " + this._bootstrapTimeout + " ms."));
        else if (i === X.UNAUTHORIZED) {
          ((o = et.Unauthorized), (n = "Initialization failed because the authorization token is invalid."));
          try {
            const e = JSON.parse(t.responseText);
            e.error &&
              e.error.details &&
              Array.isArray(e.error.details) &&
              e.error.details.forEach(function (t) {
                t && "ORIGIN_CHECK_FAILURE" === t.errorType && t.message && (n += " " + t.message);
              });
          } catch (t) {
            if ("SyntaxError" !== t.name) throw t;
          }
        } else
          i === X.TOO_MANY_REQUESTS
            ? ((o = et.TooManyRequests), (n = "Initialization failed because the daily usage limit has exceeded."))
            : 0 === i
              ? ((o = et.NetworkError), (n = "Initialization failed because of network error."))
              : ((o = et.Unknown),
                (n = "Initialization failed because the server returned error " + i + " (" + t.statusText + ")."));
        return (this._loadFailed(o, n, e), !0);
      },
      _getClientLanguage: function () {
        return window.navigator.languages ? window.navigator.languages[0] : window.navigator.language;
      },
      _restore: function () {
        (this._syrupUrl && console.warn("[MapKit] mapkit.restore() cannot unset _syrupUrl."),
          this[J] && console.warn("[MapKit] mapkit.restore() cannot unset R`ha\\aHe_"),
          delete this._proxyPrefixes,
          delete this._forcedRenderingMode,
          delete this._userInitializedInit,
          delete this._loginPromise,
          delete this._readyPromise,
          delete this._readyPromiseResolve,
          (this._distUrl = null),
          (this.authorizationCallback = null),
          (this.apiBaseUrl = null),
          (this.apiBaseUrlOverride = null),
          (this.state = Q.UNINITIALIZED),
          (this._listeners = {}),
          clearTimeout(this._reloadTimerId),
          delete this._reloadTimerId,
          document.removeEventListener("visibilitychange", this),
          window.removeEventListener("online", this));
      },
      _debugInfo: function () {
        const t = {};
        return (
          [
            "ready",
            "state",
            "_countryCode",
            "tileProvider",
            "apiBaseUrl",
            "language",
            "_getClientLanguage",
            "types"
          ].forEach(function (e) {
            t[e] = "function" == typeof this[e] ? this[e]() : this[e];
          }, this),
          t
        );
      }
    })));
  const ht = lt;
  function ct() {
    ht.call(this);
  }
  ((ct.prototype = Object.create(ht.prototype)),
    Object.defineProperty(ct.prototype, "constructor", {enumerable: !0, writable: !0, value: ct}));
  const dt = new ct();
  function ut() {}
  ((ut.prototype = Object.create(k.EventTarget.prototype)),
    (ut.prototype.dispatchEvent = function (t) {
      return q(k.EventTarget.prototype.dispatchEvent, this, [t], !0);
    }));
  const pt = {EventTarget: ut, Event: k.Event},
    mt = {
      Airport: "Airport",
      AirportGate: "AirportGate",
      AirportTerminal: "AirportTerminal",
      AmusementPark: "AmusementPark",
      AnimalService: "AnimalService",
      Aquarium: "Aquarium",
      ATM: "ATM",
      AutomotiveRepair: "AutomotiveRepair",
      Bakery: "Bakery",
      Bank: "Bank",
      Baseball: "Baseball",
      Basketball: "Basketball",
      Beach: "Beach",
      Beauty: "Beauty",
      Bowling: "Bowling",
      Brewery: "Brewery",
      Cafe: "Cafe",
      Campground: "Campground",
      CarRental: "CarRental",
      Castle: "Castle",
      ConventionCenter: "ConventionCenter",
      Distillery: "Distillery",
      EVCharger: "EVCharger",
      Fairground: "Fairground",
      FireStation: "FireStation",
      Fishing: "Fishing",
      FitnessCenter: "FitnessCenter",
      FoodMarket: "FoodMarket",
      Fortress: "Fortress",
      GasStation: "GasStation",
      GoKart: "GoKart",
      Golf: "Golf",
      Hiking: "Hiking",
      Hospital: "Hospital",
      Hotel: "Hotel",
      Kayaking: "Kayaking",
      Landmark: "Landmark",
      Laundry: "Laundry",
      Library: "Library",
      Mailbox: "Mailbox",
      Marina: "Marina",
      MiniGolf: "MiniGolf",
      MovieTheater: "MovieTheater",
      Museum: "Museum",
      MusicVenue: "MusicVenue",
      NationalMonument: "NationalMonument",
      NationalPark: "NationalPark",
      Nightlife: "Nightlife",
      Park: "Park",
      Parking: "Parking",
      Pharmacy: "Pharmacy",
      Planetarium: "Planetarium",
      Playground: "Playground",
      Police: "Police",
      PostOffice: "PostOffice",
      PublicTransport: "PublicTransport",
      ReligiousSite: "ReligiousSite",
      Restaurant: "Restaurant",
      Restroom: "Restroom",
      RockClimbing: "RockClimbing",
      RVPark: "RVPark",
      School: "School",
      SkatePark: "SkatePark",
      Skating: "Skating",
      Skiing: "Skiing",
      Soccer: "Soccer",
      Spa: "Spa",
      Stadium: "Stadium",
      Store: "Store",
      Surfing: "Surfing",
      Swimming: "Swimming",
      Tennis: "Tennis",
      Theater: "Theater",
      University: "University",
      Volleyball: "Volleyball",
      Winery: "Winery",
      Zoo: "Zoo"
    };
  function gt(t) {
    return t.map(function (t) {
      if (!l(t, mt))
        throw new Error("[MapKit] Unknown category `" + t + "`. Choose from mapkit.PointOfInterestCategory.");
      return t;
    });
  }
  function _t(t) {
    if (void 0 !== (t = p(t)).includes && void 0 !== t.excludes)
      throw new Error("[MapKit] `includes` and `excludes` may not be specified at the same time.");
    if (void 0 === t.includes && void 0 === t.excludes)
      throw new Error("[MapKit] Either `includes` or `excludes` should be specified.");
    (void 0 !== t.includes && (this._includes = gt(t.includes)),
      void 0 !== t.excludes && (this._excludes = gt(t.excludes)));
  }
  const ft = function () {
    throw new Error(
      "[MapKit] `PointOfInterestFilter` may not be constructed directly. Use the mapkit.PointOfInterestFilter.including or the mapkit.PointOfInterestFilter.excluding methods."
    );
  };
  ((_t.prototype = ft.prototype =
    {
      constructor: ft,
      _includes: null,
      _excludes: null,
      includesCategory: function (t) {
        if (!l(t, mt))
          throw new Error("[MapKit] Unknown category `" + t + "`. Choose from mapkit.PointOfInterestCategory.");
        return this._includes
          ? -1 !== this._includes.indexOf(t)
          : this._excludes
            ? -1 === this._excludes.indexOf(t)
            : void 0;
      },
      excludesCategory: function (t) {
        if (!l(t, mt))
          throw new Error("[MapKit] Unknown category `" + t + "`. Choose from mapkit.PointOfInterestCategory.");
        return this._includes
          ? -1 === this._includes.indexOf(t)
          : this._excludes
            ? -1 !== this._excludes.indexOf(t)
            : void 0;
      }
    }),
    (_t.including = function (t) {
      return (u(t, "[MapKit] PointOfInterestFilter.including expected an array of categories."), new _t({includes: t}));
    }),
    (_t.excluding = function (t) {
      return (u(t, "[MapKit] PointOfInterestFilter.excluding expected an array of categories."), new _t({excludes: t}));
    }),
    (_t.exposedConstructor = ft),
    Object.defineProperties(_t, {
      filterIncludingAllCategories: {
        get: function () {
          const t = this.excluding([]);
          return (Object.defineProperty(this, "filterIncludingAllCategories", {value: t, configurable: !0}), t);
        },
        configurable: !0
      },
      filterExcludingAllCategories: {
        get: function () {
          const t = this.including([]);
          return (Object.defineProperty(this, "filterExcludingAllCategories", {value: t, configurable: !0}), t);
        },
        configurable: !0
      }
    }),
    Object.defineProperties(ft, {
      including: {
        get: function () {
          return _t.including;
        },
        configurable: !0
      },
      excluding: {
        get: function () {
          return _t.excluding;
        },
        configurable: !0
      },
      includingAllCategories: {get: () => _t.filterIncludingAllCategories},
      excludingAllCategories: {get: () => _t.filterExcludingAllCategories}
    }));
  const yt = _t;
  function vt(t) {
    const e = {device_pixel_ratio: window.devicePixelRatio};
    return t._isInternalClient ? ((e.width = screen.width), (e.height = screen.height), e) : e;
  }
  function wt(t, e) {
    const i = {device_platform: e.uaParserInfo.deviceInfo.platform, device_os_version: e.uaParserInfo.deviceInfo.os};
    return (void 0 !== t._isInternalServer && (i.is_internal_server = t._isInternalServer), i);
  }
  const bt = Object.freeze({Dark: "dark", Light: "light", Adaptive: "adaptive"});
  class Ct extends M.EventTarget {}
  const kt = new (class {
    constructor() {
      ((this._queryList = window.matchMedia("(prefers-color-scheme: dark)")),
        (this._handles = new Set()),
        (this._boundQueryListDidChange = () => this._queryListDidChange()));
    }
    addHandle() {
      const t = new Ct();
      return (this._handles.add(t), 1 === this._handles.size && this._addListener(), t);
    }
    removeHandle(t) {
      (this._handles.delete(t), 0 === this._handles.size && this._removeListener());
    }
    get currentColorScheme() {
      return this._queryList.matches ? bt.Dark : bt.Light;
    }
    get isDarkMode() {
      return this._queryList.matches;
    }
    _addListener() {
      this._queryList.addListener(this._boundQueryListDidChange);
    }
    _removeListener() {
      this._queryList.removeListener(this._boundQueryListDidChange);
    }
    _queryListDidChange() {
      for (const t of this._handles.values()) {
        const e = new M.Event("change");
        t.dispatchEvent(e);
      }
    }
  })();
  function Mt(t, e) {
    let i;
    return (
      (i = {browser_language: navigator.language, prefers_color_scheme: kt.isDarkMode ? "DARK" : "LIGHT"}),
      location.host.match(/duckduckgo.com$/) ||
        location.host.match(/apple-mapkit.com$/) ||
        ((i.browser_name = e.uaParserInfo.browserInfo.name), (i.browser_version = e.uaParserInfo.browserInfo.version)),
      t._isInternalClient
        ? (i.browser_origin = location.protocol + "//" + location.host)
        : (i.browser_origin = t.getReduceHostPlaceholder("ProtocolPlusHost")),
      t._isInternalClient && (i.browser_referer = t.getReduceHostPlaceholder("ReferrerHost")),
      e.browserDefaultFontSize && (i.browser_default_font_size = e.browserDefaultFontSize),
      e.browserInfoValues && Object.assign(i, e.browserInfoValues),
      i
    );
  }
  function St(t) {
    const e = {mkjs_version: i.version};
    return (
      t._isInternalClient &&
        window.placecard &&
        window.placecard.version &&
        (e.placecard_version = window.placecard.version),
      t._teamId && (e.team_id = t._teamId),
      t._isInternalClient ? (e.host = location.host) : (e.host = t.getReduceHostPlaceholder("Host")),
      null !== t._serverEnvironment && (e.server_environment = t._serverEnvironment),
      e
    );
  }
  function Lt(t) {
    if (t._isInternalClient) return {width: window.innerWidth, height: window.innerHeight};
  }
  function At(t) {
    const e = {};
    return (t._isInternalClient && (e.path = location.pathname), e);
  }
  function Et(t, e) {
    const i = e.map.region.toBoundingRegion(),
      n = e.map.ensureRenderingFrame().size;
    return {
      display_map_region: {
        eastLng: Math.round(i.eastLongitude),
        northLat: Math.round(i.northLatitude),
        southLat: Math.round(i.southLatitude),
        westLng: Math.round(i.westLongitude)
      },
      zoom_level: e.map.zoomLevel,
      map_type: "MAP_TYPE_" + e.map.mapType.toUpperCase(),
      size: {width: n.width, height: n.height},
      color_scheme: e.map.colorScheme.toUpperCase()
    };
  }
  function xt(t) {
    return {session_id: t._sessionId, sequence_number: t._sequenceNumber, relative_timestamp: t._relativeTimestamp};
  }
  function Tt(t, e) {
    return {rendering: e.map._mapNodeController && e.map._mapNodeController.renderingMode};
  }
  const It = location.host.match(/duckduckgo.com$/),
    Rt = "other";
  function Ot(t) {
    t = t.toLowerCase();
    const e = {name: Rt, version: Rt};
    try {
      if (t.includes("edg") && !t.includes("edgios")) {
        e.name = "Edge";
        const i = /edg(?:e|ios|a|i)?\/(\d+\.?\d*)/gi;
        e.version = i.exec(t)[1];
      } else
        !t.includes("safari") ||
        t.includes("chrome") ||
        t.includes("crios") ||
        t.includes("gsa") ||
        t.includes("fxios") ||
        t.includes("duckduckgo") ||
        t.includes("edg")
          ? (!t.includes("chrome") && !t.includes("crios")) ||
            t.includes("chromium") ||
            t.includes("edg") ||
            t.includes("samsungbrowser")
            ? (!t.includes("firefox") && !t.includes("fxios")) || t.includes("seamonkey")
              ? t.includes("msie") || (t.includes("trident") && t.includes("rv"))
                ? ((e.name = "Internet Explorer"),
                  (e.version = t.includes("msie") ? /msie\s(\d+\.?\d*)/gi.exec(t)[1] : /rv:(\d+\.?\d*)/gi.exec(t)[1]))
                : t.includes("gsa") && ((e.name = "Google Search App"), (e.version = /gsa\/(\d+\.?\d*)/i.exec(t)[1]))
              : ((e.name = "Firefox"),
                (e.version = t.includes("firefox")
                  ? /firefox\/(\d+\.?\d*)/gi.exec(t)[1]
                  : /fxios\/(\d+\.?\d*)/gi.exec(t)[1]))
            : ((e.name = "Chrome"),
              (e.version = t.includes("chrome") ? /chrome\/([\d.]+)/gi.exec(t)[1] : /crios\/([\d.]+)/gi.exec(t)[1]))
          : ((e.name = "Safari"), (e.version = /version\/(\d+(\.\d+)*)/i.exec(t)[1]));
      return e;
    } catch (t) {
      return e;
    }
  }
  function Pt(t) {
    let e, i;
    t = t.toLowerCase();
    try {
      return (
        t.includes("ipad")
          ? ((e = "iPad"), (i = "iOS " + /os\s+(.*?)[^_.\d]/i.exec(t)[1]))
          : t.includes("iphone") && !t.includes("ipad")
            ? ((e = "iPhone"), (i = "iOS " + /os\s+(.*?)[^_.\d]+/i.exec(t)[1]))
            : t.includes("macintosh")
              ? ((e = "Macintosh"), (i = "Mac OS X " + /mac os x (.*?)[^_.\d]/.exec(t)[1]))
              : t.includes("windows")
                ? ((e = "Windows"), (i = "Windows NT " + /windows nt (.*?)[^._\d]/.exec(t)[1]))
                : t.includes("android")
                  ? ((e = "Android"), (i = "Android " + /android (.*?)[^._\d]/.exec(t)[1]))
                  : t.includes("linux") && !t.includes("android")
                    ? ((e = "Linux"), (i = "Linux"))
                    : t.includes("cros")
                      ? ((e = "Chrome OS"), (i = "Chrome OS"))
                      : ((e = Rt), (i = Rt)),
        {platform: e, os: i}
      );
    } catch (t) {
      return {platform: Rt, os: Rt};
    }
  }
  function Dt() {
    this._startTime = Date.now();
  }
  Dt.prototype = {
    _budget: 10,
    didTimeout: !1,
    timeRemaining: function () {
      return Math.max(0, this._budget - (Date.now() - this._startTime));
    }
  };
  const zt = function (t, e) {
      return "undefined" != typeof requestIdleCallback
        ? requestIdleCallback(t, e)
        : (function (t) {
            return setTimeout(function () {
              const e = new Dt();
              t(e);
            });
          })(t);
    },
    Nt = Object.freeze({Highest: 0, High: 1, Medium: 2, Low: 3}),
    Ft = Object.freeze([{timeout: 600}, {timeout: 1e3}, {timeout: 3e3}, {}]),
    Ut = [
      function (t) {
        Zt(t, Nt.Highest);
      },
      function (t) {
        Zt(t, Nt.High);
      },
      function (t) {
        Zt(t, Nt.Medium);
      },
      function (t) {
        Zt(t, Nt.Low);
      }
    ],
    Gt = [-1, -1, -1, -1],
    Bt = [];
  for (const t of Object.values(Nt)) Bt[t] = [];
  function Zt(t, e) {
    for (; (t.timeRemaining() > 0 || t.didTimeout) && Bt[e].length; ) {
      const t = Bt[e].shift();
      "function" == typeof t
        ? t()
        : t && "object" == typeof t && "function" == typeof t.performScheduledTask && t.performScheduledTask();
    }
    Bt[e].length
      ? (Gt[e] = zt(Ut[e], Ft[e]))
      : -1 !== Gt[e] &&
        ((function (t) {
          "undefined" != typeof cancelIdleCallback ? cancelIdleCallback(t) : clearTimeout(t);
        })(Gt[e]),
        (Gt[e] = -1));
  }
  const Wt = function (t, e) {
    (Bt[e].push(t), -1 === Gt[e] && (Gt[e] = zt(Ut[e], Ft[e])));
  };
  let Kt = -1,
    Ht = [],
    jt = [],
    Vt = [];
  const qt = Object.freeze({Idle: 0, Updating: 1, Drawing: 2, Flushing: 3});
  let Yt = qt.Idle;
  function Xt(t) {
    (-1 !== Kt &&
      (Yt === qt.Flushing && ("undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame(Kt) : clearTimeout(Kt)),
      (Kt = -1)),
      (function (t) {
        for (Yt = qt.Updating; Ht.length > 0; ) {
          const e = Ht;
          Ht = [];
          for (let i = 0, n = e.length; i < n; ++i) {
            const n = e[i];
            "function" == typeof n
              ? n()
              : n &&
                "object" == typeof n &&
                "function" == typeof n.performScheduledUpdate &&
                n.performScheduledUpdate(t);
          }
        }
        ((Ht = jt), (jt = []));
      })(t),
      (function (t) {
        Yt = qt.Drawing;
        const e = Vt;
        Vt = [];
        for (let i = 0, n = e.length; i < n; ++i) {
          const n = e[i];
          "function" == typeof n
            ? n()
            : n && "object" == typeof n && "function" == typeof n.performScheduledDraw && n.performScheduledDraw(t);
        }
      })(t),
      (Yt = qt.Idle));
  }
  function $t(t, e) {
    return -1 === t.indexOf(e) && (t.push(e), !0);
  }
  function Jt() {
    Kt = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame(Xt) : setTimeout(Xt);
  }
  const Qt = {
      scheduleASAP: function (t) {
        $t(Ht, t) && -1 === Kt && Yt !== qt.Updating && Jt();
      },
      scheduleOnNextFrame: function (t) {
        $t(Yt === qt.Updating ? jt : Ht, t) && -1 === Kt && Jt();
      },
      scheduleDraw: function (t) {
        $t(Vt, t) && -1 === Kt && Jt();
      },
      flush: function () {
        Yt > qt.Idle || ((Yt = qt.Flushing), Xt());
      },
      Priority: Nt,
      scheduleInBackground: function (t, e) {
        Wt(t, e || Nt.Low);
      }
    },
    te = function (t, e, i) {
      let n;
      return function (...o) {
        const s = o;
        (n && clearTimeout(n),
          (n = setTimeout(function () {
            ((n = null), t.apply(i, s));
          }, e || 0)));
      };
    },
    ee = /^.*(?=\/mapkit([.a-z-]*)\.js)/;
  function ie(t) {
    const e = ee.exec(t.src);
    return e ? e[0] : null;
  }
  const ne = {
    _baseUrl: void 0,
    _versionSuffix: "",
    scriptBaseUrl: void 0,
    createUrl: function (t, e) {
      if (void 0 === this._baseUrl) {
        if (dt.state === dt.States.UNINITIALIZED && !e) return;
        dt.distUrl
          ? ((this._baseUrl = dt.distUrl), (this._versionSuffix = "?mkjsVersion=" + i.cdnVersion))
          : i.useLocalResources
            ? (void 0 === this.scriptBaseUrl && this.findScriptAndSetBasePath(),
              (this._baseUrl = this.scriptBaseUrl),
              (this._versionSuffix = "?mkjsVersion=" + i.cdnVersion))
            : dt.proxyPrefixes
              ? (this._baseUrl = dt.proxyPrefixes[0] + [i.cdnBase, "mk", i.cdnVersion].join("/"))
              : (this._baseUrl = ["https:" + i.cdnBase, "mk", i.cdnVersion].join("/"));
      }
      t = (t && t.replace(/^\//, "")) || "";
      let n = this._versionSuffix;
      return (
        ("__mapkitSourceMap" in window || dt.enableSourceMap) && (n += (n ? "&" : "?") + "sourcemap=1"),
        [this._baseUrl, t].join("/") + n
      );
    },
    isUrlTrusted: () =>
      dt.distUrl ? dt.isDistUrlTrusted() : !!i.useLocalResources || !dt.proxyPrefixes || dt.isProxyPrefixTrusted(),
    createImageUrl: function (t) {
      return this.createUrl("images/" + t);
    },
    findScriptAndSetBasePath: function () {
      if (document.currentScript) {
        const t = ie(document.currentScript);
        if (t) return ((ne.scriptBaseUrl = t), document.currentScript);
      }
      for (let t = document.scripts, e = 0, i = t.length; e < i; ++e) {
        const i = ie(t[e]);
        if (null !== i) return ((this.scriptBaseUrl = i), t[e]);
      }
      return null;
    }
  };
  (i.useLocalResources && "undefined" != typeof window && void 0 !== window.document && ne.findScriptAndSetBasePath(),
    dt.addEventListener(dt.Events.Initialized, function () {
      ((ne._baseUrl = void 0), (ne._versionSuffix = ""));
    }));
  const oe = ne,
    se = [
      "ac.com",
      "aws.sagemaker",
      "biz.orx",
      "cloud.jele",
      "com.amazonaws",
      "com.amazoncognito",
      "com.est-a-la-masion",
      "com.onthewifi",
      "dev.curv",
      "host.freesite",
      "it.barletta-trani-andria",
      "it.trento",
      "jp.chiba",
      "jp.fukushima",
      "jp.hokkaido",
      "jp.hyogo",
      "jp.kanagawa",
      "jp.miyazaki",
      "jp.niigata",
      "jp.saga",
      "jp.tochigi",
      "jp.xn--7t0a264c",
      "lv.mil",
      "net.homeunix",
      "no.fuossko",
      "no.smola",
      "no.xn--sandy-yua",
      "pa.ac",
      "py.org",
      "tj.ac",
      "us.mi",
      "zm.edu"
    ],
    ae = j,
    re = I,
    le = ["alt", "arpa", "example", "invalid", "local", "localhost", "onion", "test"],
    he = [];
  function ce(t, e) {
    const i = e.length,
      n = t.length;
    if (i > n) return !1;
    for (let o = 0; o < i; o++) if ("*" !== e[i - 1 - o] && e[i - 1 - o] !== t[n - 1 - o]) return !1;
    return !0;
  }
  function de(t) {
    let e = t[0];
    for (let i = 1; i < t.length; i++) {
      const n = t[i];
      n.length > e.length && (e = n);
    }
    return e;
  }
  const ue = {
      getRegisterableDomain: function (t) {
        if (!t || t.includes(":") || /^[\d.]+$/.test(t)) return Promise.resolve(null);
        const e = t.endsWith(".") ? "." : "";
        e && (t = t.substring(0, t.length - 1));
        const i = t.split("."),
          n = i.slice(-1)[0],
          o = 1 === i.length ? null : i.slice(-2)[0];
        if (!o || le.includes(n)) return Promise.resolve(null);
        const s = [].concat(se),
          a = `${n}.${o}`;
        (s.push(a), s.sort());
        const r = s.lastIndexOf(a);
        return 0 === r
          ? Promise.resolve(`${o}.${n}${e}`)
          : ((l = r - 1),
            he[l] ||
              (he[l] = new Promise((t) => {
                const e = new ae(
                  oe.createUrl("psl/" + l + ".txt"),
                  {
                    loaderDidSucceed(e, i) {
                      if (i.status < 200 || i.status >= 300) return void t(null);
                      const n = i.responseText
                        .split("\n")
                        .map((t) => t.trim())
                        .filter((t) => !!t);
                      t(n);
                    },
                    loaderDidFail() {
                      t(null);
                    }
                  },
                  {priority: re.Low, withCredentials: dt.distUrlWithCredentials}
                );
                e.schedule();
              })),
            he[l]).then((t) =>
              t
                ? (function (t, e) {
                    let i = "";
                    const n = [],
                      o = [];
                    for (const i of e)
                      if (i.startsWith("!")) {
                        const e = i.substring(1).split(".");
                        ce(t, e) && o.push(e);
                      } else {
                        const e = i.split(".");
                        ce(t, e) && n.push(e);
                      }
                    let s = ["*"];
                    return (
                      0 !== o.length ? ((s = de(o)), (s = s.slice(1))) : 0 !== n.length && (s = de(n)),
                      (i = t.slice(-s.length - 1).join(".")),
                      i
                    );
                  })(i, t) + e
                : `${o}.${n}${e}`
            );
        var l;
      }
    },
    pe = ue,
    me = j,
    ge = I,
    _e = {
      ScreenSize: "SCREEN_SIZE",
      DeviceIdentifier: "DEVICE_IDENTIFIER",
      BrowserInfo: "BROWSER_INFO",
      ApplicationIdentifier: "APPLICATION_IDENTIFIER",
      BrowserWindowSize: "BROWSER_WINDOW_SIZE",
      Url: "URL",
      MapView: "MAP_VIEW",
      UserSession: "USER_SESSION",
      Tiles: "TILES"
    },
    fe = {
      MapUserActionStates: [
        _e.ScreenSize,
        _e.DeviceIdentifier,
        _e.BrowserInfo,
        _e.ApplicationIdentifier,
        _e.BrowserWindowSize,
        _e.Url,
        _e.MapView,
        _e.UserSession,
        _e.Tiles
      ],
      SessionLessMapUserActionStates: [
        _e.ScreenSize,
        _e.DeviceIdentifier,
        _e.BrowserInfo,
        _e.ApplicationIdentifier,
        _e.BrowserWindowSize,
        _e.Url,
        _e.MapView,
        _e.Tiles
      ],
      GeneralUserActionStates: [
        _e.ScreenSize,
        _e.DeviceIdentifier,
        _e.BrowserInfo,
        _e.ApplicationIdentifier,
        _e.BrowserWindowSize,
        _e.Url,
        _e.UserSession
      ],
      SessionLessGeneralUserActionStates: [
        _e.ScreenSize,
        _e.DeviceIdentifier,
        _e.BrowserInfo,
        _e.ApplicationIdentifier,
        _e.BrowserWindowSize,
        _e.Url
      ],
      NetworkStates: [_e.DeviceIdentifier, _e.BrowserInfo, _e.ApplicationIdentifier, _e.UserSession]
    },
    ye = "USER_ACTION",
    ve = "NETWORK",
    we = ["OPEN_APPLE_MAPS"],
    be = {
      Zoom: {name: "ZOOM", states: fe.MapUserActionStates, type: ye},
      MapsLoad: {name: "MAPS_LOAD", states: fe.MapUserActionStates, type: ye},
      AnnotationClick: {name: "ANNOTATION_CLICK", states: fe.MapUserActionStates, type: ye},
      MapFeatureSelect: {
        name: "TAP_POI",
        states: fe.MapUserActionStates,
        type: ye,
        valueMap: {Poi: "POINT_OF_INTEREST", Territory: "TERRITORY", PhysicalFeature: "PHYSICAL_FEATURE"}
      },
      MapTypeChange: {name: "MAP_TYPE_CHANGE", states: fe.MapUserActionStates, type: ye},
      MapNodeReady: {name: "MAP_NODE_READY", states: fe.MapUserActionStates, type: ye},
      Pan: {name: "PAN", states: fe.MapUserActionStates, type: ye},
      PlaceAccessoryReveal: {name: "REVEAL", states: fe.MapUserActionStates, type: ye},
      PlaceAccessoryOpenAppleMaps: {name: "OPEN_APPLE_MAPS", states: fe.SessionLessMapUserActionStates, type: ye},
      PlaceDetailReveal: {name: "REVEAL", states: fe.GeneralUserActionStates, type: ye},
      PlaceDetailOpenAppleMaps: {name: "OPEN_APPLE_MAPS", states: fe.SessionLessGeneralUserActionStates, type: ye},
      Search: {name: "SEARCH", states: fe.NetworkStates, type: ve},
      SearchAC: {name: "SEARCH_AC", states: fe.NetworkStates, type: ve},
      PlaceLookup: {name: "PLACE_LOOKUP", states: fe.NetworkStates, type: ve},
      ForwardGeocoder: {name: "FORWARD_GEOCODER", states: fe.NetworkStates, type: ve},
      ReverseGeocoder: {name: "REVERSE_GEOCODER", states: fe.NetworkStates, type: ve},
      Directions: {name: "DIRECTIONS", states: fe.NetworkStates, type: ve},
      PointsOfInterestSearch: {name: "POINTS_OF_INTEREST_SEARCH", states: fe.NetworkStates, type: ve}
    };
  function Ce() {
    var t;
    ((this._isInternalClient =
      /\.apple\.com$/.test(window.origin) ||
      /\.icloud\.com$/.test(window.origin) ||
      /\.filemaker\.com$/.test(window.origin) ||
      /\.apple-mapkit\.com$/.test(window.origin) ||
      /\.tryrating\.com$/.test(window.origin)),
      dt.addEventListener(dt.Events.Changed, this),
      dt.ready && this._configurationBecameAvailable(),
      (this.uaParserInfo = ((t = navigator.userAgent), {browserInfo: It ? {} : Ot(t), deviceInfo: It ? {} : Pt(t)})),
      (this._debouncedQueueAsBackgroundTask = te(this._queueAsBackgroundTask, 1e4, this)),
      window.addEventListener("pagehide", this),
      document.addEventListener("visibilitychange", this),
      (this._queuedMessages = []),
      (this._queuedSessionLessMessages = []));
  }
  Ce.prototype = {
    _shortSessionLoader: null,
    _sessionLessLoader: null,
    _analyticsUrl: null,
    _errorUrl: null,
    _sessionId: null,
    _sessionTimerStart: null,
    _sessionTimeToExpire: null,
    _sequenceNumber: null,
    _relativeTimestamp: null,
    _isCustomSession: !1,
    _refreshCustomSession: null,
    _enableServerAnalytics: !1,
    _serverEnvironment: null,
    _isInternalServer: void 0,
    _trackPanEvent: !1,
    _handleAnalyticsTrackingResponse: null,
    _registerableHostDomain: "",
    _registerableReferrerDomain: "",
    _reducedHostPlaceholders: {ProtocolPlusHost: null, Host: null, ReferrerHost: null},
    States: _e,
    Events: be,
    EventTarget: "UI_TARGET_UNKNOWN",
    log: function (t, e = {}) {
      this._enableServerAnalytics;
      const i = new Date().getTime();
      ((!this._sessionId || i > this._sessionTimeToExpire) &&
        (this._isCustomSession && this._refreshCustomSession ? this._refreshCustomSession() : this._initSession()),
        (this._relativeTimestamp = (new Date().getTime() - this._sessionTimerStart) / 1e3),
        (this._sequenceNumber = Math.ceil(1e4 * this._relativeTimestamp)),
        this.uaParserInfo && (e.uaParserInfo = this.uaParserInfo),
        we.includes(t.name) || e?.isEventSessionLess
          ? this._queuedSessionLessMessages.push(this._createMessage(t, e))
          : this._queuedMessages.push(this._createMessage(t, e)),
        dt.analytics && this._debouncedQueueAsBackgroundTask());
    },
    initCustomSession: function (t) {
      ((this._isCustomSession = !0),
        (this._sessionId = t.sessionId),
        (this._sessionTimerStart = t.sessionStartTime),
        (this._sessionTimeToExpire = this._sessionTimerStart + t.sessionDurationMs));
    },
    manageAnalyticsTrackingResponse: function (t, e, i = !1) {
      if (!this._handleAnalyticsTrackingResponse) return;
      let n;
      if (i) n = {eventCount: e, sentViaSendBeacon: i};
      else {
        const e = t._xhr.status,
          o = (t._xhrData ? JSON.parse(t._xhrData) : {}).analytics_event;
        n = {eventCount: o && Array.isArray(o) ? o.length : 0, responseCode: e, sentViaSendBeacon: i};
      }
      (this._handleAnalyticsTrackingResponse(n),
        i &&
          (0 !== this._queuedMessages.length &&
            this._queuedMessages.forEach((t) => {
              t.sent_via_send_beacon = !0;
            }),
          0 !== this._queuedSessionLessMessages.length &&
            this._queuedSessionLessMessages.forEach((t) => {
              t.sent_via_send_beacon = !0;
            })));
    },
    setEventTarget: function (t) {
      this.EventTarget = t;
    },
    getDataToSend: function (t) {
      return 0 === this._queuedMessages.length
        ? (this._shortSessionLoader.unschedule(), !1)
        : (t.setRequestHeader("Content-Type", "text/plain"), (t.responseType = "text"), this._createShortSessionJson());
    },
    loaderDidSucceed: function (t) {
      (this.manageAnalyticsTrackingResponse(t), delete this._shortSessionLoader);
    },
    loaderDidFail: function (t) {
      ((this._queuedMessages = this._queuedMessages.concat(JSON.parse(t.xhrData).analytics_event)),
        this.manageAnalyticsTrackingResponse(t),
        delete this._shortSessionLoader);
    },
    getSessionLessDataToSend: function (t) {
      return 0 === this._queuedSessionLessMessages.length
        ? (this._sessionLessLoader.unschedule(), !1)
        : (t.setRequestHeader("Content-Type", "text/plain"), (t.responseType = "text"), this._createSessionLessJson());
    },
    sessionLessloaderDidSucceed: function (t) {
      (this.manageAnalyticsTrackingResponse(t), delete this._sessionLessLoader);
    },
    sessionLessLoaderDidFail: function (t) {
      ((this._queuedSessionLessMessages = this._queuedSessionLessMessages.concat(
        JSON.parse(t.xhrData).analytics_event
      )),
        this.manageAnalyticsTrackingResponse(t),
        delete this._sessionLessLoader);
    },
    handleEvent: function (t) {
      switch (t.type) {
        case dt.Events.Changed:
          this._configurationBecameAvailable();
          break;
        case "pagehide":
          this._sendPendingData();
          break;
        case "visibilitychange":
          "hidden" === document.visibilityState && this._sendPendingData();
      }
    },
    getReduceHostPlaceholder: function (t) {
      return (
        this._reducedHostPlaceholders[t] || (this._reducedHostPlaceholders[t] = Symbol()),
        this._reducedHostPlaceholders[t]
      );
    },
    _createMessage: function (t, e) {
      let i;
      switch (t.type) {
        case ye:
          i = this._createUserActionMessage(t, e);
          break;
        case ve:
          i = this._createNetworkMessage(t, e);
          break;
        default:
          i = {};
      }
      const n = [].concat(t.states ? t.states : [], e.states ? Object.keys(e.states) : []);
      return ((i.analytics_state = this._createStateMessages(n, e)), (i.sent_via_send_beacon = !1), i);
    },
    _createUserActionMessage: function (t, e) {
      const i = {event_type: ye, user_action_event: {user_action_event_key: t.name}};
      return (
        (e.eventValue || 0 === e.eventValue) &&
          (i.user_action_event.user_action_event_value = t.valueMap ? t.valueMap[e.eventValue] : e.eventValue),
        e.eventTarget && (i.user_action_event.user_action_event_target = e.eventTarget),
        e.eventModule && (i.user_action_event.user_action_event_module = e.eventModule),
        i
      );
    },
    _createNetworkMessage: function (t, e) {
      const i = {event_type: ve, network_event: {network_service: t.name}},
        n = parseInt(e.responseCode);
      return (e.responseCode && !isNaN(n) && (i.network_event.http_response_code = n), i);
    },
    _initSession: function () {
      ((this._isCustomSession = !1),
        (this._sessionId = {high: _(), low: _()}),
        (this._sessionTimerStart = new Date().getTime()),
        (this._sessionTimeToExpire = this._sessionTimerStart + 9e5));
    },
    _createStateMessages: function (t, i) {
      return t.map(function (t) {
        const n = {state_type: t};
        return (e[t] ? (n[t.toLowerCase()] = e[t](this, i)) : i.states[t] && (n[t.toLowerCase()] = i.states[t](i)), n);
      }, this);
    },
    _createShortSessionJson: function () {
      const t = this._createJson({
        analytics_message_type: "SHORT_SESSION_USAGE",
        analytics_event: this._queuedMessages
      });
      return ((this._queuedMessages = []), t);
    },
    _createSessionLessJson() {
      const t = this._createJson({
        analytics_message_type: "SESSIONLESS_USAGE",
        analytics_event: this._queuedSessionLessMessages
      });
      return ((this._queuedSessionLessMessages = []), t);
    },
    _createJson(t) {
      return JSON.stringify(t, (t, e) => {
        switch (e) {
          case this._reducedHostPlaceholders.Host:
            return this._registerableHostDomain;
          case this._reducedHostPlaceholders.ProtocolPlusHost:
            return this._registerableHostDomain ? window.location.protocol + "//" + this._registerableHostDomain : "";
          case this._reducedHostPlaceholders.ReferrerHost:
            return this._registerableReferrerDomain;
          default:
            return e;
        }
      });
    },
    _configurationBecameAvailable: function () {
      (dt.analytics && ((this._analyticsUrl = dt.analytics.analyticsUrl), (this._withCredentials = dt.withCredentials)),
        dt.analyticsTeamId ? (this._teamId = dt.analyticsTeamId) : dt.teamId && (this._teamId = dt.teamId));
    },
    _scheduleLoaderRequest: function () {
      (this._shortSessionLoader ||
        0 === this._queuedMessages.length ||
        ((this._shortSessionLoader = new me(this._analyticsUrl, this, {
          method: "POST",
          priority: ge.Low,
          retry: !0,
          withCredentials: this._withCredentials
        })),
        this._shortSessionLoader.schedule()),
        this._sessionLessLoader ||
          0 === this._queuedSessionLessMessages.length ||
          ((this._sessionLessLoader = new me(
            this._analyticsUrl,
            {
              getDataToSend: (t) => {
                this.getSessionLessDataToSend(t);
              },
              loaderDidSucceed: (t) => {
                this.sessionLessloaderDidSucceed(t);
              },
              loaderDidFail: (t) => {
                this.sessionLessLoaderDidFail(t);
              }
            },
            {method: "POST", priority: ge.Low, retry: !0, withCredentials: this._withCredentials}
          )),
          this._sessionLessLoader.schedule()));
    },
    _scheduleLoader: function () {
      this._resolveRegisterableDomains().then(() => {
        this._scheduleLoaderRequest();
      });
    },
    _queueAsBackgroundTask: function () {
      Qt.scheduleInBackground(() => this._scheduleLoader(), Qt.Priority.Low);
    },
    _resolveRegisterableDomains: function () {
      const t = !!this._reducedHostPlaceholders.ProtocolPlusHost || !!this._reducedHostPlaceholders.Host,
        e = this._reducedHostPlaceholders.ReferrerHost && document.referrer ? new URL(document.referrer) : null,
        i = e ? e.hostname : null;
      return Promise.all([
        t ? pe.getRegisterableDomain(window.location.hostname) : "",
        pe.getRegisterableDomain(i)
      ]).then(([t, i]) => {
        ((this._registerableHostDomain = t ? (window.location.port ? `${t}:${window.location.port}` : t) : ""),
          (this._registerableReferrerDomain = i ? (e && e.port ? `${i}:${e.port}` : i) : ""));
      });
    },
    _sendPendingData: function () {
      if (0 !== this._queuedMessages.length) {
        const t = this._queuedMessages.length;
        if ((this.manageAnalyticsTrackingResponse(null, t, !0), "function" == typeof navigator.sendBeacon))
          navigator.sendBeacon(this._analyticsUrl, this._createShortSessionJson());
        else {
          const t = new XMLHttpRequest();
          (t.open("POST", this._analyticsUrl, !1), t.send(this._createShortSessionJson()));
        }
      }
      if (0 !== this._queuedSessionLessMessages.length) {
        const t = this._queuedSessionLessMessages.length;
        if ((this.manageAnalyticsTrackingResponse(null, t, !0), "function" == typeof navigator.sendBeacon))
          navigator.sendBeacon(this._analyticsUrl, this._createSessionLessJson());
        else {
          const t = new XMLHttpRequest();
          (t.open("POST", this._analyticsUrl, !1), t.send(this._createSessionLessJson()));
        }
      }
    }
  };
  const ke = new Ce(),
    Me = (t, e) => t - e * Math.floor(t / e),
    Se = Math.PI / 180,
    Le = Math.PI / 4,
    Ae = 2 * Math.PI,
    Ee = 12,
    xe = 256,
    Te = Math.PI / 3,
    Ie = Math.tan(Te / 2);
  function Re(t) {
    const e = ((i = t), 1e-8 - 90, 90 - 1e-8, Math.max(-89.99999999, Math.min(i, 89.99999999)) * Se);
    var i;
    return 0.5 + Math.log(Math.tan(Le - e / 2)) / Ae;
  }
  function Oe(t) {
    const e = Math.pow(Math.E, 2 * Math.PI * (t - 0.5));
    return ((-2 * (Math.atan(e) - Math.PI / 4)) / Math.PI) * 180;
  }
  function Pe(t) {
    return Me(t / 360 + 0.5, 1);
  }
  function De(t) {
    return 360 * (Me(t, 1) - 0.5);
  }
  function ze(t) {
    return Me(180 + t, 360) - 180;
  }
  function Ne(t) {
    const e = t * Se,
      i = 111132.92 + -559.82 * Math.cos(2 * e) + 1.175 * Math.cos(4 * e) + -0.0023 * Math.cos(6 * e),
      n = Re(t - 0.5),
      o = Re(t + 0.5);
    return Math.abs(n - o) / i;
  }
  const Fe = 1e-8,
    Ue = Oe(0),
    Ge = Oe(1);
  class Be {
    constructor(t, e) {
      if ((void 0 === t && (t = new We()), void 0 === e && (e = new Ze()), !(t instanceof We)))
        throw Error("[MapKit] `center` is not a Coordinate.");
      if (!(e instanceof Ze)) throw Error("[MapKit] `span` is not a CoordinateSpan.");
      ((this.center = new We(t.latitude, t.longitude)), (this.span = new Ze(e.latitudeDelta, e.longitudeDelta)));
    }
    copy() {
      return new Be(this.center.copy(), this.span.copy());
    }
    toString() {
      return [
        "CoordinateRegion(",
        "\tlatitude: " + this.center.latitude,
        "\tlongitude: " + this.center.longitude,
        "\tlatitudeDelta: " + this.span.latitudeDelta,
        "\tlongitudeDelta: " + this.span.longitudeDelta,
        ")"
      ].join("\n");
    }
    equals(t) {
      return this.center.equals(t.center) && this.span.equals(t.span);
    }
    toBoundingRegion() {
      const t = this.span.latitudeDelta / 2,
        e = this.span.longitudeDelta / 2;
      return new Ke(
        this.center.latitude + t,
        ze(this.center.longitude + e),
        this.center.latitude - t,
        ze(this.center.longitude - e)
      );
    }
    toMapRect() {
      if (this.span.latitudeDelta < 0) this.span.latitudeDelta = 0;
      else {
        const t = Re(Math.abs(this.center.latitude)),
          e = Ue - Oe(2 * t);
        this.span.latitudeDelta > e && (this.span.latitudeDelta = e);
      }
      const t = ze(this.center.longitude),
        e = this.span.longitudeDelta / 2;
      let i = t - e,
        n = t + e,
        o = !1;
      i < -180 && ((i += 360), (o = !0));
      let s = !1;
      n > 180 && ((n -= 360), (s = !0));
      const a = new We(this.center.latitude, i),
        r = new We(this.center.latitude, n),
        l = a.toMapPoint(),
        h = r.toMapPoint();
      (o && (l.x -= 1), s && (h.x += 1));
      const c = new Ve();
      let d, u;
      if (0 === this.center.latitude)
        return (
          (d = new We(this.center.latitude + this.span.latitudeDelta / 2, this.center.longitude)),
          (u = new We(this.center.latitude - this.span.latitudeDelta / 2, this.center.longitude)),
          (c.origin.x = l.x),
          (c.size.width = h.x - c.origin.x),
          (c.origin.y = d.toMapPoint().y),
          (c.size.height = u.toMapPoint().y - c.origin.y),
          c
        );
      const p = this.copy();
      p.center.latitude = Ge + this.span.latitudeDelta / 2;
      let m = 10,
        g = new We();
      const _ = new He();
      ((d = new We()), (u = new We()), (d.longitude = this.center.longitude), (u.longitude = this.center.longitude));
      let f = 0;
      do {
        if (
          (p.center.latitude > Ue && p.center.latitude > this.center.latitude) ||
          (p.center.latitude < Ge && p.center.latitude < this.center.latitude)
        )
          ((p.center.latitude -= m), (m *= 0.1));
        else if (p.center.latitude > Ue || p.center.latitude < Ge) return new Ve(0, 0, 1, 1);
        if (f > 500) return new Ve(0, 0, 1, 1);
        ((d.latitude = p.center.latitude + p.span.latitudeDelta / 2),
          (u.latitude = p.center.latitude - p.span.latitudeDelta / 2),
          (c.origin.x = l.x),
          (c.size.width = h.x - c.origin.x),
          (c.origin.y = d.toMapPoint().y),
          (c.size.height = u.toMapPoint().y - c.origin.y),
          (_.x = c.midX()),
          (_.y = c.midY()),
          (g = _.toCoordinate()),
          ((m > 0 && g.latitude > this.center.latitude) || (m < 0 && g.latitude < this.center.latitude)) && (m *= -0.1),
          (p.center.latitude += m),
          f++);
      } while (Math.abs(g.latitude - this.center.latitude) >= Fe);
      return c;
    }
    get radius() {
      const t = this.toMapRect();
      let e, i;
      return (
        t.size.width > t.size.height
          ? ((e = new He(t.minX(), t.midY())), (i = new He(t.maxX(), t.midY())))
          : ((e = new He(t.midX(), t.minY())), (i = new He(t.midX(), t.maxY()))),
        (function (t, e) {
          const i = t.toCoordinate(),
            n = e.toCoordinate();
          return (function (t, e, i, n, o) {
            const s = (i - t) * Se,
              a = (n - e) * Se,
              r = Math.pow(Math.sin(s / 2), 2) + Math.cos(t * Se) * Math.cos(i * Se) * Math.pow(Math.sin(a / 2), 2);
            return o * (2 * Math.atan2(Math.sqrt(r), Math.sqrt(1 - r)));
          })((o = i.latitude), i.longitude, n.latitude, n.longitude, 6378160 - 21e3 * Math.sin(o * Se));
          var o;
        })(e, i) / 2
      );
    }
  }
  class Ze {
    constructor(t, e) {
      if ((void 0 === t && (t = 0), void 0 === e && (e = 0), "number" != typeof t || isNaN(t)))
        throw new TypeError("[MapKit] `latitudeDelta` is not a number.");
      if ("number" != typeof e || isNaN(e)) throw new TypeError("[MapKit] `longitudeDelta` is not a number.");
      ((this.latitudeDelta = Math.max(t, 0)), (this.longitudeDelta = Math.max(e, 0)));
    }
    copy() {
      return new Ze(this.latitudeDelta, this.longitudeDelta);
    }
    equals(t) {
      return (
        Math.abs(this.latitudeDelta - t.latitudeDelta) < Fe && Math.abs(this.longitudeDelta - t.longitudeDelta) < Fe
      );
    }
    toString() {
      return [
        "CoordinateSpan(",
        "\tlatitudeDelta: " + this.latitudeDelta,
        "\tlongitudeDelta: " + this.longitudeDelta,
        ")"
      ].join("\n");
    }
  }
  class We {
    constructor(t, e) {
      if ((void 0 === t && (t = 0), void 0 === e && (e = 0), "number" != typeof t || isNaN(t)))
        throw new TypeError("[MapKit] `latitude` is not a number.");
      if ("number" != typeof e || isNaN(e)) throw new TypeError("[MapKit] `longitude` is not a number.");
      ((this.latitude = t), (this.longitude = e));
    }
    copy() {
      return new We(this.latitude, this.longitude);
    }
    equals(t) {
      return Math.abs(this.latitude - t.latitude) < Fe && Math.abs(this.longitude - t.longitude) < Fe;
    }
    toMapPoint() {
      return new He(Pe(this.longitude), Re(this.latitude));
    }
    toUnwrappedMapPoint() {
      return new He(this.longitude / 360 + 0.5, Re(this.latitude));
    }
    toString() {
      return [
        "Coordinate(",
        "latitude:" + this.latitude.toFixed(Ee),
        ",longitude:" + this.longitude.toFixed(Ee),
        ")"
      ].join("");
    }
  }
  class Ke {
    constructor(t, e, i, n) {
      if (
        (arguments.length < 4 &&
          ((n = 0),
          arguments.length < 3 && ((i = 0), arguments.length < 2 && ((e = 0), arguments.length < 1 && (t = 0)))),
        "number" != typeof t || isNaN(t))
      )
        throw new TypeError(
          "[MapKit] Expected a number for `northLatitude` in BoundingRegion constructor but got `" + t + "` instead."
        );
      if ("number" != typeof e || isNaN(e))
        throw new TypeError(
          "[MapKit] Expected a number for `eastLongitude` in BoundingRegion constructor but got `" + e + "` instead."
        );
      if ("number" != typeof i || isNaN(i))
        throw new TypeError(
          "[MapKit] Expected a number for `southLatitude` in BoundingRegion constructor but got `" + i + "` instead."
        );
      if ("number" != typeof n || isNaN(n))
        throw new TypeError(
          "[MapKit] Expected a number for `westLongitude` in BoundingRegion constructor but got `" + n + "` instead."
        );
      ((this.northLatitude = t), (this.eastLongitude = e), (this.southLatitude = i), (this.westLongitude = n));
    }
    copy() {
      return new Ke(this.northLatitude, this.eastLongitude, this.southLatitude, this.westLongitude);
    }
    toString() {
      return [
        "BoundingRegion(",
        "\tnorthLatitude: " + this.northLatitude,
        "\teastLongitude: " + this.eastLongitude,
        "\tsouthLatitude: " + this.southLatitude,
        "\twestLongitude: " + this.westLongitude,
        ")"
      ].join("\n");
    }
    toCoordinateRegion() {
      let t = ze(this.eastLongitude);
      const e = ze(this.westLongitude);
      t < e && (t += 360);
      const i = this.northLatitude - this.southLatitude,
        n = t - e;
      return new Be(new We(this.southLatitude + i / 2, ze(e + n / 2)), new Ze(i, n));
    }
  }
  class He {
    constructor(t, e) {
      if ((arguments.length < 2 && ((e = 0), arguments.length < 1 && (t = 0)), "number" != typeof t || isNaN(t)))
        throw new TypeError("[MapKit] Expected a number for `x` in MapPoint constructor but got `" + t + "` instead.");
      if ("number" != typeof e || isNaN(e))
        throw new TypeError("[MapKit] Expected a number for `y` in MapPoint constructor but got `" + e + "` instead.");
      ((this.x = t), (this.y = e), (this.z = 0), (this.w = 1));
    }
    toString() {
      return "MapPoint(" + this.x + ", " + this.y + ")";
    }
    copy() {
      return new He(this.x, this.y);
    }
    equals(t) {
      return this.x === t.x && this.y === t.y;
    }
    toCoordinate() {
      return new We(Oe(this.y), ze(De(this.x)));
    }
  }
  class je {
    constructor(t, e) {
      if ((arguments.length < 2 && ((e = 0), arguments.length < 1 && (t = 0)), "number" != typeof t || isNaN(t)))
        throw new TypeError(
          "[MapKit] Expected a number for `width` in MapSize constructor but got `" + t + "` instead."
        );
      if ("number" != typeof e || isNaN(e))
        throw new TypeError(
          "[MapKit] Expected a number for `height` in MapSize constructor but got `" + e + "` instead."
        );
      ((this.width = t), (this.height = e));
    }
    toString() {
      return "MapSize(" + this.width + ", " + this.height + ")";
    }
    copy() {
      return new je(this.width, this.height);
    }
    equals(t) {
      return this.width === t.width && this.height === t.height;
    }
  }
  class Ve {
    constructor(t, e, i, n) {
      if (
        (arguments.length < 4 &&
          ((n = 0),
          arguments.length < 3 && ((i = 0), arguments.length < 2 && ((e = 0), arguments.length < 1 && (t = 0)))),
        "number" != typeof t || isNaN(t))
      )
        throw new TypeError("[MapKit] Expected a number for `x` in MapRect constructor but got `" + t + "` instead.");
      if ("number" != typeof e || isNaN(e))
        throw new TypeError("[MapKit] Expected a number for `y` in MapRect constructor but got `" + e + "` instead.");
      if ("number" != typeof i || isNaN(i))
        throw new TypeError(
          "[MapKit] Expected a number for `width` in MapRect constructor but got `" + i + "` instead."
        );
      if ("number" != typeof n || isNaN(n))
        throw new TypeError(
          "[MapKit] Expected a number for `height` in MapRect constructor but got `" + n + "` instead."
        );
      ((this.origin = new He(t, e)), (this.size = new je(i, n)));
    }
    toString() {
      return (
        "MapRect(" +
        [
          this.origin.x.toFixed(Ee),
          this.origin.y.toFixed(Ee),
          this.size.width.toFixed(Ee),
          this.size.height.toFixed(Ee)
        ].join(", ") +
        ")"
      );
    }
    copy() {
      return new Ve(this.origin.x, this.origin.y, this.size.width, this.size.height);
    }
    equals(t) {
      return this.origin.equals(t.origin) && this.size.equals(t.size);
    }
    minX() {
      return this.origin.x;
    }
    minY() {
      return this.origin.y;
    }
    midX() {
      return this.origin.x + this.size.width / 2;
    }
    midY() {
      return this.origin.y + this.size.height / 2;
    }
    maxX() {
      return this.origin.x + this.size.width;
    }
    maxY() {
      return this.origin.y + this.size.height;
    }
    scale(t, e) {
      if ("number" != typeof t || isNaN(t))
        throw new TypeError("[MapKit] The `scaleFactor` parameter passed to `MapRect.scale()` is not a number.");
      const i = this.size.width * t,
        n = this.size.height * t;
      if (!e) return new Ve(this.midX() - i / 2, this.midY() - n / 2, i, n);
      if (!(e instanceof He))
        throw Error("[MapKit] The `scaleCenter` parameter passed to `MapRect.scale()` is not a MapPoint.");
      return new Ve(e.x - t * (e.x - this.origin.x), e.y - t * (e.y - this.origin.y), i, n);
    }
    toCoordinateRegion() {
      const t = this.origin.toCoordinate(),
        e = new He(this.maxX(), this.maxY()).toCoordinate(),
        i = Math.abs(e.latitude - t.latitude);
      let n = e.longitude - t.longitude;
      return (
        e.longitude < t.longitude && (n += 360),
        new Be(new He(this.midX(), this.midY()).toCoordinate(), new Ze(i, n))
      );
    }
  }
  class qe {
    constructor(t, e) {
      if (null == e)
        if ("number" == typeof t) e = 1 / 0;
        else {
          const i = null == t ? {} : t;
          ((t = "minCameraDistance" in i ? i.minCameraDistance : 0),
            (e = "maxCameraDistance" in i ? i.maxCameraDistance : 1 / 0));
        }
      if ("number" != typeof t || t < 0)
        throw new Error("[MapKit] The `minCameraDistance` property of CameraZoomRange must be a number >= 0");
      if ("number" != typeof e || e < 0)
        throw new Error("[MapKit] The `maxCameraDistance` property of CameraZoomRange must be a number >= 0");
      if (e < t)
        throw new Error(
          "[MapKit] The `maxCameraDistance` property of CameraZoomRange must be greater than the `minCameraDistance` property."
        );
      ((this._minCameraDistance = t), (this._maxCameraDistance = e));
    }
    get minCameraDistance() {
      return this._minCameraDistance;
    }
    get maxCameraDistance() {
      return this._maxCameraDistance;
    }
    copy() {
      return new qe(this._minCameraDistance, this._maxCameraDistance);
    }
  }
  const Ye = {
      tileSize: xe,
      convertLatitudeToY: Re,
      convertYToLatitude: Oe,
      convertLongitudeToX: Pe,
      convertXToLongitude: De,
      wrapLongitude: ze,
      wrapX: function (t, e) {
        let i = 1.5,
          n = t;
        for (let o = -1; o <= 1; ++o) {
          const s = Math.abs(t + o - e);
          s < i && ((i = s), (n = t + o));
        }
        return n;
      },
      zoomLevelForMapRectInViewport: function (t, e, i) {
        const n = e.width / (i * t.size.width),
          o = e.height / (i * t.size.height);
        return Math.log2(Math.min(n, o));
      },
      mapUnitsPerMeterAtLatitude: Ne,
      pointsPerAxis: function (t) {
        return Math.pow(2, t) * xe;
      },
      zoomLevelForCameraDistanceAtLatitudeAndViewportWidth: function (t, e, i) {
        const n = Ie * t * 2 * Ne(e);
        return Math.log2(i / n / xe);
      },
      CameraZoomRange: qe,
      CoordinateRegion: Be,
      CoordinateSpan: Ze,
      Coordinate: We,
      BoundingRegion: Ke,
      MapPoint: He,
      MapRect: Ve,
      MapSize: je
    },
    Xe = Ye.BoundingRegion,
    $e = Ye.Coordinate;
  function Je(t) {
    let e, i;
    (t.id && ((this.id = t.id), (this.alternateIds = t.alternateIds || [])),
      t.muid && (this.muid = t.muid),
      t.placecardUrl && (this._wpURL = t.placecardUrl),
      t.style &&
        t.style.attributes &&
        ((this._styleAttributes = t.style.attributes.map((t) => t.key + ":" + t.value).join(",")),
        t.poiCategory &&
          -1 !== Object.keys(mt).indexOf(t.poiCategory) &&
          (this.pointOfInterestCategory = mt[t.poiCategory])),
      t.name && (this.name = t.name),
      t.attribution &&
        ((this._providerId = t.attribution.vendorId), (this._providerItemId = t.attribution.externalItemId)),
      t.displayMapRegion &&
        ((e = t.displayMapRegion),
        (i = new Xe(e.northLat, e.eastLng, e.southLat, e.westLng)),
        (this.region = i.toCoordinateRegion()),
        (this.coordinate = this.region.center)),
      t.formattedAddressLines && (this.formattedAddress = t.formattedAddressLines.join(", ")),
      t.center && (this.coordinate = new $e(t.center.lat, t.center.lng)),
      t.countryCode && (this.countryCode = t.countryCode),
      (this.telephone = t.telephone),
      (this.urls = t.urls || []),
      (this.country = t.country),
      (this.administrativeArea = t.administrativeArea),
      (this.administrativeAreaCode = t.administrativeAreaCode),
      (this.locality = t.locality),
      (this.postCode = t.postCode),
      (this.subLocality = t.subLocality),
      (this.thoroughfare = t.thoroughfare),
      (this.subThoroughfare = t.subThoroughfare),
      (this.fullThoroughfare = t.fullThoroughfare),
      (this.areasOfInterest = t.areasOfInterest),
      (this.dependentLocalities = t.dependentLocalities),
      (this.timezone = t.timezone),
      (this.timezoneSecondsFromGmt = t.timezoneSecondsFromGmt));
  }
  Je.isConstructable = !1;
  const Qe = function (t) {
    if (Je.isConstructable) return Je.call(this, t);
    throw new TypeError("[MapKit] Place may not be constructed.");
  };
  Je.prototype = Qe.prototype = {constructor: Qe};
  const ti = Je;
  class ei {
    constructor(t, e, i, n) {
      ((this.localeId = t),
        (this._dict = e || {}),
        (this.ready = !!e),
        (this.delegate = i),
        (this.rtl = i.rtlLocales.indexOf(t) > -1),
        (this.dow = n));
    }
    get(t, e) {
      const i = this._dict[t];
      return i ? m(i, e ?? {}, !0) : `[${t}]`;
    }
    load(t) {
      const e = this.localeId,
        i = this.delegate.localeUrl.replace(/{{(.*?)}}/, e),
        n = new j(
          i,
          {
            loaderDidSucceed: (i, n) => {
              if (n.status < 200 || n.status >= 300) {
                const i = new Error(`HTTP error ${n.status} loading strings for locale: ${e}`);
                t(i, this);
              } else {
                try {
                  this._dict = JSON.parse(n.responseText ?? "");
                } catch (i) {
                  const n = new Error(`Failed to parse response for locale: ${e}`);
                  return void t(n, this);
                }
                ((this.ready = !0), t(null, this));
              }
            },
            loaderDidFail: (i, n) => {
              const o = new Error(`Network error loading strings for locale: ${e}`);
              t(o, this);
            }
          },
          {withCredentials: this.delegate.withCredentials}
        );
      n.schedule();
    }
  }
  const ii = Object.freeze({
      "ar-SA": 6,
      "ca-ES": 1,
      "cs-CZ": 1,
      "da-DK": 1,
      "de-DE": 1,
      "el-GR": 1,
      "en-AU": 1,
      "en-GB": 1,
      "en-US": 0,
      "en-ZA": 0,
      "es-ES": 1,
      "es-MX": 1,
      "fi-FI": 1,
      "fr-CA": 0,
      "fr-FR": 1,
      "he-IL": 0,
      "hi-IN": 0,
      "hr-HR": 1,
      "hu-HU": 1,
      "id-ID": 1,
      "it-IT": 1,
      "ja-JP": 0,
      "ko-KR": 0,
      "ms-MY": 1,
      "nb-NO": 1,
      "nl-NL": 1,
      "pl-PL": 1,
      "pt-BR": 0,
      "pt-PT": 1,
      "ro-RO": 1,
      "ru-RU": 1,
      "sk-SK": 1,
      "sv-SE": 1,
      "th-TH": 0,
      "tr-TR": 1,
      "uk-UA": 1,
      "vi-VN": 1,
      "zh-CN": 1,
      "zh-HK": 0,
      "zh-TW": 0
    }),
    ni = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    oi = {
      "ar-SA": ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
      "hi-IN": ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"]
    },
    si = ",",
    ai = {
      "ca-ES": si,
      "ca-CZ": si,
      "da-DK": si,
      "da-DE": si,
      "el-GR": si,
      "en-ZA": si,
      "es-ES": si,
      "fi-FI": si,
      "fr-CA": si,
      "fr-FR": si,
      "hr-HR": si,
      "hu-HU": si,
      "it-IT": si,
      "nb-NO": si,
      "nl-NL": si,
      "pl-PL": si,
      "pt-BR": si,
      "pt-PT": si,
      "ro-RO": si,
      "ru-RU": si,
      "sk-SK": si,
      "sv-SE": si,
      "tr-TR": si,
      "uk-UA": si
    },
    ri = "en-US",
    li = new WeakSet(),
    hi = new WeakSet(),
    ci = (t, e) => {
      const {language: i, region: n} = e;
      ((t.supportMap[i] = t.supportMap[i] || []),
        n && -1 !== t.delegate.primaryLocales.indexOf(e.tag)
          ? t.supportMap[i].splice(0, 0, n)
          : n && t.supportMap[i].push(n));
    },
    di = (t, e, i) => new ei(e, i ?? null, t.delegate, t.dowForBestMatch(e)),
    ui = (t, e) => {
      (t.locales[e.localeId] || (t.locales[e.localeId] = e), (t.activeLocale = e), t.dispatchEvent(new pi(e)));
    };
  class pi extends k.Event {
    constructor(t) {
      (super(mi.Events.LocaleChanged), (this.locale = t));
    }
  }
  class mi extends k.EventTarget {
    constructor(t) {
      (super(),
        (this.delegate = t),
        (this._requestedLocaleId = ""),
        (this.locales = t.localesCache || Object.create(null)),
        (this.supportMap = t.supportCache || Object.create(null)),
        (this.scriptMap = t.scriptCache || Object.create(null)),
        (this.Events = mi.Events),
        ((t) => {
          if (!li.has(t.supportMap)) {
            li.add(t.supportMap);
            for (const e of t.delegate.supportedLocales) {
              const i = f.parse(e);
              i && ci(t, i);
            }
          }
        })(this));
      const e = this.locales[ri] || di(this, ri, this.delegate.enUSDictionary);
      (this.locales[e.localeId] || (this.locales[e.localeId] = e),
        (this.activeLocale = e),
        ((t) => {
          if (hi.has(t.scriptMap)) return;
          hi.add(t.scriptMap);
          const e = t.delegate.regionToScriptMap;
          for (const [i, n] of Object.entries(e)) {
            t.scriptMap[i] = {};
            for (const [e, o] of Object.entries(n)) t.scriptMap[i][o.toLowerCase()] = e;
          }
        })(this));
    }
    get(t, e) {
      return this.activeLocale.get(t, e) ?? `[${t}]`;
    }
    get localeId() {
      return this.activeLocale.localeId ?? "";
    }
    set localeId(t) {
      this._requestedLocaleId !== t &&
        ((t, e) => {
          t._requestedLocaleId = e;
          let i = e;
          if (
            (((t, e) => -1 !== t.delegate.supportedLocales.indexOf(e))(t, e) || (i = t.bestMatch(e, ri)),
            t.activeLocale.localeId === i)
          )
            return;
          let n = i ? t.locales[i] : null;
          n || !i || ((n = di(t, i)), n.ready)
            ? n && ui(t, n)
            : n.load((i, n) => {
                if (t._requestedLocaleId === e)
                  return i ? ((t._requestedLocaleId = ri), void ui(t, t.locales[ri])) : void ui(t, n);
              });
        })(this, t);
    }
    get loaded() {
      return !!this._requestedLocaleId && this.bestMatch(this._requestedLocaleId, ri) === this.localeId;
    }
    get requestedLocaleId() {
      return this._requestedLocaleId;
    }
    set requestedLocaleId(t) {
      console.warn("l10n: requestedLocaleId can't be set, use localeId.");
    }
    get localeIds() {
      return Object.keys(this.locales);
    }
    get supportedLocaleIds() {
      return this.delegate.supportedLocales;
    }
    bestMatch(t, e) {
      let i = "string" == typeof t ? f.parse(t) : null,
        n = null;
      if (i && this.delegate.localesMap) {
        const t = this.delegate.localesMap;
        t[i.tag] ? (i = f.parse(t[i.tag])) : t[i.language] && (i = f.parse(t[i.language]));
      }
      return (
        (e = e || null),
        i &&
          (n = ((t, e) => {
            const {language: i, region: n, script: o} = e;
            let s;
            const a = t.supportMap[i];
            if (!a) return null;
            if ((n && (s = a.find((t) => t.toUpperCase() === e.region?.toUpperCase())), !s && o)) {
              const e = t.scriptMap[i]?.[o.toLowerCase()];
              s = e ?? s;
            }
            return (s || (s = a[0]), new f(i, s));
          })(this, i)),
        n ? n.tag : e
      );
    }
    dowForBestMatch(t, e) {
      const i = this.bestMatch(t, e);
      return i && i in ii ? ii[i] : 0;
    }
    digits(t) {
      return (function (t, e) {
        const i = oi[e] || ni,
          n = ai[e] || ".";
        let o = "";
        const s = t.toString();
        for (let t = 0, e = s.length; t < e; ++t) {
          const e = s.charAt(t);
          o += "." === e ? n : i[parseInt(e, 10)] || e;
        }
        return o;
      })(t, this.localeId);
    }
  }
  ((mi.Events = Object.freeze({LocaleChanged: "locale-changed"})),
    (mi.Days = Object.freeze({Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6})),
    (mi.LocaleChangedEvent = pi));
  const gi = [
      "AS",
      "BS",
      "BZ",
      "DM",
      "FK",
      "GB",
      "GD",
      "GU",
      "KN",
      "KY",
      "LC",
      "LR",
      "MM",
      "MP",
      "SH",
      "TC",
      "US",
      "VC",
      "VG",
      "VI",
      "WS"
    ],
    _i = new mi({
      supportedLocales: [
        "ar-SA",
        "ca-ES",
        "cs-CZ",
        "da-DK",
        "de-DE",
        "el-GR",
        "en-GB",
        "en-US",
        "es-ES",
        "es-MX",
        "fi-FI",
        "fr-CA",
        "fr-FR",
        "he-IL",
        "hi-IN",
        "hr-HR",
        "hu-HU",
        "id-ID",
        "it-IT",
        "ja-JP",
        "ko-KR",
        "ms-MY",
        "nl-NL",
        "nb-NO",
        "pl-PL",
        "pt-BR",
        "pt-PT",
        "ro-RO",
        "ru-RU",
        "sl-SI",
        "sk-SK",
        "sv-SE",
        "th-TH",
        "tr-TR",
        "uk-UA",
        "vi-VN",
        "zh-CN",
        "zh-HK",
        "zh-TW"
      ],
      primaryLocales: ["en-US", "fr-FR", "pt-BR", "zh-CN"],
      localesMap: w,
      regionToScriptMap: v,
      rtlLocales: ["ar-SA", "he-IL"],
      enUSDictionary: {
        "Annotation.Clustering.AccessibilityLabel": "{{n}} locations, {{title}}, {{subtitle}}",
        "Annotation.Clustering.More": "+{{n}} more",
        "Annotation.Clustering.More.Plural": "+{{n}} more",
        "Annotation.Clustering.NoTitle.AccessibilityLabel": "{{n}} locations, {{subtitle}}",
        "Annotation.Generic.AccessibilityLabel": "{{title}}, {{subtitle}}",
        "Annotation.Marker.AccessibilityLabel": "Marker",
        "Annotation.Pin.AccessibilityLabel": "Pin",
        "Annotation.Pin.Green.AccessibilityLabel": "Green Pin",
        "Annotation.Pin.Purple.AccessibilityLabel": "Purple Pin",
        "Annotation.Pin.Red.AccessibilityLabel": "Red Pin",
        "Compass.Degrees.Plural": "{{n}} degrees",
        "Compass.Degrees.Single": "{{n}} degree",
        "Compass.EastIndicator": "E",
        "Compass.NorthIndicator": "N",
        "Compass.SouthIndicator": "S",
        "Compass.Tooltip": "Rotate the map",
        "Compass.WestIndicator": "W",
        "Legal.Apple.URL": "https://www.apple.com/legal/internet-services/maps/legal-en.html",
        "Legal.Label": "Legal",
        "Location.Error.Message":
          "Your location can only be shown when location services are enabled and you are connected to the Internet.",
        "Location.Error.Support.Label": "Learn more",
        "Location.Subtitle": "Unknown Address",
        "Location.Title": "Current Location",
        "Logo.Apple.Tooltip": "Apple Maps",
        "Logo.AutoNavi.Tooltip": "AutoNavi Maps",
        "MapType.Tooltip": "Change the map type",
        "Mode.Hybrid": "Hybrid",
        "Mode.Satellite": "Satellite",
        "Mode.Standard": "Standard",
        "OpenInAppleMaps.Label": "Open in Apple Maps",
        "Place.Error.Message": "Could not load place details.",
        "Place.Error.Title": "Place Unavailable",
        "Scale.Feet.Short": "ft",
        "Scale.Kilometer.Short": "km",
        "Scale.Meter.Short": "m",
        "Scale.Mile.Short": "mi",
        "Track.User.Location.Tooltip": "Show your current location",
        "Zoom.In.Tooltip": "Zoom In",
        "Zoom.Out.Tooltip": "Zoom Out"
      },
      get localeUrl() {
        return oe.createUrl("locales/{{locale}}/strings.json");
      },
      get withCredentials() {
        return dt.distUrlWithCredentials;
      }
    });
  ((_i._useMetric = !1),
    _i.addEventListener(mi.Events.LocaleChanged, function () {
      const t = f.parse(_i.requestedLocaleId);
      _i._useMetric = ((t) => {
        const e = t.region;
        return e ? gi.indexOf(e) < 0 : "en" !== t.language && "my" !== t.language;
      })(t);
    }),
    (_i.useMetric = function () {
      return this._useMetric;
    }),
    dt.setL10n(_i));
  const fi = _i,
    yi = new WeakMap(),
    vi = window.btoa("Copyright (c) Apple Inc. All rights reserved.");
  class wi {
    constructor(t, e) {
      ((this._delegate = e),
        (this._handleConfigChangedListener = () => this._handleConfigChanged()),
        dt.addEventListener(dt.Events.Changed, this._handleConfigChangedListener),
        (this._handleLocaleChangedListener = (t) => this._handleLocaleChanged(t)),
        fi.addEventListener(fi.Events.LocaleChanged, this._handleLocaleChangedListener),
        (this._container = t));
    }
    update() {
      this._delegate.place && dt.ready ? this._renderPlaceIframe() : this._removeIframeElement();
    }
    destroy() {
      (this._removeIframeElement(),
        dt.removeEventListener(dt.Events.Changed, this._handleConfigChangedListener),
        fi.removeEventListener(fi.Events.LocaleChanged, this._handleLocaleChangedListener));
    }
    _handleLocaleChanged() {
      this.update();
    }
    _handleConfigChanged() {
      this.update();
    }
    _getPlaceAsUrlParams() {
      const t = this._delegate.place,
        e = new URLSearchParams();
      return (
        e.append("uiStyle", this._delegate.uiStyle),
        t.muid && e.append("auid", t.muid),
        t.formattedAddress && e.append("address", t.formattedAddress),
        t.coordinate && e.append("ll", `${t.coordinate.latitude},${t.coordinate.longitude}`),
        t.name && e.append("q", t.name),
        e.append("countryCode", dt.countryCode || ""),
        e.append("lang", fi.localeId),
        e.append("mapkitVersion", i.version),
        dt.enableSourceMap && e.append("sourcemap", "1"),
        `${dt.uiBaseUrl}/v1/place?${e.toString()}`
      );
    }
    _renderPlaceIframe() {
      this._iframeElement ||
        ((this._iframeElement = document.createElement("iframe")),
        this._container.appendChild(this._iframeElement),
        (this._handleMessageEventListener = (t) => this._handleMessageEvent(t)),
        window.addEventListener("message", this._handleMessageEventListener),
        (this._iframeElement.style.display = "block"),
        (this._iframeElement.style.width = "100%"),
        (this._iframeElement.style.height = "0"),
        (this._iframeElement.style.border = "none"),
        "standalone" === this._delegate.uiStyle &&
          ((this._iframeElement.style.maxWidth = "380px"),
          (this._iframeElement.style.minWidth = "240px"),
          (this._iframeElement.style.margin = "0 auto"),
          (this._iframeElement.style.borderRadius = "18px")),
        (this._iframeContentWindowReady = !1));
      const t = this._getPlaceAsUrlParams();
      t !== this._iframeElement.src
        ? ((this._iframeElement.src = t),
          (this._iframeLoadingTimeout = window.setTimeout(() => this._frameLoadingDidFail(), 3e4)))
        : this._postMessage({
            action: "set-options",
            placeKey: yi.get(this),
            mapkitVersion: i.version,
            colorScheme: this._delegate.colorScheme,
            displaysMap: this._delegate.displaysMap
          });
    }
    _postMessage(t) {
      if (!this._iframeContentWindowReady) return;
      const e = this._iframeElement.contentWindow;
      e && e.postMessage(t, new URL(this._iframeElement.src).origin);
    }
    _handleMessageEvent(t) {
      if (t.source === this._iframeElement.contentWindow)
        switch (
          (t.data.action && (clearTimeout(this._iframeLoadingTimeout), (this._iframeContentWindowReady = !0)),
          t.data.action)
        ) {
          case "ready": {
            const e = ((t, e) => {
              const i = new Uint8Array(
                  window
                    .atob(t)
                    .split("")
                    .map((t) => t.charCodeAt(0))
                ),
                n = new Uint8Array(
                  window
                    .atob(e)
                    .split("")
                    .map((t) => t.charCodeAt(0))
                );
              return window.btoa(String.fromCharCode(...i.map((t, e) => t ^ n[e % n.length])));
            })(vi, t.data.key);
            yi.set(this, e);
            const n = {
              action: "render-place",
              placeKey: e,
              accessToken: dt.accessToken,
              mapkitVersion: i.version,
              colorScheme: this._delegate.colorScheme,
              displaysMap: this._delegate.displaysMap
            };
            (dt._showMapsLogo || (n.showMapsLogo = !1), this._postMessage(n));
            break;
          }
          case "update-size": {
            const e = t.data.width,
              i = t.data.height;
            ((this._iframeElement.style.height = `${i}px`),
              this._delegate.placeCardSizeDidChange && this._delegate.placeCardSizeDidChange(e, i));
            break;
          }
          case "place-card-did-reveal":
            this._delegate.placeCardDidReveal && this._delegate.placeCardDidReveal(t.data.analyticsState);
            break;
          case "open-in-maps-clicked":
            this._delegate.placeCardOpenInMapsClicked &&
              this._delegate.placeCardOpenInMapsClicked(t.data.analyticsState);
        }
    }
    _frameLoadingDidFail() {
      this._delegate.loadingDidFail && this._delegate.loadingDidFail();
    }
    _removeIframeElement() {
      this._iframeElement &&
        (this._container.removeChild(this._iframeElement),
        window.removeEventListener("message", this._handleMessageEventListener),
        clearTimeout(this._iframeLoadingTimeout),
        (this._iframeElement = void 0));
    }
  }
  const bi = [];
  class Ci {
    constructor(t, e = null, i = {}) {
      if (!t || !B(t)) throw new Error("[MapKit] `parent` must be a DOM element.");
      const n = this;
      ((this._impl = {
        controllerDelegate: {
          get colorScheme() {
            return n._impl.colorScheme;
          },
          get displaysMap() {
            return n._impl.displaysMap;
          },
          get place() {
            return n._impl.place;
          },
          uiStyle: "standalone",
          placeCardDidReveal(t) {
            ke.log(ke.Events.PlaceDetailReveal, {
              eventValue: "LARGE",
              eventTarget: "PLACECARD_TRAY",
              states: {PLACE_CARD: () => t}
            });
          },
          placeCardOpenInMapsClicked(t) {
            ke.log(ke.Events.PlaceDetailOpenAppleMaps, {eventTarget: "PLACECARD_TRAY", states: {PLACE_CARD: () => t}});
          }
        },
        element: t,
        shadowRoot: t.attachShadow({mode: dt.shadowDOMMode || "closed"}),
        controller: void 0,
        colorScheme: void 0,
        displaysMap: void 0,
        place: null,
        destroyed: !1
      }),
        (this._impl.controller = new wi(this._impl.shadowRoot, this._impl.controllerDelegate)),
        void 0 !== i.colorScheme ? (this.colorScheme = i.colorScheme) : (this.colorScheme = bt.Light),
        void 0 !== i.displaysMap ? (this.displaysMap = i.displaysMap) : (this.displaysMap = !0),
        (this.place = e),
        bi.push(this));
    }
    get element() {
      return this._impl.element;
    }
    get place() {
      return this._impl.place;
    }
    set place(t) {
      if (!this._impl.destroyed && t !== this._impl.place) {
        if (
          null !== t &&
          (d(t, ti, "[MapKit] The `place` parameter must be a Place."), "CN" === dt.countryCode && !dt.customUiBaseUrl)
        )
          throw new Error("[MapKit] PlaceDetail is not supported in China yet.");
        ((this._impl.place = t), this._impl.controller.update());
      }
    }
    get colorScheme() {
      return this._impl.colorScheme;
    }
    set colorScheme(t) {
      if (!this._impl.destroyed && t !== this._impl.colorScheme) {
        if (!l(t, bt))
          throw new Error("[MapKit] Unknown value for `colorScheme`. Choose from `PlaceDetail.ColorSchemes`.");
        ((this._impl.colorScheme = t), this._impl.controller.update());
      }
    }
    get displaysMap() {
      return this._impl.displaysMap;
    }
    set displaysMap(t) {
      this._impl.destroyed ||
        (t !== this._impl.displaysMap && ((this._impl.displaysMap = !!t), this._impl.controller.update()));
    }
    destroy() {
      this._impl.destroyed ||
        ((this._impl.destroyed = !0), this._impl.controller.destroy(), bi.splice(bi.indexOf(this), 1));
    }
  }
  Ci.ColorSchemes = bt;
  class ki {
    constructor(t, e) {
      ((this.width = t ?? 0), (this.height = e ?? 0));
    }
    toString() {
      return `Size[${this.width}, ${this.height}]`;
    }
    copy() {
      return new ki(this.width, this.height);
    }
    equals(t) {
      return this.width === t.width && this.height === t.height;
    }
  }
  ki.Zero = new ki();
  class Mi {
    constructor(t, e, i) {
      ((this.x = t ?? 0), (this.y = e ?? 0), (this.z = i ?? 0));
    }
    toString() {
      return `Point[${this.x}, ${this.y}, ${this.z}]`;
    }
    copy() {
      return new Mi(this.x, this.y, this.z);
    }
    equals(t) {
      return this.x === t.x && this.y === t.y && this.z === t.z;
    }
    distanceToPoint(t) {
      return Math.sqrt(Math.pow(this.x - t.x, 2) + Math.pow(this.y - t.y, 2) + Math.pow(this.z - t.z, 2));
    }
  }
  Mi.Zero = new Mi();
  class Si {
    constructor(t, e, i, n) {
      ((this.origin = new Mi(t, e)), (this.size = new ki(i, n)));
    }
    static rectFromClientRect(t) {
      const {left: e, top: i, width: n, height: o} = t;
      return new Si(e, i, n, o);
    }
    static unionOfRects(t) {
      return t.reduce((t, e) => t._updateToUnion(e), t[0].copy());
    }
    _update(t, e, i, n) {
      return ((this.origin.x = t), (this.origin.y = e), (this.size.width = i), (this.size.height = n), this);
    }
    _updateToIntersect(t) {
      const e = Math.max(this.minX(), t.minX()),
        i = Math.min(this.maxX(), t.maxX());
      if (e > i) return this._update(0, 0, 0, 0);
      const n = Math.max(this.minY(), t.minY()),
        o = Math.min(this.maxY(), t.maxY());
      return n > o ? this._update(0, 0, 0, 0) : this._update(e, n, i - e, o - n);
    }
    _updateToUnion(t) {
      const e = Math.min(this.minX(), t.minX()),
        i = Math.min(this.minY(), t.minY()),
        n = Math.max(this.maxX(), t.maxX()) - e,
        o = Math.max(this.maxY(), t.maxY()) - i;
      return this._update(e, i, n, o);
    }
    toString() {
      const {x: t, y: e} = this.origin,
        {width: i, height: n} = this.size;
      return `Rect[${t}, ${e}, ${i}, ${n}]`;
    }
    copy() {
      return new Si(this.origin.x, this.origin.y, this.size.width, this.size.height);
    }
    equals(t) {
      return this.origin.equals(t.origin) && this.size.equals(t.size);
    }
    inset(t, e, i, n) {
      return new Si(this.origin.x + t, this.origin.y + e, this.size.width - t - i, this.size.height - e - n);
    }
    pad(t) {
      return new Si(this.origin.x - t, this.origin.y - t, this.size.width + 2 * t, this.size.height + 2 * t);
    }
    minX() {
      return this.origin.x;
    }
    minY() {
      return this.origin.y;
    }
    midX() {
      return this.origin.x + this.size.width / 2;
    }
    midY() {
      return this.origin.y + this.size.height / 2;
    }
    maxX() {
      return this.origin.x + this.size.width;
    }
    maxY() {
      return this.origin.y + this.size.height;
    }
    intersectionWithRect(t) {
      return this.copy()._updateToIntersect(t);
    }
    unionWithRect(t) {
      return this.copy()._updateToUnion(t);
    }
    round() {
      return new Si(
        Math.floor(this.origin.x),
        Math.floor(this.origin.y),
        Math.ceil(this.size.width),
        Math.ceil(this.size.height)
      );
    }
  }
  Si.Zero = new Si();
  class Li {
    constructor(t, e, i, n, o, s, a, r, l, h, c, d, u, p, m, g) {
      this._data = Ai();
      const _ = "string" == typeof t,
        f = Array.isArray(t);
      if (_ || f) {
        const e =
          "none" === t
            ? []
            : f
              ? t
              : (t.match(/\bmatrix(?:3d)?\(([^)]+)\)/)?.[1] ?? "").split(",").map((t) => parseFloat(t));
        16 === e.length
          ? ((this.m11 = e[0]),
            (this.m12 = e[1]),
            (this.m13 = e[2]),
            (this.m14 = e[3]),
            (this.m21 = e[4]),
            (this.m22 = e[5]),
            (this.m23 = e[6]),
            (this.m24 = e[7]),
            (this.m31 = e[8]),
            (this.m32 = e[9]),
            (this.m33 = e[10]),
            (this.m34 = e[11]),
            (this.m41 = e[12]),
            (this.m42 = e[13]),
            (this.m43 = e[14]),
            (this.m44 = e[15]))
          : 6 === e.length &&
            ((this.a = e[0]), (this.b = e[1]), (this.c = e[2]), (this.d = e[3]), (this.e = e[4]), (this.f = e[5]));
      } else {
        const _ = void 0 !== o && void 0 !== s,
          f = void 0 !== t && void 0 !== e && void 0 !== i && void 0 !== n;
        f &&
        _ &&
        void 0 !== a &&
        void 0 !== r &&
        void 0 !== l &&
        void 0 !== h &&
        void 0 !== c &&
        void 0 !== d &&
        void 0 !== u &&
        void 0 !== p &&
        void 0 !== m &&
        void 0 !== g
          ? ((this.m11 = t),
            (this.m12 = e),
            (this.m13 = i),
            (this.m14 = n),
            (this.m21 = o),
            (this.m22 = s),
            (this.m23 = a),
            (this.m24 = r),
            (this.m31 = l),
            (this.m32 = h),
            (this.m33 = c),
            (this.m34 = d),
            (this.m41 = u),
            (this.m42 = p),
            (this.m43 = m),
            (this.m44 = g))
          : f && _ && ((this.a = t), (this.b = e), (this.c = i), (this.d = n), (this.e = o), (this.f = s));
      }
    }
    get a() {
      return this._data[0][0];
    }
    get b() {
      return this._data[0][1];
    }
    get c() {
      return this._data[1][0];
    }
    get d() {
      return this._data[1][1];
    }
    get e() {
      return this._data[3][0];
    }
    get f() {
      return this._data[3][1];
    }
    get m11() {
      return this._data[0][0];
    }
    get m12() {
      return this._data[0][1];
    }
    get m13() {
      return this._data[0][2];
    }
    get m14() {
      return this._data[0][3];
    }
    get m21() {
      return this._data[1][0];
    }
    get m22() {
      return this._data[1][1];
    }
    get m23() {
      return this._data[1][2];
    }
    get m24() {
      return this._data[1][3];
    }
    get m31() {
      return this._data[2][0];
    }
    get m32() {
      return this._data[2][1];
    }
    get m33() {
      return this._data[2][2];
    }
    get m34() {
      return this._data[2][3];
    }
    get m41() {
      return this._data[3][0];
    }
    get m42() {
      return this._data[3][1];
    }
    get m43() {
      return this._data[3][2];
    }
    get m44() {
      return this._data[3][3];
    }
    set a(t) {
      this._data[0][0] = t;
    }
    set b(t) {
      this._data[0][1] = t;
    }
    set c(t) {
      this._data[1][0] = t;
    }
    set d(t) {
      this._data[1][1] = t;
    }
    set e(t) {
      this._data[3][0] = t;
    }
    set f(t) {
      this._data[3][1] = t;
    }
    set m11(t) {
      this._data[0][0] = t;
    }
    set m12(t) {
      this._data[0][1] = t;
    }
    set m13(t) {
      this._data[0][2] = t;
    }
    set m14(t) {
      this._data[0][3] = t;
    }
    set m21(t) {
      this._data[1][0] = t;
    }
    set m22(t) {
      this._data[1][1] = t;
    }
    set m23(t) {
      this._data[1][2] = t;
    }
    set m24(t) {
      this._data[1][3] = t;
    }
    set m31(t) {
      this._data[2][0] = t;
    }
    set m32(t) {
      this._data[2][1] = t;
    }
    set m33(t) {
      this._data[2][2] = t;
    }
    set m34(t) {
      this._data[2][3] = t;
    }
    set m41(t) {
      this._data[3][0] = t;
    }
    set m42(t) {
      this._data[3][1] = t;
    }
    set m43(t) {
      this._data[3][2] = t;
    }
    set m44(t) {
      this._data[3][3] = t;
    }
    translate(t, e, i) {
      ((t = t || 0), (e = e || 0), (i = i || 0));
      const [n, o, s, a] = this._data[0],
        [r, l, h, c] = this._data[1],
        [d, u, p, m] = this._data[2];
      return (
        (this._data[3][0] += t * n + e * r + i * d),
        (this._data[3][1] += t * o + e * l + i * u),
        (this._data[3][2] += t * s + e * h + i * p),
        (this._data[3][3] += t * a + e * c + i * m),
        this
      );
    }
    scale(t, e, i) {
      return (
        (t = t || 1),
        (e = e || t),
        (i = i || 1),
        (this._data[0][0] *= t),
        (this._data[0][1] *= t),
        (this._data[0][2] *= t),
        (this._data[0][3] *= t),
        (this._data[1][0] *= e),
        (this._data[1][1] *= e),
        (this._data[1][2] *= e),
        (this._data[1][3] *= e),
        (this._data[2][0] *= i),
        (this._data[2][1] *= i),
        (this._data[2][2] *= i),
        (this._data[2][3] *= i),
        this
      );
    }
    rotate(t) {
      return this.rotateAxisAngle(0, 0, 1, t);
    }
    rotateAxisAngle(t, e, i, n) {
      0 === t && 0 === e && 0 === i && (i = 1);
      const o = Math.sqrt(t * t + e * e + i * i);
      (1 !== o && ((t /= o), (e /= o), (i /= o)), (n = Ei(n)));
      const s = Math.sin(n),
        a = Math.cos(n),
        r = new Li();
      if (1 === t && 0 === e && 0 === i)
        ((r._data[0][0] = 1),
          (r._data[0][1] = 0),
          (r._data[0][2] = 0),
          (r._data[1][0] = 0),
          (r._data[1][1] = a),
          (r._data[1][2] = s),
          (r._data[2][0] = 0),
          (r._data[2][1] = -s),
          (r._data[2][2] = a),
          (r._data[0][3] = r._data[1][3] = r._data[2][3] = 0),
          (r._data[3][0] = r._data[3][1] = r._data[3][2] = 0),
          (r._data[3][3] = 1));
      else if (0 === t && 1 === e && 0 === i)
        ((r._data[0][0] = a),
          (r._data[0][1] = 0),
          (r._data[0][2] = -s),
          (r._data[1][0] = 0),
          (r._data[1][1] = 1),
          (r._data[1][2] = 0),
          (r._data[2][0] = s),
          (r._data[2][1] = 0),
          (r._data[2][2] = a),
          (r._data[0][3] = r._data[1][3] = r._data[2][3] = 0),
          (r._data[3][0] = r._data[3][1] = r._data[3][2] = 0),
          (r._data[3][3] = 1));
      else if (0 === t && 0 === e && 1 === i)
        ((r._data[0][0] = a),
          (r._data[0][1] = s),
          (r._data[0][2] = 0),
          (r._data[1][0] = -s),
          (r._data[1][1] = a),
          (r._data[1][2] = 0),
          (r._data[2][0] = 0),
          (r._data[2][1] = 0),
          (r._data[2][2] = 1),
          (r._data[0][3] = r._data[1][3] = r._data[2][3] = 0),
          (r._data[3][0] = r._data[3][1] = r._data[3][2] = 0),
          (r._data[3][3] = 1));
      else {
        const n = 1 - a;
        ((r._data[0][0] = a + t * t * n),
          (r._data[0][1] = e * t * n + i * s),
          (r._data[0][2] = i * t * n - e * s),
          (r._data[1][0] = t * e * n - i * s),
          (r._data[1][1] = a + e * e * n),
          (r._data[1][2] = i * e * n + t * s),
          (r._data[2][0] = t * i * n + e * s),
          (r._data[2][1] = e * i * n - t * s),
          (r._data[2][2] = a + i * i * n),
          (r._data[0][3] = r._data[1][3] = r._data[2][3] = 0),
          (r._data[3][0] = r._data[3][1] = r._data[3][2] = 0),
          (r._data[3][3] = 1));
      }
      return this.multiply(r);
    }
    multiply(t) {
      const [e, i, n, o] = t._data[0],
        [s, a, r, l] = t._data[1],
        [h, c, d, u] = t._data[2],
        [p, m, g, _] = t._data[3],
        [f, y, v, w] = this._data[0],
        [b, C, k, M] = this._data[1],
        [S, L, A, E] = this._data[2],
        [x, T, I, R] = this._data[3];
      return (
        (this._data[0][0] = e * f + i * b + n * S + o * x),
        (this._data[0][1] = e * y + i * C + n * L + o * T),
        (this._data[0][2] = e * v + i * k + n * A + o * I),
        (this._data[0][3] = e * w + i * M + n * E + o * R),
        (this._data[1][0] = s * f + a * b + r * S + l * x),
        (this._data[1][1] = s * y + a * C + r * L + l * T),
        (this._data[1][2] = s * v + a * k + r * A + l * I),
        (this._data[1][3] = s * w + a * M + r * E + l * R),
        (this._data[2][0] = h * f + c * b + d * S + u * x),
        (this._data[2][1] = h * y + c * C + d * L + u * T),
        (this._data[2][2] = h * v + c * k + d * A + u * I),
        (this._data[2][3] = h * w + c * M + d * E + u * R),
        (this._data[3][0] = p * f + m * b + g * S + _ * x),
        (this._data[3][1] = p * y + m * C + g * L + _ * T),
        (this._data[3][2] = p * v + m * k + g * A + _ * I),
        (this._data[3][3] = p * w + m * M + g * E + _ * R),
        this
      );
    }
    skewX(t) {
      return this._skew(t, 0);
    }
    skewY(t) {
      return this._skew(0, t);
    }
    isAffine() {
      return (
        0 === this._data[0][2] &&
        0 === this._data[0][3] &&
        0 === this._data[1][2] &&
        0 === this._data[1][3] &&
        0 === this._data[2][0] &&
        0 === this._data[2][1] &&
        1 === this._data[2][2] &&
        0 === this._data[2][3] &&
        0 === this._data[3][2] &&
        1 === this._data[3][3]
      );
    }
    inverse() {
      if (this._isIdentityOrTranslation())
        return (
          (0 === this._data[3][0] && 0 === this._data[3][1] && 0 === this._data[3][2]) ||
            ((this._data[3][0] *= -1), (this._data[3][1] *= -1), (this._data[3][2] *= -1)),
          this
        );
      const t = new Li();
      return Li._inverse(this, t) ? t : new Li();
    }
    transformPoint(t) {
      const [e, i, n] = this._data[0],
        [o, s, a] = this._data[1],
        [r, l, h] = this._data[2],
        [c, d, u] = this._data[3],
        {x: p, y: m, z: g} = t;
      return new Mi(e * p + o * m + r * g + c, i * p + s * m + l * g + d, n * p + a * m + h * g + u);
    }
    toString() {
      if (this.isAffine()) {
        const [t, e] = this._data[0],
          [i, n] = this._data[1],
          [o, s] = this._data[3];
        return `matrix(${t}, ${e}, ${i}, ${n}, ${o}, ${s})`;
      }
      return `matrix3d(${this._data.map((t) => t.join(", ")).join(", ")})`;
    }
    _isIdentityOrTranslation() {
      return (
        1 === this._data[0][0] &&
        0 === this._data[0][1] &&
        0 === this._data[0][2] &&
        0 === this._data[0][3] &&
        0 === this._data[1][0] &&
        1 === this._data[1][1] &&
        0 === this._data[1][2] &&
        0 === this._data[1][3] &&
        0 === this._data[2][0] &&
        0 === this._data[2][1] &&
        1 === this._data[2][2] &&
        0 === this._data[2][3] &&
        1 === this._data[3][3]
      );
    }
    _skew(t, e) {
      const i = new Li();
      return ((i._data[0][1] = Math.tan(Ei(e))), (i._data[1][0] = Math.tan(Ei(t))), this.multiply(i));
    }
    _determinant() {
      const [t, e, i, n] = this._data[0],
        [o, s, a, r] = this._data[1],
        [l, h, c, d] = this._data[2],
        [u, p, m, g] = this._data[3];
      return (
        t * Ti(s, h, p, a, c, m, r, d, g) -
        e * Ti(o, l, u, a, c, m, r, d, g) +
        i * Ti(o, l, u, s, h, p, r, d, g) -
        n * Ti(o, l, u, s, h, p, a, c, m)
      );
    }
    static _inverse(t, e) {
      Li._adjoint(t, e);
      const i = t._determinant();
      if (Math.abs(i) < 1e-8) return !1;
      for (let t = 0; t < 4; t += 1) for (let n = 0; n < 4; n += 1) e._data[t][n] = e._data[t][n] / i;
      return !0;
    }
    static _adjoint(t, e) {
      const [i, n, o, s] = t._data[0],
        [a, r, l, h] = t._data[1],
        [c, d, u, p] = t._data[2],
        [m, g, _, f] = t._data[3];
      ((e._data[0][0] = +Ti(r, d, g, l, u, _, h, p, f)),
        (e._data[1][0] = -Ti(a, c, m, l, u, _, h, p, f)),
        (e._data[2][0] = +Ti(a, c, m, r, d, g, h, p, f)),
        (e._data[3][0] = -Ti(a, c, m, r, d, g, l, u, _)),
        (e._data[0][1] = -Ti(n, d, g, o, u, _, s, p, f)),
        (e._data[1][1] = +Ti(i, c, m, o, u, _, s, p, f)),
        (e._data[2][1] = -Ti(i, c, m, n, d, g, s, p, f)),
        (e._data[3][1] = +Ti(i, c, m, n, d, g, o, u, _)),
        (e._data[0][2] = +Ti(n, r, g, o, l, _, s, h, f)),
        (e._data[1][2] = -Ti(i, a, m, o, l, _, s, h, f)),
        (e._data[2][2] = +Ti(i, a, m, n, r, g, s, h, f)),
        (e._data[3][2] = -Ti(i, a, m, n, r, g, o, l, _)),
        (e._data[0][3] = -Ti(n, r, d, o, l, u, s, h, p)),
        (e._data[1][3] = +Ti(i, a, c, o, l, u, s, h, p)),
        (e._data[2][3] = -Ti(i, a, c, n, r, d, s, h, p)),
        (e._data[3][3] = +Ti(i, a, c, n, r, d, o, l, u)));
    }
  }
  const Ai = () => [
      [1, 0, 0, 0],
      [0, 1, 0, 0],
      [0, 0, 1, 0],
      [0, 0, 0, 1]
    ],
    Ei = (t) => (t / 180) * Math.PI,
    xi = (t, e, i, n) => t * n - e * i,
    Ti = (t, e, i, n, o, s, a, r, l) => t * xi(o, s, r, l) - n * xi(e, i, r, l) + a * xi(e, i, o, s);
  function Ii(t) {
    const e = t.getBoundingClientRect(),
      i = t.offsetWidth,
      n = t.offsetHeight,
      o = [new Mi(0, 0), new Mi(i, 0), new Mi(i, n), new Mi(0, n)];
    let s = new Li();
    const a = t.ownerDocument.defaultView;
    let r,
      l = t;
    for (
      ;
      l.nodeType === Node.ELEMENT_NODE &&
      ((r = a.getComputedStyle(t)), (s = new Li(r.transform).multiply(s)), l.parentNode);
    )
      l = l.parentNode;
    let h = 1 / 0,
      c = 1 / 0;
    o.forEach(function (t) {
      const e = s.transformPoint(t);
      ((h = Math.min(h, e.x)), (c = Math.min(c, e.y)));
    });
    const d = window.pageXOffset + e.left - h,
      u = window.pageYOffset + e.top - c;
    return new Li().translate(d, u).multiply(s);
  }
  const Ri = function (t, e) {
      return Ii(t).inverse().transformPoint(e);
    },
    Oi = function (t, e) {
      return Ii(t).transformPoint(e);
    },
    Pi = Ri;
  let Di = [],
    zi = !1;
  function Ni() {
    const t = Di;
    Di = [];
    const e = [];
    for (let i = 0, n = t.length; i < n; ++i) {
      const n = t[i].scene;
      if (n && Fi(e, n)) {
        const t = n.performanceMeasureName ? performance.now() : void 0;
        (n.renderer.update(),
          n.performanceMeasureName && performance.measure(n.performanceMeasureName, {start: t}),
          n.sceneDidUpdate && n.sceneDidUpdate(n, zi));
      }
    }
  }
  function Fi(t, e) {
    return -1 === t.indexOf(e) && (t.push(e), !0);
  }
  const Ui = {
      scheduleNode: function (t) {
        Fi(Di, t) && 1 === Di.length && Qt.scheduleDraw(Ni);
      },
      flush(t) {
        zi = !0;
        const e = Di;
        Di = [];
        const i = [];
        for (let n = 0, o = e.length; n < o; ++n) e[n].scene === t ? Di.push(e[n]) : i.push(e[n]);
        (Ni(), (zi = !1), (Di = i));
      }
    },
    Gi = new Li().toString();
  function Bi() {
    ((this._parent = null),
      (this._children = []),
      (this._renderer = null),
      (this._opacity = 1),
      (this._size = new ki()),
      (this._position = new Mi()),
      (this._transform = new Li()),
      (this._frozen = !1),
      (this._keyForFrozenLayer = ""),
      (this._wantsLayerBacking = !1));
  }
  function Zi(t) {
    t._parent = null;
    const e = [t];
    for (; e.length > 0; ) {
      const t = e.pop();
      (t.wasRemoved(),
        t._renderer && "function" == typeof t._renderer.nodeWasRemoved && t._renderer.nodeWasRemoved(),
        Array.prototype.push.apply(e, t.children));
    }
  }
  function Wi(t) {
    let e = null,
      i = 0,
      n = 0;
    for (; t && !e; ) {
      const o = t.transform.transformPoint(t.position);
      ((i -= o.x), (n -= o.y), (e = (t = t.parent).element));
    }
    return {element: e, offsetX: i, offsetY: n};
  }
  function Ki(t, e, i, n, o) {
    let s = "";
    if (
      ((s += e),
      o &&
        (s += (function (t) {
          return t < 0 ? "" : t + ":";
        })(i)),
      (s += t.toString()),
      (s += (function (t) {
        return t.childCount < 1 ? "" : " ⤵︎ " + t.childCount;
      })(t)),
      t.extraInfo &&
        "function" == typeof t.extraInfo &&
        t.extraInfo().forEach((t) => {
          s += "\n" + e + "| " + t;
        }),
      0 === n)
    )
      return s;
    const a = t.children;
    for (let i = 0, r = a.length; i < r; ++i) {
      const r = t.childCount < 1 ? -1 : i;
      ((s += "\n"), (s += Ki(a[i], e + "    ", r, n - 1, o)));
    }
    return s;
  }
  Bi.prototype = {
    constructor: Bi,
    isScene: !1,
    get scene() {
      for (let t = this; t; t = t._parent) if (t.isScene) return t;
    },
    get renderer() {
      return this._renderer;
    },
    get wantsLayerBacking() {
      return !!this.keyForFrozenLayer || this._frozen || this._wantsLayerBacking || this._needsLayerBacking();
    },
    set wantsLayerBacking(t) {
      t !== this._wantsLayerBacking && ((this._wantsLayerBacking = t), (this.needsDisplay = !0));
    },
    get frozen() {
      return !!this.keyForFrozenLayer || this._frozen;
    },
    set frozen(t) {
      t !== this._frozen && ((this._frozen = t), (this.needsDisplay = !0));
    },
    get keyForFrozenLayer() {
      return this._keyForFrozenLayer;
    },
    set keyForFrozenLayer(t) {
      t !== this._keyForFrozenLayer && ((this._keyForFrozenLayer = t), (this.needsDisplay = !0));
    },
    get opacity() {
      return this._opacity;
    },
    set opacity(t) {
      (t = Math.min(Math.max(0, t), 1)) !== this._opacity && ((this._opacity = t), (this.needsDisplay = !0));
    },
    get position() {
      return this._position;
    },
    set position(t) {
      t.equals(this._position) || ((this._position = t.copy()), (this.needsDisplay = !0));
    },
    get transform() {
      return this._transform;
    },
    set transform(t) {
      ((this._transform = t), (this.needsDisplay = !0));
    },
    get size() {
      return this._size;
    },
    set size(t) {
      ((this._size = t || new ki()), (this.needsDisplay = !0));
    },
    get bounds() {
      return new Si(this._position.x, this._position.y, this.size.width, this.size.height);
    },
    get layerBounds() {
      let t = new Si(0, 0, this.size.width, this.size.height);
      const e = this._children;
      for (let i = 0, n = e.length; i < n; ++i) {
        const n = e[i],
          o = n.layerBounds;
        ((o.origin.x += n._position.x), (o.origin.y += n._position.y));
        const s = n.transform,
          a = [
            s.transformPoint(new Mi(o.minX(), o.minY())),
            s.transformPoint(new Mi(o.maxX(), o.minY())),
            s.transformPoint(new Mi(o.maxX(), o.maxY())),
            s.transformPoint(new Mi(o.minX(), o.maxY()))
          ];
        let r = a[0].x,
          l = a[0].y,
          h = a[0].x,
          c = a[0].y;
        for (let t = 1; t < a.length; ++t) {
          const e = a[t];
          (e.x < r && (r = e.x), e.x > h && (h = e.x), e.y < l && (l = e.y), e.y > c && (c = e.y));
        }
        t = t.unionWithRect(new Si(r, l, h - r, c - l));
      }
      return t;
    },
    set needsDisplay(t) {
      t && Ui.scheduleNode(this);
    },
    get parent() {
      return this._parent;
    },
    get children() {
      return this._children;
    },
    set children(t) {
      let e = 0,
        i = 0;
      const n = [].concat(this._children);
      for (; e < t.length; )
        n[i] !== t[e]
          ? n[i] && -1 === t.indexOf(n[i])
            ? (this.removeChild(n[i]), i++)
            : (t[e]._parent === this && n.splice(n.indexOf(t[e]), 1), this.addChild(t[e], e), e++)
          : (e++, i++);
      for (; i < n.length; ) (this.removeChild(n[i]), i++);
    },
    get childCount() {
      return this._children.length;
    },
    get firstChild() {
      return this._children[0] || null;
    },
    get lastChild() {
      return this._children[this._children.length - 1] || null;
    },
    get previousSibling() {
      if (!this._parent) return null;
      const t = this._parent._children,
        e = t.indexOf(this);
      return e > 0 ? t[e - 1] : null;
    },
    get nextSibling() {
      if (!this._parent) return null;
      const t = this._parent._children,
        e = t.indexOf(this);
      return -1 !== e && e < t.length - 1 ? t[e + 1] : null;
    },
    isTainted() {
      return this._children.some((t) => t.isTainted());
    },
    toString: function () {
      let t = "";
      return (
        this.element && (t += "🏷 "),
        this.wantsLayerBacking && (t += "🏁 "),
        this.frozen && ((t += "❄️ "), this.keyForFrozenLayer && (t += "<" + this.keyForFrozenLayer + ">")),
        this.stringInfo && "function" == typeof this.stringInfo ? (t += this.stringInfo()) : (t += "UnknownNode"),
        (0 === this.position.x && 0 === this.position.y) ||
          (t += " (" + this.position.x + ", " + this.position.y + ")"),
        "number" == typeof this.repeatOffset && (t += (this.repeatOffset > 0 ? "+" : "") + this.repeatOffset + " "),
        (0 === this.size.width && 0 === this.size.height) || (t += " " + this.size.width + "x" + this.size.height),
        1 !== this.opacity && (t += " [opacity:" + this.opacity + "]"),
        this.transform.toString() !== Gi && (t += " [" + this.transform.toString() + "]"),
        this.animators &&
          this.animators.forEach((e) => {
            t += " " + e.stringInfo();
          }),
        t
      );
    },
    dump: function (t, e) {
      return (void 0 === t && (t = 1 / 0), Ki(this, "", -1, t, !!e));
    },
    addChild: function (t, e) {
      return (
        t.remove(),
        (void 0 === e || e < 0 || e > this._children.length) && (e = this._children.length),
        this._children.splice(e, 0, t),
        (t._parent = this),
        (this.needsDisplay = !0),
        t
      );
    },
    insertBefore: function (t, e) {
      return this.addChild(t, this._children.indexOf(e));
    },
    insertAfter: function (t, e) {
      return this.addChild(t, this._children.indexOf(e) + 1);
    },
    removeChild: function (t) {
      if (t._parent !== this) return;
      const e = this._children.indexOf(t);
      return -1 !== e ? (this._children.splice(e, 1), Zi(t), (this.needsDisplay = !0), t) : void 0;
    },
    replaceChild: function (t, e) {
      if (!e || e._parent !== this) return;
      const i = this._children.indexOf(e);
      return (t.remove(), this._children.splice(i, 1, t), Zi(e), (t._parent = this), (this.needsDisplay = !0), e);
    },
    remove: function () {
      if (this._parent instanceof Bi) return this._parent.removeChild(this);
    },
    wasRemoved: function () {},
    convertPointFromPage: function (t) {
      if (this.element) return Ri(this.element, t);
      const e = Wi(this),
        i = Ri(e.element, t);
      return new Mi(i.x + e.offsetX, i.y + e.offsetY);
    },
    convertPointToPage: function (t) {
      if (this.element) return Oi(this.element, t);
      const e = Wi(this),
        i = Oi(e.element, t);
      return new Mi(i.x - e.offsetX, i.y - e.offsetY);
    },
    _needsLayerBacking: function () {
      return (
        this.opacity < 1 &&
        (this._children.length > 1 || (1 === this._children.length && this._children[0]._children.length > 0))
      );
    }
  };
  const Hi = Bi,
    ji = "dark",
    Vi = "light",
    qi = "FEATURE_ERROR",
    Yi = {
      blue: [0, 122, 255],
      green: [52, 199, 89],
      indigo: [88, 86, 214],
      orange: [255, 149, 0],
      pink: [255, 45, 85],
      purple: [175, 82, 222],
      red: [255, 59, 48],
      teal: [90, 200, 250],
      yellow: [255, 204, 0],
      gray: [142, 142, 147],
      gray2: [174, 174, 178],
      gray3: [199, 199, 204],
      gray4: [209, 209, 214],
      gray5: [229, 229, 234],
      gray6: [242, 242, 247]
    },
    Xi = {Satellite: "satellite", Hybrid: "hybrid", MutedStandard: "mutedStandard", Standard: "standard"},
    $i = {
      BaseMap: "basemap",
      Roads: "roads",
      Borders: "borders",
      Buildings: "buildings",
      Icons: "icons",
      Labels: "labels"
    },
    Ji = {Normal: "normal", Multiply: "multiply", HardLight: "hard-light", SoftLight: "soft-light"},
    Qi = {Normal: "normal", Grayscale: "grayscale"},
    tn = {LandCover: "LandCover", PointsOfInterest: "PointsOfInterest", None: null},
    en = "muted",
    nn = "standard",
    on = {Adaptive: "adaptive", Hidden: "hidden", Visible: "visible"},
    sn = {
      default: Yi,
      light: Yi,
      dark: {
        blue: [10, 132, 255],
        green: [48, 209, 88],
        indigo: [94, 92, 230],
        orange: [255, 159, 10],
        pink: [255, 55, 95],
        purple: [191, 90, 242],
        red: [255, 69, 58],
        teal: [100, 210, 255],
        yellow: [255, 214, 10],
        gray: [142, 142, 147],
        gray2: [99, 99, 102],
        gray3: [72, 72, 74],
        gray4: [58, 58, 60],
        gray5: [44, 44, 46],
        gray6: [28, 28, 30]
      }
    },
    an = '"SFProRegular", "-apple-system", "BlinkMacSystemFont", "Helvetica Neue", Helvetica, Arial, sans-serif',
    rn = "SCROLL",
    ln = {
      minimumSizeToShowControls: new ki(306, 220),
      minimumSizeToShowLogo: new ki(200, 100),
      minimumSizeToShowLogoWithReducedMargin: new ki(100, 100),
      maximumSizeControlsNormal: new ki(1024, 0)
    };
  class hn {
    constructor(t = 0, e = 0, i = 0) {
      ((this.x = t), (this.y = e), (this.z = i));
    }
    toString() {
      const {x: t, y: e, z: i} = this;
      return !t || e || i
        ? !e || t || i
          ? !i || t || e
            ? i
              ? `translate3d(${t}px, ${e}px, ${i}px)`
              : `translate(${t}px, ${e}px)`
            : `translateZ(${i}px)`
          : `translateY(${e}px)`
        : `translateX(${t}px)`;
    }
  }
  class cn {
    constructor(t = 1, e = t, i = 1) {
      ((this.x = t), (this.y = e), (this.z = i));
    }
    toString() {
      const {x: t, y: e, z: i} = this;
      return 1 !== t && 1 === e && 1 === i
        ? `scaleX(${t})`
        : 1 !== e && 1 === t && 1 === i
          ? `scaleY(${e})`
          : 1 !== i && 1 === t && 1 === e
            ? `scaleZ(${i})`
            : 1 === i && t === e
              ? `scale(${t})`
              : 1 === i
                ? `scale(${t}, ${e})`
                : `scale3d(${t}, ${e}, ${i})`;
    }
  }
  class dn {
    constructor(t = 0) {
      this.angle = t;
    }
    toString() {
      return `rotate(${this.angle}deg)`;
    }
  }
  class un {
    constructor(t = 0, e = 0) {
      ((this.x = t), (this.y = e));
    }
    toString() {
      const {x: t, y: e} = this;
      return 0 !== t && 0 === e ? `skewX(${t}deg)` : 0 !== e && 0 === t ? `skewY(${e}deg)` : `skew(${t}deg, ${e}deg)`;
    }
  }
  class pn {
    constructor(t = 0, e = 0, i = 0, n = 0) {
      ((this.x = t), (this.y = e), (this.z = i), (this.angle = n));
    }
    toString() {
      return `rotate3d(${this.x}, ${this.y}, ${this.z}, ${this.angle}deg)`;
    }
  }
  const mn = class {
    constructor() {
      this._operations = [];
    }
    translate(t = 0, e = 0, i = 0) {
      return (this._operations.push(new hn(t, e, i)), this);
    }
    scale(t = 1, e = t, i = 1) {
      return (this._operations.push(new cn(t, e, i)), this);
    }
    rotate(t = 0) {
      return (this._operations.push(new dn(t)), this);
    }
    rotate3d(t = 0, e = 0, i = 0, n = 0) {
      return (this._operations.push(new pn(t, e, i, n)), this);
    }
    skew(t = 0, e = 0) {
      return (this._operations.push(new un(t, e)), this);
    }
    transform(t) {
      return (Array.isArray(t) ? this._operations.push(...t) : this._operations.push(t), this);
    }
    toString() {
      return this._operations.map((t) => t.toString()).join(" ");
    }
  };
  let gn = [],
    _n = [];
  const fn = Object.freeze({None: 0, Removal: 1, Addition: 2, AttachAsShadowRoot: 3});
  let yn;
  class vn {
    constructor() {
      ((this._parent = null),
        (this._children = []),
        (this._dirtyAttributes = {}),
        (this._dirtyProperties = []),
        (this._doNotNotifyParentChange = !1),
        (this.domNode = null),
        (this.nodeIsShadowRoot = !1));
    }
    get parent() {
      return this._parent;
    }
    get children() {
      return this._children;
    }
    set children(t) {
      const e = this._children;
      for (; e.length; ) this.removeChild(e[0]);
      t.forEach((t) => {
        this.addChild(t);
      });
    }
    get childCount() {
      return this._children.length;
    }
    get firstChild() {
      return this._children[0] || null;
    }
    get lastChild() {
      return this._children[this._children.length - 1] || null;
    }
    get previousSibling() {
      if (!this._parent) return null;
      const t = this._parent._children,
        e = t.indexOf(this);
      return e > 0 ? t[e - 1] : null;
    }
    get nextSibling() {
      if (!this._parent) return null;
      const t = this._parent._children,
        e = t.indexOf(this);
      return -1 !== e && e < t.length - 1 ? t[e + 1] : null;
    }
    addChild(t, e) {
      if (0 === e && this._children[0] && this._children[0].nodeIsShadowRoot)
        throw new TypeError("RenderTree.RenderNode.addChild: Node cannot insert before shadow root node.");
      return (
        t.willMoveToParent(this),
        (t._doNotNotifyParentChange = !0),
        t.remove(),
        delete t._doNotNotifyParentChange,
        (void 0 === e || e < 0 || e > this._children.length) && (e = this._children.length),
        this._children.splice(e, 0, t),
        (t._parent = this),
        t.didMoveToParent(this),
        this.didAddChild(t),
        t._markNodeManipulation(fn.Addition),
        t
      );
    }
    insertBefore(t, e) {
      return this.addChild(t, e ? this._children.indexOf(e) : -1);
    }
    insertAfter(t, e) {
      const i = e ? this._children.indexOf(e) : -1;
      return this.addChild(t, -1 !== i ? i + 1 : 0);
    }
    removeChild(t) {
      if (t._parent !== this) return;
      const e = this._children.indexOf(t);
      if (-1 !== e) {
        if (t.nodeIsShadowRoot)
          throw new TypeError("RenderTree.RenderNode: Not supported in ShadowRoot-backed RenderNode.");
        return (
          this.willRemoveChild(t),
          t._doNotNotifyParentChange || t.willMoveToParent(null),
          this._children.splice(e, 1),
          (t._parent = null),
          t._doNotNotifyParentChange || t.didMoveToParent(null),
          t._markNodeManipulation(fn.Removal),
          t
        );
      }
    }
    remove() {
      if (this._parent instanceof vn) return this._parent.removeChild(this);
    }
    dump(t) {
      return xn(this, "", -1, t);
    }
    willRemoveChild(t) {}
    didAddChild(t) {}
    willMoveToParent(t) {}
    didMoveToParent(t) {}
    _markDirtyProperty(t, e) {
      let i;
      ((i = void 0 === e || e ? An(this._dirtyProperties, t) : En(this._dirtyProperties, t)),
        i && this._updateNodeDirtiness());
    }
    _markNodeManipulation(t) {
      ((this._pendingDOMManipulation = t), this._updateNodeDirtiness());
    }
    _updateNodeDirtiness() {
      this._pendingDOMManipulation !== fn.None ||
      this._dirtyProperties.length > 0 ||
      Object.getOwnPropertyNames(this._dirtyAttributes).length > 0
        ? (An(gn, this), Qt.scheduleDraw(Cn))
        : En(gn, this);
    }
  }
  class wn extends vn {
    constructor(t) {
      (super(), (this.shadowRootMode = t), (this.nodeIsShadowRoot = !0));
    }
    toString() {
      return this.stringInfo() + " [" + this.shadowRootMode + "]";
    }
    stringInfo() {
      return "#shadow-root";
    }
  }
  class bn extends vn {
    constructor(t) {
      let e;
      var i;
      (super(),
        (e =
          (i = t) instanceof window.Node && i.nodeType === window.Node.ELEMENT_NODE
            ? t
            : "string" == typeof t
              ? (function (t) {
                  const e = document.createElement("div");
                  e.innerHTML = t;
                  const i = e.firstElementChild;
                  if (!(i instanceof Text || i instanceof HTMLElement || i instanceof Text)) throw new Error("");
                  return i;
                })(t)
              : "object" == typeof t
                ? Ln(t)
                : document.createElement("div")),
        (this.domNode = e),
        (this._opacity = 1),
        (this._color = ""),
        (this._size = new ki()),
        (this._position = new Mi()),
        (this._transform = new mn()),
        (this._backgroundImages = []),
        (this._classList = new Tn(this)),
        (this._wantsHardwareCompositing = !1),
        (this._pendingDOMManipulation = fn.None));
    }
    get element() {
      return this.domNode;
    }
    set element(t) {
      this.domNode = t;
    }
    get classList() {
      return this._classList;
    }
    get wantsHardwareCompositing() {
      return this._wantsHardwareCompositing;
    }
    set wantsHardwareCompositing(t) {
      t !== this._wantsHardwareCompositing &&
        ((this._wantsHardwareCompositing = t), this._markDirtyProperty("will-change"));
    }
    get opacity() {
      return this._opacity;
    }
    set opacity(t) {
      (t = Math.min(Math.max(0, t), 1)) !== this._opacity && ((this._opacity = t), this._markDirtyProperty("opacity"));
    }
    get color() {
      return this._color;
    }
    set color(t) {
      t !== this._color && ((this._color = t), this._markDirtyProperty("color"));
    }
    get position() {
      return this._position;
    }
    set position(t) {
      ((this._position = t), this._markDirtyProperty("position"));
    }
    get transform() {
      return this._transform;
    }
    set transform(t) {
      ((this._transform = t), this._markDirtyProperty("transform"));
    }
    get backgroundImages() {
      return this._backgroundImages;
    }
    set backgroundImages(t) {
      ((this._backgroundImages = t || []), this._markDirtyProperty("backgroundImages"));
    }
    get size() {
      return this._size;
    }
    set size(t) {
      ((this._size = t || new ki()), this._markDirtyProperty("size"));
    }
    setAttribute(t, e) {
      if (this.domNode instanceof Text) throw new Error("");
      ((this._dirtyAttributes[t] = e), this._updateNodeDirtiness());
    }
    removeAttribute(t) {
      if (this.domNode instanceof Text) throw new Error("");
      ((this._dirtyAttributes[t] = null), this._updateNodeDirtiness());
    }
    createAndAddShadowRootChild(t) {
      if (this.domNode instanceof Text || this.domNode instanceof SVGElement) throw new Error("");
      if (this._children[0] && this._children[0].nodeIsShadowRoot)
        throw new Error("RenderTree.RenderNode.createAndAddShadowRootChild: Cannot add more than one shadow root.");
      const e = new wn(t || "closed");
      return (
        this._children.unshift(e),
        (e._parent = this),
        this.didAddChild(e),
        e._markNodeManipulation(fn.AttachAsShadowRoot),
        e
      );
    }
    convertPointFromPage(t) {
      if (!(this.domNode instanceof HTMLElement)) throw new Error("");
      return Ri(this.domNode, t);
    }
    convertPointToPage(t) {
      if (!(this.domNode instanceof HTMLElement)) throw new Error("");
      return Oi(this.domNode, t);
    }
    toString() {
      let t = "";
      return (
        this._wantsHardwareCompositing && (t += "🏁 "),
        (t += this.stringInfo()),
        this.classList.toString() &&
          (t += this.classList
            ._classes()
            .map(function (t) {
              return "." + t;
            })
            .join(", ")),
        (0 === this.position.x && 0 === this.position.y) ||
          (t += " (" + this.position.x + ", " + this.position.y + ")"),
        (0 === this.size.width && 0 === this.size.height) || (t += " " + this.size.width + "x" + this.size.height),
        1 !== this.opacity && (t += " [opacity:" + this.opacity + "]"),
        this.transform.toString() && (t += " [" + this.transform.toString() + "]"),
        t
      );
    }
    stringInfo() {
      return this.domNode instanceof Element ? "<" + this.domNode.tagName.toLowerCase() + ">" : "<#text>";
    }
  }
  function Cn() {
    const t = yn ? performance.now() : void 0;
    (gn.forEach(kn),
      (gn = []),
      _n.forEach(Mn),
      (_n = []),
      bn.updates++,
      In.dispatchEvent(new k.Event("update")),
      yn && performance.measure(yn, {start: t}));
  }
  function kn(t) {
    if (t._pendingDOMManipulation === fn.Removal) {
      const e = t.domNode?.parentNode;
      e && t.domNode && e.removeChild(t.domNode);
    }
    if (t._dirtyProperties) {
      const e = t;
      (e._dirtyProperties.forEach(function (t) {
        !(function (t, e) {
          const i = t.domNode;
          if (!(i instanceof HTMLElement || i instanceof SVGElement)) return;
          const n = i.style;
          switch (e) {
            case "opacity":
              n.opacity = t._opacity.toString();
              break;
            case "color":
              n.color = t._color;
              break;
            case "size":
              ((n.width = t._size.width + "px"), (n.height = t._size.height + "px"));
              break;
            case "will-change":
              n.willChange = t._wantsHardwareCompositing ? "transform" : "";
              break;
            case "position":
            case "transform": {
              const e = new mn().translate(Sn(t._position.x), Sn(t._position.y)).transform(t._transform.toString());
              n.transform = e.toString();
              break;
            }
            case "backgroundImages":
              !(function (t) {
                if (!(t.domNode instanceof HTMLElement || t.domNode instanceof SVGElement)) return;
                const e = t.domNode.style;
                if (!t._backgroundImages.length)
                  return (
                    e.removeProperty("background-image"),
                    e.removeProperty("background-position"),
                    void e.removeProperty("background-size")
                  );
                const i = [],
                  n = [],
                  o = [],
                  s = t._backgroundImages;
                for (let t = s.length - 1; t >= 0; --t) {
                  const e = s[t];
                  (i.push("url(" + e.url + ")"),
                    n.push(e.position.x + "px " + e.position.y + "px"),
                    o.push(e.size.width + "px " + e.size.height + "px"));
                }
                ((e.backgroundImage = i.join(",")),
                  (e.backgroundPosition = n.join(",")),
                  (e.backgroundSize = o.join(",")));
              })(t);
              break;
            case "classList":
              (i.setAttribute("class", t._classList.toString()), t._classList.reset());
          }
        })(e, t);
      }),
        (e._dirtyProperties = []));
    }
    if (t._dirtyAttributes) {
      const e = t.domNode;
      (Object.getOwnPropertyNames(t._dirtyAttributes).forEach(function (i) {
        const n = t._dirtyAttributes[i];
        null === n ? e.removeAttribute(i) : e.setAttribute(i, n);
      }),
        (t._dirtyAttributes = {}));
    }
    (t._pendingDOMManipulation !== fn.Addition && t._pendingDOMManipulation !== fn.AttachAsShadowRoot) ||
      An(_n, t.parent);
  }
  function Mn(t) {
    let e = null;
    const i = t.domNode;
    for (let n = t.children.length - 1; n >= 0; --n) {
      const o = t.children[n],
        s = o.domNode;
      switch (o._pendingDOMManipulation) {
        case fn.Addition:
          (i.insertBefore(s, e), (o._pendingDOMManipulation = fn.None));
          break;
        case fn.AttachAsShadowRoot: {
          const t = i.attachShadow({mode: o.shadowRootMode});
          ((o.domNode = t), (o._pendingDOMManipulation = fn.None));
          break;
        }
      }
      e = s;
    }
  }
  function Sn(t) {
    const e = Math.max(Math.round(window.devicePixelRatio), 1);
    return Math.round(t * e) / e;
  }
  function Ln(t) {
    const e = t.name;
    if ("#text" === e) return document.createTextNode(t.value ?? "");
    const i = document.createElement(e),
      n = t.attributes;
    for (const t in n) i.setAttribute(t, n[t]);
    return (
      t.children instanceof Array &&
        t.children.forEach(function (t) {
          i.appendChild(Ln(t));
        }),
      i
    );
  }
  function An(t, e) {
    return -1 === t.indexOf(e) && (t.push(e), !0);
  }
  function En(t, e) {
    const i = t.indexOf(e);
    return -1 !== i && (t.splice(i, 1), !0);
  }
  function xn(t, e, i, n) {
    let o = "";
    ((o += e),
      n &&
        (o += (function (t) {
          return t < 0 ? "" : t + ":";
        })(i)),
      (o += t.toString()),
      (o += (function (t) {
        return t.childCount < 1 ? "" : " ⤵︎ " + t.childCount;
      })(t)));
    const s = t.children;
    for (let i = 0, a = s.length; i < a; ++i) {
      const a = t.childCount < 1 ? -1 : i;
      ((o += "\n"), (o += xn(s[i], e + "    ", a, n)));
    }
    return o;
  }
  bn.updates = 0;
  class Tn {
    constructor(t) {
      ((this._node = t),
        (this._additions = []),
        (this._removals = []),
        (this.__classes = []),
        (this._populateClasses = !0));
    }
    add(t) {
      this._add(t);
    }
    remove(t) {
      this._remove(t);
    }
    contains(t) {
      return -1 !== this._classes().indexOf(t);
    }
    toggle(t, e) {
      if (arguments.length > 1) return (e ? this._add(t) : this._remove(t), !!e);
      this._add(t) || this._remove(t);
    }
    toString() {
      return this._classes().join(" ");
    }
    _classes() {
      if (this._populateClasses) {
        let t =
          this._node.domNode instanceof HTMLElement || this._node.domNode instanceof SVGElement
            ? this._node.domNode.className
            : "";
        ("string" == typeof t.baseVal && (t = t.baseVal),
          (this.__classes = t.split(/[ ]+/).filter(Boolean)),
          delete this._populateClasses);
      }
      return this.__classes;
    }
    reset() {
      ((this._additions = []), (this._removals = []), (this.__classes = []), (this._populateClasses = !0));
    }
    _add(t) {
      if (!t) return !1;
      const e = An(this._classes(), t);
      return (e && (En(this._removals, t) || An(this._additions, t), this._updateNodeDirtiness()), e);
    }
    _remove(t) {
      if (!t) return !1;
      const e = En(this._classes(), t);
      return (e && (En(this._additions, t) || An(this._removals, t), this._updateNodeDirtiness()), e);
    }
    _updateNodeDirtiness() {
      this._node._markDirtyProperty("classList", this._additions.length > 0 || this._removals.length > 0);
    }
  }
  const In = new (class extends k.EventTarget {
      constructor() {
        (super(), (this.Node = bn), (this.Point = Mi), (this.Transform = mn));
      }
      setPerformanceMeasureName(t) {
        yn = t;
      }
    })(),
    Rn = In;
  class On extends k.EventTarget {
    constructor() {
      (super(),
        (this.modifierKeys = {alt: !1, ctrl: !1, meta: !1, shift: !1}),
        (this.useGestures = !1),
        (this._targetTouches = []),
        (this._lastKnownEventLocation = null),
        (this._shouldHandleTrackingEvents = !1),
        (this._domEvents = []),
        (this.events = void 0),
        (this._mode = void 0),
        (this.mode = On.Modes.Adaptive),
        (this._enabled = !0),
        (this._target = null),
        (this.state = On.States.Possible),
        (this.delegate = null));
    }
    get mode() {
      return this._mode;
    }
    set mode(t) {
      if (this._mode !== t) {
        if (this._targetTouches.length) throw new Error("");
        switch ((this._removeBaseListeners(), t)) {
          case On.Modes.Adaptive:
            On.SupportsPointerEvents
              ? (this.events = Gn.Pointer)
              : On.SupportsTouches
                ? (this.events = Gn.Touch)
                : (this.events = Gn.Mouse);
            break;
          case On.Modes.Pointer:
            this.events = Gn.Pointer;
            break;
          case On.Modes.Touch:
            this.events = Gn.Touch;
            break;
          case On.Modes.Mouse:
            this.events = Gn.Mouse;
        }
        ((this._mode = t), this._updateBaseListeners());
      }
    }
    get currentMode() {
      if (this._mode === On.Modes.Adaptive)
        switch (this.events) {
          case Gn.Pointer:
            return On.Modes.Pointer;
          case Gn.Touch:
            return On.Modes.Touch;
          case Gn.Mouse:
            return On.Modes.Mouse;
        }
      return this._mode;
    }
    get target() {
      return this._target;
    }
    set target(t) {
      this._target !== t && (this._removeBaseListeners(), t && ((this._target = t), this._initRecognizer()));
    }
    get numberOfTouches() {
      return this._targetTouches.length;
    }
    get enabled() {
      return this._enabled;
    }
    set enabled(t) {
      this._enabled !== t &&
        ((this._enabled = t),
        t ||
          (0 === this.numberOfTouches ? (this._removeTrackingListeners(), this.reset()) : this.enterCancelledState()),
        this._updateBaseListeners());
    }
    get domEvents() {
      return this._domEvents;
    }
    reset() {}
    preventDefault(t) {
      "touchmove" !== t.type && "pointer" !== t.type.substr(0, 7) && t.preventDefault();
    }
    locationInElement(t) {
      const e = new Mi(),
        i = this._targetTouches;
      if (this._lastKnownEventLocation)
        ((e.x = this._lastKnownEventLocation.pageX), (e.y = this._lastKnownEventLocation.pageY));
      else {
        const t = i.length;
        for (let n = 0; n < t; ++n) {
          const t = i[n];
          ((e.x += t.pageX), (e.y += t.pageY));
        }
        ((e.x /= t), (e.y /= t));
      }
      return t ? Pi(t, e) : e;
    }
    locationInClient() {
      const t = new Mi(),
        e = this._targetTouches;
      if (this._lastKnownEventLocation)
        ((t.x = this._lastKnownEventLocation.clientX), (t.y = this._lastKnownEventLocation.clientY));
      else {
        const i = e.length;
        for (let n = 0; n < i; ++n) {
          const i = e[n];
          ((t.x += i.clientX), (t.y += i.clientY));
        }
        ((t.x /= i), (t.y /= i));
      }
      return t;
    }
    locationOfTouchInElement(t, e) {
      const i = this._targetTouches[t];
      if (!i) return new Mi();
      const n = new Mi(i.pageX, i.pageY);
      return e ? Pi(e, n) : n;
    }
    touchesBegan(t) {
      t.currentTarget === this._target &&
        ((this._shouldHandleTrackingEvents = !0),
        window.addEventListener(this.events.Move, this, !0),
        window.addEventListener(this.events.End, this, !0),
        this.events.Cancel && window.addEventListener(this.events.Cancel, this, !0),
        this.enterPossibleState());
    }
    touchesMoved(t) {}
    touchesEnded(t) {}
    touchesCancelled(t) {}
    gestureBegan(t) {
      t.currentTarget === this._target &&
        (window.addEventListener(this.events.GestureChange, this, !0),
        window.addEventListener(this.events.GestureEnd, this, !0),
        this.enterPossibleState());
    }
    gestureChanged(t) {}
    gestureEnded(t) {}
    enterPossibleState() {
      this._setStateAndNotifyOfChange(On.States.Possible);
    }
    enterBeganState() {
      !this.delegate ||
      "function" != typeof this.delegate.gestureRecognizerShouldBegin ||
      this.delegate.gestureRecognizerShouldBegin(this)
        ? this._setStateAndNotifyOfChange(On.States.Began)
        : this.enterFailedState();
    }
    enterEndedState() {
      (this._setStateAndNotifyOfChange(On.States.Ended), this._removeTrackingListeners(), this.reset());
    }
    enterCancelledState() {
      (this._setStateAndNotifyOfChange(On.States.Cancelled), this._removeTrackingListeners(), this.reset());
    }
    enterFailedState() {
      (this._setStateAndNotifyOfChange(On.States.Failed), this._removeTrackingListeners(), this.reset());
    }
    enterChangedState() {
      this._setStateAndNotifyOfChange(On.States.Changed);
    }
    enterRecognizedState() {
      this._setStateAndNotifyOfChange(On.States.Recognized);
    }
    handleEvent(t) {
      this._shouldCountAndHandleTouch(t) &&
        ((this.lastEventTimeStamp = t.timeStamp),
        this._updateTargetTouches(t),
        this._updateKeyboardModifiers(t),
        this._handleTouches(t));
    }
    _handleTouches(t) {
      if (this._shouldHandleTouch(t))
        switch (t.type) {
          case this.events.Start:
            this.touchesBegan(t);
            break;
          case this.events.Move:
            this.touchesMoved(t);
            break;
          case this.events.End:
            this.touchesEnded(t);
            break;
          case this.events.Cancel:
            this.touchesCancelled(t);
            break;
          case this.events.GestureStart:
            this.gestureBegan(t);
            break;
          case this.events.GestureChange:
            this.gestureChanged(t);
            break;
          case this.events.GestureEnd:
            this.gestureEnded(t);
        }
    }
    _shouldCountAndHandleTouch(t) {
      if (this.events !== Gn.Pointer) return !0;
      if (!(t instanceof PointerEvent)) return !0;
      const e = this._targetTouches[0];
      return !(e && e instanceof PointerEvent && t.pointerType !== e.pointerType && e.pointerId !== t.pointerId);
    }
    _shouldHandleTouch(t) {
      return (
        this.events !== Gn.Pointer ||
        t.type === this.events.Start ||
        t.type === this.events.GestureStart ||
        t.type === this.events.GestureChange ||
        t.type === this.events.GestureEnd ||
        this._shouldHandleTrackingEvents
      );
    }
    _initRecognizer() {
      (this.reset(), (this.state = On.States.Possible), this._updateBaseListeners());
    }
    _removeBaseListeners() {
      this._target &&
        (this._target.removeEventListener(this.events.Start, this),
        this.useGestures && this._target.removeEventListener(this.events.GestureStart, this),
        this.events === Gn.Pointer &&
          ((this._targetTouches = []),
          window.removeEventListener(this.events.End, this, !0),
          window.removeEventListener(this.events.Cancel, this, !0)));
    }
    _updateBaseListeners() {
      this._target &&
        (this._enabled
          ? (this._target.addEventListener(this.events.Start, this),
            this.useGestures && this._target.addEventListener(this.events.GestureStart, this),
            this.events === Gn.Pointer &&
              (window.addEventListener(this.events.End, this, !0),
              window.addEventListener(this.events.Cancel, this, !0)))
          : this._removeBaseListeners());
    }
    _removeTrackingListeners() {
      ((this._shouldHandleTrackingEvents = !1),
        window.removeEventListener(this.events.Move, this, !0),
        this.events !== Gn.Pointer &&
          (window.removeEventListener(this.events.End, this, !0),
          this.events.Cancel && window.removeEventListener(this.events.Cancel, this, !0)),
        window.removeEventListener(this.events.GestureChange, this, !0),
        window.removeEventListener(this.events.GestureEnd, this, !0));
    }
    _setStateAndNotifyOfChange(t) {
      ((this.state = t), this.dispatchEvent(new k.Event(this.events.StateChange)));
    }
    _setLastKnownSinglePointLocation(t) {
      this._lastKnownEventLocation = {clientX: t.clientX, clientY: t.clientY, pageX: t.pageX, pageY: t.pageY};
    }
    _updateTargetTouches(t) {
      if (
        t.type === this.events.GestureStart ||
        t.type === this.events.GestureChange ||
        t.type === this.events.GestureEnd
      ) {
        const e = t;
        return void this._setLastKnownSinglePointLocation(e);
      }
      if (this.events === Gn.Mouse) {
        const e = t;
        return void (t.type === this.events.End
          ? ((this._targetTouches = []), this._setLastKnownSinglePointLocation(e))
          : ((this._targetTouches = [e]), (this._lastKnownEventLocation = null)));
      }
      let e, i, n;
      if (this.events === Gn.Touch) {
        const o = t,
          s = this._targetTouches;
        if (o.type === this.events.Start) {
          for (this._targetTouches = [], e = o.targetTouches, i = 0, n = e.length; i < n; ++i)
            this._targetTouches.push(e[i]);
          return void (this._lastKnownEventLocation = null);
        }
        if (o.type === this.events.Move) {
          const t = s.map((t) => t.identifier);
          for (this._targetTouches = [], e = o.touches, i = 0, n = e.length; i < n; ++i) {
            const n = e[i];
            -1 !== t.indexOf(n.identifier) && this._targetTouches.push(n);
          }
          return void (this._lastKnownEventLocation = null);
        }
        const a = o.touches,
          r = [];
        for (i = 0, n = a.length; i < n; ++i) r.push(a[i].identifier);
        return (
          (this._targetTouches = s.filter((t) => -1 !== r.indexOf(t.identifier))),
          void (0 === this._targetTouches.length
            ? this._setLastKnownSinglePointLocation(a[0])
            : (this._lastKnownEventLocation = null))
        );
      }
      if (this.events === Gn.Pointer) {
        const e = t,
          i = this._targetTouches;
        return t.type === this.events.Start
          ? (this._targetTouches.push(e), void (this._lastKnownEventLocation = null))
          : t.type === this.events.Move
            ? ((this._targetTouches = i.map((t) => (t.pointerId !== e.pointerId ? t : e))),
              void (this._lastKnownEventLocation = null))
            : ((this._targetTouches = i.filter((t) => t.pointerId !== e.pointerId)),
              void (0 === this._targetTouches.length
                ? this._setLastKnownSinglePointLocation(e)
                : (this._lastKnownEventLocation = null)));
      }
      throw new Error("");
    }
    _updateKeyboardModifiers(t) {
      ((this.modifierKeys.alt = t.altKey),
        (this.modifierKeys.ctrl = t.ctrlKey),
        (this.modifierKeys.meta = t.metaKey),
        (this.modifierKeys.shift = t.shiftKey));
    }
    _distance() {
      if (2 !== this.numberOfTouches) return 0;
      const t = this._targetTouches[0],
        e = new Mi(t.pageX, t.pageY),
        i = this._targetTouches[1],
        n = new Mi(i.pageX, i.pageY);
      return e.distanceToPoint(n);
    }
  }
  On.Modes = Object.freeze({Adaptive: "adaptive", Pointer: "pointer", Touch: "touch", Mouse: "mouse"});
  const Pn = "PointerEvent" in window;
  On.SupportsPointerEvents = Pn;
  const Dn = "ontouchmove" in document;
  On.SupportsTouches = Dn;
  const zn = !!window.GestureEvent;
  let Nn, Fn;
  ((On.SupportsGestures = zn),
    On.SupportsGestures
      ? On.SupportsPointerEvents
        ? (Nn = Fn = !On.SupportsTouches)
        : ((Nn = !On.SupportsTouches), (Fn = !0))
      : ((Nn = !1), (Fn = !1)),
    (On.UseGesturesForRotation = Nn),
    (On.UseGesturesForPinch = Fn));
  const Un = Object.freeze({
    Possible: "possible",
    Began: "began",
    Changed: "changed",
    Ended: "ended",
    Cancelled: "cancelled",
    Failed: "failed",
    Recognized: "ended"
  });
  On.States = Un;
  const Gn = Object.freeze({
      Pointer: {
        Start: "pointerdown",
        Move: "pointermove",
        End: "pointerup",
        Cancel: "pointercancel",
        GestureStart: "gesturestart",
        GestureChange: "gesturechange",
        GestureEnd: "gestureend",
        StateChange: "statechange"
      },
      Touch: {
        Start: "touchstart",
        Move: "touchmove",
        End: "touchend",
        Cancel: "touchcancel",
        GestureStart: "gesturestart",
        GestureChange: "gesturechange",
        GestureEnd: "gestureend",
        StateChange: "statechange"
      },
      Mouse: {
        Start: "mousedown",
        Move: "mousemove",
        End: "mouseup",
        Cancel: void 0,
        GestureStart: "gesturestart",
        GestureChange: "gesturechange",
        GestureEnd: "gestureend",
        StateChange: "statechange"
      }
    }),
    Bn = On,
    Zn = Bn.SupportsTouches,
    Wn = Bn.SupportsPointerEvents,
    Kn = Bn.SupportsGestures,
    Hn = "ShadowRoot" in window;
  function jn(t, e, ...i) {
    const n = window.document.createElementNS(t, e);
    let o = 0;
    if ("object" == typeof i[0] && null != i[0] && !(i[0] instanceof window.Node)) {
      ++o;
      for (const t in i[0]) n.setAttribute(t, i[0][t]);
    }
    for (let t = o, e = i.length; t < e; ++t) {
      const e = i[t];
      e instanceof window.Node ? n.appendChild(e) : "string" == typeof e && n.appendChild(document.createTextNode(e));
    }
    return n;
  }
  const Vn = {
      focusColor: "rgb(0, 122, 255)",
      get devicePixelRatio() {
        return Math.max(Math.round(window.devicePixelRatio), 1) || 1;
      },
      roundToDevicePixel: function (t, e) {
        const i = e || this.devicePixelRatio;
        return Math.round(t * i) / i;
      },
      supportsTouches: Zn,
      supportsPointerEvents: Wn,
      supportsGestureEvents: Kn,
      startEventType: Wn ? "pointerdown" : Zn ? "touchstart" : "mousedown",
      moveEventType: Wn ? "pointermove" : Zn ? "touchmove" : "mousemove",
      endEventType: Wn ? "pointerup" : Zn ? "touchend" : "mouseup",
      cancelEventType: Wn ? "pointercancel" : Zn ? "touchcancel" : void 0,
      supportsForceTouch: !Zn && "webkitForce" in MouseEvent.prototype,
      htmlElement: (t, ...e) => jn("http://www.w3.org/1999/xhtml", t, ...e),
      svgElement: (t, ...e) => jn("http://www.w3.org/2000/svg", t, ...e),
      supportsShadowDOM: Hn,
      insideIframe: window.top !== window,
      getShadowDOMTargetFromEvent: function (t, e) {
        const i = this.containingDocumentOrShadowRoot(t);
        if (i === document) return e.target;
        const n = "changedTouches" in e ? e.changedTouches[0] : e;
        return i.elementFromPoint(n.clientX, n.clientY) || document.body;
      },
      containingDocumentOrShadowRoot: function (t) {
        return this.supportsShadowDOM ? t.getRootNode() : document;
      },
      addShadowRootChild: function (t, e, i, n) {
        let o;
        this.supportsShadowDOM
          ? (o = t.createAndAddShadowRootChild(e))
          : ((o = t.addChild(new bn())),
            (i = (function (t) {
              let e,
                i = "";
              for (; (e = t.match(/:host\(/)); ) {
                ((i += t.substr(0, e.index)), (t = t.substr(e.index + e[0].length)));
                let n = 1;
                for (; (e = t.match(/^([^()]*)([()])?/)); ) {
                  if (((t = t.substr(e[0].length)), "(" === e[2])) n += 1;
                  else if (")" === e[2] && ((n -= 1), 0 === n)) {
                    i += e[1];
                    break;
                  }
                  if (((i += e[0]), !e[2])) break;
                }
              }
              return i + t;
            })(i)));
        const s = this.htmlElement("style", i);
        return (n && (s.nonce = n), o.addChild(new bn(s)), o);
      },
      parentNodeForSvgTarget: function (t) {
        return t.tagName && "div" !== t.tagName.toLowerCase() ? this.parentNodeForSvgTarget(t.parentNode) : t;
      },
      imagePathForDevice: function (t, e, i) {
        const n = Math.floor(this.devicePixelRatio);
        let o;
        return (
          (o = -1 !== t.indexOf(n) ? n : n > t[t.length - 1] ? t[t.length - 1] : t[0]),
          e + (o > 1 ? "_" + o + "x" : "") + (i || ".png")
        );
      },
      parseQueryString: function (t) {
        const e = {};
        let i;
        const n = /\+/g,
          o = /([^&=]+)=?([^&]*)/g,
          s = function (t) {
            return decodeURIComponent(t.replace(n, " "));
          };
        if ("string" == typeof t) for (; null !== (i = o.exec(t)); ) e[s(i[1])] = s(i[2]);
        return e;
      },
      createSVGIcon: function (t, e) {
        let i = "mk-icon";
        e.class && ((i += " " + e.class), delete e.class);
        const n = this.svgElement("svg", e);
        return (
          n.setAttribute("class", i),
          n.setAttribute("focusable", "false"),
          n.appendChild(this.svgElement("g")).appendChild(t),
          n
        );
      },
      convertColorToRGB: function (t) {
        const e = document.createElement("div");
        return (e.style.setProperty("color", t), e.style.color);
      },
      isValidCSSColor: function (t) {
        return "" !== this.convertColorToRGB(t);
      },
      updateLabel: function (t, e) {
        (t.setAttribute("title", e), t.setAttribute("aria-label", e));
      },
      easeInOut: function (t) {
        const e = Math.pow(t, 2);
        return e / (e + Math.pow(1 - t, 2));
      },
      lerp: function (t, e, i) {
        return (1 - t) * e + t * i;
      },
      darkColorScheme: function (t) {
        return t === ji;
      },
      restrictRotation: function (t) {
        return t < 180 ? Math.min(t, 30) : Math.max(t, 330);
      },
      getIntegralZoom: function (t) {
        return Math.floor(t + 1e-6);
      }
    },
    qn = Vn;
  function Yn(t) {
    ((this._node = t), (this._layer = null));
  }
  let Xn = {};
  Yn.prototype = {
    constructor: Yn,
    get node() {
      return this._node;
    },
    get shouldDraw() {
      const t = this._node.keyForFrozenLayer;
      return !((this._frozenLayer && (!this._sharedLayer || this._sharedLayer.key === t)) || (t && Xn[t]));
    },
    get layer() {
      const t = this._node,
        e = t.frozen,
        i = t.keyForFrozenLayer;
      if (e) {
        if (this._frozenLayer) {
          if (!i || !this._sharedLayer || this._sharedLayer.key === i) return this._frozenLayer;
          this.releaseLayer();
        }
        if (i) {
          const t = Xn[i];
          if (t && t.key === i)
            return ((this._sharedLayer = t), (this._layer = this._frozenLayer = t.canvas), ++t.count, t.canvas);
        }
      }
      (delete this._frozenLayer,
        this._layer ||
          ((this._layer = this.createCanvas()),
          (this._layer.hidden = !0),
          i && (this._sharedLayer = Xn[i] = {canvas: this._layer, count: 1, key: i})));
      const n = qn.devicePixelRatio,
        o = t.layerBounds;
      ((this._layer.width = Math.ceil(o.size.width * n)), (this._layer.height = Math.ceil(o.size.height * n)));
      const s = this._layer.getContext("2d");
      return (
        s && (s.scale(n, n), s.translate(-o.origin.x, -o.origin.y)),
        e && (this._frozenLayer = this._layer),
        this._layer
      );
    },
    releaseLayer: function (t) {
      this._layer &&
        (this._sharedLayer
          ? t ||
            (--this._sharedLayer.count,
            0 === this._sharedLayer.count &&
              (delete Xn[this._sharedLayer.key],
              (this._layer.width = 0),
              this._layer.parentNode && this._layer.parentNode.removeChild(this._layer)))
          : ((this._layer.width = 0), this._layer.parentNode && this._layer.parentNode.removeChild(this._layer)),
        delete this._sharedLayer,
        delete this._frozenLayer,
        delete this._layer);
    },
    nodeWasRemoved: function () {
      this._layer &&
        (function (t) {
          (0 === $n.length &&
            setTimeout(function () {
              ($n.forEach(function (t) {
                t._node.scene || t.releaseLayer();
              }),
                ($n = []));
            }, 0),
            $n.push(t));
        })(this);
    },
    createCanvas: function () {
      return W();
    },
    draw: function (t) {}
  };
  let $n = [];
  Yn.releaseSharedLayers = function () {
    (Object.keys(Xn).forEach(function (t) {
      const e = Xn[t];
      ((e.canvas.width = 0), delete e.key, delete e.canvas);
    }),
      (Xn = {}));
  };
  const Jn = Yn;
  function Qn(t) {
    (Jn.call(this, t), (this._canvas = this.createCanvas()), (this._ctx = this._canvas.getContext("2d")));
  }
  function to(t, e, i, n, o, s) {
    if (!e || 0 === t.opacity) return;
    const a = t.renderer;
    o && a.releaseLayer(!0);
    const r = a.shouldDraw,
      l = t.wantsLayerBacking ? a.layer : null;
    if ((l || t.frozen || a.releaseLayer(), t.wantsLayerBacking && !l)) return;
    const h = function (a) {
        if (
          (e.save(), e.translate(a, d), e.transform(u.a, u.b, u.c, u.d, u.e, u.f), (e.globalAlpha = s), r || !t.frozen)
        ) {
          const a = l ? l.getContext("2d") : e;
          (l && e.canvas && "appendChild" in e.canvas && e.canvas.appendChild(l), t.renderer.draw(a));
          const r = t.children;
          for (let t = 0, e = r.length; t < e; ++t) to(r[t], a, i, n, o, l ? 1 : s);
        }
        (l &&
          0 !== l.width &&
          0 !== l.height &&
          e.drawImage(l, t.layerBounds.origin.x, t.layerBounds.origin.y, l.width / n, l.height / n),
          e.restore());
      },
      c = t.position.x,
      d = t.position.y,
      u = t.transform;
    ((s *= t.opacity), h(c), t.repeatOffset && h(c + t.repeatOffset));
  }
  Qn.prototype = r(Jn, Qn, {
    get ctx() {
      return this._ctx;
    },
    get element() {
      return this._canvas;
    },
    update: function () {
      if (!this._ctx) return;
      const t = this._node,
        e = t.size,
        i = qn.devicePixelRatio,
        n = !this._previousScale || this._previousScale !== i;
      (n && Jn.releaseSharedLayers(),
        !n && this._previousSize && this._previousSize.equals(e)
          ? this._ctx.clearRect(0, 0, e.width * i, e.height * i)
          : ((this._canvas.style.width = e.width + "px"),
            (this._canvas.style.height = e.height + "px"),
            (this._canvas.width = e.width * i),
            (this._canvas.height = e.height * i),
            (this._previousSize = e.copy()),
            (this._previousScale = i)),
        this._ctx.scale(i, i),
        to(this.node, this._ctx, new Si(-t.position.x, -t.position.y, e.width, e.height), i, n, 1),
        this._ctx.scale(1 / i, 1 / i));
    }
  });
  const eo = Qn;
  function io() {
    (Hi.call(this), (this._renderer = new eo(this)));
  }
  io.prototype = r(Hi, io, {
    isScene: !0,
    performanceMeasureName: void 0,
    get element() {
      return this._renderer.element;
    },
    get contextForMeasurement() {
      return this._renderer.ctx;
    },
    _isTainted: !1,
    isTainted() {
      if (this._isTainted) return this._isTainted;
      const t = Hi.prototype.isTainted.call(this);
      return (t && (this._isTainted = !0), t);
    },
    destroy: function () {
      ((this.children = []),
        (this._renderer._ctx = null),
        (this._renderer._canvas.width = this._renderer._canvas.height = 0));
    },
    flush() {
      Ui.flush(this);
    },
    stringInfo: function () {
      return "Scene";
    }
  });
  const no = io;
  function oo() {
    (Hi.call(this), (this._renderer = new Jn(this)));
  }
  oo.prototype = r(Hi, oo, {
    stringInfo: function () {
      return "GroupNode";
    }
  });
  const so = oo;
  function ao(t) {
    Jn.call(this, t);
  }
  ao.prototype = r(Jn, ao, {
    _lastDrawnImage: null,
    draw: function (t) {
      this._node.image &&
        (this._node.image.complete && this._node.image.naturalWidth
          ? ((this._lastDrawnImage = this._node.image),
            t.drawImage(this._node.image, 0, 0, this._node.size.width, this._node.size.height))
          : this._node.image === this._lastDrawnImage && (this._node.needsDisplay = !0));
    }
  });
  const ro = ao;
  function lo() {
    (Hi.call(this), (this._image = null), (this._renderer = new ro(this)));
  }
  lo.prototype = r(Hi, lo, {
    get image() {
      return this._image;
    },
    set image(t) {
      this._image !== t &&
        (this._image && this._image.removeEventListener("load", this),
        (this._image = t),
        this._imageDidLoad(),
        !t || (t.src && t.complete) || t.addEventListener("load", this));
    },
    isTainted() {
      return !!this._image && null === this._image.crossOrigin;
    },
    stringInfo: function () {
      let t = this._image ? this._image.src : null;
      return "ImageNode" + (t ? "<src:" + t + ">" : "");
    },
    handleEvent: function (t) {
      t.target === this._image &&
        this._image.complete &&
        (this._image.removeEventListener("load", this), this._imageDidLoad(), (this.needsDisplay = !0));
    },
    _imageDidLoad: function () {
      (this.size.equals(ki.Zero) && (this.size = new ki(this._image.width, this._image.height)),
        (this.needsDisplay = !0));
    }
  });
  const ho = lo;
  function co(t) {
    ((this.node = t.node),
      this.node.animators || (this.node.animators = []),
      this.node.animators.push(this),
      (this.duration = t.duration),
      ["from", "to", "done"].forEach(function (e) {
        e in t && null != t[e] && (this[e] = t[e]);
      }, this));
  }
  function uo(t) {
    co.call(this, t);
  }
  function po(t) {
    (t.pop && (this.springSolver = new _o(1, this.STIFFNESS, this.DAMPING, 0)), co.call(this, t));
  }
  function mo(t) {
    (co.call(this, t), t.center && (this.center = t.center));
  }
  function go(t) {
    ((this.popAnimationDone = t.done || n),
      delete t.done,
      (t.duration *= this.FLOAT_DURATION_SCALE),
      co.call(this, t),
      t.center && (this.center = t.center),
      t.floatCenter && (this.floatCenter = t.floatCenter),
      (this.popSpringSolver = new _o(1, this.SCALE_STIFFNESS, this.SCALE_DAMPING, 0)),
      t.to > t.from &&
        ((this.swayAmplitude = (Math.random() < 0.5 ? -1 : 1) * (3 + 3 * Math.random())),
        (this.rotateSpringSolver = new _o(1, this.ROTATE_STIFFNESS, this.ROTATE_DAMPING, 0))));
  }
  function _o(t, e, i, n) {
    ((this.w0 = Math.sqrt(e / t)),
      (this.zeta = i / (2 * Math.sqrt(e * t))),
      this.zeta < 1
        ? ((this.wd = this.w0 * Math.sqrt(1 - this.zeta * this.zeta)),
          (this.A = 1),
          (this.B = (this.zeta * this.w0 - n) / this.wd))
        : ((this.wd = 0), (this.A = 1), (this.B = -n + this.w0)));
  }
  ((co.prototype = {
    from: 0,
    to: 1,
    done: n,
    begin: function () {
      return ((this.startTime = null), (this._p = 0), Qt.scheduleASAP(this), this);
    },
    end: function () {
      if (((this.ended = !0), this.node.animators)) {
        const t = this.node.animators.indexOf(this);
        t >= 0 && (this.node.animators.splice(t, 1), 0 === this.node.animators.length && delete this.node.animators);
      }
      this.done(this);
    },
    performScheduledUpdate: function (t) {
      this.ended ||
        (null != t &&
          (this.beginDate || (this.beginDate = t),
          (this._p = Math.min((t - this.beginDate) / this.duration, 1)),
          this.update(this._p)),
        this._p < 1 ? Qt.scheduleOnNextFrame(this) : this.end());
    },
    valueAt: function (t) {
      return this.from + t * (this.to - this.from);
    },
    stringInfo: function (t, e) {
      let i = "🏇" + t + "<" + this.duration + "ms; " + this.from + "→" + this.to;
      return (
        this._p >= 0 && (i += "/" + Math.round(100 * this._p) + "%"),
        Object.prototype.hasOwnProperty.call(this, "done") && (i += "*"),
        i + (e || "") + ">"
      );
    }
  }),
    (uo.prototype = r(co, uo, {
      update: function (t) {
        this.node.opacity = this.valueAt(t);
      },
      stringInfo: function () {
        return co.prototype.stringInfo.call(this, "opacity");
      }
    })),
    (po.prototype = r(co, po, {
      from: new Mi(0, 0),
      to: new Mi(0, 0),
      STIFFNESS: 100,
      DAMPING: 10,
      update: function (t) {
        (this.springSolver && (t = this.springSolver.solve(t)),
          (this.node.transform = new Li().translate(
            this.from.x + t * (this.to.x - this.from.x),
            this.from.y + t * (this.to.y - this.from.y)
          )));
      },
      end: function () {
        ((this.node.transform = new Li().translate(this.to.x, this.to.y)), co.prototype.end.call(this));
      },
      stringInfo: function () {
        return co.prototype.stringInfo.call(this, "translation");
      }
    })),
    (mo.prototype = r(co, mo, {
      center: new Mi(0, 0),
      scale: function (t) {
        const e = this.center.x,
          i = this.center.y;
        this.node.transform = new Li().translate(e, i).scale(t).translate(-e, -i);
      },
      update: function (t) {
        this.scale(this.valueAt(t));
      },
      stringInfo: function () {
        let t = "";
        return (
          (0 === this.center.x && 0 === this.center.y) || (t += " (" + this.center.x + ", " + this.center.y + ")"),
          co.prototype.stringInfo.call(this, "scale", t)
        );
      }
    })),
    (go.prototype = r(co, go, {
      center: new Mi(0, 0),
      SCALE_STIFFNESS: 100,
      SCALE_DAMPING: 10,
      FLOAT_DURATION_SCALE: 4.2,
      ROTATE_DAMPING: 5,
      ROTATE_STIFFNESS: 127.15275,
      scaleAndRotate: function (t, e) {
        const i = this.center.x,
          n = this.center.y;
        this.floatCenter
          ? (this.node.transform = new Li()
              .translate(this.floatCenter.x, this.floatCenter.y)
              .rotate(e)
              .translate(-this.floatCenter.x, -this.floatCenter.y)
              .translate(i, n)
              .scale(t)
              .translate(-i, -n))
          : (this.node.transform = new Li().translate(i, n).scale(t).rotate(e).translate(-i, -n));
      },
      update: function (t) {
        const e = t * this.FLOAT_DURATION_SCALE,
          i = this.valueAt(this.popSpringSolver.solve(e));
        let n = 0;
        (this.rotateSpringSolver && (n = (this.rotateSpringSolver.solve(t) - 1) * this.swayAmplitude),
          this.scaleAndRotate(i, n),
          e > 1 && !this.popAnimationDoneCalled && ((this.popAnimationDoneCalled = !0), this.popAnimationDone(this)));
      },
      end: function () {
        (this.scaleAndRotate(this.to, 0),
          co.prototype.end.call(this),
          this.popAnimationDoneCalled || this.popAnimationDone(this));
      },
      stringInfo: function () {
        let t = "";
        (0 === this.center.x && 0 === this.center.y) || (t += " (" + this.center.x + ", " + this.center.y + ")");
        let e = "float";
        return (this.popAnimationDoneCalled && (e += " (swing)"), co.prototype.stringInfo.call(this, e, t));
      }
    })),
    (_o.prototype.solve = function (t) {
      return (
        1 -
        (this.zeta < 1
          ? Math.exp(-t * this.zeta * this.w0) * (this.A * Math.cos(this.wd * t) + this.B * Math.sin(this.wd * t))
          : (this.A + this.B * t) * Math.exp(-t * this.w0))
      );
    }));
  const fo = {Basic: co, Opacity: uo, Translation: po, Scale: mo, Float: go},
    yo = (Ye.Coordinate, Ye.CoordinateRegion, Ye.CoordinateSpan, Ye.MapRect),
    vo = function (t, e) {
      const i = e.origin.x,
        n = e.origin.y,
        o = t.maxX(),
        s = t.maxY();
      return i >= t.origin.x && i <= o && n >= t.origin.y && n <= s && e.maxX() <= o && e.maxY() <= s;
    },
    wo = function (t) {
      if (0 === t.length) return new yo();
      if (1 === t.length) {
        const e = t[0].minX();
        return e >= 0 && e < 1 ? t[0] : new yo(o(e, 1), t[0].minY(), t[0].size.width, t[0].size.height);
      }
      const e = [[t[0].minX(), t[0].maxX()]];
      let i = t[0].minY(),
        n = t[0].maxY();
      for (let o = 1, s = t.length, a = 0; o < s; ++o) {
        const s = e[a],
          r = t[o];
        ((i = Math.min(i, r.minY())),
          (n = Math.max(n, r.maxY())),
          r.minX() <= s[1] ? (e[a] = [s[0], Math.max(s[1], r.maxX())]) : (e.push([r.minX(), r.maxX()]), ++a));
      }
      const s = e.length;
      if (1 === s) return new yo(e[0][0], i, Math.min(e[0][1] - e[0][0], 1), n - i);
      let a = 1 + e[0][0] - e[s - 1][1],
        r = e[0][0];
      for (let t = 1; t < s; ++t) {
        const i = e[t][0] - e[t - 1][1];
        i > a && ((a = i), (r = e[t][0]));
      }
      return new yo(o(r, 1), i, 1 - a, n - i);
    },
    bo = function (t, e) {
      return (
        t instanceof e ||
        (console.warn("[MapKit] Unexpected object instance. Did you forget to `new`?"),
        "function" == typeof console.trace && console.trace(),
        !1)
      );
    };
  function Co() {
    if (!bo(this, Co)) return;
    const t = arguments.length;
    if (1 === t && "object" == typeof arguments[0]) {
      ((this.top = 0), (this.right = 0), (this.bottom = 0), (this.left = 0));
      const t = arguments[0];
      Object.keys(t).forEach(function (e) {
        "top" === e || "right" === e || "bottom" === e || "left" === e
          ? (this[e] = t[e])
          : console.warn("[MapKit] Unknown property `" + e + "` for Padding constructor.");
      }, this);
    } else
      ((this.top = t > 0 ? arguments[0] : 0),
        (this.right = t > 1 ? arguments[1] : 0),
        (this.bottom = t > 2 ? arguments[2] : 0),
        (this.left = t > 3 ? arguments[3] : 0));
    (c(
      this.top,
      "number",
      "[MapKit] Expected a number for `top` in Padding constructor but got `" + this.top + "` instead."
    ),
      c(
        this.left,
        "number",
        "[MapKit] Expected a number for `left` in Padding constructor but got `" + this.left + "` instead."
      ),
      c(
        this.bottom,
        "number",
        "[MapKit] Expected a number for `bottom` in Padding constructor but got `" + this.bottom + "` instead."
      ),
      c(
        this.right,
        "number",
        "[MapKit] Expected a number for `right` in Padding constructor but got `" + this.right + "` instead."
      ));
  }
  ((Co.Zero = new Co()),
    (Co.prototype = {
      constructor: Co,
      toString: function () {
        return "Padding(" + [this.top, this.right, this.bottom, this.left].join(", ") + ")";
      },
      copy: function () {
        return new Co(this.top, this.right, this.bottom, this.left);
      },
      equals: function (t) {
        return this.top === t.top && this.right === t.right && this.bottom === t.bottom && this.left === t.left;
      }
    }));
  const ko = Co;
  function Mo(t, e) {
    ((this._delegate = e), (this._snapsToIntegralZoomLevels = t));
  }
  Mo.prototype = {
    constructor: Mo,
    _speed: 0.03,
    _startTime: 0,
    _shouldStop: !1,
    _animating: !1,
    start: function (t, e) {
      const i = Date.now();
      return (
        (this._gasPedalValue = 0),
        (this._startTime = i),
        this._shouldStop && this._cleanUp(),
        (this._shouldStop = !1),
        (this.zoomsIn = !!e),
        qn.supportsForceTouch && window.addEventListener("webkitmouseforcechanged", this),
        !this._animating &&
          ((this._animating = !0), (this._zoomLevel = t), (this._timeAtLastFrame = i), Qt.scheduleOnNextFrame(this), !0)
      );
    },
    stop: function () {
      ((this._shouldStop = !0),
        qn.supportsForceTouch && (window.removeEventListener("webkitmouseforcechanged", this), delete this._speed));
    },
    set snapsToIntegralZoomLevels(t) {
      this._snapsToIntegralZoomLevels = !!t;
    },
    performScheduledUpdate: function () {
      let t = !0;
      const e = Date.now(),
        i = e - this._timeAtLastFrame,
        n = this._speed * (this.zoomsIn ? 1 : -1);
      ((this._zoomLevel += (60 * i * s(1 + n)) / 1e3),
        (this._timeAtLastFrame = e),
        this._shouldStop &&
          e - this._startTime >= 250 &&
          (this._zoomLevelAtWhichToStop
            ? ((t =
                (this.zoomsIn && this._zoomLevel < this._zoomLevelAtWhichToStop) ||
                (!this.zoomsIn && this._zoomLevel > this._zoomLevelAtWhichToStop)),
              t || (this._zoomLevel = this._zoomLevelAtWhichToStop))
            : this._snapsToIntegralZoomLevels
              ? (this._zoomLevelAtWhichToStop = this.zoomsIn ? Math.ceil(this._zoomLevel) : Math.floor(this._zoomLevel))
              : (t = !1)),
        this._delegate && this._delegate.linearZoomControllerDidZoom(this._zoomLevel),
        t ? Qt.scheduleOnNextFrame(this) : this._cleanUp());
    },
    handleEvent: function (t) {
      this._handleForceChangedEvent(t);
    },
    _handleForceChangedEvent: function (t) {
      const e =
        a(t.webkitForce, MouseEvent.WEBKIT_FORCE_AT_MOUSE_DOWN, MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN) -
        MouseEvent.WEBKIT_FORCE_AT_MOUSE_DOWN;
      (Math.abs(e - this._gasPedalValue) > 0.01 && (this._gasPedalValue = e),
        (this._speed = 0.01 + this._gasPedalValue * (0.06 - 0.01)));
    },
    _cleanUp: function () {
      ((this._animating = !1),
        (this._shouldStop = !1),
        delete this._zoomLevelAtWhichToStop,
        this._delegate && this._delegate.linearZoomControllerDidStop());
    }
  };
  const So = Mo;
  class Lo extends On {
    constructor() {
      (super(),
        (this.numberOfTapsRequired = 1),
        (this.numberOfTouchesRequired = 1),
        (this.allowsRightMouseButton = !1),
        (this._taps = 0));
    }
    touchesBegan(t) {
      t.currentTarget === this.target &&
        (("button" in t && 2 === t.button && !this.allowsRightMouseButton) ||
          (super.touchesBegan(t),
          this.numberOfTouches === this.numberOfTouchesRequired
            ? (this._domEvents.push(t),
              (this._startPoint = super.locationInElement()),
              (this._startClientPoint = super.locationInClient()),
              this._rewindTimer(750))
            : this.enterFailedState()));
    }
    touchesMoved(t) {
      let e;
      switch ((this.preventDefault(t), this.currentMode)) {
        case On.Modes.Pointer:
          e = "touch" === t.pointerType ? 40 : 2;
          break;
        case On.Modes.Touch:
          e = 40;
          break;
        case On.Modes.Mouse:
          e = 2;
      }
      void 0 !== e &&
        (!this._startPoint || this._startPoint.distanceToPoint(super.locationInElement()) > e) &&
        this.enterFailedState();
    }
    touchesEnded(t) {
      (this._taps++,
        this._domEvents.push(t),
        this._taps === this.numberOfTapsRequired && (this.preventDefault(t), this.enterRecognizedState(), this.reset()),
        this._rewindTimer(350));
    }
    reset() {
      ((this._taps = 0), this._clearTimer(), (this._domEvents = []));
    }
    locationInElement(t) {
      const e = this._startPoint || new Mi();
      return t ? Pi(t, e) : e;
    }
    locationInClient() {
      return this._startClientPoint || new Mi();
    }
    _clearTimer() {
      (window.clearTimeout(this._timerId), delete this._timerId);
    }
    _rewindTimer(t) {
      (this._clearTimer(), (this._timerId = window.setTimeout(this._timerFired.bind(this), t)));
    }
    _timerFired() {
      this.enterFailedState();
    }
  }
  class Ao extends On {
    constructor() {
      (super(),
        (this.allowableMovement = 10),
        (this.minimumPressDuration = 500),
        (this.numberOfTouchesRequired = 1),
        (this.allowsRightMouseButton = !1),
        (this._startPoint = void 0));
    }
    touchesBegan(t) {
      t.currentTarget === this.target &&
        (("button" in t && 2 === t.button && !this.allowsRightMouseButton) ||
          (super.touchesBegan(t),
          this.numberOfTouches === this.numberOfTouchesRequired
            ? ((this._startPoint = this.locationInElement()),
              (this._timerId = window.setTimeout(this.enterRecognizedState.bind(this), this.minimumPressDuration)))
            : this.enterFailedState()));
    }
    touchesMoved(t) {
      (this.preventDefault(t),
        void 0 !== this._startPoint &&
          this._startPoint.distanceToPoint(this.locationInElement()) > this.allowableMovement &&
          this.enterFailedState());
    }
    touchesCancelled(t) {
      this.touchesEnded(t);
    }
    touchesEnded(t) {
      this.state === On.States.Recognized
        ? (this.preventDefault(t), this.numberOfTouches !== this.numberOfTouchesRequired && this.enterFailedState())
        : this.enterFailedState();
    }
    reset() {
      (window.clearTimeout(this._timerId), delete this._timerId);
    }
  }
  const Eo = class extends Ao {
      constructor() {
        (super(), (this.minimumPressDuration = 500));
      }
      touchesBegan(t) {
        ((/MSIE|Trident\//i.test(navigator.userAgent) || /Edge\//i.test(navigator.userAgent)) &&
          document.getSelection().removeAllRanges(),
          Ao.prototype.touchesBegan.call(this, t),
          this._domEvents.push(t),
          (this.translation = new Mi()),
          (this._translationOrigin = this._lastTouchLocation = this.locationInElement()));
      }
      enterRecognizedState() {
        Ao.prototype.enterBeganState.call(this);
      }
      touchesMoved(t) {
        this.preventDefault(t);
        const e = this.locationInElement();
        (this.state === Un.Possible
          ? Ao.prototype.touchesMoved.call(this, t)
          : (this.state !== Un.Began && this.state !== Un.Changed) ||
            ((this.translation.x += e.x - this._lastTouchLocation.x),
            (this.translation.y += e.y - this._lastTouchLocation.y),
            this.enterChangedState()),
          (this._lastTouchLocation = e));
      }
      touchesCanceled(t) {
        this.interruptGesture();
      }
      touchesEnded(t) {
        this.state === Un.Changed ? (this.preventDefault(t), this.enterEndedState()) : this.enterFailedState();
      }
      interruptGesture() {
        this.state === Un.Changed ? this.enterEndedState() : this.state === Un.Began && this.enterFailedState();
      }
      reset() {
        (Ao.prototype.reset.call(this),
          delete this._translationOrigin,
          delete this._lastTouchLocation,
          (this._domEvents = []));
      }
    },
    xo = "mk-disable-all-gestures",
    To = "mk-disable-pan-gestures",
    Io = "mk-disable-pinch-gestures",
    Ro = "mk-disable-zoom-gestures";
  function Oo(t, e) {
    ((this._target = t),
      (this._delegate = e),
      (this._touchCount = 0),
      (this.initialEventTargetForCurrentInteraction = null),
      (this._doubleTapWithOneFingerRecognizer = this._addGestureRecognizer(Lo)),
      (this._doubleTapWithOneFingerRecognizer.numberOfTouchesRequired = 1),
      (this._doubleTapWithOneFingerRecognizer.numberOfTapsRequired = 2),
      (this._singleTapWithOneFingerRecognizer = this._addGestureRecognizer(Lo)),
      (this._longPressAndPanRecognizer = this._addGestureRecognizer(Eo)),
      (this._longPressAndPanRecognizer.delegate = this),
      t.addEventListener(qn.startEventType, this),
      t.addEventListener("dragstart", this),
      this.updateGestureEnableState());
  }
  Oo.prototype = {
    constructor: Oo,
    handleEvent: function (t) {
      switch (t.type) {
        case "pointerdown":
          (this._installEndListeners(),
            this._touchCount++,
            (this.initialEventTargetForCurrentInteraction = this._delegate.getEventTargetFromSubShadowDOM(t)),
            this._suppressDefaultBehavior(t));
          break;
        case "pointerup":
        case "pointercancel":
          (this._touchCount--,
            0 === this._touchCount &&
              (this._removeEndListeners(),
              document.removeEventListener("selectstart", this, !0),
              (this.initialEventTargetForCurrentInteraction = null)));
          break;
        case "dragstart":
          this._delegate.elementShouldPreventDragstart(t.target) && t.preventDefault();
          break;
        case "mousedown":
          (this._installEndListeners(),
            (this.initialEventTargetForCurrentInteraction = this._delegate.getEventTargetFromSubShadowDOM(t)),
            this._suppressDefaultBehavior(t));
          break;
        case "mouseup":
          (this._removeEndListeners(),
            document.removeEventListener("selectstart", this, !0),
            (this.initialEventTargetForCurrentInteraction = null));
          break;
        case "touchstart":
          t.touches.length === t.changedTouches.length &&
            (this._installEndListeners(),
            (this.initialEventTargetForCurrentInteraction = this._delegate.getEventTargetFromSubShadowDOM(t)),
            this._delegate.elementWantsDefaultBrowserBehavior(
              this.initialEventTargetForCurrentInteraction,
              t,
              t.touches.length
            ) || t.preventDefault());
          break;
        case "touchend":
        case "touchcancel":
          0 === t.touches.length && (this._removeEndListeners(), (this.initialEventTargetForCurrentInteraction = null));
          break;
        case "statechange":
          this._handleStatechange(t);
          break;
        case "selectstart":
          t.preventDefault();
      }
    },
    _handleStatechange: function (t) {
      switch (t.target) {
        case this._doubleTapWithOneFingerRecognizer:
          this._handleDoubleTapWithOneFingerChange(t);
          break;
        case this._singleTapWithOneFingerRecognizer:
          this._handleSingleTapWithOneFingerChange(t);
          break;
        case this._longPressAndPanRecognizer:
          this._handleLongPressAndPanChange(t);
      }
    },
    gestureRecognizerShouldBegin: function (t) {
      return this._delegate.userDidLongPress(t);
    },
    updateGestureEnableState: function () {
      const t =
          (this._delegate.isScrollEnabled ? 1 : 0) |
          (this._delegate.isRotationEnabled ? 2 : 0) |
          (this._delegate.isZoomEnabled ? 4 : 0),
        e = [void 0, To, Io, xo, Ro, xo, Io, xo];
      (this._delegate.rootNode.classList.remove(xo),
        this._delegate.rootNode.classList.remove(To),
        this._delegate.rootNode.classList.remove(Io),
        this._delegate.rootNode.classList.remove(Ro),
        e[t] && this._delegate.rootNode.classList.add(e[t]));
    },
    mapWasDestroyed: function () {
      (this._removeEndListeners(),
        this._target.removeEventListener(qn.startEventType, this),
        this._target.removeEventListener("dragstart", this),
        this._doubleTapWithOneFingerRecognizer.removeEventListener("statechange", this),
        (this._doubleTapWithOneFingerRecognizer.enabled = !1),
        (this._doubleTapWithOneFingerRecognizer = null),
        this._singleTapWithOneFingerRecognizer.removeEventListener("statechange", this),
        (this._singleTapWithOneFingerRecognizer.enabled = !1),
        (this._singleTapWithOneFingerRecognizer = null),
        this._longPressAndPanRecognizer.removeEventListener("statechange", this),
        (this._longPressAndPanRecognizer.enabled = !1),
        (this._longPressAndPanRecognizer.delegate = null),
        (this._longPressAndPanRecognizer = null),
        window.clearTimeout(this._delayedSingleTapRecognizerTimeoutID),
        delete this.initialEventTargetForCurrentInteraction,
        delete this._target,
        delete this._delegate);
    },
    _addGestureRecognizer: function (t) {
      const e = new t();
      return ((e.target = this._target), e.addEventListener("statechange", this), e);
    },
    _handleDoubleTapWithOneFingerChange: function (t) {
      const e = t.target;
      e.state === Un.Recognized &&
        (this._delayedSingleTapRecognizerTimeoutID &&
          (this._delegate.userCanceledTap(),
          window.clearTimeout(this._delayedSingleTapRecognizerTimeoutID),
          delete this._delayedSingleTapRecognizerTimeoutID),
        (this._singleTapWithOneFingerRecognizer.enabled = !1),
        this._delegate.userDidDoubleTap(e));
    },
    _handleSingleTapWithOneFingerChange: function (t) {
      const e = t.target;
      if (this._singleTapWithOneFingerRecognizer.enabled && e.state === Un.Recognized) {
        this._delegate.userWillTap(e);
        const t = this._delegate.shouldDelaySingleTap() ? 350 : 0;
        this._delayedSingleTapRecognizerTimeoutID = window.setTimeout(() => {
          (delete this._delayedSingleTapRecognizerTimeoutID, this._delegate.userDidTap());
        }, t);
      }
    },
    _handleLongPressAndPanChange: function (t) {
      const e = t.target;
      switch (e.state) {
        case Un.Possible:
          this._delegate.userMayStartPanningAfterLongPress();
          break;
        case Un.Began:
          ((this._singleTapWithOneFingerRecognizer.enabled = !1),
            (this._doubleTapWithOneFingerRecognizer.enabled = !1),
            (this._doubleTapWithOneFingerRecognizer.enabled = !0));
          break;
        case Un.Changed:
          this._delegate.userDidPanAfterLongPress(e.translation);
          break;
        case Un.Ended:
        case Un.Failed:
          ((this._singleTapWithOneFingerRecognizer.enabled = !0),
            this._delegate.userDidStopPanningAfterLongPress(e.state !== Un.Failed));
      }
    },
    _stopDraggingAnnotation: function () {
      this._longPressAndPanRecognizer.interruptGesture();
    },
    _suppressDefaultBehavior: function (t) {
      this._delegate.elementWantsDefaultBrowserBehavior(
        this.initialEventTargetForCurrentInteraction,
        t,
        this._touchCount
      ) ||
        (("pointerType" in t && "mouse" !== t.pointerType) || !qn.insideIframe
          ? t.preventDefault()
          : (document.addEventListener("selectstart", this, !0), document.getSelection().removeAllRanges()));
    },
    _installEndListeners: function () {
      (window.addEventListener(qn.endEventType, this),
        qn.cancelEventType && window.addEventListener(qn.cancelEventType, this));
    },
    _removeEndListeners: function () {
      (window.removeEventListener(qn.endEventType, this),
        qn.cancelEventType && window.removeEventListener(qn.cancelEventType, this));
    }
  };
  const Po = Oo,
    Do = Math.log(10) / Math.log(2);
  function zo(t) {
    Jn.call(this, t);
  }
  function No(t, e, i, n, s, a) {
    ((i = o(i, e)), (n = o(n, e)), (s = Math.ceil(s)), (a = Math.ceil(a)));
    const r = Math.ceil(s / e),
      l = Math.ceil(a / e);
    for (let n = 0; n < r; ++n) t.fillRect(i + n * e, 0, 1, a);
    for (let i = 0; i < l; ++i) t.fillRect(0, n + i * e, s, 1);
  }
  function Fo(t) {
    return "rgb(" + t.join(",") + ")";
  }
  function Uo(t, e, i) {
    return Math.round(e * i + t * (1 - i));
  }
  zo.prototype = r(Jn, zo, {
    draw: function (t, e) {
      const i = this.node,
        n = i.zoom,
        s = 100 * Math.pow(2, n % Do),
        a = s / 10,
        r = Math.min(a, 100),
        l = a < 10 ? 0 : (r - 10) / 90,
        h = i.origin,
        c = Ye.pointsPerAxis(n),
        d = new Mi(-h.x * c, -h.y * c),
        u = o(d.x, s) - s,
        p = o(d.y, s) - s,
        m = this.node.theme;
      if (((t.fillStyle = Fo(m.fillColor)), t.fillRect(0, 0, i.size.width, i.size.height), i.initialRendering)) return;
      const g = 1 - Math.pow(1 - l, 2);
      (g > 0 &&
        ((t.fillStyle = Fo(
          (function (t, e, i) {
            return 0 === i ? t : 1 === i ? e : [Uo(t[0], e[0], i), Uo(t[1], e[1], i), Uo(t[2], e[2], i)];
          })(m.fillColor, m.lineColor, g)
        )),
        No(t, a, u, p, i.size.width, i.size.height)),
        (t.fillStyle = Fo(m.lineColor)),
        No(t, s, u, p, i.size.width, i.size.height));
    }
  });
  const Go = zo,
    Bo = {
      light: {fillColor: [248, 245, 236], lineColor: [149, 148, 144]},
      dark: {fillColor: [44, 45, 47], lineColor: [56, 64, 66]}
    };
  function Zo() {
    (Hi.call(this), (this._renderer = new Go(this)), (this._theme = Bo.light));
  }
  Zo.prototype = r(Hi, Zo, {
    initialRendering: !1,
    get size() {
      return this.parent.size;
    },
    get zoom() {
      return this.parent.zoomLevel;
    },
    get origin() {
      return this.parent.visibleMapRect.origin;
    },
    get theme() {
      return this._theme;
    },
    updateThemeFromTint: function (t) {
      const e = Bo[t];
      e !== this._theme && ((this._theme = e), (this.needsDisplay = !0));
    },
    stringInfo: function () {
      return "BackgroundGridNode" + (this.initialRendering ? "!" : "") + (this._theme === Bo.light ? "" : "<dark>");
    }
  });
  const Wo = Zo,
    Ko = Symbol();
  function Ho() {
    so.call(this);
  }
  ((Ho.prototype = r(so, Ho, {
    delegate: null,
    deactivate: function () {
      this._impl.deactivate();
    },
    destroy: function (t) {
      this._impl.destroy(t);
    },
    get element() {
      return this._impl.element;
    },
    get camera() {
      return this._impl.camera;
    },
    get minZoomLevel() {
      return this._impl.currentMinZoomLevel;
    },
    get maxZoomLevel() {
      return this._impl.currentMaxZoomLevel;
    },
    get usesInteractionCenter() {
      return this._impl.usesInteractionCenter;
    },
    set usesInteractionCenter(t) {
      this._impl.usesInteractionCenter = t;
    },
    get configuration() {
      return this._impl.configuration;
    },
    set configuration(t) {
      this._impl.configuration = t;
    },
    get tint() {
      return this._impl.tint;
    },
    get tileTint() {
      return this._impl.tileTint;
    },
    get emphasis() {
      return this._impl.emphasis;
    },
    get language() {
      return this._impl.language;
    },
    set language(t) {
      this._impl.language = t;
    },
    get allowWheelToZoom() {
      return this._impl.allowWheelToZoom;
    },
    set allowWheelToZoom(t) {
      this._impl.allowWheelToZoom = t;
    },
    get allowWheelToZoom2() {
      return this._impl.allowWheelToZoom2;
    },
    set allowWheelToZoom2(t) {
      this._impl.allowWheelToZoom2 = t;
    },
    get pointOfInterestFilter() {
      return this._impl.pointOfInterestFilter;
    },
    set pointOfInterestFilter(t) {
      this._impl.pointOfInterestFilter = t;
    },
    setPoiFiltered: function (t, e) {
      this._impl.setPoiFiltered && this._impl.setPoiFiltered(t, e);
    },
    get backgroundGridTheme() {
      return this._impl.backgroundGridTheme;
    },
    set backgroundGridTheme(t) {
      this._impl.backgroundGridTheme = t;
    },
    get size() {
      return this._impl.size;
    },
    set size(t) {
      this._impl.size = t;
    },
    get rotation() {
      return this._impl.rotation;
    },
    set rotation(t) {
      this._impl.rotation = t;
    },
    getRotation: function () {
      return this._impl.rotation;
    },
    get isRotationEnabled() {
      return this._impl.isRotationEnabled;
    },
    set isRotationEnabled(t) {
      this._impl.isRotationEnabled = t;
    },
    get isRotationLocked() {
      return this._impl.isRotationLocked;
    },
    get cameraIsPanning() {
      return this._impl.cameraIsPanning;
    },
    get pannable() {
      return this._impl.pannable;
    },
    set pannable(t) {
      this._impl.pannable = t;
    },
    get cameraIsZooming() {
      return this._impl.cameraIsZooming;
    },
    get zoomable() {
      return this._impl.zoomable;
    },
    set zoomable(t) {
      this._impl.zoomable = t;
    },
    get cameraIsRotating() {
      return this._impl.cameraIsRotating;
    },
    get cameraIsAnimating() {
      return !!this._impl.cameraAnimation;
    },
    get zoomLevel() {
      return this._impl.zoomLevel;
    },
    set zoomLevel(t) {
      this._impl.setZoomLevelAnimated(t);
    },
    set fontSizeRatio(t) {
      this._impl.fontSizeRatio = t;
    },
    setZoomLevelAnimated: function (t, e) {
      this._impl.setZoomLevelAnimated(t, e);
    },
    setCameraDistanceAnimated: function (t, e) {
      this._impl.setCameraDistanceAnimated(t, e);
    },
    getCurrentCameraDistance: function () {
      return this._impl.getCurrentCameraDistance();
    },
    get cameraZoomRange() {
      return this._impl.cameraZoomRange;
    },
    setCameraZoomRangeAnimated: function (t, e) {
      this._impl.setCameraZoomRangeAnimated(t, e);
    },
    setCameraZoomLevelLimitAnimated: function (t, e) {
      this._impl.setCameraZoomLevelLimitAnimated(t, e);
    },
    zoomLevelForCameraDistanceAtY: function (t, e) {
      return this._impl.zoomLevelForCameraDistanceAtY(t, e);
    },
    get visibleMapRect() {
      return this._impl.visibleMapRect;
    },
    set visibleMapRect(t) {
      this._impl.setVisibleMapRectAnimated(t);
    },
    setVisibleMapRectAnimated: function (t, e) {
      this._impl.setVisibleMapRectAnimated(t, e);
    },
    setCenterAnimated: function (t, e) {
      this._impl.setCenterAnimated(t, e);
    },
    setCameraBoundaryAnimated: function (t, e) {
      this._impl.setCameraBoundaryAnimated(t, e);
    },
    isMapPointWithinBounds: function (t) {
      return this._impl.isMapPointWithinBounds(t);
    },
    get showsDefaultTiles() {
      return this._impl.showsDefaultTiles;
    },
    set showsDefaultTiles(t) {
      this._impl.showsDefaultTiles = t;
    },
    get tileOverlays() {
      return this._impl.tileOverlays;
    },
    set tileOverlays(t) {
      this._impl.tileOverlays = t;
    },
    addTileOverlay: function (t) {
      return this._impl.addTileOverlay(t);
    },
    addTileOverlays: function (t) {
      return this._impl.addTileOverlays(t);
    },
    removeTileOverlay: function (t) {
      return this._impl.removeTileOverlay(t);
    },
    removeTileOverlays: function (t) {
      return this._impl.removeTileOverlays(t);
    },
    adjustMapItemPoint: function (t) {
      return this._impl.adjustMapItemPoint(t);
    },
    cameraWillStartZooming: function (t, e, i) {
      return this._impl.cameraWillStartZooming(t, e, i);
    },
    cameraDidStopZooming: function () {
      this._impl.cameraDidStopZooming();
    },
    get fullyRendered() {
      return this._impl.fullyRendered;
    },
    devicePixelRatioDidChange: function () {
      return this._impl.devicePixelRatioDidChange();
    },
    stringInfo: function () {
      return this._impl.stringInfo();
    },
    get snapsToIntegralZoomLevels() {
      return this._impl.snapsToIntegralZoomLevels;
    },
    set snapsToIntegralZoomLevels(t) {
      this._impl.snapsToIntegralZoomLevels = t;
    },
    migrateStateTo: function (t) {
      return this._impl.migrateStateTo(t);
    },
    needsReplacing: function (t) {
      return this._impl.needsReplacing(t);
    },
    createLabelRegion: function () {
      return this._impl.createLabelRegion();
    },
    updatedLabelRegion: function () {
      this._impl.updatedLabelRegion();
    },
    unregisterLabelRegion: function (t) {
      this._impl.unregisterLabelRegion(t);
    },
    setCameraAnimated: function (t, e, i) {
      this._impl.setCameraAnimated(t, e, i);
    },
    setTintAndEmphasis: function (t, e, i) {
      this._impl.setTintAndEmphasis(t, e, i);
    },
    compassRotationWillStart: function () {
      return this._impl.compassRotationWillStart();
    },
    compassRotationDidEnd: function () {
      this._impl.compassRotationDidEnd();
    },
    forceRerender() {},
    forceDraw() {},
    requireRender() {}
  })),
    Object.defineProperty(Ho.prototype, Ko, {
      get: function () {
        return this._impl[Ko];
      },
      set: function (t) {
        this._impl[Ko] = t;
      },
      configurable: !0
    }),
    M.EventTarget(Ho.prototype));
  const jo = Ho;
  function Vo(t, e, i, n) {
    ((this.center = t || new Ye.MapPoint(0.5, 0.5)),
      (this.zoom = e || 3),
      (this.viewportSize = i || new ki()),
      (this.rotation = n || 0));
  }
  Vo.prototype = {
    constructor: Vo,
    get zoom() {
      return this._zoom;
    },
    set zoom(t) {
      this._zoom !== t && ((this._zoom = t || 3), (this._pointsPerAxis = Ye.pointsPerAxis(this._zoom)));
    },
    get worldSize() {
      return this._pointsPerAxis;
    },
    get rotation() {
      return this._rotation;
    },
    set rotation(t) {
      const e = o(t, 360);
      this._rotation = e;
    },
    minX: function () {
      if (0 === this._pointsPerAxis) return 0;
      const t = this.viewportSize.width / this._pointsPerAxis;
      return this.center.x - t / 2;
    },
    minY: function () {
      if (0 === this._pointsPerAxis) return 0;
      const t = this.viewportSize.height / this._pointsPerAxis;
      return this.center.y - t / 2;
    },
    maxX: function () {
      if (0 === this._pointsPerAxis) return 0;
      const t = this.viewportSize.width / this._pointsPerAxis;
      return this.center.x + t / 2;
    },
    maxY: function () {
      if (0 === this._pointsPerAxis) return 0;
      const t = this.viewportSize.height / this._pointsPerAxis;
      return this.center.y + t / 2;
    },
    equals: function (t) {
      return (
        this.zoom === t.zoom &&
        this.center.equals(t.center) &&
        this.viewportSize.equals(t.viewportSize) &&
        this.rotation === t.rotation
      );
    },
    copy: function () {
      return new Vo(this.center, this.zoom, this.viewportSize, this.rotation);
    },
    toString: function () {
      return (
        "Camera(" +
        [
          "center: [" + this.center.x + ", " + this.center.y + "]",
          "zoom: " + this.zoom,
          "viewportSize: " + this.viewportSize.toString(),
          "rotation: " + this.rotation
        ].join(", ") +
        ")"
      );
    },
    toMapRect: function () {
      if (0 === this._pointsPerAxis) return new Ye.MapRect(this.center.x, this.center.y, 0, 0);
      const t = this.viewportSize.width / this._pointsPerAxis,
        e = this.viewportSize.height / this._pointsPerAxis,
        i = Object.create(Ye.MapPoint.prototype);
      ((i.x = this.center.x - t / 2), (i.y = this.center.y - e / 2));
      const n = Object.create(Ye.MapSize.prototype);
      ((n.width = t), (n.height = e));
      const o = Object.create(Ye.MapRect.prototype);
      return ((o.origin = i), (o.size = n), o);
    },
    toRenderingMapRect: function () {
      let t = [
        new Mi(this.minX(), this.minY()),
        new Mi(this.maxX(), this.minY()),
        new Mi(this.maxX(), this.maxY()),
        new Mi(this.minX(), this.maxY())
      ];
      if (0 !== this.rotation) {
        const e = new Li().rotate(this.rotation);
        t = t.map((t) => e.transformPoint(t));
      }
      let e = t[0].x,
        i = t[0].y,
        n = t[0].x,
        o = t[0].y;
      for (let s = 1; s < t.length; ++s) {
        const a = t[s];
        (a.x < e && (e = a.x), a.x > n && (n = a.x), a.y < i && (i = a.y), a.y > o && (o = a.y));
      }
      const s = n - e,
        a = o - i;
      return new Ye.MapRect(this.center.x - s / 2, this.center.y - a / 2, s, a);
    },
    translate: function (t) {
      if (0 === this._pointsPerAxis) return this.copy();
      0 !== this.rotation && (t = new Li().rotate(-this.rotation).transformPoint(t));
      const e = Math.round(t.x) / this._pointsPerAxis,
        i = Math.round(t.y) / this._pointsPerAxis,
        n = Object.create(Ye.MapPoint.prototype);
      ((n.x = o(this.center.x - e, 1)), (n.y = o(this.center.y - i, 1)));
      const s = Object.create(Vo.prototype);
      return (
        (s.center = n),
        (s._zoom = this._zoom),
        (s._pointsPerAxis = this._pointsPerAxis),
        (s.viewportSize = this.viewportSize),
        (s._rotation = this._rotation),
        s
      );
    },
    transformMapPoint: function (t) {
      const e = this.viewportSize.width,
        i = this.viewportSize.height,
        n = this._pointsPerAxis,
        o = new Li()
          .translate(-this.minX() * n, -this.minY() * n)
          .scale(n)
          .transformPoint(t);
      return new Li()
        .translate(e / 2, i / 2)
        .rotate(this.rotation)
        .translate(e / -2, i / -2)
        .transformPoint(o);
    },
    transformGestureCenter: function (t) {
      if (0 === this.rotation) return t;
      const e = this.viewportSize.width,
        i = this.viewportSize.height;
      return new Li()
        .translate(e / 2, i / 2)
        .rotate(-this.rotation)
        .translate(-e / 2, -i / 2)
        .transformPoint(t);
    },
    rotateAroundCenter: function (t, e) {
      const i = new Li()
        .translate(t.x, t.y)
        .rotate(-e)
        .translate(-t.x, -t.y)
        .transformPoint(new Mi(this.center.x, this.center.y));
      ((this.center = new Ye.MapPoint(i.x, i.y)), (this.rotation += e));
    },
    withNewMapRect: function (t, e, i) {
      i = i || this.viewportSize;
      const n = Ye.zoomLevelForMapRectInViewport(t, i, Ye.tileSize);
      return new Vo(new Ye.MapPoint(t.midX(), t.midY()), e ? Math.floor(n) : n, i, this.rotation);
    }
  };
  const qo = Vo;
  function Yo(t, e, i, n) {
    ((this.map = t),
      (this._startCamera = e),
      (this._endCamera = i),
      (this._duration = 250),
      (this._rotationCenter = n),
      t.snapsToIntegralZoomLevels && (i.zoom = Math.round(i.zoom)),
      this._updateAnimationRects(),
      (this._startTime = null),
      this._schedule());
  }
  Yo.prototype = {
    constructor: Yo,
    cancel: function () {
      this._canceled = !0;
    },
    get zooming() {
      return this._startCamera.zoom !== this._endCamera.zoom;
    },
    set additiveZoom(t) {
      ((this._zoomIsAdditive = !0), (this._endCamera.zoom = t), this._updateAnimationRects());
    },
    get zoomIsAdditive() {
      return this._zoomIsAdditive;
    },
    get rotating() {
      return this._startCamera.rotation !== this._endCamera.rotation;
    },
    adjustRotation: function (t, e) {
      (this._startCamera.rotateAroundCenter(t, e),
        this._endCamera.rotateAroundCenter(t, e),
        this._updateAnimationRects());
    },
    unconstrained: !1,
    updateViewportSize: function (t) {
      ((this._startCamera = new qo(this._startCamera.center, this._startCamera.zoom, t, this._startCamera.rotation)),
        (this._endCamera = new qo(this._endCamera.center, this._endCamera.zoom, t, this._endCamera.rotation)),
        this._updateAnimationRects());
    },
    performScheduledUpdate: function (t) {
      this._canceled ||
        (null == t
          ? this._animationDidProgress(1)
          : null == this._startTime
            ? ((this._startTime = t), this._schedule())
            : this._animationDidProgress(Math.min((t - this._startTime) / this._duration, 1)));
    },
    _zoomIsAdditive: !1,
    _updateAnimationRects: function () {
      if (
        ((this._rotationDelta = this._endCamera.rotation - this._startCamera.rotation),
        Math.abs(this._rotationDelta) > 180 &&
          (this._rotationDelta = this._endCamera.rotation + 360 - this._startCamera.rotation),
        this._rotationCenter)
      )
        return;
      ((this._startRect = this._startCamera.toMapRect()), (this._animatedEndRect = this._endCamera.toMapRect()));
      const t = this._startCamera.center.x - this._endCamera.center.x;
      Math.abs(t) > 0.5 && (t < 0 ? (this._startRect.origin.x += 1) : (this._animatedEndRect.origin.x += 1));
    },
    _schedule: function () {
      Qt.scheduleOnNextFrame(this);
    },
    _animationDidProgress: function (t) {
      if (1 === t)
        return (
          this.map.snapsToIntegralZoomLevels && (this._endCamera.zoom = Math.round(this._endCamera.zoom)),
          this.map.cameraAnimationDidProgress(this._endCamera),
          void this.map.cameraAnimationDidEnd()
        );
      (this._rotationCenter ? this._animateAroundCenter(t) : this._animateRects(t), this._schedule());
    },
    _animateAroundCenter: function (t) {
      const e = this._startCamera.copy();
      (e.rotateAroundCenter(this._rotationCenter, t * this._rotationDelta), this.map.cameraAnimationDidProgress(e));
    },
    _animateRects: function (t) {
      const e = this._startRect,
        i = this._animatedEndRect,
        n = e.origin.x,
        o = e.origin.y,
        s = e.size.width,
        a = e.size.height,
        r = i.origin.x - e.origin.x,
        l = i.origin.y - e.origin.y,
        h = i.size.width - e.size.width,
        c = i.size.height - e.size.height;
      let d = this._endCamera.rotation - this._startCamera.rotation;
      Math.abs(d) > 180 && (d = this._endCamera.rotation + 360 - this._startCamera.rotation);
      const u = new Ye.MapRect(n + r * t, o + l * t, s + h * t, a + c * t),
        p = this._startCamera.withNewMapRect(u);
      (this.map.cameraAnimationDidProgress(p, this.unconstrained),
        (this.map.rotation = this._startCamera.rotation + this._rotationDelta * t));
    }
  };
  const Xo = Yo;
  function $o(t, e) {
    ((this._map = t),
      (this._startEventType = Pn ? "pointerdown" : Dn ? "touchstart" : "mousedown"),
      this._map.element.addEventListener(this._startEventType, this));
  }
  $o.prototype = {
    constructor: $o,
    handleEvent: function (t) {
      ("mousedown" === t.type ||
        ("touchstart" === t.type && t.touches.length === t.changedTouches.length) ||
        ("pointerdown" === t.type && t.isPrimary)) &&
        this._map.interactionDidStart();
    },
    destroy: function () {
      this._map.element.removeEventListener(this._startEventType, this);
    }
  };
  const Jo = $o;
  class Qo extends On {
    constructor() {
      (super(),
        (this.scaleThreshold = 0),
        (this.useGestures = On.UseGesturesForPinch),
        (this._scaledMinimumAmount = !1),
        (this.scale = 1),
        (this._velocity = 0),
        (this._gestures = []),
        (this._startDistance = 0));
    }
    get velocity() {
      const t = this._gestures[this._gestures.length - 1];
      if (!t) return this._velocity;
      const e = performance.now() - (t.timeStamp + 100);
      if (e <= 0) return this._velocity;
      const i = Math.max((500 - e) / 500, 0);
      return this._velocity * i;
    }
    touchesBegan(t) {
      if (t.currentTarget === this.target) {
        if (this.useGestures) {
          if (2 !== this.numberOfTouches) return;
        } else {
          if (this.numberOfTouches > 2) return void this.enterFailedState();
          if (2 !== this.numberOfTouches) return;
          ((this._startDistance = this._distance()),
            this._recordGesture(t.timeStamp, 1),
            (this._scaledMinimumAmount = !1),
            this._updateStateWithEvent(t));
        }
        super.touchesBegan(t);
      }
    }
    touchesMoved(t) {
      this.useGestures || (2 === this.numberOfTouches && this._updateStateWithEvent(t));
    }
    touchesEnded(t) {
      this.useGestures ||
        this.numberOfTouches >= 2 ||
        !this._startDistance ||
        (this._scaledMinimumAmount ? this.enterEndedState() : this.enterFailedState());
    }
    gestureBegan(t) {
      (super.gestureBegan(t),
        this._recordGesture(t.timeStamp, t.scale),
        (this._scaledMinimumAmount = !1),
        this._updateStateWithEvent(t),
        this.preventDefault(t));
    }
    gestureChanged(t) {
      (this.preventDefault(t), this._updateStateWithEvent(t));
    }
    gestureEnded(t) {
      this._scaledMinimumAmount ? this.enterEndedState() : this.enterFailedState();
    }
    reset() {
      ((this.scale = 1), (this._velocity = 0), (this._gestures = []), (this._startDistance = 0));
    }
    _recordGesture(t, e) {
      const i = t,
        n = this._gestures.push({scale: e, timeStamp: i});
      if (n <= 2) return;
      const o = this._gestures[n - 1].scale >= this._gestures[n - 2].scale;
      let s;
      for (s = n - 3; s >= 0; --s) {
        const t = this._gestures[s];
        if (i - t.timeStamp > 100 || this._gestures[s + 1].scale >= t.scale !== o) break;
      }
      s > 0 && (this._gestures = this._gestures.slice(s + 1));
    }
    _updateStateWithEvent(t) {
      const e = this.useGestures ? t.scale : 0 !== this._startDistance ? this._distance() / this._startDistance : 1;
      if (!this._scaledMinimumAmount)
        return void (
          Math.abs(1 - e) >= this.scaleThreshold &&
          ((this._scaledMinimumAmount = !0), (this.scale = 1), this.enterBeganState())
        );
      this._recordGesture(t.timeStamp, e);
      const i = this._gestures[0],
        n = e - i.scale,
        o = t.timeStamp - i.timeStamp;
      ((this._velocity = 0 === o ? 0 : (n / o) * 1e3),
        (this.scale *= e / this._gestures[this._gestures.length - 2].scale),
        this.enterChangedState());
    }
  }
  function ts(t) {
    ((this._map = t), (this._recognizers = []));
  }
  ts.prototype = {
    constructor: ts,
    get map() {
      return this._map;
    },
    canTrustGestureCenter: function (t) {
      return 1 === t.numberOfTouchesRequired || !(qn.supportsGestureEvents && !qn.supportsTouches && qn.insideIframe);
    },
    addRecognizer: function (t) {
      return (
        this._recognizers.push(t),
        (t.target = this.map.node.element),
        t.addEventListener("statechange", this),
        t
      );
    },
    interrupt: function () {
      this._recognizers.forEach(function (t) {
        ((t.enabled = !1), (t.enabled = !0));
      });
    },
    centerForGesture: function (t) {
      const e = this.map;
      return e.usesInteractionCenter || !this.canTrustGestureCenter(t)
        ? e.interactionCenter
        : this._centerWithRecognizer(t);
    },
    destroy: function () {
      for (; this._recognizers.length; ) {
        const t = this._recognizers.pop();
        ((t.enabled = !1), (t.target = null), t.removeEventListener("statechange", this));
      }
    }
  };
  const es = ts,
    is = dt.performanceMarkers.interactions,
    ns = Math.pow(1e-4, 2.5);
  function os(t) {
    (es.call(this, t),
      (this._pinchRecognizer = this.addRecognizer(new Qo())),
      (this._pinchRecognizer.scaleThreshold = 0.1),
      (this._doubleTapWithOneFingerRecognizer = this.addRecognizer(new Lo())),
      (this._doubleTapWithOneFingerRecognizer.numberOfTouchesRequired = 1),
      (this._doubleTapWithOneFingerRecognizer.numberOfTapsRequired = 2),
      (this._singleTapWithTwoFingersRecognizer = this.addRecognizer(new Lo())),
      (this._singleTapWithTwoFingersRecognizer.numberOfTouchesRequired = 2),
      (this._singleTapWithTwoFingersRecognizer.numberOfTapsRequired = 1));
  }
  function ss(t) {
    return t.state === Un.Began || t.state === Un.Changed;
  }
  os.prototype = r(es, os, {
    decelerating: !1,
    stopDecelerating: function () {
      this.decelerating && this._decelerationEnded();
    },
    destroy: function () {
      (es.prototype.destroy.call(this),
        delete this._pinchRecognizer,
        delete this._doubleTapWithOneFingerRecognizer,
        delete this._singleTapWithTwoFingersRecognizer,
        this.stopDecelerating());
    },
    get active() {
      return (
        ss(this._pinchRecognizer) ||
        ss(this._doubleTapWithOneFingerRecognizer) ||
        ss(this._singleTapWithTwoFingersRecognizer)
      );
    },
    handleEvent: function (t) {
      const e = t.target;
      switch (e) {
        case this._pinchRecognizer:
          this._handlePinchChange(e);
          break;
        case this._doubleTapWithOneFingerRecognizer:
          this._handleDoubleTapWithOneFingerChange(e);
          break;
        case this._singleTapWithTwoFingersRecognizer:
          this._handleSingleTapWithTwoFingersChange(e);
      }
      is && performance.measure("mapkit-map-zoom-interaction", {start: e.lastEventTimeStamp, detail: e.state});
    },
    performScheduledUpdate: function (t) {
      const e = is ? performance.now() : void 0;
      if (!this.decelerating) return;
      if (null == t) return void this._decelerationEnded();
      const i = this.map,
        n = t - this._startTime;
      if (n >= this._decelerationDuration)
        return (
          i.scaleCameraAroundMapPoint(this._adjustedScaleAtDecelerationEnd / this._scale, this._lastScaleCenter),
          this._decelerationEnded(),
          void (is && performance.measure("mapkit-map-zoom-deceleration", {start: e}))
        );
      let o = this._scaleAtTime(n);
      const s = (o - this._initialScale) / (this._scaleAtDecelerationEnd - this._initialScale);
      ((o += this._scaleAdjustment * s), i.scaleCameraAroundMapPoint(o / this._scale, this._lastScaleCenter));
      const a = i.camera.zoom;
      (a === i.currentMinZoomLevel || a === this.currentMaxZoomLevel
        ? this.stopDecelerating()
        : ((this._scale = o), this._schedule()),
        is && performance.measure("mapkit-map-zoom-deceleration", {start: e}));
    },
    _centerWithRecognizer: function (t) {
      const e = this.map,
        i = t.locationInElement();
      let n = e.node.convertPointFromPage(i);
      n = e.camera.transformGestureCenter(n);
      const o = e.visibleMapRect,
        s = e.camera.viewportSize;
      return new Ye.MapPoint(o.minX() + (n.x / s.width) * o.size.width, o.minY() + (n.y / s.height) * o.size.height);
    },
    _handlePinchChange: function (t) {
      const e = this.map,
        i = e.camera,
        n = i.zoom;
      if (t.state === Un.Began)
        ((this._singleTapWithTwoFingersRecognizer.enabled = !1), e.cameraWillStartZooming("PINCH"));
      else if (t.state === Un.Ended || t.state === Un.Changed) {
        const i = t.scale;
        ((this._lastScaleCenter = this.centerForGesture(t)),
          ((i > 1 && n !== e.currentMaxZoomLevel) || (i < 1 && n !== e.currentMinZoomLevel)) &&
            (e.scaleCameraAroundMapPoint(i, this._lastScaleCenter), (t.scale = 1)));
      }
      if (
        (t.state === Un.Ended || t.state === Un.Failed) &&
        ((this._singleTapWithTwoFingersRecognizer.enabled = !0),
        this._startDeceleratingWithVelocity(t),
        !this.decelerating)
      ) {
        const t = e.snapsToIntegralZoomLevels ? Math.round(n) : n,
          o = a(t, e.currentMinZoomLevel, e.currentMaxZoomLevel);
        n === o
          ? e.cameraDidStopZooming()
          : this._lastScaleCenter
            ? e.scaleCameraAroundMapPoint(Math.pow(2, o - n), this._lastScaleCenter, !0)
            : e.setCameraAnimated(new qo(i.center, o, i.viewportSize, i.rotation), !0);
      }
    },
    _handleDoubleTapWithOneFingerChange: function (t) {
      t.state === Un.Recognized && this._zoomWithTapRecognizer(t, t.modifierKeys.alt);
    },
    _handleSingleTapWithTwoFingersChange: function (t) {
      t.state === Un.Recognized && this._zoomWithTapRecognizer(t, !0);
    },
    _zoomWithTapRecognizer: function (t, e) {
      const i = this.map,
        n = i.camera.zoom,
        o = e ? -1 : 1,
        s = (e ? Math.floor(n + 0.5) : Math.ceil(n - 0.5)) + o,
        r = n - a(s, i.currentMinZoomLevel, i.currentMaxZoomLevel);
      Math.abs(r) < 0.5 ||
        !i.cameraWillStartZooming("DOUBLE_TAP", !0, !0) ||
        (i.setCameraAnimated(
          i.camera.withNewMapRect(i.visibleMapRect.scale(Math.pow(2, r), this.centerForGesture(t))),
          !0
        ),
        is && performance.measure("mapkit-map-zoom-interaction", {start: t.lastEventTimeStamp, detail: t.state}));
    },
    _startDeceleratingWithVelocity: function (t) {
      let e = t.velocity;
      Math.abs(e) < 1 ||
        (8 < e && (e = 8),
        e < -8 && (e = -8),
        (this.decelerating = !0),
        (this._startTime = t.lastEventTimeStamp),
        (this._initialScale = this._scale = 1),
        (this._initialVelocity = e / 1e3),
        (this._decelerationFactor = 0.98875),
        (this._decelerationDuration =
          Math.log(ns / Math.pow(this._initialVelocity, 2)) / (2 * Math.log(this._decelerationFactor))),
        (this._scaleAtDecelerationEnd = this._scaleAtTime(this._decelerationDuration)),
        (this._adjustedScaleAtDecelerationEnd = this._adjustScaleAtDecelerationEnd(
          this._scaleAtDecelerationEnd / this._scale
        )),
        (this._scaleAdjustment = this._adjustedScaleAtDecelerationEnd - this._scaleAtDecelerationEnd),
        this._schedule());
    },
    _adjustScaleAtDecelerationEnd: function (t) {
      const e = this.map,
        i = e.camera.zoom;
      let n = i + s(t);
      if (e.snapsToIntegralZoomLevels) {
        let t = Math.round(n);
        (n > i && t <= i ? (t = Math.ceil(n)) : n < i && t >= i && (t = Math.floor(n)), (n = t));
      }
      const o = a(n, e.currentMinZoomLevel, e.currentMaxZoomLevel);
      return Math.pow(2, o - i);
    },
    _schedule: function () {
      Qt.scheduleOnNextFrame(this);
    },
    _scaleAtTime: function (t) {
      return Math.max(
        this._initialScale +
          (this._decelerationFactor * this._initialVelocity * (Math.pow(this._decelerationFactor, t) - 1)) /
            (this._decelerationFactor - 1),
        0
      );
    },
    _decelerationEnded: function () {
      this.decelerating = !1;
      const t = this.map;
      if (t.snapsToIntegralZoomLevels) {
        const e = t.camera,
          i = t.snapsToIntegralZoomLevels ? Math.round(e.zoom) : e.zoom;
        t.setCameraAnimated(new qo(e.center, i, e.viewportSize, e.rotation));
      }
      t.cameraDidStopZooming();
    }
  });
  const as = os;
  function rs() {
    return {start: new Mi(), end: new Mi(), dt: 0};
  }
  function ls(t) {
    return t.dt < 1 ? new Mi() : new Mi(((t.end.x - t.start.x) / t.dt) * 1e3, ((t.end.y - t.start.y) / t.dt) * 1e3);
  }
  class hs extends On {
    constructor() {
      (super(),
        (this.minimumNumberOfTouches = 1),
        (this.maximumNumberOfTouches = 1e5),
        (this.translationThreshold = 10),
        (this._traveledMinimumDistance = !1),
        (this._previousVelocitySample = rs()),
        (this._velocitySample = rs()),
        (this.translation = new Mi()));
    }
    get velocity() {
      if (void 0 === this._lastTouchTime) return new Mi();
      if (performance.now() - this._lastTouchTime > 100) return new Mi();
      const t = ls(this._velocitySample);
      if (On.SupportsTouches && this._previousVelocitySample.dt > 0) {
        const e = ls(this._previousVelocitySample);
        ((t.x = 0.25 * t.x + 0.75 * e.x), (t.y = 0.25 * t.y + 0.75 * e.y));
      }
      return t;
    }
    touchesBegan(t) {
      t.currentTarget === this.target &&
        ((t instanceof MouseEvent && 0 !== t.button) ||
          (super.touchesBegan(t),
          this._numberOfTouchesIsAllowed()
            ? ((this._lastTouchTime = t.timeStamp),
              this._resetTrackedLocations(),
              1 === this.numberOfTouches && (this._traveledMinimumDistance = !1))
            : this.enterFailedState()));
    }
    touchesMoved(t) {
      this.preventDefault(t);
      const e = t.timeStamp,
        i = this.locationInElement();
      if (void 0 === this._lastTouchTime || void 0 === this._lastTouchLocation || void 0 === this._translationOrigin)
        return;
      const n = e - this._lastTouchTime;
      (n > 8 &&
        ((this._previousVelocitySample.start = this._velocitySample.start.copy()),
        (this._previousVelocitySample.end = this._velocitySample.end.copy()),
        (this._previousVelocitySample.dt = this._velocitySample.dt),
        (this._velocitySample.start = this._lastTouchLocation.copy()),
        (this._velocitySample.end = i),
        (this._velocitySample.dt = n)),
        this._traveledMinimumDistance
          ? ((this.translation.x += i.x - this._lastTouchLocation.x),
            (this.translation.y += i.y - this._lastTouchLocation.y),
            this.enterChangedState())
          : this._canBeginWithTraveledDistance(
              new Mi(i.x - this._translationOrigin.x, i.y - this._translationOrigin.y)
            ) && ((this._traveledMinimumDistance = !0), this.enterBeganState()),
        (this._lastTouchTime = e),
        (this._lastTouchLocation = i));
    }
    touchesEnded(t) {
      this._numberOfTouchesIsAllowed()
        ? this._resetTrackedLocations()
        : this._traveledMinimumDistance
          ? this.enterEndedState()
          : this.enterFailedState();
    }
    reset() {
      ((this._velocitySample = rs()),
        (this._previousVelocitySample = rs()),
        (this.translation = new Mi()),
        (this._traveledMinimumDistance = !1));
    }
    _canBeginWithTraveledDistance(t) {
      return Math.abs(t.x) >= this.translationThreshold || Math.abs(t.y) >= this.translationThreshold;
    }
    _numberOfTouchesIsAllowed() {
      return this.numberOfTouches >= this.minimumNumberOfTouches && this.numberOfTouches <= this.maximumNumberOfTouches;
    }
    _resetTrackedLocations() {
      const t = this.locationInElement();
      ((this._lastTouchLocation = t), (this._translationOrigin = t));
    }
  }
  const cs = 1e8,
    ds = dt.performanceMarkers.interactions;
  function us(t) {
    (es.call(this, t), (this.addRecognizer(new hs()).maximumNumberOfTouches = 2));
  }
  us.prototype = r(es, us, {
    decelerating: !1,
    stopDecelerating: function () {
      this.decelerating && this._decelerationEnded();
    },
    destroy: function () {
      (es.prototype.destroy.call(this), this.stopDecelerating());
    },
    handleEvent: function (t) {
      const e = t.target,
        i = this.map;
      (i.usesInteractionCenter && i.cameraIsZooming) ||
        (e.state === Un.Began
          ? i.cameraWillStartPanning()
          : (e.state !== Un.Ended && e.state !== Un.Changed) ||
            (this._panMapCameraBy(e.translation), (e.translation = new Mi())),
        e.state === Un.Ended && (this._startDeceleratingWithVelocity(e), this.decelerating || i.cameraDidStopPanning()),
        ds && performance.measure("mapkit-map-pan-interaction", {start: e.lastEventTimeStamp, detail: e.state}));
    },
    performScheduledUpdate: function (t) {
      const e = ds ? performance.now() : void 0;
      if (!this.decelerating) return;
      if (null == t) return void this._decelerationEnded();
      const i = t - this._timeAtPreviousFrame;
      if (i > 300) return void this._decelerationEnded();
      const n = Math.exp(Math.log(0.995) * i),
        o = ((1 - n) / 0.0050000000000000044) * 0.995;
      if (
        (this._panMapCameraBy(new Mi((this._velocity.x / 1e3) * o, (this._velocity.y / 1e3) * o)),
        (this._velocity.x *= n),
        (this._velocity.y *= n),
        Math.abs(this._velocity.x) <= 10 && Math.abs(this._velocity.y) <= 10)
      )
        return (this._decelerationEnded(), void (ds && performance.measure("mapkit-map-pan-deceleration", {start: e})));
      ((this._timeAtPreviousFrame = t),
        this._schedule(),
        ds && performance.measure("mapkit-map-pan-deceleration", {start: e}));
    },
    _panMapCameraBy: function (t) {
      const e = this.map;
      e.setCameraAnimated(e.camera.translate(t));
    },
    _startDeceleratingWithVelocity: function (t) {
      const e = t.velocity;
      ((this._velocity = e), this.map.cameraWillStopPanning());
      const i = Math.pow(e.x, 2) + Math.pow(e.y, 2);
      if (!(i < 62500)) {
        if (i > cs) {
          const t = Math.sqrt(cs / i);
          this._velocity = {x: e.x * t, y: e.y * t};
        }
        ((this.decelerating = !0), (this._timeAtPreviousFrame = t.lastEventTimeStamp), this._schedule());
      }
    },
    _schedule: function () {
      Qt.scheduleOnNextFrame(this);
    },
    _decelerationEnded: function () {
      ((this.decelerating = !1), this.map.cameraDidStopPanning());
    }
  });
  const ps = us,
    ms = {
      getCorsAttribute: function (t) {
        return t ? "use-credentials" : "anonymous";
      }
    },
    gs = class extends H {
      constructor(t, e) {
        (super(t, e), (this._image = null), (this.crossOrigin = null));
      }
      get image() {
        return this._image;
      }
      get url() {
        return this._image?.src ?? null;
      }
      reuse(t, e) {
        this._init(t, e);
      }
      _loaderWillStart() {
        (super._loaderWillStart(), this._image || (this._image = document.createElement("img")));
        const t = this._getDelegate().urlForImageLoader;
        ((this._image.crossOrigin = this.crossOrigin),
          (this._image.src = t),
          this._image.addEventListener("load", this),
          this._image.addEventListener("error", this));
      }
      handleEvent(t) {
        switch (t.type) {
          case "error":
            this._loaderDidFail(this._image);
            break;
          case "load":
            this._loaderDidSucceed(null);
        }
      }
      _reset() {
        (this._image && (this._image.removeEventListener("load", this), this._image.removeEventListener("error", this)),
          super._reset());
      }
    },
    _s = {},
    fs = [];
  function ys(t, e, i, n, o, s, a, r, l, h, c) {
    ((this.x = t),
      (this.y = e),
      (this.z = i),
      (this.tileSource = n),
      (this.tint = o),
      (this.emphasis = s),
      (this.language = a),
      (this.poi = r ? 1 : 0),
      (this.labels = l ? 1 : 0),
      (this.resolution = h),
      (this._priority = c),
      (this._loader = vs(c, this)),
      this._setLoaderCrossOriginMode());
  }
  function vs(t, e) {
    let i;
    return (fs.length > 0 ? ((i = fs.shift()), i.reuse(t, e)) : (i = new gs(t, e)), i);
  }
  ys.prototype = {
    constructor: ys,
    get preferredOpacity() {
      return "number" == typeof this.tileSource.opacity ? this.tileSource.opacity : 1;
    },
    get loaderState() {
      return this._loader ? this._loader.state : K.Unscheduled;
    },
    schedule: function () {
      (this._loader || ((this._loader = vs(this._priority, this)), this._setLoaderCrossOriginMode()),
        this._loader.state > K.Unscheduled || this._loader.schedule());
    },
    unschedule: function () {
      this._loader && this._loader.unschedule() && (fs.push(this._loader), (this._loader = null));
    },
    whenDoneLoading: function (t) {
      this._doneLoadingCallback = t;
    },
    get urlForImageLoader() {
      const t = this.tileSource;
      if ("function" == typeof t.urlForImageLoader) return t.urlForImageLoader(this.x, this.y, this.z, this.resolution);
      const e = t.domains,
        i = t.proxyPrefixes,
        n = t.protocol,
        o = t.supportedResolutions[0],
        s = t.supportedResolutions[t.supportedResolutions.length - 1],
        r = a(this.resolution, o, s);
      let l = 1;
      if ("satellite" === t.name) {
        const e = t.supportedSizes.length - 1,
          i = t.supportedSizes[0],
          n = t.supportedSizes[e];
        l = a(this.resolution, i, n);
      }
      let h = m(t.path, {
        x: this.x,
        y: this.y,
        z: this.z,
        resolution: r,
        tileSizeIndex: l,
        lang: this.language,
        poi: this.poi
      });
      "satellite" !== t.name &&
        (0 === this.labels
          ? (h += "&labels=0&tint=" + this.tint + "&emphasis=" + this.emphasis)
          : (h += "&emphasis=" + this.emphasis + "&tint=" + this.tint));
      let c = _s[h];
      if (c) return c;
      const d = Math.floor(76731.36742 * (this.x + this.y)) % e.length;
      return ((c = n + "//" + e[d] + h), i && (c = i[d % i.length] + c), (_s[h] = c), c);
    },
    loaderDidSucceed: function (t) {
      this._loaderDidComplete();
    },
    loaderDidFail: function (t) {
      this._loaderDidComplete();
    },
    _setLoaderCrossOriginMode: function () {
      this.tileSource.crossOrigin && (this._loader.crossOrigin = ms.getCorsAttribute(this.tileSource.withCredentials));
    },
    _loaderDidComplete: function () {
      ((this.image = this._loader.image),
        "function" == typeof this._doneLoadingCallback &&
          (this._doneLoadingCallback(this), delete this._doneLoadingCallback));
    }
  };
  const ws = ys;
  function bs(t, e, i, n, o, s, a) {
    ((this.key = t),
      (this.x = e),
      (this.y = i),
      (this.z = n),
      (this.settings = o),
      (this.resolution = s),
      (this.priority = a),
      (this.tileImages = []));
  }
  ((bs.Events = {LoadSuccess: "tile-load-success", LoadFail: "tile-load-fail"}),
    (bs.prototype = r(M.EventTarget, bs, {
      loading: !1,
      loaded: !1,
      get tileSources() {
        return (this.settings.showsDefaultTiles ? this.settings.configuration.tileSources : [])
          .concat(
            this.settings.tileOverlays
              .map((t) => t._impl)
              .filter(function (t) {
                return !!t.urlForImageLoader(this.x, this.y, this.z, this.resolution);
              }, this)
          )
          .filter(function (t) {
            return (
              (this.z >= t.minZoomLevel || "number" != typeof t.minZoomLevel) &&
              (this.z <= t.maxZoomLevel || "number" != typeof t.maxZoomLevel)
            );
          }, this);
      },
      schedule: function () {
        this.loaded ||
          (this.tileImages.forEach((t) => {
            t.schedule();
          }),
          (this.loading = !0));
      },
      unschedule: function () {
        (this.tileImages.forEach((t) => {
          t.unschedule();
        }),
          (this.loading = !1));
      },
      _loadTileImages: function () {
        if (this.loading) return;
        if (this.loaded) {
          if (!this._containsCanceledTileImages()) return;
          ((this.tileImages = []), (this.loaded = !1));
        }
        this.loading = !0;
        const t = this.tileSources;
        0 !== t.length
          ? ((this._pendingTileImageLoads = t.length), t.forEach(this._loadTileImage, this))
          : this._allTileImagesDoneLoading();
      },
      _loadTileImage: function (t) {
        const e = this.settings,
          i = new ws(
            this.x,
            this.y,
            this.z,
            t,
            e.tint,
            e.emphasis,
            e.language,
            e.showsPOI,
            e.showsLabels,
            this.resolution,
            this.priority
          );
        (i.schedule(), this.tileImages.push(i), i.whenDoneLoading(() => this._tileImageDoneLoading(t, i)));
      },
      _requestTileImageLoadStatus: function (t, e) {
        const i = Z(e, t.image.src);
        (i.open("GET", t.image.src, !0), i.send());
      },
      _tileImageDoneLoading: function (t, e) {
        if (e._loader.state === K.Failed)
          if ("function" == typeof t.dispatchErrorForURL) t.dispatchErrorForURL(e._loader.url);
          else {
            const t = new M.Event(bs.Events.LoadFail);
            ((t.tileImage = e), this.dispatchEvent(t));
          }
        (this._pendingTileImageLoads--, 0 === this._pendingTileImageLoads && this._allTileImagesDoneLoading());
      },
      _allTileImagesDoneLoading: function () {
        (delete this._pendingTileImageLoads,
          (this.loading = !1),
          (this.loaded = !0),
          this._containsCanceledTileImages() || this.dispatchEvent(new M.Event(bs.Events.LoadSuccess)));
      },
      _containsCanceledTileImages: function () {
        return this.tileImages.some((t) => t.loaderState === K.Canceled);
      }
    })));
  const Cs = bs,
    ks = {};
  function Ms(t, e, i, n) {
    return (
      n.settings.configuration.provider +
      n.settings.configuration.countryCode +
      n.settings.configuration.name +
      t +
      "-" +
      e +
      "-" +
      i +
      n.settings.tint +
      n.settings.emphasis +
      n.settings.language +
      n.settings.showsPOI +
      n.settings.showsLabels +
      n.settings.showsDefaultTiles +
      n.settings.showsTileInfo +
      n.resolution +
      n.settings.tileOverlays.map((n) => n._impl.keyForTile(t, e, i)).join("-")
    );
  }
  function Ss(t) {
    const e = t.target;
    (e.removeEventListener(Cs.Events.LoadSuccess, Ss), e.removeEventListener(Cs.Events.LoadFail, Ls));
  }
  function Ls(t) {
    const e = t.target;
    (delete ks[e.key], e.removeEventListener(Cs.Events.LoadSuccess, Ss), e.removeEventListener(Cs.Events.LoadFail, Ls));
  }
  const As = function (t) {
      const e = t.range,
        i = e.min.z,
        n = Math.pow(2, i),
        s = e.min,
        a = e.denormalize().max,
        r = new Mi((s.x + a.x) / 2, (s.y + a.y) / 2),
        l = [],
        h = Math.min(a.x, s.x + n - 1);
      for (let t = s.x; t <= h; ++t) for (let e = s.y; e <= a.y; ++e) l.push(new Mi(t, e));
      return (
        l.sort(function (t, e) {
          const i = t.distanceToPoint(r) - e.distanceToPoint(r);
          return 0 === i ? (t.x - e.x == 0 ? t.y - e.y : t.x - e.x) : i;
        }),
        l.map(function (e) {
          return (function (t, e, i, n, o) {
            const s = Ms(t, e, i, n);
            let a = ks[s];
            return (
              a
                ? a.schedule()
                : ((a = new Cs(s, t, e, i, n.settings, n.resolution, o)),
                  a.addEventListener(Cs.Events.LoadSuccess, Ss),
                  a.addEventListener(Cs.Events.LoadFail, Ls),
                  (ks[s] = a),
                  (a._refCount = 0),
                  a._loadTileImages()),
              a._refCount++,
              a
            );
          })(o(e.x, n), e.y, i, t, I.High);
        })
      );
    },
    Es = function (t, e) {
      if ((t._refCount--, 0 === t._refCount)) {
        t.unschedule();
        const i = Ms(t.x, t.y, t.z, e);
        delete ks[i];
      }
    };
  function xs(t, e) {
    ((this.min = t), (this.max = e));
  }
  xs.prototype = {
    constructor: xs,
    denormalize: function () {
      const t = this.min.copy(),
        e = this.max.copy();
      return (e.x < t.x && (e.x += Math.pow(2, t.z)), new xs(t, e));
    },
    toString: function () {
      return this.min.toString() + " -> " + this.max.toString();
    },
    equals: function (t) {
      const e = this.denormalize(),
        i = t.denormalize();
      return (
        i.min.x === e.min.x &&
        i.min.y === e.min.y &&
        i.max.x === e.max.x &&
        i.max.y === e.max.y &&
        i.min.z === e.min.z &&
        i.max.z === e.max.z
      );
    }
  };
  const Ts = xs;
  function Is(t, e) {
    const i = qn.getIntegralZoom(t.zoom),
      n = Math.pow(2, i),
      o = Math.pow(2, t.zoom) * Ye.tileSize,
      s = t.viewportSize.width / o / 2,
      r = t.viewportSize.height / o / 2,
      l = new Ye.MapPoint(t.center.x - s, t.center.y - r),
      h = new Ye.MapPoint(t.center.x + s, t.center.y + r),
      c = n - 1,
      d = Math.floor(l.x * n),
      u = Math.floor(h.x * n),
      p = a(Math.floor(l.y * n), 0, c),
      m = a(Math.floor(h.y * n), 0, c);
    ((this.range = new Ts(new Mi(d, p, i), new Mi(u, m, i))),
      (this.settings = e),
      (this.resolution = qn.devicePixelRatio),
      (this.zoom = i),
      (this.mapRect = new Ye.MapRect(d / n, p / n, (u - d) / n, (m - p) / n)),
      this.mapRect.size.width < 0 && this.mapRect.size.width++);
  }
  Is.prototype = {
    constructor: Is,
    equals: function (t) {
      return this.sameSettings(t) && this.resolution === t.resolution && this.range.equals(t.range);
    },
    sameSettings: function (t) {
      const e = this.settings,
        i = t.settings;
      return (
        e.configuration === i.configuration &&
        e.tint === i.tint &&
        e.emphasis === i.emphasis &&
        e.showsPOI === i.showsPOI &&
        e.showsLabels === i.showsLabels &&
        e.language === i.language &&
        e.showsDefaultTiles === i.showsDefaultTiles &&
        e.showsTileInfo === i.showsTileInfo &&
        this.sameTileOverlays(t)
      );
    },
    sameTileOverlays: function (t) {
      return (
        this.settings.tileOverlays.length === t.settings.tileOverlays.length &&
        this.settings.tileOverlays.every(function (e, i) {
          return (e === t.settings.tileOverlays[i]) & !e._impl.stale;
        }, this)
      );
    },
    sharesTileSourcesWithTileData: function (t) {
      if (this.settings.tint !== t.settings.tint || this.settings.emphasis !== t.settings.emphasis) return !1;
      const e = this.settings.configuration.tileSources,
        i = t.settings.configuration.tileSources;
      return (
        !(
          "AutoNavi" !== this.settings.configuration.provider ||
          "AutoNavi" !== t.settings.configuration.provider ||
          1 !== e.length ||
          1 !== i.length ||
          ("satellite" !== e[0].name && "hybrid" !== e[0].name) ||
          ("satellite" !== i[0].name && "hybrid" !== i[0].name)
        ) || i.some((t) => -1 !== e.indexOf(t))
      );
    },
    load: function () {
      this._tiles || (this._tiles = As(this));
    },
    cancel: function () {
      if (!this._canceled && ((this._canceled = !0), this._tiles))
        for (let t = 0, e = this._tiles, i = e.length; t < i; ++t) e[t].unschedule();
    },
    releaseTiles: function () {
      if (this._tiles) for (let t = 0, e = this._tiles, i = e.length; t < i; ++t) Es(e[t], this);
    },
    get tiles() {
      return (this.load(), this._tiles);
    }
  };
  const Rs = Is,
    Os = ["minimumZ", "maximumZ", "opacity", "data"];
  function Ps(t, e, i) {
    ((this._public = t),
      (i = p(i)),
      Os.forEach(function (t) {
        void 0 !== i[t] && (this[t] = i[t]);
      }, this),
      Object.keys(i).forEach(function (t) {
        Os.indexOf(t) < 0 &&
          console.warn("[MapKit] Unknown option: " + t + ". Use the data property to store custom data.");
      }),
      (this.urlTemplate = e),
      void 0 === this.opacity && (this.opacity = 1),
      (this.stale = !1));
  }
  ((Ps.RELOAD_EVENT = "tile-overlay-reload"),
    (Ps.OPACITY_EVENT = "tile-overlay-opacity-changed"),
    (Ps.ERROR_EVENT = "tile-error"),
    (Ps.prototype = {
      constructor: Ps,
      _minimumZ: null,
      _maximumZ: null,
      get urlTemplate() {
        return this._urlTemplate;
      },
      set urlTemplate(t) {
        const e = typeof t;
        if ("function" !== e && "string" !== e)
          throw new TypeError(
            "[MapKit] TileOverlay.urlTemplate expected a function or a string, but got `" + t + "` instead."
          );
        this._urlTemplate = t;
      },
      keyForTile: function (t, e, i) {
        return this._minimumZ + "-" + this._maximumZ + "-" + this.urlForImageLoader(t, e, i, 1);
      },
      get minimumZ() {
        return this._minimumZ;
      },
      get minZoomLevel() {
        return this._minimumZ;
      },
      set minimumZ(t) {
        (c(t, "number", "[MapKit] TileOverlay.minimumZ expected a number, but got `" + t + "` instead."),
          (this._minimumZ = Math.floor(t)));
      },
      get maximumZ() {
        return this._maximumZ;
      },
      get maxZoomLevel() {
        return this._maximumZ;
      },
      set maximumZ(t) {
        (c(t, "number", "[MapKit] TileOverlay.maximumZ expected a number, but got `" + t + "` instead."),
          (this._maximumZ = Math.ceil(t)));
      },
      get opacity() {
        return this._opacity;
      },
      set opacity(t) {
        (c(t, "number", "[MapKit] TileOverlay.opacity expected a number, but got `" + t + "` instead."),
          (this._opacity = a(t, 0, 1)));
        const e = new pt.Event(Ps.OPACITY_EVENT);
        ((e.tileOverlay = this), (e.opacity = this._opacity), this._public.dispatchEvent(e));
      },
      get data() {
        return (Object.prototype.hasOwnProperty.call(this, "_data") || (this._data = {}), this._data);
      },
      set data(t) {
        (c(t, "object", "[MapKit] TileOverlay.data expected an Object, but got `" + t + "` instead."),
          (this._data = t));
      },
      reload: function () {
        this.stale = !0;
        const t = new pt.Event(Ps.RELOAD_EVENT);
        ((t.tileOverlay = this), this._public.dispatchEvent(t));
      },
      reloadComplete: function () {
        this.stale = !1;
      },
      urlForImageLoader: function (t, e, i, n) {
        if (!this._urlTemplate) return;
        if ("function" == typeof this._urlTemplate) return q(this._urlTemplate, null, [t, e, i, n, this._data]);
        const o = this._urlTemplate.replace(/\{/g, "{{").replace(/\}/g, "}}"),
          s = {};
        return (
          this._data &&
            Object.keys(this._data).forEach((t) => {
              s[t] = this._data[t];
            }),
          (s.x = t),
          (s.y = e),
          (s.z = i),
          (s.scale = n),
          m(o, s)
        );
      },
      withCredentials: !1,
      crossOrigin: !1,
      dispatchErrorForURL: function (t) {
        const e = new pt.Event(Ps.ERROR_EVENT);
        ((e.tileOverlay = this._public), (e.tileUrl = t), this._public.dispatchEvent(e));
      }
    }));
  const Ds = Ps;
  function zs(t, e) {
    bo(this, zs) && Object.defineProperty(this, "_impl", {value: new Ds(this, t, e)});
  }
  zs.prototype = r(pt.EventTarget, zs, {
    get urlTemplate() {
      return this._impl.urlTemplate;
    },
    set urlTemplate(t) {
      this._impl.urlTemplate = t;
    },
    get minimumZ() {
      return this._impl.minimumZ;
    },
    set minimumZ(t) {
      this._impl.minimumZ = t;
    },
    get maximumZ() {
      return this._impl.maximumZ;
    },
    set maximumZ(t) {
      this._impl.maximumZ = t;
    },
    get opacity() {
      return this._impl.opacity;
    },
    set opacity(t) {
      this._impl.opacity = t;
    },
    get data() {
      return this._impl.data;
    },
    set data(t) {
      this._impl.data = t;
    },
    reload: function () {
      this._impl.reload();
    }
  });
  const Ns = zs;
  function Fs(t, e) {
    switch (e) {
      case WheelEvent.DOM_DELTA_LINE:
        t *= (100 / 3) * window.devicePixelRatio;
        break;
      case WheelEvent.DOM_DELTA_PAGE:
        t *= 100 * window.devicePixelRatio;
    }
    return t;
  }
  const Us = (t, e) => {
      let i = t;
      for (; i.parentNode !== document.body; ) {
        ((i = i.parentNode), window.ShadowRoot && i instanceof window.ShadowRoot && (i = i.host));
        const t = window.getComputedStyle(i);
        switch (e) {
          case "x":
            if (["auto", "scroll"].includes(t.overflowX) && i.scrollWidth > i.clientWidth) return !0;
            break;
          case "y":
            if (["auto", "scroll"].includes(t.overflowY) && i.scrollHeight > i.clientHeight) return !0;
        }
        if ("fixed" === t.position) return !1;
      }
      switch (e) {
        case "x": {
          const t = window.getComputedStyle(document.body).overflowX,
            e = window.getComputedStyle(document.documentElement).overflowX;
          if (
            ["auto", "scroll", "visible"].includes(t) &&
            ["auto", "scroll", "visible"].includes(e) &&
            ("CSS1Compat" === document.compatMode
              ? document.documentElement.scrollWidth > document.documentElement.clientWidth
              : document.body.scrollWidth > document.body.clientWidth)
          )
            return !0;
          break;
        }
        case "y": {
          const t = window.getComputedStyle(document.body).overflowY,
            e = window.getComputedStyle(document.documentElement).overflowY;
          if (
            ["auto", "scroll", "visible"].includes(t) &&
            ["auto", "scroll", "visible"].includes(e) &&
            ("CSS1Compat" === document.compatMode
              ? document.documentElement.scrollHeight > document.documentElement.clientHeight
              : document.body.scrollHeight > document.body.clientHeight)
          )
            return !0;
          break;
        }
      }
      return !1;
    },
    Gs = dt.performanceMarkers.interactions,
    Bs = Math.log2(1.03) / (1e3 / 60),
    Zs = Math.log2(0.97) / (1e3 / 60),
    Ws = Math.log2(1.06) / (1e3 / 60),
    Ks = Math.log2(0.94) / (1e3 / 60),
    Hs = 100,
    js = Math.log2(1.0075),
    Vs = Math.log2(0.9925);
  function qs(t) {
    ((this.map = t),
      this.map.node.element.addEventListener("wheel", this),
      (this._previousZoomLevelDelta = []),
      (this._nextEventIsPan = !1),
      (this._nextEventIsZoom = !1),
      (this.pannable = !1),
      (this.zoomable = !1));
  }
  qs.prototype = {
    constructor: qs,
    _animating: !1,
    destroy: function () {
      (this.map.node.element.removeEventListener("wheel", this),
        clearTimeout(this._wheelEndTimeoutId),
        (this.map = null),
        this._animationEndingTimeoutId && clearTimeout(this._animationEndingTimeoutId));
    },
    handleEvent(t) {
      this._handleWheelZoom(t);
    },
    performScheduledUpdate: function (t) {
      if (!this.map) return;
      const e = this.zoomsIn
          ? Math.ceil(this._accumulatedDesiredZoomLevelDelta)
          : Math.floor(this._accumulatedDesiredZoomLevelDelta),
        i = t - this._timeAtLastFrame,
        n = this._getEstimatedSpeedPerMS() * i;
      if (
        ((this._accumulatedZoomLevelDelta += n),
        (this._timeAtLastFrame = t),
        !(
          (this.zoomsIn && this._accumulatedZoomLevelDelta < e) ||
          (!this.zoomsIn && this._accumulatedZoomLevelDelta > e)
        ))
      ) {
        const t = this.map.zoomLevel,
          e = Math.round(this.map.zoomLevel);
        return (
          this.map.scaleCameraAroundMapPoint(Math.pow(2, e - t), this._lastScaleCenter),
          (this._animating = !1),
          (this._previousEstimatedSpeedPerMS = void 0),
          void (this._animationEndingTimeoutId = setTimeout(() => {
            ((this._animationEndingTimeoutId = void 0), this.map.cameraDidStopZooming());
          }, Hs))
        );
      }
      (this.map.scaleCameraAroundMapPoint(Math.pow(2, n), this._lastScaleCenter), Qt.scheduleOnNextFrame(this));
    },
    _handleWheelZoom(t) {
      if (!this._nextEventIsPan && !this._nextEventIsZoom && !t.ctrlKey && !t.shiftKey && this.map.allowWheelToZoom2) {
        const e = this.map.node.element;
        if (t.deltaX && Us(e, "x")) return;
        if (t.deltaY && Us(e, "y")) return;
      }
      const e = (function (t) {
          return t.ctrlKey;
        })(t),
        i = this.map.allowWheelToZoom || this.map.allowWheelToZoom2;
      if (!e && !t.shiftKey && !i) return;
      const n = (function (t) {
          const e = t.shiftKey && !!t.deltaX && !t.deltaY;
          let i = e ? t.deltaX : t.deltaY;
          return (
            (i = Fs(i, t.deltaMode)),
            (t.ctrlKey || !t.shiftKey || e) && (i *= -1),
            t.ctrlKey && t.deltaMode === t.DOM_DELTA_PIXEL && (i *= 10),
            1 + 0.0075 * (i > 0 ? Math.sqrt(i) : -Math.sqrt(-i))
          );
        })(t),
        o = 3 * Math.abs(t.deltaX) > 2 * Math.abs(t.deltaY),
        s =
          this.map.allowWheelToZoom2 &&
          !this._nextEventIsZoom &&
          (this._nextEventIsPan || 1 === n || (!t.shiftKey && o));
      if (s && !this.pannable) return;
      if (!s && !this.zoomable) return;
      if (
        (s
          ? (clearTimeout(this._nextEventIsPanTimer),
            (this._nextEventIsPanTimer = setTimeout(() => {
              this._nextEventIsPan = !1;
            }, Hs)),
            (this._nextEventIsPan = !0))
          : (clearTimeout(this._nextEventIsZoomTimer),
            (this._nextEventIsZoomTimer = setTimeout(() => {
              this._nextEventIsZoom = !1;
            }, Hs)),
            (this._nextEventIsZoom = !0)),
        t.preventDefault(),
        s)
      )
        return void this.map.setCameraAnimated(this.map.camera.translate(new Mi(-Fs(t.deltaX), -Fs(t.deltaY))));
      const a = this.map;
      if ((n > 1 && a.camera.zoom === a.currentMaxZoomLevel) || (n < 1 && a.camera.zoom === a.currentMinZoomLevel))
        return;
      const r = new Mi(t.pageX, t.pageY);
      ((this._lastScaleCenter = a.usesInteractionCenter ? a.interactionCenter : this._mapPointFromCentroid(r)),
        a.snapsToIntegralZoomLevels
          ? this._integralZoomToScale(n, this._lastScaleCenter, t.timeStamp)
          : this._wheelZoomToScale(n),
        Gs && performance.measure("mapkit-map-zoom-interaction", {start: t.timeStamp, detail: "changed"}));
    },
    _mapPointFromCentroid(t) {
      const e = this.map;
      let i = e.node.convertPointFromPage(t);
      i = e.camera.transformGestureCenter(i);
      const n = e.visibleMapRect,
        o = e.camera.viewportSize;
      return new Ye.MapPoint(n.minX() + (i.x / o.width) * n.size.width, n.minY() + (i.y / o.height) * n.size.height);
    },
    _integralZoomToScale: function (t, e, i) {
      this._lastUpdateTime = i;
      const n = Math.log2(t);
      ((this.zoomsIn = n > 0),
        (this._lastScaleCenter = e),
        this._previousZoomLevelDelta.push({delta: n, timestamp: i}),
        this._animating
          ? (this._accumulatedDesiredZoomLevelDelta += n)
          : (this._cleanupPreviousZoomLevelDelta(),
            (Vs <= n && n <= js && this._previousZoomLevelDelta.length <= 1) ||
              ((this._animating = !0),
              (this._accumulatedZoomLevelDelta = 0),
              (this._accumulatedDesiredZoomLevelDelta = n),
              (this._timeAtLastFrame = i),
              this._animationEndingTimeoutId
                ? (clearTimeout(this._animationEndingTimeoutId), (this._animationEndingTimeoutId = void 0))
                : this.map.cameraWillStartZooming(rn),
              Qt.scheduleOnNextFrame(this))));
    },
    _cleanupPreviousZoomLevelDelta: function () {
      const t = performance.now() - 100,
        e = this.zoomsIn ? 1 : -1;
      for (let i = 0; i < this._previousZoomLevelDelta.length; i++)
        (this._previousZoomLevelDelta[i].timestamp < t || this._previousZoomLevelDelta[i].delta * e < 0) &&
          this._previousZoomLevelDelta.splice(i, 1);
    },
    _getEstimatedSpeedPerMS: function () {
      if ((this._cleanupPreviousZoomLevelDelta(), this._previousZoomLevelDelta.length <= 1))
        return this._previousEstimatedSpeedPerMS ? this._previousEstimatedSpeedPerMS : this.zoomsIn ? Ws : Ks;
      let t =
        this._previousZoomLevelDelta.reduce(function (t, e) {
          return t + e.delta;
        }, 0) / 100;
      return (Zs < t && t < Bs && (t = this.zoomsIn ? Bs : Zs), (this._previousEstimatedSpeedPerMS = t), t);
    },
    _wheelZoomToScale: function (t) {
      const e = this.map;
      (this._wheelZooming || (e.cameraWillStartZooming(rn), (this._wheelZooming = !0)),
        e.scaleCameraAroundMapPoint(t, this._lastScaleCenter),
        this._wheelEndTimeoutId && (clearTimeout(this._wheelEndTimeoutId), (this._wheelEndTimeoutId = null)),
        (this._wheelEndTimeoutId = setTimeout(() => {
          ((this._wheelEndTimeoutId = null), (this._wheelZooming = !1), e.cameraDidStopZooming());
        }, Hs)));
    }
  };
  const Ys = qs,
    Xs = 1 - Math.pow(2, -52),
    $s = Math.PI / 3,
    Js = Math.tan($s / 2);
  function Qs(t) {
    ((this.node = t),
      (this._configuration = null),
      (this._debug = !1),
      (this._language = null),
      (this.allowWheelToZoom = !1),
      (this.allowWheelToZoom2 = !1),
      (this._pointOfInterestFilter = null),
      (this._showsDefaultTiles = !0),
      (this._tileOverlays = []),
      (this._filteredPois = new Set()),
      (this._ = {}),
      (this._[Ko] = !1),
      (this.camera = new qo()),
      (this._element = document.createElement("div")),
      (this.currentMinZoomLevel = this.minZoomLevel),
      (this.currentMaxZoomLevel = this.maxZoomLevel));
  }
  ((Qs.prototype = {
    constructor: Qs,
    get element() {
      return this._element;
    },
    deactivate: function () {
      ((this.pannable = !1), (this.zoomable = !1), (this.node.delegate = null));
    },
    destroy: function (t) {
      (!t && this.cameraAnimation && this.cameraAnimation.cancel(),
        this._tileOverlays.forEach((t) => {
          t.removeEventListener(Ds.RELOAD_EVENT, this);
        }),
        this._initialInteractionController &&
          (this._initialInteractionController.destroy(), (this._initialInteractionController = null)),
        this._panController && (this._panController.destroy(), (this._panController = null)),
        this._wheelEventHandler && (this._wheelEventHandler.destroy(), delete this._wheelEventHandler),
        this._zoomController && (this._zoomController.destroy(), (this._zoomController = null)),
        this._rotationController && (this._rotationController.destroy(), (this._rotationController = null)),
        delete this.node.delegate);
    },
    minZoomLevel: -1 / 0,
    maxZoomLevel: 1 / 0,
    usesInteractionCenter: !1,
    cameraAnimation: null,
    isRotationEnabled: !1,
    isRotationLocked: !0,
    snapsToIntegralZoomLevels: !1,
    get configuration() {
      return this._configuration;
    },
    set configuration(t) {
      this._configuration !== t && this.updateConfiguration(t);
    },
    get tint() {
      return this._tint;
    },
    get tileTint() {
      return this._tileTint;
    },
    get emphasis() {
      return this._emphasis;
    },
    setTintAndEmphasis: function (t, e, i) {
      (t === this._tint && e === this._tileTint && i === this._emphasis) ||
        ((this._tint = t), (this._tileTint = e), (this._emphasis = i), this.updateTintAndEmphasis(t, e, i));
    },
    get language() {
      return this._language;
    },
    set language(t) {
      this._language !== t && ((this._language = t), this.refresh());
    },
    get pointOfInterestFilter() {
      return this._pointOfInterestFilter;
    },
    set pointOfInterestFilter(t) {
      this._pointOfInterestFilter !== t && ((this._pointOfInterestFilter = t), this.updatePointOfInterestFilter());
    },
    get size() {
      return this.camera.viewportSize.copy();
    },
    set size(t) {
      (this.adjustForSize(t.copy()), t.width > 0 && t.height > 0 && this._updateZoom(!1));
    },
    adjustForSize: function (t) {
      if (
        this._visibleMapRect &&
        this._visibleMapRect.size.width > 0 &&
        this._visibleMapRect.size.height > 0 &&
        t.width > 0 &&
        t.height > 0
      ) {
        const e = this._visibleMapRect;
        (delete this._visibleMapRect,
          this.setCameraAnimated(this.camera.withNewMapRect(e, this.snapsToIntegralZoomLevels, t)));
      } else {
        let e = null;
        Object.prototype.hasOwnProperty.call(this, "_pendingCameraDistance") && (e = this._pendingCameraDistance);
        const i = this.camera;
        (this.setCameraAnimated(new qo(i.center, i.zoom, t, i.rotation)),
          null !== e && this.setCameraDistanceAnimated(e, !1));
      }
    },
    get cameraIsPanning() {
      return !!this._panning;
    },
    get pannable() {
      return !!this._panController;
    },
    set pannable(t) {
      if (
        (!t && this._panController
          ? (this._panController.destroy(), delete this._panController)
          : t &&
            !this._panController &&
            (this._initialInteractionController || (this._initialInteractionController = new Jo(this)),
            (this._panController = new ps(this))),
        !t && !this.zoomable && this._wheelEventHandler)
      )
        return (this._wheelEventHandler.destroy(), void delete this._wheelEventHandler);
      (this._wheelEventHandler || (this._wheelEventHandler = new Ys(this)),
        (this._wheelEventHandler.zoomable = this.zoomable),
        (this._wheelEventHandler.pannable = t));
    },
    get cameraIsZooming() {
      return !!this._zooming || !!this._suspendedZoom;
    },
    get zoomable() {
      return !!this._zoomController;
    },
    set zoomable(t) {
      if (
        (!t && this._zoomController
          ? (this._zoomController.destroy(), delete this._zoomController)
          : t &&
            !this._zoomController &&
            (this._initialInteractionController || (this._initialInteractionController = new Jo(this)),
            (this._zoomController = new as(this))),
        !t && !this.pannable && this._wheelEventHandler)
      )
        return (this._wheelEventHandler.destroy(), void delete this._wheelEventHandler);
      (this._wheelEventHandler || (this._wheelEventHandler = new Ys(this)),
        (this._wheelEventHandler.zoomable = t),
        (this._wheelEventHandler.pannable = this.pannable));
    },
    get cameraIsRotating() {
      return !!this._rotating;
    },
    get visibleMapRect() {
      return this._visibleMapRect || this.camera.toMapRect();
    },
    set visibleMapRect(t) {
      this.setVisibleMapRectAnimated(t);
    },
    setVisibleMapRectAnimated: function (t, e) {
      if (this.camera.viewportSize.equals(ki.Zero)) this._visibleMapRect = t.copy();
      else {
        const i = this.camera.withNewMapRect(t, this.snapsToIntegralZoomLevels);
        ((i.rotation = 0), this.setCameraAnimated(i, !!e));
      }
    },
    setCenterAnimated: function (t, e) {
      const i = t.toMapPoint();
      if (this._visibleMapRect)
        this._visibleMapRect = new Ye.MapRect(
          i.x - this._visibleMapRect.size.width / 2,
          i.y - this._visibleMapRect.size.height / 2,
          this._visibleMapRect.size.width,
          this._visibleMapRect.size.height
        );
      else {
        const t = this.camera.copy();
        ((t.center = i), this.setCameraAnimated(t, e));
      }
    },
    setCameraBoundaryAnimated: function (t, e) {
      t
        ? ((this._cameraBeforeBoundaryChange = this.camera),
          (this._cameraBoundaryRect = new Ye.MapRect(
            t.origin.x,
            t.origin.y,
            a(t.size.width, 0, 1),
            Math.max(t.size.height, 0)
          )),
          this.setCameraAnimated(this.camera.copy(), e),
          delete this._cameraBeforeBoundaryChange)
        : delete this._cameraBoundaryRect;
    },
    constrainCamera: function (t) {
      (this._cameraBoundaryRect && (t.center = this._constrainCenterWithinBounds(t.center)),
        this._updateMinAndMaxZoomLevelsAtY(t.center.y),
        (t.zoom = a(t.zoom, this.currentMinZoomLevel, this.currentMaxZoomLevel)));
    },
    constrainCameraRotation: function (t) {
      const e = this.isRotationLocked;
      if (((this.isRotationLocked = t.zoom < 7), 0 !== t.rotation && this.isRotationLocked))
        return ((t.rotation = 0), !e && 0 !== this.camera.rotation);
    },
    get transformCenter() {
      const t = this.node.delegate;
      return t && "function" == typeof t.mapTransformCenter ? t.mapTransformCenter(this.node) : this.camera.center;
    },
    get interactionCenter() {
      const t = this.node.delegate;
      return t && "function" == typeof t.mapInteractionCenter ? t.mapInteractionCenter(this.node) : this.camera.center;
    },
    get zoomLevel() {
      return this.camera.zoom;
    },
    set zoomLevel(t) {
      this.setZoomLevelAnimated(t);
    },
    setZoomLevelAnimated: function (t, e) {
      if ((delete this._cameraDistance, this._suspendedZoom))
        return (
          (this._suspendedZoom.animated = this._suspendedZoom.animated || this._suspendedZoom.level !== t),
          void (this._suspendedZoom.level = t)
        );
      if (this.cameraAnimation && !e) return void (this.cameraAnimation.additiveZoom = t);
      const i = this.zoomLevel,
        n = a(t, this.currentMinZoomLevel, this.currentMaxZoomLevel);
      if (i === n) return;
      const o = this.interactionCenter,
        s = this.camera;
      o.equals(s.center)
        ? this.setCameraAnimated(new qo(s.center, n, s.viewportSize, s.rotation), e)
        : this.scaleCameraAroundMapPoint(Math.pow(2, n - i), this.interactionCenter, e);
    },
    setCameraDistanceAnimated: function (t, e) {
      if (0 === this.camera.viewportSize.width) return void (this._pendingCameraDistance = t);
      let i = this.zoomLevelForCameraDistanceAtY(t, this.camera.center.y);
      (this.snapsToIntegralZoomLevels && (i = qn.getIntegralZoom(i)),
        this.setZoomLevelAnimated(i, e),
        (this._cameraDistance = t));
    },
    getCurrentCameraDistance: function () {
      return (
        this.visibleMapRect.size.width /
        2 /
        Ye.mapUnitsPerMeterAtLatitude(this.camera.center.toCoordinate().latitude) /
        Js
      );
    },
    get cameraZoomRange() {
      return this._cameraZoomRange ? this._cameraZoomRange.copy() : new Ye.CameraZoomRange();
    },
    setCameraZoomRangeAnimated: function (t, e) {
      (t ? ((this._cameraZoomRange = t.copy()), delete this._cameraZoomLevelLimit) : delete this._cameraZoomRange,
        this._updateZoom(e));
    },
    setCameraZoomLevelLimitAnimated: function (t, e) {
      (t
        ? ((this._cameraZoomLevelLimit = {minZoomLevel: t.minZoomLevel, maxZoomLevel: t.maxZoomLevel}),
          delete this._cameraZoomRange)
        : delete this._cameraZoomLevelLimit,
        this._updateZoom(e));
    },
    zoomLevelForCameraDistanceAtY: function (t, e) {
      return this._zoomLevelForCameraDistanceAtLatitude(t, Ye.convertYToLatitude(e));
    },
    adjustMapItemPoint: function (t) {
      if (this.cameraIsZooming || this._pendingCameraDrawingReadiness) return t;
      if (!this._pointAdjustmentReference) {
        const t = this.camera.zoom,
          e = this.visibleMapRect.origin,
          i = new Rs(this.camera),
          n = i.zoom,
          o = i.mapRect.origin,
          s = Math.pow(2, t - n),
          a = Ye.pointsPerAxis(n) * s;
        this._pointAdjustmentReference = new Mi((o.x - e.x) * a, (o.y - e.y) * a);
      }
      return (
        (t.x =
          qn.roundToDevicePixel(this._pointAdjustmentReference.x) +
          qn.roundToDevicePixel(t.x - this._pointAdjustmentReference.x)),
        (t.y =
          qn.roundToDevicePixel(this._pointAdjustmentReference.y) +
          qn.roundToDevicePixel(t.y - this._pointAdjustmentReference.y)),
        t
      );
    },
    scaleCameraAroundMapPoint: function (t, e, i) {
      const n = Ye.pointsPerAxis(this.currentMinZoomLevel),
        o = this.camera.viewportSize,
        s = this.visibleMapRect.size,
        a = 1 / t,
        r = n > 0 ? o.width / (s.width * n) : a,
        l = n > 0 ? o.height / (s.height * n) : a,
        h = Math.min(a, r, l),
        c = e.x + (e.x < 1 ? 1 : -1),
        d = this.visibleMapRect;
      c >= d.origin.x && c <= d.maxX() && (e = new Ye.MapPoint(c, e.y));
      const u = this.camera.withNewMapRect(d.scale(h, e), !1);
      this.setCameraAnimated(u, i);
    },
    setCameraAnimated: function (t, e, i, n) {
      if (0 === t.viewportSize.width || 0 === t.viewportSize.height)
        return ((this._pendingCameraDrawingReadiness = !0), void (this.camera = t));
      delete this._pendingCameraDistance;
      const s = this.camera;
      (t.viewportSize.equals(s.viewportSize) ||
        (this._updateMinAndMaxZoomLevels(t.viewportSize),
        !e && this.cameraAnimation && this.cameraAnimation.updateViewportSize(t.viewportSize)),
        n || this.constrainCamera(t));
      const r = this.constrainCameraRotation(t),
        l = t.toMapRect().size,
        h = l.width / 2,
        c = l.height / 2;
      if (
        ((t.center.x = o(t.center.x - h, 1) + h),
        (t.center.y = a(t.center.y, c, Xs - c)),
        this._pendingCameraDrawingReadiness || !t.equals(s))
      )
        if (
          (delete this._pendingCameraDrawingReadiness, this._cameraWillChange(!!e), (!e && !r) || this.cameraAnimation)
        )
          (delete this._pointAdjustmentReference, (this.camera = t), this.cameraZoomWasSet(), this._cameraDidChange());
        else {
          let n;
          (e ? (n = this._cameraBeforeBoundaryChange || s) : ((n = t.copy()), (n.rotation = s.rotation)),
            this._cameraChangesMayHaveStarted(),
            (this.cameraAnimation = new Xo(this, n, t, i)),
            this._cameraBeforeBoundaryChange && (this.cameraAnimation.unconstrained = !0),
            this.cameraAnimation.rotating && (this._rotating = !0),
            this.cameraAnimation.zooming && this.cameraZoomWasSet(t));
        }
    },
    cameraWillStartZooming: function (t, e, i) {
      const n = this.node.delegate,
        o = () => !!n && "function" == typeof n.mapCanStartZooming && !n.mapCanStartZooming(this.node);
      return this.cameraAnimation
        ? !(
            this._zoomController.active ||
            this.cameraAnimation.zooming ||
            o() ||
            ((this._suspendedZoom = {animated: !!e, offCenter: !!i, level: this.zoomLevel, completed: !1}), 0)
          )
        : o()
          ? (this._zoomController.interrupt(), !1)
          : (this._cameraWillStartZooming(n, t, e, i), !0);
    },
    _cameraWillStartZooming: function (t, e, i, n) {
      (t && "function" == typeof t.mapWillStartZooming && t.mapWillStartZooming(this.node, e, i, n),
        this._cameraChangesMayHaveStarted(),
        (this._zooming = !0),
        this.beforeCameraZoomChange(!0),
        this._cameraWillChange(!!i));
    },
    cameraDidStopZooming: function () {
      if ((this.snapsToIntegralZoomLevels && (this.camera.zoom = Math.round(this.camera.zoom)), this._suspendedZoom))
        return void (this._suspendedZoom.complete = !0);
      (delete this._zooming,
        this.beforeCameraZoomChange(!1),
        this._cameraDidChange(),
        this._cameraChangesMayHaveEnded());
      const t = this.node.delegate;
      t && "function" == typeof t.mapDidStopZooming && t.mapDidStopZooming(this.node);
    },
    cameraWillStartRotating: function () {
      const t = this.node.delegate;
      (t && "function" == typeof t.mapCanStartRotating && !t.mapCanStartRotating(this.node)) ||
        (this._cameraChangesMayHaveStarted(), (this._rotating = !0), this._cameraWillChange());
    },
    cameraDidStopRotating: function () {
      if (!this._rotating) return;
      (delete this._rotating, this._cameraDidChange(), this._cameraChangesMayHaveEnded());
      const t = this.node.delegate;
      t && "function" == typeof t.mapDidStopRotating && t.mapDidStopRotating(this.node);
    },
    setPoiFiltered: function (t, e) {
      (e
        ? (this._filteredPois.has(t) &&
            console.warn(
              "[MapKit] Multiple annotations linked to a single place have been added to the map, display instability may occur."
            ),
          this._filteredPois.add(t))
        : this._filteredPois.delete(t),
        this.updatePointOfInterestFilter());
    },
    migrateStateTo: function (t) {
      ((t.configuration = this.node.configuration),
        t.setTintAndEmphasis(this.node.tint, this.node.tileTint, this.node.emphasis),
        (t.language = this.node.language),
        (t.pannable = this.node.pannable),
        (t.allowWheelToZoom = this.node.allowWheelToZoom),
        (t.allowWheelToZoom2 = this.node.allowWheelToZoom2),
        (t.pointOfInterestFilter = this.node._impl.pointOfInterestFilter),
        (t.showsDefaultTiles = this.node.showsDefaultTiles),
        (t.tileOverlays = this.node.tileOverlays),
        (t.size = this.node.size),
        (t.usesInteractionCenter = this.node.usesInteractionCenter));
      const e = this.node.visibleMapRect;
      (e.size.width > 0 && e.size.height > 0 && (t.visibleMapRect = e),
        (t.zoomable = this.node.zoomable),
        (t.isRotationEnabled = this.isRotationEnabled),
        (t.rotation = this.rotation),
        (t[Ko] = this[Ko]),
        this._cameraZoomRange && t.setCameraZoomRangeAnimated(this._cameraZoomRange, !1),
        this._cameraZoomLevelLimit && t.setCameraZoomLevelLimitAnimated(this._cameraZoomLevelLimit, !1),
        this._cameraDistance >= 0 && t.setCameraDistanceAnimated(this._cameraDistance, !1),
        this._cameraBoundaryRect && t.setCameraBoundaryAnimated(this._cameraBoundaryRect, !1),
        (t._impl._filteredPois = this._filteredPois),
        t._impl.updatePointOfInterestFilter(),
        (t._impl.debug = this.debug),
        (t._impl.isRotationLocked = this.isRotationLocked),
        this.cameraAnimation &&
          ((this.cameraAnimation.map = t._impl),
          (t._impl.cameraAnimation = this.cameraAnimation),
          this.cameraChangesHaveStarted && (t._impl.cameraChangesHaveStarted = !0)));
    },
    createLabelRegion: n,
    updatedLabelRegion: n,
    unregisterLabelRegion: n,
    get debug() {
      return this._debug;
    },
    set debug(t) {
      this._debug !== !!t && ((this._debug = !!t), this.refresh());
    },
    updateConfiguration: function (t) {
      ((this._configuration = t),
        this._updateMinAndMaxZoomLevels(this.camera.viewportSize),
        this.setCameraAnimated(this.camera),
        this.refresh());
    },
    updatePointOfInterestFilter: function () {
      this.refresh();
    },
    refresh: function () {},
    beforeCameraZoomChange: function () {},
    cameraZoomWasSet: function () {},
    prepareLayer: function (t) {},
    cleanupLayer: function (t) {},
    addLayer: function (t) {},
    insertBefore: function (t, e) {},
    insertAfter: function (t, e) {},
    removeLayer: function (t) {},
    get showsDefaultTiles() {
      return this._showsDefaultTiles;
    },
    set showsDefaultTiles(t) {
      this._showsDefaultTiles !== t && ((this._showsDefaultTiles = t), this._tileOverlaysDidChange());
    },
    get tileOverlays() {
      return this._tileOverlays;
    },
    set tileOverlays(t) {
      (0 === this._tileOverlays.length && 0 === t.length) ||
        (u(t, "[MapKit] Map.tileOverlays should be an array, got `" + t + "` instead."),
        t.forEach(function (t) {
          d(t, Ns, "[MapKit] Map.tileOverlays can only contain TileOverlays, but got `" + t + "` instead.");
        }),
        this._tileOverlays.forEach((t) => {
          t.removeEventListener(Ds.RELOAD_EVENT, this);
        }),
        (this._tileOverlays = t),
        this._tileOverlays.forEach((t) => {
          t.addEventListener(Ds.RELOAD_EVENT, this);
        }),
        this._tileOverlaysDidChange());
    },
    addTileOverlay: function (t) {
      return (
        d(t, Ns, "[MapKit] Map.addTileOverlay expected a TileOverlay, but got `" + t + "` instead."),
        this.addTileOverlays([t]),
        t
      );
    },
    addTileOverlays: function (t) {
      return (
        u(t, "[MapKit] Map.addTileOverlays expected an array, but got `" + t + "` instead."),
        t.forEach(function (t) {
          if (
            (d(t, Ns, "[MapKit] Map.addTileOverlays expected only TileOverlays, but got `" + t + "` instead."),
            "number" == typeof t.minimumZ && t.minimumZ < this.currentMinZoomLevel)
          ) {
            const e = Math.ceil(100 * this.currentMinZoomLevel) / 100;
            console.warn(
              "[MapKit] This TileOverlay has its minimumZ set to " +
                t.minimumZ +
                ", but this map can only zoom to a minimum value of " +
                e +
                ". As a result, some zoom levels supported by the TileOverlay cannot be viewed on this map."
            );
          }
        }, this),
        (this.tileOverlays = this.tileOverlays.concat(t)),
        t
      );
    },
    removeTileOverlay: function (t) {
      return (
        d(t, Ns, "[MapKit] Map.removeTileOverlay expected a TileOverlay, but got `" + t + "` instead."),
        (this.tileOverlays = this.tileOverlays.filter((e) => e !== t)),
        t
      );
    },
    removeTileOverlays: function (t) {
      return (
        u(t, "[MapKit] Map.removeTileOverlays expected an array, but got `" + t + "` instead."),
        t.forEach(function (t) {
          (d(t, Ns, "[MapKit] Map.removeTileOverlays expected only TileOverlays, but got `" + t + "` instead."),
            this.removeTileOverlay(t));
        }, this),
        t
      );
    },
    handleEvent: function () {},
    cameraWillStartPanning: function () {
      const t = this.node.delegate;
      this.cameraAnimation ||
      (() => !!t && "function" == typeof t.mapCanStartPanning && !t.mapCanStartPanning(this.node))()
        ? this._panController.interrupt()
        : (t && "function" == typeof t.mapWillStartPanning && t.mapWillStartPanning(this.node),
          this.refresh(),
          this._cameraChangesMayHaveStarted(),
          (this._panning = !0),
          this._cameraWillChange());
    },
    cameraWillStopPanning: function () {
      const t = this.node.delegate;
      t && "function" == typeof t.mapWillStopPanning && t.mapWillStopPanning(this.node);
    },
    cameraDidStopPanning: function () {
      (delete this._panning, this._cameraDidChange(), this._cameraChangesMayHaveEnded());
      const t = this.node.delegate;
      t && "function" == typeof t.mapDidStopPanning && t.mapDidStopPanning(this.node);
    },
    cameraAnimationDidProgress: function (t, e) {
      this.setCameraAnimated(t, !1, null, e);
    },
    cameraAnimationDidEnd: function () {
      const t = this.cameraAnimation;
      this.cameraAnimation = null;
      let e = !1;
      if (
        (t.zooming && !t.zoomIsAdditive && (this.cameraDidStopZooming(), (e = !0)),
        t.rotating && (this.cameraDidStopRotating(), (e = !0)),
        e || this._cameraDidChange(),
        this._cameraChangesMayHaveEnded(),
        this._suspendedZoom)
      ) {
        const t = this._suspendedZoom;
        (delete this._suspendedZoom,
          this._cameraWillStartZooming(this.node.delegate, "", t.animated),
          t.complete && (this.setZoomLevelAnimated(t.level, t.animated), t.animated || this.cameraDidStopZooming()));
      }
      this._nextCameraZoomRange &&
        (this.setCameraZoomRangeAnimated(this._nextCameraZoomRange, !1), delete this._nextCameraZoomRange);
    },
    interactionDidStart: function () {
      (this._panController && this._panController.stopDecelerating(),
        this._zoomController && this._zoomController.stopDecelerating(),
        this._rotationController && this._rotationController.stopDecelerating());
    },
    beganRecognizingRotation: function () {
      (this._zoomController && (this._zoomController._singleTapWithTwoFingersRecognizer.enabled = !1),
        this.isRotationLocked && ((this.restrictedCamera = this.camera.copy()), (this.restrictIncomingRotation = !0)));
    },
    finishedRecognizingRotation: function () {
      (this._zoomController && (this._zoomController._singleTapWithTwoFingersRecognizer.enabled = !0),
        this.resetRestrictedCamera());
    },
    compassRotationWillStart: function () {
      this.isRotationLocked && ((this.restrictedCamera = this.camera.copy()), (this.restrictIncomingRotation = !1));
    },
    compassRotationDidEnd: function () {
      this.resetRestrictedCamera();
    },
    resetRestrictedCamera: function () {
      this.restrictedCamera &&
        ((this.restrictedCamera.rotation = 0),
        this.setCameraAnimated(this.restrictedCamera, !0),
        delete this.restrictedCamera,
        delete this.restrictIncomingRotation);
    },
    tileGridDidFinishRendering: function () {
      const t = this.node.delegate;
      t && "function" == typeof t.mapDidFinishRendering && t.mapDidFinishRendering(this.node);
    },
    tileAccessForbidden: function () {
      const t = this.node.delegate;
      t && "function" == typeof t.tileAccessForbidden && t.tileAccessForbidden(this.node);
    },
    updateMinAndMaxZoomLevelsWhenConfigurationChanges: function () {
      ((this.minZoomLevel = 0),
        (this.maxZoomLevel = this.constructor.prototype.maxZoomLevel),
        this._configuration.tileSources.forEach(function (t) {
          ((this.minZoomLevel = Math.max(this.minZoomLevel, t.minZoomLevel)),
            (this.maxZoomLevel = Math.min(this.maxZoomLevel, t.maxZoomLevel)));
        }, this),
        this.minAndMaxZoomLevelsWereUpdated(),
        (this.currentMinZoomLevel = this.minZoomLevel),
        (this.currentMaxZoomLevel = this.maxZoomLevel));
    },
    minAndMaxZoomLevelsWereUpdated: function () {},
    _updateMinAndMaxZoomLevels: function (t) {
      if (t.width <= 0 || t.height <= 0) return !1;
      (this._configuration && this.updateMinAndMaxZoomLevelsWhenConfigurationChanges(),
        (this.minZoomLevel = Math.max(this.minZoomLevel, this.minZoomLevelForViewportSize(t, Ye.tileSize))),
        this.snapsToIntegralZoomLevels && (this.minZoomLevel = Math.ceil(this.minZoomLevel)),
        (this.currentMinZoomLevel = Math.max(this.currentMinZoomLevel, this.minZoomLevel)),
        this.adjustForSize(this.size));
    },
    _cameraChangesMayHaveStarted: function (t) {
      if (
        !(this.cameraChangesHaveStarted || this._panning || this._zooming || this._rotating || this.cameraAnimation)
      ) {
        this.cameraChangesHaveStarted = !0;
        const e = this.node.delegate;
        e && "function" == typeof e.mapCameraChangesWillStart && e.mapCameraChangesWillStart(this.node, t);
      }
    },
    _cameraWillChange: function (t) {
      (this._cameraChangesMayHaveStarted(t), (this._cameraWillChangeAnimated = !!t));
      const e = this.node.delegate;
      e && "function" == typeof e.mapCameraWillChange && e.mapCameraWillChange(this.node, !!t);
    },
    _cameraDidChange: function () {
      const t = this.node.delegate;
      (t &&
        "function" == typeof t.mapCameraDidChange &&
        t.mapCameraDidChange(this.node, !!this._cameraWillChangeAnimated),
        delete this._cameraWillChangeAnimated,
        this._cameraChangesMayHaveEnded());
    },
    _cameraChangesMayHaveEnded: function (t) {
      if (
        this.cameraChangesHaveStarted &&
        !this._panning &&
        !this._zooming &&
        !this._rotating &&
        !this.cameraAnimation
      ) {
        delete this.cameraChangesHaveStarted;
        const t = this.node.delegate;
        return (t && "function" == typeof t.mapCameraChangesDidEnd && t.mapCameraChangesDidEnd(this.node), !0);
      }
    },
    isMapPointWithinBounds: function (t) {
      if (!this._cameraBoundaryRect) return !0;
      const e = this._constrainCenterWithinBounds(t);
      return t.x === e.x && t.y === e.y;
    },
    _constrainCenterWithinBounds: function (t) {
      if (0 === this.camera.viewportSize.width || 0 === this.camera.viewportSize.height) return t;
      const e = this.camera.center,
        i = this.transformCenter,
        n = e.x - i.x,
        s = e.y - i.y,
        r = o(this._cameraBoundaryRect.origin.x + n, 1),
        l = r + this._cameraBoundaryRect.size.width;
      let h = o(t.x, 1);
      if ((h < r && (h += 1), h > l)) {
        let t = h - r;
        t > 0.5 && (t = 1 - t);
        let e = h - l;
        (e > 0.5 && (e = 1 - e), (h = t < e ? r : l));
      }
      const c = a(t.y, this._cameraBoundaryRect.minY() + s, this._cameraBoundaryRect.maxY() + s);
      return h !== t.x || c !== t.y ? new Ye.MapPoint(h, c) : t;
    },
    _updateMinAndMaxZoomLevelsAtY: function (t) {
      let e = this.minZoomLevel,
        i = this.maxZoomLevel;
      if (this._cameraZoomRange) {
        const n = Ye.convertYToLatitude(t);
        ((e = a(this._zoomLevelForCameraDistanceAtLatitude(this._cameraZoomRange.maxCameraDistance, n), e, i)),
          (i = a(this._zoomLevelForCameraDistanceAtLatitude(this._cameraZoomRange.minCameraDistance, n), e, i)),
          this.snapsToIntegralZoomLevels && ((e = Math.ceil(e)), (i = Math.floor(i))));
      } else
        this._cameraZoomLevelLimit &&
          ((e = a(this._cameraZoomLevelLimit.minZoomLevel, e, i)),
          (i = a(this._cameraZoomLevelLimit.maxZoomLevel, e, i)));
      ((this.currentMinZoomLevel = e), (this.currentMaxZoomLevel = i));
    },
    _updateZoom: function (t) {
      this._updateMinAndMaxZoomLevelsAtY(this.camera.center.y);
      const e = a(this.camera.zoom, this.currentMinZoomLevel, this.currentMaxZoomLevel);
      if (e !== this.camera.zoom)
        (t && ((this._nextCameraZoomRange = this._cameraZoomRange), delete this._cameraZoomRange),
          this.setZoomLevelAnimated(e, t));
      else {
        const t = this.node.delegate;
        t && "function" == typeof t.mapMinAndMaxZoomLevelsDidChange && t.mapMinAndMaxZoomLevelsDidChange(this.node);
      }
    },
    _zoomLevelForCameraDistanceAtLatitude: function (t, e) {
      return Ye.zoomLevelForCameraDistanceAtLatitudeAndViewportWidth(t, e, this.camera.viewportSize.width);
    }
  }),
    Object.defineProperty(Qs.prototype, Ko, {
      get: function () {
        return this._[Ko];
      },
      set: function (t) {
        this._[Ko] = t;
      },
      configurable: !0
    }));
  const ta = Qs;
  function ea(t) {
    Jn.call(this, t);
  }
  ea.prototype = r(Jn, ea, {
    draw: function (t) {
      const e = this._node.size.width,
        i = "standard" === this._node.tile.settings.configuration.name;
      ((t.fillStyle = i ? "rgba(0, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.75)"),
        t.fillRect(0, 0, e, 1),
        t.fillRect(0, 1, 1, e - 1));
      const n = ["x", "y", "z"].map((t) => t + " = " + this._node.tile[t]);
      ((t.font = "12px -apple-system-font"), t.beginPath(), t.moveTo(1, 1));
      let o = 1,
        s = 1;
      (n.forEach(function (e, i) {
        const n = t.measureText(e).width;
        ((o = 1 + n + 16), t.lineTo(o, s), (s += 20), 0 === i && (s += 8), t.lineTo(o, s));
      }),
        t.lineTo(1, s),
        t.closePath(),
        t.fill(),
        (t.fillStyle = i ? "white" : "black"),
        (t.textBaseline = "hanging"),
        n.forEach(function (i, n) {
          t.fillText(i, 9, 9 + 20 * n, e);
        }));
    }
  });
  const ia = ea;
  function na(t) {
    (Hi.call(this), (this._tile = t), (this._renderer = new ia(this)));
  }
  na.prototype = r(Hi, na, {
    get tile() {
      return this._tile;
    },
    stringInfo: function () {
      return "DebugNode<x:" + this.tile.x + ",y:" + this.tile.y + ",z:" + this.tile.z + ">";
    }
  });
  const oa = na;
  function sa(t) {
    (ho.call(this),
      (this._tileSource = t._public),
      this._tileSource &&
        "function" == typeof this._tileSource.addEventListener &&
        this._tileSource.addEventListener(Ds.OPACITY_EVENT, this));
  }
  sa.prototype = r(ho, sa, {
    handleEvent: function () {
      this._tileSource && (this.opacity = this._tileSource.opacity);
    },
    wasRemoved: function () {
      setTimeout(() => {
        (this.parent && this.parent.scene) ||
          (this._tileSource &&
            "function" == typeof this._tileSource.removeEventListener &&
            this._tileSource.removeEventListener(Ds.OPACITY_EVENT, this));
      }, 0);
    }
  });
  const aa = sa,
    ra = K,
    la = new Li(),
    ha = new ki(Ye.tileSize, Ye.tileSize);
  function ca(t) {
    (so.call(this), (this._scale = 1), (this._nodesByTileKey = {}), (this._fadingNodes = []), (this._debug = !!t));
  }
  function da(t) {
    const e = new aa(t.tileSource);
    return (
      (e.size = ha),
      t.loaderState === ra.Succeeded && ((e.image = t.image), (e.opacity = t.preferredOpacity)),
      e
    );
  }
  ca.prototype = r(so, ca, {
    stale: !1,
    fullyRendered: !1,
    _pendingTileCount: 0,
    _tileData: null,
    get locked() {
      return this.wantsLayerBacking;
    },
    set locked(t) {
      t !== this.wantsLayerBacking &&
        (t && this._fadingNodes.length > 0
          ? (this.wantsLayerBacking = !0)
          : !t && this._wantsLayerBacking
            ? (this.wantsLayerBacking = !1)
            : (this.frozen = t));
    },
    get tileData() {
      return this._tileData;
    },
    setTileDataAnimated: function (t, e) {
      ((this._fadingNodes = []), delete this._failedTileAndImage);
      const i = t.tiles,
        n = t.range.min,
        s = Math.pow(2, n.z);
      (this._tileData &&
        this._tileData.tiles.forEach(function (t) {
          if (
            (t.removeEventListener(Cs.Events.LoadSuccess, this),
            t.removeEventListener(Cs.Events.LoadFail, this),
            -1 === i.indexOf(t))
          ) {
            const e = t.key,
              i = this._nodesByTileKey[e];
            i && (i.remove(), delete this._nodesByTileKey[e]);
          }
        }, this),
        (this._tileData = t),
        (this.fullyRendered = !1),
        (this._pendingTileCount = i.length));
      const a = this.childCount,
        r = t.range.min.x,
        l = t.range.max.x - r === s,
        h = s * Ye.tileSize;
      i.forEach(function (t) {
        const i = new Mi(o(t.x - n.x, s) * Ye.tileSize, (t.y - n.y) * Ye.tileSize),
          c = this._ensureNodeForTile(t);
        ((c.position = i),
          (c.opacity = 0),
          l && t.x === r && (c.repeatOffset = h),
          this.addChild(c),
          t.loaded
            ? ((a > 0 || !e) && (c.opacity = 1), this._tileDidLoad(t))
            : (e || (c.opacity = 1),
              t.addEventListener(Cs.Events.LoadSuccess, this),
              t.addEventListener(Cs.Events.LoadFail, this)));
      }, this);
    },
    get pendingTileCount() {
      return this._pendingTileCount;
    },
    set scale(t) {
      t !== this._scale && ((this._scale = t), (this.transform = 1 === t ? la : new Li().scale(t)));
    },
    get debug() {
      return this._debug;
    },
    stringInfo: function () {
      return "TileGridNode" + (this.tileData ? "<range:(" + this.tileData.range.toString() + ")>" : "");
    },
    get cssBackgroundProperty() {
      if (!this.fullyRendered) return "";
      const t = this.position;
      return Array.prototype.concat
        .apply(
          [],
          this._tileData.tiles.map(function (e) {
            const i = this._nodesByTileKey[e.key];
            return e.tileImages.reduce(function (e, n, o) {
              return (
                "url(" +
                n.image.src +
                ") " +
                (t.x + i.position.x) +
                "px " +
                (t.y + i.position.y) +
                "px / " +
                Ye.tileSize +
                "px no-repeat" +
                (0 === o ? "" : ", ") +
                e
              );
            }, "");
          }, this)
        )
        .join(", ");
    },
    handleEvent: function (t) {
      const e = t.target;
      switch (t.type) {
        case Cs.Events.LoadSuccess:
          (e.removeEventListener(Cs.Events.LoadSuccess, this), this._tileDidLoad(e));
          break;
        case Cs.Events.LoadFail:
          this._tileLoadFail(e, t.tileImage);
      }
    },
    performScheduledUpdate: function () {
      (this._updateFadingNodes(),
        0 === this._pendingTileCount && 0 === this._fadingNodes.length && this._allTilesDidDraw());
    },
    _tileDidLoad: function (t) {
      (this._pendingTileCount--,
        0 === this._pendingTileCount &&
          this._failedTileAndImage &&
          (this._failedTileAndImage.tile._requestTileImageLoadStatus(this._failedTileAndImage.tileImage, (t) =>
            this._handleTileImageLoadStatus(t)
          ),
          delete this._failedTileAndImage));
      const e = this._nodesByTileKey[t.key];
      if (0 === e.childCount) {
        const i = t.tileImages;
        if (((e.children = i.map(da)), this.debug)) {
          const i = new oa(t);
          ((i.size = ha), e.addChild(i));
        }
      }
      e.opacity < 1
        ? (this._fadingNodes.push(e), Qt.scheduleASAP(this))
        : 0 === this._pendingTileCount && this._allTilesDidDraw();
    },
    _tileLoadFail: function (t, e) {
      this._failedTileAndImage = {tile: t, tileImage: e};
    },
    _handleTileImageLoadStatus: function (t) {
      403 === t.target.status && this.parent && this.parent.tileAccessForbidden(this);
    },
    _updateFadingNodes: function () {
      const t = Date.now();
      ((this._fadingNodes = this._fadingNodes.filter(function (e) {
        return (
          e._startTime ? (e.opacity = Math.min(1, (t - e._startTime) / 150)) : 0 === e.opacity && (e._startTime = t),
          1 !== e.opacity || (delete e._startTime, !1)
        );
      })),
        this._fadingNodes.length > 0
          ? Qt.scheduleOnNextFrame(this)
          : this._wantsLayerBacking && ((this.wantsLayerBacking = !1), (this.frozen = !0)));
    },
    _allTilesDidDraw: function () {
      ((this.fullyRendered = !0), this.parent && this.parent.tileGridDidFinishRendering(this));
    },
    _ensureNodeForTile: function (t) {
      const e = t.key;
      let i = this._nodesByTileKey[e];
      return (i ? delete i.repeatOffset : (i = this._nodesByTileKey[e] = new so()), i);
    }
  });
  const ua = ca;
  function pa(t) {
    (so.call(this), (this._map = t));
  }
  pa.prototype = r(so, pa, {
    fullyRendered: !1,
    scheduleRefresh: function () {
      (this.children.forEach((t) => {
        t.stale = !0;
      }),
        this.invalidate());
    },
    destroy: function () {
      this._releaseChildren(!0);
    },
    invalidate: function () {
      ((this.fullyRendered = !1), Qt.scheduleASAP(this));
    },
    stringInfo: function () {
      return "TileGridsGroupNode";
    },
    get cssBackgroundProperty() {
      return this.fullyRendered ? this.lastChild.cssBackgroundProperty : "";
    },
    handleEvent: function (t) {
      this.scheduleRefresh();
    },
    performScheduledUpdate: function () {
      if (!this._canDraw()) return;
      const t = this._map,
        e = t.camera,
        i = this.lastChild,
        n = !!i && i.debug !== this._map.debug,
        o = !!i && i.tileData.settings.showsDefaultTiles !== this._map.showsDefaultTiles;
      if (!this._tileDataAtZoomCompletion) {
        let s;
        if (Math.round(e.zoom) !== e.zoom && t.tileSettings.showsLabels) {
          if (!i) return;
          s = i.tileData;
        } else s = new Rs(e, t.tileSettings);
        if (i) {
          if ((i.stale || !i.locked) && (!s.equals(i.tileData) || n || o)) {
            const t = i.tileData;
            t.tiles.forEach(function (t) {
              s.tiles.indexOf(t) < 0 && t.unschedule();
            });
            const e = s.settings.configuration === t.settings.configuration,
              o = s.sameSettings(t) && s.resolution === t.resolution && !n;
            if (e ? !o : s.sharesTileSourcesWithTileData(t)) ((i.locked = !0), this._addNewTileGridAnimated(s, !0));
            else if (!i.locked) {
              const t = e && this._children.length > 1;
              (delete i.stale, i.setTileDataAnimated(s, t));
              const n = this._children[this._children.length - 2];
              n && !s.sharesTileSourcesWithTileData(n.tileData) && (this._releaseChildren(!1), (this._children = [i]));
            }
          }
        } else this._addNewTileGridAnimated(s, !1);
      }
      const s = e.zoom,
        a = t.visibleMapRect,
        r = a.origin,
        l = a.size,
        h = this.children,
        c = h.length;
      for (let t = 0; t < c; ++t) {
        const e = h[t],
          i = e.tileData,
          n = i.zoom,
          o = i.mapRect.origin,
          a = Math.pow(2, s - n),
          d = Math.pow(2, n) * (Ye.tileSize * a);
        let u = o.x - r.x;
        if (u > l.width) u--;
        else {
          const t = i.mapRect.size.width;
          t > 0 && u + t < 0 && u++;
        }
        ((e.scale = a),
          (e.position = new Mi(qn.roundToDevicePixel(u * d), qn.roundToDevicePixel((o.y - r.y) * d))),
          t < c - 1 && i.cancel());
      }
      this.fullyRendered = c > 0 && this.children[c - 1].fullyRendered;
    },
    cameraWillStartZooming: function (t) {
      if (!this._canDraw()) return;
      const e = this._map;
      (t && ((this._tileDataAtZoomCompletion = new Rs(t, e.tileSettings)), this._tileDataAtZoomCompletion.load()),
        this.children.forEach((t) => {
          t.locked = !0;
        }));
    },
    cameraDidStopZooming: function () {
      if (this._canDraw())
        if (this._tileDataAtZoomCompletion)
          (this._addNewTileGridAnimated(this._tileDataAtZoomCompletion, !0, !0), delete this._tileDataAtZoomCompletion);
        else {
          const t = this._map,
            e = this.lastChild;
          if (e && t.camera.zoom === e.tileData.zoom) e.locked = !1;
          else {
            const e = new Rs(t.camera, t.tileSettings);
            this._addNewTileGridAnimated(e, !0, !0);
          }
        }
    },
    tileGridDidFinishRendering: function (t) {
      const e = this.children,
        i = e.length,
        n = e[i - 1];
      if (n.fullyRendered && !n.locked) {
        for (let t = 0; t < i - 1; ++t) e[t].tileData.releaseTiles();
        (i > 1 && (this.children = [n]), (this.fullyRendered = !0), this._map.tileGridDidFinishRendering());
      }
    },
    tileAccessForbidden: function (t) {
      this._map.tileAccessForbidden();
    },
    _canDraw: function () {
      const t = this._map;
      return t && !!t.configuration && !!t.language;
    },
    _addNewTileGridAnimated: function (t, e, i) {
      const n = new ua(this._map.debug),
        o = this.lastChild;
      (o && !t.sharesTileSourcesWithTileData(o.tileData)
        ? (this._releaseChildren(!0), (this.children = [n]))
        : this.addChild(n),
        n.setTileDataAnimated(t, e),
        i && Qt.scheduleASAP(this));
    },
    _releaseChildren: function (t) {
      for (let e = this.childCount - (t ? 1 : 2); e >= 0; --e) {
        const t = this.children[e].tileData;
        (t.cancel(), t.releaseTiles());
      }
    }
  });
  const ma = pa;
  function ga(t) {
    (ta.call(this, t),
      (this._backgroundGrid = this.node.addChild(new Wo())),
      (this._tileGridsGroup = this.node.addChild(new ma(this))),
      (this._labels = !0),
      (this.rotation = 0),
      (this._backgroundGrid.initialRendering = !0),
      (this._tileGridsGroup.opacity = 0),
      setTimeout(() => {
        ((this._backgroundGrid.initialRendering = !1), (this._tileGridsGroup.opacity = 1));
      }, 0));
  }
  ga.prototype = r(ta, ga, {
    stringInfo: function () {
      return "MapNode<camera:" + this.camera.toString() + ">";
    },
    get tileSettings() {
      return {
        configuration: this._configuration,
        tint: this._tileTint,
        emphasis: this._emphasis,
        language: this._language,
        showsPOI: this._showsPOI(),
        showsLabels: this._labels,
        showsDefaultTiles: this._showsDefaultTiles,
        showsTileInfo: this._debug,
        tileOverlays: this._tileOverlays
      };
    },
    get fullyRendered() {
      return this._tileGridsGroup.fullyRendered;
    },
    get cssBackgroundProperty() {
      return this._tileGridsGroup.cssBackgroundProperty;
    },
    get labels() {
      return this._labels;
    },
    set labels(t) {
      ((this._labels = !!t), this.refresh());
    },
    destroy: function (t) {
      (ta.prototype.destroy.call(this, t), this._tileGridsGroup.destroy());
    },
    updateTintAndEmphasis: function (t, e, i) {
      (this._backgroundGrid.updateThemeFromTint(t), this.refresh());
    },
    refresh: function () {
      this._tileGridsGroup.scheduleRefresh();
    },
    cameraZoomWasSet: function (t) {
      t ? this._tileGridsGroup.cameraWillStartZooming(t) : this._tileGridsGroup.invalidate();
    },
    tileGridDidFinishRendering: function () {
      (this._tileOverlays.forEach((t) => {
        t._impl.reloadComplete();
      }),
        ta.prototype.tileGridDidFinishRendering.call(this));
    },
    handleEvent: function () {
      this._tileGridsGroup.scheduleRefresh();
    },
    beforeCameraZoomChange: function (t) {
      t ? this._tileGridsGroup.cameraWillStartZooming() : this._tileGridsGroup.cameraDidStopZooming();
    },
    devicePixelRatioDidChange: function () {
      return (this._tileGridsGroup.scheduleRefresh(), !0);
    },
    minZoomLevelForViewportSize: function (t, e) {
      const i = Math.max(t.width, t.height);
      return s(i / e);
    },
    minAndMaxZoomLevelsWereUpdated: function () {
      this.tileOverlays.forEach(function (t) {
        ("number" != typeof t.minimumZ ||
          isNaN(t.minimumZ) ||
          (this.minZoomLevel = Math.min(this.minZoomLevel, t.minimumZ)),
          "number" != typeof t.maximumZ ||
            isNaN(t.maximumZ) ||
            (this.maxZoomLevel = Math.max(this.maxZoomLevel, t.maximumZ)));
      }, this);
    },
    _tileOverlaysDidChange: function () {
      (this._updateMinAndMaxZoomLevels(this.camera.viewportSize), this._tileGridsGroup.scheduleRefresh());
    },
    _showsPOI: function () {
      return (
        (null == this._pointOfInterestFilter ||
          (null == this._pointOfInterestFilter._includes && 0 === this._pointOfInterestFilter._excludes.length)) &&
        this.labels
      );
    },
    needsReplacing: function (t) {
      return t;
    }
  });
  const _a = ga;
  function fa() {
    (jo.call(this), Object.defineProperty(this, "_impl", {value: new _a(this)}));
  }
  fa.prototype = r(jo, fa, {
    get cssBackgroundProperty() {
      return this._impl.cssBackgroundProperty;
    },
    get labels() {
      return this._impl.labels;
    },
    set labels(t) {
      this._impl.labels = t;
    },
    get pointOfInterestFilter() {
      return null === this._impl._pointOfInterestFilter
        ? null
        : null === this._impl._pointOfInterestFilter._includes &&
            0 === this._impl._pointOfInterestFilter._excludes.length
          ? this._impl._pointOfInterestFilter
          : yt.filterExcludingAllCategories;
    },
    set pointOfInterestFilter(t) {
      this._impl.pointOfInterestFilter = t;
    },
    get rotation() {
      return 0;
    },
    set rotation(t) {
      this._impl.rotation = t;
    },
    rotateCameraAroundMapPoint: function (t, e) {
      this._impl.rotation += e;
    }
  });
  const ya = fa;
  let va = 0;
  function wa() {
    throw new Error("[MapKit] The specified reference layer has not been added to the map.");
  }
  const ba = dt.performanceMarkers.rendering,
    Ca = dt.performanceMarkers["frame-updates"];
  function ka(t) {
    ((this.node = t),
      (this._id = va++),
      (this._state = 0),
      (this._unregisteredLabelRegions = []),
      (this._unregisteredLayers = []),
      (this._baseLoadedOnce = !1),
      (this._fullyLoadedOnce = !1),
      (this._fullyRenderedOnce = !1));
  }
  const Ma = "mapkit-re-bootstrap-notification",
    Sa = "mapkit-csr-fallback-notification",
    La = "mapkit-zoom-support-notification";
  ((ka.prototype = {
    constructor: ka,
    init: function (t, e, i, n, o, s, a) {
      ((this._state = 1),
        (this.SyrupRenderer = e),
        (this.Camera = i),
        (this.Camera.hasRotationLock = !0),
        (this._initialDisplayOptions = o),
        (this._initialPoiFilter = s),
        this.initRenderer(e, t, n)
          .then(() => this.syrupInitHandler(a))
          .catch((t) => this.syrupInitErrorHandler(a, t)));
    },
    initRenderer: function (t, e, i) {
      const n = (this._syrupRenderer = new t(i));
      return (
        n.on(
          "invalid-access-key",
          function () {
            e.accessKeyHasExpired();
          },
          Ma
        ),
        n.on(
          "fallback",
          function () {
            e.syrupRequestedFallback("RENDERER_ERROR");
          },
          Sa
        ),
        n.on("zoom-support-did-change", () => this.node.didReconfigure(), La),
        n.init(e)
      );
    },
    syrupInitErrorHandler: function (t, e) {
      if (4 === this._state) return ((this._state = 0), void this.destroy());
      ((this._state = 0), t(e || new Error()));
    },
    syrupInitHandler: function (t) {
      if (4 === this._state) return ((this._state = 3), void this.destroy());
      this._state = 2;
      const e = this._syrupRenderer.DrawPasses;
      e && (this._drawPasses = [e.BaseMap, e.Roads, e.Borders, e.Buildings, e.Icons, e.Labels]);
      const i = this._syrupRenderer;
      (i.setDeterministicCollisions(!0),
        i.setLanguage(this.node.language),
        i.setDeterministicCollisions(!1),
        i.setPixelRatio(qn.devicePixelRatio),
        (this._canvas = i.element()),
        this.updateConfiguration(this.node.configuration, this._initialDisplayOptions),
        (this._initialDisplayOptions = null),
        this._initialPoiFilter &&
          (this.updatePointOfInterestFilter(this._initialPoiFilter), (this._initialPoiFilter = null)),
        this.performScheduledDraw(),
        this[Ko] && this[Ko](this.node[Ko]),
        this._unregisteredLabelRegions.forEach((t) => {
          i.registerLabelRegion(t);
        }),
        delete this._unregisteredLabelRegions);
      const n = this._unregisteredLayers;
      (delete this._unregisteredLayers,
        n.forEach(function (t) {
          (this.prepareLayer(t), (t._impl.syrupToken = i.addLayer(t._impl.syrupLayer)));
        }, this),
        t());
    },
    deactivate: function () {
      1 !== this._state ? 4 !== this._state && (this._state = 3) : (this._state = 4);
    },
    destroy: function () {
      1 !== this._state
        ? 4 !== this._state &&
          5 !== this._state &&
          ((this._state = 5),
          this._syrupRenderer &&
            (this._syrupRenderer.off("invalid-access-key", null, Ma),
            this._syrupRenderer.off("fallback", null, Sa),
            this._syrupRenderer.off("zoom-support-did-change", null, La),
            "function" == typeof this._syrupRenderer.destroy && this._syrupRenderer.destroy(),
            (this._syrupRenderer = null)))
        : (this._state = 4);
    },
    get snapsToIntegralZoomLevels() {
      return !!this._syrupRenderer && !this._syrupRenderer.supportsNonIntegralZoomLevels();
    },
    getMapFeatureRegions: function () {
      return this._syrupRenderer && this._syrupRenderer.getMapFeatureRegions
        ? this._syrupRenderer.getMapFeatureRegions()
        : [];
    },
    performScheduledDraw: function (t) {
      if (2 !== this._state && 3 !== this._state) return;
      const e = [this.node.size.width, this.node.size.height];
      if (0 === e[0] || 0 === e[1]) return;
      this.node.delegate &&
        this.node.delegate.mapCustomCanvasWillRender &&
        this.node.delegate.mapCustomCanvasWillRender(this.node);
      const i = new this.Camera(e[0] / e[1]),
        n = this.node.zoomLevel,
        o = [this.node.camera.center.x, 1 - this.node.camera.center.y, 0];
      (i.setTarget(o), i.setZoomLevel(n), i.setRotation(this.node.camera.rotation * Aa * -1));
      const s = Ca ? performance.now() : void 0;
      let a;
      this._syrupRenderer.update(i, e, void 0, void 0, t);
      const r = this.SyrupRenderer.StatusType;
      if (
        (Ca &&
          ((a = this._syrupRenderer.status()),
          performance.measure("mapkit-syrup-update-frame", {
            start: s,
            detail: {syrupStatus: a, timestamp: t, baseLoaded: a >= r.BASE_LOADED, fullyLoaded: a >= r.FULLY_LOADED}
          })),
        5 !== this._state)
      ) {
        for (const t of ka.PostUpdateHandlers) t.call(this);
        (ba &&
          !this._fullyRenderedOnce &&
          this._syrupRenderer.status &&
          (a || (a = this._syrupRenderer.status()),
          !this._baseLoadedOnce &&
            a >= r.BASE_LOADED &&
            ((this._baseLoadedOnce = !0), performance.measure("mapkit-map-land-cover-rendered", "mapkit-map-start")),
          !this._fullyLoadedOnce &&
            a >= r.FULLY_LOADED &&
            ((this._fullyLoadedOnce = !0), performance.measure("mapkit-map-base-map-loaded", "mapkit-map-start")),
          !this._fullyRenderedOnce &&
            a >= r.FULLY_RENDERED &&
            ((this._fullyRenderedOnce = !0), performance.measure("mapkit-map-base-map-rendered", "mapkit-map-start"))),
          this._syrupRenderer.mapFullyRendered()
            ? this.node._impl.tileGridDidFinishRendering()
            : (this.node.needsDisplay = !0));
      }
    },
    forceRerender: function () {
      2 === this._state && this._syrupRenderer.forceRerender();
    },
    devicePixelRatioDidChange: function () {
      this._syrupRenderer && this._syrupRenderer.setPixelRatio(qn.devicePixelRatio);
    },
    frozen: !1,
    get element() {
      return this.canvas;
    },
    get canvas() {
      return this._canvas;
    },
    get fullyRendered() {
      return this._syrupRenderer && this._syrupRenderer.mapFullyRendered();
    },
    set language(t) {
      this._syrupRenderer && this._syrupRenderer.setLanguage(t);
    },
    set fontSizeRatio(t) {
      this._syrupRenderer && this._syrupRenderer.setFontSize(t);
    },
    updateNetworkConfiguration: function (t) {
      this._syrupRenderer && this._syrupRenderer.updateNetworkConfiguration(t);
    },
    updateConfiguration: function (t, e) {
      this._syrupRenderer &&
        ((e.mode = t.name),
        this._syrupRenderer.setDisplayOptions(e),
        t.countryCode && this._syrupRenderer.setLocationInfo(t.countryCode, t.countryCode));
    },
    updatePointOfInterestFilter: function (t) {
      this._syrupRenderer ? this._syrupRenderer.setPOIFilter(t) : (this._initialPoiFilter = t);
    },
    createLabelRegion: function () {
      if (!this._syrupRenderer) return;
      const t = this._syrupRenderer.createLabelRegion();
      return (
        this._unregisteredLabelRegions
          ? this._unregisteredLabelRegions.push(t)
          : this._syrupRenderer.registerLabelRegion(t),
        t
      );
    },
    unregisterLabelRegion: function (t) {
      this._unregisteredLabelRegions
        ? this._unregisteredLabelRegions.splice(this._unregisteredLabelRegions.indexOf(t), 1)
        : this._syrupRenderer && this._syrupRenderer.unregisterLabelRegion(t);
    },
    prepareLayer: function (t) {
      if (!this._unregisteredLayers) {
        if (!t._impl.syrupLayer || t._impl.rendererId !== this._id) {
          const e = {},
            i = t._impl.blendMode;
          if (void 0 !== i) {
            if (!l(i, Ji)) throw new Error("Invalid blendMode: " + i);
            e.blendMode = i;
          }
          const n = t._impl.backdropFilter;
          if (void 0 !== n) {
            if (!l(n, Qi)) throw new Error("Invalid backdropFilter: " + n);
            e.backdropFilter = n;
          }
          ((t._impl.rendererId = this._id), (t._impl.syrupLayer = this._syrupRenderer.createWebGLLayer(t._impl, e)));
        }
        t._impl.syrupLayer.setDrawPass(this._drawPasses[t._impl.passIndex] + t._impl.passOffset);
      }
    },
    cleanupLayer: function (t) {
      t._impl.syrupLayer = void 0;
    },
    addLayer: function (t) {
      const e = this._unregisteredLayers;
      if (e) {
        const i = e.indexOf(t);
        (i >= 0 && e.splice(i, 1), e.push(t));
      } else {
        const e = this._syrupRenderer,
          i = t._impl,
          n = (t) => {
            i.syrupToken = e.addLayer(t);
          };
        i.syrupToken ? i.syrupToken.then(n) : n(i.syrupLayer);
      }
    },
    insertBefore: function (t, e) {
      const i = this._unregisteredLayers;
      if (i) {
        const n = i.indexOf(e);
        n < 0 && wa();
        const o = i.indexOf(t);
        o !== n && (o >= 0 && i.splice(o, 1), i.splice(n, 0, t));
      } else {
        const i = this._syrupRenderer,
          n = e._impl.syrupToken;
        (n || wa(),
          n.then(function (e) {
            const n = t._impl,
              o = (t) => {
                n.syrupToken = i.insertBefore(t, e);
              };
            n.syrupToken ? n.syrupToken.then(o) : o(n.syrupLayer);
          }));
      }
    },
    insertAfter: function (t, e) {
      const i = this._unregisteredLayers;
      if (i) {
        const n = i.indexOf(e);
        n < 0 && wa();
        const o = i.indexOf(t);
        o !== n && (o >= 0 && i.splice(o, 1), i.splice(n + 1, 0, t));
      } else {
        const i = this._syrupRenderer,
          n = e._impl.syrupToken;
        (n || wa(),
          n.then(function (e) {
            const n = t._impl,
              o = (t) => {
                n.syrupToken = i.insertAfter(t, e);
              };
            n.syrupToken ? n.syrupToken.then(o) : o(n.syrupLayer);
          }));
      }
    },
    removeLayer: function (t) {
      if (this._unregisteredLayers) {
        const e = this._unregisteredLayers.indexOf(t);
        (e < 0 && wa(), this._unregisteredLayers.splice(e, 1));
      } else {
        const e = this._syrupRenderer,
          i = t._impl.syrupToken;
        (i || wa(),
          (t._impl.syrupToken = void 0),
          i.then((t) => {
            e.removeLayer(t);
          }));
      }
    }
  }),
    (ka.PostUpdateHandlers = []));
  const Aa = Math.PI / 180,
    Ea = ka,
    xa = {
      fontFamily: "-apple-system-font, sans-serif",
      margin: "2em auto",
      width: "20em",
      borderRadius: "0.5em",
      color: "#f8f9f0",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      padding: "1em",
      textAlign: "center",
      position: "relative"
    },
    Ta = {listStyleType: "none", margin: 0, paddingLeft: 0},
    Ia = {width: "1em", height: "1em", position: "absolute", top: "0.5em", left: "0.5em"};
  function Ra(t, e) {
    this._element = Oa(document.createElement("div"), xa);
    const i = Oa(this._element.appendChild(document.createElement("ul")), Ta);
    this._items = [
      function (t) {
        const e = t.center.toCoordinate();
        return "Center: " + e.latitude.toFixed(6) + ", " + e.longitude.toFixed(6);
      },
      function (t) {
        return "Zoom: " + t.zoom.toFixed(6) + ", rotation: " + t.rotation.toFixed(6);
      },
      function (t) {
        const e = Math.floor(t.zoom),
          i = Math.pow(2, e);
        return "Center tile: x=" + Math.floor(o(t.center.x, 1) * i) + ", y=" + Math.floor(t.center.y * i) + ", z=" + e;
      },
      function (t) {
        return "Viewport: " + t.viewportSize.width + "×" + t.viewportSize.height;
      }
    ].map(function (t) {
      const e = i.appendChild(document.createElement("li"));
      return function (i) {
        e.textContent = t(i);
      };
    });
    const n = qn.svgElement(
      "svg",
      {viewBox: "-16 -16 32 32"},
      qn.svgElement("circle", {r: 16, fill: "#ccc"}),
      qn.svgElement(
        "g",
        {"stroke-width": 4, stroke: "#222"},
        qn.svgElement("line", {x1: -8, y1: -8, x2: 8, y2: 8}),
        qn.svgElement("line", {x1: 8, y1: -8, x2: -8, y2: 8})
      )
    );
    (this._element.appendChild(Oa(n, Ia)),
      n.addEventListener("click", t),
      this.update(e),
      (this.update = te(this.update, 50, this)));
  }
  function Oa(t, e) {
    for (const i in e) t.style[i] = e[i];
    return t;
  }
  Ra.prototype = {
    constructor: Ra,
    attachTo: function (t) {
      t.appendChild(this._element);
    },
    detach: function () {
      this._element.remove();
    },
    update: function (t) {
      this._items.forEach((e) => {
        e(t);
      });
    }
  };
  const Pa = Ra;
  class Da extends On {
    constructor() {
      (super(),
        (this._rotation = 0),
        (this.rotation = 0),
        (this._velocity = 0),
        (this._lastEventData = null),
        (this._startAngle = null),
        (this.useGestures = On.UseGesturesForRotation));
    }
    get velocity() {
      return this._velocity;
    }
    get rotation() {
      return this._rotation;
    }
    set rotation(t) {
      this._rotation = (function (t) {
        for (; t > 180; ) t -= 360;
        for (; t < -180; ) t += 360;
        return t;
      })(t);
    }
    touchesBegan(t) {
      this.useGestures ||
        (t.currentTarget === this.target &&
          2 === this.numberOfTouches &&
          (super.touchesBegan(t),
          this.numberOfTouches > 2
            ? this.enterFailedState()
            : ((this._startAngle = this._angle()),
              (this._startDistance = this._distance()),
              (this.rotation = 0),
              (this._lastEventData = {rotation: 0, scale: 1, timeStamp: t.timeStamp}))));
    }
    touchesMoved(t) {
      this.useGestures ||
        (2 === this.numberOfTouches &&
          null !== this._startAngle &&
          void 0 !== this._startDistance &&
          this._handleEvent(t, {
            rotation: this._angle() - this._startAngle,
            scale: 0 === this._startDistance ? 1 : this._distance() / this._startDistance
          }));
    }
    touchesEnded(t) {
      this.useGestures ||
        this.numberOfTouches >= 2 ||
        null === this._startAngle ||
        (this.state === On.States.Changed ? this.enterEndedState() : this.enterFailedState());
    }
    gestureBegan(t) {
      this.useGestures &&
        (super.gestureBegan(t),
        this.preventDefault(t),
        (this.rotation = 0),
        (this._lastEventData = {rotation: 0, scale: 1, timeStamp: t.timeStamp}));
    }
    gestureChanged(t) {
      this.useGestures && (this.preventDefault(t), this._handleEvent(t));
    }
    gestureEnded(t) {
      this.useGestures && this.enterEndedState();
    }
    reset() {
      ((this.rotation = 0), (this._velocity = 0), (this._lastEventData = null), (this._startAngle = null));
    }
    _handleEvent(t, e) {
      const i = "rotation" in t ? t.rotation : e ? e.rotation : NaN,
        n = "scale" in t ? t.scale : e ? e.scale : NaN,
        o = this._lastEventData;
      if (!o || isNaN(i) || isNaN(n)) throw new Error("");
      const s = i - o.rotation,
        a = n - o.scale,
        r = t.timeStamp - o.timeStamp;
      if (((this._lastEventData = {rotation: i, scale: n, timeStamp: t.timeStamp}), this.state !== On.States.Possible))
        (r > 0 && (this._velocity = (s / r) * 1e3), (this.rotation += s), this.enterChangedState());
      else {
        const t = Math.abs(i) < 8,
          e = Math.abs(s / 90) < Math.abs(a),
          n = Math.abs(s) >= 135;
        if (t || e || n) return;
        this.enterBeganState();
      }
    }
    _angle() {
      if (2 !== this.numberOfTouches) return 0;
      const t = this._targetTouches[0],
        e = new Mi(t.pageX, t.pageY),
        i = this._targetTouches[1],
        n = new Mi(i.pageX, i.pageY);
      return (180 * Math.atan2(e.y - n.y, e.x - n.x)) / Math.PI;
    }
  }
  const za = dt.performanceMarkers.interactions,
    Na = 180 / Math.PI,
    Fa = 3 * Na,
    Ua = 1e-4 * Na * 1e3;
  function Ga(t) {
    (es.call(this, t), (this._recognizer = this.addRecognizer(new Da())));
  }
  Ga.prototype = r(es, Ga, {
    decelerating: !1,
    stopDecelerating: function () {
      this.decelerating && this._decelerationEnded();
    },
    destroy: function () {
      (es.prototype.destroy.call(this), this.stopDecelerating(), delete this._recognizer);
    },
    handleEvent: function (t) {
      const e = t.target;
      e === this._recognizer &&
        (e.state === Un.Began && (this.map.beganRecognizingRotation(), this.map.cameraWillStartRotating()),
        e.state === Un.Ended &&
          (delete this._restricted, this.map.finishedRecognizingRotation(), this._startDeceleratingWithVelocity(e)),
        this._handleRotationChange(t.target),
        za && performance.measure("mapkit-map-rotate-interaction", {start: e.lastEventTimeStamp, detail: e.state}));
    },
    _handleRotationChange: function (t) {
      this._lastRotationCenter = this.centerForGesture(t);
      const e = this.map.cameraIsRotating && t.state === Un.Changed,
        i = 2 === t.numberOfTouches && Math.abs(t.rotation) <= 150 / t._distance();
      e && !i && (this.map.rotateCameraAroundMapPoint(this._lastRotationCenter, t.rotation), (t.rotation = 0));
    },
    _centerWithRecognizer: function (t) {
      const e = this.map,
        i = t.locationInElement();
      let n = this.map.node.convertPointFromPage(i);
      n = e.camera.transformGestureCenter(n);
      const o = e.visibleMapRect,
        s = e.camera.viewportSize;
      return new Ye.MapPoint(o.minX() + (n.x / s.width) * o.size.width, o.minY() + (n.y / s.height) * o.size.height);
    },
    performScheduledUpdate: function (t) {
      const e = za ? performance.now() : void 0;
      if (!this.decelerating) return;
      if (null == t) return void this._decelerationEnded();
      const i = t - this._timeAtPreviousFrame;
      if (i > 300) return void this._decelerationEnded();
      let n = this._velocity / 1e3;
      const o = Math.pow(0.995, i),
        s = (0.995 * n * (o - 1)) / -0.0050000000000000044;
      if (
        ((n *= o),
        this.map.cameraAnimation
          ? this.map.cameraAnimation.adjustRotation(this._lastRotationCenter, s)
          : this.map.rotateCameraAroundMapPoint(this._lastRotationCenter, s),
        (this._velocity *= o),
        Math.abs(this._velocity) <= Ua)
      )
        this._decelerationEnded();
      else {
        if (((this._velocity *= o), Math.abs(this._velocity) <= Ua))
          return (
            this._decelerationEnded(),
            void (za && performance.measure("mapkit-map-rotate-deceleration", {start: e}))
          );
        ((this._timeAtPreviousFrame = t),
          this._schedule(),
          za && performance.measure("mapkit-map-rotate-deceleration", {start: e}));
      }
    },
    _startDeceleratingWithVelocity: function (t) {
      const e = t.velocity;
      if (Math.abs(e) > 1440 || isNaN(e)) this.map.cameraDidStopRotating();
      else {
        if (Math.abs(e) < Fa) return ((this.decelerating = !1), void this.map.cameraDidStopRotating());
        ((this._velocity = e),
          (this.decelerating = !0),
          (this._timeAtPreviousFrame = t.lastEventTimeStamp),
          this._schedule());
      }
    },
    _schedule: function () {
      Qt.scheduleOnNextFrame(this);
    },
    _decelerationEnded: function () {
      ((this.decelerating = !1), this.map.cameraDidStopRotating());
    }
  });
  const Ba = Ga;
  function Za(t) {
    (ta.call(this, t),
      (this._renderer = t._renderer),
      (this._requiresFallback = !1),
      (this._fallback = () => {
        this._requiresFallback = !0;
      }));
  }
  Za.prototype = r(ta, Za, {
    init: function (t, e, i, n, o) {
      if (this._requiresFallback) return void t.syrupRequestedFallback(qi);
      this._fallback = () => t.syrupRequestedFallback(qi);
      const s = {tint: this.tileTint, emphasis: this.emphasis};
      this._renderer.init(this.networkConfigurationFor(t), e, i, n, s, this._getRendererPoiFilter(), (t) => {
        (this._updateMinAndMaxZoomLevels(this.camera.viewportSize), o(t, this._renderer));
      });
    },
    get isRotationEnabled() {
      return this._isRotationEnabled;
    },
    set isRotationEnabled(t) {
      (!t && this._rotationController
        ? (this._rotationController.destroy(), delete this._rotationController)
        : t &&
          !this._rotationController &&
          (this._initialInteractionController || (this._initialInteractionController = new Jo(this)),
          (this._rotationController = new Ba(this)),
          (this.camera._initialRotation = 0)),
        (this._isRotationEnabled = t));
    },
    get rotation() {
      return this.camera.rotation;
    },
    set rotation(t) {
      if (
        (this._cameraWillChange(),
        (this.camera.rotation = t),
        this._updateDisplay(),
        this._cameraDidChange(),
        this.cameraAnimation && this.cameraAnimation.rotating)
      )
        return;
      const e = this.node.delegate;
      e && "function" == typeof e.mapRotationDidChange && e.mapRotationDidChange(this.node);
    },
    set fontSizeRatio(t) {
      ((this._renderer.fontSizeRatio = t), this._updateDisplay());
    },
    updateNetworkConfiguration: function (t) {
      this._renderer.updateNetworkConfiguration(this.networkConfigurationFor(t));
    },
    forceRerender: function () {
      this._renderer.forceRerender();
    },
    prepareLayer: function (t) {
      this._renderer.prepareLayer(t);
    },
    cleanupLayer: function (t) {
      this._renderer.cleanupLayer(t);
    },
    addLayer: function (t) {
      this._renderer.addLayer(t);
    },
    insertBefore: function (t, e) {
      this._renderer.insertBefore(t, e);
    },
    insertAfter: function (t, e) {
      this._renderer.insertAfter(t, e);
    },
    removeLayer: function (t) {
      this._renderer.removeLayer(t);
    },
    adjustForSize: function (t) {
      (ta.prototype.adjustForSize.call(this, t), this.forceRerender());
    },
    adjustMapItemPoint: function (t) {
      return (
        this.cameraIsZooming ||
          this.cameraIsPanning ||
          this.cameraIsRotating ||
          ((t.x = qn.roundToDevicePixel(t.x)), (t.y = qn.roundToDevicePixel(t.y))),
        t
      );
    },
    networkConfigurationFor: function (t) {
      if (!t) return {};
      let e = null;
      t.proxyPrefixes && !t.customMadabaUrl && (e = t.proxyPrefixes.slice(0));
      const i = !(!t.withCredentials || t.customMadabaUrl);
      return {
        madabaDomains: t.madabaDomains.slice(0),
        rasterTiles: t.rasterTilesForSyrup,
        proxyPrefixes: e,
        withCredentials: i,
        tileGroup: t.tileGroup,
        accessKey: t.accessKey,
        accessKeyHasExpired: () => t.accessKeyHasExpired(),
        syrupRequestedFallback: (e) => t.syrupRequestedFallback(e)
      };
    },
    rotateCameraAroundMapPoint: function (t, e) {
      if (this.isRotationLocked) {
        if (!this.restrictedCamera) return;
        if (this.restrictIncomingRotation) {
          const t = o(this.camera.rotation + e, 360),
            i = qn.restrictRotation(t);
          i !== t && (e = i - this.camera.rotation);
        }
      }
      if (0 === e) return;
      (this._cameraWillChange(),
        this.camera.rotateAroundCenter(t, e),
        this.constrainCamera(this.camera),
        this._updateDisplay(),
        this._cameraDidChange());
      const i = this.node.delegate;
      i && "function" == typeof i.mapRotationDidChange && i.mapRotationDidChange(this.node);
    },
    deactivate: function () {
      (ta.prototype.deactivate.call(this), (this.isRotationEnabled = !1), this._renderer.deactivate());
    },
    getMapFeatureRegions: function () {
      return this._renderer.getMapFeatureRegions();
    },
    destroy: function (t) {
      (ta.prototype.destroy.call(this, t),
        this.customCanvas &&
          this.customCanvas.parentNode &&
          this.customCanvas.parentNode.removeChild(this.customCanvas),
        this._renderer && (this._renderer.destroy(), (this._renderer = null)));
    },
    stringInfo: function () {
      return "SyrupNode<camera:" + this.camera.toString() + ">";
    },
    get backgroundGridTheme() {
      return this._backgroundGridTheme;
    },
    set backgroundGridTheme(t) {
      this._backgroundGridTheme = t;
    },
    get fullyRendered() {
      return this._renderer.fullyRendered;
    },
    get customCanvas() {
      return this._renderer && this._renderer.canvas;
    },
    get camera() {
      return this._camera;
    },
    set camera(t) {
      ((this._camera = t), (this.node.needsDisplay = !0));
    },
    get language() {
      return this._language;
    },
    set language(t) {
      this._language !== t &&
        ((this._language = t), this._renderer && ((this._renderer.language = t), (this.node.needsDisplay = !0)));
    },
    updateConfiguration: function (t) {
      const e =
        this._configuration &&
        (t.name !== this._configuration.name ||
          t.provider !== this._configuration.provider ||
          t.countryCode !== this._configuration.countryCode);
      (ta.prototype.updateConfiguration.call(this, t),
        e && this._renderer && (this._renderer.updateConfiguration(t, {}), (this.node.needsDisplay = !0)));
    },
    updateTintAndEmphasis: function (t, e, i) {
      this._renderer.node.pendingConfigurationUpdates
        ? ((this._renderer.node.pendingConfigurationUpdates.tint = t),
          (this._renderer.node.pendingConfigurationUpdates.tileTint = e),
          (this._renderer.node.pendingConfigurationUpdates.emphasis = i))
        : this._renderer &&
          this._configuration &&
          (this._renderer.updateConfiguration(this._configuration, {tint: e, emphasis: i}),
          (this.node.needsDisplay = !0));
    },
    updatePointOfInterestFilter: function () {
      this._renderer &&
        (this._renderer.updatePointOfInterestFilter(this._getRendererPoiFilter()), (this.node.needsDisplay = !0));
    },
    makePendingConfigurationUpdates: function () {
      const t = this._renderer.node.pendingConfigurationUpdates;
      t &&
        (delete this._renderer.node.pendingConfigurationUpdates,
        t.tint && t.emphasis && this.updateTintAndEmphasis(t.tint, t.tileTint, t.emphasis),
        t.poiFilter && this.updatePointOfInterestFilter());
    },
    devicePixelRatioDidChange: function () {
      return !this._renderer;
    },
    forcedSnapsToIntegralZoomLevels: !1,
    get snapsToIntegralZoomLevels() {
      return this.forcedSnapsToIntegralZoomLevels || (this._renderer && this._renderer.snapsToIntegralZoomLevels);
    },
    set snapsToIntegralZoomLevels(t) {},
    get debug() {
      return this._debug;
    },
    set debug(t) {
      this._debug !== !!t && ((this._debug = !!t), this._debug ? this._showDebugPanel() : this._hideDebugPanel());
    },
    minZoomLevelForViewportSize: function (t, e) {
      return this._renderer && this._renderer.Camera
        ? this._renderer.Camera.getMinZoomLevel([t.width, t.height], e)
        : this.minZoomLevel;
    },
    needsReplacing: function (t) {
      return !t;
    },
    createLabelRegion: function () {
      return this._renderer.createLabelRegion();
    },
    updatedLabelRegion: function () {
      (this.forceRerender(), (this.node.needsDisplay = !0));
    },
    unregisterLabelRegion: function (t) {
      (this._renderer.unregisterLabelRegion(t), (this.node.needsDisplay = !0));
    },
    _tileOverlaysDidChange: function () {
      this._fallback();
    },
    _showDebugPanel: function () {
      ((this._debugPanel = new Pa(() => {
        this.debug = !1;
      }, this.camera)),
        this._debugPanel.attachTo(this._element),
        (this._cameraDidChange = function () {
          (ta.prototype._cameraDidChange.call(this), this._debugPanel && this._debugPanel.update(this.camera));
        }));
    },
    _hideDebugPanel: function () {
      (this._debugPanel.detach(), delete this._debugPanel, delete this._cameraDidChange);
    },
    _updateDisplay: function () {
      (this.forceRerender(), (this.node.needsDisplay = !0));
    },
    _getRendererPoiFilter: function () {
      const t = null !== this.pointOfInterestFilter,
        e = 0 !== this._filteredPois.size,
        i = {};
      return (
        t &&
          ((i.categoryInclude = this.pointOfInterestFilter._includes),
          (i.categoryExclude = this.pointOfInterestFilter._excludes)),
        e && (i.muidExclude = Array.from(this._filteredPois)),
        t || e ? i : null
      );
    }
  });
  const Wa = Za;
  function Ka() {
    (jo.call(this), (this._renderer = new Ea(this)), Object.defineProperty(this, "_impl", {value: new Wa(this)}));
  }
  Ka.prototype = r(jo, Ka, {
    get isRotationEnabled() {
      return this._impl.isRotationEnabled;
    },
    set isRotationEnabled(t) {
      this._impl.isRotationEnabled = t;
    },
    get customCanvas() {
      return this._impl.customCanvas;
    },
    set needsDisplay(t) {
      t && Qt.scheduleDraw(this._renderer);
    },
    get forcedSnapsToIntegralZoomLevels() {
      return this._impl.forcedSnapsToIntegralZoomLevels;
    },
    set forcedSnapsToIntegralZoomLevels(t) {
      this._impl.forcedSnapsToIntegralZoomLevels = t;
    },
    init: function (t, e, i, n, o) {
      this._impl.init(t, e, i, n, o);
    },
    updateNetworkConfiguration: function (t) {
      this._impl.updateNetworkConfiguration(t);
    },
    forceRerender: function () {
      this._impl.forceRerender();
    },
    forceDraw() {
      (this._impl.forceRerender(), this._impl._renderer.performScheduledDraw());
    },
    requireRender: function () {
      (this._impl.forceRerender(), Qt.scheduleDraw(this._renderer));
    },
    rotateCameraAroundMapPoint: function (t, e) {
      this._impl.rotateCameraAroundMapPoint(t, e);
    },
    makePendingConfigurationUpdates: function () {
      this._impl.makePendingConfigurationUpdates();
    },
    didReconfigure: function () {
      this.dispatchEvent(new M.Event("reconfigured"));
    },
    getMapFeatureRegions: function () {
      return this._impl.getMapFeatureRegions();
    }
  });
  const Ha = Ka,
    ja = Object.freeze({
      name: "functions",
      fn: function () {
        return !!(
          Array.prototype.fill &&
          Uint8Array.from &&
          "undefined" != typeof Set &&
          Set.prototype.forEach &&
          window.btoa
        );
      }
    });
  function Va(t) {
    return {VERSION: t.getParameter(t.VERSION), MAX_RENDERBUFFER_SIZE: t.getParameter(t.MAX_RENDERBUFFER_SIZE)};
  }
  const qa = Object.freeze({
    name: "webGL",
    fn: function (t, e) {
      if (e) return {capable: !0};
      const i = t ? [t] : ["webgl2", "webgl"];
      for (let t = 0; t < i.length; t++) {
        const e = document.createElement("canvas");
        e.width = e.height = 0;
        const o = e.getContext(i[t], {antialias: !1, stencil: !0, failIfMajorPerformanceCaveat: !0});
        if (null != o)
          return {
            contextType: i[t],
            capable:
              ((n = o),
              n.getParameter(n.MAX_TEXTURE_SIZE) >= 4096 &&
                n.getParameter(n.MAX_VERTEX_TEXTURE_IMAGE_UNITS) >= 8 &&
                n.getParameter(n.MAX_VARYING_VECTORS) >= 8 &&
                n.getParameter(n.STENCIL_BITS) >= 8),
            gpuInfo: Va(o)
          };
      }
      var n;
      return !1;
    }
  });
  let Ya;
  ((oe.createSyrupUrl = function () {
    if (dt.state === dt.States.UNINITIALIZED) return;
    let t;
    const e = "/ti/csr/1.x.x";
    return (
      (t = dt._syrupUrl
        ? dt._syrupUrl
        : dt.proxyPrefixes
          ? dt.proxyPrefixes[0] + i.cdnBase + e
          : "https:" + i.cdnBase + e),
      [t, "mk-csr.js?mapkitVersion=" + i.version + (dt.enableSourceMap ? "&sourcemap=1" : "")].join("/")
    );
  }),
    (oe.isSyrupUrlTrusted = function () {
      return !dt._syrupUrl && (!dt.proxyPrefixes || dt.isProxyPrefixTrusted());
    }));
  const Xa = () => {
      if (window.Syrup || (window.Spile && window.Spile.Syrup)) return Promise.resolve();
      if (!Ya) {
        const t = dt.performanceMarkers.loading;
        t && performance.mark("mapkit-syrup-load-start");
        const e = () =>
          new Promise((t, e) => {
            const i = document.head.appendChild(document.createElement("script"));
            (i.addEventListener("error", (t) => e(t), {once: !0}),
              i.addEventListener("load", () => t(), {once: !0}),
              dt.nonce && oe.isSyrupUrlTrusted() && (i.nonce = dt.nonce),
              (i.crossOrigin = ms.getCorsAttribute(
                dt._syrupUrl ? dt.urlWithCredentials(dt._syrupUrl) : dt.withCredentials
              )),
              (i.src = oe.createSyrupUrl()));
          }).then(
            () => {
              (window.Syrup || (window.Spile && window.Spile.Syrup)) &&
                (t && performance.measure("mapkit-syrup-load", "mapkit-syrup-load-start"),
                (dt.componentVersions.s = window.Syrup ? window.Syrup.Version : window.Spile.version));
            },
            (t) => {
              console.error(t);
            }
          );
        Ya = dt._syrupUrl ? e() : dt.loginPromise.then(e);
      }
      return Ya;
    },
    $a = j,
    Ja = I,
    Qa = {
      sg_grid: {"global-configuration": "sg_ready", upgrade: "syrup_insert"},
      sg_insert: {"global-configuration": "sg_ready", upgrade: "syrup_insert", recreate: "sg_insert"},
      syrup_insert: {"global-configuration": "syrup_need_load", fallback: "sg_insert", recreate: "syrup_insert"},
      syrup_need_load: {"syrup-load": "syrup_init", fallback: "sg_insert", recreate: "syrup_insert"},
      syrup_init: {
        "global-configuration": "syrup_network_stalled",
        fallback: "sg_insert",
        recreate: "syrup_insert",
        "syrup-complete": "syrup_ready"
      },
      syrup_network_stalled: {
        "global-configuration": "syrup_network_stalled",
        fallback: "sg_insert",
        recreate: "syrup_insert",
        "syrup-complete": "syrup_ready"
      },
      sg_ready: {
        "global-configuration": "sg_ready",
        upgrade: "syrup_insert",
        recreate: "sg_insert",
        "map-configuration": "sg_ready"
      },
      syrup_ready: {
        "global-configuration": "syrup_ready",
        upgrade: "syrup_insert",
        fallback: "sg_insert",
        recreate: "syrup_insert",
        "map-configuration": "syrup_ready",
        "print-match": "syrup_printing"
      },
      syrup_printing: {"print-unmatch": "syrup_ready"}
    },
    tr = Object.keys($i).map((t) => $i[t]);
  function er(t, e) {
    ((this._state = null),
      (this._map = t),
      (this._previousNode = null),
      (this.node = null),
      (this._initialOptions = e),
      (this._cachedWebGLCheck = null),
      (this._layers = []),
      (this.loadPriority = tn.LandCover),
      void 0 !== e.loadPriority &&
        (l(e.loadPriority, tn)
          ? (this.loadPriority = e.loadPriority)
          : console.warn("[MapKit] Unknown value for `loadPriority`. Choose from mapkit.Map.LoadPriorities.")),
      (this.initialContextType = e.contextType),
      (this._previousCanRunCSR = !1),
      this._updateState("sg_grid"));
  }
  function ir(t) {
    ((this.customCanvas = t.customCanvas), fo.Opacity.call(this, t));
  }
  ((er.prototype = {
    constructor: er,
    get usingSSR() {
      return "sg_insert" === this._state || "sg_ready" === this._state;
    },
    get csrCapable() {
      return (
        "HYBRID" === dt.forcedRenderingMode ||
        "CLIENT" === dt.forcedRenderingMode ||
        this._webglCheckResult.shouldTryCSR
      );
    },
    get shouldDynamicallyLoadSyrup() {
      return this._webglCheckResult.shouldTryCSR;
    },
    get _webglCheckResult() {
      return (
        null === this._cachedWebGLCheck &&
          (this._cachedWebGLCheck = (function (t, e) {
            const i = {};
            return (
              (i.shouldTryCSR = [ja, qa].every(function (n) {
                const o = n.fn(t, e);
                return ((i[n.name] = o), "object" == typeof o ? o.capable : o);
              })),
              i
            );
          })(this.initialContextType, dt._disableWebGLCheck)),
        this._cachedWebGLCheck
      );
    },
    get renderingMode() {
      let t = "CLIENT";
      return (this.usingSSR ? (t = "SERVER") : this._switchedToLoCSR && (t = "HYBRID"), t);
    },
    configurationDidBecomeAvailable: function (t) {
      const e = this._previousCanRunCSR,
        i = dt.canRunCSR;
      ((this._previousCanRunCSR = i),
        !e || i || this.usingSSR
          ? !e && i
            ? this.handleUpgrade()
            : t || this.handleGlobalConfigurationChange()
          : this.handleFallback("CONFIGURATION_CHANGE_FALLBACK"));
    },
    forceSyrup: function () {
      this._transition("upgrade");
    },
    _findLayerIndex: function (t) {
      let e;
      const i = this._layers;
      if ("string" == typeof t) for (e = i.length; e-- && i[e].name !== t; );
      else e = i.indexOf(t);
      if (e < 0) throw new Error("[MapKit] Layer not found");
      return e;
    },
    _addLayer: function (t, e, i) {
      const n = this._layers;
      let o;
      const s = tr.indexOf(e);
      if (s < 0) ((o = this._findLayerIndex(e)), (t._impl.passIndex = n[o]._impl.passIndex), (o += i));
      else {
        for (o = 0; o < n.length && n[o].passIndex < s + i; ) o++;
        ((t._impl.passIndex = s), (t._impl.passOffset = i - 1));
      }
      (this.node._impl.prepareLayer(t),
        o === n.length
          ? this.node._impl.addLayer(t)
          : 0 === o
            ? this.node._impl.insertBefore(t, n[0])
            : this.node._impl.insertAfter(t, n[o - 1]),
        n.splice(o, 0, t));
    },
    _addedLayer: function (t) {
      this.usingSSR ? t._impl.contextFailed() : this.node.requireRender();
    },
    addLayerAbove: function (t, e) {
      (void 0 === e
        ? ((t._impl.passIndex = tr.length - 1),
          (t._impl.passOffset = 0),
          this.node._impl.prepareLayer(t),
          this.node._impl.addLayer(t),
          this._layers.push(t))
        : this._addLayer(t, e, 1),
        this._addedLayer(t));
    },
    addLayerBelow: function (t, e) {
      if (void 0 === e) throw new Error("[MapKit] Relative layer not specified");
      (this._addLayer(t, e, 0), this._addedLayer(t));
    },
    removeLayer: function (t) {
      const e = this._findLayerIndex(t);
      (this._layers.splice(e, 1), this.node._impl.removeLayer(t), this.node.requireRender());
    },
    requireRender: function () {
      this.node.requireRender();
    },
    updateSize: function (t) {
      ((this.node.size = t), this._previousNode && (this._previousNode.size = t));
    },
    destroy: function () {
      (this._layers.forEach((t) => this.node._impl.removeLayer(t)),
        this.node.removeEventListener("reconfigured", this),
        this.node.destroy(),
        (this.node.delegate = null),
        (this.node = null),
        this._previousNode && (this._previousNode.destroy(), (this._previousNode = null)));
    },
    handleEvent: function (t) {
      "reconfigured" === t.type &&
        ((this._switchedToLoCSR = this.node.snapsToIntegralZoomLevels), this._map.didReconfigureMapNode(this.node));
    },
    handleGlobalConfigurationChange: function () {
      this._transition("global-configuration");
    },
    handleSyrupLoad: function () {
      this._transition("syrup-load");
    },
    handleFallback: function (t, e) {
      const i = (dt.didFallback && dt.fallbackType) || t;
      (i && this._logFallback(i, e), (this._fallbackInfo = {reason: t, message: e}), this._transition("fallback"));
    },
    handleUpgrade: function () {
      ((this._fallbackInfo = void 0), this._transition("upgrade"));
    },
    handleRecreate: function () {
      this._transition("recreate");
    },
    handleMapConfigurationChange: function () {
      (this._transition("map-configuration"),
        this._previousNode &&
          this._previousNode.configuration &&
          ((this._previousNode.language = dt.language),
          (this._previousNode.configuration = dt.types[this._map.mapType])));
    },
    handleSyrupComplete: function () {
      this._transition("syrup-complete");
    },
    handlePrintMatch: function () {
      this._transition("print-match");
    },
    handlePrintUnmatch: function () {
      this._transition("print-unmatch");
    },
    handleMapRendered: function () {
      this.node instanceof Ha && ((this.node.forcedSnapsToIntegralZoomLevels = !1), this._removePreviousMapNode(!0));
    },
    setPointOfInterestFilter: function (t) {
      this._previousNode && (this._previousNode.pointOfInterestFilter = t);
    },
    setTintAndEmphasis: function (t, e, i) {
      this._previousNode && this._previousNode.setTintAndEmphasis(t, e, i);
    },
    mapCameraDidChange: function () {
      this._previousNode && this._previousNode.setCameraAnimated(this.node.camera.copy());
    },
    _transition: function (t) {
      const e = Qa[this._state][t];
      e && this._updateState(e);
    },
    _updateState: function (t) {
      this._state = t;
      const e = this["_enter_" + t];
      "function" == typeof e && e.call(this);
    },
    _loadSyrupIfNeeded: function (t) {
      Xa().then(() => {
        t.call(this, !!window.Syrup || (!!window.Spile && !!window.Spile.Syrup));
      });
    },
    _insertSceneGraphNode: function () {
      this.usingSSR && (this.node.isRotationEnabled = !1);
      const t = new ya();
      (this._insertNewMapNode(t), this._map.didFinishMapNodeInitialization(t));
    },
    _enter_sg_grid: function () {
      (this._insertSceneGraphNode(), dt.ready && !dt.canRunCSR && this._updateState("sg_ready"));
    },
    _enter_sg_insert: function () {
      (this._insertSceneGraphNode(), dt.ready && this._updateState("sg_ready"));
    },
    _enter_syrup_insert: function () {
      const t = new Ha();
      ((t.pendingConfigurationUpdates = {}),
        this._insertNewMapNode(t),
        dt.state === dt.States.READY && this._updateState("syrup_need_load"));
    },
    _insertNewMapNode: function (t) {
      const e = this._initialOptions || {};
      this._initialOptions || this.node._impl._cameraWillChange(this.node, !1);
      const i = this.node;
      if (i)
        (this._removePreviousMapNode(),
          i.migrateStateTo(t),
          i.removeEventListener("reconfigured", this),
          i.deactivate(),
          this._layers.forEach(function (t) {
            (i._impl.cleanupLayer(t), i._impl.removeLayer(t));
          }),
          (this._previousNode = i));
      else {
        ((t.allowWheelToZoom = void 0 !== e._allowWheelToZoom && !!e._allowWheelToZoom),
          (t.allowWheelToZoom2 = void 0 !== e._allowWheelToZoom2 && !!e._allowWheelToZoom2),
          (t.pannable = void 0 === e.isScrollEnabled || !!e.isScrollEnabled),
          (t.zoomable = void 0 === e.isZoomEnabled || !!e.isZoomEnabled),
          void 0 !== e.pointOfInterestFilter
            ? (void 0 !== e.showsPointsOfInterest &&
                console.warn("[MapKit] `showsPointsOfInterest` is ignored because `pointOfInterestFilter` is set."),
              null !== e.pointOfInterestFilter &&
                d(
                  e.pointOfInterestFilter,
                  yt,
                  "[MapKit] Unknown value for `pointOfInterestFilter`. It must be an instance of mapkit.PointOfInterestFilter."
                ),
              (t.pointOfInterestFilter = e.pointOfInterestFilter))
            : void 0 !== e.showsPointsOfInterest &&
              (e.showsPointsOfInterest
                ? (t.pointOfInterestFilter = null)
                : (t.pointOfInterestFilter = yt.filterExcludingAllCategories)),
          (t.showsDefaultTiles = void 0 === e._showsDefaultTiles || !!e._showsDefaultTiles));
        for (const i of er.InitialOptionsHandlers) i.call(this, t, e);
      }
      ((this.node = t),
        this.node.addEventListener("reconfigured", this),
        this._map.didInsertNewMapNode(t),
        this._layers.forEach(function (e) {
          (t._impl.prepareLayer(e), t._impl.addLayer(e));
        }),
        this._initialOptions ? delete this._initialOptions : this.node._impl._cameraDidChange(this.node, !1));
    },
    _removePreviousMapNode: function (t) {
      if (this._previousNode)
        if (t) {
          if (this._previousNode.animators && this._previousNode.animators.length) return;
          const t = this._previousNode;
          new ir({
            node: this._previousNode,
            duration: 150,
            from: 1,
            to: 0,
            customCanvas: this._previousNode.customCanvas,
            done: () => {
              t === this._previousNode && this._removePreviousMapNode(!1);
            }
          }).begin();
        } else (this._previousNode.destroy(!0), this._previousNode.remove(), (this._previousNode = null));
    },
    _enter_syrup_need_load: function () {
      if (this.shouldDynamicallyLoadSyrup) {
        if (
          this.loadPriority &&
          this._previousNode &&
          this._previousNode instanceof ya &&
          !this._previousNode.configuration
        )
          if (0 !== this.node.rotation);
          else {
            const t = this.loadPriority === tn.PointsOfInterest;
            ((this._previousNode.snapsToIntegralZoomLevels = t),
              (this._previousNode.labels = t),
              t &&
                ((this.node.forcedSnapsToIntegralZoomLevels = !0),
                this.node.setZoomLevelAnimated(qn.getIntegralZoom(this.node.zoomLevel))),
              (this._previousNode.language = dt.language),
              (this._previousNode.configuration = dt.types[this._map.mapType]),
              (this._previousNode.delegate = {
                mapDidFinishRendering: (t) => this._map.previousMapDidFinishRendering(t)
              }),
              this._previousNode.setCameraBoundaryAnimated(null),
              this._previousNode.setCameraZoomRangeAnimated(null));
          }
        this._loadSyrupIfNeeded((t) => {
          t ? this.handleSyrupLoad() : (dt.syrupRequestedFallback(), this.handleFallback("NETWORK_ERROR"));
        });
      } else this.handleFallback("BROWSER_SUPPORT_ERROR");
    },
    _enter_syrup_init: function () {
      if (!this.node) return;
      if (!dt.madabaDomains || !dt.madabaDomains.length)
        return (this._csrWarning("Network error"), void this.handleFallback("CONFIGURATION_MISSING_FALLBACK"));
      const t = "object" == typeof Syrup ? Syrup.SyrupRenderer : Spile.getRendererWithoutAnyWarranty(),
        e = "object" == typeof Syrup ? Syrup.Camera : Spile.Syrup.Camera;
      ((this._switchedToLoCSR = !1),
        dt.forcedRenderingMode && (this._switchedToLoCSR = "HYBRID" === dt.forcedRenderingMode));
      const i = this.node;
      this._reConfigureMapNode();
      const n = dt.performanceMarkers.rendering ? performance.now() : void 0;
      i.init(
        dt,
        t,
        e,
        {
          startInLoCSR: this._switchedToLoCSR,
          contextType: this._webglCheckResult.webGL.contextType,
          performanceMarkers: dt.performanceMarkers.rendering
        },
        (t) => {
          (dt.performanceMarkers.rendering && performance.measure("mapkit-syrup-init", {start: n}),
            t
              ? (this._csrWarning(t), this.handleFallback(t.type || "UNKNOWN_ERROR", t.message))
              : (this._reConfigureMapNode(),
                (i.needsDisplay = !0),
                this._map.didFinishMapNodeInitialization(i),
                this.handleSyrupComplete()));
        }
      );
    },
    _csrWarning: function (t) {
      console.warn("[MapKit] CSR is unavailable. " + t);
    },
    _enter_syrup_network_stalled: function () {
      this.node.updateNetworkConfiguration(dt);
    },
    _enter_sg_ready: function () {
      (this._removePreviousMapNode(),
        (this.node.snapsToIntegralZoomLevels = !0),
        (this.node.isRotationEnabled = !1),
        ("HYBRID" !== dt.forcedRenderingMode && "CLIENT" !== dt.forcedRenderingMode) ||
          (this._map.mapNodeDidFail(this._fallbackInfo),
          console.warn("[MapKit] Not rendering raster tiles under forced client rendering."),
          (this.node.showsDefaultTiles = !1)),
        this._reConfigureMapNode(),
        this._map.mapNodeReady(!1),
        this._layers.forEach((t) => {
          t._impl.contextFailed();
        }));
    },
    _enter_syrup_ready: function () {
      (!this.node.fullyRendered && this._previousNode && this._previousNode.configuration
        ? ((this._previousNode.language = dt.language),
          (this._previousNode.configuration = dt.types[this._map.mapType]))
        : this._removePreviousMapNode(),
        this._reConfigureMapNode(),
        this.node.updateNetworkConfiguration(dt),
        this.node.makePendingConfigurationUpdates(),
        this._map.mapNodeReady(!0));
    },
    _reConfigureMapNode: function () {
      ((this.node.language = dt.language),
        (this.node.configuration = dt.types[this._map.mapType]),
        this.node._impl.debug || (this.node._impl.debug = !!dt.showsTileInfo),
        this._map.didReconfigureMapNode(this.node));
    },
    _enter_syrup_printing: function () {
      (this.node.forceRerender(), (this.node.needsDisplay = !0));
    },
    _sendAnalytics: function (t) {
      let e = "https://gsp10.apple-mapkit.com/hvr/mw/v1/spile";
      dt.proxyPrefixes && (e = dt.proxyPrefixes[dt.proxyPrefixes.length - 1] + e);
      const i = {};
      (t && (i.ssrFallback = t),
        new $a(
          e,
          {
            getDataToSend: function (t) {
              return (t.setRequestHeader("Content-Type", "text/plain"), (t.responseType = "text"), JSON.stringify(i));
            }
          },
          {method: "POST", priority: Ja.Low, withCredentials: dt.withCredentials}
        ).schedule());
    },
    _logFallback: function (t, e) {
      const i = ke.uaParserInfo.browserInfo,
        n = ke.uaParserInfo.deviceInfo,
        o = this._usingCSRAPI();
      this._sendAnalytics({
        reason: t,
        message: e,
        usingCSRAPI: o,
        devicePlatform: n.platform,
        deviceOs: n.os,
        browserName: i.name,
        browserVersion: i.version
      });
    },
    _usingCSRAPI: function () {
      return !(
        this._map._showsCompass !== on.Visible &&
        (this._map._showsCompass !== on.Adaptive || this._map._usingDefaultShowsCompassValue) &&
        0 === this._map.rotation &&
        !this._map._annotationsController.containsMarkerAnnotation()
      );
    }
  }),
    (er.InitialOptionsHandlers = []),
    (ir.prototype = r(fo.Opacity, ir, {
      update: function (t) {
        (this.customCanvas && (this.customCanvas.style.opacity = this.valueAt(t)),
          fo.Opacity.prototype.update.call(this, t));
      }
    })));
  const nr = er,
    or = (t, e, i) => {
      const n = t.createShader(e);
      if ((t.shaderSource(n, i), t.compileShader(n), t.getShaderParameter(n, t.COMPILE_STATUS))) return n;
      t.deleteShader(n);
    },
    sr = function (t) {
      this._impl = {
        scene: t,
        failed: !1,
        prepare(t) {
          if (this.failed) return;
          const e = or(
              t,
              t.VERTEX_SHADER,
              "\nattribute vec2 a_position;\nvarying vec2 v_texcoord;\nvoid main() {\n gl_Position = vec4((a_position * 2.0 - 1.0) * vec2(1, -1), 0, 1);\n v_texcoord = a_position;\n}\n"
            ),
            i = or(
              t,
              t.FRAGMENT_SHADER,
              "precision mediump float;\nvarying vec2 v_texcoord;\nuniform sampler2D u_texture;\nvoid main() {\n gl_FragColor = texture2D(u_texture, v_texcoord);\n}"
            );
          this.program = ((t, e, i) => {
            const n = t.createProgram();
            if ((t.attachShader(n, e), t.attachShader(n, i), t.linkProgram(n), t.getProgramParameter(n, t.LINK_STATUS)))
              return n;
            t.deleteProgram(n);
          })(t, e, i);
        },
        release(t) {
          this.failed || t.deleteProgram(this.program);
        },
        added(t) {
          this.prepare(t);
        },
        removed(t) {
          this.release(t);
        },
        render(t, e) {
          if (this.failed) return;
          const i = this.program,
            n = t.getAttribLocation(i, "a_position"),
            o = t.getUniformLocation(i, "u_texture"),
            s = t.createBuffer();
          t.bindBuffer(t.ARRAY_BUFFER, s);
          const a = t.canvas.width,
            r = t.canvas.height;
          (t.viewport(0, 0, a, r),
            t.useProgram(this.program),
            t.enableVertexAttribArray(n),
            t.bindBuffer(t.ARRAY_BUFFER, s));
          const l = t.createTexture();
          (t.bindTexture(t.TEXTURE_2D, l),
            t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, this.scene.element),
            t.generateMipmap(t.TEXTURE_2D),
            t.bufferData(t.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]), t.STATIC_DRAW),
            t.vertexAttribPointer(n, 2, t.FLOAT, !1, 0, 0),
            t.uniform1i(o, 0),
            t.enable(t.BLEND),
            t.blendFuncSeparate(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA, t.ONE, t.ONE_MINUS_SRC_ALPHA),
            t.drawArrays(t.TRIANGLES, 0, 6));
        },
        contextLost(t) {
          this.release(t);
        },
        contextRestored(t) {
          this.prepare(t);
        },
        contextFailed() {
          this.failed = !0;
        }
      };
    },
    ar = {
      "logo-autonavi": {xMin: 0.132, xMax: 0.828},
      "logo-autonavi-rtl": {xMin: 0.127, xMax: 0.833},
      "logo-autonavi-satellite": {xMin: 0.132, xMax: 0.828},
      "logo-autonavi-satellite-rtl": {xMin: 0.186, xMax: 0.862},
      "logo-wordmark-ar-SA": {xMin: 0.36, xMax: 0.996},
      "logo-wordmark-ca-ES": {xMin: 0.003, xMax: 0.631},
      "logo-wordmark-cs-CZ": {xMin: 0.003, xMax: 0.546},
      "logo-wordmark-da-DK": {xMin: 0.003, xMax: 0.434},
      "logo-wordmark-de-DE": {xMin: 0.003, xMax: 0.616},
      "logo-wordmark-el-GR": {xMin: 0.003, xMax: 0.681},
      "logo-wordmark-en-US": {xMin: 0.003, xMax: 0.539},
      "logo-wordmark-en-GB": {xMin: 0.003, xMax: 0.539},
      "logo-wordmark-es-ES": {xMin: 0.003, xMax: 0.63},
      "logo-wordmark-fr-CA": {xMin: 0.003, xMax: 0.533},
      "logo-wordmark-fi-FI": {xMin: 0.003, xMax: 0.578},
      "logo-wordmark-fr-FR": {xMin: 0.003, xMax: 0.533},
      "logo-wordmark-he-IL": {xMin: 0.491, xMax: 0.996},
      "logo-wordmark-hi-IN": {xMin: 0.003, xMax: 0.523},
      "logo-wordmark-hr-HR": {xMin: 0.003, xMax: 0.523},
      "logo-wordmark-hu-HU": {xMin: 0.003, xMax: 0.807},
      "logo-wordmark-es-MX": {xMin: 0.003, xMax: 0.63},
      "logo-wordmark-id-ID": {xMin: 0.003, xMax: 0.454},
      "logo-wordmark-ja-JP": {xMin: 0.003, xMax: 0.506},
      "logo-wordmark-ko-KR": {xMin: 0.003, xMax: 0.407},
      "logo-wordmark-it-IT": {xMin: 0.003, xMax: 0.644},
      "logo-wordmark-ms-MY": {xMin: 0.003, xMax: 0.454},
      "logo-wordmark-nb-NO": {xMin: 0.003, xMax: 0.432},
      "logo-wordmark-nl-NL": {xMin: 0.003, xMax: 0.704},
      "logo-wordmark-pt-BR": {xMin: 0.003, xMax: 0.63},
      "logo-wordmark-pl-PL": {xMin: 0.003, xMax: 0.546},
      "logo-wordmark-pt-PT": {xMin: 0.003, xMax: 0.63},
      "logo-wordmark-ru-RU": {xMin: 0.003, xMax: 0.605},
      "logo-wordmark-ro-RO": {xMin: 0.003, xMax: 0.488},
      "logo-wordmark-satellite-ar-SA": {xMin: 0.357, xMax: 0.996},
      "logo-wordmark-satellite-ca-ES": {xMin: 0.003, xMax: 0.635},
      "logo-wordmark-satellite-de-DE": {xMin: 0.003, xMax: 0.62},
      "logo-wordmark-satellite-da-DK": {xMin: 0.003, xMax: 0.437},
      "logo-wordmark-satellite-cs-CZ": {xMin: 0.003, xMax: 0.551},
      "logo-wordmark-satellite-en-GB": {xMin: 0.003, xMax: 0.542},
      "logo-wordmark-satellite-en-US": {xMin: 0.003, xMax: 0.542},
      "logo-wordmark-satellite-es-ES": {xMin: 0.003, xMax: 0.633},
      "logo-wordmark-satellite-es-MX": {xMin: 0.003, xMax: 0.633},
      "logo-wordmark-satellite-el-GR": {xMin: 0.003, xMax: 0.685},
      "logo-wordmark-satellite-fr-CA": {xMin: 0.003, xMax: 0.537},
      "logo-wordmark-satellite-fi-FI": {xMin: 0.003, xMax: 0.581},
      "logo-wordmark-satellite-he-IL": {xMin: 0.487, xMax: 0.997},
      "logo-wordmark-satellite-fr-FR": {xMin: 0.003, xMax: 0.537},
      "logo-wordmark-satellite-hu-HU": {xMin: 0.003, xMax: 0.814},
      "logo-wordmark-satellite-hi-IN": {xMin: 0.003, xMax: 0.525},
      "logo-wordmark-satellite-hr-HR": {xMin: 0.003, xMax: 0.523},
      "logo-wordmark-satellite-id-ID": {xMin: 0.003, xMax: 0.458},
      "logo-wordmark-satellite-it-IT": {xMin: 0.003, xMax: 0.648},
      "logo-wordmark-satellite-ja-JP": {xMin: 0.003, xMax: 0.51},
      "logo-wordmark-satellite-ko-KR": {xMin: 0.003, xMax: 0.41},
      "logo-wordmark-satellite-nl-NL": {xMin: 0.003, xMax: 0.707},
      "logo-wordmark-satellite-nb-NO": {xMin: 0.003, xMax: 0.435},
      "logo-wordmark-satellite-ms-MY": {xMin: 0.003, xMax: 0.458},
      "logo-wordmark-satellite-pt-BR": {xMin: 0.003, xMax: 0.633},
      "logo-wordmark-satellite-pl-PL": {xMin: 0.003, xMax: 0.551},
      "logo-wordmark-satellite-pt-PT": {xMin: 0.003, xMax: 0.633},
      "logo-wordmark-satellite-ro-RO": {xMin: 0.003, xMax: 0.492},
      "logo-wordmark-satellite-ru-RU": {xMin: 0.003, xMax: 0.608},
      "logo-wordmark-satellite-sk-SK": {xMin: 0.003, xMax: 0.551},
      "logo-wordmark-satellite-sl-SI": {xMin: 0.003, xMax: 0.881},
      "logo-wordmark-satellite-sv-SE": {xMin: 0.003, xMax: 0.588},
      "logo-wordmark-satellite-th-TH": {xMin: 0.003, xMax: 0.542},
      "logo-wordmark-satellite-tr-TR": {xMin: 0.003, xMax: 0.574},
      "logo-wordmark-satellite-uk-UA": {xMin: 0.003, xMax: 0.588},
      "logo-wordmark-satellite-vi-VN": {xMin: 0.003, xMax: 0.636},
      "logo-wordmark-satellite-zh-CN": {xMin: 0.003, xMax: 0.407},
      "logo-wordmark-satellite-zh-HK": {xMin: 0.003, xMax: 0.407},
      "logo-wordmark-satellite-zh-TW": {xMin: 0.003, xMax: 0.407},
      "logo-wordmark-sv-SE": {xMin: 0.003, xMax: 0.585},
      "logo-wordmark-sk-SK": {xMin: 0.003, xMax: 0.546},
      "logo-wordmark-sl-SI": {xMin: 0.003, xMax: 0.882},
      "logo-wordmark-th-TH": {xMin: 0.003, xMax: 0.539},
      "logo-wordmark-vi-VN": {xMin: 0.003, xMax: 0.633},
      "logo-wordmark-zh-CN": {xMin: 0.003, xMax: 0.403},
      "logo-wordmark-tr-TR": {xMin: 0.003, xMax: 0.571},
      "logo-wordmark-uk-UA": {xMin: 0.003, xMax: 0.584},
      "logo-wordmark-zh-HK": {xMin: 0.003, xMax: 0.403},
      "logo-wordmark-zh-TW": {xMin: 0.003, xMax: 0.403}
    };
  function rr(t, e, i) {
    const n = t._logoUpdatedDelegate,
      o = (function (t, e) {
        let i = ["logo-wordmark"];
        return (
          dt.isAutoNavi && (i = ["logo", "autonavi"]),
          t && i.push("satellite"),
          dt.isAutoNavi && e && i.push("rtl"),
          dt.isAutoNavi || i.push(fi.localeId),
          i.join("-")
        );
      })(i, t.rtl),
      s = "logos/" + o,
      a = dt.isAutoNavi,
      r = a ? [1, 2, 3] : [1],
      l = a || 1 === qn.devicePixelRatio ? ".png" : ".svg",
      h = ar[o];
    (h && n && n.logoUpdated && n.logoUpdated(h),
      e.classList.toggle("mk-logo-autonavi", dt.isAutoNavi),
      (e.element.crossOrigin = ms.getCorsAttribute(dt.distUrlWithCredentials)),
      e.setAttribute("src", oe.createImageUrl(qn.imagePathForDevice(r, s, l))));
  }
  const lr = class extends bn {
    constructor() {
      const t = qn.htmlElement("img");
      (super(qn.htmlElement("div", {class: "mk-logo-control"}, t)),
        (this._logoElement = t),
        (this._logoElementNode = new bn(this._logoElement)),
        this._logoElementNode.classList.add("mk-logo"),
        (this.tint = void 0),
        fi.addEventListener(fi.Events.LocaleChanged, this),
        dt.addEventListener(dt.Events.Changed, this),
        (this.rtl = fi.activeLocale.rtl));
    }
    setUpdatedDelegate(t) {
      this._logoUpdatedDelegate = t;
    }
    updateWithMapNodeTint(t) {
      this.tint = t;
      const e = qn.darkColorScheme(t),
        i = this._logoElementNode;
      dt.state === dt.States.UNINITIALIZED
        ? dt.addEventListener(dt.Events.Initialized, function t() {
            (dt.removeEventListener(dt.Events.Initialized, t), rr(this, i, e));
          })
        : rr(this, i, e);
      const n = dt.tileProvider ? dt.tileProvider : dt.TileProviders.Apple;
      i.setAttribute("alt", fi.get("Logo." + n + ".Tooltip"));
    }
    handleEvent(t) {
      switch (t.type) {
        case fi.Events.LocaleChanged:
          ((this.rtl = t.locale.rtl), this._handleLocaleChange(t));
          break;
        case dt.Events.Changed:
          if (!this.tint) return;
          this.updateWithMapNodeTint(this.tint);
      }
    }
    mapWasDestroyed() {
      (fi.removeEventListener(fi.Events.LocaleChanged, this), dt.removeEventListener(dt.Events.Changed, this));
    }
    _handleLocaleChange(t) {
      this.tint && this.updateWithMapNodeTint(this.tint);
    }
  };
  class hr extends Rn.Node {
    constructor() {
      (super(qn.htmlElement("a", {target: "_blank", tabindex: 0})), this.classList.add("mk-legal"));
      const t = qn.htmlElement("span");
      ((t.textContent = fi.get("Legal.Label")),
        (this._labelNode = new Rn.Node(t)),
        this._labelNode.classList.add("mk-legal-label"),
        this.element.appendChild(this._labelNode.element),
        (this._handleKeyPressEventListener = (t) => this._handleKeyPressEvent(t)));
    }
    updateWithMapType(t) {
      if (((this.mapType = t), (this._labelNode.element.textContent = fi.get("Legal.Label")), dt.isAutoNavi))
        if (dt.ready) {
          const t = dt.types[this.mapType].tileSources[0];
          t.attribution && t.attribution.url && this.setAttribute("href", t.attribution.url);
        } else this.removeAttribute("href");
      else this.setAttribute("href", fi.get("Legal.Apple.URL"));
    }
    willMoveToParent(t) {
      t
        ? this.parent ||
          ((this._handleLocaleChangedListener = (t) => this._handleLocaleChanged(t)),
          fi.addEventListener(fi.Events.LocaleChanged, this._handleLocaleChangedListener),
          this.element.addEventListener("keypress", this._handleKeyPressEventListener))
        : (fi.removeEventListener(fi.Events.LocaleChanged, this._handleLocaleChangedListener),
          this.element.removeEventListener("keypress", this._handleKeyPressEventListener));
    }
    _handleLocaleChanged(t) {
      this.mapType && this.updateWithMapType(this.mapType);
    }
    _handleKeyPressEvent(t) {
      "Space" === t.code && (t.preventDefault(), this.element.click());
    }
  }
  const cr = hr;
  class dr extends bn {
    constructor(t) {
      (super(t),
        this.classList.add(ur.CONTROL),
        void 0 === this._enabled && (this._enabled = !1),
        void 0 === this.hasFocus && (this.hasFocus = !1),
        void 0 === this.pageHasFocus && (this.pageHasFocus = !1));
    }
    get enabled() {
      return this._enabled;
    }
    set enabled(t) {
      const e = !!t;
      this._enabled !== e && (e ? this.enable() : this.disable(), (this._enabled = e), this.reset());
    }
    set canShowTooltips(t) {
      t ? this._updateLabels() : this._clearLabels();
    }
    willMoveToParent(t) {
      t
        ? this.parent ||
          (this._createListeners(),
          fi.addEventListener(fi.Events.LocaleChanged, this._eventListener),
          this.enabled && (this._addFocusAndBlurListeners(), this._addKeyboardListeners(), this.addEventListeners()))
        : (fi.removeEventListener(fi.Events.LocaleChanged, this._eventListener),
          this.removeEventListeners(),
          this._removeFocusAndBlurListeners(),
          this._removeKeyboardListeners(),
          this._destroyListeners());
    }
    enable() {
      (this.classList.remove(ur.DISABLED),
        this._createListeners(),
        this.element.addEventListener(qn.startEventType, this._eventListener),
        this.element.addEventListener("click", this._eventListener),
        this.parent && (this._addFocusAndBlurListeners(), this._addKeyboardListeners(), this.addEventListeners()));
    }
    disable() {
      (this.classList.add(ur.DISABLED),
        this.element.removeEventListener(qn.startEventType, this._eventListener),
        this.element.removeEventListener("click", this._eventListener),
        this.removeEventListeners(),
        this._removeFocusAndBlurListeners(),
        this._removeKeyboardListeners());
    }
    blurFocusedElement(t) {
      const e = qn.getShadowDOMTargetFromEvent(this.element, t);
      if (!this.element.contains(e)) {
        const t = qn.containingDocumentOrShadowRoot(this.element);
        t.activeElement && this.element.contains(t.activeElement) && t.activeElement.blur();
      }
    }
    reset() {}
    saveEndEventProps(t) {
      if (t && t.type === qn.endEventType) {
        const e = t.changedTouches ? t.changedTouches[0] : t;
        this._endEventProps = [e.clientX, e.clientY, e.screenX, e.screenY];
      }
    }
    checkClickEventProps(t) {
      if (!this._endEventProps) return !1;
      const e = [t.clientX, t.clientY, t.screenX, t.screenY];
      let i = !0;
      for (let t = 0; t < e.length; t++)
        if (Math.abs(this._endEventProps[t] - e[t]) > 1) {
          i = !1;
          break;
        }
      return (delete this._endEventProps, i);
    }
    clicked() {}
    touchesBegan(t) {}
    touchesMoved(t) {}
    touchesEnded(t) {}
    touchesCanceled(t) {}
    spaceBarKeyDown(t) {}
    spaceBarKeyUp(t) {}
    escapeKeyDown(t) {}
    escapeKeyUp(t) {}
    downArrowKeyUp(t) {}
    downArrowKeyDown(t) {}
    upArrowKeyUp(t) {}
    upArrowKeyDown(t) {}
    rightArrowKeyUp(t) {}
    leftArrowKeyUp(t) {}
    rightArrowKeyDown(t) {}
    leftArrowKeyDown(t) {}
    focused(t) {}
    blurred(t) {}
    pageDidFocus(t) {}
    pageDidBlur(t) {}
    updateTintColor(t) {}
    removeEventListeners() {}
    addEventListeners() {}
    localeChanged() {}
    _clearLabels() {
      qn.updateLabel(this.element, "");
    }
    _createListeners() {
      (this._eventListener || (this._eventListener = new pr(this)),
        this._windowEventListener || (this._windowEventListener = new gr(this)),
        this._cancelFocusEventListener || (this._cancelFocusEventListener = new mr(this)));
    }
    _destroyListeners() {
      (this._eventListener &&
        (this.element.removeEventListener(qn.startEventType, this._eventListener),
        this.element.removeEventListener("click", this._eventListener),
        this._eventListener.destroy(),
        delete this._eventListener),
        this._windowEventListener && (this._windowEventListener.destroy(), delete this._windowEventListener),
        this._cancelFocusEventListener &&
          (this._cancelFocusEventListener.destroy(), delete this._cancelFocusEventListener));
    }
    _addFocusAndBlurListeners() {
      (this.element.addEventListener("focus", this._eventListener, !0),
        this.element.addEventListener("blur", this._eventListener, !0),
        window.addEventListener("focus", this._windowEventListener),
        window.addEventListener("blur", this._windowEventListener),
        (this.hasFocus = qn.containingDocumentOrShadowRoot(this.element).activeElement === this.element));
    }
    _removeFocusAndBlurListeners() {
      (this.element.removeEventListener("focus", this._eventListener, !0),
        this.element.removeEventListener("blur", this._eventListener, !0),
        window.removeEventListener(qn.startEventType, this._cancelFocusEventListener, !0),
        window.removeEventListener("focus", this._windowEventListener),
        window.removeEventListener("blur", this._windowEventListener));
    }
    _addKeyboardListeners() {
      (this.element.addEventListener("keydown", this._eventListener),
        this.element.addEventListener("keyup", this._eventListener));
    }
    _removeKeyboardListeners() {
      (this.element.removeEventListener("keydown", this._eventListener),
        this.element.removeEventListener("keyup", this._eventListener));
    }
  }
  const ur = {CONTROL: "mk-control", DISABLED: "mk-disabled", FOCUS: "mk-focus"};
  function pr(t) {
    this._control = t;
  }
  function mr(t) {
    this._control = t;
  }
  function gr(t) {
    this._control = t;
  }
  (M.EventTarget(dr.prototype),
    (pr.prototype = {
      destroy: function () {
        (window.removeEventListener(qn.startEventType, this._control._cancelFocusEventListener, !0),
          this._removeEventListeners(),
          delete this._control);
      },
      handleEvent: function (t) {
        switch (t.type) {
          case "click":
            this._click(t);
            break;
          case qn.startEventType:
            this._touchesBegan(t);
            break;
          case qn.moveEventType:
            this._control.touchesMoved(t);
            break;
          case qn.endEventType:
            (this._removeEventListeners(), this._control.touchesEnded(t));
            break;
          case qn.cancelEventType:
            (this._removeEventListeners(), this._control.touchesCanceled(t));
            break;
          case "keydown":
            this._keyDown(t);
            break;
          case "keyup":
            this._keyUp(t);
            break;
          case "focus":
            this._focus(t);
            break;
          case "blur":
            this._blur(t);
            break;
          case fi.Events.LocaleChanged:
            this._control.localeChanged(t);
        }
      },
      _click: function (t) {
        (this._swallowEvent(t), this._control.clicked(t));
      },
      _touchesBegan: function (t) {
        (this._swallowEvent(t),
          (("mousedown" === t.type || ("pointerdown" === t.type && "mouse" === t.pointerType)) &&
            (0 !== t.button || t.ctrlKey)) ||
            (window.addEventListener(qn.moveEventType, this, !0),
            window.addEventListener(qn.endEventType, this, !0),
            qn.cancelEventType && window.addEventListener(qn.cancelEventType, this, !0),
            this._control.touchesBegan(t)));
      },
      _keyDown: function (t) {
        switch (t.keyCode) {
          case 27:
            this._control.escapeKeyDown(t);
            break;
          case 32:
            (t.preventDefault(), this._control.spaceBarKeyDown(t));
            break;
          case 40:
            (t.preventDefault(), this._control.downArrowKeyDown(t));
            break;
          case 38:
            (t.preventDefault(), this._control.upArrowKeyDown(t));
            break;
          case 39:
            (t.preventDefault(), this._control.rightArrowKeyDown(t));
            break;
          case 37:
            (t.preventDefault(), this._control.leftArrowKeyDown(t));
        }
      },
      _keyUp: function (t) {
        switch (t.keyCode) {
          case 27:
            this._control.escapeKeyUp(t);
            break;
          case 40:
            (t.preventDefault(), this._control.downArrowKeyUp(t));
            break;
          case 38:
            (t.preventDefault(), this._control.upArrowKeyUp(t));
            break;
          case 39:
            (t.preventDefault(), this._control.rightArrowKeyUp(t));
            break;
          case 37:
            (t.preventDefault(), this._control.leftArrowKeyUp(t));
            break;
          case 32:
            (t.preventDefault(), this._control.spaceBarKeyUp(t));
        }
      },
      _focus: function (t) {
        this._control.hasFocus ||
          (qn.containingDocumentOrShadowRoot(this._control.element).activeElement === t.target &&
            ((this._control.hasFocus = !0),
            this._control.classList.add(ur.FOCUS),
            window.addEventListener(qn.startEventType, this._control._cancelFocusEventListener, !0),
            this._control.focused(t)));
      },
      _blur: function (t) {
        this._control.hasFocus &&
          ((this._control.hasFocus = !1),
          window.removeEventListener(qn.startEventType, this._control._cancelFocusEventListener, !0),
          this._control.classList.remove(ur.FOCUS),
          this._control.blurred(t));
      },
      _removeEventListeners: function () {
        (window.removeEventListener(qn.moveEventType, this, !0),
          window.removeEventListener(qn.endEventType, this, !0),
          qn.cancelEventType && window.removeEventListener(qn.cancelEventType, this, !0));
      },
      _swallowEvent: function (t) {
        (t.preventDefault(), t.stopPropagation());
      }
    }),
    (mr.prototype = {
      destroy: function () {
        delete this._control;
      },
      handleEvent: function (t) {
        this._control.blurFocusedElement(t);
      }
    }),
    (gr.prototype = {
      destroy: function () {
        delete this._control;
      },
      handleEvent: function (t) {
        switch (t.type) {
          case "focus":
            this._control.pageHasFocus || ((this._control.pageHasFocus = !0), this._control.pageDidFocus(t));
            break;
          case "blur":
            ((this._control.pageHasFocus = !1), this._control.pageDidBlur(t));
        }
      }
    }));
  const _r = dr,
    fr = "mk-popover",
    yr = "mk-popover-arrow",
    vr = "mk-shown",
    wr = class extends bn {
      constructor() {
        (super(qn.htmlElement("div", {class: fr, role: "dialog", tabindex: "-1"})),
          this.element.appendChild(
            qn.createSVGIcon(
              qn.svgElement(
                "g",
                qn.svgElement("rect", {y: 12, x: 0, height: 2, width: 30}),
                qn.svgElement("path", {
                  d: "M0 13v-.5c4.038 0 8.305-3.53 12.835-10.477.454-.71 1.005-1.137 1.564-1.326h.001a2.07 2.07 0 011.814.225c.273.175.505.407.68.68C21.525 8.829 25.881 12.5 30 12.5v.5"
                })
              ),
              {class: yr, "aria-hidden": !0, width: 30, height: 14}
            )
          ));
      }
      open() {
        this.classList.add(vr);
      }
      handleEvent(t) {
        this.classList.contains(vr) && this.focus();
      }
      focus() {
        this.element.focus();
      }
      close() {
        this.classList.remove(vr);
      }
      didMoveToParent(t) {
        t
          ? this.element.addEventListener("transitionend", this)
          : this.element.removeEventListener("transitionend", this);
      }
    };
  class br extends Rn.Node {
    constructor(t, e, i) {
      (super(qn.htmlElement("label", {class: Cr.CONTROL})),
        (this.delegate = i),
        (this.mapType = t),
        (this.enabled = !1),
        (this._handleChangeEventListener = () => this._handleChangeEvent()));
      const n = i.mapTypes[t] === i.mapType,
        o = fi.get("Mode." + t),
        s = qn.htmlElement("input", {type: "radio", name: e, "aria-label": o, tabindex: "0"});
      ((s.checked = n), (this.radioElement = s), this.element.appendChild(s));
      const a = (function (t, e) {
        const i = [];
        return (
          e[t] === e.Standard
            ? (i.push(
                qn.htmlElement("img", {
                  class: Cr.LIGHT_ICON,
                  "aria-hidden": !0,
                  crossOrigin: ms.getCorsAttribute(dt.distUrlWithCredentials),
                  src: kr(t, !1)
                })
              ),
              i.push(
                qn.htmlElement("img", {
                  class: Cr.DARK_ICON,
                  "aria-hidden": !0,
                  crossOrigin: ms.getCorsAttribute(dt.distUrlWithCredentials),
                  src: kr(t, !0)
                })
              ))
            : i.push(
                qn.htmlElement("img", {
                  "aria-hidden": !0,
                  crossOrigin: ms.getCorsAttribute(dt.distUrlWithCredentials),
                  src: kr(t, !1)
                })
              ),
          i
        );
      })(t, i.mapTypes);
      a.forEach((t) => this.element.appendChild(t));
    }
    focus() {
      this.radioElement.focus();
    }
    setSelected() {
      this.element.firstChild.checked = !0;
    }
    updateLabels() {
      const t = fi.get("Mode." + this.mapType);
      this.radioElement.setAttribute("aria-label", t);
    }
    activate() {
      (this.radioElement.addEventListener("change", this._handleChangeEventListener), this._handleChangeEvent());
    }
    deactivate() {
      this.radioElement.removeEventListener("change", this._handleChangeEventListener);
    }
    _handleChangeEvent() {
      this.radioElement.checked && this._handleSelected(this.radioElement.checked);
    }
    _handleSelected() {
      this.delegate.mapType = this.delegate.mapTypes[this.mapType];
    }
  }
  const Cr = {CONTROL: "mk-map-type-button", LIGHT_ICON: "mk-light-icon", DARK_ICON: "mk-dark-icon"};
  function kr(t, e) {
    const i = ["icons/map-type"];
    return (
      i.push(t.toLowerCase()),
      e && i.push("dark"),
      oe.createImageUrl(qn.imagePathForDevice([1, 2], i.join("-"), ".png"))
    );
  }
  const Mr = br,
    Sr = ["Standard", "Hybrid", "Satellite"],
    Lr = "mk-map-type-popover",
    Ar = "mk-map-type-label",
    Er = class extends wr {
      constructor(t) {
        (super(),
          this.classList.add(Lr),
          this.setAttribute("aria-label", fi.get("MapType.Tooltip")),
          (this.delegate = t),
          (this.buttons = {}),
          (this.labels = {}));
        const e = `mk-map-type-button-${Math.random().toString(32).substring(2)}`;
        Sr.forEach((i) => {
          const n = new bn(),
            o = new Mr(i, e, t);
          n.addChild(o);
          const s = new bn(qn.htmlElement("div", {"aria-hidden": "true", class: Ar}));
          ((s.element.textContent = fi.get("Mode." + i)),
            n.addChild(s),
            this.addChild(n),
            (this.buttons[i] = o),
            (this.labels[i] = s),
            t.mapTypes[i] === t.mapType && (this.selectedButton = o));
        });
      }
      focus() {
        this.selectedButton.focus();
      }
      updateSelected() {
        const t = Sr.find((t) => this.delegate.mapTypes[t] === this.delegate.mapType);
        ((this.selectedButton = this.buttons[t]), this.selectedButton.setSelected());
      }
      updateLabels() {
        (this.setAttribute("aria-label", fi.get("MapType.Tooltip")),
          Sr.forEach((t) => {
            ((this.labels[t].element.textContent = fi.get("Mode." + t)), this.buttons[t].updateLabels());
          }));
      }
      didMoveToParent(t) {
        (super.didMoveToParent(t),
          t ? Sr.forEach((t) => this.buttons[t].activate()) : Sr.forEach((t) => this.buttons[t].deactivate()));
      }
    };
  function xr(t) {
    this._control = t;
  }
  xr.prototype = {
    constructor: xr,
    get mapTypes() {
      return this._control.mapTypes;
    },
    get mapType() {
      return this._control.mapType;
    },
    set mapType(t) {
      this._control.mapType = t;
    }
  };
  const Tr = "mk-pressed";
  class Ir extends _r {
    constructor(t, e, i) {
      (super(qn.htmlElement("div", {role: "button", tabindex: "0"})),
        this.classList.add("mk-map-type-control"),
        (this._delegate = new xr(this)),
        (this._focusDelegate = i));
      const n = (function () {
        const t = qn.svgElement("path"),
          e = qn.createSVGIcon(t, {});
        return (e.setAttribute("viewBox", "0 0 45 24"), [e, t]);
      })();
      (this.element.appendChild(n[0]),
        (this._iconElement = n[1]),
        (this._mapType = e),
        (this._mapTypes = t),
        this._updateIcon(),
        this._updateLabels(),
        (this.enabled = !0),
        (this._isOpen = !1));
    }
    get mapType() {
      return this._mapType;
    }
    set mapType(t) {
      t !== this._mapType &&
        ((this._mapType = t),
        this._updateIcon(),
        this.popover.updateSelected(),
        this.dispatchEvent(new M.Event(Ir.EVENTS.MAP_TYPE_CHANGE)));
    }
    get mapTypes() {
      return this._mapTypes;
    }
    localeChanged(t) {
      (this._updateLabels(), this.popover.updateLabels());
    }
    touchesBegan(t) {
      this._pressed();
    }
    touchesEnded(t) {
      this.reset();
    }
    clicked(t) {
      this._toggle();
    }
    touchesCanceled(t) {
      this.reset();
    }
    spaceBarKeyDown(t) {
      this._pressed();
    }
    spaceBarKeyUp(t) {
      (this.reset(), this._open(!0));
    }
    updateTintColor(t) {
      ((this.tintColor = t), (this._iconElement.style.fill = t));
    }
    reset() {
      (this.classList.remove(Tr), this._focusDelegate.controlWasReleased(this));
    }
    handleEvent(t) {
      switch (t.type) {
        case qn.startEventType: {
          const e = qn.getShadowDOMTargetFromEvent(this.element, t);
          this.popover.element.contains(e) || this.element.contains(e) || this._close();
          break;
        }
        case "keydown":
          if (((t) => 27 === t.keyCode)(t)) {
            this._close();
            const t = qn.containingDocumentOrShadowRoot(this.element).activeElement;
            t && this.popover.element.contains(t) && this.element.focus();
          }
          break;
        case "blur":
          this.popover.element.contains(t.relatedTarget) || this._close();
      }
    }
    didMoveToParent(t) {
      t
        ? ((this.popover = new Er(this._delegate)), this.parent.insertAfter(this.popover, this))
        : (window.removeEventListener(qn.startEventType, this, !0),
          window.removeEventListener("keydown", this, !0),
          this.popover.element.removeEventListener("blur", this, !0),
          this.popover.remove(),
          (this.popover = null));
    }
    focused(t) {
      this._focusDelegate.controlDidGetFocus(this);
    }
    blurred(t) {
      this._focusDelegate.controlDidLoseFocus(this);
    }
    _updateLabels() {
      qn.updateLabel(this, fi.get("MapType.Tooltip"));
    }
    _toggle() {
      this._isOpen ? this._close() : this._open();
    }
    _pressed() {
      (this.classList.add(Tr), this._focusDelegate.controlWasPressed(this));
    }
    _open() {
      this._isOpen ||
        ((this._isOpen = !0),
        this.popover.open(),
        window.addEventListener(qn.startEventType, this, !0),
        window.addEventListener("keydown", this, !0),
        this.popover.element.addEventListener("blur", this, !0));
    }
    _close() {
      this._isOpen &&
        ((this._isOpen = !1),
        this.popover.close(),
        window.removeEventListener(qn.startEventType, this, !0),
        window.removeEventListener("keydown", this, !0),
        this.popover.element.removeEventListener("blur", this, !0));
    }
    _handleLocaleChange() {
      this.children.forEach(function (t) {
        const e = t.element.getAttribute("data-l10n-key");
        t.element.textContent = fi.get(e);
      });
    }
    _updateIcon() {
      this._iconElement.setAttribute("d", Rr[this._mapType]);
    }
  }
  Ir.EVENTS = {MAP_TYPE_CHANGE: "map-type-change"};
  const Rr = {
      standard:
        "M24.597 18.663V8.233L21.53 6.369a1.83 1.83 0 00-.413-.178v10.569l3.136 1.764c.06.03.116.058.171.083a.815.815 0 00.172.057zm-7.548-.178c.17 0 .356-.057.559-.171l2.615-1.416V6.285c-.06.026-.125.055-.197.089-.072.034-.14.07-.203.108l-2.958 1.695c-.199.11-.346.246-.44.41a1.118 1.118 0 00-.144.574v8.544c0 .25.07.442.207.577.137.136.324.203.561.203zm8.436.153a.641.641 0 00.204-.09l3.269-1.853c.203-.114.352-.251.447-.412.095-.161.143-.354.143-.578V7.18c0-.254-.07-.447-.21-.58-.14-.134-.332-.2-.577-.2-.17 0-.358.057-.565.17l-2.71 1.505v10.563z",
      hybrid:
        "M22.918 13.579c.13 0 .262-.023.393-.067.131-.044.275-.111.432-.2l4.951-2.875c.267-.157.456-.303.568-.438a.741.741 0 00.168-.49.724.724 0 00-.168-.475c-.112-.136-.301-.282-.568-.438L23.743 5.72a2.539 2.539 0 00-.432-.2 1.22 1.22 0 00-.79 0c-.129.045-.274.111-.435.2l-4.951 2.876c-.267.156-.456.302-.568.438a.724.724 0 00-.168.476c0 .19.056.353.168.489.112.135.301.28.568.438l4.951 2.875c.161.089.306.156.435.2.13.044.261.067.397.067zm0 3.135a.81.81 0 00.343-.076c.11-.05.237-.116.38-.197l5.409-3.192a.775.775 0 00.292-.28.656.656 0 00.095-.33.601.601 0 00-.12-.374.81.81 0 00-.267-.235l-5.847 3.377c-.055.034-.105.06-.152.08a.352.352 0 01-.133.028.366.366 0 01-.14-.029 1.063 1.063 0 01-.152-.08L16.78 12.03a.81.81 0 00-.267.235.601.601 0 00-.12.374c0 .11.032.22.098.33.065.11.164.203.295.28l5.402 3.192c.144.08.27.146.38.197.11.051.227.076.35.076zm0 2.94a.81.81 0 00.343-.077c.11-.05.237-.118.38-.203l5.409-3.186a.825.825 0 00.288-.277.644.644 0 00.099-.34.582.582 0 00-.12-.361.887.887 0 00-.267-.241l-5.847 3.383a2.55 2.55 0 01-.152.076.322.322 0 01-.133.032.335.335 0 01-.14-.032 2.55 2.55 0 01-.152-.076L16.78 14.97a.887.887 0 00-.267.241.582.582 0 00-.12.362c0 .118.032.231.098.34.065.107.164.2.295.275l5.402 3.187c.144.085.27.152.38.203.11.05.227.076.35.076z",
      satellite:
        "M22.915 18.923c.888 0 1.725-.169 2.51-.507a6.62 6.62 0 002.079-1.41 6.62 6.62 0 001.41-2.079 6.271 6.271 0 00.507-2.51c0-.889-.17-1.726-.508-2.51a6.583 6.583 0 00-1.41-2.076 6.682 6.682 0 00-2.081-1.41 6.26 6.26 0 00-2.514-.51c-.888 0-1.725.17-2.51.51a6.654 6.654 0 00-3.482 3.485 6.271 6.271 0 00-.508 2.511c0 .889.17 1.725.508 2.51a6.62 6.62 0 001.41 2.08c.6.6 1.293 1.07 2.078 1.409a6.271 6.271 0 002.51.507zm0-.92c-.762 0-1.48-.147-2.155-.441a5.732 5.732 0 01-1.781-1.21 5.687 5.687 0 01-1.206-1.78 5.37 5.37 0 01-.438-2.155c0-.762.146-1.479.438-2.152.209-.48.473-.92.794-1.32l.188-.222-.068.254a4.38 4.38 0 00-.127 1.04c0 .695.23 1.23.689 1.607.459.376 1.114.564 1.964.564.115 0 .196.04.245.121.048.08.041.171-.022.273a2.875 2.875 0 00-.311.584c-.055.157-.083.32-.083.489 0 .283.069.525.206.723.138.2.304.361.499.486a3.2 3.2 0 00.57.295l-.247.997c-.076.296-.039.53.111.704.15.174.348.26.594.26.245 0 .478-.114.698-.342l1.543-1.67c.258-.275.443-.524.555-.749.112-.224.168-.448.168-.672a1.11 1.11 0 00-.11-.426 3.165 3.165 0 00-.664-.958 1.378 1.378 0 00-.594-.337 3.345 3.345 0 00-.784-.076h-.342l-.35-.685.965-.362c.271.178.487.313.648.406.16.093.317.14.47.14.194 0 .347-.06.457-.178a.582.582 0 00.155-.435.742.742 0 00-.225-.485l-.99-1.048c-.064-.063-.096-.124-.096-.18 0-.058.028-.118.083-.182a4.83 4.83 0 00.431-.552c.144-.211.216-.442.216-.692a.813.813 0 00-.084-.357l-.045-.078.183.073c.675.292 1.27.695 1.784 1.21a5.709 5.709 0 011.21 1.78c.291.673.437 1.39.437 2.152a5.37 5.37 0 01-.438 2.155 5.687 5.687 0 01-1.206 1.78 5.732 5.732 0 01-1.78 1.21 5.336 5.336 0 01-2.155.44z"
    },
    Or = Ir;
  function Pr(t, e) {
    if (!e) return ((this._targetOpacity = t), void (this.opacity = t));
    t !== this._targetOpacity &&
      (t !== this.opacity
        ? ((this._targetOpacity = t),
          (this._startTime = null),
          (this._startOpacity = this._opacity),
          Qt.scheduleOnNextFrame(this))
        : (this._targetOpacity = t));
  }
  function Dr(t) {
    if (
      (null == this._startTime && (this._startTime = t),
      "function" == typeof this.constructor.prototype.performScheduledUpdate &&
        this.constructor.prototype.performScheduledUpdate.call(this, t),
      null === this._targetOpacity)
    )
      return;
    if ((null == t && (this.opacity = this._targetOpacity), this._targetOpacity === this.opacity))
      return ((this._startTime = null), (this._startOpacity = null), void (this._targetOpacity = null));
    const e = t - this._startTime,
      i = this._targetOpacity - this._startOpacity,
      n = Math.abs(i * this._totalDurationMs),
      o = Math.min(e / n, 1),
      s = qn.easeInOut(o) * i + this._startOpacity;
    ((this.opacity = a(s, 0, 1)), Qt.scheduleOnNextFrame(this));
  }
  const zr = function (t, e) {
      return (
        (t._targetOpacity = null),
        (t._startOpacity = null),
        (t._startTime = null),
        (t._totalDurationMs = e || 300),
        (t.setOpacityAnimated = Pr),
        (t.performScheduledUpdate = Dr),
        t
      );
    },
    Nr = {
      GlobalFadeDuration: 700,
      InnerTransitionDuration: 200,
      MinimumNumberOfSegments: 2,
      MaximumNumberOfSegments: 5,
      MagicNumbers: [1.25, 2.5, 5],
      FirstMagicExponent: -3,
      LastMagicExponent: 7,
      MaximumNumberOfDisplayedSegments: 3,
      SegmentThickness: 3,
      LegendHorizontalMargin: 6,
      LegendMarginBottom: 8,
      LegendSpacing: 1,
      OutlineWidth: 1,
      LightSegmentColorRegular: "rgba(255, 255, 255, 0.7)",
      DarkSegmentColorRegular: "rgba(0, 0, 0, 0.73)",
      OutlineColorRegular: "rgba(255, 255, 255, 0.5)",
      LightSegmentColorSatellite: "rgba(255, 255, 255, 0.8)",
      DarkSegmentColorSatellite: "rgba(178, 178, 178, 0.8)",
      OutlineColorSatellite: "rgba(0, 0, 0, 1)",
      SegmentInnerStrokeColor: "rgba(0, 0, 0, 0.2)",
      SegmentInnerStrokeWidth: 0.5,
      LegendFontSize: 9,
      LegendFontFamily: "'-apple-system-font', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'",
      LegendColorRegular: "rgba(72, 69, 65, 1)",
      LegendOuterStrokeColorRegular: "rgba(255, 255, 255, 0.5)",
      LegendColorSatellite: "rgba(255, 255, 255, 1)",
      LegendOuterStrokeColorSatellite: "rgba(0, 0, 0, 1)",
      LegendOuterStrokeWidth: 1,
      MetersThreshold: 500,
      FeetThreshold: 0.25,
      MilesToMeters: 1609.344,
      MetersToMiles: 1 / 1609.344,
      MilesToFeet: 5280
    };
  function Fr(t) {
    Jn.call(this, t);
  }
  Fr.prototype = r(Jn, Fr, {
    measureTextOverflow: function (t, e) {
      const i = this._node;
      if (!i.legend) return 0;
      const n = Nr.LegendFontSize * this.node.fontSizeRatio;
      let o;
      ((t.font = `${n}px ${Nr.LegendFontFamily}`), (o = e ? i.legend.labels[0] : i.legend.labels[i.numberOfSegments]));
      const s = t.measureText(o).width / 2;
      let a;
      return ((a = e ? 0 : t.measureText(" " + i.legend.unit).width), s + a);
    },
    draw: function (t) {
      const e = this._node;
      if (!e.legend) return;
      const i = Nr.LegendFontSize * this.node.fontSizeRatio;
      ((t.font = `${i}px ${Nr.LegendFontFamily}`),
        (t.textAlign = "center"),
        (t.textBaseline = "bottom"),
        (t.lineWidth = Nr.LegendOuterStrokeWidth),
        (t.fillStyle = e.fillColor),
        (t.strokeStyle = e.strokeColor));
      const n = e.size.height - Nr.LegendMarginBottom - Nr.LegendSpacing;
      let o = e.segmentStart;
      for (let i = 0; i <= e.numberOfSegments; i++) {
        const s = e.legend.labels[i];
        (t.strokeText(s, o, n),
          t.fillText(s, o, n),
          this.node.leftAligned
            ? i === e.numberOfSegments
              ? (o += t.measureText(s).width / 2)
              : (o += e.segmentWidth)
            : i === e.numberOfSegments
              ? (o -= t.measureText(s).width / 2)
              : (o -= e.segmentWidth));
      }
      const s = " " + e.legend.unit;
      ((t.textAlign = this.node.leftAligned ? "left" : "right"), t.strokeText(s, o, n), t.fillText(s, o, n));
    }
  });
  const Ur = Fr;
  function Gr() {
    (Hi.call(this),
      (this.fontSizeRatio = 1),
      (this._legend = null),
      (this._segmentWidth = 0),
      (this._segmentStart = 0),
      (this._numberOfSegments = 0),
      (this._fillColor = null),
      (this._strokeColor = null),
      (this._renderer = new Ur(this)));
  }
  Gr.prototype = r(Hi, Gr, {
    get leftAligned() {
      return this._leftAligned;
    },
    set leftAligned(t) {
      ((this._leftAligned = t), (this.needsDisplay = !0));
    },
    get legend() {
      return this._legend;
    },
    set legend(t) {
      ((this._legend = t), (this.needsDisplay = !0));
    },
    get segmentStart() {
      return this._segmentStart;
    },
    set segmentStart(t) {
      ((this._segmentStart = t), (this.needsDisplay = !0));
    },
    get segmentWidth() {
      return this._segmentWidth;
    },
    set segmentWidth(t) {
      ((this._segmentWidth = t), (this.needsDisplay = !0));
    },
    get numberOfSegments() {
      return this._numberOfSegments;
    },
    set numberOfSegments(t) {
      ((this._numberOfSegments = t), (this.needsDisplay = !0));
    },
    get fillColor() {
      return this._fillColor;
    },
    set fillColor(t) {
      ((this._fillColor = t), (this.needsDisplay = !0));
    },
    get strokeColor() {
      return this._strokeColor;
    },
    set strokeColor(t) {
      ((this._strokeColor = t), (this.needsDisplay = !0));
    },
    stringInfo: function () {
      const t = "~" + this.fillColor + "/" + this.strokeColor + "~ ",
        e = this.leftAligned ? "" : ", rtl";
      return this._legend
        ? "LegendNode<labels:[" +
            this._legend.labels.slice(0, this.numberOfSegments + 1).join(", ") +
            "], unit:" +
            this._legend.unit +
            e +
            ")> " +
            t
        : "LegendNode " + t;
    },
    measureTextOverflow: function (t, e) {
      return this._renderer.measureTextOverflow(t, e);
    }
  });
  const Br = Gr;
  function Zr(t) {
    Jn.call(this, t);
  }
  Zr.prototype = r(Jn, Zr, {
    draw: function (t) {
      const e = this._node,
        i = e.fillColor,
        n = e.strokeColor,
        o = e.lineWidth;
      (i && ((t.fillStyle = i), t.fillRect(0, 0, e.size.width, e.size.height)),
        n &&
          o &&
          (o >= 1 || qn.devicePixelRatio > 1) &&
          ((t.lineWidth = o),
          (t.strokeStyle = n),
          e.innerStroke
            ? t.strokeRect(o / 2, o / 2, e.size.width - o, e.size.height - o)
            : t.strokeRect(-o / 2, -o / 2, e.size.width + o, e.size.height + o)));
    }
  });
  const Wr = Zr;
  function Kr() {
    (Hi.call(this),
      (this._fillColor = null),
      (this._strokeColor = null),
      (this._lineWidth = null),
      (this._innerStroke = !1),
      (this._renderer = new Wr(this)));
  }
  Kr.prototype = r(Hi, Kr, {
    get fillColor() {
      return this._fillColor;
    },
    set fillColor(t) {
      ((this._fillColor = t), (this.needsDisplay = !0));
    },
    get strokeColor() {
      return this._strokeColor;
    },
    set strokeColor(t) {
      ((this._strokeColor = t), (this.needsDisplay = !0));
    },
    get innerStroke() {
      return this._innerStroke;
    },
    set innerStroke(t) {
      ((this._innerStroke = t), (this.needsDisplay = !0));
    },
    get lineWidth() {
      return this._lineWidth;
    },
    set lineWidth(t) {
      ((this._lineWidth = t), (this.needsDisplay = !0));
    }
  });
  const Hr = Kr;
  function jr() {
    (Hr.call(this), zr(this, Nr.InnerTransitionDuration), (this.lineWidth = Nr.OutlineWidth));
  }
  jr.prototype = r(Hr, jr, {
    stringInfo: function () {
      return "OutlineNode ~" + this.strokeColor + "~ ";
    }
  });
  const Vr = jr;
  function qr() {
    (Hr.call(this),
      zr(this, Nr.InnerTransitionDuration),
      (this.lineWidth = Nr.SegmentInnerStrokeWidth),
      (this.innerStroke = !0));
  }
  qr.prototype = r(Hr, qr, {
    stringInfo: function () {
      return "SegmentNode ~" + this.fillColor + "~ ";
    }
  });
  const Yr = qr;
  function Xr() {
    (so.call(this),
      (this._needsLayout = !1),
      (this._distance = 0),
      (this._mapWidth = 0),
      (this._theme = Xr.Themes.light),
      (this._leftAligned = !1),
      (this._l10n = null),
      (this._segmentWidth = 0),
      (this._oldNumberOfSegments = 0),
      (this._legend = {labels: [], unit: ""}),
      (this._legendNode = this.addChild(new Br())),
      (this._outlineNodes = [0, 1].map(() => this.addChild(new Vr()))),
      (this._activeOutlineNode = this._outlineNodes[0]),
      (this._outlineNodes[1].opacity = 0),
      (this._segmentNodes = [0, 1, 2].map((t) => this.addChild(new Yr()))),
      this._updateColors(),
      zr(this, Nr.GlobalFadeDuration));
  }
  const $r = {light: "Light", dark: "Dark"};
  ((Xr.prototype = r(so, Xr, {
    get layerBounds() {
      return new Si(0, 0, this.size.width, Math.max(this.size.height, 48));
    },
    get fontSizeRatio() {
      return this._legendNode.fontSizeRatio;
    },
    set fontSizeRatio(t) {
      ((this._legendNode.fontSizeRatio = t), this._computeSegments());
    },
    get distance() {
      return this._distance;
    },
    set distance(t) {
      Math.abs(t - this._distance) / this._distance < 0.01 || ((this._distance = t), this._computeSegments());
    },
    get mapWidth() {
      return this._mapWidth;
    },
    set mapWidth(t) {
      t !== this._mapWidth && ((this._mapWidth = t), this._computeSegments());
    },
    get theme() {
      return this._theme;
    },
    set theme(t) {
      ((this._theme = t), this._updateColors());
    },
    get l10n() {
      return this._l10n;
    },
    set l10n(t) {
      (this._l10n && this._l10n.removeEventListener(this._l10n.Events.LocaleChanged, this),
        (this._l10n = t),
        t && t.addEventListener(t.Events.LocaleChanged, this));
    },
    get useMetric() {
      return this._useMetric;
    },
    set useMetric(t) {
      this._useMetric !== t && ((this._useMetric = t), this._computeSegments());
    },
    get leftAligned() {
      return this._leftAligned;
    },
    set leftAligned(t) {
      ((this._leftAligned = t), (this.needsLayout = !0));
    },
    stringInfo: function () {
      return "ScaleNode<distance:" + Math.round(100 * this.distance) / 100 + "m>";
    },
    get needsLayout() {
      return this._needsLayout;
    },
    set needsLayout(t) {
      this._needsLayout !== t && ((this._needsLayout = t), t && Qt.scheduleASAP(this));
    },
    performScheduledUpdate: function () {
      this.needsLayout && this.parent && (this.layoutSubNodes(), (this.needsLayout = !1));
    },
    layoutSubNodes: function () {
      const t = this._computeSegmentsRects();
      for (let e = 0; e < Nr.MaximumNumberOfDisplayedSegments; e++) {
        const i = t[e],
          n = this._segmentNodes[e];
        i ? ((n.position = i.origin), (n.size = i.size), n.setOpacityAnimated(1, !0)) : n.setOpacityAnimated(0, !0);
      }
      const e = Si.unionOfRects(t).round();
      if (t.length !== this._oldNumberOfSegments) {
        this._activeOutlineNode.setOpacityAnimated(0, !0);
        const t = 0 === this._outlineNodes.indexOf(this._activeOutlineNode) ? 1 : 0;
        ((this._activeOutlineNode = this._outlineNodes[t]), this._activeOutlineNode.setOpacityAnimated(1, !0));
      }
      ((this._activeOutlineNode.position = e.origin), (this._activeOutlineNode.size = e.size));
      const i = t[0];
      ((this._legendNode.segmentStart = this.leftAligned ? i.origin.x : i.origin.x + i.size.width),
        (this._legendNode.leftAligned = this.leftAligned),
        (this._legendNode.segmentWidth = i.size.width),
        (this._legendNode.size.width = this.size.width),
        (this._legendNode.size.height = this.size.height),
        (this._oldNumberOfSegments = t.length));
    },
    handleEvent: function (t) {
      this._computeSegments();
    },
    _updateColors: function (t) {
      const e = this.theme === Xr.Themes.dark;
      ((this._legendNode.fillColor = e ? Nr.LegendColorSatellite : Nr.LegendColorRegular),
        (this._legendNode.strokeColor = e ? Nr.LegendOuterStrokeColorSatellite : Nr.LegendOuterStrokeColorRegular));
      const i = e
        ? [Nr.LightSegmentColorSatellite, Nr.DarkSegmentColorSatellite]
        : [Nr.DarkSegmentColorRegular, Nr.LightSegmentColorRegular];
      this._segmentNodes.forEach(function (t, n) {
        ((t.fillColor = i[n % 2]), (t.strokeColor = e ? null : Nr.SegmentInnerStrokeColor));
      }, this);
      const n = e ? Nr.OutlineColorSatellite : Nr.OutlineColorRegular;
      this._outlineNodes.forEach((t) => {
        t.strokeColor = n;
      });
    },
    _computeSegments: function () {
      if (0 === this.size.width || 0 === this.mapWidth || !this._l10n) return;
      const t = this.size.width,
        e = this.mapWidth;
      let i = (this.distance * t) / e;
      const n = !this._useMetric;
      let o,
        s = !1,
        a = 1;
      function r(t, e) {
        return (
          (o = t * Math.pow(10, e)),
          (a = i / o),
          a >= Nr.MinimumNumberOfSegments && a < Nr.MaximumNumberOfSegments
        );
      }
      n && ((i *= Nr.MetersToMiles), i < Nr.FeetThreshold && ((s = !0), (i *= Nr.MilesToFeet)));
      let l = !1;
      for (let t = Nr.FirstMagicExponent; !l && t < Nr.LastMagicExponent; t++) l = Nr.MagicNumbers.some((e) => r(e, t));
      this._segmentWidth = a ? t / a : 0;
      const h = o;
      (n && (s && (o /= Nr.MilesToFeet), (o *= Nr.MilesToMeters)), this._computeLegend(o, h, s));
    },
    _computeLegend: function (t, e, i) {
      let n = 0;
      this._useMetric
        ? t > Nr.MetersThreshold
          ? ((this._legend.unit = this._l10n.get("Scale.Kilometer.Short")), (n = t / 1e3))
          : ((this._legend.unit = this._l10n.get("Scale.Meter.Short")), (n = t))
        : ((this._legend.unit = i ? this._l10n.get("Scale.Feet.Short") : this._l10n.get("Scale.Mile.Short")), (n = e));
      const o = [];
      let s;
      "object" == typeof Intl &&
        Intl &&
        Intl.NumberFormat &&
        (s = new Intl.NumberFormat(this._l10n.activeLocale.localeId));
      for (let t = 0; t < Nr.MaximumNumberOfSegments; t++) {
        const e = t * n,
          i = s ? s.format(e) : e.toString();
        o.push(i);
      }
      ((this._legend.labels = o), (this._legendNode.legend = this._legend), (this.needsLayout = !0));
    },
    _computeSegmentsRects: function () {
      const t = this.scene.contextForMeasurement;
      let e = 0,
        i = this.leftAligned
          ? Nr.LegendHorizontalMargin + this._legendNode.measureTextOverflow(t, !0)
          : this.size.width - Nr.LegendHorizontalMargin - this._legendNode.measureTextOverflow(t, !0);
      const n = this.size.height - Nr.LegendMarginBottom + Nr.LegendSpacing,
        o = this._segmentWidth,
        s = [];
      for (let a = 0; a < Nr.MaximumNumberOfDisplayedSegments; a++) {
        const a = new Si(this.leftAligned ? i : i - o, n, o, Nr.SegmentThickness).round();
        (s.push(a),
          (i = this.leftAligned ? a.origin.x + a.size.width : a.origin.x),
          (this._legendNode.numberOfSegments = s.length),
          (e = this._legendNode.measureTextOverflow(t)));
        const r = o + e + Nr.LegendHorizontalMargin;
        if (this.leftAligned && i + r > this.size.width) break;
        if (!this.leftAligned && i - r < 0) break;
      }
      return (0 === this._oldNumberOfSegments && (this._oldNumberOfSegments = s.length), s);
    }
  })),
    (Xr.Themes = $r),
    (Xr.ScaleNode = Xr));
  const Jr = Xr,
    Qr = new ki(170, 20),
    tl = class extends bn {
      constructor(t) {
        const e = new no();
        (super(e.element), (this.scene = e), (this._map = t));
        const i = Qr.copy();
        ((i.height = this._getHeight()),
          (this.scene.size = i),
          (this.node = this.scene.addChild(new Jr())),
          (this.node.size = i),
          (this.node.position = new Mi(0, 0)),
          (this.node.opacity = 0),
          (this.node.l10n = fi),
          (this.node.fontSizeRatio = t.fontSizeRatio),
          (this.node.useMetric = t.useMetric),
          fi.addEventListener(fi.Events.LocaleChanged, this),
          this.classList.add("mk-scale"),
          this.element.setAttribute("aria-hidden", "true"),
          (this.size = Qr));
      }
      get shouldDisplayScale() {
        return (
          this._map._showsScale === on.Visible || (this._map._showsScale === on.Adaptive && this._map.cameraIsZooming)
        );
      }
      updateTheme(t) {
        this.node.theme = $r[t];
      }
      update() {
        const t = this._map;
        if (!this.node || !this.shouldDisplayScale) return;
        const e = t.renderingMapRect.origin.toCoordinate().latitude,
          i = t.renderingMapRect.size.width / Ye.mapUnitsPerMeterAtLatitude(e);
        if ((i / t._visibleFrame.size.width) * qn.devicePixelRatio >= 7500) return void this.hideIfNeeded(!0);
        const n = this._getHeight();
        if (n !== this.node.size.height) {
          const t = Qr.copy();
          ((t.height = n), (this.scene.size = t), (this.node.size = t));
        }
        ((this.node.fontSizeRatio = t.fontSizeRatio),
          (this.node.distance = i),
          (this.node.useMetric = this._map.useMetric),
          this.node.setOpacityAnimated(1, !1));
      }
      hideIfNeeded(t) {
        !this.node || (this.shouldDisplayScale && !t) || this.node.setOpacityAnimated(0, !0);
      }
      handleEvent(t) {
        this.node.useMetric = this._map.useMetric;
      }
      mapWasDestroyed() {
        ((this.node.l10n = null),
          this.node.remove(),
          this.scene.destroy(),
          fi.removeEventListener(fi.Events.LocaleChanged, this));
      }
      _getHeight() {
        const t = Nr.LegendFontSize * this._map.fontSizeRatio;
        return Qr.height - Nr.LegendFontSize + t;
      }
    },
    el = "mk-pressed",
    il = "mk-pill-pressed",
    nl = "mk-disabled";
  class ol extends _r {
    constructor() {
      const t = qn.htmlElement("div");
      (super(t),
        this.classList.add("mk-zoom-controls"),
        (this._zoomInEnabled = !0),
        (this._zoomOutEnabled = !0),
        (this._zoomInButton = qn.htmlElement("div", {role: "button", tabindex: "0"})),
        (this._zoomInButtonNode = new Rn.Node(this._zoomInButton)),
        this._zoomInButtonNode.classList.add("mk-zoom-in"),
        this._zoomInButton.appendChild(
          (function () {
            const t = qn.svgElement("path", {
                d: "M11.813 17.404c.4 0 .724-.33.724-.705v-3.974h3.872a.726.726 0 00.717-.723.73.73 0 00-.717-.724h-3.872V7.305a.72.72 0 00-.724-.705.724.724 0 00-.724.705v3.973H7.217a.739.739 0 00-.717.724c0 .4.343.723.717.723h3.872V16.7c0 .375.33.705.724.705z"
              }),
              e = qn.createSVGIcon(t, {width: "100%", height: "100%"});
            return (e.setAttribute("viewBox", "0 0 24 24"), e);
          })()
        ),
        t.appendChild(this._zoomInButton),
        t.appendChild(qn.htmlElement("div", {class: "mk-divider"})),
        (this._zoomOutButton = qn.htmlElement("div", {role: "button", tabindex: "0"})),
        (this._zoomOutButtonNode = new Rn.Node(this._zoomOutButton)),
        this._zoomOutButtonNode.classList.add("mk-zoom-out"),
        this._zoomOutButton.appendChild(
          (function () {
            const t = qn.svgElement("path", {
                d: "M16.325 12.75c.364 0 .675-.336.675-.75 0-.408-.31-.75-.675-.75h-8.65c-.352 0-.675.342-.675.75 0 .414.323.75.675.75h8.65z"
              }),
              e = qn.createSVGIcon(t, {width: "100%", height: "100%"});
            return (e.setAttribute("viewBox", "0 0 24 24"), e);
          })()
        ),
        t.appendChild(this._zoomOutButton),
        this._updateLabels());
    }
    get zoomInEnabled() {
      return this._zoomInEnabled;
    }
    set zoomInEnabled(t) {
      (this._enabled && t === this._zoomInEnabled) ||
        ((this._zoomInEnabled = this._enabled && t), sl(this._zoomInButtonNode, this._zoomInEnabled));
    }
    get zoomOutEnabled() {
      return this._zoomOutEnabled;
    }
    set zoomOutEnabled(t) {
      (this._enabled && t === this._zoomOutEnabled) ||
        ((this._zoomOutEnabled = this._enabled && t), sl(this._zoomOutButtonNode, this._zoomOutEnabled));
    }
    localeChanged(t) {
      this._updateLabels();
    }
    touchesBegan(t) {
      this._pressed(t);
    }
    touchesEnded(t) {
      (this.saveEndEventProps(t), this.reset(t));
    }
    clicked(t) {
      this.checkClickEventProps(t) || (this._pressed(t), this.reset(t));
    }
    touchesCanceled(t) {
      this.reset(t);
    }
    focused(t) {
      (this.updateTintColor(this.tintColor), (t.target.style.fill = qn.focusColor));
    }
    blurred(t) {
      this.updateTintColor(this.tintColor);
    }
    spaceBarKeyDown(t) {
      this._pressed(t);
    }
    spaceBarKeyUp(t) {
      this.reset(t);
    }
    updateTintColor(t) {
      ((this.tintColor = t),
        (this._zoomInButton.firstChild.style.fill = t),
        (this._zoomOutButton.firstChild.style.fill = t));
    }
    reset(t) {
      let e;
      if (
        (this._zoomInButtonNode.classList.contains(el)
          ? (e = this._zoomInButtonNode)
          : this._zoomOutButtonNode.classList.contains(el) && (e = this._zoomOutButtonNode),
        e)
      ) {
        (e.classList.remove(el), this.classList.remove(il));
        const t = new M.Event(ol.EVENTS.ZOOM_END);
        this.dispatchEvent(t);
      }
      (window.removeEventListener(qn.endEventType, this),
        qn.supportsPointerEvents
          ? window.removeEventListener("pointercancel", this)
          : qn.supportsTouches && window.removeEventListener("touchcancel", this));
    }
    _clearLabels(t) {
      (qn.updateLabel(this._zoomInButtonNode, ""), qn.updateLabel(this._zoomOutButtonNode, ""));
    }
    _updateLabels(t) {
      (qn.updateLabel(this._zoomInButtonNode, fi.get("Zoom.In.Tooltip")),
        qn.updateLabel(this._zoomOutButtonNode, fi.get("Zoom.Out.Tooltip")));
    }
    _pressed(t) {
      const e = this._findButtonNodeFromButtonDOMElement(qn.parentNodeForSvgTarget(t.target));
      if (!e || e.classList.contains(nl)) return;
      if (this.hasFocus) {
        const t = qn.containingDocumentOrShadowRoot(this.element).activeElement;
        t !== e.element && t.blur();
      }
      (e.classList.add(el), this.classList.add(il));
      const i = new M.Event(ol.EVENTS.ZOOM_START);
      ((i.zoomIn = e === this._zoomInButtonNode), this.dispatchEvent(i));
    }
    _findButtonNodeFromButtonDOMElement(t) {
      return t === this._zoomOutButton
        ? this._zoomOutButtonNode
        : t === this._zoomInButton
          ? this._zoomInButtonNode
          : null;
    }
  }
  function sl(t, e) {
    e
      ? (t.classList.remove(nl), t.removeAttribute("aria-disabled"), t.setAttribute("tabindex", 0))
      : (t.classList.add(nl), t.setAttribute("aria-disabled", "true"), t.setAttribute("tabindex", -1));
  }
  ol.EVENTS = {ZOOM_START: "zoom-start", ZOOM_END: "zoom-end"};
  const al = ol,
    rl = "mk-user-location-error-popover",
    ll = "mk-error-message",
    hl = "mk-error-text",
    cl = "mk-error-support",
    dl = class extends wr {
      constructor() {
        (super(),
          this.classList.add(rl),
          (this._errorMessageElement = this._createErrorMessageElement()),
          (this._errorMessageNode = new bn(this._errorMessageElement)),
          this.update(),
          this.addChild(this._errorMessageNode));
      }
      get errorMessageElement() {
        return this._errorMessageElement;
      }
      update() {
        ((this._errorMessageElement.getElementsByClassName(hl)[0].textContent = fi.get("Location.Error.Message") + " "),
          (this._supportLink.textContent = fi.get("Location.Error.Support.Label")),
          qn.supportsTouches
            ? (this._supportLink.href = "https://support.apple.com/HT203033")
            : (this._supportLink.href =
                "https://support.apple.com/guide/mac-help/allow-apps-to-detect-the-location-of-your-mac-mh35873/mac"));
      }
      _createErrorMessageElement() {
        const t = qn.htmlElement("div", {class: ll});
        return (
          (this._supportLink = qn.htmlElement("a", {class: cl, target: "_blank"})),
          t.appendChild(qn.htmlElement("span", {class: hl})),
          t.appendChild(this._supportLink),
          t
        );
      }
    },
    ul = {
      CONTROL: "mk-user-location-control",
      WRAPPER: "mk-user-location-control-wrapper",
      PRESSED: "mk-pressed",
      TRACKING: "mk-tracking",
      WAITING: "mk-waiting",
      DISABLED: "mk-disabled",
      WAITING_ICON: "mk-icon-waiting",
      ARROW_ICON: "mk-icon-arrow",
      SCALED_OUT: "mk-scaled-out"
    };
  class pl extends _r {
    constructor(t, e, i) {
      (super(qn.htmlElement("div", {class: ul.CONTROL, role: "button", tabindex: "0"})),
        (this._state = pl.States.Default),
        (this._tintColor = ""),
        (this._wrapper = qn.htmlElement("div", {class: ul.WRAPPER})),
        this.element.appendChild(this._wrapper),
        (this._arrowIconNode = new Rn.Node(
          qn.createSVGIcon(qn.svgElement("path"), {class: ul.ARROW_ICON, viewBox: gl})
        )),
        (this._waitingIconNode = new Rn.Node(
          (function () {
            const t = [];
            for (let e = 0; e < 8; ++e)
              t.push(
                qn.svgElement("rect", {
                  x: -1.25,
                  y: 5,
                  width: 2.5,
                  height: 6,
                  rx: 1.25,
                  transform: "rotate(" + 45 * e + ")"
                })
              );
            const e = ["g", {transform: "scale(0.6666666666666666, -0.6666666666666666)"}].concat(t);
            return qn.createSVGIcon(qn.svgElement.apply(null, e), {
              class: [ul.WAITING_ICON, ul.SCALED_OUT].join(" "),
              viewBox: _l
            });
          })()
        )),
        this._wrapper.appendChild(this._arrowIconNode.element),
        this._wrapper.appendChild(this._waitingIconNode.element),
        (this._errorPopover = new dl()),
        this._updateLabels(),
        this._updateArrowIcon(),
        (this._waitingIconBlades = this._waitingIconNode.element.querySelectorAll("rect")),
        (this._map = t),
        (this._rtl = e),
        (this._focusDelegate = i));
    }
    get state() {
      return this._state;
    }
    set state(t) {
      this._state !== t &&
        ((this._state = t),
        this.classList.toggle(ul.TRACKING, this.isTrackingState()),
        this.classList.toggle(ul.WAITING, this.isWaitingState()),
        this.classList.toggle(ul.DISABLED, this.isDisabledState()),
        this.updateTintColor(this._tintColor),
        this.isWaitingState() ? this._animateArrowIconOut() : this._animateWaitingIconOut());
    }
    isDefaultState() {
      return this.state === pl.States.Default;
    }
    toDefaultState() {
      ((this.state = pl.States.Default), this._updateArrowIcon(), this._closeErrorPopover());
    }
    isTrackingState() {
      return this.state === pl.States.Tracking;
    }
    toTrackingState() {
      ((this.state = pl.States.Tracking), this._updateArrowIcon(), this._closeErrorPopover());
    }
    isWaitingState() {
      return this.state === pl.States.Waiting;
    }
    toWaitingState() {
      this.state = pl.States.Waiting;
    }
    isDisabledState() {
      return this.state === pl.States.Disabled;
    }
    toDisabledState() {
      (this._map.tracksUserLocation && this._map.userLocationAnnotation) ||
        ((this.state = pl.States.Disabled), this._updateArrowIcon(), this._openErrorPopover());
    }
    handleEvent(t) {
      switch (t.type) {
        case qn.startEventType: {
          const e = qn.getShadowDOMTargetFromEvent(this.element, t);
          this._errorPopover.errorMessageElement.contains(e) ||
            (this._closeErrorPopover(), window.removeEventListener(qn.startEventType, this, !0));
          break;
        }
        case "keydown":
          27 === t.keyCode && this._closeErrorPopover();
          break;
        case "blur":
          this._errorPopover.element.contains(t.relatedTarget) || this._closeErrorPopover();
      }
    }
    touchesBegan(t) {
      this._pressed(t);
    }
    touchesEnded() {
      this.reset();
    }
    clicked() {
      this.dispatchEvent(new M.Event(pl.EVENTS.PRESSED));
    }
    touchesCanceled(t) {
      this.reset();
    }
    spaceBarKeyDown(t) {
      this._pressed(t);
    }
    spaceBarKeyUp(t) {
      (this.reset(t), this.dispatchEvent(new M.Event(pl.EVENTS.PRESSED)));
    }
    updateTintColor(t) {
      ((this._tintColor = t),
        (this._arrowIconNode.element.querySelector("g").style.fill = this.isTrackingState() ? "" : t),
        (this._waitingIconNode.element.querySelector("g").style.fill = t),
        (this.element.style.backgroundColor = this.isTrackingState() ? t : ""));
    }
    reset() {
      (this.classList.contains(ul.PRESSED) &&
        (this.classList.remove(ul.PRESSED),
        this._focusDelegate.controlWasReleased(this),
        this.isDefaultState() || this.isDisabledState() ? this.toWaitingState() : this.toDefaultState()),
        delete this._mousedown,
        window.removeEventListener(qn.endEventType, this),
        qn.supportsPointerEvents
          ? window.removeEventListener("pointercancel", this)
          : qn.supportsTouches && window.removeEventListener("touchcancel", this));
    }
    localeChanged(t) {
      (this._updateLabels(), (this._rtl = t.locale.rtl), this._errorPopover.update());
    }
    mapWasDestroyed() {
      delete this._map;
    }
    focused(t) {
      this._focusDelegate.controlDidGetFocus(this);
    }
    blurred(t) {
      this._focusDelegate.controlDidLoseFocus(this);
    }
    didMoveToParent(t) {
      t ? this.parent.insertAfter(this._errorPopover, this) : (this._closeErrorPopover(), this._errorPopover.remove());
    }
    _updateLabels() {
      qn.updateLabel(this.element, fi.get("Track.User.Location.Tooltip"));
    }
    _pressed(t) {
      (this.classList.add(ul.PRESSED), this._focusDelegate.controlWasPressed(this));
    }
    _animateArrowIconOut() {
      (this._arrowIconNode.classList.add(ul.SCALED_OUT), this._waitingIconNode.classList.remove(ul.SCALED_OUT));
    }
    _animateWaitingIconOut() {
      (this._waitingIconNode.classList.add(ul.SCALED_OUT), this._arrowIconNode.classList.remove(ul.SCALED_OUT));
    }
    _openErrorPopover() {
      (this._errorPopover.open(),
        window.addEventListener(qn.startEventType, this, !0),
        window.addEventListener("keydown", this, !0),
        this._errorPopover.element.addEventListener("blur", this, !0));
    }
    _closeErrorPopover() {
      (this._errorPopover.close(),
        window.removeEventListener(qn.startEventType, this, !0),
        window.removeEventListener("keydown", this, !0),
        this._errorPopover.element.removeEventListener("blur", this, !0));
    }
    _updateArrowIcon() {
      this._arrowIconNode.element.querySelector("path").setAttribute("d", ml[this.state]);
    }
  }
  ((pl.States = {Default: "default", Waiting: "waiting", Tracking: "tracking", Disabled: "disabled"}),
    (pl.EVENTS = {PRESSED: "pressed"}));
  const ml = {
      default:
        "M24.675 17.91L29.48 7.512c.514-1.11-.349-1.847-1.409-1.358l-10.448 4.818c-.971.444-.768 1.802.342 1.809l4.723.019c.095 0 .127.038.127.133l.013 4.691c0 1.092 1.365 1.34 1.847.286zm-.711-1.448l.025-4.272c0-.387-.184-.577-.584-.577l-4.272.025c-.05 0-.07-.057-.012-.089l8.95-4.094c.076-.032.12.013.082.089l-4.1 8.925c-.025.063-.089.05-.089-.007z",
      disabled:
        "M27.112 12.641l2.368-5.129c.514-1.11-.349-1.847-1.409-1.358l-5.097 2.348.882.883 4.215-1.93c.076-.032.12.013.082.089l-1.93 4.208.89.89zm2.4 4.196a.51.51 0 000-.717l-9.934-9.934a.517.517 0 00-.724 0 .522.522 0 000 .717l9.947 9.934c.197.197.52.197.71 0zm-4.837 1.073l1.301-2.812-.882-.883-1.041 2.254c-.025.063-.089.05-.089-.007l.02-3.351-1.493-1.492-3.358.02c-.05 0-.07-.058-.012-.09l2.266-1.034-.876-.876-2.888 1.333c-.971.444-.768 1.802.342 1.809l4.723.019c.095 0 .127.038.127.133l.013 4.691c0 1.092 1.365 1.34 1.847.286z",
      tracking:
        "M24.675 17.91L29.48 7.512c.514-1.11-.349-1.847-1.409-1.358l-10.448 4.818c-.971.444-.768 1.802.342 1.809l4.723.019c.095 0 .127.038.127.133l.013 4.691c0 1.092 1.365 1.34 1.847.286z"
    },
    gl = "0 0 45 24",
    _l = "-22.5 -12 45 24",
    fl = pl,
    yl = "mk-pressed";
  function vl(t, e, i, n) {
    let o;
    const s = e - n,
      a = t - i;
    return (
      (o =
        t > i
          ? e < n
            ? 90 + wl(Math.atan(s / a))
            : 180 - wl(Math.atan(a / s))
          : e < n
            ? 360 - wl(Math.atan(a / s))
            : 0 !== a
              ? 270 + wl(Math.atan(s / a))
              : 180),
      o
    );
  }
  function wl(t) {
    return (180 * t) / Math.PI;
  }
  function bl(t) {
    const e = oe.createImageUrl("icons/compass-sheet.svg");
    ((t.crossOrigin = ms.getCorsAttribute(dt.distUrlWithCredentials)), (t.src = e));
  }
  const Cl = class extends _r {
      constructor(t) {
        const e = qn.htmlElement("div");
        (super(e),
          (this.element = e),
          (this._isDragging = !1),
          (this._isDraggingPrevented = !1),
          this.classList.add("mk-rotation-control"));
        const i = qn.htmlElement("input", {
          class: "mk-rotation-slider",
          type: "range",
          min: 0,
          max: 360,
          value: 0,
          "aria-label": fi.get("Compass.Degrees.Plural", {n: 0})
        });
        (i.addEventListener("change", this),
          (this._slider = i),
          (this._sliderNode = new Rn.Node(i)),
          this.element.appendChild(i),
          (this._compassNode = new Rn.Node(
            qn.htmlElement("div", {class: "mk-rotation-wrapper"}, qn.htmlElement("img", {role: "presentation"}))
          )),
          this.element.appendChild(this._compassNode.element));
        const n = qn.htmlElement("div");
        if (
          ((this._heading = n),
          (this._headingNode = new Rn.Node(n)),
          this._headingNode.classList.add("mk-heading"),
          this.element.appendChild(n),
          dt.state === dt.States.UNINITIALIZED)
        ) {
          const t = () => {
            (dt.removeEventListener(dt.Events.Initialized, t), bl(this._compassNode.element.firstChild));
          };
          dt.addEventListener(dt.Events.Initialized, t);
        } else bl(this._compassNode.element.firstChild);
        ((this._map = t),
          (this._rotation = 0),
          (this._activeKeyRightAt = null),
          (this._activeKeyLeftAt = null),
          this._updateLabels());
      }
      enable() {
        (_r.prototype.enable.call(this),
          this._setupGestureRecognizers(),
          this._sliderNode.removeAttribute("aria-disabled"),
          this._sliderNode.setAttribute("tabindex", 0));
      }
      disable() {
        (_r.prototype.disable.call(this),
          this._sliderNode.setAttribute("aria-disabled", "true"),
          this._sliderNode.setAttribute("tabindex", -1));
      }
      set rotation(t) {
        t === this._rotation ||
          (360 === this._rotation && 0 === t) ||
          ((this._rotation = t), this._updateHeading(), this._updateSlider(), this._rotateTo(t));
      }
      localeChanged(t) {
        this._updateLabels();
      }
      mapWasDestroyed() {
        delete this._map;
      }
      updateTintColor(t) {
        this.tintColor !== t && ((this.tintColor = t), (this._heading.style.color = t));
      }
      updateImage(t, e) {
        (this._dprValue === t && this._darkColorScheme === e) ||
          ((this._dprValue = t),
          (this._darkColorScheme = e),
          dt.state !== dt.States.UNINITIALIZED && bl(this._compassNode.element));
      }
      touchesEnded(t) {
        this.saveEndEventProps(t);
      }
      clicked(t) {
        this.checkClickEventProps(t) || this.reset(t);
      }
      reset(t) {
        const e = t && (t.target === this._tapRecognizer || "click" === t.type || 38 === t.keyCode || 32 === t.keyCode);
        (this._map &&
          this._center &&
          !e &&
          this._isDragging &&
          (this._map.mapDidStopRotating(), this._map.compassRotationDidEnd()),
          this.classList.remove(yl),
          e && this._map.setRotationAnimated(0, !0),
          (this._isDragging = !1),
          (this._isDraggingPrevented = !1),
          delete this._angleOffset);
      }
      spaceBarKeyDown(t) {
        this.reset(t);
      }
      upArrowKeyUp(t) {
        this.reset(t);
      }
      rightArrowKeyDown(t) {
        this._beginKeyboardRotate(t);
      }
      rightArrowKeyUp(t) {
        this._endKeyboardRotate(t);
      }
      leftArrowKeyDown(t) {
        this._beginKeyboardRotate(t);
      }
      leftArrowKeyUp(t) {
        this._endKeyboardRotate(t);
      }
      performScheduledUpdate() {
        if (!this._activeKeyRightAt && !this._activeKeyLeftAt) return !1;
        (this._keyboardRotate(), Qt.scheduleOnNextFrame(this));
      }
      handleEvent(t) {
        switch (t.target) {
          case this._tapRecognizer:
            t.target.state === Un.Recognized && this.reset(t);
            break;
          case this._panRecognizer:
            t.target.state === Un.Possible
              ? this._beginDrag(t)
              : t.target.state === Un.Changed
                ? this._drag(t)
                : (t.target.state !== Un.Recognized && t.target.state !== Un.Failed) || this.reset(t);
            break;
          case this._slider:
            this._handleSliderChange(t);
        }
      }
      fadeIn() {
        this.element.style.opacity = 1;
      }
      fadeOut() {
        this.element.style.opacity = 0;
      }
      _updateHeading() {
        const t = 360 - this._rotation,
          e = Math.round((t / 360) * 4) % 4;
        this._heading.textContent = fi.get(
          "Compass." + ["NorthIndicator", "EastIndicator", "SouthIndicator", "WestIndicator"][e]
        );
      }
      _updateLabels() {
        (this._updateHeading(), qn.updateLabel(this.element, fi.get("Compass.Tooltip")));
      }
      _rotateTo(t) {
        this._compassNode.transform = "rotate(" + t + "deg)";
      }
      _setupGestureRecognizers() {
        const t = new Lo();
        ((t.numberOfTapsRequired = 1),
          t.addEventListener("statechange", this),
          (t.target = this.element),
          (this._tapRecognizer = t));
        const e = new hs();
        (e.addEventListener("statechange", this), (e.target = this.element), (this._panRecognizer = e));
      }
      removeEventListeners() {
        (this._tapRecognizer.removeEventListener("statechange", this),
          (this._tapRecognizer.enabled = !1),
          (this._tapRecognizer.target = null),
          this._panRecognizer.removeEventListener("statechange", this),
          (this._panRecognizer.enabled = !1),
          (this._panRecognizer.target = null),
          this._slider.removeEventListener("change", this));
      }
      _beginDrag(t) {
        this.classList.add(yl);
        const e = this.element.getBoundingClientRect();
        this._center = {x: e.right - e.width / 2, y: e.bottom - e.height / 2};
        const i = vl(t.target.locationInClient().x, t.target.locationInClient().y, this._center.x, this._center.y);
        this._angleOffset = i - this._map.rotation;
      }
      _drag(t) {
        if (!this._center || isNaN(this._angleOffset)) return;
        if (this._isDraggingPrevented) return;
        if (!this._isDragging) {
          if (!this._map.mapCanStartRotating()) return void (this._isDraggingPrevented = !0);
          this._isDragging = !0;
        }
        this._map.compassRotationWillStart(!0);
        let e =
          vl(t.target.locationInClient().x, t.target.locationInClient().y, this._center.x, this._center.y) -
          this._angleOffset;
        ((e = this._map.compassRotate(e, !0)), this._rotateTo(e));
      }
      _beginKeyboardRotate(t) {
        const e = this._activeKeyRightAt && 39 === t.keyCode,
          i = this._activeKeyLeftAt && 37 === t.keyCode;
        if (e || i) return;
        const n = Date.now();
        (39 === t.keyCode ? (this._activeKeyRightAt = n) : (this._activeKeyLeftAt = n),
          this._map.mapCanStartRotating() &&
            ((this._timeAtLastFrame = n), Qt.scheduleASAP(this), this._map.compassRotationWillStart(!1)));
      }
      _keyboardRotate() {
        const t = Math.max(this._activeKeyRightAt || 0, this._activeKeyLeftAt || 0);
        if (!t || !this._timeAtLastFrame) return;
        const e = Date.now();
        let i = this._rotation;
        const n = e - this._timeAtLastFrame;
        ((i += ((4 * (t === this._activeKeyLeftAt) ? -1 : 1) * (60 * n)) / 1e3),
          this._map.compassRotate(i, !1),
          (this._timeAtLastFrame = Date.now()));
      }
      _endKeyboardRotate(t) {
        (39 === t.keyCode ? (this._activeKeyRightAt = null) : (this._activeKeyLeftAt = null),
          this._activeKeyRightAt || this._activeKeyLeftAt || (this._timeAtLastFrame = null),
          this._map.mapDidStopRotating(),
          this._map.compassRotationDidEnd());
      }
      _handleSliderChange(t) {
        const e = parseInt(t.target.value);
        if (e === this._rotation) return;
        let i = e;
        (0 === e ? (i = 360) : 360 === e && (i = 0), (this.rotation = i), this._map.setRotationAnimated(i, !1, !0));
      }
      _updateSlider() {
        const t = Math.round(this._rotation);
        this._slider.value = t;
        const e = fi.get(1 === t ? "Compass.Degrees.Single" : "Compass.Degrees.Plural", {n: t});
        this._sliderNode.setAttribute("aria-label", e);
      }
    },
    kl = on,
    Ml = [
      "ca-ES",
      "en-GB",
      "en-US",
      "es-ES",
      "es-MX",
      "hi-IN",
      "id-ID",
      "ja-JP",
      "ko-KR",
      "ms-MY",
      "nb-NO",
      "pt-BR",
      "pt-PT",
      "ro-RO",
      "zh-CN",
      "zh-HK",
      "zh-TW"
    ],
    Sl = "mk-rtl",
    Ll = "mk-autonavi",
    Al = "mk-controls-container-controls-normal",
    El = "mk-controls-container-controls-larger",
    xl = "mk-text-zoom",
    Tl = [
      "mk-top-right-controls-container-children-none",
      "mk-top-right-controls-container-children-one",
      "mk-top-right-controls-container-children-two"
    ],
    Il = "mk-with-zoom-control",
    Rl = "mk-pill-focus",
    Ol = "mk-pill-pressed",
    Pl = new Mi(7, 11);
  class Dl extends bn {
    constructor(t) {
      (super(qn.htmlElement("div", {class: "mk-controls-container"})),
        (this._rtl = !1),
        (this._map = t),
        (this._topRightControlsNode = new bn(qn.htmlElement("div", {class: this._getTopRightControlsClass()}))),
        (this._bottomRightControlsNode = new bn(qn.htmlElement("div", {class: "mk-bottom-right-controls-container"}))),
        (this._bottomLeftControlsNode = new bn(qn.htmlElement("div", {class: "mk-bottom-left-controls-container"}))),
        this._setPendingControls(),
        (this._shadowRootNode = qn.addShadowRootChild(
          this,
          dt.shadowDOMMode,
          '@media (inverted-colors){:host(.mk-controls) img,:host(.mk-controls-container) img{filter:initial}}:host(.mk-controls-container) *{box-sizing:content-box}:host(.mk-controls-container) ::selection{background:0 0}.mk-error-message{font-family:"-apple-system-font","Helvetica Neue",Helvetica,Arial,sans-serif;font-size:calc(100% * 13 / var(--font-size-default));width:200px;padding:10px;pointer-events:auto}.mk-error-support{white-space:nowrap}:host(.mk-controls) :focus,:host(.mk-controls-container) :focus{outline:0}.mk-logo-control .mk-logo{vertical-align:bottom;width:auto}:host(.mk-controls-container) .mk-bottom-left-controls-container{--logo-width:101px;--logo-height:24px;--logo-xmin:0;--logo-xmax:1;font:16px sans-serif;--font-size-default:16}:host(.mk-controls-container.mk-text-zoom) .mk-bottom-left-controls-container{font:initial}@supports (font:-apple-system-body) and (-webkit-touch-callout:default){:host(.mk-controls-container.mk-text-zoom) .mk-bottom-left-controls-container{font:-apple-system-body;--font-size-default:17}}:host(.mk-controls-container) .mk-bottom-left-controls-container.mk-controls-container-controls-larger{--logo-width:126.25px;--logo-height:30px}:host(.mk-controls-container) .mk-bottom-left-controls-container.mk-autonavi{--logo-width:68px;--logo-height:45px}:host(.mk-controls-container) .mk-bottom-left-controls-container.mk-autonavi.mk-controls-container-controls-larger{--logo-width:85px;--logo-height:56.25px}:host(.mk-controls-container) div.mk-logo-control img.mk-logo{width:var(--logo-width);height:var(--logo-height);margin:0;transition:width .3s ease-in-out,height .3s ease-in-out}.mk-legal{height:calc(1em * 16 / var(--font-size-default));padding:0 6px;margin:2px 4px;border-radius:5px;pointer-events:auto;z-index:1;text-align:center;vertical-align:middle;line-height:calc(100% * 12 / var(--font-size-default));cursor:pointer;transition:left .3s ease-in-out}.mk-legal .mk-legal-label{display:inline-block;font-size:calc(100% * 9 / var(--font-size-default));font-family:"-apple-system-font","Helvetica Neue",Helvetica,Arial,sans-serif;font-weight:500;text-decoration:underline;white-space:nowrap}:host(.mk-controls-container) .mk-bottom-right-controls-container{font:16px sans-serif;--font-size-default:16}:host(.mk-controls-container.mk-text-zoom) .mk-bottom-right-controls-container{font:initial}@supports (font:-apple-system-body) and (-webkit-touch-callout:default){:host(.mk-controls-container.mk-text-zoom) .mk-bottom-right-controls-container{font:-apple-system-body;--font-size-default:17}}.mk-zoom-controls{width:48px;height:24px;border-radius:25%/50%;pointer-events:auto;transition:width .3s ease-in-out,height .3s ease-in-out}.mk-controls-container-controls-larger .mk-zoom-controls{width:60px;height:30px}.mk-zoom-controls .mk-zoom-in .mk-icon,.mk-zoom-controls .mk-zoom-out .mk-icon{pointer-events:none;display:block;opacity:.55}.mk-zoom-controls .mk-zoom-in.mk-pressed .mk-icon,.mk-zoom-controls .mk-zoom-in:focus .mk-icon,.mk-zoom-controls .mk-zoom-out.mk-pressed .mk-icon,.mk-zoom-controls .mk-zoom-out:focus .mk-icon{opacity:.85}@media not all and (hover:none){.mk-zoom-controls .mk-zoom-in:hover .mk-icon,.mk-zoom-controls .mk-zoom-out:hover .mk-icon{opacity:.85}}.mk-zoom-controls .mk-zoom-in.mk-disabled .mk-icon,.mk-zoom-controls .mk-zoom-out.mk-disabled .mk-icon{opacity:.2}.mk-zoom-controls .mk-zoom-in,.mk-zoom-controls .mk-zoom-out{position:absolute;z-index:2;width:50%;height:100%;cursor:pointer}.mk-zoom-controls .mk-divider{position:absolute;left:calc(50% - 1px);width:2px;height:100%;box-sizing:border-box;z-index:100}:host(.mk-controls-container) .mk-top-left-controls-container{font:16px sans-serif;--font-size-default:16}:host(.mk-controls-container.mk-text-zoom) .mk-top-left-controls-container{font:initial}@supports (font:-apple-system-body) and (-webkit-touch-callout:default){:host(.mk-controls-container.mk-text-zoom) .mk-top-left-controls-container{font:-apple-system-body;--font-size-default:17}}.mk-top-right-controls-container{position:relative;width:0;height:24px;transition:width .3s ease-in-out,height .3s ease-in-out}:host(.mk-controls-container) .mk-top-right-controls-container{font:16px sans-serif;--font-size-default:16}:host(.mk-controls-container.mk-text-zoom) .mk-top-right-controls-container{font:initial}@supports (font:-apple-system-body) and (-webkit-touch-callout:default){:host(.mk-controls-container.mk-text-zoom) .mk-top-right-controls-container{font:-apple-system-body;--font-size-default:17}}.mk-controls-container-controls-larger.mk-top-right-controls-container{height:30px}.mk-top-right-controls-container-children-one{width:45px;border-radius:20%/37.5%}.mk-controls-container-controls-larger.mk-top-right-controls-container-children-one{width:56.25px}.mk-top-right-controls-container-children-two{width:90px;border-radius:10%/37.5%}.mk-controls-container-controls-larger.mk-top-right-controls-container-children-two{width:112.5px}:host(.mk-controls-container) .mk-map-type-control,:host(.mk-controls-container) .mk-user-location-control{display:inline-block;position:absolute;width:45px;height:24px;cursor:pointer;pointer-events:auto;transition:width .3s ease-in-out,height .3s ease-in-out}:host(.mk-controls-container) .mk-user-location-control{left:0}:host(.mk-controls-container.mk-rtl) .mk-user-location-control{left:auto;right:0}:host(.mk-controls-container) .mk-map-type-control{right:0}:host(.mk-controls-container.mk-rtl) .mk-map-type-control{left:0;right:auto}:host(.mk-controls-container) .mk-controls-container-controls-larger .mk-map-type-control,:host(.mk-controls-container) .mk-controls-container-controls-larger .mk-user-location-control{width:56.25px;height:30px}:host(.mk-controls-container) .mk-user-location-control .mk-icon{position:absolute;left:0;height:100%;width:100%;display:block;transition:transform .2s ease-in-out}:host(.mk-controls-container) .mk-user-location-control .mk-scaled-out{transform:scale(0)}:host(.mk-controls-container) .mk-user-location-control .mk-icon.mk-icon-waiting rect{animation:.8s infinite mk-spinner}:host(.mk-controls-container) .mk-user-location-control .mk-icon.mk-icon-waiting rect:nth-child(2){animation-delay:-.1s}:host(.mk-controls-container) .mk-user-location-control .mk-icon.mk-icon-waiting rect:nth-child(3){animation-delay:-.2s}:host(.mk-controls-container) .mk-user-location-control .mk-icon.mk-icon-waiting rect:nth-child(4){animation-delay:-.3s}:host(.mk-controls-container) .mk-user-location-control .mk-icon.mk-icon-waiting rect:nth-child(5){animation-delay:-.4s}:host(.mk-controls-container) .mk-user-location-control .mk-icon.mk-icon-waiting rect:nth-child(6){animation-delay:-.5s}:host(.mk-controls-container) .mk-user-location-control .mk-icon.mk-icon-waiting rect:nth-child(7){animation-delay:-.6s}:host(.mk-controls-container) .mk-user-location-control .mk-icon.mk-icon-waiting rect:nth-child(8){animation-delay:-.7s}@keyframes mk-spinner{0%{opacity:1}88%{opacity:.15}}:host(.mk-controls-container) .mk-map-type-control .mk-icon,:host(.mk-controls-container) .mk-user-location-control .mk-icon{pointer-events:none;display:block;opacity:.55}:host(.mk-controls-container) .mk-map-type-control.mk-pressed .mk-icon,:host(.mk-controls-container) .mk-map-type-control:focus .mk-icon,:host(.mk-controls-container) .mk-map-type-control:hover .mk-icon,:host(.mk-controls-container) .mk-user-location-control.mk-pressed .mk-icon,:host(.mk-controls-container) .mk-user-location-control:focus .mk-icon,:host(.mk-controls-container) .mk-user-location-control:hover .mk-icon{opacity:.85}@media (hover:none){:host(.mk-controls-container) .mk-map-type-control:hover:not(.mk-pressed):not(:focus) .mk-icon,:host(.mk-controls-container) .mk-user-location-control:hover:not(.mk-pressed):not(:focus) .mk-icon{opacity:.55}}:host(.mk-controls-container) .mk-popover{visibility:hidden;transform:scale(.5);opacity:0;border-radius:10px;transition:.2s opacity cubic-bezier(.25,.1,.25,1),.2s visibility step-end,.2s transform step-end;will-change:transform,opacity,visibility;border-width:1px;border-style:solid;cursor:default}:host(.mk-controls-container) .mk-popover.mk-shown{visibility:visible;pointer-events:auto;transform:none;opacity:1;transition:.2s transform cubic-bezier(.25,.1,.25,1.3),.2s opacity cubic-bezier(.25,.1,.25,1.3)}:host(.mk-controls-container) .mk-popover-arrow path{stroke-width:1px}:host(.mk-controls-container) .mk-map-type-popover{width:241px;padding:20px 20px 0 20px}:host(.mk-controls-container) .mk-map-type-popover>div{width:67px;display:inline-block}:host(.mk-controls-container) .mk-map-type-label{margin-top:10px;margin-bottom:17px;text-align:center;font-size:calc(100% * 13 / var(--font-size-default));line-height:calc(16 / 13 * 100%);font-family:"-apple-system-font",HelveticaNeue-Medium,Helvetica,Arial,sans-serif}.mk-map-type-button{position:relative;display:block;cursor:pointer;width:65px;height:52px}.mk-map-type-button input{appearance:none;padding:0;margin:0}.mk-map-type-button img,.mk-map-type-button input,.mk-map-type-button::after{position:absolute;top:0;left:0;width:65px;height:52px;border-radius:8px}.mk-map-type-button::after{content:""}:host(.mk-controls-container) .mk-map-type-button img.mk-dark-icon,:host(.mk-controls-container.mk-color-scheme-dark) .mk-map-type-button img.mk-light-icon{display:none}:host(.mk-controls-container.mk-color-scheme-dark) .mk-map-type-button img.mk-dark-icon{display:block}.mk-style-helper{opacity:0;pointer-events:none}.mk-compass,.mk-rotation-control{width:48px;height:48px;pointer-events:auto;border-radius:50%;overflow:hidden;line-height:0;transition:opacity .1s cubic-bezier(.19,1,.22,1)}.mk-rotation-control{cursor:-webkit-grab;cursor:grab}.mk-rotation-control.mk-pressed{cursor:-webkit-grabbing;cursor:grabbing}@supports ((backdrop-filter:blur(30px)) or (-webkit-backdrop-filter:blur(30px))){.mk-compass,.mk-focus .mk-zoom-in,.mk-focus .mk-zoom-out,.mk-legal:focus-visible,.mk-pill-focus .mk-map-type-control,.mk-pill-focus .mk-user-location-control,.mk-pill-pressed .mk-map-type-control,.mk-pill-pressed .mk-user-location-control,.mk-pill-pressed .mk-zoom-in,.mk-pill-pressed .mk-zoom-out,.mk-rotation-control,.mk-top-right-controls-container:not(.mk-pill-pressed):not(.mk-pill-focus):not(:empty),.mk-zoom-controls:not(.mk-pill-pressed):not(.mk-focus){-webkit-backdrop-filter:blur(30px);backdrop-filter:blur(30px)}}.mk-compass>.mk-compass-wrapper,.mk-rotation-control>.mk-rotation-wrapper{width:100%;height:100%;position:absolute;will-change:transform;overflow:hidden;pointer-events:none}.mk-compass>.mk-compass-wrapper>img,.mk-rotation-control>.mk-rotation-wrapper>img{position:absolute;left:0;top:0;width:200%;height:200%;pointer-events:none}.mk-compass:active>.mk-compass-wrapper>img,.mk-compass:hover>.mk-compass-wrapper>img,.mk-rotation-control.mk-focus>.mk-rotation-wrapper>img,.mk-rotation-control.mk-pressed>.mk-rotation-wrapper>img,.mk-rotation-control:hover>.mk-rotation-wrapper>img{left:-100%}.mk-compass:has(:focus-visible)>.mk-compass-wrapper>img{left:-100%}@media (hover:none){.mk-rotation-control:hover:not(.mk-focus):not(.mk-pressed)>.mk-rotation-wrapper>img{left:0}.mk-compass:hover:not(:has(:focus-visible)):not(:active)>.mk-compass-wrapper>img{left:0}}:host(.mk-dark-mode) .mk-compass>.mk-compass-wrapper>img,:host(.mk-dark-mode) .mk-rotation-control>.mk-rotation-wrapper>img{top:-100%}.mk-compass .mk-compass-heading,.mk-rotation-control .mk-heading{font:15.5px "-apple-system-font",HelveticaNeue-Medium,Helvetica,Arial,sans-serif;font-weight:500;position:absolute;left:0;width:100%;overflow:hidden;text-overflow:clip;text-align:center;opacity:.55;pointer-events:none}.mk-compass .mk-compass-heading{top:0;line-height:48px}.mk-rotation-control .mk-heading{top:calc(50% - 1em / 15.5 * 10.5);line-height:19px}.mk-compass:active .mk-compass-heading,.mk-compass:hover .mk-compass-heading,.mk-rotation-control.mk-focus .mk-heading,.mk-rotation-control.mk-pressed .mk-heading,.mk-rotation-control:hover .mk-heading{opacity:.85}.mk-compass:has(:focus-visible) .mk-compass-heading{opacity:.85}@media (hover:none){.mk-rotation-control:not(.mk-focus):not(.mk-pressed):hover .mk-heading{opacity:.55}.mk-compass:not(:has(:focus-visible)):not(:active):hover .mk-compass-heading{opacity:.55}}.mk-rotation-control .mk-rotation-slider{position:absolute;left:0;width:100%;height:15px;top:-30px}.mk-compass-slider{all:initial;opacity:0;position:absolute;display:block;width:100%;height:100%;top:0;left:0;border-radius:24px;margin:0;padding:0;cursor:grab}.mk-compass-slider:active{cursor:grabbing}.mk-compass-slider::-webkit-slider-runnable-track,.mk-compass-slider::-webkit-slider-thumb{all:initial;appearance:none;display:block;width:100%;height:100%;top:0;left:0}.mk-compass-slider::-moz-range-progress,.mk-compass-slider::-moz-range-thumb,.mk-compass-slider::-moz-range-track{all:initial;appearance:none;display:block;width:100%;height:100%}:host(.mk-controls-container.mk-dragging-annotation) .mk-legal,:host(.mk-controls-container.mk-dragging-annotation) .mk-map-type-control,:host(.mk-controls-container.mk-dragging-annotation) .mk-rotation-control,:host(.mk-controls-container.mk-dragging-annotation) .mk-rotation-control input,:host(.mk-controls-container.mk-dragging-annotation) .mk-user-location-control,:host(.mk-controls-container.mk-dragging-annotation) .mk-zoom-in,:host(.mk-controls-container.mk-dragging-annotation) .mk-zoom-out{cursor:none}.mk-compass,.mk-rotation-control,.mk-top-right-controls-container:not(.mk-pill-pressed):not(.mk-pill-focus):not(:empty),.mk-zoom-controls{box-shadow:0 0 0 .5px rgba(0,0,0,.05)}.mk-compass,.mk-focus .mk-zoom-in,.mk-focus .mk-zoom-out,.mk-pill-focus .mk-map-type-control,.mk-pill-focus .mk-user-location-control,.mk-pill-pressed .mk-map-type-control,.mk-pill-pressed .mk-user-location-control,.mk-pill-pressed .mk-zoom-in,.mk-pill-pressed .mk-zoom-out,.mk-rotation-control,.mk-top-right-controls-container:not(.mk-pill-pressed):not(.mk-pill-focus):not(:empty),.mk-zoom-controls:not(.mk-pill-pressed):not(.mk-focus){background-color:#fff}.mk-compass:active,.mk-map-type-control.mk-pressed,.mk-rotation-control.mk-pressed,.mk-user-location-control.mk-pressed,.mk-zoom-controls .mk-zoom-in.mk-pressed:not(.mk-disabled),.mk-zoom-controls .mk-zoom-out.mk-pressed:not(.mk-disabled){background-color:#e5e5e5}.mk-legal:focus-visible,.mk-map-type-control:focus,.mk-rotation-control.mk-focus,.mk-user-location-control:focus,.mk-zoom-controls.mk-focus .mk-zoom-in:focus,.mk-zoom-controls.mk-focus .mk-zoom-out:focus{background-color:#cce5ff}.mk-legal:focus-visible,.mk-map-type-control:focus,.mk-pill-focus .mk-map-type-control,.mk-pill-focus .mk-user-location-control,.mk-rotation-control.mk-focus,.mk-user-location-control:focus,.mk-zoom-controls.mk-focus{box-shadow:0 0 0 2px #007cff}.mk-compass:has(:focus-visible){background-color:#cce5ff;box-shadow:0 0 0 2px #007cff}.mk-map-type-control.mk-focus.mk-pressed,.mk-rotation-control.mk-focus.mk-pressed,.mk-user-location-control.mk-focus.mk-pressed,.mk-zoom-controls.mk-focus .mk-zoom-in.mk-pressed:focus,.mk-zoom-controls.mk-focus .mk-zoom-out.mk-pressed:focus{background-color:#7fbdff}.mk-compass:has(:focus-visible):active{background-color:#7fbdff}.mk-zoom-controls.mk-focus .mk-divider{border-left:2px solid #007cff}.mk-map-type-control .mk-icon,.mk-user-location-control .mk-icon,.mk-zoom-controls .mk-icon{fill:#000}:host(.mk-controls-container) .mk-popover{background-color:#efefef;color:#000;border-color:transparent;box-shadow:0 5px 10px 0 rgba(0,0,0,.3)}:host(.mk-controls-container) .mk-popover-arrow{fill:#efefef}.mk-error-message{color:#333}.mk-error-message a{color:#007aff}.mk-error-message a:visited{color:#af52de}.mk-legal .mk-legal-label{color:rgba(0,0,0,.7);text-shadow:0 0 1px rgba(255,255,255,.85)}.mk-compass .mk-compass-heading,.mk-rotation-control .mk-heading{color:#000}.mk-popover .mk-map-type-button input{box-shadow:0 0 0 .5px rgb(0,0,0,.14)}.mk-popover .mk-map-type-button input:checked{box-shadow:0 0 0 2px #007cff}.mk-popover .mk-map-type-button input:focus-visible{box-shadow:0 0 0 4px rgba(0,124,255,.4)}.mk-popover .mk-map-type-button input:checked:focus-visible{box-shadow:0 0 0 2px #007cff,0 0 0 4px rgba(0,124,255,.4)}.mk-map-type-button:active::after{background-color:rgba(0,0,0,.25)}@supports ((backdrop-filter:blur(30px)) or (-webkit-backdrop-filter:blur(30px))){.mk-compass,.mk-focus .mk-zoom-in,.mk-focus .mk-zoom-out,.mk-pill-focus .mk-map-type-control,.mk-pill-focus .mk-user-location-control,.mk-pill-pressed .mk-map-type-control,.mk-pill-pressed .mk-user-location-control,.mk-pill-pressed .mk-zoom-in,.mk-pill-pressed .mk-zoom-out,.mk-rotation-control,.mk-top-right-controls-container:not(.mk-pill-pressed):not(.mk-pill-focus):not(:empty),.mk-zoom-controls:not(.mk-pill-pressed):not(.mk-focus){background-color:rgba(255,255,255,.75)}.mk-compass:active,.mk-map-type-control.mk-pressed,.mk-rotation-control.mk-pressed,.mk-user-location-control.mk-pressed,.mk-zoom-controls .mk-zoom-in.mk-pressed:not(.mk-disabled),.mk-zoom-controls .mk-zoom-out.mk-pressed:not(.mk-disabled){background-color:rgba(229,229,229,.6)}.mk-legal:focus-visible,.mk-map-type-control.mk-focus,.mk-rotation-control.mk-focus,.mk-user-location-control.mk-focus,.mk-zoom-controls.mk-focus .mk-zoom-in:focus,.mk-zoom-controls.mk-focus .mk-zoom-out:focus{background-color:rgba(204,229,255,.6)}.mk-compass:has(:focus-visible){background-color:rgba(204,229,255,.6)}.mk-map-type-control.mk-focus.mk-pressed,.mk-rotation-control.mk-focus.mk-pressed,.mk-user-location-control.mk-focus.mk-pressed,.mk-zoom-controls.mk-focus .mk-zoom-in.mk-pressed:focus,.mk-zoom-controls.mk-focus .mk-zoom-out.mk-pressed:focus{background-color:rgb(127,189,255,.6)}.mk-compass:has(:focus-visible):active{background-color:rgb(127,189,255,.6)}}:host(.mk-dark-mode) .mk-compass,:host(.mk-dark-mode) .mk-rotation-control,:host(.mk-dark-mode) .mk-top-right-controls-container:not(.mk-pill-pressed):not(.mk-pill-focus):not(:empty),:host(.mk-dark-mode) .mk-zoom-controls{box-shadow:0 0 0 .5px rgba(255,255,255,.05)}:host(.mk-dark-mode) .mk-compass,:host(.mk-dark-mode) .mk-focus .mk-zoom-in,:host(.mk-dark-mode) .mk-focus .mk-zoom-out,:host(.mk-dark-mode) .mk-pill-focus .mk-map-type-control,:host(.mk-dark-mode) .mk-pill-focus .mk-user-location-control,:host(.mk-dark-mode) .mk-pill-pressed .mk-map-type-control,:host(.mk-dark-mode) .mk-pill-pressed .mk-user-location-control,:host(.mk-dark-mode) .mk-pill-pressed .mk-zoom-in,:host(.mk-dark-mode) .mk-pill-pressed .mk-zoom-out,:host(.mk-dark-mode) .mk-rotation-control,:host(.mk-dark-mode) .mk-top-right-controls-container:not(.mk-pill-pressed):not(.mk-pill-focus):not(:empty),:host(.mk-dark-mode) .mk-zoom-controls:not(.mk-pill-pressed):not(.mk-focus){background-color:#121212}:host(.mk-dark-mode) .mk-map-type-control.mk-pressed,:host(.mk-dark-mode) .mk-user-location-control.mk-pressed,:host(.mk-dark-mode) .mk-zoom-controls .mk-zoom-in.mk-pressed:not(.mk-disabled),:host(.mk-dark-mode) .mk-zoom-controls .mk-zoom-out.mk-pressed:not(.mk-disabled){background-color:#2a2a2a}:host(.mk-dark-mode) .mk-legal:focus-visible,:host(.mk-dark-mode) .mk-map-type-control.mk-focus,:host(.mk-dark-mode) .mk-rotation-control.mk-focus,:host(.mk-dark-mode) .mk-user-location-control.mk-focus,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus .mk-zoom-in:focus,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus .mk-zoom-out:focus{background-color:#0c3159}:host(.mk-dark-mode) .mk-legal:focus-visible,:host(.mk-dark-mode) .mk-map-type-control:focus,:host(.mk-dark-mode) .mk-pill-focus .mk-map-type-control,:host(.mk-dark-mode) .mk-pill-focus .mk-user-location-control,:host(.mk-dark-mode) .mk-rotation-control.mk-focus,:host(.mk-dark-mode) .mk-user-location-control:focus,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus{box-shadow:0 0 0 2px #007cff}:host(.mk-dark-mode) .mk-compass:has(:focus-visible){background-color:#0c3159;box-shadow:0 0 0 2px #007cff}:host(.mk-dark-mode) .mk-map-type-control.mk-focus.mk-pressed,:host(.mk-dark-mode) .mk-rotation-control.mk-focus.mk-pressed,:host(.mk-dark-mode) .mk-user-location-control.mk-focus.mk-pressed,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus .mk-zoom-in.mk-pressed:focus,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus .mk-zoom-out.mk-pressed:focus{background-color:#0366cf}:host(.mk-dark-mode) .mk-compass:has(:focus-visible):active{background-color:#0366cf}:host(.mk-dark-mode) .mk-map-type-control .mk-icon,:host(.mk-dark-mode) .mk-user-location-control .mk-icon,:host(.mk-dark-mode) .mk-zoom-controls .mk-icon{fill:#fff}:host(.mk-controls-container.mk-dark-mode) .mk-popover{background-color:#363636;color:#fff;border-color:#5a5c64}:host(.mk-controls-container.mk-dark-mode) .mk-popover-arrow{fill:#363636}:host(.mk-controls-container.mk-dark-mode) .mk-popover-arrow path{stroke:#5a5c64}:host(.mk-dark-mode) .mk-error-message{color:rgba(255,255,255,.85)}:host(.mk-dark-mode) .mk-error-message a{color:#0a84ff}:host(.mk-dark-mode) .mk-error-message a:visited{color:#bf5af2}:host(.mk-dark-mode) .mk-legal .mk-legal-label{color:rgba(255,255,255,.9);text-shadow:0 0 1px rgba(0,0,0,.5),0 0 10px rgba(0,0,0,1)}:host(.mk-dark-mode) .mk-compass .mk-compass-heading,:host(.mk-dark-mode) .mk-rotation-control .mk-heading{color:#fff}:host(.mk-dark-mode) .mk-popover .mk-map-type-button input:not(:checked):not(:focus-visible){box-shadow:0 0 0 .5px rgb(255,255,255,.3)}@supports ((backdrop-filter:blur(30px)) or (-webkit-backdrop-filter:blur(30px))){:host(.mk-dark-mode) .mk-compass,:host(.mk-dark-mode) .mk-focus .mk-zoom-in,:host(.mk-dark-mode) .mk-focus .mk-zoom-out,:host(.mk-dark-mode) .mk-pill-focus .mk-map-type-control,:host(.mk-dark-mode) .mk-pill-focus .mk-user-location-control,:host(.mk-dark-mode) .mk-pill-pressed .mk-map-type-control,:host(.mk-dark-mode) .mk-pill-pressed .mk-user-location-control,:host(.mk-dark-mode) .mk-pill-pressed .mk-zoom-in,:host(.mk-dark-mode) .mk-pill-pressed .mk-zoom-out,:host(.mk-dark-mode) .mk-rotation-control,:host(.mk-dark-mode) .mk-top-right-controls-container:not(.mk-pill-pressed):not(.mk-pill-focus):not(:empty),:host(.mk-dark-mode) .mk-zoom-controls:not(.mk-pill-pressed):not(.mk-focus){background-color:rgba(18,18,18,.6)}:host(.mk-dark-mode) .mk-compass:active,:host(.mk-dark-mode) .mk-map-type-control.mk-pressed,:host(.mk-dark-mode) .mk-rotation-control.mk-pressed,:host(.mk-dark-mode) .mk-type-control.mk-pressed,:host(.mk-dark-mode) .mk-user-location-control.mk-pressed,:host(.mk-dark-mode) .mk-zoom-controls .mk-zoom-in.mk-pressed:not(.mk-disabled),:host(.mk-dark-mode) .mk-zoom-controls .mk-zoom-out.mk-pressed:not(.mk-disabled){background-color:rgba(42,42,42,.6)}:host(.mk-dark-mode) .mk-legal:focus-visible,:host(.mk-dark-mode) .mk-map-type-control.mk-focus,:host(.mk-dark-mode) .mk-rotation-control.mk-focus,:host(.mk-dark-mode) .mk-user-location-control.mk-focus,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus .mk-zoom-in:focus,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus .mk-zoom-out:focus{background-color:rgba(12,49,89,.6)}:host(.mk-dark-mode) .mk-compass:has(:focus-visible){background-color:rgba(12,49,89,.6)}:host(.mk-dark-mode) .mk-map-type-control.mk-focus.mk-pressed,:host(.mk-dark-mode) .mk-rotation-control.mk-focus.mk-pressed,:host(.mk-dark-mode) .mk-user-location-control.mk-focus.mk-pressed,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus .mk-zoom-in.mk-pressed:focus,:host(.mk-dark-mode) .mk-zoom-controls.mk-focus .mk-zoom-out.mk-pressed:focus{background-color:rgb(3,102,207,.6)}:host(.mk-dark-mode) .mk-compass:has(:focus-visible):active{background-color:rgb(3,102,207,.6)}}.mk-scale{position:absolute;top:0;left:0;vertical-align:top}:host(.mk-rtl) .mk-scale{direction:rtl}:host(.mk-controls-container) .mk-popover{position:absolute;top:38px;right:-1px}:host(.mk-controls-container) .mk-popover-arrow{position:absolute;top:-13px}.mk-top-right-controls-container{position:absolute;top:9px;right:9px;direction:ltr}:host(.mk-controls-container:not(.mk-rtl)) .mk-top-right-controls-container>.mk-control:first-child{border-top-left-radius:20% 37.5%;border-bottom-left-radius:20% 37.5%}:host(.mk-controls-container:not(.mk-rtl)) .mk-top-right-controls-container>.mk-control:nth-last-child(2){border-top-right-radius:20% 37.5%;border-bottom-right-radius:20% 37.5%}:host(.mk-controls-container) .mk-popover.mk-user-location-error-popover{transform-origin:calc(100% - 69px) -12.416px}:host(.mk-controls-container) .mk-popover.mk-map-type-popover,:host(.mk-controls-container) .mk-popover.mk-user-location-error-popover:last-child{transform-origin:calc(100% - 24px) -12.416px}:host(.mk-controls-container) .mk-popover.mk-user-location-error-popover>.mk-popover-arrow{right:52.5px}:host(.mk-controls-container) .mk-popover.mk-map-type-popover>.mk-popover-arrow,:host(.mk-controls-container) .mk-popover.mk-user-location-error-popover:last-child>.mk-popover-arrow{right:10px}:host(.mk-controls-container) .mk-map-type-popover>div:not(:last-child){margin-right:20px}:host(.mk-controls-container) .mk-controls-container-controls-larger .mk-popover{top:44px}:host(.mk-controls-container) .mk-controls-container-controls-larger .mk-popover.mk-user-location-error-popover>.mk-popover-arrow{right:65px}:host(.mk-rtl) .mk-top-right-controls-container{left:9px;right:auto;direction:rtl}:host(.mk-controls-container.mk-rtl) .mk-top-right-controls-container>.mk-control:first-child{border-top-right-radius:20% 37.5%;border-bottom-right-radius:20% 37.5%}:host(.mk-controls-container.mk-rtl) .mk-top-right-controls-container>.mk-control:nth-last-child(2){border-top-left-radius:20% 37.5%;border-bottom-left-radius:20% 37.5%}:host(.mk-controls-container.mk-rtl) .mk-popover{right:auto;left:-1px}:host(.mk-controls-container.mk-rtl) .mk-popover.mk-user-location-error-popover{transform-origin:69px -12.416px}:host(.mk-controls-container.mk-rtl) .mk-popover.mk-map-type-popover,:host(.mk-controls-container.mk-rtl) .mk-popover.mk-user-location-error-popover:last-child{transform-origin:24px -12.416px}:host(.mk-controls-container.mk-rtl) .mk-popover.mk-user-location-error-popover>.mk-popover-arrow{right:auto;left:52.5px}:host(.mk-controls-container) .mk-controls-container-controls-larger .mk-popover.mk-map-type-popover>.mk-popover-arrow{right:12px}:host(.mk-controls-container.mk-rtl) .mk-popover.mk-map-type-popover>.mk-popover-arrow,:host(.mk-controls-container.mk-rtl) .mk-popover.mk-user-location-error-popover:last-child>.mk-popover-arrow{right:auto;left:10px}:host(.mk-controls-container.mk-rtl) .mk-controls-container-controls-larger .mk-popover.mk-user-location-error-popover>.mk-popover-arrow{right:auto;left:69.75px}:host(.mk-controls-container) .mk-controls-container-controls-larger .mk-popover.mk-user-location-error-popover:last-child>.mk-popover-arrow{right:12px}:host(.mk-controls-container.mk-rtl) .mk-controls-container-controls-larger .mk-popover.mk-map-type-popover>.mk-popover-arrow,:host(.mk-controls-container.mk-rtl) .mk-controls-container-controls-larger .mk-popover.mk-user-location-error-popover:last-child>.mk-popover-arrow{right:auto;left:13.25px}:host(.mk-controls-container.mk-rtl) .mk-map-type-popover>div:not(:last-child){margin-left:20px;margin-right:0}.mk-bottom-left-controls-container,.mk-bottom-right-controls-container{position:absolute;bottom:9px}.mk-rotation-control,.mk-zoom-controls{position:absolute;bottom:0}.mk-compass{position:absolute;bottom:42px}.mk-legal,.mk-logo-control{position:absolute}.mk-logo-control,:host(.mk-controls-container) .mk-legal{bottom:-4px}:host(.mk-controls) .mk-legal{bottom:9px}.mk-bottom-right-controls-container{right:9px}.mk-bottom-left-controls-container{left:9px}:host(.mk-reduce-margin) .mk-bottom-right-controls-container{right:0}:host(.mk-reduce-margin) .mk-bottom-left-controls-container{left:4px}.mk-logo-control{left:0}:host(.mk-controls-container) div.mk-logo-control img.mk-logo.mk-logo-autonavi.mk-logo-autonavi{margin:0 0 -6px -9px}.mk-rotation-control,.mk-zoom-controls,:host(.mk-controls-container) .mk-legal{right:0;left:auto}:host(:not(.mk-rtl))>.mk-compass{right:9px}:host(.mk-controls-container) .mk-legal{right:auto;left:0}:host(.mk-controls:not(.mk-rtl))>.mk-legal{right:0}.mk-zoom-controls .mk-zoom-in{border-top-right-radius:50%;border-bottom-right-radius:50%;right:0}.mk-zoom-controls .mk-zoom-out{border-top-left-radius:50%;border-bottom-left-radius:50%;left:0}.mk-rotation-control~.mk-zoom-controls{right:57px;left:auto}:host(.mk-controls-container) .mk-legal:nth-child(2){left:calc(var(--logo-width) * var(--logo-xmax))}:host(.mk-rtl) .mk-bottom-right-controls-container{left:9px;right:auto}:host(.mk-rtl) .mk-bottom-left-controls-container{left:auto;right:9px}:host(.mk-rtl.mk-reduce-margin) .mk-bottom-right-controls-container{left:0;right:auto}:host(.mk-rtl.mk-reduce-margin) .mk-bottom-left-controls-container{left:auto;right:4px}:host(.mk-rtl) .mk-logo-control{left:auto;right:0}:host(.mk-rtl.mk-controls-container) div.mk-logo-control img.mk-logo.mk-logo-autonavi.mk-logo-autonavi{margin:0 -9px -6px 0}:host(.mk-rtl) .mk-zoom-controls .mk-zoom-in{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:50%;border-bottom-left-radius:50%;right:auto;left:0}:host(.mk-rtl) .mk-zoom-controls .mk-zoom-out{border-top-right-radius:50%;border-bottom-right-radius:50%;border-top-left-radius:0;border-bottom-left-radius:0;right:0;left:auto}:host(.mk-controls-container.mk-rtl) .mk-legal,:host(.mk-rtl) .mk-rotation-control,:host(.mk-rtl) .mk-zoom-controls{left:0;right:auto}:host(.mk-rtl)>.mk-compass{left:9px}:host(.mk-controls.mk-rtl)>.mk-legal{left:0}:host(.mk-controls-container.mk-rtl) .mk-legal{left:auto;right:0}:host(.mk-rtl) .mk-rotation-control~.mk-zoom-controls{left:57px;right:auto}:host(.mk-controls-container) .mk-autonavi .mk-legal:nth-child(2){left:calc(var(--logo-width) * var(--logo-xmax) - 9px)}:host(.mk-controls-container.mk-rtl) .mk-legal:nth-child(2){right:calc(var(--logo-width) * (1 - var(--logo-xmin)))}:host(.mk-controls-container.mk-rtl) .mk-autonavi .mk-legal:nth-child(2){left:auto;right:calc(var(--logo-width) * (1 - var(--logo-xmin)) - 9px)}',
          dt.nonce
        )),
        this._shadowRootNode.addChild(this._topRightControlsNode),
        this._shadowRootNode.addChild(this._bottomRightControlsNode),
        this._shadowRootNode.addChild(this._bottomLeftControlsNode),
        (this._logo = new lr()),
        (this._legalNode = new cr()),
        this._logo.setUpdatedDelegate(this),
        dt.addEventListener(dt.Events.Changed, this),
        this._updateAutoNaviClass(),
        (this.textZoom = t.textZoom),
        fi.activeLocale &&
          ((this._rtl = fi.activeLocale.rtl),
          this.setAttribute("lang", fi.localeId),
          this.classList.toggle(Sl, this._rtl)),
        fi.addEventListener(fi.Events.LocaleChanged, this));
    }
    get textZoom() {
      return this.classList.contains(xl);
    }
    set textZoom(t) {
      this.classList.toggle(xl, t);
    }
    get controlsPending() {
      return this._controlsPending;
    }
    set canShowTooltips(t) {
      (this._userLocationControl && (this._userLocationControl.canShowTooltips = t),
        this._zoomControl && (this._zoomControl.canShowTooltips = t),
        this._mapTypeControl && (this._mapTypeControl.canShowTooltips = t),
        this._rotationControl && (this._rotationControl.canShowTooltips = t));
    }
    mapPaddingDidChange(t) {
      const e = this.element.style;
      ((e.top = t.top + "px"),
        (e.left = t.left + "px"),
        (e.bottom = t.bottom + "px"),
        (e.right = t.right + "px"),
        this.sizeDidChange());
    }
    sizeDidChange() {
      const t = this._shouldHideControls();
      (this._toggleControl(this._map.showsZoomControl && !t, this._zoomControl, this.updateZoomControl),
        this._toggleControl(this._map.showsMapTypeControl && !t, this._mapTypeControl, this.updateMapTypeControl),
        this._toggleControl(
          this._map.showsUserLocationControl && !t,
          this._userLocationControl,
          this.updateUserLocationControl
        ),
        this.updateLogo(),
        this.updateLegalNode(),
        this.updateRotationControl(),
        this.updateScale(),
        this.zoomLevelDidChange());
      const e = this._getSizeClass();
      (this._updateTopRightControlsContainer(!1),
        this._setSizeClass(this._bottomRightControlsNode, e),
        this._setSizeClass(this._bottomLeftControlsNode, e),
        this._setReduceMargin());
    }
    logoUpdated(t) {
      const e = this._bottomLeftControlsNode.domNode;
      (e.style.setProperty("--logo-xmin", t.xMin), e.style.setProperty("--logo-xmax", t.xMax));
    }
    zoomLevelDidChange() {
      this._zoomControl &&
        ((this._zoomControl.zoomOutEnabled = this._map.canZoomOut),
        (this._zoomControl.zoomInEnabled = this._map.canZoomIn));
    }
    update() {
      this._map &&
        (this.classList.toggle("mk-color-scheme-dark", qn.darkColorScheme(this._map.currentColorScheme)),
        this.classList.toggle("mk-dark-mode", qn.darkColorScheme(this._map.tint)),
        this._shouldHideControls()
          ? (this._removeZoomControl(),
            this._removeMapTypeControl(),
            this._removeUserLocationControl(),
            this._removeRotationControl(),
            this._removeScale())
          : (this.updateZoomControl(),
            this.updateMapTypeControl(),
            this.updateUserLocationControl(),
            this.updateRotationControl(),
            this.updateScale()),
        this.updateLogo(),
        this.updateLegalNode(),
        this._setReduceMargin());
    }
    scaleDidChange() {
      this._scale && (this._scale.update(), this._scale.hideIfNeeded());
    }
    updateScale() {
      this._map.showsScale === kl.Hidden || this._shouldHideControls()
        ? this._removeScale()
        : (this._addScale(),
          (this._scale.node.mapWidth = this._map._mapNode.size.width),
          this._scale.updateTheme(this._map.mapNodeTint),
          this._positionScale(),
          this._scale.update());
    }
    updateZoomControl() {
      this._map.showsZoomControl && !this._shouldHideControls()
        ? (this._addZoomControl(),
          (this._zoomControl.enabled = this._map.isZoomEnabled),
          this.zoomLevelDidChange(),
          this._zoomControl.updateTintColor(this._map.tintColorForControls))
        : this._removeZoomControl();
    }
    updateMapTypeControl() {
      this._map.showsMapTypeControl && !this._shouldHideControls()
        ? (this._addMapTypeControl(),
          (this._mapTypeControl.mapType = this._map.mapType),
          (this._mapTypeControl.enabled = !0),
          this._mapTypeControl.updateTintColor(this._map.tintColorForControls))
        : this._removeMapTypeControl();
    }
    updateUserLocationControl() {
      if (this._map.showsUserLocationControl && !this._shouldHideControls()) {
        switch (
          (this._addUserLocationControl(), (this._userLocationControl.enabled = !0), this._userLocationControl.state)
        ) {
          case fl.States.Default:
            Dl.userLocation.isAvailable
              ? this._map.tracksUserLocation && Dl.userLocation.location
                ? this._userLocationControl.toTrackingState()
                : (this._map.tracksUserLocation ||
                    (this._map.showsUserLocation && !this._map.userLocationAnnotation)) &&
                  this._userLocationControl.toWaitingState()
              : this._userLocationControl.toDisabledState();
            break;
          case fl.States.Waiting:
            (Dl.userLocation.location && this.userLocationDidChange(Dl.userLocation),
              this._map.showsUserLocation || this._userLocationControl.toDefaultState());
            break;
          case fl.States.Tracking:
            this._map.tracksUserLocation || this._userLocationControl.toDefaultState();
        }
        this._userLocationControl.updateTintColor(this._map.tintColorForControls);
      } else this._removeUserLocationControl();
    }
    updateRotationControl() {
      this._shouldHideControls() || this._map.isCompassHidden
        ? this._removeRotationControl()
        : (this._addRotationControl(),
          (this._rotationControl.rotation = this._map.rotation),
          this._rotationControl.updateImage(qn.devicePixelRatio, qn.darkColorScheme(this._map.mapNodeTint)),
          this._rotationControl.updateTintColor(this._map.tintColorForControls));
    }
    updateLegalNode() {
      this._addAndUpdateLegalNode();
    }
    updateLogo() {
      (!this._shouldHideLogo() && zl() ? this._addAndUpdateLogo() : this._logo.remove(),
        this._legalNode.updateWithMapType(this._map.mapType));
    }
    devicePixelRatioDidChange() {
      (this._rotationControl &&
        this._rotationControl.updateImage(qn.devicePixelRatio, qn.darkColorScheme(this._map.mapNodeTint)),
        this._scale && this._scale.update(),
        this._logo.updateWithMapNodeTint(this._map.mapNodeTint));
    }
    fontSizeDidChange() {
      this._scale && this._scale.update();
    }
    handleEvent(t) {
      if (this._map)
        switch (t.type) {
          case Or.EVENTS.MAP_TYPE_CHANGE:
            this._mapTypeControl && (this._map.mapType = this._mapTypeControl.mapType);
            break;
          case fl.EVENTS.PRESSED:
            this._userLocationControl.state === fl.States.Waiting
              ? (this._map.tracksUserLocation = !0)
              : this._userLocationControl.state !== fl.States.Tracking && (this._map.tracksUserLocation = !1);
            break;
          case fi.Events.LocaleChanged:
            this._handleLocaleChanged(t);
            break;
          case "update":
            (this._unsetPendingControls(), this._map.addWaitingAnnotations());
            break;
          case dt.Events.Changed:
            (this._updateAutoNaviClass(), this.updateLogo(), this.updateLegalNode());
        }
    }
    mapWasDestroyed() {
      (this._unsetPendingControls(),
        fi.removeEventListener(fi.Events.LocaleChanged, this),
        dt.removeEventListener(dt.Events.Changed, this),
        this._destroyZoomControl(),
        this._destroyMapTypeControl(),
        this._destroyUserLocationControl(),
        this._destroyRotationControl(!0),
        this._legalNode.remove(),
        delete this._legalNode,
        this._logo.mapWasDestroyed(),
        this._logo.remove(),
        delete this._logo,
        this._removeScale(),
        this.remove(),
        delete this._map);
    }
    userLocationDidChange(t) {
      this._userLocationControl &&
        (this._map.tracksUserLocation
          ? this._userLocationControl.toTrackingState()
          : this._userLocationControl.toDefaultState());
    }
    userLocationDidError(t) {
      (this._userLocationControl && this._userLocationControl.toDisabledState(),
        this._map.userLocationAnnotation || 3 === t.errorCode || (this._map.showsUserLocation = !1));
    }
    _handleLocaleChanged(t) {
      (this.classList.toggle(Sl, t.locale.rtl),
        this.setAttribute("lang", fi.localeId),
        this._rtl !== t.locale.rtl
          ? ((this._rtl = t.locale.rtl), (this._rtlChanged = !0), this.update(), (this._rtlChanged = !1))
          : this.updateLogo());
    }
    _addScale() {
      this._scale ||
        (this._setPendingControls(), (this._scale = new tl(this._map)), this._shadowRootNode.addChild(this._scale, 0));
    }
    _positionScale() {
      const t = this._map.ensureVisibleFrame().size,
        e = !this._rtl;
      ((this._scale.node.leftAligned = e),
        (this._scale.position = new Mi(e ? Pl.x : t.width - this._scale.size.width - Pl.x, Pl.y)),
        this._scale.shouldDisplayScale || this._scale.node.setOpacityAnimated(0, !1));
    }
    _removeScale() {
      this._scale &&
        (this._setPendingControls(), this._scale.mapWasDestroyed(), this._scale.remove(), delete this._scale);
    }
    _addZoomControl() {
      !this._map.showsZoomControl ||
        this._zoomControl ||
        this._shouldHideControls() ||
        (this._setPendingControls(),
        (this._zoomControl = new al()),
        (this._zoomControl.enabled = this._map.isZoomEnabled),
        this._zoomControl.addEventListener(al.EVENTS.ZOOM_START, this._map),
        this._zoomControl.addEventListener(al.EVENTS.ZOOM_END, this._map),
        this._bottomRightControlsNode.insertBefore(this._zoomControl, this._legalNode),
        this._rotationControl && this._rotationControl.classList.add(Il));
    }
    _removeZoomControl() {
      (!this._shouldHideControls() && this._map.showsZoomControl) ||
        !this._zoomControl ||
        (this._setPendingControls(), (this._zoomControl.enabled = !1), this._destroyZoomControl());
    }
    _destroyZoomControl() {
      this._zoomControl &&
        (this._zoomControl.removeEventListener(al.EVENTS.ZOOM_START, this._map),
        this._zoomControl.removeEventListener(al.EVENTS.ZOOM_END, this._map),
        this._zoomControl.remove(),
        this._rotationControl && this._rotationControl.classList.remove(Il),
        delete this._zoomControl);
    }
    _addMapTypeControl() {
      !this._map.showsMapTypeControl ||
        this._mapTypeControl ||
        this._shouldHideControls() ||
        (this._setPendingControls(),
        (this._mapTypeControl = new Or(Xi, this._map.mapType, this)),
        this._mapTypeControl.addEventListener(Or.EVENTS.MAP_TYPE_CHANGE, this),
        this._topRightControlsNode.addChild(this._mapTypeControl),
        this._updateTopRightControlsContainer(!0));
    }
    _removeMapTypeControl() {
      this._mapTypeControl &&
        (this._setPendingControls(),
        (this._mapTypeControl.enabled = !1),
        this._destroyMapTypeControl(),
        this._updateTopRightControlsContainer(!0));
    }
    _destroyMapTypeControl() {
      this._mapTypeControl &&
        (this._mapTypeControl.removeEventListener(Or.EVENTS.MAP_TYPE_CHANGE, this),
        this._mapTypeControl.remove(),
        delete this._mapTypeControl);
    }
    _toggleControl(t, e, i) {
      ((e && !t) || (!e && t)) && i.call(this);
    }
    _shouldHideControls() {
      if (!dt.ready) return !0;
      const t = this._map.ensureVisibleFrame().size;
      return t.width < ln.minimumSizeToShowControls.width || t.height < ln.minimumSizeToShowControls.height;
    }
    _shouldHideLogo() {
      if (!dt.ready) return !0;
      const t = -1 === Ml.indexOf(fi.localeId) ? ln.minimumSizeToShowLogo : ln.minimumSizeToShowLogoWithReducedMargin,
        e = this._map.ensureVisibleFrame().size;
      return e.width < t.width || e.height < t.height;
    }
    _addRotationControl() {
      this._shouldHideControls() ||
        this._rotationControl ||
        (this._setPendingControls(),
        (this._rotationControl = new Cl(this._map)),
        (this._rotationControl.enabled = !0),
        this._bottomRightControlsNode.insertBefore(this._rotationControl, this._zoomControl || this._legalNode),
        this._zoomControl && this._rotationControl.classList.add(Il));
    }
    _removeRotationControl() {
      this._rotationControl && (this._setPendingControls(), this._destroyRotationControl());
    }
    _destroyRotationControl(t) {
      if (this._rotationControl) {
        if (t) (this._rotationControl.mapWasDestroyed(), this._rotationControl.remove());
        else {
          const t = this._rotationControl,
            e = () => {
              (clearTimeout(i), t.element.removeEventListener("transitionend", e), t.mapWasDestroyed(), t.remove());
            };
          t.opacity = 0;
          const i = setTimeout(e, 300);
          t.element.addEventListener("transitionend", e);
        }
        delete this._rotationControl;
      }
    }
    _addUserLocationControl() {
      !this._map.showsUserLocationControl ||
        this._userLocationControl ||
        this._shouldHideControls() ||
        (this._setPendingControls(),
        (this._userLocationControl = new fl(this._map, this._rtl, this)),
        this._userLocationControl.addEventListener(fl.EVENTS.PRESSED, this),
        this._topRightControlsNode.insertBefore(this._userLocationControl, this._mapTypeControl),
        this._updateTopRightControlsContainer(!0));
    }
    controlDidGetFocus(t) {
      this._toggleParentClass(t, Rl, !0);
    }
    controlDidLoseFocus(t) {
      this._toggleParentClass(t, Rl, !1);
    }
    controlWasPressed(t) {
      this._toggleParentClass(t, Ol, !0);
    }
    controlWasReleased(t) {
      this._toggleParentClass(t, Ol, !1);
    }
    _setSizeClass(t, e) {
      (t.classList.toggle(Al, Al === e), t.classList.toggle(El, El === e));
    }
    _updateAutoNaviClass() {
      const t = this._bottomRightControlsNode,
        e = this._bottomLeftControlsNode;
      (t.classList.toggle(Ll, dt.isAutoNavi), e.classList.toggle(Ll, dt.isAutoNavi));
    }
    _toggleParentClass(t, e, i) {
      const n = t.parent;
      n === this._topRightControlsNode && n.classList.toggle(e, i);
    }
    _removeUserLocationControl() {
      (!this._shouldHideControls() && this._map.showsUserLocationControl) ||
        !this._userLocationControl ||
        (this._setPendingControls(), this._destroyUserLocationControl(), this._updateTopRightControlsContainer(!0));
    }
    _destroyUserLocationControl() {
      this._userLocationControl &&
        (this._userLocationControl.removeEventListener(fl.EVENTS.STATE_CHANGE, this._map),
        this._userLocationControl.mapWasDestroyed(),
        this._userLocationControl.remove(),
        delete this._userLocationControl);
    }
    _addAndUpdateLegalNode() {
      (this._setPendingControls(),
        dt.showLegalLink &&
          (this._bottomLeftControlsNode.addChild(this._legalNode),
          this._legalNode.updateWithMapType(this._map.mapType)));
    }
    _addAndUpdateLogo() {
      (this._logo.parent ||
        (this._setPendingControls(), this._bottomLeftControlsNode.insertBefore(this._logo, this._legalNode)),
        this._logo.updateWithMapNodeTint(this._map.mapNodeTint));
    }
    _setPendingControls() {
      ((this._controlsPending = !0), Rn.addEventListener("update", this));
    }
    _unsetPendingControls() {
      ((this._controlsPending = !1), Rn.removeEventListener("update", this));
    }
    _setReduceMargin() {
      const t = this._map.ensureVisibleFrame().size.width,
        e = ln,
        i = e.minimumSizeToShowLogo.width,
        n = e.minimumSizeToShowControls.width;
      (this.classList.toggle("mk-reduce-margin", t < i && zl()),
        this.classList.toggle("mk-reduced-vertical-margin", t < n));
    }
    _updateTopRightControlsContainer(t) {
      const e = this._topRightControlsNode,
        i = e.element,
        n = i && i.parentNode;
      if (n && t) {
        const t = qn.htmlElement("div", {class: i.className});
        for (; i.children.length > 0; ) t.appendChild(i.children[0]);
        (n.insertBefore(t, i), n.removeChild(i), (e.element = t));
      }
      e.element && ((e.element.className = this._getTopRightControlsClass()), e.classList.reset());
    }
    _getSizeClass() {
      const t = this._map.ensureVisibleFrame().size,
        e = ln.maximumSizeControlsNormal;
      return t.width > e.width && t.height > e.height
        ? "mk-controls-container-controls-larger"
        : "mk-controls-container-controls-normal";
    }
    _getTopRightControlsClass() {
      const t = (this._userLocationControl ? 1 : 0) + (this._mapTypeControl ? 1 : 0);
      return "mk-top-right-controls-container " + Tl[t] + " " + this._getSizeClass();
    }
    controlBounds() {
      const t = [];
      return (
        [this._topRightControlsNode, this._bottomLeftControlsNode, this._bottomRightControlsNode].forEach(function (e) {
          0 !== e.children.length &&
            (e === this._bottomRightControlsNode ? Array.prototype.push.apply(t, e.children) : t.push(e));
        }, this),
        t.map(function (t) {
          try {
            const e = t.element.getBoundingClientRect();
            if ("none" === window.getComputedStyle(this._map.element).transform) {
              const t = this._map.element.getBoundingClientRect();
              return new Si(e.left - t.left, e.top - t.top, e.width, e.height);
            }
            return Si.rectFromClientRect(e);
          } catch (t) {
            return new Si();
          }
        }, this)
      );
    }
  }
  function zl() {
    return dt.isAutoNavi || dt.showMapsLogo;
  }
  ((Dl.ZoomControl = al),
    L.jsModules.userLocation
      ? (Dl.userLocation = L.jsModules.userLocation)
      : L.addEventListener("load", function t(e) {
          e.jsModules.userLocation && ((Dl.userLocation = e.jsModules.userLocation), L.removeEventListener("load", t));
        }));
  const Nl = Dl;
  class Fl {
    constructor({container: t, fontSizeDidChange: e}) {
      const i = document.createElement("div");
      ((this.element = i),
        t.appendChild(i),
        (i.className = "mk-font-size-detector"),
        (i.textContent = "A"),
        (i.ariaHidden = "true"),
        (this.fontSizeDidChange = e),
        CSS.supports("(font: -apple-system-body) and (-webkit-touch-callout: default)")
          ? ((this.defaultFontSize = this.currentFontSize = 17), (i.style.font = "-apple-system-body"))
          : ((this.defaultFontSize = this.currentFontSize = 16),
            (i.style.fontSize = "initial"),
            (i.style.fontFamily = "sans-serif")),
        (this.ratio = 1),
        "undefined" != typeof ResizeObserver &&
          ((this.observer = new ResizeObserver(() => this._sizeChanged())), this.observer.observe(i)));
    }
    _sizeChanged() {
      if (!this.element) throw new Error();
      const t = parseInt(window.getComputedStyle(this.element).fontSize);
      if (isNaN(t) || t === this.currentFontSize) return;
      const e = Math.min(t / this.defaultFontSize, 2);
      ((this.currentFontSize = this.defaultFontSize * e), (this.ratio = e), this.fontSizeDidChange(this));
    }
    destroy() {
      (this.observer && (this.observer.disconnect(), (this.observer = null)),
        this.element &&
          this.element.parentNode &&
          (this.element.parentNode.removeChild(this.element), (this.element = null)));
    }
  }
  let Ul = Math.random().toString(36);
  function Gl(t) {
    if (t === Ul) return;
    Ul = t;
    const e = "[MapKit] Authorization token is invalid.";
    if ("string" != typeof t) return void console.warn(e);
    const i = t.split(".");
    if (3 !== i.length) return void console.warn(e);
    let n;
    try {
      (i.pop(),
        (n = i.map((t) => {
          return JSON.parse(((e = t), window.atob(e)));
          var e;
        })));
    } catch (t) {
      return void console.warn(e);
    }
    ("alg" in n[0]
      ? "ES256" !== n[0].alg && console.warn('[MapKit] Authorization token has incorrect "alg" value.')
      : console.warn('[MapKit] Authorization token has no "alg" value.'),
      "typ" in n[0]
        ? "JWT" !== n[0].typ && console.warn('[MapKit] Authorization token has incorrect "typ" value.')
        : console.warn('[MapKit] Authorization token has no "typ" value.'),
      "kid" in n[0] || console.warn('[MapKit] Authorization token has no "kid" value.'));
    const o = Date.now(),
      s = 1e3 * parseInt(n[1].iat);
    if (
      (!("iat" in n[1]) || isNaN(s)
        ? console.warn('[MapKit] Authorization token has no "iat" value.')
        : s > o + 36e5 &&
          console.warn(
            '[MapKit] Authorization token may have an "iat" value that is in the future (' + new Date(s) + ")."
          ),
      "exp" in n[1])
    ) {
      const t = 1e3 * parseInt(n[1].exp);
      (t < o || isNaN(t)) && console.warn('[MapKit] Authorization token may be expired according to its "exp" value.');
    }
    "origin" in n[1] ||
      console.warn(
        "[MapKit] Authorization token without origin restriction is not recommended in production environments."
      );
  }
  for (
    Object.defineProperties(ht.prototype, {
      forcedRenderingMode: {
        get: function () {
          return this._forcedRenderingMode;
        }
      },
      didFallback: {
        get: function () {
          return this._syrupRequestedFallback;
        }
      },
      fallbackType: {
        get: function () {
          return this._syrupRequestedFallbackType;
        }
      },
      showMapsLogo: {
        get: function () {
          return this._showMapsLogo;
        }
      },
      showLegalLink: {
        get: function () {
          return this._showLegalLink;
        }
      },
      showsTileInfo: {
        get: function () {
          return this._showsTileInfo;
        }
      },
      canRunCSR: {
        get: function () {
          const t = "CLIENT" === this.forcedRenderingMode || "HYBRID" === this.forcedRenderingMode,
            e = "SERVER" === this.forcedRenderingMode;
          return !(!this.ready || e || (this._disableCsr && !t) || this._syrupRequestedFallback);
        }
      },
      madabaDomains: {
        get: function () {
          return this.customMadabaUrl || (!this._madabaDomains && this._madabaBaseUrl)
            ? [this._madabaBaseUrl]
            : this._madabaDomains
              ? this._madabaDomains
              : null;
        }
      }
    }),
      ht.prototype.syrupRequestedFallback = function (t) {
        ((this._syrupRequestedFallback = !0),
          (this._syrupRequestedFallbackType = t),
          setTimeout(() => {
            const t = new M.Event(this.Events.Changed);
            ((t.status = ht.ChangeStatus.Refreshed), this.dispatchEvent(t));
          }, 0));
      },
      ht.prototype.getMadabaDomainFromStringHash = function (t) {
        const e = (function (t) {
          let e = 0,
            i = t.length;
          for (; i--; ) e += t.charCodeAt(i);
          return e;
        })(t);
        return this.madabaDomains[e % this.madabaDomains.length];
      },
      ht.prototype._parseMapData = function () {
        const t = this._data;
        (this.customMadabaUrl ||
          (!t.madabaBaseUrl && !t.madabaDomains) ||
          ((this._madabaBaseUrl = t.madabaBaseUrl),
          (this._madabaDomains =
            t.madabaDomains &&
            t.madabaDomains.length &&
            t.madabaDomains.map((t) =>
              t.match(/^(https?:)?\/\//)
                ? t
                : -1 !== t.indexOf(":") && this.proxyPrefixes
                  ? "http://" + t
                  : ht.PROTOCOL + "//" + t
            ))),
          (this._disableCsr = !!t.disableCsr));
        const e = {};
        t.attributions &&
          t.attributions.forEach(function (t) {
            ((e[t.attributionId] = t), (this.tileGroup = t.attributionId));
          }, this);
        const i = {};
        (t.tileSources.forEach((t) => {
          const n = t.tileSource;
          ((i[n] = {
            name: n,
            path: t.path,
            domains: t.domains,
            proxyPrefixes: this.proxyPrefixes,
            withCredentials: this.withCredentials,
            crossOrigin: !0,
            protocol: t.protocol || (this.proxyPrefixes && -1 !== t.domains[0].indexOf(":") ? "http:" : "https:"),
            attribution: e[t.attributionId],
            minZoomLevel: t.minZoomLevel,
            maxZoomLevel: t.maxZoomLevel,
            supportedSizes: t.supportedSizes,
            supportedResolutions: t.supportedResolutions,
            showPrivacyLink: t.showPrivacyLink,
            showTermsOfUseLink: t.showTermsOfUseLink
          }),
            i[n].attribution &&
              i[n].attribution.global &&
              ((i[n].attribution.name = i[n].attribution.global[0].name),
              (i[n].attribution.url = i[n].attribution.global[0].url)));
        }),
          (this.types = {}),
          (this.rasterTilesForSyrup = {}));
        for (const e in t.modes) {
          const n = t.modes[e].layers;
          ((this.types[e] = {
            name: e,
            provider: this.tileProvider,
            countryCode: this.countryCode,
            lowResolutionTileSource: i[n[0].lowResTileSource],
            tileSources: n.map((t) => i[t.tileSource])
          }),
            (this.rasterTilesForSyrup[e] = {
              name: e,
              provider: this.tileProvider,
              countryCode: this.countryCode,
              tileSources: n.map((t) => i[t.tileSource])
            }));
        }
      },
      dt._data && dt._parseMapData(),
      ht.prototype._checkJwtToken = Gl;
    dt._jwtTokensToCheck.length;
  ) {
    const t = dt._jwtTokensToCheck.shift();
    dt._checkJwtToken(t);
  }
  const Bl = on,
    Zl = Ye.CoordinateRegion,
    Wl = Ye.Coordinate,
    Kl = Ye.MapPoint,
    Hl = Ye.MapSize,
    jl = Ye.MapRect,
    Vl = qn.supportsTouches,
    ql = new jl(0, 0, 1, 1),
    Yl = "mk-panning",
    Xl = "mk-dragging-cursor",
    $l = "mk-dragging-annotation",
    Jl = "InitializedWithoutConfiguration",
    Ql = "Initialized",
    th = "ReadyWithoutConfiguration",
    eh = "Ready",
    ih = "Rendered",
    nh = "Destroyed",
    oh = {
      padding: "rw",
      isScrollEnabled: "rw",
      isZoomEnabled: "rw",
      center: "rw",
      region: "rw",
      rotation: "rw",
      isRotationEnabled: "rw",
      showsCompass: "rw",
      visibleMapRect: "rw",
      tintColor: "rw",
      annotations: "rw",
      selectedAnnotation: "rw",
      overlays: "rw",
      selectedOverlay: "rw",
      showsUserLocation: "rw",
      tracksUserLocation: "rw",
      mapType: "rw",
      contextType: "rw",
      colorScheme: "rw",
      _allowWheelToZoom: "rw",
      _allowWheelToZoom2: "rw",
      _showsDefaultTiles: "rw",
      _internalAppDelegate: "rw",
      loadPriority: "rw",
      showsPointsOfInterest: "rw",
      showsMapTypeControl: "rw",
      showsZoomControl: "rw",
      showsScale: "rw",
      showsUserLocationControl: "rw",
      pointOfInterestFilter: "rw",
      annotationForCluster: "rw",
      cameraDistance: "rw",
      cameraZoomRange: "rw",
      cameraZoomLimit: "rw",
      cameraBoundary: "rw",
      distances: "rw",
      tileOverlays: "rw",
      selectableMapFeatures: "rw",
      selectableMapFeatureSelectionAccessory: "rw",
      annotationForMapFeature: "rw",
      _unifiedCanvas: "rw",
      _textZoom: "rw",
      element: "ro",
      userLocationAnnotation: "ro"
    };
  function sh(t, e) {
    return new Error(
      1 === e.length
        ? `[MapKit] mapkit.Map.${t} is available after loading the following library: ${e.join(", ")}.`
        : `[MapKit] mapkit.Map.${t} is available after loading one of the following libraries: ${e.join(", ")}.`
    );
  }
  const ah = dt.performanceMarkers.loading,
    rh = dt.performanceMarkers.rendering,
    lh = dt.performanceMarkers["frame-updates"];
  function hh(t, e, i) {
    (ah && performance.mark("mapkit-map-start"),
      dt.state !== dt.States.UNINITIALIZED && Xa(),
      dt.state === dt.States.READY ? (this.state = Ql) : (this.state = Jl));
    try {
      ((e = this._checkParent(e)) && (this._bootstrapSize = new ki(e.offsetWidth, e.offsetHeight)),
        (this.public = t),
        hh.maps.push(this.public),
        (i = p(i)),
        this._checkOptions(i),
        void 0 !== i._internalAppDelegate && (this.public._internalAppDelegate = i._internalAppDelegate),
        this._setDefaultState(i),
        this._setupScene(),
        this._setupRenderTree(),
        this._setupControllers(i));
      const n = void 0 !== i.isRotationEnabled;
      (this._setIsRotationEnabled(!n || i.isRotationEnabled, n),
        void 0 !== i.selectableMapFeatures && (this.selectableMapFeatures = i.selectableMapFeatures),
        void 0 !== i.selectableMapFeatureSelectionAccessory &&
          (this.selectableMapFeatureSelectionAccessory = i.selectableMapFeatureSelectionAccessory),
        this._flushToDOM(e),
        this._handleOptions(i, e),
        this._setupListeners(),
        Qt.scheduleOnNextFrame(this));
    } catch (t) {
      throw t;
    } finally {
      ah && performance.measure("mapkit-map-constructor", "mapkit-map-start");
    }
  }
  (lh && Rn.setPerformanceMeasureName("mapkit-dom-update-frame"), (hh.maps = []));
  const ch = "mk-dark-mode",
    dh = "select",
    uh = "deselect",
    ph = "single-tap",
    mh = "double-tap";
  function gh(t) {
    ((t.selected = !0), this._logWithMap(ke.Events.AnnotationClick));
  }
  function _h(t, e, i, n) {
    if (!l(t, e)) throw new Error("[MapKit] Unknown value for `" + i + "`. Choose from " + n + ".");
  }
  function fh(t, e) {
    const i = new pt.Event(t),
      n = e.locationInElement();
    return ((i.pointOnPage = new DOMPoint(n.x, n.y)), (i.domEvents = e.domEvents.slice()), i);
  }
  ((hh.MapTypes = Xi),
    (hh.Distances = {Adaptive: "adaptive", Metric: "metric", Imperial: "imperial"}),
    (hh.ColorSchemes = bt),
    (hh.LoadPriorities = tn),
    (hh.MapProperties = oh),
    (hh.prototype = {
      constructor: hh,
      _showsUserLocation: !1,
      _tracksUserLocation: !1,
      _tintColor: "",
      _annotationForCluster: null,
      _emphasis: nn,
      get padding() {
        return this._padding.copy();
      },
      set padding(t) {
        if (
          (d(t, ko, "[MapKit] The `padding` parameter passed to `Map.padding` is not a Padding."),
          this._padding.equals(t))
        )
          return;
        this._padding = t.copy();
        const e = this.ensureRenderingFrame();
        if (!e.equals(Si.Zero)) {
          this.rotation = 0;
          const t = this._mapRectAccountingForPadding(),
            i = t.midX(),
            n = t.midY();
          this._setRenderingFrameValue(e);
          const o = this._mapRectAccountingForPadding(),
            s = i - o.midX(),
            a = n - o.midY(),
            r = new jl(o.minX() + s, o.minY() + a, o.size.width, o.size.height);
          this.setVisibleMapRectAnimated(r, !1);
        }
        this.controlsLayer && this.controlsLayer.mapPaddingDidChange(this._adjustedPadding);
      },
      get isScrollEnabled() {
        return this._mapNode.pannable;
      },
      set isScrollEnabled(t) {
        ((this._mapNode.pannable = !!t), this._mapUserInteractionController.updateGestureEnableState());
      },
      get isZoomEnabled() {
        return this._mapNode.zoomable;
      },
      set isZoomEnabled(t) {
        ((this._mapNode.zoomable = !!t),
          this.controlsLayer && this.controlsLayer.updateZoomControl(),
          this._mapUserInteractionController.updateGestureEnableState());
      },
      get snapsToIntegralZoomLevels() {
        return this._mapNode.snapsToIntegralZoomLevels;
      },
      set snapsToIntegralZoomLevels(t) {
        this._mapNode.snapsToIntegralZoomLevels = !!t;
      },
      get showsZoomControl() {
        return this._showsZoomControl;
      },
      set showsZoomControl(t) {
        (t = !!t) !== this._showsZoomControl &&
          ((this._showsZoomControl = t),
          this.controlsLayer && (this.controlsLayer.updateZoomControl(), this.controlsLayer.updateScale()));
      },
      get showsScale() {
        return this._showsScale;
      },
      set showsScale(t) {
        l(t, Bl)
          ? t !== this._showsScale && ((this._showsScale = t), this.controlsLayer && this.controlsLayer.updateScale())
          : console.warn(
              "[MapKit] value passed to `Map.showsScale` setter must be part of the mapkit.FeatureVisibility enum."
            );
      },
      get mapType() {
        return this._mapType;
      },
      set mapType(t) {
        t !== this._mapType &&
          (_h(t, hh.MapTypes, "mapType", "Map.MapTypes"), this._setMapTypeAndEmphasis(t, this._emphasis));
      },
      getMapTypeWithEmphasis: function () {
        return this._mapType === hh.MapTypes.Standard && this._emphasis === en
          ? hh.MapTypes.MutedStandard
          : this._mapType;
      },
      setMapTypeWithEmphasis: function (t) {
        let e = nn;
        (t === hh.MapTypes.MutedStandard
          ? ((t = hh.MapTypes.Standard), (e = en))
          : _h(t, hh.MapTypes, "mapType", "Map.MapTypes"),
          (e === this._emphasis && t === this._mapType) || this._setMapTypeAndEmphasis(t, e));
      },
      _setMapTypeAndEmphasis: function (t, e) {
        ((this._mapType = t),
          (this._emphasis = e),
          this._annotationsController && this._annotationsController.mapTypeDidChange(),
          this._updateMapNodeTintAndEmphasis(this._mapNode),
          this._mapNodeController.handleMapConfigurationChange(),
          this.controlsLayer && this.controlsLayer.update(),
          this.public.dispatchEvent(new pt.Event("map-type-change")),
          this._logWithMap(ke.Events.MapTypeChange));
      },
      get distances() {
        return this._distances;
      },
      set distances(t) {
        t !== this._distances &&
          (_h(t, hh.Distances, "distances", "Map.Distances"),
          (this._distances = t),
          this.controlsLayer && this.controlsLayer.updateScale());
      },
      get colorScheme() {
        return this._colorScheme;
      },
      set colorScheme(t) {
        t !== this._colorScheme &&
          (_h(t, hh.ColorSchemes, "colorScheme", "Map.ColorSchemes"),
          this._colorScheme === bt.Adaptive &&
            (this._colorSchemeHandle.removeEventListener("change", this._boundDarkModeDidChange),
            kt.removeHandle(this._colorSchemeHandle),
            (this._colorSchemeHandle = null)),
          (this._colorScheme = t),
          t === bt.Adaptive &&
            ((this._colorSchemeHandle = kt.addHandle()),
            (this._boundDarkModeDidChange = () => this._updateMapNodeTintAndEmphasis(this._mapNode)),
            this._colorSchemeHandle.addEventListener("change", this._boundDarkModeDidChange)),
          this._updateMapNodeTintAndEmphasis(this._mapNode));
      },
      currentColorScheme: null,
      tint: null,
      get tileTint() {
        return this._mapNode.tileTint;
      },
      get _allowWheelToZoom() {
        return this._mapNode.allowWheelToZoom;
      },
      set _allowWheelToZoom(t) {
        this._mapNode.allowWheelToZoom = t;
      },
      get _allowWheelToZoom2() {
        return this._mapNode.allowWheelToZoom2;
      },
      set _allowWheelToZoom2(t) {
        this._mapNode.allowWheelToZoom2 = t;
      },
      get loadPriority() {
        return this._mapNodeController.loadPriority;
      },
      set loadPriority(t) {
        l(t, hh.LoadPriorities)
          ? (this._mapNodeController.loadPriority = t)
          : console.warn("[MapKit] Unknown value for `loadPriority`. Choose from mapkit.Map.LoadPriorities.");
      },
      get _showsTileInfo() {
        return this._mapNode._impl.debug;
      },
      set _showsTileInfo(t) {
        this._mapNode._impl.debug = t;
      },
      get _showsDefaultTiles() {
        return this._mapNode.showsDefaultTiles;
      },
      set _showsDefaultTiles(t) {
        this._mapNode.showsDefaultTiles = t;
      },
      get tileOverlays() {
        return this._mapNode.tileOverlays;
      },
      set tileOverlays(t) {
        ((this._mapNode.tileOverlays = t), this.controlsLayer && this.controlsLayer.updateZoomControl());
      },
      addTileOverlay: function (t) {
        if (!this._overlaysController) throw sh("addTileOverlay", ["overlays"]);
        const e = this._mapNode.addTileOverlay(t);
        return (this.controlsLayer && this.controlsLayer.updateZoomControl(), e);
      },
      addTileOverlays: function (t) {
        if (!this._overlaysController) throw sh("addTileOverlays", ["overlays"]);
        const e = this._mapNode.addTileOverlays(t);
        return (this.controlsLayer && this.controlsLayer.updateZoomControl(), e);
      },
      removeTileOverlay: function (t) {
        if (!this._overlaysController) throw sh("removeTileOverlay", ["overlays"]);
        const e = this._mapNode.removeTileOverlay(t);
        return (this.controlsLayer && this.controlsLayer.updateZoomControl(), e);
      },
      removeTileOverlays: function (t) {
        if (!this._overlaysController) throw sh("removeTileOverlays", ["overlays"]);
        const e = this._mapNode.removeTileOverlays(t);
        return (this.controlsLayer && this.controlsLayer.updateZoomControl(), e);
      },
      get showsMapTypeControl() {
        return this._showsMapTypeControl;
      },
      set showsMapTypeControl(t) {
        (t = !!t) !== this._showsMapTypeControl &&
          ((this._showsMapTypeControl = t), this.controlsLayer && this.controlsLayer.updateMapTypeControl());
      },
      get showsUserLocationControl() {
        return !!this._userLocationController && this._showsUserLocationControl;
      },
      set showsUserLocationControl(t) {
        if ((t = !!t) !== this._showsUserLocationControl) {
          if (!this._userLocationController) throw sh("showsUserLocationControl", ["user-location"]);
          ((this._showsUserLocationControl = t),
            this.controlsLayer && (this.controlsLayer.updateUserLocationControl(), this.controlsLayer.updateScale()));
        }
      },
      get showsPointsOfInterest() {
        return (
          null === this.pointOfInterestFilter ||
          (null === this.pointOfInterestFilter._includes && 0 === this.pointOfInterestFilter._excludes.length)
        );
      },
      set showsPointsOfInterest(t) {
        if (t) {
          if (null === this.pointOfInterestFilter) return;
          this.pointOfInterestFilter = null;
        } else {
          if (this.pointOfInterestFilter === yt.filterExcludingAllCategories) return;
          this.pointOfInterestFilter = yt.filterExcludingAllCategories;
        }
      },
      get pointOfInterestFilter() {
        return this._mapNode.pointOfInterestFilter;
      },
      set pointOfInterestFilter(t) {
        (null !== t &&
          d(
            t,
            yt,
            "[MapKit] Value passed to `Map.pointOfInterestFilter` setter must be an instance of mapkit.PointOfInterestFilter."
          ),
          (this._mapNode.pointOfInterestFilter = t),
          this._mapNodeController.setPointOfInterestFilter(t));
      },
      setPoiFiltered: function (t, e) {
        this._mapNode.setPoiFiltered(t, e);
      },
      get element() {
        return this.rootNode && this.rootNode.element;
      },
      set element(t) {
        console.warn("[MapKit] The `element` property is read-only.");
      },
      get renderingMapRect() {
        return this._mapNode.visibleMapRect;
      },
      get visibleMapRect() {
        return (
          this._visibleMapRect || (this._visibleMapRect = this._mapRectAccountingForPadding()),
          this._visibleMapRect
        );
      },
      set visibleMapRect(t) {
        this.setVisibleMapRectAnimated(t, !1);
      },
      setVisibleMapRectAnimated: function (t, e, i) {
        (h(t, "[MapKit] Missing `visibleMapRect` parameter in call to `Map.setVisibleMapRectAnimated()`."),
          d(
            t,
            jl,
            "[MapKit] The `visibleMapRect` parameter passed to `Map.setVisibleMapRectAnimated()` is not a MapRect."
          ));
        const n = this.ensureRenderingFrame();
        if (0 === n.size.width || 0 === n.size.height) this._visibleMapRect = t;
        else {
          delete this._visibleMapRect;
          const e = this._visibleFrame;
          let i = t;
          const o = this._adjustedPadding;
          if (!o.equals(ko.Zero)) {
            const s = n.size.width / e.size.width,
              a = n.size.height / e.size.height;
            i = new jl(
              t.minX() - o.left * s * t.size.width,
              t.minY() - o.top * a * t.size.height,
              t.size.width * s,
              t.size.height * a
            );
          }
          const s = new Kl(t.midX(), t.midY());
          let r = Ye.zoomLevelForMapRectInViewport(i, n.size, Ye.tileSize);
          r = a(
            this._mapNode.snapsToIntegralZoomLevels ? qn.getIntegralZoom(r) : r,
            this.minZoomLevel,
            this.maxZoomLevel
          );
          const l = Math.pow(2, Math.ceil(r)) * (Ye.tileSize * Math.pow(2, r - Math.ceil(r))),
            h = new Hl(e.size.width / l, e.size.height / l);
          t = new jl(s.x - h.width / 2, s.y - h.height / 2, h.width, h.height);
        }
        return ((e = null == e || !!e), this._setVisibleMapRect(t, e, i), delete this._delayedShowItems, this.public);
      },
      get region() {
        return this.visibleMapRect.toCoordinateRegion();
      },
      set region(t) {
        this.setRegionAnimated(t, !1);
      },
      setRegionAnimated: function (t, e, i) {
        return (
          h(t, "[MapKit] Tried to set `Map.region` property to a non-existent value."),
          d(t, Zl, "[MapKit] Region passed to `Map.region` setter is not a CoordinateRegion."),
          this.region.equals(t) || this.setVisibleMapRectAnimated(t.toMapRect(), e, i),
          this.public
        );
      },
      get isRotationAvailable() {
        return "HYBRID" === dt.forcedRenderingMode || "CLIENT" === dt.forcedRenderingMode
          ? !dt.didFallback && this.csrCapable
          : dt.ready || dt.didFallback
            ? dt.canRunCSR && this.csrCapable
            : this.csrCapable;
      },
      set isRotationAvailable(t) {
        console.warn("[MapKit] Map.isRotationAvailable is a read-only property");
      },
      get isRotationEnabled() {
        return this._mapNode.isRotationEnabled;
      },
      set isRotationEnabled(t) {
        this._setIsRotationEnabled(t, !0);
      },
      get isRotationLocked() {
        return this._mapNode.isRotationLocked;
      },
      get rotation() {
        return this._mapNode.rotation;
      },
      set rotation(t) {
        (this.setRotationAnimated(t, !1), this.controlsLayer && this.controlsLayer.updateRotationControl());
      },
      get heading() {
        const t = this._mapNode.rotation;
        return 0 === t ? 0 : 360 - t;
      },
      get showsCompass() {
        return this.usingCSR ? this._showsCompass : Bl.Hidden;
      },
      set showsCompass(t) {
        l(t, Bl)
          ? (this.isRotationEnabled ||
              (t !== Bl.Visible && t !== Bl.Adaptive) ||
              console.warn("[MapKit] The compass cannot be shown when `Map.isRotationEnabled` is false."),
            (this._usingDefaultShowsCompassValue = !1),
            t !== this._showsCompass &&
              ((this._showsCompass = t), this.controlsLayer && this.controlsLayer.updateRotationControl()))
          : console.warn(
              "[MapKit] value passed to `Map.showsCompass` setter must be part of the MapKit.FeatureVisibility enum."
            );
      },
      get usingCSR() {
        return !this._mapNodeController.usingSSR;
      },
      compassRotate(t, e) {
        if (e) {
          if (this.isRotationLocked) {
            const e = o(t, 360),
              i = qn.restrictRotation(e);
            t = e < 180 ? i + 0.025 * (e - i) : i - 0.025 * (i - e);
          }
          Math.abs(t) < 5 && (t = 0);
        } else this.isRotationLocked && (t = qn.restrictRotation(o(t, 360)));
        return (this.setRotationAnimated(t, !1, !0), t);
      },
      setRotationAnimated: function (t, e, i) {
        if (!this.isRotationAvailable) return void console.warn("[MapKit] Rotation is not available.");
        if (
          (h(t, "[MapKit] Tried to set `Map.rotation` property to a non-existent value."),
          "number" != typeof t || !isFinite(t))
        )
          return void console.warn("[MapKit] Argument for `Map.rotation` is not a finite number.");
        const n = this.forcedInteractionCenter ? this.forcedInteractionCenter : this._centerMapPoint(),
          s = o(t, 360) - this._mapNode.getRotation();
        if (!s) return;
        const a = (e || null == e || !i) && this.mapCanStartRotating();
        if ((e || null == e) && a) {
          const t = this.camera.copy();
          (t.rotateAroundCenter(n, s), this._mapNode.setCameraAnimated(t, !0, n));
        } else ((a || i) && this._mapNode.rotateCameraAroundMapPoint(n, s), i || this.mapDidStopRotating());
        return this.public;
      },
      get center() {
        return this._centerMapPoint().toCoordinate();
      },
      set center(t) {
        this.setCenterAnimated(t, !1);
      },
      setCenterAnimated: function (t, e, i) {
        (h(t, "[MapKit] Tried to set `Map.center` property to a non-existent value."),
          d(t, Wl, "[MapKit] Value passed to `Map.center` setter is not a Coordinate object."));
        const n = this.ensureRenderingFrame();
        if (0 !== n.size.width && 0 !== n.size.height) {
          const e = this._offsetCenterWithPaddingAndRotation(t.toMapPoint(), -1);
          e && (t = e.toCoordinate());
        }
        return (
          this._mapNode.setCenterAnimated(t, null == e || !!e),
          delete this._visibleMapRect,
          i || (this.tracksUserLocation = !1),
          this.public
        );
      },
      get cameraZoomLevelLimit() {
        return this._mapNode.cameraZoomLimit;
      },
      set cameraZoomLevelLimit(t) {
        this.setCameraZoomLevelLimitAnimated(t, !1);
      },
      setCameraZoomLevelLimitAnimated: function (t, e) {
        return (this._mapNode.setCameraZoomLevelLimitAnimated(t, null == e || !!e), this.public);
      },
      get cameraZoomRange() {
        return this._mapNode.cameraZoomRange;
      },
      set cameraZoomRange(t) {
        this.setCameraZoomRangeAnimated(t, !1);
      },
      setCameraZoomRangeAnimated: function (t, e) {
        return (
          null != t &&
            d(
              t,
              Ye.CameraZoomRange,
              "[MapKit] Expected a `mapkit.CameraZoomRange` object for `Map.cameraZoomRange`, but got `" +
                t +
                "` instead."
            ),
          this._mapNode.setCameraZoomRangeAnimated(t, null == e || !!e),
          this.public
        );
      },
      get cameraDistance() {
        return this._mapNode.getCurrentCameraDistance();
      },
      set cameraDistance(t) {
        this.setCameraDistanceAnimated(t, !1);
      },
      setCameraDistanceAnimated: function (t, e) {
        if (!(t >= 0))
          throw new Error("[MapKit] Expected a number for Map.cameraDistance, but got `" + t + "` instead");
        return (this._mapNode.setCameraDistanceAnimated(t, null == e || !!e), this.public);
      },
      get cameraBoundary() {
        const t = this._cameraBoundary;
        return t
          ? {
              region: t.toCoordinateRegion ? t.toCoordinateRegion() : t.copy(),
              mapRect: t.toMapRect ? t.toMapRect() : t.copy()
            }
          : null;
      },
      set cameraBoundary(t) {
        this.setCameraBoundaryAnimated(t, !1);
      },
      setCameraBoundaryAnimated: function (t, e) {
        let i = null;
        if (null == t) delete this._cameraBoundary;
        else if (t instanceof Zl) ((i = t.toMapRect()), (this._cameraBoundary = t.copy()));
        else {
          if (!(t instanceof jl))
            throw new Error(
              "[MapKit] `Map.cameraBoundaryRect` expected a CoordinateRegion or a MapRect, but got `" + t + "` instead."
            );
          ((i = t), (this._cameraBoundary = i.copy()));
        }
        const n = this._centerMapPoint();
        return (
          this._mapNode.setCameraBoundaryAnimated(i, null == e || !!e),
          this.tracksUserLocation && !this._mapNode.isMapPointWithinBounds(n) && (this.tracksUserLocation = !1),
          this.public
        );
      },
      get overlays() {
        return this._overlaysController ? this._overlaysController.items : [];
      },
      set overlays(t) {
        if (!this._overlaysController) throw sh("overlays", ["overlays"]);
        this._overlaysController.items = t;
      },
      get selectedOverlay() {
        return this._overlaysController ? this._overlaysController.selectedItem : null;
      },
      set selectedOverlay(t) {
        if (!this._overlaysController) throw sh("selectedOverlay", ["overlays"]);
        this._overlaysController.selectedItem = t;
      },
      addOverlay: function (t) {
        if (this._overlaysController) return this._overlaysController.addItem(t);
        throw sh("addOverlay", ["overlays"]);
      },
      addOverlays: function (t) {
        if (this._overlaysController) return (this._overlaysController.addItems(t), t);
        throw sh("addOverlays", ["overlays"]);
      },
      removeOverlay: function (t) {
        if (this._overlaysController) return this._overlaysController.removeItem(t);
        throw sh("removeOverlay", ["overlays"]);
      },
      removeOverlays: function (t) {
        if (this._overlaysController) return this._overlaysController.removeItems(t);
        throw sh("removeOverlays", ["overlays"]);
      },
      topOverlayAtPoint: function (t) {
        if (!this._overlaysController) throw sh("topOverlayAtPoint", ["overlays"]);
        d(t, window.DOMPoint, "[MapKit] Map.topOverlayAtPoint expected a DOMPoint, but got `" + t + "` instead.");
        const e = this.rootNode.convertPointFromPage(t),
          i = this._overlaysController.pickableItemsCloseToPoint(this.overlays, e, 0),
          n = this.selectedOverlay;
        return n && i.indexOf(n) > 0 ? n : i[0];
      },
      overlaysAtPoint: function (t) {
        if (!this._overlaysController) throw sh("overlaysAtPoint", ["overlays"]);
        d(t, window.DOMPoint, "[MapKit] Map.overlaysAtPoint expected a DOMPoint, but got `" + t + "` instead.");
        const e = this.rootNode.convertPointFromPage(t);
        return this._overlaysController.pickableItemsCloseToPoint(this.overlays, e, 0).reverse();
      },
      get annotations() {
        if (this._annotationsController) return this._annotationsController.items;
        throw sh("annotations", ["annotations"]);
      },
      set annotations(t) {
        if (!this._annotationsController) throw sh("annotations", ["annotations"]);
        this._annotationsController.items = t;
      },
      get selectedAnnotation() {
        if (this._annotationsController) return this._annotationsController.selectedItem;
        throw sh("selectedAnnotation", ["annotations"]);
      },
      set selectedAnnotation(t) {
        if (!this._annotationsController) throw sh("selectedAnnotation", ["annotations"]);
        this._annotationsController.selectedItem = t;
      },
      addAnnotation: function (t) {
        if (this._annotationsController) return this._annotationsController.addItem(t);
        throw sh("addAnnotation", ["annotations"]);
      },
      addAnnotations: function (t) {
        if (this._annotationsController) return this._annotationsController.addItems(t);
        throw sh("addAnnotations", ["annotations"]);
      },
      removeAnnotation: function (t) {
        if (this._annotationsController) return this._annotationsController.removeItem(t);
        throw sh("removeAnnotation", ["annotations"]);
      },
      removeAnnotations: function (t) {
        if (this._annotationsController) return this._annotationsController.removeItems(t);
        throw sh("removeAnnotations", ["annotations"]);
      },
      showItems: function (t, e) {
        if (!hh.LayerItemsController || !hh.ItemCollection)
          throw sh("showItems", ["annotations", "overlays", "user-location"]);
        const i = new hh.ItemCollection(t).getFlattenedItemList();
        e = hh.LayerItemsController.checkShowItemsParameters(i, e);
        const n = [],
          o = [];
        return (
          i.forEach(function (t) {
            (hh.OverlaysController &&
              t instanceof hh.OverlaysController.Overlay &&
              !t.map &&
              ((t._impl._map = this.public), n.push(t)),
              hh.AnnotationsController &&
                t instanceof hh.AnnotationsController.Annotation &&
                this._annotationsController &&
                this._annotationsController.preAddedAnnotation(t) &&
                o.push(t));
          }, this),
          (this.isRooted() && hh.LayerItemsController.setRegionForItems(this, i, e)) ||
            (this._delayedShowItems = [i, e]),
          n.forEach((t) => {
            delete t._impl._map;
          }),
          o.forEach((t) => this._annotationsController.resetAnnotation(t)),
          this._addItems(i),
          t
        );
      },
      addItems: function (t) {
        if (!hh.ItemCollection) throw sh("addItems", ["annotations", "overlays", "user-location"]);
        const e = new hh.ItemCollection(t).getFlattenedItemList();
        return (this._addItems(e), t);
      },
      removeItems: function (t) {
        if (!hh.ItemCollection) throw sh("removeItems", ["annotations", "overlays", "user-location"]);
        const e = new hh.ItemCollection(t).getFlattenedItemList(),
          i = [],
          n = [];
        return (
          e.forEach(function (t, e) {
            const o = hh.OverlaysController && t instanceof hh.OverlaysController.Overlay,
              s = hh.AnnotationsController && t instanceof hh.AnnotationsController.Annotation;
            if (!o && !s)
              throw new Error(
                "[MapKit] Map.removeItems expected an Annotation, Overlay, ItemCollection, or Array of valid items at index " +
                  e +
                  ", but got `" +
                  t +
                  "` instead."
              );
            o ? i.push(t) : n.push(t);
          }, this),
          this.removeOverlays(i),
          this.removeAnnotations(n),
          t
        );
      },
      addLayerAbove: function (t, e) {
        return this._mapNodeController.addLayerAbove(t, e);
      },
      addLayerBelow: function (t, e) {
        return this._mapNodeController.addLayerBelow(t, e);
      },
      removeLayer: function (t) {
        return this._mapNodeController.removeLayer(t);
      },
      requireRender: function () {
        return this._mapNodeController.requireRender();
      },
      annotationsInMapRect: function (t) {
        if (this._annotationsController) return this._annotationsController.annotationsInMapRect(t);
        throw sh("annotationsInMapRect", ["annotations"]);
      },
      updateSize: function (t) {
        return (
          console.warn(
            "[MapKit] Map resizing is now automatic, the Map.updateSize() method has been deprecated and will be removed in a future version."
          ),
          this.public
        );
      },
      convertCoordinateToPointOnPage: function (t) {
        d(t, Wl, "[MapKit] Map.convertCoordinateToPointOnPage expected a Coordinate, but got `" + t + "` instead.");
        const e = t.toMapPoint();
        e.x < this.camera.minX() && (e.x += 1);
        const i = this.camera.transformMapPoint(e),
          n = this.rootNode.convertPointToPage(i);
        return new window.DOMPoint(n.x, n.y);
      },
      convertPointOnPageToCoordinate: function (t) {
        d(
          t,
          window.DOMPoint,
          "[MapKit] Map.convertPointOnPageToCoordinate expected a DOMPoint, but got `" + t + "` instead."
        );
        const e = this.camera.transformGestureCenter(this.rootNode.convertPointFromPage(new Mi(t.x, t.y))),
          i = this.renderingMapRect.origin;
        return new Wl(
          Ye.convertYToLatitude(i.y + e.y / this.worldSize),
          Ye.convertXToLongitude(i.x + e.x / this.worldSize)
        );
      },
      get showsUserLocation() {
        return !!this._userLocationController && this._userLocationController.showsUserLocation;
      },
      set showsUserLocation(t) {
        if ((t = !!t) !== this.showsUserLocation) {
          if (!this._userLocationController) throw sh("showsUserLocation", ["user-location"]);
          ((this._userLocationController.showsUserLocation = t),
            t || (this._removeUserLocationDisplay(), (this.tracksUserLocation = !1)),
            this.showsUserLocationControl &&
              this.controlsLayer &&
              (this.controlsLayer.updateUserLocationControl(), this.controlsLayer.updateScale()));
        }
      },
      get userLocationAnnotation() {
        return this._userLocationController ? this._annotationsController.userLocationAnnotation : null;
      },
      get tracksUserLocation() {
        return !!this._userLocationController && this._userLocationController.tracksUserLocation;
      },
      set tracksUserLocation(t) {
        if ((t = !!t) !== this.tracksUserLocation) {
          if (!this._userLocationController) throw sh("tracksUserLocation", ["user-location"]);
          ((this._userLocationController.tracksUserLocation = t),
            (this._mapNode.usesInteractionCenter = !(!t && !this.forcedInteractionCenter)),
            t ? (this.showsUserLocation = !0) : this.userLocationAnnotation || (this.showsUserLocation = !1),
            (this._firstCameraUpdateToTrackUserLocationPending = t),
            this._updateCameraToTrackUserLocation(this._userLocationController.userLocation),
            this._userLocationController.tracksUserLocation === t &&
              (this.controlsLayer && this.controlsLayer.updateUserLocationControl(),
              this._userLocationTrackingDelegate &&
                "function" == typeof this._userLocationTrackingDelegate.mapUserLocationTrackingDidChange &&
                this._userLocationTrackingDelegate.mapUserLocationTrackingDidChange(this.public)));
        }
      },
      _forcedInteractionCenter: null,
      get forcedInteractionCenter() {
        return this._forcedInteractionCenter;
      },
      set forcedInteractionCenter(t) {
        ((this._forcedInteractionCenter = t),
          (this._mapNode.usesInteractionCenter = !(!this.tracksUserLocation && !t)));
      },
      get tintColor() {
        return this._tintColor;
      },
      set tintColor(t) {
        if (t !== this._tintColor) {
          if (null != t) {
            if (
              (c(t, "string", "[MapKit] Expected a string value for Map.tintColor, but got `" + t + "` instead"),
              "" !== t && !qn.isValidCSSColor(t))
            )
              return void console.warn(
                "[MapKit] value passed to `Map.tintColor` is not a valid color value. Ignoring: " + t
              );
            this._tintColor = t;
          } else delete this._tintColor;
          this.controlsLayer && this.controlsLayer.update();
        }
      },
      get tintColorForControls() {
        return qn.darkColorScheme(this.mapNodeTint) ? "" : this._tintColor;
      },
      get minZoomLevel() {
        return this._mapNode.minZoomLevel;
      },
      get maxZoomLevel() {
        return this._mapNode.maxZoomLevel;
      },
      get zoomLevel() {
        return this._mapNode.zoomLevel;
      },
      get canZoomIn() {
        const t = this.snapsToIntegralZoomLevels ? Math.floor(this.maxZoomLevel) : this.maxZoomLevel - 0.01;
        return this.zoomLevel < t;
      },
      get canZoomOut() {
        const t = this.snapsToIntegralZoomLevels ? Math.ceil(this.minZoomLevel) : this.minZoomLevel + 0.01;
        return this.zoomLevel > t;
      },
      shouldDispatchRotationChangeEvent: !1,
      set zoomLevel(t) {
        this._mapNode.zoomLevel = t;
      },
      get worldSize() {
        return Ye.pointsPerAxis(this._mapNode.zoomLevel);
      },
      get camera() {
        return this._mapNodeController.node.camera;
      },
      get cameraIsPanning() {
        return this._mapNode.cameraIsPanning;
      },
      get cameraIsZooming() {
        return this._mapNode.cameraIsZooming;
      },
      get cameraIsRotating() {
        return this._mapNode.cameraIsRotating;
      },
      get cameraIsAnimating() {
        return this._mapNode.cameraIsAnimating;
      },
      get cameraIsMoving() {
        return this.cameraIsPanning || this.cameraIsZooming || this.cameraIsRotating || this.cameraIsAnimating;
      },
      get _mapNode() {
        return this._mapNodeController.node;
      },
      get csrCapable() {
        return this._mapNodeController.csrCapable;
      },
      destroy: function () {
        if (this.state === nh) return void console.warn("[MapKit] Map was already destroyed.");
        ((this.state = nh),
          this._annotationsController && this.removeAnnotations(this.annotations),
          this._overlaysController && this.removeOverlays(this.overlays),
          this._stopStabilizationTimeout(),
          this._linearZoomController.stop(),
          this.showsUserLocation && this._removeUserLocationDisplay(),
          this.controlsLayer && (this.controlsLayer.mapWasDestroyed(), (this.controlsLayer = null)),
          this._mapUserInteractionController.mapWasDestroyed(),
          this._overlaysController && this._overlaysController.mapWasDestroyed(),
          this._annotationsController && this._annotationsController.mapWasDestroyed(),
          this._userLocationController && this._userLocationController.mapWasDestroyed(),
          (this._linearZoomController._delegate = null),
          this._colorSchemeHandle && (kt.removeHandle(this._colorSchemeHandle), (this._colorSchemeHandle = null)),
          dt.removeEventListener(dt.Events.Changed, this),
          fi.removeEventListener(fi.Events.LocaleChanged, this),
          this._boundDevicePixelRatioDidChange &&
            (this._dppxMediaQueryList.removeListener(this._boundDevicePixelRatioDidChange),
            (this._dppxMediaQueryList = null),
            (this._boundDevicePixelRatioDidChange = null)),
          this._iframe &&
            (this._iframe.removeEventListener("load", this),
            this._iframe.contentWindow && this._iframe.contentWindow.removeEventListener("resize", this),
            this.element.removeChild(this._iframe),
            (this._iframe = null)),
          this._resizeObserver && (this._resizeObserver.disconnect(), (this._resizeObserver = null)),
          this._mapNodeController.destroy(),
          this._mapRoot.remove(),
          (this._mapRoot = null),
          this._scene.destroy(),
          (this._scene = null),
          this._removePrintListener(),
          this.textZoom && (this.textZoom = !1),
          this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element),
          this.rootNode.remove(),
          (this.rootNode = null));
        const t = hh.maps.indexOf(this.public);
        t >= 0 && hh.maps.splice(t, 1);
      },
      adjustMapItemPoint: function (t) {
        return this._mapNode.adjustMapItemPoint(t);
      },
      get annotationForCluster() {
        return this._annotationForCluster;
      },
      set annotationForCluster(t) {
        if (null == t) delete this._annotationForCluster;
        else {
          if ("function" != typeof t) throw new Error("[MapKit] annotationForCluster must be a function or null");
          this._annotationForCluster = t;
        }
      },
      selectionMayChange: !0,
      get selectableMapFeatures() {
        return this._selectableMapFeatures
          ? (dt.ready && (dt.didFallback || !dt.canRunCSR)) || !this.csrCapable || "SERVER" === dt.forcedRenderingMode
            ? []
            : this._selectableMapFeatures.slice()
          : [];
      },
      set selectableMapFeatures(t) {
        if (null == t) return (delete this._selectableMapFeatures, void this._mapFeaturesLayerController.node.remove());
        if (!hh.MapFeatureType) throw sh("selectableMapFeatures", ["annotations"]);
        (u(t, "[MapKit] Map.selectableMapFeatures expected an array of values, but got `" + t + "` instead."),
          t.forEach(function (t) {
            _h(t, hh.MapFeatureType, "MapFeatureType", "mapkit.MapFeatureType");
          }));
        const e = [];
        if (
          (Object.values(hh.MapFeatureType).forEach(function (i) {
            -1 !== t.indexOf(i) && e.push(i);
          }),
          0 === e.length)
        )
          return (delete this._selectableMapFeatures, void this._mapFeaturesLayerController.node.remove());
        (((!dt.ready || (!dt.didFallback && dt.canRunCSR)) && this.csrCapable && "SERVER" !== dt.forcedRenderingMode) ||
          console.warn("[MapKit] Selectable map features is not available."),
          (this._selectableMapFeatures = e),
          this._updateMapFeatureRegionLayer());
      },
      get selectableMapFeatureSelectionAccessory() {
        return this._selectableMapFeatureSelectionAccessory ? this._selectableMapFeatureSelectionAccessory : null;
      },
      set selectableMapFeatureSelectionAccessory(t) {
        if (!hh.PlaceSelectionAccessory) throw sh("selectableMapFeatureSelectionAccessory", ["annotations"]);
        (null !== t &&
          d(
            t,
            hh.PlaceSelectionAccessory,
            "[MapKit] The `selectableMapFeatureSelectionAccessory` parameter passed to `Map.selectableMapFeatureSelectionAccessory` is not a PlaceSelectionAccessory."
          ),
          (this._selectableMapFeatureSelectionAccessory = t));
      },
      get annotationForMapFeature() {
        return this._annotationForMapFeature;
      },
      set annotationForMapFeature(t) {
        if (null == t) delete this._annotationForMapFeature;
        else {
          if ("function" != typeof t) throw new Error("[MapKit] annotationForMapFeature must be a function or null");
          this._annotationForMapFeature = t;
        }
      },
      handleEvent: function (t) {
        const e = hh.ControlsLayer ? hh.ControlsLayer.ZoomControl.EVENTS.ZOOM_START : void 0,
          i = hh.ControlsLayer ? hh.ControlsLayer.ZoomControl.EVENTS.ZOOM_END : void 0;
        switch (t.type) {
          case dt.Events.Initialized:
            Xa();
            break;
          case dt.Events.Changed:
            this._configurationDidBecomeAvailable();
            break;
          case e:
            this.zoomControlStart(t.zoomIn);
            break;
          case i:
            this.zoomControlEnd();
            break;
          case fi.Events.LocaleChanged:
            this._handleLocaleChange(t);
            break;
          case "load":
            this._iframeDidLoad();
            break;
          case "resize":
            this._sizeDidChange();
        }
      },
      elementShouldPreventDragstart: function (t) {
        return !!this._annotationsController && !this._annotationsController.isElementInCustomCallout(t);
      },
      elementWantsDefaultBrowserBehavior: function (t, e, i) {
        if (e && i && ("touchstart" === e.type || ("pointerdown" === e.type && "touch" === e.pointerType))) {
          if (1 === i && !this.isScrollEnabled) return !0;
          if (2 === i && !this.isZoomEnabled && !this.isRotationEnabled) return !0;
        }
        return !!this._annotationsController && this._annotationsController.isElementInAccessory(t);
      },
      getEventTargetFromSubShadowDOM: function (t) {
        const e = t.touches ? t.touches[0].target : t.target;
        return (
          (qn.supportsShadowDOM &&
            this._annotationsController &&
            e === this._annotationsController.node.element &&
            this._annotationsController.getShadowDOMTargetFromEvent(t)) ||
          e
        );
      },
      tileAccessForbidden: function () {
        dt.accessKeyHasExpired();
      },
      previousMapDidFinishRendering: function (t) {
        (ah && performance.measure("mapkit-map-start-up-rendered", "mapkit-map-start"),
          this.state !== nh && this.public.dispatchEvent(new pt.Event("start-up-complete")));
      },
      mapDidFinishRendering: function (t) {
        this.state !== nh &&
          ((this.state = ih),
          this._controlsLayer || setTimeout(() => this._loadControlsLayer(!1)),
          this._mapNodeController.handleMapRendered(),
          this.addWaitingAnnotations(),
          this._startStabilizationTimeoutIfNeeded());
      },
      mapCanStartPanning: function (t) {
        return this._panningWasPrevented
          ? (delete this._panningWasPrevented, !1)
          : !(
              (this.tracksUserLocation && this.cameraIsZooming) ||
              (this._annotationsController && this._annotationsController.dragging) ||
              this._isInitialInteractionTargetInUIElement() ||
              !this.public.dispatchEvent(new pt.Event("scroll-start"))
            );
      },
      mapWillStartPanning: function (t) {
        (this._stopStabilizationTimeout(),
          (this.tracksUserLocation = !1),
          this.rootNode.classList.add(Yl),
          this.rootNode.classList.add(Xl),
          this._annotationsController && this._annotationsController.node.classList.add(Yl),
          ke._trackPanEvent && this._logWithMap(ke.Events.Pan));
      },
      mapWillStopPanning: function (t) {
        this.rootNode.classList.remove(Xl);
      },
      mapDidStopPanning: function (t) {
        (this._startStabilizationTimeoutIfNeeded(),
          this.rootNode.classList.remove(Yl),
          this._annotationsController && this._annotationsController.node.classList.remove(Yl),
          this.public.dispatchEvent(new pt.Event("scroll-end")));
      },
      mapCanStartZooming: function (t) {
        return !(
          this._isInitialInteractionTargetInUIElement() || !this.public.dispatchEvent(new pt.Event("zoom-start"))
        );
      },
      mapWillStartZooming: function (t, e, i, n) {
        (this._stopStabilizationTimeout(),
          n && (this.tracksUserLocation = !1),
          this._logWithMap(ke.Events.Zoom, {eventValue: e}));
      },
      mapDidStopZooming: function (t) {
        (this._startStabilizationTimeoutIfNeeded(),
          this.public.dispatchEvent(new pt.Event("zoom-end")),
          this.controlsLayer && this.controlsLayer.scaleDidChange());
      },
      mapCameraWillChange: function (t, e) {
        this.mapNodeCameraBeforeChange = t.camera;
      },
      mapCameraDidChange: function (t, e) {
        if (this.state === nh) return;
        const i = this.mapNodeCameraBeforeChange;
        (delete this.mapNodeCameraBeforeChange,
          delete this._visibleMapRect,
          this._mapNodeController.mapCameraDidChange(),
          this._overlaysController && this._overlaysController.mapCameraDidChange(),
          this._annotationsController && this._annotationsController.updateVisibleAnnotations());
        const n = !i || i.rotation !== t.camera.rotation;
        (n && this._dispatchRotationChangeEvent(),
          this.controlsLayer && (this.controlsLayer.scaleDidChange(), n && this.controlsLayer.updateRotationControl()));
      },
      mapCameraChangesWillStart: function (t, e) {
        (this._mapFeaturesLayerController && this._mapFeaturesLayerController.node.remove(),
          (this._zoomLevelWhenCameraChangeStarted = this.zoomLevel),
          this._annotationsController && this._annotationsController.mapRegionChangeWillStart(),
          this.public.dispatchEvent(new pt.Event("region-change-start")));
      },
      mapCameraChangesDidEnd: function (t) {
        this.state !== nh &&
          (this._zoomLevelWhenCameraChangeStarted !== this.zoomLevel &&
            this.controlsLayer &&
            this.controlsLayer.zoomLevelDidChange(),
          delete this._zoomLevelWhenCameraChangeStarted,
          this._annotationsController && this._annotationsController.mapRegionChangeDidEnd(),
          this.public.dispatchEvent(new pt.Event("region-change-end")));
      },
      mapMinAndMaxZoomLevelsDidChange: function (t) {
        this.controlsLayer && this.controlsLayer.zoomLevelDidChange();
      },
      mapCanStartRotating: function (t) {
        return this.public.dispatchEvent(new pt.Event("rotation-start"));
      },
      mapRotationDidChange: function (t) {
        (this.controlsLayer && this.controlsLayer.updateRotationControl(), this._dispatchRotationChangeEvent());
      },
      mapDidStopRotating: function (t) {
        this.public.dispatchEvent(new pt.Event("rotation-end"));
      },
      mapCustomCanvasWillRender(t) {
        this.state !== nh && this._canvas2dLayer && this._scene.flush();
      },
      mapInteractionCenter: function (t) {
        return this._forcedInteractionCenter ? this._forcedInteractionCenter : this._centerMapPoint();
      },
      mapTransformCenter: function (t) {
        return this._centerMapPoint();
      },
      userWillTap: function (t) {
        const e = t.locationInElement();
        if (this._isInitialInteractionTargetInUIElement())
          return void (
            qn.supportsTouches &&
            (this._delayedTapFunction = () =>
              this._elementWasTapped(this._mapUserInteractionController.initialEventTargetForCurrentInteraction))
          );
        const i = this.rootNode.convertPointFromPage(e),
          n = this._annotationsController ? this._annotationsController.enabledItemCloseToPoint(i) : void 0;
        if (n) return void (this._delayedTapFunction = () => gh.call(this, n));
        let o = !1;
        if (this._overlaysController) {
          const t = this._overlaysController.enabledItemCloseToPoint(i);
          if (t) {
            if (t !== this._overlaysController.userLocationAccuracyRingOverlay)
              return void (this._delayedTapFunction = () => {
                t.selected = !0;
              });
            o = !0;
          }
        }
        if (this._annotationsController && this._selectableMapFeatures && this._mapNode.getMapFeatureRegions) {
          const t = this._mapNode.getMapFeatureRegions(),
            e = -1 !== this._selectableMapFeatures.indexOf(hh.MapFeatureType.PointOfInterest),
            n = -1 !== this._selectableMapFeatures.indexOf(hh.MapFeatureType.Territory),
            o = -1 !== this._selectableMapFeatures.indexOf(hh.MapFeatureType.PhysicalFeature),
            s = t.filter(
              (t) =>
                !(
                  -1 === ["Poi", "Territory", "PhysicalFeature"].indexOf(t.category) ||
                  (!e && "Poi" === t.category) ||
                  (!n && "Territory" === t.category) ||
                  (!o && "PhysicalFeature" === t.category)
                )
            ),
            a = this._annotationsController.mapFeatureRegionCloseToPoint(i, s);
          if (a) {
            const t = this._annotationsController.getMapFeatureAnnotationForRegion(
              a,
              this.selectableMapFeatureSelectionAccessory
            );
            return void (this._delayedTapFunction = () => {
              (this._annotationsController.mapFeatureDidSelect(t),
                this._logWithMap(ke.Events.MapFeatureSelect, {eventValue: a.category}));
            });
          }
        }
        if (o)
          return void (this._delayedTapFunction = () => {
            const t = this.userLocationAnnotation;
            t && gh.call(this, t);
          });
        const s = fh(ph, t);
        this._delayedTapFunction = () => {
          (this.public.dispatchEvent(s),
            s.defaultPrevented ||
              (this._annotationsController && (this._annotationsController.selectedItem = null),
              this._overlaysController && (this._overlaysController.selectedItem = null)));
        };
      },
      shouldDelaySingleTap: function () {
        return (
          this.isZoomEnabled ||
          (this.public._listeners &&
            ((this.public._listeners[ph] && this.public._listeners[ph].length > 0) ||
              (this.public._listeners[mh] && this.public._listeners[mh].length > 0)))
        );
      },
      userDidTap: function (t) {
        this._delayedTapFunction && (this._delayedTapFunction(), delete this._delayedTapFunction);
      },
      userCanceledTap: function (t) {
        delete this._delayedTapFunction;
      },
      userDidDoubleTap: function (t) {
        const e = t.modifierKeys.alt;
        (!this.isZoomEnabled ||
          (e && this.zoomLevel === this._mapNode.minZoomLevel) ||
          (!e && this.zoomLevel === this._mapNode.maxZoomLevel)) &&
          this.public.dispatchEvent(fh(mh, t));
      },
      userDidLongPress: function (t) {
        if (this._isInitialInteractionTargetInUIElement()) return !1;
        const e = t.locationInElement(),
          i = this._annotationsController
            ? this._annotationsController.enabledItemCloseToPoint(this.rootNode.convertPointFromPage(e), !0)
            : void 0;
        if (!i) {
          const e = fh("long-press", t);
          return (
            this.public.dispatchEvent(e),
            e.defaultPrevented && (this._panningWasPrevented = !0),
            qn.supportsTouches
          );
        }
        return i._impl.isDraggable() && !this.cameraIsMoving
          ? (this._annotationsController.startDraggingAnnotation(i, e), !0)
          : qn.supportsTouches
            ? (gh.call(this, i), !0)
            : qn.supportsTouches;
      },
      userMayStartPanningAfterLongPress: function () {
        delete this._panningWasPrevented;
      },
      userDidPanAfterLongPress: function (t) {
        this._annotationsController && this._annotationsController.annotationDraggingDidChange(t);
      },
      userDidStopPanningAfterLongPress: function (t) {
        this._annotationsController && this._annotationsController.annotationDraggingDidEnd(t);
      },
      linearZoomControllerDidZoom: function (t) {
        this.cameraIsZooming &&
          ((this.zoomLevel = t),
          ((t <= this.minZoomLevel && !this._linearZoomController.zoomsIn) ||
            (t >= this.maxZoomLevel && this._linearZoomController.zoomsIn)) &&
            this._mapNode.cameraDidStopZooming());
      },
      linearZoomControllerDidStop: function () {
        this._mapNode.cameraDidStopZooming();
      },
      userLocationDidChange: function (t) {
        (this._updateUserLocationDisplay(t.target),
          this.controlsLayer && this.controlsLayer.userLocationDidChange(t.target),
          this.tracksUserLocation && this._updateCameraToTrackUserLocation(t.target),
          this.public.dispatchEvent(t));
      },
      userLocationDidError: function (t) {
        (this._updateUserLocationDisplay(t.target),
          this.controlsLayer && this.controlsLayer.userLocationDidError(t.target),
          this.public.dispatchEvent(t));
      },
      get mapNodeTint() {
        const t = this._mapNodeController && this._mapNodeController.node;
        return t ? t.tint : Vi;
      },
      isRooted: function () {
        return this.element && this.element.ownerDocument.body.contains(this.element);
      },
      stopDraggingAnnotation: function () {
        this._mapUserInteractionController._stopDraggingAnnotation();
      },
      translateVisibleMapRectAnimated: function (t, e) {
        const i = this.visibleMapRect;
        this._setVisibleMapRect(
          new jl(i.minX() + t.x / this.worldSize, i.minY() + t.y / this.worldSize, i.size.width, i.size.height),
          !!e
        );
      },
      translateCameraAnimated: function (t, e) {
        this._mapNode.setCameraAnimated(this.camera.translate(t), !!e);
      },
      setCameraAnimated: function (t, e) {
        this._mapNode.setCameraAnimated(t, !!e);
      },
      shouldWaitForTilesAndControls: function () {
        return this.state !== ih || !this.controlsLayer || this.controlsLayer.controlsPending;
      },
      ensureRenderingFrame: function () {
        return this._renderingFrame || new Si();
      },
      ensureVisibleFrame: function () {
        return this._visibleFrame || new Si();
      },
      annotationDraggingWillStart: function () {
        (this.rootNode.classList.add($l),
          this._loadControlsLayer(!1),
          this.controlsLayer && (this.controlsLayer.classList.add($l), (this.controlsLayer.canShowTooltips = !1)));
      },
      annotationDraggingDidEnd: function () {
        (this.rootNode.classList.remove($l),
          this.controlsLayer && (this.controlsLayer.classList.remove($l), (this.controlsLayer.canShowTooltips = !0)));
      },
      get useMetric() {
        switch (this.distances) {
          case hh.Distances.Adaptive:
            return fi.useMetric();
          case hh.Distances.Metric:
            return !0;
          case hh.Distances.Imperial:
            return !1;
        }
      },
      get isCompassHidden() {
        return (
          this.showsCompass === Bl.Hidden ||
          (qn.supportsTouches && this.showsCompass === Bl.Adaptive && 0 === this.rotation) ||
          !this.isRotationEnabled
        );
      },
      get fontSizeRatio() {
        return this._textZoomDetector ? this._textZoomDetector.ratio : 1;
      },
      get textZoom() {
        return !!this._textZoomDetector;
      },
      set textZoom(t) {
        (t && !this._textZoomDetector
          ? (this._textZoomDetector = new Fl({
              container: this.element,
              fontSizeDidChange: () => {
                (this._mapNode && (this._mapNode.fontSizeRatio = this.fontSizeRatio),
                  this.controlsLayer && this.controlsLayer.fontSizeDidChange(),
                  this._annotationsController && this._annotationsController.fontSizeDidChange());
              }
            }))
          : !t &&
            this._textZoomDetector &&
            (this._textZoomDetector.destroy(),
            (this._textZoomDetector = void 0),
            this._mapNode && (this._mapNode.fontSizeRatio = this.fontSizeRatio)),
          this.controlsLayer && (this.controlsLayer.textZoom = !!t),
          this._annotationsController && (this._annotationsController.textZoom = !!t));
      },
      compassRotationWillStart: function (t) {
        return (t && this.rootNode.classList.add(Xl), this._mapNodeController.node.compassRotationWillStart());
      },
      compassRotationDidEnd: function () {
        (this.rootNode.classList.remove(Xl), this._mapNodeController.node.compassRotationDidEnd());
      },
      panningDuringAnnotationDrag: function () {
        this._annotationsController && this._annotationsController.mapPanningDuringAnnotationDrag();
      },
      padMapRect: function (t, e, i) {
        (c(e, "object", "[MapKit] padding must be an object with any of `top`, `left`, `bottom`, `right`"),
          ["top", "left", "bottom", "right"].forEach(function (t) {
            if (t in e) {
              const i = e[t];
              if ("number" != typeof i || i < 0)
                throw new Error("[MapKit] property `" + t + "` of padding must be a number >= 0; got `" + i + "`");
            } else e[t] = 0;
          }));
        const n = this.ensureRenderingFrame().size;
        let o = s(
          Math.min(
            (n.width - (e.left + e.right)) / (t.size.width * Ye.tileSize),
            (n.height - (e.top + e.bottom)) / (t.size.height * Ye.tileSize)
          )
        );
        const a = Math.max(Ye.pointsPerAxis(o), 1),
          r = (function (t, e) {
            c(
              e,
              "object",
              "[MapKit] MapRect.pad expects a padding object with top, left, bottom, right but got `" + e + "` instead"
            );
            const i = e.left || 0,
              n = e.top || 0;
            return new yo(
              t.origin.x - i,
              t.origin.y - n,
              t.size.width + i + (e.right || 0),
              t.size.height + n + (e.bottom || 0)
            );
          })(t, {top: e.top / a, left: e.left / a, bottom: e.bottom / a, right: e.right / a});
        if (void 0 !== i && i >= 0) {
          o = this._mapNode.zoomLevelForCameraDistanceAtY(i, r.midY());
          const t = a / Ye.pointsPerAxis(o);
          return r.scale(t, new Ye.MapPoint(r.midX(), r.midY()));
        }
        return r;
      },
      supportsLabelRegions: function () {
        return !this._mapNodeController.usingSSR;
      },
      createLabelRegion: function () {
        return this._mapNode.createLabelRegion();
      },
      updatedLabelRegion: function () {
        this._mapNode.updatedLabelRegion();
      },
      unregisterLabelRegion: function (t) {
        this._mapNode.unregisterLabelRegion(t);
      },
      annotationPlaceSelectionAccessoryDidReveal(t, e) {
        this._logWithMap(ke.Events.PlaceAccessoryReveal, {
          eventValue: t,
          eventTarget: "PLACECARD_TRAY",
          states: {PLACE_CARD: () => e}
        });
      },
      annotationPlaceSelectionAccessoryOpenInMapsClicked(t, e) {
        this._logWithMap(ke.Events.PlaceAccessoryOpenAppleMaps, {
          eventTarget: "PLACECARD_TRAY",
          states: {PLACE_CARD: () => e}
        });
      },
      _addItems: function (t) {
        const e = [];
        return (
          t.forEach(function (t, i) {
            const n = hh.OverlaysController && t instanceof hh.OverlaysController.Overlay,
              o = hh.AnnotationsController && t instanceof hh.AnnotationsController.Annotation;
            if (!n && !o)
              throw new Error(
                "[MapKit] Map.addItems expected an Annotation, Overlay, ItemCollection, or Array of valid items at index " +
                  i +
                  ", but got `" +
                  t +
                  "` instead."
              );
            t.map || (n ? this.addOverlay(t) : e.push(t));
          }, this),
          this._annotationsController && this.addAnnotations(e),
          t
        );
      },
      _configurationDidBecomeAvailable: function (t) {
        let e = t && this.state === Ql;
        (t || (this.state === Jl ? ((this.state = Ql), (e = !0)) : this.state === th && ((this.state = eh), (e = !0))),
          this._mapNodeController.configurationDidBecomeAvailable(t),
          e && this._logWithMap(ke.Events.MapsLoad),
          this.controlsLayer && this.controlsLayer.update(),
          this.public._internalAppDelegate &&
            "function" == typeof this.public._internalAppDelegate.networkConfigurationUpdated &&
            this.public._internalAppDelegate.networkConfigurationUpdated({
              madabaDomains: dt.madabaDomains,
              tileGroup: dt.tileGroup,
              accessKey: dt.accessKey
            }));
      },
      _setupScene: function () {
        ((this._scene = new no()),
          (this._scene.sceneDidUpdate = (t, e) => this._sceneDidUpdate(t, e)),
          lh && (this._scene.performanceMeasureName = "mapkit-scene-graph-update-frame"));
        const t = this._scene.element;
        ((t.className = "rt-root"),
          fi.activeLocale && ((t.lang = fi.localeId), (t.dir = fi.activeLocale.rtl ? "rtl" : "ltr")),
          this._scene.element.setAttribute("aria-hidden", "true"));
      },
      unifiedCanvas: !1,
      _sceneDidUpdate(t, e) {
        e ||
          this.state === nh ||
          (this.unifiedCanvas && this._mapNode && this._mapNode.customCanvas && !this._scene.isTainted()
            ? (this._canvas2dLayer ||
                ((this._canvas2dLayer = new sr(this._scene)),
                (this._scene.element.hidden = !0),
                this.addLayerAbove(this._canvas2dLayer, $i.Labels)),
              this._mapNode.forceDraw())
            : this._canvas2dLayer &&
              (console.warn("[MapKit] Fallback to 2D rendering because canvas is tainted, or CSR became unavailable."),
              this.removeLayer(this._canvas2dLayer),
              (this._canvas2dLayer = null),
              (this._scene.element.hidden = !1)));
      },
      _checkOptions: function (t) {
        (c(t, "object", "[MapKit] The `options` object is invalid."),
          Object.keys(t).forEach(function (e) {
            let i = oh[e];
            if (void 0 === i) {
              const n = x(e);
              ((i = oh[n]), void 0 !== i && (t[n] = t[e]));
            }
            "rw" === i ||
              ("ro" === i
                ? console.warn("[MapKit] `" + e + "` is read-only and can't be set on a Map.")
                : console.warn("[MapKit] `" + e + "` is not a valid property of Map."));
          }));
      },
      _checkParent: function (t) {
        if (null == t) return;
        const e = "string" == typeof t ? document.getElementById(t) : t;
        if (!e || !B(e)) throw new Error("[MapKit] `parent` must either be a DOM element or its ID.");
        return e;
      },
      _setDefaultState: function (t) {
        ((this._showsScale = Bl.Hidden),
          (this._visibleMapRect = ql),
          (this._padding = new ko()),
          (this._adjustedPadding = new ko()),
          (this._showsCompass = Bl.Adaptive),
          (this._usingDefaultShowsCompassValue = !0),
          (this._distances = hh.Distances.Adaptive),
          (this._showsZoomControl = void 0 !== t.showsZoomControl ? !!t.showsZoomControl : !Vl),
          (this._showsMapTypeControl = void 0 !== t.showsMapTypeControl ? !!t.showsMapTypeControl : !Vl),
          (this._showsUserLocationControl = void 0 !== t.showsUserLocationControl && !!t.showsUserLocationControl));
        const e = t.mapType || hh.MapTypes.Standard;
        (_h(e, hh.MapTypes, "mapType", "Map.MapTypes"),
          e === hh.MapTypes.MutedStandard
            ? ((this._emphasis = en), (this._mapType = hh.MapTypes.Standard))
            : ((this._emphasis = nn), (this._mapType = e)));
        const i = t.colorScheme || hh.ColorSchemes.Light;
        (_h(i, hh.ColorSchemes, "colorScheme", "Map.ColorSchemes"),
          (this._colorScheme = i),
          i === bt.Adaptive &&
            ((this._colorSchemeHandle = kt.addHandle()),
            (this._boundDarkModeDidChange = () => this._updateMapNodeTintAndEmphasis(this._mapNode)),
            this._colorSchemeHandle.addEventListener("change", this._boundDarkModeDidChange)));
      },
      _setIsRotationEnabled: function (t, e) {
        "boolean" == typeof t
          ? (this.isRotationAvailable
              ? (this._mapNode.isRotationEnabled = t)
              : e && t && console.warn("[MapKit] Rotation can't be enabled because it's not available."),
            this.controlsLayer && this.controlsLayer.updateRotationControl(),
            this._mapUserInteractionController.updateGestureEnableState())
          : console.warn("[MapKit] Value passed to `Map.isRotationEnabled` is not a Boolean.");
      },
      _setupRenderTree: function () {
        const t = document.createElement("div");
        ((t.className = "mk-map-view"), t.appendChild(this._scene.element), (this.rootNode = new Rn.Node(t)));
      },
      _setupControllers: function (t) {
        (this._loadControlsLayer(!0),
          hh.OverlaysController && this.addOverlaysController(),
          hh.MapFeaturesLayerController && this.addMapFeaturesLayerController(),
          hh.AnnotationsController && this.addAnnotationsController(),
          hh.UserLocationController && this.addUserLocationController(),
          (this._mapNodeController = new nr(this, t)),
          (this._linearZoomController = new So(this._mapNode.snapsToIntegralZoomLevels, this)),
          (this._mapUserInteractionController = new Po(this.rootNode.element, this)));
      },
      addOverlaysController: function () {
        this.state === nh ||
          this._overlaysController ||
          ((this._overlaysController = new hh.OverlaysController(this)),
          this._scene.insertAfter(
            this._overlaysController.node,
            this._mapNodeController ? this._mapNodeController.node : void 0
          ));
      },
      addMapFeaturesLayerController: function () {
        ((this._mapFeaturesLayerController = new hh.MapFeaturesLayerController(this)),
          this._startStabilizationTimeoutIfNeeded());
      },
      addAnnotationsController: function () {
        this.state === nh ||
          this._annotationsController ||
          ((this._annotationsController = new hh.AnnotationsController(this)),
          this._mapRoot &&
            this._mapRoot.insertAfter(this._annotationsController.node, this._mapFeaturesLayerController.node),
          this._scene.insertAfter(
            this._annotationsController.sceneGraphNode,
            this._overlaysController
              ? this._overlaysController.node
              : this._mapNodeController
                ? this._mapNodeController.node
                : void 0
          ));
      },
      addUserLocationController: function () {
        this._userLocationController = new hh.UserLocationController(this);
      },
      getControlBounds: function () {
        return this.controlsLayer ? this.controlsLayer.controlBounds() : [];
      },
      _loadControlsLayer: function (t) {
        if (!this._loadControlsLayerHasFailed)
          return !t && hh.ControlsLayer
            ? (this._insertControlsLayer(), void this._updateInitialControlsLayerState())
            : void ((e) => {
                if (!e)
                  return (
                    (this._showsDefaultTiles = !1),
                    Object.defineProperty(this, "_showsDefaultTiles", {
                      get: function () {
                        return !1;
                      },
                      set: function () {
                        throw new Error(
                          "[MapKit] Default tiles are not shown because map controls has failed to load."
                        );
                      },
                      configurable: !0
                    }),
                    void (this._loadControlsLayerHasFailed = !0)
                  );
                ((hh.ControlsLayer = e),
                  t
                    ? (Qt.scheduleInBackground(() => this._insertControlsLayer()),
                      Qt.scheduleInBackground(() => this._updateInitialControlsLayerState()))
                    : (this._insertControlsLayer(), this._updateInitialControlsLayerState()));
              })(Nl);
      },
      _insertControlsLayer: function () {
        if (
          this.state !== nh &&
          !this.controlsLayer &&
          ((this.controlsLayer = new hh.ControlsLayer(this)),
          this._mapRoot.insertAfter(
            this.controlsLayer,
            this._annotationsController ? this._annotationsController.node : void 0
          ),
          rh)
        ) {
          const t = () => {
            (Rn.removeEventListener("update", t),
              performance.measure("mapkit-map-controls-inserted", "mapkit-map-start"));
          };
          Rn.addEventListener("update", t);
        }
      },
      _updateInitialControlsLayerState: function () {
        this.state === nh ||
          this._updateInitialControlsLayerStateCalled ||
          ((this._updateInitialControlsLayerStateCalled = !0),
          this.controlsLayer.update(),
          this.controlsLayer.mapPaddingDidChange(this._adjustedPadding));
      },
      _handleOptions: function (t, e) {
        (void 0 !== t.contextType && (this.contextType = t.contextType),
          void 0 !== t.showsScale && (this.showsScale = t.showsScale),
          void 0 !== t.showsCompass && (this.showsCompass = t.showsCompass),
          void 0 !== t.padding && (this.padding = t.padding),
          void 0 !== t.cameraZoomRange && (this.cameraZoomRange = t.cameraZoomRange),
          void 0 !== t.cameraBoundary && (this.cameraBoundary = t.cameraBoundary),
          void 0 !== t.visibleMapRect
            ? (this.visibleMapRect = t.visibleMapRect)
            : void 0 !== t.region
              ? (this.region = t.region)
              : (void 0 !== t.center && (this.center = t.center),
                void 0 !== t.cameraDistance && (this.cameraDistance = t.cameraDistance)),
          void 0 !== t.rotation && (this.rotation = t.rotation));
        const i = [],
          n = void 0 === t.visibleMapRect && void 0 === t.region && void 0 === t.center && e;
        if (
          (void 0 !== t.overlays &&
            (u(
              t.overlays,
              "[MapKit] Map constructor overlays option expected an array of overlays, but got `" +
                t.annotations +
                "` instead."
            ),
            n ? i.push.apply(i, t.overlays) : (this.overlays = t.overlays)),
          void 0 !== t.annotations &&
            (u(
              t.annotations,
              "[MapKit] Map constructor annotations option expected an array of annotations, but got `" +
                t.annotations +
                "` instead."
            ),
            n ? i.push.apply(i, t.annotations) : (this.annotations = t.annotations)),
          i.length > 0)
        ) {
          const e = {};
          (void 0 !== t.cameraDistance && (e.cameraDistance = t.cameraDistance), this.showItems(i, e));
        }
        (void 0 !== t.selectedOverlay && (this.selectedOverlay = t.selectedOverlay),
          void 0 !== t.selectedAnnotation && (this.selectedAnnotation = t.selectedAnnotation),
          void 0 !== t.distances && (this.distances = t.distances),
          void 0 !== t.tintColor && (this.tintColor = t.tintColor),
          void 0 !== t.showsUserLocation && (this.showsUserLocation = t.showsUserLocation),
          void 0 !== t.tracksUserLocation && (this.tracksUserLocation = t.tracksUserLocation),
          void 0 !== t.tileOverlays && (this.tileOverlays = t.tileOverlays),
          void 0 !== t.annotationForCluster && (this.annotationForCluster = t.annotationForCluster),
          void 0 !== t.annotationForMapFeature && (this.annotationForMapFeature = t.annotationForMapFeature),
          void 0 !== t._unifiedCanvas && (this.unifiedCanvas = !!t._unifiedCanvas),
          void 0 !== t._textZoom && (this.textZoom = !!t._textZoom));
      },
      _flushToDOM: function (t) {
        (this._addMapToParent(t), Qt.flush(), this._ensureContainerIsPositioned());
      },
      _addMapToParent: function (t) {
        null != t &&
          (t.appendChild(this.element),
          this._bootstrapSize.width &&
            this._bootstrapSize.height &&
            this._updateRenderingFrameSize(this._bootstrapSize),
          delete this._bootstrapSize);
      },
      performScheduledUpdate: function () {
        if (this.state === nh) return;
        const t = this._mapNode.camera.zoom;
        (t % 1 != 0 &&
          (this.state === Jl || this.state === Ql) &&
          ("SERVER" === dt.forcedRenderingMode ||
            (dt.ready && (dt.didFallback || !dt.canRunCSR)) ||
            !this.csrCapable ||
            "HYBRID" === dt.forcedRenderingMode ||
            this._mapNodeController.loadPriority === tn.PointsOfInterest) &&
          this._mapNode.setZoomLevelAnimated(qn.getIntegralZoom(t)),
          this.state === Jl ? (this.state = th) : this.state === Ql && (this.state = eh),
          this._loadResizeDetector());
      },
      _loadResizeDetector: function () {
        if (!this._iframe && !this._resizeObserver) {
          if (window.ResizeObserver)
            return (
              (this._resizeObserver = new window.ResizeObserver((t) => this._sizeDidChange())),
              this._resizeObserver.observe(this.rootNode.element),
              void this._resizeDetectorDidInstall()
            );
          ((this._iframe = qn.htmlElement("iframe", {tabindex: -1, "aria-hidden": !0})),
            this._iframe.addEventListener("load", this),
            this.element.insertBefore(this._iframe, this.element.firstChild));
        }
      },
      _updateUserLocationDisplay: function (t) {
        (this._annotationsController.updateUserLocationAnnotation(t),
          this._overlaysController.updateUserLocationAccuracyRingOverlay(t));
      },
      _removeUserLocationDisplay: function () {
        (this._annotationsController.removeUserLocationAnnotation(),
          this._overlaysController.removeUserLocationAccuracyRingOverlay());
      },
      _updateCameraToTrackUserLocation: function (t) {
        let e, i;
        if (this.tracksUserLocation && this.showsUserLocation && t.coordinate) {
          if (this._mapNode.isMapPointWithinBounds(t.coordinate.toMapPoint()))
            if (this._firstCameraUpdateToTrackUserLocationPending && this.zoomLevel < 9.5) {
              let n = 14;
              if (t.location.accuracy > 0) {
                const e = 5 * t.location.accuracy * Ye.mapUnitsPerMeterAtLatitude(t.location.latitude),
                  i = new jl(0, 0, e, e),
                  o = this.ensureVisibleFrame().size;
                n = Math.max(this.zoomLevel, Ye.zoomLevelForMapRectInViewport(i, o, Ye.tileSize));
              }
              ((e = this._mapRectForCenterAndZoomLevel(t.coordinate.toMapPoint(), n)),
                this._userLocationTrackingDelegate &&
                  "function" == typeof this._userLocationTrackingDelegate.mapRegionWillChangeToTrackUserLocation &&
                  ((i = e.toCoordinateRegion()),
                  this._userLocationTrackingDelegate.mapRegionWillChangeToTrackUserLocation(this.public, i),
                  (e = i.toMapRect())),
                this._mapNode.setCameraAnimated(this.camera.withNewMapRect(e), !0, !0));
            } else
              this._userLocationTrackingDelegate &&
              "function" == typeof this._userLocationTrackingDelegate.mapRegionWillChangeToTrackUserLocation
                ? ((e = this._mapRectForCenterAndZoomLevel(t.coordinate.toMapPoint(), this.zoomLevel)),
                  (i = e.toCoordinateRegion()),
                  this._userLocationTrackingDelegate.mapRegionWillChangeToTrackUserLocation(this.public, i),
                  this._mapNode.setCameraAnimated(this.camera.withNewMapRect(e), !0, !0))
                : this.setCenterAnimated(t.coordinate, !0, !0);
          else
            (this.setCenterAnimated(t.coordinate, !0, !0),
              (this._userLocationController.tracksUserLocation = !1),
              (this._mapNode.usesInteractionCenter = !1),
              this.controlsLayer && this.controlsLayer.updateUserLocationControl());
          delete this._firstCameraUpdateToTrackUserLocationPending;
        }
      },
      _updateRenderingFrameFromElement: function () {
        const t = this.rootNode.element,
          e = t.offsetWidth,
          i = t.offsetHeight;
        0 !== e && 0 !== i && this._updateRenderingFrameSize(new ki(e, i));
      },
      _setRenderingFrameValue: function (t) {
        ((this._renderingFrame = t), (this._visibleFrame = t));
        const e = this._adjustedPadding.copy(),
          i = (this._adjustedPadding = this._adjustedPaddingForMapSize(t.size));
        (i.equals(ko.Zero) ||
          (this._visibleFrame = new Si(
            t.origin.x + i.left,
            t.origin.y + i.top,
            t.size.width - i.left - i.right,
            t.size.height - i.top - i.bottom
          )),
          !i.equals(e) && this.controlsLayer && this.controlsLayer.mapPaddingDidChange(i));
      },
      _adjustedPaddingForMapSize: function (t) {
        const e = new ki(
            Math.min(ln.minimumSizeToShowLogo.width, t.width),
            Math.min(ln.minimumSizeToShowLogo.height, t.height)
          ),
          i = this._padding.copy();
        (i.top < 0 && (i.top = 0),
          i.left < 0 && (i.left = 0),
          i.bottom < 0 && (i.bottom = 0),
          i.right < 0 && (i.right = 0));
        const n = i.left + i.right,
          o = i.top + i.bottom,
          s = n + e.width - t.width,
          a = o + e.height - t.height;
        if (s > 0 && n > 0) {
          const t = (n - s) / n;
          ((i.left *= t), (i.right *= t));
        }
        if (a > 0 && o > 0) {
          const t = (o - a) / o;
          ((i.top *= t), (i.bottom *= t));
        }
        return i;
      },
      _iframeDidLoad: function () {
        try {
          this._iframe.contentWindow.addEventListener("resize", this);
        } catch (t) {
          console.warn("[MapKit] Map resize detection is disabled when loaded in a sandboxed iframe.");
        }
        this._resizeDetectorDidInstall();
      },
      _resizeDetectorDidInstall: function () {
        const t = this._visibleMapRect && this._visibleMapRect.copy(),
          e = this.rotation,
          i = this._padding && !this._padding.equals(ko.Zero);
        (this._ensureContainerIsPositioned(),
          this._sizeDidChange(),
          t &&
            i &&
            (t.size.width > 0 || t.size.height > 0
              ? (this.setVisibleMapRectAnimated(t, !1), e && this.setRotationAnimated(e, !1))
              : this.setCenterAnimated(new Kl(t.midX(), t.midY()).toCoordinate())));
      },
      _sizeDidChange: function () {
        (this._printMediaQueryList && this._printMediaQueryList.matches) || this._updateRenderingFrameFromElement();
      },
      _updateRenderingFrameSize: function (t) {
        const e = !this._renderingFrame;
        0 === t.width ||
          0 === t.height ||
          (!e && this._renderingFrame.size.equals(t)) ||
          (this._setRenderingFrameValue(new Si(0, 0, t.width, t.height)),
          (this._scene.size = t),
          (this._mapRoot.size = t),
          this._mapNodeController.updateSize(t),
          this._delayedShowItems &&
            (hh.LayerItemsController.setRegionForItems(this, this._delayedShowItems[0], this._delayedShowItems[1]),
            delete this._delayedShowItems),
          this.controlsLayer && this.controlsLayer.sizeDidChange(),
          this._annotationsController && this._annotationsController.mapSizeDidUpdate());
      },
      _mapRectForCenterAndZoomLevel: function (t, e) {
        const i = this.ensureVisibleFrame().size,
          n = Ye.pointsPerAxis(e),
          o = i.width / n,
          s = i.height / n;
        return new jl(t.x - o / 2, t.y - s / 2, o, s);
      },
      _isInitialInteractionTargetInUIElement: function () {
        const t = this._mapUserInteractionController.initialEventTargetForCurrentInteraction;
        return !!(
          t &&
          ((this._annotationsController && this._annotationsController.isElementInAccessory(t)) ||
            (this.controlsLayer && this.controlsLayer.element.contains(t)))
        );
      },
      zoomControlStart: function (t) {
        (t && !this.canZoomIn) ||
          (!t && !this.canZoomOut) ||
          (this._linearZoomController.start(this.zoomLevel, t) && this._mapNode.cameraWillStartZooming("BUTTON"));
      },
      zoomControlEnd: function () {
        this._linearZoomController.stop();
      },
      _centerMapPoint: function () {
        if (0 !== this.rotation) {
          const t = this.renderingMapRect,
            e = new Kl(t.midX(), t.midY()),
            i = this._offsetCenterWithPaddingAndRotation(e, 1);
          if (i) return i;
        }
        const t = this.visibleMapRect;
        return new Kl(t.midX(), t.midY());
      },
      _offsetCenterWithPaddingAndRotation: function (t, e) {
        const i = 2 * e * this.worldSize,
          n = (this._adjustedPadding.right - this._adjustedPadding.left) / i,
          o = (this._adjustedPadding.bottom - this._adjustedPadding.top) / i;
        if (0 !== n || 0 !== o) {
          const e = (-this.rotation / 180) * Math.PI;
          return new Kl(t.x - n * Math.cos(e) + o * Math.sin(e), t.y - n * Math.sin(e) - o * Math.cos(e));
        }
      },
      _setVisibleMapRect: function (t, e, i) {
        i || (this.tracksUserLocation = !1);
        let n = t;
        const o = this._adjustedPadding,
          s = this.ensureRenderingFrame(),
          a = this.ensureVisibleFrame();
        (o.equals(ko.Zero) ||
          a.equals(Si.Zero) ||
          (n = new jl(
            t.minX() - (o.left / a.size.width) * t.size.width,
            t.minY() - (o.top / a.size.height) * t.size.height,
            t.size.width * (s.size.width / a.size.width),
            t.size.height * (s.size.height / a.size.height)
          )),
          this._mapNode.setVisibleMapRectAnimated(n, e));
      },
      _ensureContainerIsPositioned: function () {
        const t = this.rootNode.element;
        "static" === t.ownerDocument.defaultView.getComputedStyle(t).position && (t.style.position = "relative");
      },
      didInsertNewMapNode: function (t) {
        ((t.delegate = this),
          this.state === ih && (this.state = "Switched"),
          this._updateMapRoot(t),
          this._updateMapNodeTintAndEmphasis(t),
          window.setTimeout(() => this.public.dispatchEvent(new pt.Event("map-node-change")), 0));
      },
      didReconfigureMapNode: function (t) {
        (t.snapsToIntegralZoomLevels &&
          t.zoomLevel % 1 != 0 &&
          !t.cameraIsAnimating &&
          (t.zoomLevel = qn.getIntegralZoom(t.zoomLevel)),
          this._linearZoomController &&
            (this._linearZoomController.snapsToIntegralZoomLevels = t.snapsToIntegralZoomLevels),
          (t.fontSizeRatio = this.fontSizeRatio),
          this.controlsLayer && this.controlsLayer.updateZoomControl());
      },
      didFinishMapNodeInitialization: function (t) {
        t.customCanvas
          ? (t.customCanvas.setAttribute("aria-hidden", "true"),
            this.element.insertBefore(t.customCanvas, this.element.firstChild))
          : this._scene.addChild(t, 0);
      },
      mapNodeDidFail: function (t) {
        const e = new pt.Event("error");
        (t && ((e.reason = t.reason), (e.message = t.message)), this.public.dispatchEvent(e));
      },
      mapNodeReady: function (t) {
        (window.setTimeout(() => {
          const e = new pt.Event("map-node-ready");
          ((e.usingCSR = t), this.public.dispatchEvent(e), this._logWithMap(ke.Events.MapNodeReady));
        }, 0),
          this.controlsLayer && this.controlsLayer.updateRotationControl(),
          this._annotationsController && this._annotationsController.mapSupportForLabelRegionsChanged());
      },
      _updateMapRoot: function (t) {
        (this._mapRoot && this._mapRoot.remove(),
          (this._mapRoot = this.rootNode.insertBefore(new Rn.Node(t.element), this.rootNode.firstChild)),
          (t.element.className = "mk-map-node-element"),
          (this._mapRoot.size = t.size = this._scene.size),
          this._annotationsController && this._mapRoot.addChild(this._annotationsController.node),
          this.controlsLayer && this._mapRoot.addChild(this.controlsLayer));
      },
      _updateMapNodeTintAndEmphasis: function (t) {
        const e = this._colorScheme === bt.Adaptive ? kt.currentColorScheme : this._colorScheme;
        this.currentColorScheme = e;
        const i = this._mapType === hh.MapTypes.Standard ? e : ji;
        this.tint = i;
        let n = e;
        ((this._mapType !== hh.MapTypes.Hybrid && this._mapType !== hh.MapTypes.Satellite) || (n = Vi),
          t.setTintAndEmphasis(i, n, this._emphasis),
          this._mapNodeController && this._mapNodeController.setTintAndEmphasis(i, n, this._emphasis),
          this.controlsLayer && this.controlsLayer.update(),
          this._annotationsController &&
            (this._annotationsController.mapNodeTintWasSet(i),
            this._annotationsController.node.classList.toggle(ch, qn.darkColorScheme(i))),
          this.rootNode.classList.toggle(ch, qn.darkColorScheme(i)));
      },
      overlaySelectionDidChange: function (t) {
        t.selected && this._annotationsController && (this._annotationsController.selectedItem = null);
        const e = new pt.Event(t.selected ? dh : uh);
        ((e.overlay = t), (this.selectionMayChange = !1), this.public.dispatchEvent(e), delete this.selectionMayChange);
      },
      annotationSelectionDidChange: function (t) {
        (t.selected && this._overlaysController && (this._overlaysController.selectedItem = null),
          (this.selectionMayChange = !1),
          this.dispatchEventWithAnnotation(t.selected ? dh : uh, t),
          delete this.selectionMayChange);
      },
      dispatchEventWithAnnotation: function (t, e, i) {
        const n = new pt.Event(t);
        if (((n.annotation = e), i)) for (const t in i) n[t] = i[t];
        this.public.dispatchEvent(n);
      },
      addWaitingAnnotations: function () {
        this.shouldWaitForTilesAndControls() ||
          (this._annotationsController
            ? this._annotationsController.addWaitingAnnotations(() => this._dispatchCompleteEvent())
            : this._dispatchCompleteEvent());
      },
      _completedOnce: !1,
      _dispatchCompleteEvent: function () {
        (this._completedOnce ||
          ((this._completedOnce = !0),
          rh && performance.measure("mapkit-map-annotations-rendered", "mapkit-map-start")),
          this._mapNode.fullyRendered && this.public.dispatchEvent(new pt.Event("complete")));
      },
      _dispatchRotationChangeEvent: function () {
        this.shouldDispatchRotationChangeEvent && this.public.dispatchEvent(new pt.Event("rotation-change"));
      },
      _handleLocaleChange: function (t) {
        const e = this._scene.element;
        ((e.lang = fi.localeId),
          (e.dir = fi.activeLocale.rtl ? "rtl" : "ltr"),
          this._mapNodeController.handleMapConfigurationChange(),
          this._annotationsController &&
            (this._annotationsController.localeChanged(),
            this._userLocationController &&
              this._annotationsController.updateUserLocationAnnotation(this._userLocationController.userLocation, !0)));
        const i = this.ensureRenderingFrame();
        0 !== i.size.width && 0 !== i.size.height && this._setRenderingFrameValue(i);
      },
      _elementWasTapped: function (t) {
        for (; null !== t; t = t.parentNode)
          if ("a" === (e = t).localName || "button" === e.localName || ("input" === e.localName && "button" === e.type))
            return void t.click();
        var e;
      },
      _devicePixelRatioDidChange: function () {
        ((this._scene.needsDisplay = !0),
          this.controlsLayer && this.controlsLayer.devicePixelRatioDidChange(),
          this._annotationsController && this._annotationsController.devicePixelRatioDidChange(),
          this._mapNode.devicePixelRatioDidChange() || this._mapNodeController.handleRecreate());
      },
      _mapRectAccountingForPadding: function () {
        const t = this.renderingMapRect;
        if (this._adjustedPadding.equals(ko.Zero)) return t.copy();
        const e = this.ensureVisibleFrame(),
          i = this.ensureRenderingFrame();
        return new jl(
          t.minX() + (this._adjustedPadding.left / i.size.width) * t.size.width,
          t.minY() + (this._adjustedPadding.top / i.size.height) * t.size.height,
          t.size.width * (e.size.width / i.size.width),
          t.size.height * (e.size.height / i.size.height)
        );
      },
      _setupListeners: function () {
        (dt.state === dt.States.READY && this._configurationDidBecomeAvailable(!0),
          dt.addEventListener(dt.Events.Initialized, this),
          dt.addEventListener(dt.Events.Changed, this),
          fi.activeLocale && this._handleLocaleChange({locale: fi.activeLocale}),
          fi.addEventListener(fi.Events.LocaleChanged, this),
          (this._boundDevicePixelRatioDidChange = () => this._devicePixelRatioDidChange()),
          (this._dppxMediaQueryList = window.matchMedia("(-webkit-device-pixel-ratio: 1)")),
          this._dppxMediaQueryList.addListener(this._boundDevicePixelRatioDidChange),
          (this._boundPrintMediaQueryChanged = () => this._printMediaQueryChanged()),
          (this._printMediaQueryList = window.matchMedia("print")),
          this._printMediaQueryList.addListener(this._boundPrintMediaQueryChanged));
      },
      _removePrintListener: function () {
        (this._printMediaQueryList.removeListener(this._boundPrintMediaQueryChanged),
          (this._boundPrintMediaQueryChanged = null),
          (this._printMediaQueryList = null));
      },
      _printMediaQueryChanged: function () {
        const t = this._mapNode;
        this._printMediaQueryList.matches
          ? ((this.rootNode.element.style.background = this.rootNode.element.parentNode.dataset.mapPrintingBackground),
            t.fullyRendered
              ? this._ensureMapCenterDuringPrint(!0)
              : ((t.opacity = 0), this._annotationsController && this._annotationsController.addWaitingAnnotations()),
            this._loadControlsLayer(!1),
            this._mapNodeController.handlePrintMatch(),
            Qt.flush())
          : (this._mapNodeController.handlePrintUnmatch(),
            (t.opacity = 1),
            (this.rootNode.element.style.background = ""),
            this._ensureMapCenterDuringPrint(!1));
      },
      _ensureMapCenterDuringPrint: function (t) {
        const e = [this._scene.element];
        (this._mapNode.customCanvas && e.push(this._mapNode.customCanvas),
          e.forEach(function (e) {
            if (t) {
              const t = this._scene.size;
              ((e.style.left = "50%"),
                (e.style.marginLeft = "-" + t.width / 2 + "px"),
                (e.style.top = "50%"),
                (e.style.marginTop = "-" + t.height / 2 + "px"));
            } else ((e.style.left = ""), (e.style.marginLeft = ""), (e.style.top = ""), (e.style.marginTop = ""));
          }, this));
      },
      _mapStabilizationTimeout: null,
      _startStabilizationTimeoutIfNeeded: function () {
        this._mapNodeController &&
          this._mapNode &&
          this._mapNode.fullyRendered &&
          !this.cameraIsMoving &&
          (this._stopStabilizationTimeout(),
          (this._mapStabilizationTimeout = window.setTimeout(
            () => Qt.scheduleInBackground(() => this._mapIsStabilized()),
            500
          )));
      },
      _stopStabilizationTimeout: function () {
        this._mapStabilizationTimeout &&
          (window.clearTimeout(this._mapStabilizationTimeout), (this._mapStabilizationTimeout = null));
      },
      _mapIsStabilized: function () {
        (this._updateMapFeatureRegionLayer(), this._updatePrintingBackground());
      },
      _updatePrintingBackground: function () {
        this._mapNode &&
          this._mapNode.cssBackgroundProperty &&
          this._mapNode.fullyRendered &&
          this.isRooted() &&
          (this.rootNode.element.parentNode.dataset.mapPrintingBackground = this._mapNode.cssBackgroundProperty);
      },
      _updateMapFeatureRegionLayer: function () {
        if (
          !(
            this._selectableMapFeatures &&
            this._mapNode &&
            this._mapNode.getMapFeatureRegions &&
            this._mapFeaturesLayerController
          )
        )
          return;
        if (!this._mapNode.fullyRendered || !this.isRooted()) return;
        const t = -1 !== this._selectableMapFeatures.indexOf(hh.MapFeatureType.PointOfInterest),
          e = -1 !== this._selectableMapFeatures.indexOf(hh.MapFeatureType.Territory),
          i = -1 !== this._selectableMapFeatures.indexOf(hh.MapFeatureType.PhysicalFeature),
          n = this._mapNode
            .getMapFeatureRegions()
            .filter(
              (n) =>
                (t && "Poi" === n.category) ||
                (e && "Territory" === n.category) ||
                (i && "PhysicalFeature" === n.category)
            );
        (this._mapFeaturesLayerController.update(n, this._mapNode.camera),
          this._mapRoot.addChild(this._mapFeaturesLayerController.node, 0));
      },
      _logWithMap: function (t, e = {}) {
        if (this.state === nh) return;
        const i = {map: this, eventTarget: e.eventTarget || ke.EventTarget};
        for (const t in e) i[t] = e[t];
        ke.log(t, i);
      }
    }));
  const yh = [
    "LayerItemsController",
    "ItemCollection",
    "OverlaysController",
    "MapFeaturesLayerController",
    "AnnotationsController",
    "PlaceSelectionAccessory",
    "UserLocationController",
    "MapFeatureType"
  ];
  function vh() {
    let t = !0;
    for (let e = 0; e < yh.length; e++) {
      const i = yh[e];
      !hh[i] && L.jsModules[i] ? (hh[i] = L.jsModules[i]) : (t = !1);
    }
    (hh.OverlaysController &&
      hh.maps.forEach((t) => {
        t._impl.addOverlaysController();
      }),
      hh.MapFeaturesLayerController &&
        hh.maps.forEach((t) => {
          t._impl.addMapFeaturesLayerController();
        }),
      hh.AnnotationsController &&
        hh.maps.forEach((t) => {
          t._impl.addAnnotationsController();
        }),
      hh.UserLocationController &&
        hh.maps.forEach((t) => {
          t._impl.addUserLocationController();
        }),
      t && L.removeEventListener("load", vh));
  }
  (L.addEventListener("load", vh), vh());
  const wh = hh;
  function bh(t, e) {
    bo(this, bh) &&
      (Object.defineProperty(this, "_impl", {value: Object.create(wh.prototype)}), wh.call(this._impl, this, t, e));
  }
  ((bh.MapTypes = wh.MapTypes),
    (bh.ColorSchemes = wh.ColorSchemes),
    (bh.Distances = wh.Distances),
    (bh.LoadPriorities = wh.LoadPriorities),
    (bh.prototype = r(pt.EventTarget, bh, {
      get padding() {
        return this._impl.padding;
      },
      set padding(t) {
        this._impl.padding = t;
      },
      get isScrollEnabled() {
        return this._impl.isScrollEnabled;
      },
      set isScrollEnabled(t) {
        this._impl.isScrollEnabled = t;
      },
      get isZoomEnabled() {
        return this._impl.isZoomEnabled;
      },
      set isZoomEnabled(t) {
        this._impl.isZoomEnabled = t;
      },
      get showsZoomControl() {
        return this._impl.showsZoomControl;
      },
      set showsZoomControl(t) {
        this._impl.showsZoomControl = t;
      },
      get showsScale() {
        return this._impl.showsScale;
      },
      set showsScale(t) {
        this._impl.showsScale = t;
      },
      get mapType() {
        return this._impl.getMapTypeWithEmphasis();
      },
      set mapType(t) {
        this._impl.setMapTypeWithEmphasis(t);
      },
      get colorScheme() {
        return this._impl.colorScheme;
      },
      set colorScheme(t) {
        this._impl.colorScheme = t;
      },
      get distances() {
        return this._impl.distances;
      },
      set distances(t) {
        this._impl.distances = t;
      },
      get _allowWheelToZoom() {
        return this._impl._allowWheelToZoom;
      },
      set _allowWheelToZoom(t) {
        this._impl._allowWheelToZoom = t;
      },
      get _showsTileInfo() {
        return this._impl._showsTileInfo;
      },
      set _showsTileInfo(t) {
        this._impl._showsTileInfo = t;
      },
      get _showsDefaultTiles() {
        return this._impl._showsDefaultTiles;
      },
      set _showsDefaultTiles(t) {
        this._impl._showsDefaultTiles = t;
      },
      get loadPriority() {
        return this._impl.loadPriority;
      },
      set loadPriority(t) {
        this._impl.loadPriority = t;
      },
      get tileOverlays() {
        return this._impl.tileOverlays;
      },
      set tileOverlays(t) {
        this._impl.tileOverlays = t;
      },
      addTileOverlay: function (t) {
        return this._impl.addTileOverlay(t);
      },
      addTileOverlays: function (t) {
        return this._impl.addTileOverlays(t);
      },
      removeTileOverlay: function (t) {
        return this._impl.removeTileOverlay(t);
      },
      removeTileOverlays: function (t) {
        return this._impl.removeTileOverlays(t);
      },
      get showsMapTypeControl() {
        return this._impl.showsMapTypeControl;
      },
      set showsMapTypeControl(t) {
        this._impl.showsMapTypeControl = t;
      },
      get showsUserLocationControl() {
        return this._impl.showsUserLocationControl;
      },
      set showsUserLocationControl(t) {
        this._impl.showsUserLocationControl = t;
      },
      get showsPointsOfInterest() {
        return this._impl.showsPointsOfInterest;
      },
      set showsPointsOfInterest(t) {
        this._impl.showsPointsOfInterest = t;
      },
      get pointOfInterestFilter() {
        return this._impl.pointOfInterestFilter;
      },
      set pointOfInterestFilter(t) {
        this._impl.pointOfInterestFilter = t;
      },
      get element() {
        return this._impl.element;
      },
      set element(t) {
        this._impl.element = t;
      },
      get visibleMapRect() {
        return this._impl.visibleMapRect;
      },
      set visibleMapRect(t) {
        this._impl.visibleMapRect = t;
      },
      setVisibleMapRectAnimated: function (t, e) {
        return this._impl.setVisibleMapRectAnimated(t, e);
      },
      get region() {
        return this._impl.region;
      },
      set region(t) {
        this._impl.region = t;
      },
      setRegionAnimated: function (t, e) {
        return this._impl.setRegionAnimated(t, e);
      },
      get isRotationAvailable() {
        return this._impl.isRotationAvailable;
      },
      set isRotationAvailable(t) {
        this._impl.isRotationAvailable = t;
      },
      get isRotationEnabled() {
        return this._impl.isRotationEnabled;
      },
      set isRotationEnabled(t) {
        this._impl.isRotationEnabled = t;
      },
      get rotation() {
        return this._impl.rotation;
      },
      set rotation(t) {
        this._impl.rotation = t;
      },
      get showsCompass() {
        return this._impl.showsCompass;
      },
      set showsCompass(t) {
        this._impl.showsCompass = t;
      },
      setRotationAnimated: function (t, e) {
        return this._impl.setRotationAnimated(t, e);
      },
      get center() {
        return this._impl.center;
      },
      set center(t) {
        this._impl.center = t;
      },
      setCenterAnimated: function (t, e) {
        return this._impl.setCenterAnimated(t, e);
      },
      get cameraZoomRange() {
        return this._impl.cameraZoomRange;
      },
      set cameraZoomRange(t) {
        this._impl.cameraZoomRange = t;
      },
      setCameraZoomRangeAnimated: function (t, e) {
        return this._impl.setCameraZoomRangeAnimated(t, e);
      },
      get cameraDistance() {
        return this._impl.cameraDistance;
      },
      set cameraDistance(t) {
        this._impl.cameraDistance = t;
      },
      setCameraDistanceAnimated: function (t, e) {
        return this._impl.setCameraDistanceAnimated(t, e);
      },
      get cameraBoundary() {
        return this._impl.cameraBoundary;
      },
      set cameraBoundary(t) {
        this._impl.cameraBoundary = t;
      },
      setCameraBoundaryAnimated: function (t, e) {
        return this._impl.setCameraBoundaryAnimated(t, e);
      },
      get overlays() {
        return this._impl.overlays;
      },
      set overlays(t) {
        this._impl.overlays = t;
      },
      get selectedOverlay() {
        return this._impl.selectedOverlay;
      },
      set selectedOverlay(t) {
        this._impl.selectedOverlay = t;
      },
      addOverlay: function (t) {
        return this._impl.addOverlay(t);
      },
      addOverlays: function (t) {
        return this._impl.addOverlays(t);
      },
      removeOverlay: function (t) {
        return this._impl.removeOverlay(t);
      },
      removeOverlays: function (t) {
        return this._impl.removeOverlays(t);
      },
      topOverlayAtPoint: function (t) {
        return this._impl.topOverlayAtPoint(t);
      },
      overlaysAtPoint: function (t) {
        return this._impl.overlaysAtPoint(t);
      },
      get annotations() {
        return this._impl.annotations;
      },
      set annotations(t) {
        this._impl.annotations = t;
      },
      get selectedAnnotation() {
        return this._impl.selectedAnnotation;
      },
      set selectedAnnotation(t) {
        this._impl.selectedAnnotation = t;
      },
      addAnnotation: function (t) {
        return this._impl.addAnnotation(t);
      },
      addAnnotations: function (t) {
        return this._impl.addAnnotations(t);
      },
      removeAnnotation: function (t) {
        return this._impl.removeAnnotation(t);
      },
      removeAnnotations: function (t) {
        return this._impl.removeAnnotations(t);
      },
      showItems: function (t, e) {
        return this._impl.showItems(t, e);
      },
      addItems: function (t) {
        return this._impl.addItems(t);
      },
      removeItems: function (t) {
        return this._impl.removeItems(t);
      },
      annotationsInMapRect: function (t) {
        return this._impl.annotationsInMapRect(t);
      },
      updateSize: function (t) {
        return this._impl.updateSize(t);
      },
      convertCoordinateToPointOnPage: function (t) {
        return this._impl.convertCoordinateToPointOnPage(t);
      },
      convertPointOnPageToCoordinate: function (t) {
        return this._impl.convertPointOnPageToCoordinate(t);
      },
      get showsUserLocation() {
        return this._impl.showsUserLocation;
      },
      set showsUserLocation(t) {
        this._impl.showsUserLocation = t;
      },
      get userLocationAnnotation() {
        return this._impl.userLocationAnnotation;
      },
      get tracksUserLocation() {
        return this._impl.tracksUserLocation;
      },
      set tracksUserLocation(t) {
        this._impl.tracksUserLocation = t;
      },
      get tintColor() {
        return this._impl.tintColor;
      },
      set tintColor(t) {
        this._impl.tintColor = t;
      },
      destroy: function () {
        this._impl.destroy();
      },
      get annotationForCluster() {
        return this._impl.annotationForCluster;
      },
      set annotationForCluster(t) {
        this._impl.annotationForCluster = t;
      },
      get selectableMapFeatures() {
        return this._impl.selectableMapFeatures;
      },
      set selectableMapFeatures(t) {
        this._impl.selectableMapFeatures = t;
      },
      get selectableMapFeatureSelectionAccessory() {
        return this._impl.selectableMapFeatureSelectionAccessory;
      },
      set selectableMapFeatureSelectionAccessory(t) {
        this._impl.selectableMapFeatureSelectionAccessory = t;
      },
      get annotationForMapFeature() {
        return this._impl.annotationForMapFeature;
      },
      set annotationForMapFeature(t) {
        this._impl.annotationForMapFeature = t;
      }
    })));
  const Ch = {
      MapInternal: wh,
      css: ".mk-map-view{width:100%;height:100%;overflow:hidden;-webkit-tap-highlight-color:transparent}.mk-map-view.mk-dragging-annotation{cursor:none}.mk-map-view.mk-disable-all-gestures{touch-action:none}.mk-map-view.mk-disable-pinch-gestures{touch-action:pan-x pan-y}.mk-map-view.mk-disable-zoom-gestures{touch-action:manipulation}.mk-map-view.mk-disable-pan-gestures{touch-action:none;touch-action:pinch-zoom}div.mk-map-view.mk-map-view img,div.mk-map-view.mk-map-view svg{margin:0;padding:0}.mk-annotation-container,.mk-map-view{z-index:0}.mk-map-view>*{position:absolute;left:0;-webkit-user-select:none;-moz-user-select:none}.mk-map-view .rt-root{letter-spacing:initial}.mk-map-view .mk-font-size-detector{position:absolute;height:1em;visibility:hidden;left:-100%;-webkit-text-size-adjust:none}.mk-controls-container{position:absolute;overflow:hidden;top:0;bottom:0;left:0;right:0;z-index:3;pointer-events:none}.mk-map-view .mk-annotation-container,.mk-map-view .mk-controls-container{-ms-user-select:text}.mk-map-view.mk-panning ::selection{background:0 0}.mk-map-view.mk-dragging-cursor{cursor:pointer;cursor:-moz-grabbing;cursor:-webkit-grabbing;cursor:grabbing}.mk-map-view>iframe{width:100%;height:100%;pointer-events:none;opacity:0;border:0}",
      utils: qn,
      mapkit: {
        FeatureVisibility: on,
        CoordinateRegion: Be,
        CoordinateSpan: Ze,
        Coordinate: We,
        BoundingRegion: Ke,
        MapPoint: He,
        MapRect: Ve,
        MapSize: je,
        Padding: ko,
        CameraZoomRange: qe,
        Map: bh,
        MapInternal: wh,
        get maps() {
          return wh.maps;
        },
        PointOfInterestCategory: mt,
        PointOfInterestFilter: yt.exposedConstructor,
        get filterIncludingAllCategories() {
          return yt.filterIncludingAllCategories;
        },
        get filterExcludingAllCategories() {
          return yt.filterExcludingAllCategories;
        },
        PlaceDetail: Ci,
        get placeDetails() {
          return bi;
        }
      }
    },
    kh = Ye.MapRect,
    Mh = Ye.CoordinateSpan,
    Sh = Ye.MapPoint,
    Lh = new Mh(0.001, 0.001),
    Ah = new ko(12, 12, 12, 12);
  function Eh(t) {
    ((this._map = t), (this._items = []));
  }
  ((Eh.checkShowItemsParameters = function (t, e) {
    return (
      u(t, "[MapKit] Map.showItems expects an array of items as its first parameter."),
      (e = p(e, "object")),
      Object.keys(e).forEach(function (t) {
        switch (t) {
          case "animate":
            break;
          case "padding":
            if (void 0 === e.padding) break;
            d(e.padding, ko, "[MapKit] Map.showItems expects a Padding object for `options.padding`.");
            break;
          case "minimumSpan":
            if (void 0 === e.minimumSpan) break;
            d(e.minimumSpan, Mh, "[MapKit] Map.showItems expects a CoordinateSpan for `options.minimumSpan`.");
            break;
          case "cameraDistance":
            if (void 0 === e.cameraDistance) break;
            c(e.cameraDistance, "number", "[MapKit] Map.showItems expects a number for `options.cameraDistance`.");
            break;
          default:
            console.warn("[MapKit] `" + t + "` is not a valid option of Map.showItems.");
        }
      }),
      e
    );
  }),
    (Eh.getRegionForItems = function (t, e, i) {
      let n = i.padding || Ah;
      const o = i.minimumSpan || Lh;
      let s = 0,
        a = 0,
        r = 0,
        l = 0;
      const h = [];
      for (let i = 0, n = e.length; i < n; ++i) {
        const n = e[i];
        if (n.map === t.public) {
          const t = n._impl._boundingRect || (n._impl.boundingRectAtScale && n._impl.boundingRectAtScale(1));
          if (t) {
            if (n._impl.style) {
              const t = n._impl.style._impl.halfStrokeWidthAtResolution();
              ((s = Math.max(s, t)), (a = Math.max(a, t)), (r = Math.max(r, t)), (l = Math.max(l, t)));
            }
            h.push(t);
          } else {
            n._impl.updateLayout(!0);
            const t = n._impl.delegate.paddingForAnnotation(n);
            ((s = Math.max(s, t.top)),
              (a = Math.max(a, t.right)),
              (r = Math.max(r, t.bottom)),
              (l = Math.max(l, t.left)),
              h.push(new kh(n._impl.x, n._impl.y, 0, 0)));
          }
        }
      }
      if (0 === h.length) return null;
      n = new ko(n.top + s, n.right + a, n.bottom + r, n.left + l);
      const c = (function (t, e) {
        const i = t.toCoordinateRegion();
        if (i.span.latitudeDelta >= e.latitudeDelta && i.span.longitudeDelta >= e.longitudeDelta) return t;
        ((i.span.latitudeDelta = Math.max(i.span.latitudeDelta, e.latitudeDelta)),
          (i.span.longitudeDelta = Math.max(i.span.longitudeDelta, e.longitudeDelta)));
        const n = i.span.latitudeDelta / 2,
          o = i.span.longitudeDelta / 2,
          s = new Sh(Ye.convertLongitudeToX(i.center.longitude - o), Ye.convertLatitudeToY(i.center.latitude + n)),
          a = new Sh(Ye.convertLongitudeToX(i.center.longitude + o), Ye.convertLatitudeToY(i.center.latitude - n));
        return (s.x > a.x && s.x--, new kh(s.x, s.y, Math.min(a.x - s.x, 1), a.y - s.y));
      })(
        wo(
          h.sort(function (t, e) {
            return t.minX() - e.minX();
          })
        ),
        o
      );
      return t.padMapRect(c, n, i.cameraDistance);
    }),
    (Eh.setRegionForItems = function (t, e, i) {
      if (t.ensureRenderingFrame().size.height <= 0 || t.ensureRenderingFrame().size.width <= 0) return !1;
      if (0 === e.length) return !0;
      const n = !!i.animate,
        o = Eh.getRegionForItems(t, e, i);
      return !o || (t.setVisibleMapRectAnimated(o, n), !0);
    }),
    (Eh.prototype = {
      constructor: Eh,
      _map: null,
      _selectedItem: null,
      _selectionDistance: 10,
      get node() {
        return this._node;
      },
      get items() {
        return this._items.filter(this.isItemExposed, this);
      },
      set items(t) {
        (u(
          t,
          "[MapKit] Map." +
            this.itemName +
            "s expected an array of " +
            this.itemName +
            "s, but got `" +
            t +
            "` instead."
        ),
          t.forEach(function (t, e) {
            d(
              t,
              this.itemConstructor,
              "[MapKit] Map." +
                this.itemName +
                "s expected an " +
                this.itemName +
                " at index " +
                e +
                ", but got `" +
                t +
                "` instead."
            );
          }, this),
          (t = t.filter(function (t) {
            return (
              !t.map ||
              t.map._impl === this._map ||
              (console.warn(
                "[MapKit] Map." + this.capitalizedItemName + "s: " + this.itemName + " is already in another map."
              ),
              !1)
            );
          }, this)));
        const e = [].concat(this._items);
        t = [].concat(
          this._items.filter((t) => !this.isItemExposed(t)),
          t
        );
        let i = 0,
          n = 0,
          o = !1;
        for (; i < t.length; )
          e[n] !== t[i]
            ? e[n] && -1 === t.indexOf(e[n])
              ? (this.removedItem(e[n], !0), (o = !0), n++)
              : (t[i].map && t[i].map._impl === this._map
                  ? e.splice(e.indexOf(t[i]), 1)
                  : (this.addedItem(t[i], !0), (o = !0)),
                i++)
            : (i++, n++);
        for (; n < e.length; ) (this.removedItem(e[n], !0), (o = !0), n++);
        ((t = t.filter((t) => t.map)), (this._items = t), o && this.manyItemsChanged(t, !0));
      },
      get selectedItem() {
        return this._selectedItem;
      },
      set selectedItem(t) {
        if (t !== this._selectedItem) {
          if (
            null != t &&
            (d(
              t,
              this.itemConstructor,
              "[MapKit] Map.selected" +
                this.capitalizedItemName +
                " expected an " +
                this.itemName +
                " or `null`, but got `" +
                t +
                "` instead."
            ),
            t.map !== this._map.public)
          )
            throw new Error(
              "[MapKit] Map.selected" +
                this.capitalizedItemName +
                " cannot be set to an " +
                this.itemName +
                " that is not in the map."
            );
          if (this._selectedItem) {
            const t = this._selectedItem;
            ((this._selectedItem = null),
              (t.selected = !1),
              (this._map.selectionMayChange = !1),
              t.dispatchEvent(new pt.Event("deselect")),
              delete this._map.selectionMayChange);
          }
          t &&
            ((this._selectedItem = t),
            (t.selected = !0),
            (this._map.selectionMayChange = !1),
            t.dispatchEvent(new pt.Event("select")),
            delete this._map.selectionMayChange);
        }
      },
      addItem: function (t, e) {
        return (
          d(
            t,
            this.itemConstructor,
            "[MapKit] Map.add" +
              this.capitalizedItemName +
              " expected an " +
              this.itemName +
              ", but got `" +
              t +
              "` instead."
          ),
          (t = this.addItemToList(t, !1, e)) && this.manyItemsAdded([t], !1),
          t
        );
      },
      addItems: function (t) {
        u(
          t,
          "[MapKit] Map.add" +
            this.capitalizedItemName +
            "s expected an array of " +
            this.itemName +
            "s, but got `" +
            t +
            "` instead."
        );
        const e = t.filter(function (t, e) {
          return (
            d(
              t,
              this.itemConstructor,
              "[MapKit] Map.add" +
                this.capitalizedItemName +
                "s expected an " +
                this.itemName +
                " at index " +
                e +
                ", but got `" +
                t +
                "` instead."
            ),
            !!this.addItemToList(t, !0)
          );
        }, this);
        return (e.length > 0 && this.manyItemsAdded(e, !0), e);
      },
      shouldAddItem: function (t, e) {
        return t.map
          ? (t.map._impl !== this._map &&
              console.warn(
                "[MapKit] Map." +
                  this.capitalizedItemName +
                  (e ? "s" : "") +
                  ": " +
                  this.itemName +
                  " is already in another map."
              ),
            !1)
          : !t._impl.isMapFeature ||
              (console.warn(
                "[MapKit] Map." +
                  this.capitalizedItemName +
                  (e ? "s" : "") +
                  ": " +
                  this.itemName +
                  " cannot be added to another map."
              ),
              !1);
      },
      removeItem: function (t) {
        return (
          d(
            t,
            this.itemConstructor,
            "[MapKit] Map.remove" +
              this.capitalizedItemName +
              " expected an " +
              this.itemName +
              ", but got `" +
              t +
              "` instead."
          ),
          this.isItemExposed(t)
            ? t.map !== this._map.public
              ? console.warn(
                  "[MapKit] Map.remove" +
                    this.capitalizedItemName +
                    ": cannot remove " +
                    this.itemName +
                    " as it is not attached to this map."
                )
              : this.removeAnyItem(t)
            : console.warn("[MapKit] Map.remove" + this.capitalizedItemName + ": cannot remove " + this.itemName),
          t
        );
      },
      removeAnyItem: function (t) {
        const e = this._items.indexOf(t);
        return (e >= 0 && (this._items.splice(e, 1), this.removedItem(t), this.manyItemsRemoved([t], !1)), t);
      },
      removeItems: function (t) {
        return (
          u(
            t,
            "[MapKit] Map.remove" +
              this.capitalizedItemName +
              "s expected an array of " +
              this.itemName +
              "s, but got `" +
              t +
              "` instead."
          ),
          t.forEach(function (t, e) {
            (d(
              t,
              this.itemConstructor,
              "[MapKit] Map.remove" +
                this.capitalizedItemName +
                "s expected an " +
                this.itemName +
                " at index " +
                e +
                ", but got `" +
                t +
                "` instead."
            ),
              this.isItemExposed(t)
                ? t.map !== this._map.public
                  ? console.warn(
                      "[MapKit] Map.remove" +
                        this.capitalizedItemName +
                        "s: cannot remove " +
                        this.itemName +
                        " at index " +
                        e +
                        " as it is not attached to this map."
                    )
                  : (t._impl._toBeRemoved = !0)
                : console.warn(
                    "[MapKit] Map.remove" +
                      this.capitalizedItemName +
                      "s: cannot remove " +
                      this.itemName +
                      " at index " +
                      e
                  ));
          }, this),
          (this._items = this._items.filter((t) => !t._impl._toBeRemoved)),
          t.forEach(function (t) {
            t._impl._toBeRemoved && (delete t._impl._toBeRemoved, this.removedItem(t, !0));
          }, this),
          t.length > 0 && this.manyItemsRemoved(t, !0),
          t
        );
      },
      enabledItemCloseToPoint: function (t, e) {
        return this._previousPointForPickingItem && this._previousPointForPickingItem.equals(t)
          ? (e || (this._closeItemIndex = (this._closeItemIndex + 1) % this._closeItems.length),
            this._closeItems[this._closeItemIndex])
          : ((this._previousPointForPickingItem = t),
            (this._closeItems = this._itemsCloseToPoint(t).filter((t) => t.enabled)),
            (this._closeItemIndex = !e && this._closeItems.length > 1 && this._closeItems[0].selected ? 1 : 0),
            this._closeItems[this._closeItemIndex]);
      },
      get selectionMayChange() {
        return !this._map || this._map.selectionMayChange;
      },
      addItemToList: function (t, e, i) {
        if (this.shouldAddItem(t, e))
          return (
            (void 0 === i || i < 0 || i > this._items.length) && (i = this._items.length),
            this._items.splice(i, 0, t),
            this.addedItem(t, e),
            t
          );
      },
      addedItem: function (t, e) {
        ("function" == typeof t._impl.setDelegate ? t._impl.setDelegate(this) : (t._impl.delegate = this),
          t._impl.addedToMap && t._impl.addedToMap());
      },
      manyItemsAdded: function (t, e) {},
      removedItem: function (t) {
        ((t.selected = !1), delete t._impl.delegate, t._impl.removedFromMap && t._impl.removedFromMap());
      },
      manyItemsRemoved: function (t, e) {},
      manyItemsChanged: function (t, e) {},
      mapWasDestroyed: function () {
        (delete this._map, this.removedReferenceToMap());
      },
      _node: null,
      _deletePreviousPointForPickingItem: function () {
        (delete this._previousPointForPickingItem, delete this._closeItems, delete this._closeItemIndex);
      },
      _itemsCloseToPoint: function (t) {
        const e = this._items.filter((t) => t._impl.canBePicked());
        return 0 === e.length ? [] : this.pickableItemsCloseToPoint(e, t);
      }
    }));
  const xh = Eh;
  function Th(t) {
    (so.call(this), (this._controller = t));
  }
  Th.prototype = r(so, Th, {
    stringInfo: function () {
      return "OverlaysControllerNode";
    }
  });
  const Ih = Th,
    Rh = ["visible", "enabled", "selected", "data"];
  function Oh(t, e, i) {
    ((this._node = t),
      (this._public = e),
      (i = p(i)),
      Rh.forEach(function (t) {
        void 0 !== i[t] && (this[t] = i[t]);
      }, this),
      Object.keys(i).forEach(function (t) {
        Rh.indexOf(t) < 0 &&
          console.warn("[MapKit] Unknown option: " + t + ". Use the data property to store custom data.");
      }));
  }
  Oh.prototype = {
    constructor: Oh,
    delegate: null,
    _map: null,
    _visible: !0,
    _enabled: !0,
    _selected: !1,
    get map() {
      return this._map;
    },
    set map(t) {
      console.warn("[MapKit] The `map` property of an overlay is read-only. Use map.addOverlay() instead.");
    },
    get data() {
      return (Object.prototype.hasOwnProperty.call(this, "_data") || (this._data = {}), this._data);
    },
    set data(t) {
      this._data = t;
    },
    get visible() {
      return this._visible;
    },
    set visible(t) {
      const e = !!t;
      this._visible !== e && ((this._visible = e), this.updatedProperty("visible"));
    },
    get enabled() {
      return this._enabled;
    },
    set enabled(t) {
      this._enabled = !!t;
    },
    get selected() {
      return this._selected;
    },
    set selected(t) {
      const e = !!t;
      if (e !== this._selected) {
        if (this.delegate && !this.delegate.selectionMayChange)
          return void console.warn("[MapKit] Selection may not change in select/deselect event handler.");
        ((this._selected = e), this.updatedProperty("selected"));
      }
    },
    get node() {
      return this._node;
    },
    canBePicked: function () {
      return this.shown && this._visible;
    },
    setMap: function (t) {
      t ? (this._map = t) : this._map && delete this._map;
    },
    handleEvent: function () {},
    updatedProperty: function (t) {
      this.delegate && this.delegate.overlayPropertyDidChange(this._public, t);
    },
    visibleAfterClipping: function (t, e, i, n, o) {
      this._node.shapes = [];
      const s = this.visibilityToleranceAtScale(i),
        a = this._boundingRect || this.boundingRectAtScale(i);
      if (!this.visible || a.maxY() + s < t.minY() || a.minY() - s > t.maxY()) return !1;
      const r = a.minX() - s,
        l = a.maxX() + s,
        h = r < 0 ? 1 : 0,
        c = 1 + h;
      for (let s = h - 1; s <= c; ++s) {
        const a = 0 === s ? t : new Ve(t.origin.x - s, t.origin.y, t.size.width, t.size.height);
        if (l >= a.minX() && r <= a.maxX()) {
          const t = this.clipOverlay(a, e, i, n, o);
          t.length > 0 && ((t.xOffset = s), this._node.shapes.push(t));
        }
      }
      return this._node.shapes.length > 0;
    },
    visibilityToleranceAtScale: function () {
      return 0;
    }
  };
  const Ph = Oh;
  function Dh(t) {
    Object.defineProperty(this, "_impl", {value: new Ph(null, this, t)});
  }
  ((Dh.Events = {Select: "select", Deselect: "deselect"}),
    (Dh.prototype = r(pt.EventTarget, Dh, {
      get map() {
        return this._impl.map;
      },
      set map(t) {
        this._impl.map = t;
      },
      get data() {
        return this._impl.data;
      },
      set data(t) {
        this._impl.data = t;
      },
      get visible() {
        return this._impl.visible;
      },
      set visible(t) {
        this._impl.visible = t;
      },
      get enabled() {
        return this._impl.enabled;
      },
      set enabled(t) {
        this._impl.enabled = t;
      },
      get selected() {
        return this._impl.selected;
      },
      set selected(t) {
        this._impl.selected = t;
      }
    })));
  const zh = Dh;
  function Nh() {
    this._overlays = [];
  }
  Nh.prototype = {
    constructor: Nh,
    fadeOverlayTo: function (t, e) {
      (Object.prototype.hasOwnProperty.call(t, "fadeInOutOpacity")
        ? (t.fadeInOutOpacity.durationMs = 350 * Math.abs(t.fadeInOutOpacity.value - t.fadeInOutOpacity.end))
        : ((t.fadeInOutOpacity = {durationMs: 350}), t.setFadeInOutOpacity(1 - e), this._overlays.push(t)),
        (t.fadeInOutOpacity.start = t.fadeInOutOpacity.value),
        (t.fadeInOutOpacity.end = e),
        (t.fadeInOutOpacity.startTime = Date.now()),
        Qt.scheduleASAP(this));
    },
    performScheduledUpdate: function () {
      const t = Date.now();
      ((this._overlays = this._overlays.filter(function (e) {
        return (
          e.setFadeInOutOpacity(
            a(
              e.fadeInOutOpacity.start +
                (e.fadeInOutOpacity.end - e.fadeInOutOpacity.start) *
                  ((t - e.fadeInOutOpacity.startTime) / e.fadeInOutOpacity.durationMs),
              0,
              1
            )
          ),
          e.fadeInOutOpacity.value !== e.fadeInOutOpacity.end || (delete e.fadeInOutOpacity, !1)
        );
      })),
        this._overlays.length > 0 && Qt.scheduleOnNextFrame(this));
    }
  };
  const Fh = Nh;
  function Uh(t) {
    (xh.call(this, t), (this._node = new Ih(this)), (this._fadeAnimationController = new Fh()));
  }
  ((Uh.Overlay = zh),
    (Uh.prototype = r(xh, Uh, {
      itemConstructor: zh,
      itemName: "overlay",
      capitalizedItemName: "Overlay",
      get map() {
        return this._map;
      },
      get userLocationAccuracyRingOverlay() {
        return this._userLocationAccuracyRingOverlay;
      },
      isItemExposed: function (t) {
        return t !== this._userLocationAccuracyRingOverlay;
      },
      removeUserLocationAccuracyRingOverlay: function () {
        this._userLocationAccuracyRingOverlay &&
          (this.removeAnyItem(this._userLocationAccuracyRingOverlay), delete this._userLocationAccuracyRingOverlay);
      },
      removedReferenceToMap: function () {
        this._items.forEach((t) => {
          t._impl.setMap(null);
        });
      },
      mapCameraDidChange: function () {
        0 !== this._items.length && (Qt.scheduleASAP(this), this._deletePreviousPointForPickingItem());
      },
      overlayPropertyDidChange: function (t, e) {
        switch (e) {
          case "selected":
            (t.selected ? (this.selectedItem = t) : (this.selectedItem = null),
              this._map.overlaySelectionDidChange(t),
              Qt.scheduleASAP(this));
            break;
          case "style":
          case "visible":
          case "geometry":
            Qt.scheduleASAP(this);
        }
      },
      fadeOverlayTo: function (t, e) {
        this._fadeAnimationController.fadeOverlayTo(t, e);
      },
      updateUserLocationAccuracyRingOverlay: function (t) {
        t.coordinate &&
          (this._userLocationAccuracyRingOverlay
            ? this._userLocationAccuracyRingOverlay.updateForUserLocation(t)
            : (this._userLocationAccuracyRingOverlay = this.addItem(new Uh.AccuracyRingOverlay(t))));
      },
      addedItem: function (t, e) {
        (xh.prototype.addedItem.call(this, t, e),
          t._impl.setMap(this._map.public),
          t.selected && (this.selectedItem = t),
          Qt.scheduleASAP(this));
      },
      removedItem: function (t) {
        (t._impl.setMap(null), xh.prototype.removedItem.call(this, t), Qt.scheduleASAP(this));
      },
      pickableItemsCloseToPoint: function (t, e, i) {
        const n = document.createElement("canvas", {willReadFrequently: !0}),
          o = n.getContext("2d"),
          s = (n.width = n.height = 1),
          a = this._map.camera,
          r = s / 2,
          l = e.x - r,
          h = e.y - r;
        o.translate(-l, -h);
        const c = "number" == typeof i ? i : this._selectionDistance / qn.devicePixelRatio;
        let d = !1;
        return t
          .filter(function (t) {
            return (
              !!t._impl.shown &&
              (d && (o.clearRect(l, h, n.width, n.height), (d = !1)),
              t._impl.node._renderer.render(o, a, c),
              (d = !0),
              !!o.getImageData(Math.floor(r), Math.floor(r), 1, 1).data[3])
            );
          }, this)
          .reverse();
      },
      performScheduledUpdate: function () {
        const t = this.map;
        if (!t) return;
        const e = t.camera.toRenderingMapRect(),
          i = t.worldSize,
          n = Math.ceil(s(i)),
          o = [],
          a = this._items;
        for (let s = 0, r = a.length; s < r; ++s) {
          const r = a[s];
          if (
            ((r._impl.shown = r._impl.visibleAfterClipping(e, !0, i, n, !0)),
            r === this._userLocationAccuracyRingOverlay)
          ) {
            const e = t.mapType,
              i = e === Xi.Satellite || e === Xi.Hybrid ? "satellite" : t.tint;
            this._userLocationAccuracyRingOverlay.updateIsShown(t.region, t.worldSize, i);
          }
          r._impl.shown && !r.selected && (o.push(r._impl.node), (r._impl.node.needsDisplay = !0));
        }
        const r = this.selectedItem;
        (r && r._impl.shown && (o.push(r._impl.node), (r._impl.node.needsDisplay = !0)), (this._node.children = o));
      }
    })),
    L.jsModules.AccuracyRingOverlay
      ? (Uh.AccuracyRingOverlay = L.jsModules.AccuracyRingOverlay)
      : L.addEventListener("load", function t(e) {
          e.jsModules.AccuracyRingOverlay &&
            ((Uh.AccuracyRingOverlay = e.jsModules.AccuracyRingOverlay), L.removeEventListener("load", t));
        }));
  const Gh = Uh;
  function Bh(t, e) {
    ((this.items = t), (this.data = e));
  }
  Bh.prototype = {
    constructor: Bh,
    get data() {
      return this._data;
    },
    set data(t) {
      this._data = t;
    },
    get items() {
      return this._items;
    },
    set items(t) {
      this._items = t instanceof Array ? t : null === t ? [] : [t];
    },
    getFlattenedItemList: function () {
      return this.items.reduce(function (t, e) {
        const i = "function" == typeof e.getFlattenedItemList ? e.getFlattenedItemList(e) : e;
        return t.concat(i);
      }, []);
    }
  };
  const Zh = Bh;
  function Wh(t, e) {
    Object.defineProperty(this, "_impl", {value: new Zh(t, e)});
  }
  Wh.prototype = {
    get data() {
      return this._impl.data;
    },
    set data(t) {
      this._impl.data = t;
    },
    get items() {
      return this._impl._items;
    },
    set items(t) {
      this._impl.items = t;
    },
    getFlattenedItemList: function () {
      return this._impl.getFlattenedItemList();
    }
  };
  const Kh = Wh,
    Hh = ["butt", "round", "square"],
    jh = ["miter", "round", "bevel"],
    Vh = ["nonzero", "evenodd"];
  let qh = 0;
  function Yh(t) {
    if (((this._offsets = [[0], [1]]), (this._indices = []), (this._lastUpdate = qh++), "object" == typeof t))
      for (const e in t) this.addColorStop(parseFloat(e), t[e]);
  }
  ((Yh.UPDATE_EVENT = "update-color-stop"),
    (Yh.prototype = r(M.EventTarget, Yh, {
      constructor: Yh,
      get offsets() {
        return this._offsets;
      },
      get indices() {
        return this._indices;
      },
      get lastUpdate() {
        return this._lastUpdate;
      },
      addColorStop: function (t, e) {
        if ("number" != typeof t || !(t >= 0 && t <= 1))
          throw new Error(
            "[MapKit] Expected a number between 0 and 1 for offset of LineGradient.addColorStop, but got `" +
              t +
              "` instead."
          );
        (c(
          e,
          "string",
          "[MapKit] Expected a string value for color in LineGradient.addColorStop, but got `" + e + "` instead."
        ),
          this._addColorStop(this._offsets, t, e));
      },
      addColorStopAtIndex: function (t, e) {
        if ("number" != typeof t || t < 0 || t % 1 != 0)
          throw new Error(
            "[MapKit] Expected a integer greater than or equal to 0 for index of LineGradient.addColorStopAtIndex, but got `" +
              t +
              "` instead."
          );
        (c(
          e,
          "string",
          "[MapKit] Expected a string value for color in LineGradient.addColorStopAtIndex, but got `" + e + "` instead."
        ),
          this._addColorStop(this._indices, t, e));
      },
      toString: function () {
        return "LineGradient";
      },
      _addColorStop: function (t, e, i) {
        const n = t.length;
        let o = 0;
        for (o = 0; o < n && t[o][0] < e; ) ++o;
        (o < n && t[o][0] === e ? (t[o][1] = i) : t.splice(o, 0, [e, i]),
          (this._lastUpdate = qh++),
          this.dispatchEvent(new M.Event(Yh.UPDATE_EVENT)));
      }
    })));
  const Xh = Yh;
  function $h(t) {
    bo(this, $h) && Object.defineProperty(this, "_impl", {value: new Xh(t)});
  }
  $h.prototype = {
    constructor: $h,
    addColorStop: function (t, e) {
      this._impl.addColorStop(t, e);
    },
    addColorStopAtIndex: function (t, e) {
      this._impl.addColorStopAtIndex(t, e);
    },
    toString: function () {
      return this._impl.toString();
    }
  };
  const Jh = $h;
  function Qh(t) {
    p(t);
    for (const e in t) {
      const i = Object.getOwnPropertyDescriptor(Qh.prototype, e);
      i && i.set ? (this[e] = t[e]) : console.warn("[MapKit] Style has no property named `" + e + "`, ignoring.");
    }
  }
  Qh.UPDATE_EVENT = "update-style";
  const tc = "rgb(0, 122, 255)";
  Qh.prototype = r(M.EventTarget, Qh, {
    _strokeColor: tc,
    _strokeOpacity: 1,
    _strokeStart: 0,
    _strokeEnd: 1,
    _lineWidth: 1,
    _lineCap: "round",
    _lineJoin: "round",
    _lineDash: [],
    _lineDashOffset: 0,
    _lineGradient: null,
    _fillColor: tc,
    _fillOpacity: 0.1,
    _fillRule: "nonzero",
    get strokeColor() {
      return this._strokeColor;
    },
    set strokeColor(t) {
      (null != t &&
        c(t, "string", "[MapKit] Expected a string value for Style.strokeColor, but got `" + t + "` instead."),
        this._strokeColor !== t && ((this._strokeColor = t), this._updated()));
    },
    get strokeOpacity() {
      return this._strokeOpacity;
    },
    set strokeOpacity(t) {
      c(t, "number", "[MapKit] Expected a number value for Style.strokeOpacity, but got `" + t + "` instead.");
      const e = a(t, 0, 1);
      this._strokeOpacity !== e && ((this._strokeOpacity = e), this._warnLineGradientComparability(), this._updated());
    },
    get strokeStart() {
      return this._strokeStart;
    },
    set strokeStart(t) {
      if ("number" != typeof t || !(t >= 0 && t <= 1))
        throw new Error(
          "[MapKit] Expected a number between 0 and 1 for Style.strokeStart, but got `" + t + "` instead."
        );
      this._strokeStart !== t && ((this._strokeStart = t), this._updated());
    },
    get strokeEnd() {
      return this._strokeEnd;
    },
    set strokeEnd(t) {
      if ("number" != typeof t || !(t >= 0 && t <= 1))
        throw new Error("[MapKit] Expected a number between 0 and 1 for Style.strokeEnd, but got `" + t + "` instead.");
      this._strokeEnd !== t && ((this._strokeEnd = t), this._updated());
    },
    get lineWidth() {
      return this._lineWidth;
    },
    set lineWidth(t) {
      c(t, "number", "[MapKit] Expected a number value for Style.lineWidth, but got `" + t + "` instead.");
      const e = Math.max(0, t);
      this._lineWidth !== e && ((this._lineWidth = e), this._updated());
    },
    get lineCap() {
      return this._lineCap;
    },
    set lineCap(t) {
      const e = Hh,
        i =
          "[MapKit] Expected one of " +
          e.map((t) => "`" + t + "`").join(", ") +
          " for Style.lineCap, but got `" +
          t +
          "` instead.";
      if ((c(t, "string", i), e.indexOf(t) < 0)) throw new TypeError(i);
      this._lineCap !== t && ((this._lineCap = t), this._warnLineGradientComparability(), this._updated());
    },
    get lineJoin() {
      return this._lineJoin;
    },
    set lineJoin(t) {
      const e = jh,
        i =
          "[MapKit] Expected one of " +
          e.map((t) => "`" + t + "`").join(", ") +
          " for Style.lineJoin, but got `" +
          t +
          "` instead.";
      if ((c(t, "string", i), e.indexOf(t) < 0)) throw new TypeError(i);
      this._lineJoin !== t && ((this._lineJoin = t), this._warnLineGradientComparability(), this._updated());
    },
    get lineDash() {
      return this._lineDash;
    },
    set lineDash(t) {
      (u(t, "[MapKit] Expected an array of numbers for Style.lineDash, but got `" + t + "` instead."),
        t.forEach(function (t, e) {
          c(
            t,
            "number",
            "[MapKit] Expected an array of numbers for Style.lineDash, but got `" + t + "` at index " + e + " instead."
          );
        }),
        (this._lineDash = t.slice()),
        this._warnLineGradientComparability(),
        this._updated());
    },
    get lineDashOffset() {
      return this._lineDashOffset;
    },
    set lineDashOffset(t) {
      (c(t, "number", "[MapKit] Expected a number value for Style.lineDashOffset, but got `" + t + "` instead."),
        this._lineDashOffset !== t && ((this._lineDashOffset = t), this._updated()));
    },
    get lineGradient() {
      return this._lineGradient;
    },
    set lineGradient(t) {
      (null !== t &&
        d(
          t,
          Jh,
          "[MapKit] Expected a LineGradient object value (or null) for Style.lineGradient, but got `" + t + "` instead."
        ),
        this._lineGradient !== t &&
          (this._lineGradient && this._lineGradient._impl.removeEventListener(Xh.UPDATE_EVENT, this),
          (this._lineGradient = t),
          this._lineGradient && this._lineGradient._impl.addEventListener(Xh.UPDATE_EVENT, this),
          this._warnLineGradientComparability(),
          this._updated()));
    },
    colorStopsForOverlay: function (t) {
      if (!this._lineGradient) return null;
      const e = this._lineGradient;
      return 0 === e._impl.indices.length ? e._impl.offsets : t.getColorStops(e._impl);
    },
    get fillColor() {
      return this._fillColor;
    },
    set fillColor(t) {
      (null != t &&
        c(t, "string", "[MapKit] Expected a string value for Style.fillColor, but got `" + t + "` instead."),
        this._fillColor !== t && ((this._fillColor = t), this._updated()));
    },
    get fillOpacity() {
      return this._fillOpacity;
    },
    set fillOpacity(t) {
      c(t, "number", "[MapKit] Expected a number value for Style.fillOpacity, but got `" + t + "` instead.");
      const e = a(t, 0, 1);
      this._fillOpacity !== e && ((this._fillOpacity = e), this._updated());
    },
    get fillRule() {
      return this._fillRule;
    },
    set fillRule(t) {
      const e = Vh,
        i =
          "[MapKit] Expected one of " +
          e.map((t) => "`" + t + "`").join(", ") +
          " for Style.fillRule, but got `" +
          t +
          "` instead.";
      if ((c(t, "string", i), e.indexOf(t) < 0)) throw new TypeError(i);
      this._fillRule !== t && ((this._fillRule = t), this._updated());
    },
    shouldStroke: function () {
      return (this.strokeColor || this.lineGradient) && this.strokeOpacity > 0 && this.lineWidth > 0;
    },
    shouldFill: function () {
      return this.fillColor && this.fillOpacity > 0;
    },
    halfStrokeWidthAtResolution: function () {
      return this.strokeColor && this.strokeOpacity > 0 ? (this.lineWidth / 2) * qn.devicePixelRatio : 0;
    },
    styleForHitTesting: function (t) {
      const e = Object.create(this);
      return (
        null != this._fillColor && ((e._fillColor = tc), (e._fillOpacity = 1)),
        (e._strokeColor = tc),
        (e._strokeOpacity = 1),
        (e._lineWidth = this.lineWidth + t),
        (e._impl = e),
        e
      );
    },
    toString: function () {
      return [
        "strokeColor",
        "strokeOpacity",
        "strokeStart",
        "strokeEnd",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "lineDash",
        "lineDashOffset",
        "lineGradient",
        "fillColor",
        "fillOpacity",
        "fillRule"
      ]
        .filter(function (t) {
          return Object.prototype.hasOwnProperty.call(this, "_" + t);
        }, this)
        .map(function (t) {
          return (
            t +
            ":" +
            (Array.isArray(this[t])
              ? JSON.stringify(this[t])
              : this.prop && this[t].toString
                ? this[t].toString()
                : this[t])
          );
        }, this)
        .join(",");
    },
    handleEvent: function (t) {
      t.type === Xh.UPDATE_EVENT && this._updated();
    },
    _warnLineGradientComparability: function () {
      if (!this.lineGradient) return;
      const t = [];
      (1 !== this.strokeOpacity && t.push("strokeOpacity"),
        "round" !== this.lineCap && t.push("lineCap"),
        "round" !== this.lineJoin && t.push("lineJoin"),
        0 !== this.lineDash.length && t.push("lineDash"),
        0 !== t.length &&
          (1 === t.length
            ? console.warn("[MapKit] lineGradient is incompatible with the following style property: " + t[0] + ".")
            : console.warn(
                "[MapKit] lineGradient is incompatible with the following style properties: " + t.join(", ") + "."
              )));
    },
    _updated: function () {
      this.dispatchEvent(new M.Event(Qh.UPDATE_EVENT));
    }
  });
  const ec = Qh;
  function ic(t) {
    bo(this, ic) && Object.defineProperty(this, "_impl", {value: new ec(t)});
  }
  ic.prototype = {
    constructor: ic,
    get strokeColor() {
      return this._impl.strokeColor;
    },
    set strokeColor(t) {
      this._impl.strokeColor = t;
    },
    get strokeOpacity() {
      return this._impl.strokeOpacity;
    },
    set strokeOpacity(t) {
      this._impl.strokeOpacity = t;
    },
    get strokeStart() {
      return this._impl.strokeStart;
    },
    set strokeStart(t) {
      this._impl.strokeStart = t;
    },
    get strokeEnd() {
      return this._impl.strokeEnd;
    },
    set strokeEnd(t) {
      this._impl.strokeEnd = t;
    },
    get lineWidth() {
      return this._impl.lineWidth;
    },
    set lineWidth(t) {
      this._impl.lineWidth = t;
    },
    get lineCap() {
      return this._impl.lineCap;
    },
    set lineCap(t) {
      this._impl.lineCap = t;
    },
    get lineJoin() {
      return this._impl.lineJoin;
    },
    set lineJoin(t) {
      this._impl.lineJoin = t;
    },
    get lineDash() {
      return this._impl.lineDash;
    },
    set lineDash(t) {
      this._impl.lineDash = t;
    },
    get lineDashOffset() {
      return this._impl.lineDashOffset;
    },
    set lineDashOffset(t) {
      this._impl.lineDashOffset = t;
    },
    get lineGradient() {
      return this._impl.lineGradient;
    },
    set lineGradient(t) {
      this._impl.lineGradient = t;
    },
    get fillColor() {
      return this._impl.fillColor;
    },
    set fillColor(t) {
      this._impl.fillColor = t;
    },
    get fillOpacity() {
      return this._impl.fillOpacity;
    },
    set fillOpacity(t) {
      this._impl.fillOpacity = t;
    },
    get fillRule() {
      return this._impl.fillRule;
    },
    set fillRule(t) {
      this._impl.fillRule = t;
    },
    toString: function () {
      return this._impl.toString();
    }
  };
  const nc = ic;
  function oc(t, e, i) {
    if (i) {
      i.style && (this.style = i.style);
      const t = {};
      (Object.keys(i).forEach(function (e) {
        "style" !== e && (t[e] = i[e]);
      }),
        (i = t));
    }
    Ph.call(this, t, e, i);
  }
  oc.prototype = r(Ph, oc, {
    constructor: oc,
    _fillable: !0,
    fadeInOutOpacity: {value: 1},
    get style() {
      return (
        this._style || ((this._style = new nc()), this._style._impl.addEventListener(ec.UPDATE_EVENT, this)),
        this._style
      );
    },
    set style(t) {
      if (this._style) {
        if (this._style === t) return;
        this._style._impl.removeEventListener(ec.UPDATE_EVENT, this);
      }
      (d(t, nc, "[MapKit] Expected a mapkit.Style value for Overlay.style, but got `" + t + "` instead."),
        this._style !== t &&
          ((this._style = t),
          this._style && this._style._impl.addEventListener(ec.UPDATE_EVENT, this),
          this.updatedProperty("style")));
    },
    visibilityToleranceAtScale: function (t) {
      return this.style._impl.halfStrokeWidthAtResolution() / t;
    },
    clipOverlay: function (t, e, i, n, o) {
      if (this._simplifiedShapeLevel !== n) {
        const t = Math.abs(this._simplifiedShapeLevel - n),
          e = !!this._hasPoints,
          i = this._simplifiedShape;
        ((this._simplifiedShape = this.simplifyShapeAtLevel(n)),
          (this._simplifiedShapeLevel = n),
          (this._hasPoints = this._simplifiedShape.length > 0),
          1 === t &&
            e !== this._hasPoints &&
            (this.delegate.fadeOverlayTo(this, e ? 0 : 1), e && (this.fadeInOutOpacity.previousShape = this.clip(i))));
      }
      const s =
        this.fadeInOutOpacity.previousShape ||
        (e || !this.clippedShape
          ? this.clip(this._simplifiedShape, t, this.style._impl.halfStrokeWidthAtResolution() / i)
          : this.clippedShape);
      return (o && (this.clippedShape = s), s);
    },
    setFadeInOutOpacity: function (t) {
      ((this.fadeInOutOpacity.value = t), this.updatedProperty("style"));
    },
    handleEvent: function (t) {
      t.type === ec.UPDATE_EVENT && this.updatedProperty("style");
    },
    fillPath: function (t, e) {
      (t.save(),
        (t.fillStyle = e.fillColor),
        (t.globalAlpha = e.fillOpacity * this.fadeInOutOpacity.value * this.node.opacity),
        t.fill(e.fillRule),
        t.restore());
    },
    strokePath: function (t, e, i, n) {
      (t.save(),
        (t.strokeStyle = n || e.strokeColor),
        (t.globalAlpha = e.strokeOpacity * this.fadeInOutOpacity.value * this.node.opacity));
      const o = i || qn.devicePixelRatio;
      ((t.lineWidth = e.lineWidth * o),
        e.lineDash.length > 0 &&
          "function" == typeof t.setLineDash &&
          (t.setLineDash(e.lineDash.map((t) => t * o)), (t.lineDashOffset = e.lineDashOffset * o)),
        (t.lineJoin = e.lineJoin),
        (t.lineCap = e.lineCap),
        t.stroke(),
        t.restore());
    },
    updateGeometry: function () {
      const t = this.calculateBoundingRect();
      t && ((this._boundingRect = t), this.updatedProperty("geometry"));
    }
  });
  const sc = oc;
  function ac(t) {
    Object.defineProperty(this, "_impl", {value: new sc(this, t)});
  }
  ac.prototype = r(zh, ac, {
    constructor: ac,
    get style() {
      return this._impl.style;
    },
    set style(t) {
      this._impl.style = t;
    }
  });
  const rc = ac;
  function lc(t) {
    (Hi.call(this), (this.overlay = t));
  }
  lc.prototype = r(Hi, lc, {});
  const hc = lc;
  function cc(t) {
    Jn.call(this, t);
  }
  cc.prototype = r(Jn, cc, {
    draw: function (t) {
      if (!this._node.overlay.map) return;
      const e = this._node.overlay.map._impl.camera;
      this.render(t, e);
    },
    render: function (t, e, i) {
      let n = this._node.overlay.style;
      "number" == typeof i && (n = n._impl.styleForHitTesting(i));
      const o = this._node.closed && n._impl.shouldFill(),
        s = n._impl.shouldStroke();
      (o || s) && this.drawShapes(t, n, o, s, e);
    },
    drawShapes: function (t, e, i, n, o) {
      e._impl.lineGradient && this._node.supportsLineGradient
        ? n && this.drawGradient(t, e, o)
        : (t.beginPath(),
          this._node.shapes.forEach(function (e) {
            e.forEach(function (i) {
              let n = o.transformMapPoint(new Mi(i[0].x + e.xOffset, i[0].y));
              t.moveTo(n.x, n.y);
              for (let s = 1, a = i.length; s < a; s++)
                ((n = o.transformMapPoint(new Mi(i[s].x + e.xOffset, i[s].y))), t.lineTo(n.x, n.y));
              this._node.closed && t.closePath();
            }, this);
          }, this),
          i && this._node.overlay.fillPath(t, e),
          n && this._node.overlay.strokePath(t, e, 1));
    },
    drawGradient: function (t, e, i) {
      const n = e._impl.colorStopsForOverlay(this._node.overlay);
      let o = 0;
      this._node.shapes.forEach(function (s) {
        s.forEach(function (a) {
          const r = [];
          let l;
          for (; a[0]._offset > n[o][0]; ) (++o, (l = n[o][0]));
          for (let t = 0, h = a.length; t < h; ) {
            const h = a[t]._offset,
              c = i.transformMapPoint(new Mi(a[t].x + s.xOffset, a[t].y));
            l = n[o][0];
            const d = dc.normalize(n[o][1] || e.strokeColor);
            if (h === l) (r.push([h, c, d]), ++t, ++o);
            else if (h < l) {
              const i = n[o - 1],
                s = i[0],
                a = i[1] || e.strokeColor,
                u = uc(pc(dc.stringToRGBA(a), dc.stringToRGBA(d), (h - s) / (l - s)));
              (r.push([h, c, u]), ++t);
            } else (r[r.length - 1].push([l, d]), ++o);
          }
          this.strokePathForLineEvents(t, r, e);
        }, this);
      }, this);
    },
    strokePathForLineEvents: function (t, e, i) {
      for (let n = 0, o = e.length - 1; n < o; ++n) {
        t.beginPath();
        const o = e[n],
          s = o[1],
          r = e[n + 1][1];
        (t.moveTo(s.x, s.y), t.lineTo(r.x, r.y));
        const l = t.createLinearGradient(s.x, s.y, r.x, r.y);
        if ((l.addColorStop(0, o[2]), o.length > 2)) {
          const t = o[0],
            s = e[n + 1][0] - t;
          for (let e = 3; e < o.length; ++e) l.addColorStop(a((o[e][0] - t) / s, 0, 1), o[e][1] || i.strokeColor);
        }
        (l.addColorStop(1, e[n + 1][2]), this._node.overlay.strokePath(t, i, 1, l));
      }
    }
  });
  const dc = {
    colorMap: {},
    normalize: function (t) {
      return uc(this.stringToRGBA(t));
    },
    stringToRGBA: function (t) {
      if (t in this.colorMap) return this.colorMap[t];
      if (!this.context) {
        const t = W();
        this.context = t.getContext("2d");
      }
      ((this.context.canvas.width = this.context.canvas.height = 1),
        (this.context.fillStyle = t),
        this.context.fillRect(0, 0, 1, 1));
      const e = this.context.getImageData(0, 0, 1, 1).data,
        i = [e[0], e[1], e[2], e[3]];
      return ((this.colorMap[t] = i), i);
    }
  };
  function uc(t) {
    return "rgba(" + t[0] + "," + t[1] + "," + t[2] + "," + t[3] + ")";
  }
  function pc(t, e, i) {
    const n = 1 - i;
    return [
      Math.round(t[0] * n + e[0] * i),
      Math.round(t[1] * n + e[1] * i),
      Math.round(t[2] * n + e[2] * i),
      Math.round(t[3] * n + e[3] * i)
    ];
  }
  const mc = cc;
  function gc(t, e, i) {
    (hc.call(this, t), (this._closed = !!e), (this._renderer = i || new mc(this)));
  }
  gc.prototype = r(hc, gc, {
    get closed() {
      return this._closed;
    }
  });
  const _c = gc,
    fc = 2 * Math.PI;
  function yc(t) {
    mc.call(this, t);
  }
  function vc(t, e, i, n, o, s, a) {
    t.beginPath();
    const r = e.transformMapPoint(new Mi(i.x + n, i.y));
    (s && (s += e.rotation), a && (a -= e.rotation), t.arc(r.x, r.y, o, s || 0, a || fc, !0));
  }
  yc.prototype = r(mc, yc, {
    drawShapes: function (t, e, i, n, o) {
      const s = this._node.overlay;
      this._node.shapes.forEach(function (a) {
        const r = a[0],
          l = s._mapRadius,
          h = l * o.worldSize;
        h < 0.5 ||
          this.drawClipped(t, e, i, n, o, r, l, a.xOffset) ||
          (vc(t, o, r, a.xOffset, h), i && s.fillPath(t, e), n && s.strokePath(t, e, 1));
      }, this);
    },
    drawClipped: function (t, e, i, n, o, s, a, r) {
      const l = o.toRenderingMapRect();
      if (!n || a < l.size.width || a < l.size.height) return !1;
      const h = e._impl.halfStrokeWidthAtResolution() / o.worldSize,
        c = l.minX() - h - r,
        d = l.maxX() + h - r,
        u = l.minY() - h,
        p = l.maxY() + h,
        m = s.x,
        g = s.y;
      function _(t, e) {
        const i = m - t,
          n = g - e;
        return i * i + n * n <= a * a;
      }
      const f = [];
      let y;
      _(d, p) && f.push(new He(d, p));
      const v = Math.acos((d - m) / a);
      if (!isNaN(v)) {
        let t = g + a * Math.sin(v);
        (t >= u && t <= p && ((y = new He(d, t)), (y.angle = v), f.push(y)),
          (t = g - a * Math.sin(v)),
          t >= u && t <= p && ((y = new He(d, t)), (y.angle = fc - v), f.push(y)));
      }
      _(d, u) && f.push(new He(d, u));
      const w = Math.asin((u - g) / a);
      if (!isNaN(w)) {
        let t = m + a * Math.cos(w);
        (t >= c && t <= d && ((y = new He(t, u)), (y.angle = (w + fc) % fc), f.push(y)),
          (t = m - a * Math.cos(w)),
          t >= c && t <= d && ((y = new He(t, u)), (y.angle = Math.PI - w), f.push(y)));
      }
      _(c, u) && f.push(new He(c, u));
      const b = Math.acos((c - m) / a);
      if (!isNaN(b)) {
        let t = g - a * Math.sin(b);
        (t >= u && t <= p && ((y = new He(c, t)), (y.angle = fc - b), f.push(y)),
          (t = g + a * Math.sin(b)),
          t >= u && t <= p && ((y = new He(c, t)), (y.angle = b), f.push(y)));
      }
      _(c, p) && f.push(new He(c, p));
      const C = Math.asin((p - g) / a);
      if (!isNaN(C)) {
        let t = m - a * Math.cos(C);
        (t >= c && t <= d && ((y = new He(t, p)), (y.angle = Math.PI - C), f.push(y)),
          (t = m + a * Math.cos(C)),
          t >= c && t <= d && ((y = new He(t, p)), (y.angle = (C + fc) % fc), f.push(y)));
      }
      const k = f.length;
      let M = 1;
      for (; k > 2 && M < k && (!isNaN(f[M - 1].angle) || isNaN(f[M].angle) || isNaN(f[(M + 1) % k].angle)); ) M += 1;
      if (M < k) {
        let l = (M + 1) % k;
        for (; k > 2 && !isNaN(f[l].angle) && !isNaN(f[(l + 1) % k].angle); ) l = (l + 1) % k;
        const h = a * o.worldSize,
          c = Math.abs(f[M].angle - f[l].angle),
          d = h * c - 2 * h * Math.sin(c / 2) > 0.001,
          u = o.transformMapPoint(new Mi(f[M].x + r, f[M].y)),
          p = o.transformMapPoint(new Mi(f[l].x + r, f[l].y));
        if (i) {
          d ? vc(t, o, s, r, h, f[M].angle, f[l].angle) : (t.beginPath(), t.moveTo(u.x, u.y), t.lineTo(p.x, p.y));
          for (let e = (l + 1) % k; isNaN(f[e].angle); e = (e + 1) % k) {
            const i = o.transformMapPoint(new Mi(f[e].x + r, f[e].y));
            t.lineTo(i.x, i.y);
          }
          this._node.overlay.fillPath(t, e);
        }
        n &&
          (d ? vc(t, o, s, r, h, f[M].angle, f[l].angle) : (t.beginPath(), t.moveTo(u.x, u.y), t.lineTo(p.x, p.y)),
          this._node.overlay.strokePath(t, e));
      } else
        k > 0 &&
          i &&
          ((t.fillStyle = e.fillColor),
          (t.globalAlpha = e.fillOpacity),
          t.fillRect(0, 0, l.size.width * o.worldSize, l.size.height * o.worldSize));
      return !0;
    }
  });
  const wc = yc;
  function bc(t) {
    _c.call(this, t, !0, new wc(this));
  }
  bc.prototype = r(_c, bc, {
    stringInfo: function () {
      const t = this.overlay;
      return (
        "CircleOverlayNode<radius:" +
        t.radius +
        "," +
        t.coordinate.toString().toLowerCase() +
        ">" +
        (t.style.toString() ? "[" + t.style + "]" : "")
      );
    }
  });
  const Cc = bc,
    kc = Ye.Coordinate,
    Mc = Ye.MapRect;
  function Sc(t, e, i, n) {
    (sc.call(this, new Cc(this), t, n), (this.coordinate = e), (this.radius = i));
  }
  function Lc() {
    return [this._coordinate.toMapPoint()];
  }
  Sc.prototype = r(sc, Sc, {
    get coordinate() {
      return this._coordinate;
    },
    set coordinate(t) {
      (d(t, kc, "[MapKit] CircleOverlayInternal.coordinate expected a Coordinate value, but got `" + t + "` instead."),
        (this._coordinate && this._coordinate.latitude === t.latitude && this._coordinate.longitude === t.longitude) ||
          ((this._coordinate = t.copy()), this.updateGeometry()));
    },
    get radius() {
      return this._radius;
    },
    set radius(t) {
      const e =
        "[MapKit] CircleOverlayInternal.radius expected a non-negative number (radius in meters), but got `" +
        t +
        "` instead.";
      (c(t, "number", e), t < 0 && console.warn(e));
      const i = Math.max(0, t);
      this._radius !== i && ((this._radius = i), this.updateGeometry());
    },
    calculateBoundingRect: function () {
      if (!this._coordinate || isNaN(this._radius)) return null;
      const t = (this._center = this._coordinate.toMapPoint()),
        e = (this._mapRadius = this._radius * Ye.mapUnitsPerMeterAtLatitude(this._coordinate.latitude));
      return new Mc(t.x - e, t.y - e, 2 * e, 2 * e);
    },
    simplifyShapeAtLevel: Lc,
    clip: Lc
  });
  const Ac = Sc;
  function Ec(t, e, i) {
    bo(this, Ec) && Object.defineProperty(this, "_impl", {value: new Ac(this, t, e, i)});
  }
  Ec.prototype = r(rc, Ec, {
    get coordinate() {
      return this._impl.coordinate;
    },
    set coordinate(t) {
      this._impl.coordinate = t;
    },
    get radius() {
      return this._impl.radius;
    },
    set radius(t) {
      this._impl.radius = t;
    }
  });
  const xc = Ec;
  function Tc(t) {
    _c.call(this, t, !1);
  }
  Tc.prototype = r(_c, Tc, {
    supportsLineGradient: !0,
    stringInfo: function () {
      const t = this.overlay;
      return (
        "PolylineOverlayNode<points:" +
        t.points.map((t) => t.toString()).join(",") +
        ">" +
        (t.style.toString() ? "[" + t.style + "]" : "")
      );
    }
  });
  const Ic = Tc,
    Rc = function (t, e) {
      const i = [];
      function n(t) {
        const e = i.length;
        ((t._index = e), i.push(t), s(e));
      }
      function o(t, e) {
        const n = i[t];
        return ((i[t] = i[e]), (i[e] = n), (i[t]._index = t), (i[e]._index = e), e);
      }
      function s(t) {
        for (; t > 0; ) {
          const e = Math.floor((t - 1) / 2);
          if (i[e]._area <= i[t]._area) return;
          t = o(t, e);
        }
      }
      function a(t) {
        for (;;) {
          const e = 2 * t + 1,
            n = 2 * t + 2,
            s = i[t]._area,
            a = i[e] ? i[e]._area : 1 / 0,
            r = i[n] ? i[n]._area : 1 / 0;
          if (s <= a && s <= r) return;
          t = o(t, a <= s && a <= r ? e : n);
        }
      }
      function r() {
        const t = i[0],
          e = i.pop();
        return (i.length > 0 && ((i[0] = e), (e._index = 0), a(0)), t);
      }
      function l(t) {
        const e = t._prev,
          i = t,
          n = t._next;
        return Math.abs((e.x - n.x) * (i.y - e.y) - (e.x - i.x) * (n.y - e.y)) / 2;
      }
      function h(t, e) {
        const i = t._area;
        ((t._area = Math.max(l(t), e)), t._area < i ? s(t._index) : a(t._index));
      }
      let c = t.length - 1,
        d = !1,
        u = !1;
      (e &&
        c > 1 &&
        (t[c].equals(t[0]) || (t.push(t[0].copy()), (d = !0), ++c), (u = !0), t.unshift(t[c - 1].copy()), ++c),
        (t[0]._area = t[c]._area = 1 / 0));
      for (let e = 1; e < c; ++e) {
        const i = t[e];
        ((i._prev = t[e - 1]), (i._next = t[e + 1]), (i._area = l(i)), n(i));
      }
      for (u && t.shift(), d && t.pop(); i.length > 0; ) {
        const t = r(),
          e = t._prev,
          i = t._next;
        (e._prev && ((e._next = i), h(e, t._area)),
          i._next && ((i._prev = e), h(i, t._area)),
          delete t._index,
          delete t._next,
          delete t._prev);
      }
    },
    Oc = function (t, e) {
      const i = 1 / (e * e),
        n = t.filter((t) => t._area > i);
      if (2 === n.length) {
        const t = n[0].x - n[1].x,
          e = n[0].y - n[1].y;
        if (t * t + e * e < 1 * i) return [];
      }
      return n;
    },
    Pc = Ye.Coordinate,
    Dc = Ye.MapRect;
  function zc(t, e, i) {
    (sc.call(this, new Ic(this), t, i), (this.points = e), this.updateGeometry());
  }
  function Nc(t, e, i) {
    const n = t[i];
    let o = null;
    for (let e = i - 1; !o; --e) void 0 !== t[e]._offset && (o = t[e]);
    let s = null;
    for (let e = i + 1; !s; ++e) void 0 !== t[e]._offset && (s = t[e]);
    const a = Math.sqrt(Math.pow(o.x - n.x, 2) + Math.pow(o.y - n.y, 2));
    t[i]._offset = Math.min(o._offset + a / e, s._offset);
  }
  function Fc(t, e, i, n, o) {
    let s,
      a = o.minX() - o.size.width;
    if (t.x < a) return ((s = (a - t.x) / i), Uc(a, (1 - s) * t.y + s * e.y, t, e, i, n));
    if (((a = o.maxX() + o.size.width), t.x > a))
      return ((s = (a - t.x) / i), Uc(a, (1 - s) * t.y + s * e.y, t, e, i, n));
    let r = o.minY() - o.size.height;
    return t.y < r
      ? ((s = (r - t.y) / n), Uc((1 - s) * t.x + s * e.x, r, t, e, i, n))
      : ((r = o.maxY() + o.size.height),
        t.y > r ? ((s = (r - t.y) / n), Uc((1 - s) * t.x + s * e.x, r, t, e, i, n)) : t);
  }
  function Uc(t, e, i, n, o, s) {
    const a = {x: t, y: e};
    if ("number" == typeof i._offset && "number" == typeof n._offset) {
      const r = Math.sqrt(o * o + s * s),
        l = Math.sqrt(Math.pow(t - i.x, 2) + Math.pow(e - i.y, 2));
      a._offset = i._offset + (n._offset - i._offset) * (l / r);
    }
    return a;
  }
  zc.prototype = r(sc, zc, {
    _fillable: !1,
    get points() {
      return this._points.slice();
    },
    set points(t) {
      (d(t, Array, "[MapKit] PolylineOverlay.points expected an array of Coordinates."),
        (this._points = t.slice()),
        (this._mapPoints = this._points.map(function (t, e) {
          return (
            d(t, Pc, "[MapKit] PolylineOverlay.points expected a Coordinate at index: " + e),
            t.toUnwrappedMapPoint()
          );
        })),
        (this._pointsNeedRemapping = !0),
        delete this._distances,
        delete this._colorStops,
        this.updateGeometry());
    },
    calculateBoundingRect: function () {
      if (0 === this._mapPoints.length) return new Dc(0, 0, 0, 0);
      const t = this._mapPoints.reduce(
          function (t, e) {
            return (
              e.x < t.xMin && (t.xMin = e.x),
              e.x > t.xMax && (t.xMax = e.x),
              e.y < t.yMin && (t.yMin = e.y),
              e.y > t.yMax && (t.yMax = e.y),
              t
            );
          },
          {xMin: 1 / 0, xMax: -1 / 0, yMin: 1, yMax: 0}
        ),
        e = t.xMax - t.xMin,
        i = o(t.xMin, 1);
      if (this._pointsNeedRemapping) {
        (delete this._pointsNeedRemapping,
          e > 1 &&
            console.warn("[MapKit] Polyline overlay spans over 360º in longitude and may not render correctly."));
        const n = t.xMin - i;
        (this._mapPoints.forEach((t) => {
          t.x -= n;
        }),
          Rc(this._mapPoints),
          delete this._simplifiedShapeLevel);
      }
      return new Dc(i, t.yMin, e, t.yMax - t.yMin);
    },
    simplifyShapeAtLevel: function (t) {
      delete this._distances;
      const e = this._simplifiedShapeLevel > t ? this._simplifiedShape : this._mapPoints;
      return Oc(e, Math.pow(2, t));
    },
    clip: function (t, e, i) {
      return (
        t.length > 0 && (t = this.clipShapeByStyleProperties(t)),
        !e || vo(e, this._boundingRect)
          ? 0 === t.length
            ? []
            : [t]
          : (function (t, e, i) {
              const n = e.minX() - i,
                o = e.minY() - i,
                s = e.maxX() + i,
                a = e.maxY() + i,
                r = 1e3 * e.size.width,
                l = 1e3 * e.size.height,
                h = [];
              let c, d;
              for (let i = 0, u = t.length; i < u - 1; ++i) {
                const u = t[i];
                d = t[i + 1];
                const p = d.x - u.x;
                let m, g;
                if (0 !== p) {
                  const t = (n - u.x) / p,
                    e = (s - u.x) / p;
                  g = !((t < 0 && e < 0) || (t > 1 && e > 1));
                } else g = u.x >= n && u.x <= s;
                if (g)
                  if (((m = d.y - u.y), 0 !== m)) {
                    const t = (o - u.y) / m,
                      e = (a - u.y) / m;
                    g = !((t < 0 && e < 0) || (t > 1 && e > 1));
                  } else g = u.y >= o && u.y <= a;
                const _ = Math.abs(p) > r || Math.abs(m) > l;
                g
                  ? (c || (c = []),
                    _ ? (c.push(Fc(u, d, p, m, e)), c.push(Fc(d, u, -p, -m, e)), h.push(c), (c = null)) : c.push(u))
                  : c &&
                    (_ ? (c.push(Fc(u, d, p, m, e)), c.push(Fc(d, u, -p, -m, e))) : c.push(u), h.push(c), (c = null));
              }
              return (c && (c.push(d), h.push(c)), h);
            })(t, e, i)
      );
    },
    clipShapeByStyleProperties: function (t) {
      const e = this.style.strokeStart,
        i = this.style.strokeEnd,
        n = this.style.lineGradient;
      if (0 !== e || 1 !== i || n) {
        if (!this._distances || (n && !this._colorStops)) {
          ((this._length = 0), (this._distances = []));
          const e = t.length;
          for (let i = 0; i < e - 1; ++i) {
            const e = t[i],
              n = t[i + 1],
              o = Math.sqrt(Math.pow(e.x - n.x, 2) + Math.pow(e.y - n.y, 2));
            ((this._length += o), this._distances.push(o));
          }
          if (n) {
            if (n._impl.indices.length > 0 && void 0 !== this._mapPoints[0]._offset)
              for (let t = 0, e = this._mapPoints.length; t < e; ++t) delete this._mapPoints[t]._offset;
            for (let i = 0, n = 0; i < e - 1; ++i) ((t[i]._offset = n / this._length), (n += this._distances[i]));
            e > 0 && (t[e - 1]._offset = 1);
          }
        }
        (0 === e && 1 === i) ||
          (t = (function (t, e, i, n) {
            if (i >= n) return [];
            let o = 0,
              s = !1;
            const a = [];
            let r;
            for (let l = 0, h = t.length; l < h - 1; ++l) {
              let h = t[l];
              r = t[l + 1];
              const c = e[l];
              if (((o += c), !s && o >= i)) {
                s = !0;
                const t = (o - i) / c;
                h = {
                  x: t * h.x + (1 - t) * r.x,
                  y: t * h.y + (1 - t) * r.y,
                  _offset: t * h._offset + (1 - t) * r._offset
                };
              }
              if (s && (a.push(h), o >= n)) {
                const t = (o - n) / c;
                r = {
                  x: t * h.x + (1 - t) * r.x,
                  y: t * h.y + (1 - t) * r.y,
                  _offset: t * h._offset + (1 - t) * r._offset
                };
                break;
              }
            }
            return (a.push(r), a);
          })(t, this._distances, e * this._length, i * this._length));
      }
      return t;
    },
    getColorStops: function (t) {
      if (!this._colorStops || this._colorStops.lastUpdate !== t.lastUpdate) {
        const e = t.offsets,
          i = t.indices;
        ((this._colorStops = e.slice()), (this._colorStops.lastUpdate = t.lastUpdate));
        let n = 0;
        const o = this._mapPoints.length;
        for (let t = 0, e = i.length; n < this._colorStops.length && t < e; ++n, ++t) {
          const e = i[t],
            s = e[0];
          if (!(s < o)) break;
          {
            void 0 === this._mapPoints[s]._offset && Nc(this._mapPoints, this._length, s);
            const t = this._mapPoints[s]._offset,
              i = e[1];
            for (; this._colorStops[n][0] < t; ) ++n;
            this._colorStops[n][0] === t ? (this._colorStops[n][1] = i) : this._colorStops.splice(n, 0, [t, i]);
          }
        }
      }
      return this._colorStops;
    }
  });
  const Gc = zc;
  function Bc(t, e) {
    bo(this, Bc) && Object.defineProperty(this, "_impl", {value: new Gc(this, t, e)});
  }
  Bc.prototype = r(rc, Bc, {
    get points() {
      return this._impl.points;
    },
    set points(t) {
      this._impl.points = t;
    }
  });
  const Zc = Bc;
  function Wc(t) {
    _c.call(this, t, !0);
  }
  Wc.prototype = r(_c, Wc, {
    stringInfo: function () {
      const t = this.overlay;
      return (
        "PolygonOverlayNode<points:" +
        t.points.map((t) => t.map((t) => t.toString()).join(",")).join("|") +
        ">" +
        (t.style.toString() ? "[" + t.style + "]" : "")
      );
    }
  });
  const Kc = Wc,
    Hc = Ye.Coordinate,
    jc = Ye.MapRect;
  function Vc(t, e, i) {
    (sc.call(this, new Kc(this), t, i), (this.points = e), this.updateGeometry());
  }
  Vc.prototype = r(sc, Vc, {
    get points() {
      return this._points.map((t) => t.slice());
    },
    set points(t) {
      (u(t, "[MapKit] PolygonOverlay.points expected an array of Coordinates."),
        Array.isArray(t[0]) || (t = [t]),
        (this._points = t.map(function (t, e) {
          return (u(t, "[MapKit] PolygonOverlay.points expected an array at index: " + e), t.slice());
        })),
        (this._polygons = this._points.map(function (t, e) {
          return t.map(function (t, i) {
            return (
              d(t, Hc, "[MapKit] PolygonOverlay.points expected a Coordinate at index: " + e + ", " + i),
              t.toUnwrappedMapPoint()
            );
          });
        })),
        this.updateGeometry());
    },
    calculateBoundingRect: function () {
      const t = (function (t) {
        const e = t
          .filter((t) => t.length > 2)
          .map(function (t) {
            const e = t.reduce(
              function (t, e) {
                return (
                  e.x < t.xMin && (t.xMin = e.x),
                  e.x > t.xMax && (t.xMax = e.x),
                  e.y < t.yMin && (t.yMin = e.y),
                  e.y > t.yMax && (t.yMax = e.y),
                  t
                );
              },
              {xMin: 1 / 0, xMax: -1 / 0, yMin: 1, yMax: 0}
            );
            return new jc(e.xMin, e.yMin, e.xMax - e.xMin, e.yMax - e.yMin);
          })
          .sort(function (t, e) {
            return t.minX() - e.minX();
          });
        return wo(e);
      })(this._polygons);
      return (
        delete this._simplifiedShapeLevel,
        t.size.width > 1 &&
          console.warn("[MapKit] Polygon overlay spans over 360º in longitude and may not render correctly."),
        this._polygons.forEach(function (e) {
          0 !== e.length &&
            (e.forEach(function (e) {
              const i = o(e.x, 1);
              e.x = i + (i < t.minX() ? 1 : 0);
            }),
            Rc(e, !0));
        }),
        t
      );
    },
    simplifyShapeAtLevel: function (t) {
      const e = this._simplifiedShapeLevel > t ? this._simplifiedShape : this._polygons,
        i = Math.pow(2, t);
      return e.reduce(function (t, e) {
        const n = Oc(e, i);
        return (n.length > 0 && t.push(n), t);
      }, []);
    },
    clip: function (t, e, i) {
      return !e || vo(e, this._boundingRect)
        ? t
        : (function (t, e, i) {
            const n = e.minX() - i,
              o = e.minY() - i,
              s = e.maxX() + i,
              a = e.maxY() + i,
              r = [];
            for (let e = 0, i = t.length; e < i; ++e) {
              const i = t[e],
                l = [];
              for (let t = 0, e = i.length; t < e; ++t) {
                const o = i[t],
                  s = i[(t - 1 + e) % e];
                if (o.x >= n) {
                  if (s.x < n) {
                    const t = (n - o.x) / (s.x - o.x);
                    l.push({x: n, y: (1 - t) * o.y + t * s.y});
                  }
                  l.push(o);
                } else if (s.x >= n) {
                  const t = (n - o.x) / (s.x - o.x);
                  l.push({x: n, y: (1 - t) * o.y + t * s.y});
                }
              }
              const h = [];
              for (let t = 0, e = l.length; t < e; ++t) {
                const i = l[t],
                  n = l[(t - 1 + e) % e];
                if (i.y >= o) {
                  if (n.y < o) {
                    const t = (o - i.y) / (n.y - i.y);
                    h.push({x: (1 - t) * i.x + t * n.x, y: o});
                  }
                  h.push(i);
                } else if (n.y >= o) {
                  const t = (o - i.y) / (n.y - i.y);
                  h.push({x: (1 - t) * i.x + t * n.x, y: o});
                }
              }
              const c = [];
              for (let t = 0, e = h.length; t < e; ++t) {
                const i = h[t],
                  n = h[(t - 1 + e) % e];
                if (i.x <= s) {
                  if (n.x > s) {
                    const t = (s - i.x) / (n.x - i.x);
                    c.push({x: s, y: (1 - t) * i.y + t * n.y});
                  }
                  c.push(i);
                } else if (n.x <= s) {
                  const t = (s - i.x) / (n.x - i.x);
                  c.push({x: s, y: (1 - t) * i.y + t * n.y});
                }
              }
              const d = [];
              for (let t = 0, e = c.length; t < e; ++t) {
                const i = c[t],
                  n = c[(t - 1 + e) % e];
                if (i.y <= a) {
                  if (n.y > a) {
                    const t = (a - i.y) / (n.y - i.y);
                    d.push({x: (1 - t) * i.x + t * n.x, y: a});
                  }
                  d.push(i);
                } else if (n.y <= a) {
                  const t = (a - i.y) / (n.y - i.y);
                  d.push({x: (1 - t) * i.x + t * n.x, y: a});
                }
              }
              d.length > 2 && r.push(d);
            }
            return r;
          })(t, e, i);
    }
  });
  const qc = Vc;
  function Yc(t, e) {
    bo(this, Yc) && Object.defineProperty(this, "_impl", {value: new qc(this, t, e)});
  }
  Yc.prototype = r(rc, Yc, {
    get points() {
      return this._impl.points;
    },
    set points(t) {
      this._impl.points = t;
    }
  });
  const Xc = Yc,
    $c = {
      OverlaysController: Gh,
      LayerItemsController: xh,
      ItemCollection: Kh,
      mapkit: {Style: nc, LineGradient: Jh, CircleOverlay: xc, PolylineOverlay: Zc, PolygonOverlay: Xc, TileOverlay: Ns}
    };
  function Jc(t) {
    ((this._map = t), (this.panning = !1));
  }
  Jc.prototype = {
    constructor: Jc,
    update: function (t, e) {
      if (!this._map.isScrollEnabled) return;
      const i = t._impl.translatedPosition(),
        n = i.x,
        o = n + e.size.width,
        s = i.y,
        a = s + e.size.height,
        r = this._map.ensureVisibleFrame();
      ((this._direction = new Mi()),
        n <= r.minX() ? (this._direction.x = 1) : o >= r.maxX() && (this._direction.x = -1),
        s <= r.minY() + 5 ? (this._direction.y = 1) : a >= r.maxY() - 5 && (this._direction.y = -1));
      const l = 0 !== this._direction.x || 0 !== this._direction.y;
      !this.panning && l
        ? ((this.panning = !0),
          (this._startTime = Date.now()),
          (this._initialSpeed = Math.floor(((1 / 104.1) * (r.size.width + r.size.height)) / 2)),
          Qt.scheduleOnNextFrame(this))
        : this.panning && !l && this.stop();
    },
    stop: function () {
      this.panning && ((this.panning = !1), delete this._direction, delete this._startTime, delete this._initialSpeed);
    },
    performScheduledUpdate: function () {
      if (!this.panning) return;
      let t = this._initialSpeed;
      const e = Date.now() - this._startTime;
      (e > 4e3 ? (t *= 3) : e > 1e3 && (t *= 1.5),
        this._map.translateCameraAnimated(new Mi(this._direction.x * t, this._direction.y * t), !1),
        this._map.panningDuringAnnotationDrag(),
        Qt.scheduleOnNextFrame(this));
    },
    mapWasDestroyed: function () {
      delete this._map;
    }
  };
  const Qc = Jc;
  function td(t) {
    (t && (this._public = t),
      (this._position = this._position ? this._position : new Mi()),
      (this._anchorPoint = this._anchorPoint ? this._anchorPoint : new Mi()),
      (this._anchorOffset = this._anchorOffset ? this._anchorOffset : new window.DOMPoint()));
  }
  td.prototype = {
    _shown: !0,
    _visible: !0,
    _position: void 0,
    _anchorPoint: void 0,
    _anchorOffset: void 0,
    _appearanceAnimation: "",
    renderedByDOMElement: !0,
    isMapFeature: !1,
    delegate: null,
    get node() {
      return this._node;
    },
    get element() {
      return this._element;
    },
    set element(t) {
      console.warn("[MapKit] The `element` property is read-only.");
    },
    get anchorOffset() {
      return this._anchorOffset;
    },
    set anchorOffset(t) {
      (d(t, window.DOMPoint, "[MapKit] Annotation.anchorOffset expected a DOMPoint, but got `" + t + "` instead."),
        (this._anchorOffset = new window.DOMPoint(t.x, t.y)),
        this.updatePosition());
    },
    get visible() {
      return this._visible;
    },
    set visible(t) {
      ((t = !!t), this._visible !== t && ((this._visible = t), this._updateVisibility()));
    },
    get appearanceAnimation() {
      return this._appearanceAnimation;
    },
    set appearanceAnimation(t) {
      if (
        (c(t, "string", "[MapKit] Annotation.appearanceAnimation expected a string, but got `" + t + "` instead."),
        "" === t)
      )
        return void (this._appearanceAnimation = this._appearanceAnimationName = "");
      const e = document.createElement("div");
      ((e.style.animation = t),
        (this._appearanceAnimationName = e.style.animationName),
        this._appearanceAnimationName
          ? (this._appearanceAnimation = t)
          : console.warn(
              "[MapKit] Annotation.appearanceAnimation expects an animation style value with an animation name, but got `" +
                t +
                "` instead."
            ));
    },
    nodePosition: function () {
      return this._nodePosition || this._node.position;
    },
    calculateNodePosition: function () {
      return new Mi(
        this._position.x - this._anchorPoint.x - this._anchorOffset.x,
        this._position.y - this._anchorPoint.y - this._anchorOffset.y
      );
    },
    updatePosition: function () {
      const t = this.calculateNodePosition();
      (!this.renderedByDOMElement && this.map && this.map._impl.cameraIsMoving
        ? (this._nodePosition = t)
        : (delete this._nodePosition, (this._node.position = t)),
        this.positionWasUpdated(t));
    },
    setShown: function (t) {
      ((t = !!t),
        this._shown !== t &&
          ((this._shown = t),
          this._node.element && this._node.classList.toggle("mk-hidden", !t),
          this.shownPropertyWasUpdated(t)));
    },
    shownPropertyWasUpdated: function () {},
    positionWasUpdated: function (t) {},
    isShown: function () {
      return this._shown;
    },
    position: function () {
      return this._position;
    },
    setPosition: function (t) {
      ((this._position = t), this.updatePosition());
    },
    updateVisibility: function (t) {
      this._node.classList.toggle("mk-invisible", t);
    },
    setSize: function (t) {
      ((this._node.size = t), (this._anchorPoint = new Mi(t.width / 2, t.height)), this.updatePosition());
    },
    _updateVisibility: function () {
      (!this._visible && this._animating) ||
        (this.updateVisibility(!this._visible),
        this.delegate && this.delegate.annotationPropertyDidChange(this._public || this, "visible"));
    }
  };
  const ed = td;
  function id() {
    Object.defineProperty(this, "_impl", {value: new ed(this)});
  }
  id.prototype = r(pt.EventTarget, id, {
    get element() {
      return this._impl.element;
    },
    set element(t) {
      this._impl.element = t;
    },
    get anchorOffset() {
      return this._impl.anchorOffset;
    },
    set anchorOffset(t) {
      this._impl.anchorOffset = t;
    },
    get animates() {
      return this._impl.animates;
    },
    set animates(t) {
      this._impl.animates = t;
    },
    get visible() {
      return this._impl.visible;
    },
    set visible(t) {
      this._impl.visible = t;
    },
    get appearanceAnimation() {
      return this._impl.appearanceAnimation;
    },
    set appearanceAnimation(t) {
      this._impl.appearanceAnimation = t;
    }
  });
  const nd = id,
    od = Ye.Coordinate;
  function sd(t) {
    ((this.displayLines = t.displayLines),
      t.id && ((this.id = t.id), (this.alternateIds = t.alternateIds || [])),
      t.muid && (this.muid = t.muid),
      t.location && (this.coordinate = new od(t.location.lat, t.location.lng)),
      (this._completionUrl = t.completionUrl),
      t.attribution &&
        ((this._providerId = t.attribution.vendorId), (this._providerItemId = t.attribution.externalItemId)),
      (this.name = t.name),
      (this.telephone = t.telephone),
      (this.urls = t.urls || []),
      (this.country = t.country),
      (this.administrativeArea = t.administrativeArea),
      (this.administrativeAreaCode = t.administrativeAreaCode),
      (this.locality = t.locality),
      (this.postCode = t.postCode),
      (this.subLocality = t.subLocality),
      (this.thoroughfare = t.thoroughfare),
      (this.subThoroughfare = t.subThoroughfare),
      (this.fullThoroughfare = t.fullThoroughfare),
      (this.areasOfInterest = t.areasOfInterest),
      (this.dependentLocalities = t.dependentLocalities),
      (this.timezone = t.timezone),
      (this.timezoneSecondsFromGmt = t.timezoneSecondsFromGmt));
  }
  sd.isConstructable = !1;
  const ad = function (t) {
    if (sd.isConstructable) return sd.call(this, t);
    throw new TypeError("[MapKit] SearchAutocompleteResult may not be constructed.");
  };
  sd.prototype = ad.prototype = {constructor: ad};
  const rd = sd,
    ld = (t, e, i) => {
      const n = [];
      for (let o = 0; o < t.length; o += 1) {
        let s = parseInt(t.charAt(o), e),
          a = 0;
        for (; s || a < n.length; ) ((s += (n[a] || 0) * e), (n[a] = s % i), (s = (s - n[a]) / i), (a += 1));
      }
      return n.reduce((t, e) => e.toString(i).toUpperCase() + t, "");
    },
    hd = (t, e) => (e ? `${t}${ld(e.toString(), 10, 16)}` : ""),
    cd = (t) => hd("G", t.protocolVersion) + hd("H", t.sourceId) + hd("I", t.muid),
    dd = (t) => {
      const e = {};
      let i = 0,
        n = 0;
      for (let o = 0; o <= t.length; o += 1) {
        const s = t.charCodeAt(o),
          a = isNaN(s) || (s >= 71 && s <= 90);
        (i !== n || a || (n = o), i !== n && a && ((e[t.substring(i, n)] = t.substring(n, o)), (i = o), (n = o)));
      }
      const o = e.I;
      return o
        ? {sourceId: e.H ? parseInt(e.H, 16) : 0, protocolVersion: e.G ? parseInt(e.G, 16) : 0, muid: ld(o, 16, 10)}
        : null;
    },
    ud = Object.freeze({
      Automatic: "automatic",
      Callout: "callout",
      FullCallout: "fullCallout",
      CompactCallout: "compactCallout",
      OpenInMaps: "openInMaps"
    });
  class pd {
    constructor({style: t} = {}) {
      ((this._impl = {}), (this.style = t || ud.Automatic));
    }
    get style() {
      return this._impl.style;
    }
    set style(t) {
      if (!l(t, ud))
        throw new Error(
          "[MapKit] value passed to `PlaceSelectionAccessory.style` must be a value of `PlaceSelectionAccessory.Styles` enum."
        );
      this._impl.style = t;
    }
  }
  pd.Styles = ud;
  const md = Ye.Coordinate,
    gd = Object.freeze({
      element: "ro",
      map: "ro",
      coordinate: "ro",
      id: "rw",
      place: "rw",
      title: "rw",
      subtitle: "rw",
      data: "rw",
      accessibilityLabel: "rw",
      anchorOffset: "rw",
      calloutOffset: "rw",
      size: "rw",
      callout: "rw",
      selectionAccessory: "rw",
      selectionAccessoryOffset: "rw",
      visible: "rw",
      enabled: "rw",
      selected: "rw",
      calloutEnabled: "rw",
      animates: "rw",
      appearanceAnimation: "rw",
      collisionMode: "rw",
      padding: "rw",
      draggable: "rw",
      displayPriority: "rw",
      clusteringIdentifier: "rw"
    }),
    _d = {DragStart: "drag-start", Dragging: "dragging", DragEnd: "drag-end"},
    fd = {Low: 250, High: 750, Required: 1e3},
    yd = {Rectangle: "rectangle", Circle: "circle", None: "none"};
  function vd(t) {
    function e(i, n, o, s) {
      if (
        ((this._calloutOffset = this._calloutOffset ? this._calloutOffset : new window.DOMPoint(0, 1)),
        (this._padding = this._padding ? this._padding : new ko()),
        (this._selectionAccessoryOffset = this._selectionAccessoryOffset
          ? this._selectionAccessoryOffset
          : new window.DOMPoint(0, 0)),
        t.call(this, i),
        p(s),
        (n instanceof ti || n instanceof rd) && (((s = s ? Object.create(s) : {}).place = n), (n = n.coordinate)),
        this._setCoordinate(n),
        (this._unsized = !0),
        (this.occluded = !1),
        this._setNode(n, o, s),
        s)
      ) {
        for (const [t, i] of Object.entries(this.ConstructorOptions))
          void 0 !== s[t] &&
            ("ro" !== i
              ? e.OptionSetters[t]
                ? e.OptionSetters[t].call(this, s[t])
                : (this[t] = s[t])
              : console.warn("[MapKit] `" + t + "` is read-only and can't be set on the Annotation."));
        Object.keys(s).forEach(function (t) {
          this.isAKnownOption(t) ||
            console.warn("[MapKit] Unknown option for annotation: " + t + " (use the `data` property instead)");
        }, this);
      }
      (fi.addEventListener(fi.Events.LocaleChanged, this), this.updateLocalizedText());
    }
    return (
      (e.Events = _d),
      (e.DisplayPriority = fd),
      (e.CollisionMode = yd),
      (e.prototype = r(t, e, {
        _calloutOffset: void 0,
        _enabled: !0,
        _selected: !1,
        _calloutEnabled: !0,
        _draggable: !1,
        _title: "",
        _subtitle: "",
        _accessibilityLabel: null,
        _displayPriority: fd.Required,
        _collisionMode: yd.Rectangle,
        _clusteringIdentifier: null,
        _sceneGraphNode: null,
        _padding: void 0,
        _draggingLift: 40,
        shouldHideLabels: !1,
        _callout: null,
        _selectionAccessory: null,
        _selectionAccessoryOffset: void 0,
        get map() {
          return this.delegate && this.delegate.mapForAnnotation(this._public);
        },
        set map(t) {
          console.warn("[MapKit] The `map` property is read-only.");
        },
        get coordinate() {
          return this._coordinate;
        },
        set coordinate(t) {
          this.memberAnnotations || this._setCoordinate(t);
        },
        get id() {
          return (this._place && this._place.id) || this._id;
        },
        set id(t) {
          this._id = t;
        },
        get place() {
          return this._place;
        },
        set place(t) {
          if (!(t instanceof ti || t instanceof rd))
            throw new TypeError("[MapKit] Expected a Place for Annotation.place, but got `" + t + "` instead");
          this._place = t;
        },
        get title() {
          return this._title;
        },
        set title(t) {
          (null != t
            ? (c(t, "string", "[MapKit] Expected a string value for Annotation.title, but got `" + t + "` instead"),
              (this._title = t))
            : delete this._title,
            this.updateLocalizedText(),
            this._updatedProperty("title"));
        },
        get subtitle() {
          return this._subtitle;
        },
        set subtitle(t) {
          (null != t
            ? (c(t, "string", "[MapKit] Expected a string value for Annotation.subtitle, but got `" + t + "` instead"),
              (this._subtitle = t))
            : delete this._subtitle,
            this.updateLocalizedText(),
            this._updatedProperty("subtitle"));
        },
        get accessibilityLabel() {
          return this._accessibilityLabel;
        },
        set accessibilityLabel(t) {
          (null != t
            ? (c(
                t,
                "string",
                "[MapKit] Expected a string value for Annotation.accessibilityLabel, but got `" + t + "` instead"
              ),
              (this._accessibilityLabel = t))
            : delete this._accessibilityLabel,
            this.updateLocalizedText());
        },
        get data() {
          return (Object.prototype.hasOwnProperty.call(this, "_data") || (this._data = {}), this._data);
        },
        set data(t) {
          this._data = t;
        },
        get enabled() {
          return this._enabled;
        },
        set enabled(t) {
          this._enabled = !!t;
        },
        get calloutEnabled() {
          return this._calloutEnabled;
        },
        set calloutEnabled(t) {
          this._calloutEnabled = !!t;
        },
        get selected() {
          return this._selected;
        },
        set selected(t) {
          const e = !!t;
          if (e !== this._selected) {
            if (this.delegate && !this.delegate.selectionMayChange)
              return void console.warn("[MapKit] Selection may not change in select/deselect event handler.");
            ((this._selected = e), this._updatedProperty("selected"));
          }
        },
        get animates() {
          return this._animates;
        },
        set animates(t) {
          this._animates = !!t;
        },
        get calloutOffset() {
          return this._calloutOffset;
        },
        set calloutOffset(t) {
          (d(t, window.DOMPoint, "[MapKit] Annotation.calloutOffset expected a DOMPoint, but got `" + t + "` instead."),
            (this._calloutOffset = new window.DOMPoint(t.x, t.y)),
            this._updatedProperty("calloutOffset"));
        },
        get callout() {
          return this._callout;
        },
        set callout(t) {
          (null !== t && c(t, "object", "[MapKit] Annotation.callout expected an object, but got `" + t + "` instead."),
            (this._callout = t));
        },
        get selectionAccessory() {
          return this._selectionAccessory;
        },
        set selectionAccessory(t) {
          if (!this.place && !this.muid)
            throw new Error(
              "[MapKit] Selection Accessory can only be set on an annotation with an associated `place`."
            );
          (null !== t &&
            d(
              t,
              pd,
              "[MapKit] The `selectionAccessory` parameter passed to `Annotation.selectionAccessory` is not a PlaceSelectionAccessory."
            ),
            (this._selectionAccessory = t));
        },
        get selectionAccessoryOffset() {
          return this._selectionAccessoryOffset;
        },
        set selectionAccessoryOffset(t) {
          (d(
            t,
            window.DOMPoint,
            "[MapKit] Annotation.selectionAccessoryOffset expected a DOMPoint, but got `" + t + "` instead."
          ),
            (this._selectionAccessoryOffset = new window.DOMPoint(t.x, t.y)),
            this._updatedProperty("selectionAccessoryOffset"));
        },
        get draggable() {
          return this._draggable;
        },
        set draggable(t) {
          this.memberAnnotations || this._setDraggable(t);
        },
        get draggingLift() {
          return this._draggingLift;
        },
        set draggingLift(t) {
          if (
            (c(t, "number", "[MapKit] Annotation.draggingLift expected a number, but got `" + t + "` instead."), t < 0)
          )
            throw new Error("[MapKit] Annotation.draggingLift must be zero or more.");
          this._draggingLift = t;
        },
        get size() {
          if ((this._updateSize(), !this._unsized)) return this._node.size.copy();
        },
        set size(t) {
          const e = "[MapKit] Annotation size expects a size object with width and height properties";
          (c(t, "object", e),
            c(t.width, "number", e),
            c(t.height, "number", e),
            this.setSize(new ki(t.width, t.height)),
            (this._userSetSize = !0),
            this.updateSize());
        },
        get opacity() {
          return this.sceneGraphNode ? this.sceneGraphNode.opacity : this.node.opacity;
        },
        set opacity(t) {
          this.sceneGraphNode ? (this.sceneGraphNode.opacity = t) : (this.node.opacity = t);
        },
        get displayPriority() {
          return this._displayPriority;
        },
        set displayPriority(t) {
          this.memberAnnotations || this._setDisplayPriority(t);
        },
        isRequired: function () {
          return this.selected || this.displayPriority === fd.Required;
        },
        get collisionMode() {
          return this._collisionMode;
        },
        set collisionMode(t) {
          if (!l(t, yd))
            throw new Error("[MapKit] Unknown value for `collisionMode`. Choose from Annotation.CollisionMode.");
          t !== this._collisionMode && ((this._collisionMode = t), this._updatedProperty("collisionMode"));
        },
        get clusteringIdentifier() {
          return this._clusteringIdentifier;
        },
        set clusteringIdentifier(t) {
          this.memberAnnotations || this._setClusteringIdentifier(t);
        },
        get padding() {
          return this._padding.copy();
        },
        set padding(t) {
          (d(t, ko, "[MapKit] The `padding` parameter passed to `Annotation.padding` is not a Padding."),
            this._padding.equals(t) || ((this._padding = t.copy()), this._updatedProperty("padding")));
        },
        get needsLayout() {
          return this._sceneGraphNode && this._sceneGraphNode.needsLayout;
        },
        get elementInAnnotationDOM() {
          return this._node.element.firstChild;
        },
        getMuidList() {
          const t = [],
            e = this.id,
            i = e ? dd(e) : null,
            n = (i && i.muid) || (this.place && this.place.muid) || this._muid;
          n && t.push(n);
          const o = (this.place && this.place.alternateIds) || [];
          for (const e of o) {
            const i = e ? dd(e) : null;
            i && i.muid && t.push(i.muid);
          }
          return t;
        },
        centerOffsetForSelectionAccessory() {
          const t = this.size;
          return new Mi(-t.width / 2, -t.height / 2);
        },
        removedFromMap: function () {
          ((this._removedFromMap = !0),
            fi.removeEventListener(fi.Events.LocaleChanged, this),
            this._occludedAnimation && this._occludedAnimation.end(),
            this._clusteringAnimation && this._clusteringAnimation.end());
        },
        addedToMap: function () {
          this._removedFromMap &&
            ((this._removedFromMap = !1),
            fi.addEventListener(fi.Events.LocaleChanged, this),
            this.updateLocalizedText());
        },
        delegate: null,
        setDelegate: function (t) {
          this.delegate = t;
        },
        updateLayout: function () {},
        doesAnimate: function () {
          return this._animates && !!this._appearanceAnimationName;
        },
        willMoveToMap: function () {
          ((this._isMoving = this.doesAnimate()), this._updateSize());
        },
        didMoveToMap: function () {
          (this._isMoving &&
            this._appearanceAnimationName &&
            this._visible &&
            ((this.element.style.animation = this._appearanceAnimation),
            this.element.style.animationName &&
              ((this._animating = !0), this.element.addEventListener("animationend", this))),
            delete this._isMoving);
        },
        isStable: function () {
          return !(this.isWaiting || this._isMoving || this._isAnimating || this._isLifted);
        },
        canShowCallout: function () {
          return this._calloutEnabled && this.isStable();
        },
        canShowSelectionAccessory() {
          return this.isStable();
        },
        selectionAccessoryWillAppear: function () {},
        selectionAccessoryWillDisappear: function () {},
        canBePicked: function () {
          return (
            this._shown && this._visible && !this._isMoving && !this._isAnimating && !this._isLifted && !this.occluded
          );
        },
        draggingDidStart: function () {
          this._public.dispatchEvent(new pt.Event(_d.DragStart));
        },
        isDraggable: function () {
          return this.draggable && !this._isLifted;
        },
        isLifted: function () {
          return this._isLifted;
        },
        dispatchDraggingEvent: function () {
          const t = new pt.Event(e.Events.Dragging);
          return ((t.coordinate = this._coordinateDuringDrag()), this._public.dispatchEvent(t), t);
        },
        positionForCallout: function () {
          let t = this._calloutAnchorPoint;
          if (!t) {
            const e = this._userSetSize ? this._node.size : this.delegate.sizeForElement(this.elementInAnnotationDOM);
            t = new Mi(-e.width / 2, 0);
          }
          const e = this.nodePosition();
          return new Mi(e.x - t.x - this._calloutOffset.x, e.y - t.y - this._calloutOffset.y);
        },
        positionForSelectionAccessory: function (t, e) {
          const i = this.centerOffsetForSelectionAccessory();
          ((i.x -= this._selectionAccessoryOffset.x), (i.y -= this._selectionAccessoryOffset.y));
          const n = this.nodePosition(),
            o = this.size;
          let s;
          switch (t) {
            case "top":
              s = new Mi(i.x, e);
              break;
            case "left":
              s = new Mi(e, i.y);
              break;
            case "right":
              s = new Mi(-o.width - e, i.y);
              break;
            case "bottom":
              s = new Mi(i.x, -o.height - e);
          }
          return new Mi(n.x - s.x, n.y - s.y);
        },
        setDraggingTranslationForMapFrameSize: function (t, e) {
          this._dragController.setTranslation(this.clampDraggingTranslationForMapFrameSize(t, e));
        },
        dropAfterDraggingAndRevertPosition: function (t) {
          this._dragController.dropAnnotationAfterDraggingAndRevertPosition(t);
        },
        distanceToPoint: function (t) {
          const e = this._node.position.x,
            i = e + this._node.size.width,
            n = e - t.x,
            o = i - t.x,
            s = n <= 0 && o >= 0 ? 0 : Math.min(Math.abs(n), Math.abs(o)),
            a = this._node.position.y,
            r = a + this._node.size.height,
            l = a - t.y,
            h = r - t.y,
            c = l <= 0 && h >= 0 ? 0 : Math.min(Math.abs(l), Math.abs(h));
          return s * s + c * c;
        },
        lift: function () {
          ((this._isLifted = !0), this._dragController.lift(this._draggingLift), this._updatedProperty(""));
        },
        translate: function (t, e) {
          this.sceneGraphNode
            ? (this.sceneGraphNode.transform = new Li().translate(t, e))
            : (this._node.transform = new mn().translate(t, e));
        },
        translatedPosition: function () {
          const t = this._dragController.getTranslation();
          return new Mi(
            this._position.x - this._anchorPoint.x - this._anchorOffset.x + t.x,
            this._position.y - this._anchorPoint.y - this._anchorOffset.y + t.y
          );
        },
        updatedPosition: function () {
          return this.coordinate
            ? ((this.x = Ye.convertLongitudeToX(Ye.wrapLongitude(this.coordinate.longitude))),
              (this.y = Ye.convertLatitudeToY(this.coordinate.latitude)),
              !0)
            : (this.setShown(!1), this.sceneGraphNode && this.sceneGraphNode.remove(), !1);
        },
        get sceneGraphNode() {
          return this._sceneGraphNode;
        },
        mayBeDrawn: function () {
          return !!this.sceneGraphNode && this._shown && this.visible && !this.isWaiting;
        },
        isDrawn: function () {
          return (!this.occluded || this._occludedAnimation) && this.mayBeDrawn();
        },
        animateOcclusion: function () {
          const t = this.occluded ? 0 : 1;
          this._sceneGraphNode &&
            (this._occludedAnimation && this._occludedAnimation.end(),
            (this._occludedAnimation = new fo.Opacity({
              node: this._sceneGraphNode,
              from: 1 - t,
              to: t,
              duration: 200,
              done: () => {
                delete this._occludedAnimation;
              }
            }).begin()));
          const e = this.occluded && this.cluster && this.cluster._impl && !this.cluster._impl.occluded,
            i = !this.occluded && this.previousCluster && !this.previousCluster._impl.wasOccluded;
          (e || i) && this._animateClustering();
        },
        positionWasUpdated: function (t) {
          this._sceneGraphNode && (this._sceneGraphNode.needsDisplay = !0);
        },
        dragOffset: Mi.Zero,
        handleEvent: function (t) {
          switch (t.type) {
            case fi.Events.LocaleChanged:
              this.updateLocalizedText();
              break;
            case "animationend":
              if (t.animationName !== this._appearanceAnimationName) return;
              ((this.element.style.animation = ""),
                this.element.removeEventListener("animationend", this),
                this.finishedAnimating());
          }
        },
        updateLocalizedText: function () {
          this._node && this._node.element && this._node.element.setAttribute("aria-label", this.altText());
        },
        altText: function () {
          return (
            this._accessibilityLabel ||
            (this.title && this.subtitle
              ? fi.get("Annotation.Generic.AccessibilityLabel", {title: this.title, subtitle: this.subtitle})
              : this.title || this.subtitle || "")
          );
        },
        updateSize: function () {
          (delete this._unsized,
            this._selected && this.delegate && this.delegate.selectedAnnotationDidMoveToMap(this._public));
        },
        clampDraggingTranslationForMapFrameSize: function (t, e) {
          const i = this._anchorPoint.x + this._anchorOffset.x - this._position.x,
            n = e.width - this._node.size.width + i,
            o = this._anchorPoint.y + this._anchorOffset.y + this._dragController.liftAmount - this._position.y,
            s = e.height - this._node.size.height + o;
          return new Mi(a(t.x, i, n), a(t.y, o, s));
        },
        droppedAfterLift: function () {
          (delete this._isLifted,
            this._selected && this.delegate && this.delegate.selectedAnnotationDidMoveToMap(this._public),
            this._updatedProperty(""));
        },
        draggingDidEnd: function () {
          ((this.coordinate = this._coordinateDuringDrag()),
            this.resetNodeTransform(),
            this._public.dispatchEvent(new pt.Event(e.Events.DragEnd)));
        },
        resetNodeTransform: function () {
          this.node.transform = new mn();
        },
        finishedAnimating: function () {
          (delete this._isAnimating,
            this._selected && this.delegate && this.delegate.selectedAnnotationDidMoveToMap(this._public),
            this._visible || this._updateVisibility(),
            this.delegate && this.delegate.annotationFinishedAnimating(this._public));
        },
        ConstructorOptions: gd,
        isAKnownOption: function (t) {
          return Object.keys(this.ConstructorOptions).includes(t);
        },
        _animateClustering: function () {
          if (this._sceneGraphNode) {
            const t = {
              annotation: this,
              node: this._sceneGraphNode,
              duration: 200,
              done: () => delete this._clusteringAnimation
            };
            this.cluster
              ? ((t.from = this.coordinate.toMapPoint()), (t.to = this.cluster.coordinate.toMapPoint()))
              : ((t.from = this.previousCluster.coordinate.toMapPoint()), (t.to = this.coordinate.toMapPoint()));
            const e = t.to.x - t.from.x;
            (e < -0.5 ? (t.to.x += 1) : e > 0.5 && (t.from.x += 1),
              this._clusteringAnimation && this._clusteringAnimation.end(),
              (this._clusteringAnimation = new wd(t).begin()));
          }
        },
        _setCoordinate: function (t) {
          (d(t, md, "[MapKit] Annotation.coordinate expected a Coordinate value."),
            delete this._translation,
            (this._coordinate = t.copy()),
            this._updatedProperty("coordinate"));
        },
        _setDraggable: function (t) {
          const e = !!t;
          e !== this._draggable && ((this._draggable = e), this._updatedProperty("draggable"));
        },
        _setDisplayPriority: function (t) {
          const e = "[MapKit] Annotation displayPriority expects a number between 0 and " + fd.Required;
          c(t, "number", e);
          const i = a(t, 0, fd.Required);
          if (i !== t) console.warn(e + ", value was normalized");
          else if (i === this._displayPriority) return;
          ((this._displayPriority = i), this._updatedProperty("displayPriority"));
        },
        _setClusteringIdentifier: function (t) {
          (null !== t && c(t, "string", "[MapKit] Annotation clusteringIdentifier expects a string"),
            this._clusteringIdentifier !== t &&
              ((this._clusteringIdentifier = t), this._updatedProperty("clusteringIdentifier")));
        },
        _coordinateDuringDrag: function () {
          const t = this.sceneGraphNode ? this._dragController.translation.x : 0,
            e = this.sceneGraphNode ? this._dragController.translation.y - this._dragController.liftAmount : 0,
            i = this.node.convertPointToPage(
              new Mi(
                t + this.dragOffset.x + this._anchorPoint.x + this.anchorOffset.x,
                e + this.dragOffset.y + this._anchorPoint.y + this.anchorOffset.y
              )
            );
          return this.delegate._map.convertPointOnPageToCoordinate(new window.DOMPoint(i.x, i.y));
        },
        _updateSize: function () {
          if (!this._unsized || this._userSetSize || !this.delegate) return;
          const t = this.delegate.sizeForElement(this.elementInAnnotationDOM);
          t && (delete this._unsized, this.setSize(t));
        },
        _updatedProperty: function (t) {
          this.delegate && this.delegate.annotationPropertyDidChange(this._public, t);
        }
      })),
      (e.OptionSetters = Object.freeze({
        draggable: e.prototype._setIsDraggable,
        displayPriority: e.prototype._setDisplayPriority,
        clusteringIdentifier: e.prototype._setClusteringIdentifier
      })),
      e
    );
  }
  function wd(t) {
    (fo.Basic.call(this, t), (this.annotation = t.annotation));
  }
  ((wd.prototype = r(fo.Basic, wd, {
    update: function (t) {
      const e = this.annotation;
      if (null == e.delegate) return;
      const i = e.delegate._map,
        n = i.camera.toRenderingMapRect(),
        o = Ye.wrapX((1 - t) * this.from.x + t * this.to.x, n.midX()),
        s = (1 - t) * this.from.y + t * this.to.y,
        a = i.adjustMapItemPoint(i.camera.transformMapPoint(new Mi(o, s)));
      this.node.transform = new Li().translate(a.x - e._position.x, a.y - e._position.y);
    },
    stringInfo: function () {
      return fo.Basic.prototype.stringInfo.call(this, "translation*");
    }
  })),
    (vd.Events = _d),
    (vd.DisplayPriority = fd),
    (vd.CollisionMode = yd));
  const bd = vd;
  function Cd(t) {
    this._annotation = t;
  }
  Cd.prototype = {
    liftDurationMs: 200,
    liftOpacity: 0.5,
    animateLift: function () {
      const t = Math.min((Date.now() - this._liftAnimationStartDate) / this.liftDurationMs, 1);
      (this._annotation.translate(this.translation.x, this.translation.y - this.liftAmount * t),
        (this._annotation.opacity = 1 - (1 - this.liftOpacity) * t),
        t < 1
          ? (Qt.scheduleOnNextFrame(this), (this._liftAnimationProgress = t))
          : (delete this._liftAnimationStartDate, delete this._liftAnimationProgress));
    },
    animateDropAfterLift: function () {
      const t = Math.max(
        this._dropAnimationStartP -
          Math.min((Date.now() - this._dropAfterLiftAnimationStartDate) / this.liftDurationMs, 1),
        0
      );
      (this._dropAnimationRevert && this._annotation.translate(0, -this.liftAmount * t),
        (this._annotation.opacity = 1 - (1 - this.liftOpacity) * t),
        t > 0 ? Qt.scheduleOnNextFrame(this) : this._annotation.droppedAfterLift());
    },
    dropAnnotationAfterDraggingAndRevertPosition: function (t) {
      (this._liftAnimationStartDate
        ? ((this._dropAnimationStartP = this._liftAnimationProgress),
          delete this._liftAnimationStartDate,
          delete this._liftAnimationProgress)
        : (this._dropAnimationStartP = 1),
        t ? this._annotation.resetNodeTransform() : this._annotation.draggingDidEnd(),
        (this._dropAfterLiftAnimationStartDate = Date.now()),
        (this._dropAnimationRevert = t),
        Qt.scheduleOnNextFrame(this));
    },
    lift: function (t) {
      ((this.liftAmount = t),
        (this.translation = new Mi()),
        t > 0
          ? ((this._liftAnimationStartDate = Date.now()),
            (this._liftAnimationProgress = 0),
            Qt.scheduleOnNextFrame(this))
          : (this._annotation.opacity = this.liftOpacity));
    },
    getTranslation: function () {
      return new Mi(this.translation.x, this.translation.y - this.liftAmount);
    },
    setTranslation: function (t) {
      ((this.translation = t),
        this._liftAnimationStartDate ||
          this._annotation.translate(
            this.translation.x + this._annotation.dragOffset.x,
            this.translation.y - this.liftAmount + this._annotation.dragOffset.y
          ));
    },
    performScheduledUpdate: function () {
      this._liftAnimationStartDate
        ? this.animateLift()
        : this._dropAfterLiftAnimationStartDate && this.animateDropAfterLift();
    }
  };
  const kd = Cd,
    Md = bd(ed);
  ((Md.prototype._animates = !0),
    (Md.prototype._setNode = function (t, e, i) {
      c(e, "function");
      const n = q(e, window, [t, i]);
      (G(n, "[MapKit] Annotation element factory must return a DOM element, got `" + n + "` instead."),
        (this._element = n));
      let o = n;
      if (qn.supportsShadowDOM) {
        const t = "mk-slot-" + Math.random().toString(32).substr(2, 8);
        ((n.slot = t), (o = qn.htmlElement("slot")), (o.name = t));
      }
      ((this._node = new Rn.Node(qn.htmlElement("div", o))),
        (this._node.wantsHardwareCompositing = this.renderedByDOMElement),
        this._dragController || (this._dragController = new kd(this)));
    }),
    (Md.div = function () {
      return document.createElement("div");
    }));
  const Sd = Md;
  function Ld(t, e, i) {
    bo(this, Ld) && Object.defineProperty(this, "_impl", {value: new Sd(this, t, e, i)});
  }
  ((Ld.EVENTS = bd.EVENTS),
    (Ld.DisplayPriority = bd.DisplayPriority),
    (Ld.CollisionMode = bd.CollisionMode),
    (Ld.prototype = r(nd, Ld, {
      get map() {
        return this._impl.map;
      },
      set map(t) {
        this._impl.map = t;
      },
      get coordinate() {
        return this._impl.coordinate;
      },
      set coordinate(t) {
        this._impl.coordinate = t;
      },
      get id() {
        return this._impl.id;
      },
      get title() {
        return this._impl.title;
      },
      set title(t) {
        this._impl.title = t;
      },
      get subtitle() {
        return this._impl.subtitle;
      },
      set subtitle(t) {
        this._impl.subtitle = t;
      },
      get accessibilityLabel() {
        return this._impl.accessibilityLabel;
      },
      set accessibilityLabel(t) {
        this._impl.accessibilityLabel = t;
      },
      get data() {
        return this._impl.data;
      },
      set data(t) {
        this._impl.data = t;
      },
      get enabled() {
        return this._impl.enabled;
      },
      set enabled(t) {
        this._impl.enabled = t;
      },
      get calloutEnabled() {
        return this._impl.calloutEnabled;
      },
      set calloutEnabled(t) {
        this._impl.calloutEnabled = t;
      },
      get selectionAccessory() {
        return this._impl.selectionAccessory;
      },
      set selectionAccessory(t) {
        this._impl.selectionAccessory = t;
      },
      get selectionAccessoryOffset() {
        return this._impl.selectionAccessoryOffset;
      },
      set selectionAccessoryOffset(t) {
        this._impl.selectionAccessoryOffset = t;
      },
      get selected() {
        return this._impl.selected;
      },
      set selected(t) {
        this._impl.selected = t;
      },
      get animates() {
        return this._impl.animates;
      },
      set animates(t) {
        this._impl.animates = t;
      },
      get calloutOffset() {
        return this._impl.calloutOffset;
      },
      set calloutOffset(t) {
        this._impl.calloutOffset = t;
      },
      get callout() {
        return this._impl.callout;
      },
      set callout(t) {
        this._impl.callout = t;
      },
      get draggable() {
        return this._impl.draggable;
      },
      set draggable(t) {
        this._impl.draggable = t;
      },
      get size() {
        return this._impl.size;
      },
      set size(t) {
        this._impl.size = t;
      },
      get displayPriority() {
        return this._impl.displayPriority;
      },
      set displayPriority(t) {
        this._impl.displayPriority = t;
      },
      get collisionMode() {
        return this._impl.collisionMode;
      },
      set collisionMode(t) {
        this._impl.collisionMode = t;
      },
      get clusteringIdentifier() {
        return this._impl.clusteringIdentifier;
      },
      set clusteringIdentifier(t) {
        this._impl.clusteringIdentifier = t;
      },
      get padding() {
        return this._impl.padding;
      },
      set padding(t) {
        this._impl.padding = t;
      }
    })));
  const Ad = Ld;
  function Ed(t) {
    Jn.call(this, t);
  }
  Ed.prototype = r(Jn, Ed, {
    pathForSquareDot: function (t, e) {
      const i = 0.6 * e,
        n = 0.4 * e;
      (t.moveTo(e, 0),
        t.lineTo(e + n, 0),
        t.arc(e + n, i, i, (Math.PI / 2) * 3, 0),
        t.lineTo(2 * e, e + n),
        t.arc(e + n, e + n, i, 0, Math.PI / 2),
        t.lineTo(i, 2 * e),
        t.arc(i, e + n, i, Math.PI / 2, Math.PI),
        t.lineTo(0, e - n),
        t.arc(i, i, i, Math.PI, (Math.PI / 2) * 3),
        t.lineTo(e, 0));
    }
  });
  const xd = Ed;
  let Td;
  const Id = ["default", "selected", "bubble"];
  let Rd = [],
    Od = " ",
    Pd = "default-loading";
  function Dd(t) {
    xd.call(this, t);
  }
  function zd(t, e, i, n) {
    (null == n && (n = e.glyphText), t.save(), (t.fillStyle = e.glyphColor));
    let o,
      s = i.glyphFontSize;
    do {
      ((t.font = s-- + "px " + an), (o = t.measureText(n).width));
    } while (o > i.glyphImageSize && s > 0);
    t.textBaseline = "alphabetic";
    const a = i.balloonRadius + 0.35 * s;
    let r;
    return (
      "1" === n
        ? ((t.textAlign = "left"), (r = i.balloonRadius - o / 2 - o / 16), t.fillText(n, r, a, i.glyphImageSize))
        : ((t.textAlign = "center"), t.fillText(n, i.balloonRadius, a, i.glyphImageSize)),
      t.restore(),
      s + 1
    );
  }
  function Nd() {
    const t = Math.min(qn.devicePixelRatio, 3),
      e = (t > 1 ? "_" + t + "x" : "") + ".png",
      i = {};
    let n = Id.length;
    function o() {
      (--n,
        0 === n &&
          ((Td = i),
          (Td.lifted = Td.default),
          (Od = ""),
          (Pd = "default"),
          Rd.forEach(function (t) {
            (t.freeze(), (t.needsDisplay = !0));
          }),
          (Rd = void 0)));
    }
    Id.forEach(function (t) {
      ((i[t] = {}),
        (function (t) {
          const n = new gs(I.Highest, {
            urlForImageLoader: oe.createImageUrl("pins/marker" + (t ? "-" : "") + t + e),
            loaderDidSucceed: function () {
              ((i[t] = n.image), o());
            },
            loaderDidFail: function () {
              (console.warn(
                "[MapKit] Error loading marker annotation image " +
                  n.url +
                  "; marker annotations may not display correctly."
              ),
                (Od = "?"),
                (Pd = "default-error"),
                o());
            }
          });
          ((n.crossOrigin = ms.getCorsAttribute(dt.distUrlWithCredentials)), n.schedule());
        })(t));
    });
  }
  ((Dd.loadMarkerResources = function () {
    Ud();
  }),
    (Dd.prototype = r(xd, Dd, {
      draw: function (t) {
        this._sharedLayer && (this._sharedLayer.renderer = this);
        const e = this._node,
          i = e.state,
          n = e.annotation,
          o = e.params;
        if (!n.balloonVisible) return;
        (!n.warnOnUnselectedGlyphImageAccess ||
          ("default" !== i && "lifted" !== i) ||
          console.warn("[MapKit] Unselected glyph image style is not available for this annotation."),
          delete this.glyphImageSrc,
          delete this.isTainted,
          delete this.renderType,
          t.save(),
          "bubble" !== o.style &&
            ((t.shadowOffsetY = o.shadowOffsetY * o.balloonRadius),
            (t.shadowBlur = o.shadowBlur),
            (t.shadowColor = o.shadowColor)));
        const s = "poi" === o.style;
        if ((t.beginPath(), "callout" === i)) this.drawDotUnderCallout(t, n.haloColor || n.fillColor, o.radius);
        else {
          if (
            (this.pathForBalloon(t, o.balloonRadius, o.style),
            s
              ? (t.fillStyle = n.haloColor || n.glyphColor)
              : n.isPlaceStyle && "selected" === i
                ? (t.fillStyle = n.haloColor || n.fillColor)
                : (t.fillStyle = n.fillColor),
            t.fill(),
            t.save(),
            s)
          ) {
            t.beginPath();
            const e = o.balloonRadius - o.borderWidth;
            (this.pathForMask(t, o.balloonRadius, e), (t.fillStyle = n.fillColor), t.fill());
          }
          t.restore();
        }
        if ((t.restore(), "callout" !== i))
          if ((delete this.glyphFontSize, n.glyphText))
            ((this.glyphFontSize = zd(t, n, o)), (this.renderType = "glyphText"));
          else {
            const [s, a] = (function (t, e, i, n, o, s) {
              let a,
                r = o ? 2 * n.balloonRadius : n.glyphImageSize,
                l = qn.roundToDevicePixel((e.size.width - r) / 2),
                h = !1;
              if (
                ((a = "default" === i || "lifted" === i ? e.glyphImage : e.selectedGlyphImage || e.glyphImage),
                !a && e.enablesDefaultGlyphImage)
              ) {
                if (Od) return (Ud(), Rd.indexOf(e) < 0 && Rd.push(e), zd(t, e.annotation, n, Od), [null, !1]);
                ((a = Td["bubble" === e.params.style ? "bubble" : i]),
                  (r = n.glyphImageSize),
                  (l = qn.roundToDevicePixel((e.size.width - r) / 2)),
                  (o = !1),
                  (h = !0));
              }
              try {
                let i;
                const c =
                  "poi" !== n.style &&
                  "default" !== n.style &&
                  e.annotation.haloColor &&
                  e.annotation.haloColor !== e.annotation.fillColor
                    ? e.annotation.fillColor
                    : void 0;
                return (
                  (i = o
                    ? (function (t, e, i, n, o) {
                        t._maskedPOIImage || (t._maskedPOIImage = []);
                        const s = qn.devicePixelRatio,
                          a = i * s;
                        if (!t._maskedPOIImage[a]) {
                          const i = (n * s) / 2,
                            r = W();
                          ((r.width = a), (r.height = a));
                          const l = r.getContext("2d");
                          (l.beginPath(),
                            o(l, a / 2, i),
                            e && ((l.fillStyle = e), l.fill()),
                            l.clip(),
                            l.drawImage(t, 0, 0, a, a),
                            (t._maskedPOIImage[a] = r));
                        }
                        return t._maskedPOIImage[a];
                      })(a, c, r, 2 * (n.balloonRadius - n.borderWidth), s)
                    : (function (t, e, i) {
                        (t._tinted || (t._tinted = {}), t._tinted[e] || (t._tinted[e] = []));
                        const n = i * qn.devicePixelRatio;
                        if (!t._tinted[e][n]) {
                          const i = W();
                          ((i.width = n), (i.height = n));
                          const o = i.getContext("2d");
                          ((o.fillStyle = e),
                            o.fillRect(0, 0, n, n),
                            (o.globalCompositeOperation = "destination-in"),
                            o.drawImage(t, 0, 0, n, n),
                            (t._tinted[e][n] = i));
                        }
                        return t._tinted[e][n];
                      })(a, e.annotation.glyphColor, r)),
                  t.drawImage(i, l, l, r, r),
                  h ? [null, !1] : [a.src, null === a.crossOrigin]
                );
              } catch (t) {
                return (e.glyphImageError(), [null, !1]);
              }
            })(t, e, i, o, n.isPlaceStyle, (t, e, i) => this.pathForMask(t, e, i));
            ((this.glyphImageSrc = s),
              (this.isTainted = a),
              (this.renderType = this.glyphImageSrc ? "glyphImage" : Pd));
          }
      },
      get isFallbackGlyphTextPending() {
        return !Td;
      },
      addPendingNode: function (t) {
        Rd.indexOf(t) < 0 && Rd.push(t);
      },
      get fallbackGlyphText() {
        return Od;
      },
      get rendererForSharedLayer() {
        return this._sharedLayer ? this._sharedLayer.renderer : this;
      },
      drawDotUnderCallout: function () {},
      pathForBalloon: function () {},
      pathForMask: function () {}
    })));
  let Fd = !1;
  function Ud() {
    Fd ||
      ((Fd = !0),
      dt.state !== dt.States.PENDING && dt.state !== dt.States.READY
        ? dt.addEventListener(dt.Events.Initialized, function t() {
            (dt.removeEventListener(dt.Events.Initialized, t), Nd());
          })
        : Nd());
  }
  const Gd = Dd;
  function Bd(t) {
    Gd.call(this, t);
  }
  Bd.prototype = r(Gd, Bd, {
    drawDotUnderCallout: function (t, e, i) {
      ((t.strokeStyle = e), (t.lineWidth = i), t.arc(i, i, i / 2, 0, 2 * Math.PI), t.stroke());
    },
    pathForBalloon: function (t, e, i) {
      switch (i) {
        case "balloon":
          (t.save(),
            t.scale(e / 256, e / 256),
            t.moveTo(327.439, 501.776),
            t.lineTo(327.525, 501.776),
            t.bezierCurveTo(301.142, 509.276, 279.265, 526.476, 266.881, 550.341),
            t.bezierCurveTo(263.709, 556.456, 261.65, 562.811, 255.956, 562.811),
            t.bezierCurveTo(250.262, 562.811, 248.204, 556.456, 245.03, 550.341),
            t.bezierCurveTo(232.648, 526.471, 210.771, 509.272, 184.388, 501.776),
            t.lineTo(184.561, 501.776),
            t.bezierCurveTo(77.943, 470.858, 0, 372.507, 0, 255.944),
            t.bezierCurveTo(0, 114.59, 114.615, 0, 256, 0),
            t.bezierCurveTo(397.385, 0, 512, 114.59, 512, 255.944),
            t.bezierCurveTo(512, 372.507, 434.057, 470.858, 327.439, 501.775),
            t.closePath(),
            t.restore());
          break;
        case "default": {
          const i = (e / 13.5) * 5,
            n = i / 6,
            o = i / 3,
            s = 2 * e,
            a = 0.448 * e,
            r = 0.385 * e;
          (t.moveTo(s, e),
            t.bezierCurveTo(s, 1.5 * e, s - r, s - i / 3, e + i / 2 + o, s),
            t.bezierCurveTo(e + i / 3, s + i / 3, e + n, s + i, e, s + i),
            t.bezierCurveTo(e - n, s + i, e - i / 3, s + i / 3, e - (i / 2 + o), s),
            t.bezierCurveTo(r, s - i / 3, 0, 1.5 * e, 0, e),
            t.bezierCurveTo(0, a, a, 0, e, 0),
            t.bezierCurveTo(s - a, 0, s, a, s, e),
            t.closePath());
          break;
        }
        default:
          t.arc(e, e, e, 0, 2 * Math.PI);
      }
    },
    pathForMask: function (t, e, i) {
      t.arc(e, e, i, 0, 2 * Math.PI);
    }
  });
  const Zd = Bd;
  function Wd(t) {
    Gd.call(this, t);
  }
  Wd.prototype = r(Gd, Wd, {
    drawDotUnderCallout: function (t, e, i) {
      ((t.fillStyle = e), this.pathForSquareDot(t, i), t.fill());
    },
    pathForBalloon: function (t, e, i) {
      (t.save(),
        t.scale(e / 256, e / 256),
        t.moveTo(424.278, 512.1),
        ("balloon" !== i && "default" !== i) ||
          (t.lineTo(363.104, 512.1),
          t.bezierCurveTo(302.97, 513.623, 278.509, 528.747, 266.778, 551.35),
          t.bezierCurveTo(263.607, 557.462, 261.548, 563.819, 255.857, 563.819),
          t.bezierCurveTo(250.167, 563.819, 248.107, 557.462, 244.937, 551.35),
          t.bezierCurveTo(233.205, 528.747, 208.743, 513.623, 148.61, 512.1)),
        t.lineTo(87.723, 512.1),
        t.bezierCurveTo(39.475, 512.099, 0, 472.713, 0, 424.573),
        t.lineTo(0, 87.525),
        t.bezierCurveTo(0, 39.387, 39.475, 0, 87.723, 0),
        t.lineTo(424.278, 0),
        t.bezierCurveTo(472.525, 0, 512, 39.387, 512, 87.525),
        t.lineTo(512, 424.573),
        t.bezierCurveTo(512, 472.713, 472.525, 512.099, 424.278, 512.099),
        t.closePath(),
        t.restore());
    },
    pathForMask: function (t, e, i) {
      t.save();
      const n = e - i;
      (t.translate(n, n),
        t.scale(i / 256, i / 256),
        t.moveTo(424.278, 512.1),
        t.lineTo(87.723, 512.1),
        t.bezierCurveTo(39.475, 512.099, 0, 472.713, 0, 424.573),
        t.lineTo(0, 87.525),
        t.bezierCurveTo(0, 39.387, 39.475, 0, 87.723, 0),
        t.lineTo(424.278, 0),
        t.bezierCurveTo(472.525, 0, 512, 39.387, 512, 87.525),
        t.lineTo(512, 424.573),
        t.bezierCurveTo(512, 472.713, 472.525, 512.099, 424.278, 512.099),
        t.closePath(),
        t.restore());
    }
  });
  const Kd = Wd,
    Hd = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
  function jd(t, e) {
    (Hi.call(this), (this.annotation = t), e && (this._state = e));
  }
  jd.prototype = r(Hi, jd, {
    delegate: null,
    enablesDefaultGlyphImage: !0,
    setDelegate: function (t) {
      this.delegate = t;
    },
    isTainted() {
      return this._renderer.isTainted;
    },
    stringInfo: function () {
      const t = this._renderer.rendererForSharedLayer,
        e = Hd(this, "_state") ? "<" + this.state + ">" : "",
        i = Hd(t, "glyphFontSize") ? ' "' + this.annotation.glyphText + '"@' + t.glyphFontSize : "",
        n = [];
      (this._renderer instanceof Kd && n.push("⏹"),
        this.annotation.balloonVisible || n.push("👻"),
        this.annotation.isAppStyle && n.push("⭕️"),
        this.annotation.isPlaceStyle && n.push("📍"));
      const o = n.length ? ` ${n.join(" ")}` : "",
        s = t.glyphImageSrc ? " 🖼 " + t.glyphImageSrc : "";
      return (
        "MarkerAnnotationBalloonNode" +
        e +
        "<color: " +
        this.annotation.fillColor +
        (this.annotation.haloColor ? "/" + this.annotation.haloColor : "") +
        ">" +
        i +
        s +
        o
      );
    },
    get state() {
      return Hd(this, "_state") ? this._state : this.delegate.state;
    },
    get params() {
      return this.delegate.getParamsFromState(this.state);
    },
    get layerBounds() {
      const t = Math.ceil(this.size.width / 2),
        e = Math.ceil(this.size.height / 4);
      return new Si(-t, -e, this.size.width + 2 * t, Math.ceil(1.5 * this.size.height) + e);
    },
    glyphImageError: function (t) {
      ("selected" === t && this.selectedGlyphImage ? delete this.selectedGlyphImage : delete this.glyphImage,
        (this.needsDisplay = !0));
    },
    setBalloonStyle: function () {
      if (this.annotation.useSquareBalloon) {
        if (this._renderer && this._renderer.constructor === Kd) return;
        this._renderer = new Kd(this);
      } else {
        if (this._renderer && this._renderer.constructor === Zd) return;
        this._renderer = new Zd(this);
      }
    },
    freeze: function () {
      if ("default" !== this.state && "lifted" !== this.state) return void (this.keyForFrozenLayer = "");
      const t = this.annotation;
      !t.glyph && this._renderer.isFallbackGlyphTextPending && this._renderer.addPendingNode(this);
      let e = t.fillColor;
      (t.haloColor && (e += "/" + t.haloColor),
        (this.keyForFrozenLayer =
          "balloon-" +
          [
            e,
            t.glyph ? t.glyph : this._renderer.fallbackGlyphText,
            t.glyphColor,
            t.useSquareBalloon ? "square" : ""
          ].join("-")),
        this.annotation.balloonVisible || (this.keyForFrozenLayer += "-nonvisible"),
        this.annotation.isPlaceStyle && (this.keyForFrozenLayer += "-place"),
        this.annotation.isAppStyle && (this.keyForFrozenLayer += "-app"));
    }
  });
  const Vd = jd;
  function qd(t) {
    xd.call(this, t);
  }
  qd.prototype = r(xd, qd, {
    draw: function (t) {
      const e = this._node;
      e.annotation.balloonVisible &&
        (t.save(),
        t.beginPath(),
        this.pathForDot(t, e.radius),
        (t.fillStyle = e.annotation.haloColor || e.annotation.fillColor),
        t.fill(),
        t.restore());
    },
    pathForDot: function () {}
  });
  const Yd = qd;
  function Xd(t) {
    Yd.call(this, t);
  }
  Xd.prototype = r(Yd, Xd, {
    pathForDot: function (t, e) {
      t.arc(e, e, e, 0, 2 * Math.PI);
    }
  });
  const $d = Xd;
  function Jd(t) {
    Yd.call(this, t);
  }
  Jd.prototype = r(Yd, Jd, {
    pathForDot: function (t, e) {
      this.pathForSquareDot(t, e);
    }
  });
  const Qd = Jd;
  function tu(t, e) {
    (Hi.call(this),
      (this.annotation = t),
      (this.radius = e),
      t.useSquareBalloon ? (this._renderer = new Qd(this)) : (this._renderer = new $d(this)));
  }
  tu.prototype = r(Hi, tu, {
    stringInfo: function () {
      const t = this._renderer instanceof Qd ? " ⏹" : "";
      return "MarkerAnnotationDotNode<color: " + this.annotation.fillColor + ">" + t;
    }
  });
  const eu = tu;
  function iu(t) {
    ((this._params = au()), Jn.call(this, t));
  }
  const nu = {
      title: {
        font: "600 11px " + an,
        fontWeight: 600,
        fontFamily: an,
        height: 16,
        fontSize: 11,
        lineHeight: 12,
        yPadding: 1
      },
      subtitle: {
        font: "500 10px " + an,
        fontWeight: 500,
        fontFamily: an,
        height: 15,
        fontSize: 10,
        lineHeight: 11,
        yPadding: 1
      }
    },
    ou = (t, e, i) => {
      const n = nu[t],
        o = n.fontFamily || an,
        s = n.fontWeight || 500,
        a = (n.fontSize || 11) * e,
        r = `${s} ${a}px ${o}`;
      if (i) {
        const t = (n.height || 16) * e,
          o = (n.lineHeight || 12) * e;
        ((i.weight = s), (i.fontSize = a), (i.height = t), (i.lineHeight = o), (i.font = r));
      }
      return r;
    },
    su = (t, e) => {
      for (const i in e) {
        const n = e[i];
        "object" == typeof n && i in nu && ou(i, t, n);
      }
    },
    au = () => {
      const t = {
        haloColor: {light: "rgba(255, 255, 255, .8)", dark: "black"},
        haloSize: 2,
        miterLimit: 2,
        textAlign: "center",
        title: Object.assign({}, nu.title, {color: {light: "#2b2b2b", dark: "#e7e6e4"}}),
        subtitle: Object.assign({}, nu.subtitle, {color: {light: "#4c4c4c", dark: "#e7e6e4"}})
      };
      return (su(1, t), t);
    };
  ((iu.prototype = r(Jn, iu, {
    _scale: 1,
    _params: void 0,
    get params() {
      const t = (this.node ? this.node.fontSizeRatio : 0) || this._scale;
      return (this.node && this._scale !== t && ((this._scale = t), su(this._scale, this._params)), this._params);
    },
    _setTextProperties: function (t) {
      const e = this._node,
        i = this.params[e.kind];
      ((t.font = i.font),
        (t.textAlign = this.params.textAlign),
        (t.textBaseline = "bottom"),
        (t.miterLimit = this.params.miterLimit));
    },
    draw: function (t) {
      const e = this._node,
        i = this.params[e.kind];
      this._setTextProperties(t);
      const n = e.parent.annotation.darkColorScheme ? "dark" : "light";
      ((t.fillStyle = i.color[n]), (t.strokeStyle = this.params.haloColor[n]), (t.lineWidth = this.params.haloSize));
      const o = e.size.width / 2,
        s = i.height - i.yPadding;
      (t.strokeText(e.text, o, s), t.fillText(e.text, o, s));
    }
  })),
    (iu.computeFont = ou));
  const ru = iu;
  function lu(t, e, i, n, o, s) {
    (Hi.call(this),
      (this.text = t),
      (this.kind = e),
      (this._renderer = new ru(this)),
      (this.textAscent = n.actualBoundingBoxAscent || 0),
      (this.textDescent = n.actualBoundingBoxDescent || 0));
    const a = this.textDescent > 0 ? Math.ceil(this.textDescent) : 0;
    ((this.fontSizeRatio = s),
      (this.size = new ki(i, this._renderer.params[this.kind].height + a)),
      (this.keyForFrozenLayer = (o ? "dark" : "light") + (1 !== s ? `-${s}` : "") + "-" + e + "#" + this.text));
  }
  lu.prototype = r(Hi, lu, {
    stringInfo: function () {
      return "MarkerAnnotationLabelNode<" + this.kind + '> "' + this.text + '"';
    },
    get fontSize() {
      return this._renderer.params[this.kind].fontSize;
    },
    get lineHeight() {
      return this._renderer.params[this.kind].lineHeight;
    }
  });
  const hu = lu,
    cu = 1e-12,
    du = {
      borderWidth: 1.5,
      labelOutlineWidth: 2,
      shadowColor: "rgba(0, 0, 0, .15)",
      shadowOffsetY: 0.5,
      innerShadowColor: "rgba(0, 0, 0, .35)",
      transitionDuration: 500,
      dotAnimationDuration: 100,
      dotScale: 1.5,
      anchorPointOffset: 0
    },
    uu = bu(du, {
      balloonRadius: 13.5,
      shadowBlur: 11.25,
      dotRadius: 0,
      glyphFontSize: 15,
      glyphImageSize: 20,
      offset: 0,
      style: "default",
      height: 32
    }),
    pu = bu(du, {
      borderWidth: 1.5,
      balloonRadius: 11.5,
      transitionDuration: 250,
      shadowBlur: 5,
      shadowOffsetY: 0,
      dotRadius: 0,
      glyphFontSize: 15,
      glyphImageSize: 16,
      offset: 0,
      style: "poi",
      height: 23,
      anchorPointOffset: -11.5
    }),
    mu = [];
  for (let t = 2; t <= 6; t++) {
    const e = 12 + 0.5 * t;
    mu[t] = bu(pu, {balloonRadius: e, height: 2 * e});
  }
  const gu = bu(du, {
      balloonRadius: 30,
      shadowBlur: 25,
      dotRadius: 3,
      glyphFontSize: 32,
      glyphImageSize: 40,
      offset: 8,
      style: "balloon",
      height: 66
    }),
    _u = bu(du, {radius: 4.5, shadowOffsetY: 0, shadowBlur: 0, shadowColor: "transparent"}),
    fu = bu(du, {
      balloonRadius: 20,
      dotRadius: 3,
      glyphFontSize: 28,
      glyphImageSize: 30,
      offset: 0,
      style: "bubble",
      height: 40
    });
  function yu(t) {
    (so.call(this), (this.annotation = t), (this._balloon = this.addChild(new Vd(t))), this._balloon.setDelegate(this));
  }
  let vu;
  ((yu.Params = {default: uu, lifted: uu, selected: gu, bubble: fu, callout: _u}),
    (yu.POIIconParams = bu(yu.Params, {default: pu, lifted: pu})),
    (yu.prototype = r(Hi, yu, {
      get position() {
        return this.annotation ? this.annotation.nodePosition() : new Mi();
      },
      stringInfo: function () {
        return "MarkerAnnotationNode" + ("default" !== this.state ? "<" + this.state + ">" : "");
      },
      get enablesDefaultGlyphImage() {
        return this._balloon.enablesDefaultGlyphImage;
      },
      set enablesDefaultGlyphImage(t) {
        this._balloon.enablesDefaultGlyphImage = t;
      },
      set needsLayout(t) {
        (t && !this._needsLayout && Qt.scheduleASAP(this), (this._needsLayout = t));
      },
      get needsLayout() {
        return this._needsLayout;
      },
      getParamsFromState: function (t) {
        const e = this.annotation.isAppStyle,
          i = e ? yu.POIIconParams : yu.Params;
        return "default" === t && this.annotation.n && e ? mu[Math.min(this.annotation.n, 6)] : i[t];
      },
      balloonNodeSize: function (t) {
        if (!this.annotation.balloonVisible) return new ki(0, 0);
        t || (t = this.state);
        const e = this.getParamsFromState(t);
        if ("callout" === t) return new ki(2 * e.radius, 2 * e.radius);
        const i = 2 * e.balloonRadius;
        return new ki(i, e.height + e.offset);
      },
      updateAppearance: function (t) {
        (this._balloon.freeze(), t && (this.needsDisplay = !0));
      },
      updateState: function (t) {
        if (this._usingStaticStyle) return;
        const e = this.annotation;
        this.state !== t &&
          ((!e.selected && "selected" !== this.state && "callout" !== this.state) ||
            !this.state ||
            this._animateFromState ||
            (this._animateFromState = this.state),
          (this.state = t),
          this.updateSizeAndAppearance());
      },
      updateSizeAndAppearance() {
        ((this.annotation._node.size = this._size = this._balloon.size = this.balloonNodeSize()),
          this.updateAppearance(),
          (this.needsLayout = !0));
      },
      performScheduledUpdate: function () {
        this.updateLayout(!1);
      },
      updateLayout: function (t) {
        this._needsLayout && (this._layoutSubNodes(t), (this._needsLayout = !1));
      },
      updateGlyphText: function () {
        (this.updateAppearance(!0), (this._balloon.needsDisplay = !0));
      },
      updateGlyphImage: function (t) {
        (this.updateAppearance(), (this._balloon.glyphImage = t), (this._balloon.needsDisplay = !0));
      },
      updateSelectedGlyphImage: function (t) {
        ((this._balloon.selectedGlyphImage = t), (this._balloon.needsDisplay = !0));
      },
      glyphImageError: function () {
        (this.updateAppearance(), this._balloon.glyphImageError(this.state));
      },
      animateAppearance: function (t) {
        const e = this.getParamsFromState(this.state);
        if (
          (this.children.forEach((t) => {
            this.annotation.isAppStyle || t === this._balloon || Cu(t, e);
          }),
          !this.annotation.isAppStyle || this.annotation.selected)
        )
          Mu(this._balloon, e, cu, 1, new Mi(this._balloon.size.width / 2, this._balloon.size.height), void 0, t);
        else {
          const i = new Mi(this._balloon.size.width / 2, this._balloon.size.height / 2);
          ku(this._balloon, e, cu, 1, i, t);
        }
      },
      fadeInLabels() {
        const t = this.children.filter((t) => t instanceof hu),
          e = this.getParamsFromState(this.state);
        t.forEach((t) => {
          Cu(t, e);
        });
      },
      preventAnimation: function () {
        ((this._animationPrevented = !0), (this.needsLayout = !0));
      },
      _layoutSubNodes: function (t) {
        if (!this.annotation) return;
        this.updateAppearance();
        const e = this.children.slice();
        ((this.children = [this._balloon]), this._dot && this.addChild(this._dot));
        let i = this._balloon.size.width;
        const n = this.annotation,
          o = this.state,
          s = this.getParamsFromState(this.state),
          a = n.map && !this._animationPrevented;
        delete this._animationPrevented;
        const r = (n && n.map && n.map._impl.fontSizeRatio) || 1;
        function l(t, i) {
          (e.forEach(function (e) {
            e.kind === t &&
              (this.addChild(e),
              (function (t, e, i) {
                ((t.fadingOut = !0),
                  new fo.Opacity({
                    node: t,
                    duration: e.transitionDuration,
                    from: 1,
                    to: 0,
                    done: function () {
                      (delete t.fadingOut, t.remove());
                    }
                  }).begin());
              })(e, s, this.annotation));
          }, this),
            delete this[i]);
        }
        let h = 0;
        const c = (t, e) => {
            const o = ru.computeFont(t, r),
              l = n[t],
              c = a && !!this.parent && l !== e && (!l || !e),
              d = this.annotation.darkColorScheme;
            return (
              (function (t, e, i) {
                t.font = i;
                const n = e.trim().split(/[\f\n\r\t\v\u0020\u2000-\u200b\u205f\u3000]+/),
                  o = [];
                for (; n.length > 0; ) {
                  const e = [n.shift()];
                  let i = e.join(" ").length;
                  for (; n.length > 0 && i <= 16; ) (e.push(n.shift()), (i = e.join(" ").length));
                  i > 16 && e.length > 1 && n.unshift(e.pop());
                  const s = e.join(" "),
                    a = t.measureText(s),
                    r = a.width + du.labelOutlineWidth;
                  o.push([s, r, a]);
                }
                return o;
              })(this.scene ? this.scene.contextForMeasurement : wu(), l, o).forEach(([e, n, o]) => {
                const a = new hu(e, t, n, o, d, r);
                ((i = Math.max(i, n)), (h = a.lineHeight / 2), this.addChild(a), c && Cu(a, s));
              }, this),
              l
            );
          },
          d = "callout" !== o && "lifted" !== o && !("default" === o && n.selected) && n.labelsCanBeShown(),
          u = d && n.titleCanBeShown();
        (u ? (this._prevTitle = c("title", this._prevTitle)) : l.call(this, "title", "_prevTitle"),
          d && n.subtitleCanBeShown(u)
            ? (this._prevSubtitle = c("subtitle", this._prevSubtitle))
            : l.call(this, "subtitle", "_prevSubtitle"));
        let p = this._balloon.size.height;
        "callout" === o &&
          n.isAppStyle &&
          0 !== this.children.filter((t) => t.lineHeight).length &&
          (p += this.getParamsFromState("default").balloonRadius);
        let m = p,
          g = 0;
        (this.children.forEach(function (t) {
          let e = 0;
          if (t.lineHeight) {
            const i = Math.ceil(t.textAscent - t.fontSize);
            (i > 0 && (e += i), g > 0 && (e += Math.ceil(g)));
          }
          ((t.position = new Mi((i - t.size.width) / 2, t.lineHeight ? m + e : 0)),
            t.lineHeight &&
              ((m += t.lineHeight + e),
              t.fadingOut ||
                ((p += t.lineHeight + e), (h = Math.round(t.lineHeight / 2 + (t.textDescent > 0 ? t.textDescent : 0)))),
              (g = t.textDescent)));
        }),
          (n._anchorPoint = new Mi(i / 2, this._balloon.size.height + s.anchorPointOffset)),
          (n._node.size = this.size = new ki(i, p + h)),
          n.updatePosition());
        const _ = n._position.x - n._anchorPoint.x - n._anchorOffset.x,
          f = this.position.x;
        if (
          (this.children.forEach(function (t) {
            t.position = new Mi(qn.roundToDevicePixel(_ + t.position.x) - f, t.position.y);
          }),
          "selected" === o
            ? (this._dot || (this._dot = this.addChild(new eu(this.annotation, s.dotRadius * s.dotScale), 1)),
              (this._dot.size = new ki(2 * s.dotRadius * s.dotScale, 2 * s.dotRadius * s.dotScale)),
              (this._dot.position = new Mi(
                this._balloon.position.x + s.balloonRadius - s.dotRadius,
                this._balloon.size.height - 2 * s.dotRadius
              )),
              (this._dot.transform = new Li().scale(1 / s.dotScale)))
            : this._dot && (this._dot.remove(), delete this._dot),
          a && this._animateFromState)
        ) {
          const t = this.getParamsFromState(this._animateFromState);
          if ("callout" === o || "callout" === this._animateFromState) {
            const e = bu(s);
            e.transitionDuration /= 2;
            const i = this.addChild(new Vd(this.annotation, this._animateFromState));
            let n;
            (i.setDelegate(this),
              (i.glyphImage = this._balloon.glyphImage),
              (i.selectedGlyphImage = this._balloon.selectedGlyphImage),
              i.setBalloonStyle(),
              (i.size = this.balloonNodeSize(i.state)),
              (this._balloon.transform = new Li().scale(cu)),
              "callout" === o
                ? ((i.position = new Mi(
                    (this.size.width - i.size.width) / 2,
                    this._balloon.size.height / 2 - i.size.height - t.anchorPointOffset + 4.5
                  )),
                  (n = new Mi(i.size.width / 2, i.size.height + t.anchorPointOffset)),
                  ku(i, e, 1, cu, n, () => {
                    i.remove();
                    const t = bu(s);
                    ((t.transitionDuration /= 2),
                      ku(this._balloon, t, cu, 1, new Mi(this._balloon.size.width / 2, this._balloon.size.height / 2)));
                  }))
                : ((i.position = new Mi(
                    (this.size.width - i.size.width) / 2,
                    this._balloon.size.height + s.anchorPointOffset - i.size.height / 2 - 4.5
                  )),
                  (n = new Mi(i.size.width / 2, i.size.height / 2)),
                  this.annotation.isAppStyle
                    ? ku(i, e, 1, cu, n, () => {
                        i.remove();
                        const t = new Mi(this._balloon.size.width / 2, this._balloon.size.height / 2);
                        ku(this._balloon, s, cu, 1, t);
                      })
                    : ku(i, e, 1, cu, n, () => {
                        (i.remove(),
                          Mu(this._balloon, s, cu, 1, new Mi(this._balloon.size.width / 2, this._balloon.size.height)));
                      })));
          } else {
            let e,
              i,
              a,
              r = 0;
            (n.isAppStyle
              ? ((e = t.balloonRadius / s.balloonRadius),
                (r = gu.height - gu.balloonRadius + gu.offset),
                "selected" === o
                  ? ((i = new Mi(s.balloonRadius, s.balloonRadius + r / (1 - e))),
                    (a = new Mi(this._balloon.size.width / 2, this._balloon.size.height)))
                  : (i = new Mi(s.balloonRadius, s.balloonRadius - r / (1 - e))))
              : ((e = this.balloonNodeSize(this._animateFromState).height / this.balloonNodeSize().height),
                (i = new Mi(this._balloon.size.width / 2, this._balloon.size.height))),
              1 !== e && Mu(this._balloon, s, e, 1, i, a));
            const l = this._dot;
            l && Cu(l, {transitionDuration: s.dotAnimationDuration});
            let h = 0;
            if (
              (1 !== e && n.isAppStyle && (h = (e < 1 ? 1 : -1) * this.getParamsFromState("default").balloonRadius),
              0 !== h)
            ) {
              const t = new Mi(0, 0),
                e = new Mi(0, h);
              this.children.forEach(function (i) {
                i.lineHeight &&
                  (function (t, e, i, n) {
                    new fo.Translation({node: t, duration: e.transitionDuration, from: i, to: n, pop: !0}).begin();
                  })(i, s, e, t);
              });
            }
          }
          delete this._animateFromState;
        }
        t || n.updatedLayout();
      }
    })),
    (yu.FeatureVisibility = on));
  const wu = function () {
    return (vu || (vu = W()), vu.getContext("2d"));
  };
  function bu(t, e) {
    const i = Object.create(t);
    for (const t in e) i[t] = e[t];
    return i;
  }
  function Cu(t, e) {
    new fo.Opacity({node: t, duration: e.transitionDuration}).begin();
  }
  function ku(t, e, i, n, o, s) {
    new fo.Scale({node: t, duration: e.transitionDuration, from: i, to: n, center: o, done: s}).begin();
  }
  function Mu(t, e, i, n, o, s, a) {
    new fo.Float({node: t, duration: e.transitionDuration, from: i, to: n, center: o, floatCenter: s, done: a}).begin();
  }
  const Su = yu;
  function Lu(t, e) {
    (t.useSquareBalloon ? (this._renderer = new Kd(this)) : (this._renderer = new Zd(this)),
      (this.frozen = !0),
      (this.annotation = t),
      (this.state = "selected"),
      (this.params = e));
    const i = 2 * e.balloonRadius;
    ((this.size = new ki(i, i)), (this.layerBounds = new Si(0, 0, this.size.width, this.size.height)));
  }
  ((Lu.prototype.enablesDefaultGlyphImage = !0),
    (Lu.prototype.draw = function () {
      !this.annotation.glyph && this._renderer.isFallbackGlyphTextPending && this._renderer.addPendingNode(this);
      const t = this._renderer.layer;
      ((t.hidden = !1),
        (t.style.width = t.style.height = this.size.width + "px"),
        this._renderer.draw(t.getContext("2d")));
    }),
    (Lu.prototype.getLayer = function () {
      return this._renderer.layer;
    }),
    (Lu.prototype.glyphImageError = function (t) {
      "selected" === t && this.selectedGlyphImage ? delete this.selectedGlyphImage : delete this.glyphImage;
    }),
    (Lu.prototype.updateGlyphImage = function (t) {
      this.glyphImage = t;
    }),
    (Lu.prototype.updateSelectedGlyphImage = function (t) {
      this.selectedGlyphImage = t;
    }),
    (Lu.prototype.freeze = function () {
      this.draw();
    }));
  const Au = Lu,
    Eu = function (t, e) {
      let i;
      if ("function" != typeof t.getImageUrl)
        return (
          (i = (function (t) {
            if (!t || "object" != typeof t) return;
            let e;
            const i = Object.keys(t)
                .filter((e) => !!t[e])
                .map(parseFloat)
                .filter((t) => !isNaN(t))
                .sort(),
              n = qn.devicePixelRatio;
            for (let t = i.length - 1; t >= 0 && ((!e || i[t] >= n) && (e = i[t]), !(i[t] <= n)); --t);
            return e;
          })(t)),
          i ? void e({ratio: i, glyphImageUrl: t[i]}) : void e()
        );
      ((i = qn.devicePixelRatio),
        q(t.getImageUrl, t, [
          i,
          function (t) {
            setTimeout(() => e(t ? {ratio: i, glyphImageUrl: t} : void 0));
          }
        ]));
    },
    xu = {light: "#ff5b40", dark: "#e6523b"},
    Tu = {light: "white", dark: "#e7e6e4"},
    Iu = {light: "white", dark: "black"},
    Ru = {Default: "default", Dot: "dot", Large: "large"};
  function Ou(t) {
    function e(e, i, n) {
      ((this._sceneGraphNode = new Su(this)),
        t.call(this, e, i, t.div, n),
        this.updateGlyph(),
        this._setBalloonStyle(),
        (this._userSetSize = !0),
        this._calloutWithSelectedState ||
          (this._calloutAnchorPoint = new window.DOMPoint(-Su.Params.callout.radius, 1)));
      const o = this.selected
        ? this.canShowCallout()
          ? this.selectedStateForSceneGraphNode()
          : "selected"
        : "default";
      this._sceneGraphNode.updateState(o);
    }
    return (
      (e.StaticStyles = Ru),
      (e.prototype = r(t, e, {
        _animates: !0,
        _glyphImage: null,
        _selectedGlyphImage: null,
        _glyphText: "",
        _color: null,
        _glyphColor: null,
        _titleVisibility: Su.FeatureVisibility.Adaptive,
        _subtitleVisibility: Su.FeatureVisibility.Adaptive,
        shouldHideLabels: !0,
        renderedByDOMElement: !1,
        get size() {
          return this._sceneGraphNode.size.copy();
        },
        set size(t) {
          console.warn("[MapKit] The `size` property of a marker annotation cannot be set.");
        },
        get color() {
          return null !== this._color ? this._color : this.map ? xu[this.map._impl.currentColorScheme] : xu.light;
        },
        set color(t) {
          (null !== t &&
            c(t, "string", "[MapKit] Expected a string value for MarkerAnnotation.color, but got `" + t + "` instead"),
            t !== this._color &&
              ((this._color = t), this._sceneGraphNode.updateAppearance(!0), this._drawCalloutAccessory()));
        },
        get fillColor() {
          return this.color;
        },
        get haloColor() {
          return null;
        },
        get glyphColor() {
          return null !== this._glyphColor
            ? this._glyphColor
            : this.map
              ? this.isPlaceStyle
                ? Iu[this.map._impl.tint]
                : Tu[this.map._impl.currentColorScheme]
              : Tu.light;
        },
        set glyphColor(t) {
          (null !== t &&
            c(
              t,
              "string",
              "[MapKit] Expected a string value for MarkerAnnotation.glyphColor, but got `" + t + "` instead"
            ),
            t !== this._glyphColor &&
              ((this._glyphColor = t), this._sceneGraphNode.updateAppearance(!0), this._drawCalloutAccessory()));
        },
        get glyphImage() {
          return this._glyphImage;
        },
        set glyphImage(t) {
          this._setGlyphImage("_glyphImage", "updateGlyphImage", t);
        },
        get selectedGlyphImage() {
          return this._selectedGlyphImage;
        },
        set selectedGlyphImage(t) {
          this._setGlyphImage("_selectedGlyphImage", "updateSelectedGlyphImage", t);
        },
        updateGlyphImages: function () {
          (this._setGlyphImage("_glyphImage", "updateGlyphImage", this._glyphImage),
            this._setGlyphImage("_selectedGlyphImage", "updateSelectedGlyphImage", this._selectedGlyphImage));
        },
        get glyphText() {
          return this._glyphText;
        },
        set glyphText(t) {
          (c(
            t,
            "string",
            "[MapKit] Expected a string value for MarkerAnnotation.glyphText, but got `" + t + "` instead"
          ),
            t !== this._glyphText &&
              ((this._glyphText = t),
              this.updateLocalizedText(),
              this.updateGlyph(),
              this._sceneGraphNode.updateGlyphText(),
              this._drawCalloutAccessory()));
        },
        get glyph() {
          return this._glyph;
        },
        get titleVisibility() {
          return this._titleVisibility;
        },
        set titleVisibility(t) {
          if (!l(t, Su.FeatureVisibility))
            throw new Error(
              "[MapKit] Expected one of Hidden, Visible or Adaptive for MarkerAnnotation.titleVisibility"
            );
          t !== this._titleVisibility && ((this._titleVisibility = t), (this._sceneGraphNode.needsLayout = !0));
        },
        get subtitleVisibility() {
          return this._subtitleVisibility;
        },
        set subtitleVisibility(t) {
          if (!l(t, Su.FeatureVisibility))
            throw new Error(
              "[MapKit] Expected one of Hidden, Visible or Adaptive for MarkerAnnotation.subtitleVisibility"
            );
          t !== this._subtitleVisibility && ((this._subtitleVisibility = t), (this._sceneGraphNode.needsLayout = !0));
        },
        get labelOccluded() {
          return this._labelOccluded;
        },
        set labelOccluded(t) {
          (this._labelOccluded !== t && (this._sceneGraphNode.needsLayout = !0), (this._labelOccluded = t));
        },
        _labelOccluded: !1,
        labelsCanBeShown: function () {
          return this.delegate && this.delegate.supportsLabelRegions();
        },
        titleCanBeShown: function () {
          return this.title && !this.labelOccluded && this._titleVisibility !== Su.FeatureVisibility.Hidden;
        },
        subtitleCanBeShown: function (t) {
          return (
            this.subtitle &&
            !this.labelOccluded &&
            (this._subtitleVisibility === Su.FeatureVisibility.Visible ||
              (this._subtitleVisibility === Su.FeatureVisibility.Adaptive &&
                (this._public.memberAnnotations || (this.selected && t))))
          );
        },
        updateLayout: function (t, e) {
          ((!e && t) || (this._sceneGraphNode.needsLayout = !0), (e || t) && this._sceneGraphNode.updateLayout(t));
        },
        updatedLayout: function () {
          this._updatedProperty("");
        },
        calculateNodePosition: function () {
          return new Mi(
            qn.roundToDevicePixel(this._position.x - this._anchorPoint.x - this._anchorOffset.x),
            this._position.y - this._anchorPoint.y - this._anchorOffset.y
          );
        },
        animateOcclusion() {
          if (!this.isLoadingIconMetadata) return t.prototype.animateOcclusion.call(this);
        },
        get darkColorScheme() {
          return !!this.map && qn.darkColorScheme(this.map._impl.mapNodeTint);
        },
        get isAppStyle() {
          return !!(
            (this._glyphImage && this._glyphImage.isPOIIcon) ||
            (this._selectedGlyphImage && this._selectedGlyphImage.isPOIIcon)
          );
        },
        get isPlaceStyle() {
          return this.isAppStyle;
        },
        balloonVisible: !0,
        iconRect() {
          const t = this.nodePosition(),
            e = this.sceneGraphNode._balloon.position,
            i = this.sceneGraphNode._balloon.size;
          return new Si(t.x + e.x, t.y + e.y, i.width, i.width);
        },
        _labelRect: void 0,
        _anchorPointWithLabel: void 0,
        labelRect() {
          if (!this._labelRect) {
            const t = this.sceneGraphNode.children
              .filter((t) => t instanceof hu)
              .map((t) => new Si(t.position.x, t.position.y, t.size.width, t.size.height));
            ((this._labelRect = t.length ? Si.unionOfRects(t) : new Si(0, 0, 0, 0)),
              (this._anchorPointWithLabel = this._anchorPoint.copy()));
          }
          const t = new Mi(
            qn.roundToDevicePixel(this._position.x - this._anchorPointWithLabel.x - this._anchorOffset.x),
            this._position.y - this._anchorPointWithLabel.y - this._anchorOffset.y
          );
          return new Si(
            t.x + this._labelRect.origin.x,
            t.y + this._labelRect.origin.y,
            this._labelRect.size.width,
            this._labelRect.size.height
          );
        },
        isGlyphImageInternal: !1,
        warnOnUnselectedGlyphImageAccess: !1,
        get enablesDefaultGlyphImage() {
          return this._sceneGraphNode.enablesDefaultGlyphImage;
        },
        set enablesDefaultGlyphImage(t) {
          this._sceneGraphNode.enablesDefaultGlyphImage = t;
        },
        setDelegate: function (e) {
          (t.prototype.setDelegate.call(this, e), this.labelsCanBeShown() && this._updatedProperty("title"));
        },
        doesAnimate: function () {
          return this._animates;
        },
        willMoveToMap: function (t) {
          this._isMoving = t && this.animates;
        },
        didMoveToMap: function () {
          const e = this._isMoving;
          if ((t.prototype.didMoveToMap.call(this), this.isLoadingIconMetadata))
            return ((this._sceneGraphNode.opacity = 0), void (this._isMoving = e));
          this.animateAppearance(e);
        },
        animateAppearance(t, e = !1) {
          this.delegate && t && this.visible && !this._appearanceAnimation && this._shown
            ? ((this._isAnimating = !0),
              this._sceneGraphNode.animateAppearance(function (t) {
                t.node.annotation.finishedAnimating();
              }),
              e && this._sceneGraphNode.fadeInLabels())
            : this._sceneGraphNode.preventAnimation();
        },
        iconMetadataLoaded() {
          this.isLoadingIconMetadata &&
            ((this.isLoadingIconMetadata = !1),
            (this._sceneGraphNode.opacity = 1),
            this.animateAppearance(this._isMoving, !0),
            delete this._isMoving);
        },
        lift: function (e) {
          (this._sceneGraphNode.updateState("lifted"), t.prototype.lift.call(this, e));
        },
        droppedAfterLift: function () {
          (this._sceneGraphNode.updateState("default"), t.prototype.droppedAfterLift.call(this));
        },
        canShowCallout: function () {
          return (
            (!!this.callout || (this.delegate && !this.delegate.supportsLabelRegions())) &&
            t.prototype.canShowCallout.call(this)
          );
        },
        centerOffsetForSelectionAccessory() {
          return new Mi(-this._node.size.width / 2, -Su.Params.selected.balloonRadius);
        },
        selectedStateForSceneGraphNode() {
          return this.selectionAccessory || this._calloutWithSelectedState ? "selected" : "callout";
        },
        selectionAccessoryWillAppear: function (t) {
          const e = t ? this.selectedStateForSceneGraphNode() : "selected";
          this.isStable() && this._sceneGraphNode.updateState(e);
        },
        selectionAccessoryWillDisappear: function () {
          this.selected || (delete this._calloutAccessoryNode, this._sceneGraphNode.updateState("default"));
        },
        canvasForCalloutAccessory: function () {
          if (
            !this.callout ||
            this.selectionAccessory ||
            !(
              this.callout.calloutElementForAnnotation ||
              this.callout.calloutContentForAnnotation ||
              this.callout.calloutLeftAccessoryForAnnotation ||
              this.callout.calloutRightAccessoryForAnnotation
            )
          )
            return (
              this._calloutAccessoryNode ||
                ((this._calloutAccessoryNode = new Au(this, Su.Params.bubble)),
                (this._calloutAccessoryNode.glyphImage = this._sceneGraphNode._balloon.glyphImage),
                (this._calloutAccessoryNode.selectedGlyphImage = this._sceneGraphNode._balloon.selectedGlyphImage),
                (this._calloutAccessoryNode.glyphText = this._glyphText),
                this._drawCalloutAccessory()),
              this._calloutAccessoryNode.getLayer()
            );
          delete this._calloutAccessoryNode;
        },
        get ignoreCalloutCornerRadiusForLeftAccessory() {
          return !0;
        },
        altText: function () {
          return t.prototype.altText.call(this) || fi.get("Annotation.Marker.AccessibilityLabel");
        },
        ConstructorOptions: Object.freeze(
          Object.assign({}, t.prototype.ConstructorOptions, {
            color: "rw",
            glyphColor: "rw",
            glyphImage: "rw",
            selectedGlyphImage: "rw",
            glyphText: "rw",
            titleVisibility: "rw",
            subtitleVisibility: "rw",
            _calloutWithSelectedState: "rw"
          })
        ),
        resetNodeTransform: function () {
          this.sceneGraphNode.transform = new Li();
        },
        updateGlyph: function () {
          this._glyph = this.glyphText || (this._glyphImageElement ? this._glyphImageElement.src : "");
        },
        get staticStyle() {
          return this._staticStyle;
        },
        set staticStyle(t) {
          let e;
          switch (t) {
            case Ru.Dot:
              e = "callout";
              break;
            case Ru.Large:
              e = "selected";
              break;
            default:
              ((t = Ru.Default), (e = "default"));
          }
          ((this._staticStyle = t), this._sceneGraphNode.updateState(e), (this._sceneGraphNode._usingStaticStyle = !0));
        },
        loadGlyphImage: function (t, e, i, n) {
          Eu(n, (o) => {
            if (this[e] === n)
              return o
                ? void (function (t, e, i, n) {
                    const o = i + "Loader";
                    if (
                      (t[o] && t[o].unschedule(),
                      (t[o] = new gs(I.Highest, {
                        urlForImageLoader: e,
                        loaderDidSucceed: function (e) {
                          t[o] === e &&
                            (delete t[o],
                            (t[i] = e.image),
                            t.updateGlyph(),
                            t._sceneGraphNode[n](e.image),
                            t._calloutAccessoryNode &&
                              (t._calloutAccessoryNode[n](e.image), t._drawCalloutAccessory()));
                        },
                        loaderDidFail: function (e) {
                          t[o] === e &&
                            (delete t[o],
                            delete t[i],
                            t.updateGlyph(),
                            t._sceneGraphNode[n](),
                            t._calloutAccessoryNode && (t._calloutAccessoryNode[n](), t._drawCalloutAccessory()));
                        }
                      })),
                      t.isGlyphImageInternal)
                    ) {
                      const e = dt.withCredentials && !dt.customMadabaUrl;
                      t[o].crossOrigin = ms.getCorsAttribute(e);
                    }
                    t[o].schedule();
                  })(this, o.glyphImageUrl, t, i)
                : (delete this[t],
                  this._sceneGraphNode.glyphImageError(),
                  void (this._calloutAccessoryNode && this._calloutAccessoryNode.glyphImageError()));
          });
        },
        _setBalloonStyle() {
          ((this.useSquareBalloon =
            (this._glyphImage && this._glyphImage.useSquareBalloon) ||
            (this._selectedGlyphImage && this._selectedGlyphImage.useSquareBalloon)),
            this._sceneGraphNode._balloon.setBalloonStyle());
        },
        _setGlyphImage: function (t, e, i) {
          (null != i &&
            c(
              i,
              "object",
              "[MapKit] Expected a hash value or an Image delegate for MarkerAnnotation." +
                t.replace(/^_/, "") +
                ", but got `" +
                i +
                "` instead"
            ),
            (this[t] = i));
          const n = t + "Element";
          if ((this._setBalloonStyle(), !i)) {
            delete this[n];
            const t = n + "Loader";
            return (
              this[t] && (this[t].unschedule(), delete this[t]),
              this._sceneGraphNode[e](null),
              void (this._calloutAccessoryNode && (this._calloutAccessoryNode[e](null), this._drawCalloutAccessory()))
            );
          }
          this.loadGlyphImage(n, t, e, i);
        },
        _updatedProperty: function (e) {
          (("title" !== e && "subtitle" !== e) ||
            ((this._labelRect = void 0),
            (this._anchorPointWithLabel = void 0),
            (this._sceneGraphNode.needsLayout = !0)),
            t.prototype._updatedProperty.call(this, e));
        },
        _drawCalloutAccessory: function () {
          this._calloutAccessoryNode && this._calloutAccessoryNode.draw();
        }
      })),
      (e.DefaultColor = xu),
      e
    );
  }
  ((Ou.StaticStyles = Ru), (Ou.DefaultColor = xu), (Ou.DefaultGlyphColor = Tu));
  const Pu = Ou,
    Du = Pu(Sd);
  function zu(t, e) {
    bo(this, zu) && Object.defineProperty(this, "_impl", {value: new Du(this, t, e)});
  }
  zu.prototype = r(Ad, zu, {
    get size() {
      return this._impl.size;
    },
    set size(t) {
      this._impl.size = t;
    },
    get color() {
      return this._impl.color;
    },
    set color(t) {
      this._impl.color = t;
    },
    get glyphColor() {
      return this._impl.glyphColor;
    },
    set glyphColor(t) {
      this._impl.glyphColor = t;
    },
    get glyphImage() {
      return this._impl.glyphImage;
    },
    set glyphImage(t) {
      this._impl.glyphImage = t;
    },
    get selectedGlyphImage() {
      return this._impl.selectedGlyphImage;
    },
    set selectedGlyphImage(t) {
      this._impl.selectedGlyphImage = t;
    },
    get glyphText() {
      return this._impl.glyphText;
    },
    set glyphText(t) {
      this._impl.glyphText = t;
    },
    get titleVisibility() {
      return this._impl.titleVisibility;
    },
    set titleVisibility(t) {
      this._impl.titleVisibility = t;
    },
    get subtitleVisibility() {
      return this._impl.subtitleVisibility;
    },
    set subtitleVisibility(t) {
      this._impl.subtitleVisibility = t;
    }
  });
  const Nu = zu,
    Fu = "mapsearch",
    Uu = function (t, e) {
      e = e || Vi;
      const i = t === Xi.Hybrid || t === Xi.Satellite ? "46" : "1";
      return ("46" === i && (e = Vi), {iconStyle: i, tint: e, emphasis: t === Xi.MutedStandard ? en : nn});
    };
  function Gu(t = []) {
    if (t[0] || t[1] || t[2] || t[3]) return "rgba(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] / 255 + ")";
  }
  function Bu(t) {
    ((this.results = {}), (this.completeCallback = t), (this.loaders = []), (this.loaderData = []));
  }
  function Zu() {
    this._deferredFetchOptionsMap = void 0;
  }
  ((Bu.ATLAS_URL =
    "/md/v1/atlas?data=false&dimension=1&entries={{entries}}&format=json&metadata=true&origin=top&type=icon&urls=true&accessKey={{accessKey}}"),
    (Bu._CALLOUT_GLYPH_IMAGE_ENDPOINT_URL_PATH =
      "/md/v1/icon?subtype=poi&style={{style}}&context={{context}}&tint={{tint}}&emphasis={{emphasis}}&attributes={{attributes}}&v={{tileGroup}}&accessKey={{accessKey}}&scale={{scale}}&size={{size}}&glyph=true"),
    (Bu.fillGraphImageUrlPath = function (t, e) {
      let i = Bu._CALLOUT_GLYPH_IMAGE_ENDPOINT_URL_PATH;
      return (
        dt.tileGroup && (i = i.replace("{{tileGroup}}", dt.tileGroup)),
        (i = i.replace("{{attributes}}", e ? t.styleAttributes : encodeURIComponent(t.styleAttributes))),
        i
      );
    }),
    (Bu.keyFromFetchOptions = function (t) {
      const e = Uu(t.mapType, t.colorScheme);
      return t.styleAttributes + t.iconContext + e.iconStyle + e.tint + e.emphasis;
    }),
    (Bu.prototype.fetch = function (t) {
      const e = new Map(
        t.map(function (t) {
          const e = Uu(t.mapType, t.colorScheme);
          return [
            t,
            Bu.fillGraphImageUrlPath(t, !0)
              .replace("&accessKey={{accessKey}}", "")
              .replace("{{scale}}", "2")
              .replace("{{size}}", t.iconContext === Fu ? "3" : "4")
              .replace("{{context}}", t.iconContext)
              .replace("{{style}}", e.iconStyle)
              .replace("{{tint}}", e.tint)
              .replace("{{emphasis}}", e.emphasis)
              .replace("{{tileGroup}}", dt.tileGroup || t.tileGroup)
          ];
        })
      );
      t.sort(function (t, i) {
        const n = e.get(t),
          o = e.get(i);
        return n > o ? 1 : n < o ? -1 : 0;
      });
      const i = [];
      for (let e = 0; e < t.length; e += 1) i.push(t.slice(e, e + 1));
      let n =
        dt.getMadabaDomainFromStringHash(t[0].styleAttributes) +
        Bu.ATLAS_URL.replace("{{accessKey}}", encodeURIComponent(dt.accessKey || ""));
      (dt.proxyPrefixes && !dt.customMadabaUrl && (n = dt.proxyPrefixes[0] + n),
        (this.pendingRequestsCount = i.length));
      for (let t = 0; t < i.length; t++) {
        const o = i[t].map((t) => e.get(t)),
          s = n.replace("{{entries}}", encodeURIComponent(JSON.stringify({requests: o}))),
          a = {withCredentials: dt.withCredentials && !dt.customMadabaUrl, headers: {}},
          r = new j(s, this, a);
        (this.loaders.push(r), this.loaderData.push([o, i[t]]), r.schedule());
      }
    }),
    (Bu.prototype.loaderDidSucceed = function (t, e) {
      this.pendingRequestsCount--;
      const i = this.loaders.indexOf(t),
        n = this.loaderData[i],
        o = n[0],
        s = n[1],
        a = JSON.parse(e.responseText);
      (o.forEach((t, e) => {
        const i = a.urls[t];
        if (!i) return;
        const n = a["icon-metadata"][i],
          o = s[e].styleAttributes,
          r = Bu.keyFromFetchOptions(s[e]),
          l = Uu(s[e].mapType, s[e].colorScheme),
          h = !("labelIconSource" in n) || 0 !== n.labelIconSource,
          c = !("labelTextVisibility" in n) || "Never" !== n.labelTextVisibility;
        this.results[r] = {
          context: s[e].iconContext,
          styleAttributes: o,
          iconStyle: l.iconStyle,
          tint: l.tint,
          emphasis: l.emphasis,
          badgeColor: Gu(n.badgeColor),
          calloutColor: Gu(n.calloutColor),
          calloutHaloColor: Gu(n.calloutHaloColor),
          haloColor: Gu(n.haloColor),
          calloutShape: n.calloutShape ? n.calloutShape : "Circle",
          iconVisibility: h,
          labelVisibility: c
        };
      }),
        0 === this.pendingRequestsCount && this.completeCallback(this.results));
    }),
    (Bu.prototype.loaderDidFail = function (t, e) {
      (this.pendingRequestsCount--, 0 === this.pendingRequestsCount && this.completeCallback(this.results));
    }),
    (Zu.fillGraphImageUrlPath = function (t) {
      return Bu.fillGraphImageUrlPath(t);
    }),
    (Zu.keyFromFetchOptions = function (t) {
      return Bu.keyFromFetchOptions(t);
    }),
    (Zu.prototype.fetchAll = function (t, e) {
      t.length ? new Bu(e).fetch(t) : setTimeout(() => e({}));
    }),
    (Zu.prototype.fetchDeferred = function (t, e) {
      if (!this._deferredFetchOptionsMap)
        if (((this._deferredFetchOptionsMap = {}), dt.state !== dt.States.READY)) {
          const t = () => {
            (dt.removeEventListener(dt.Events.Changed, t), setTimeout(() => this._startDeferredFetch(), 0));
          };
          dt.addEventListener(dt.Events.Changed, t);
        } else setTimeout(() => this._startDeferredFetch(), 0);
      const i = Zu.keyFromFetchOptions(t);
      (this._deferredFetchOptionsMap[i] || (this._deferredFetchOptionsMap[i] = {fetchOptions: t, callbacks: []}),
        this._deferredFetchOptionsMap[i].callbacks.push(e));
    }),
    (Zu.prototype._startDeferredFetch = function () {
      const t = this._deferredFetchOptionsMap;
      ((this._deferredFetchOptionsMap = null),
        this.fetchAll(
          Object.values(t).map((t) => t.fetchOptions),
          function (e) {
            Object.entries(t).forEach(([t, i]) => i.callbacks.forEach((i) => i.call(null, e[t])));
          }
        ));
    }),
    (Zu.sharedMadabaIconMetadata = new Zu()));
  const Wu = Zu;
  function Ku(t, e, i, n, o) {
    ((this.annotation = t),
      (this._url = e.replace("{{size}}", i.toString()).replace("{{context}}", n)),
      (this.useSquareBalloon = o));
  }
  Ku.prototype.getImageUrl = function (t, e) {
    let i, n, o;
    if (this.annotation.map) {
      const t = Uu(this.annotation.map.mapType, this.annotation.map._impl.tint);
      ((i = t.iconStyle), (n = t.tint), (o = t.emphasis));
    } else if (this.annotation._impl.iconMetadata) {
      const t = this.annotation._impl.iconMetadata;
      ((i = t.iconStyle), (n = t.tint), (o = t.emphasis));
    } else ((i = "1"), (n = Vi), (o = nn));
    ((t = Math.ceil(Math.min(Math.max(t, 1), 3))),
      e(
        this._url
          .replace("{{accessKey}}", encodeURIComponent(dt.accessKey))
          .replace("{{scale}}", t)
          .replace("{{style}}", i)
          .replace("{{tint}}", n)
          .replace("{{emphasis}}", o)
      ));
  };
  const Hu = Ku,
    ju = Wu.sharedMadabaIconMetadata,
    {Event: Vu} = pt,
    qu = Symbol(""),
    Yu = (function (t) {
      function e(i, n, o) {
        if ((t.call(this, i, n, o), (this._cachedIconMetadata = {}), this.constructor === e)) {
          if (!this.place) throw new Error("[MapKit] Expected a Place for PlaceAnnotation.");
          if (!this.place.coordinate) throw new Error("[MapKit] Expected a Place with coordinate.");
          (this.coordinate.equals(this.place.coordinate) || (this.coordinate = this.place.coordinate),
            (this.styleAttributes = this.place._styleAttributes),
            (this.iconContext = Fu),
            this.styleAttributes && ((this.styleAttributesHasIcon = !0), (this.enablesDefaultGlyphImage = !1)),
            this.title || (this.title = this.place.name));
        }
      }
      return (
        (e.StaticStyles = t.StaticStyles),
        (e.prototype = r(t, e, {
          styleAttributesHasIcon: !1,
          styleAttributes: "",
          iconContext: "",
          iconMetadata: void 0,
          get isAppStyle() {
            return !1;
          },
          get isPlaceStyle() {
            return !(this.iconMetadata && !this.iconMetadata.iconVisibility);
          },
          get balloonVisible() {
            return !(this.iconMetadata && !this.iconMetadata.iconVisibility);
          },
          titleCanBeShown: function () {
            return !(this.iconMetadata && !this.iconMetadata.labelVisibility) && t.prototype.titleCanBeShown.call(this);
          },
          subtitleCanBeShown: function () {
            return (
              !(this.iconMetadata && !this.iconMetadata.labelVisibility) && t.prototype.subtitleCanBeShown.call(this)
            );
          },
          get _color() {
            return this.iconMetadata
              ? this.iconMetadata && !this.iconMetadata.iconVisibility
                ? this.map
                  ? t.DefaultColor[this.map._impl.currentColorScheme]
                  : t.DefaultColor.light
                : this.selected || this.staticStyle === e.StaticStyles.Large || this.staticStyle === e.StaticStyles.Dot
                  ? this.iconMetadata.calloutColor
                  : this.iconMetadata.badgeColor || this.iconMetadata.calloutColor
              : null;
          },
          get haloColor() {
            return this.iconMetadata
              ? this.iconMetadata && !this.iconMetadata.iconVisibility
                ? null
                : this.selected || this.staticStyle === e.StaticStyles.Large || this.staticStyle === e.StaticStyles.Dot
                  ? this.iconMetadata.calloutHaloColor
                  : this.iconMetadata.haloColor
              : null;
          },
          muid: void 0,
          isGlyphImageInternal: !0,
          get warnOnUnselectedGlyphImageAccess() {
            return !(!this.iconMetadata || "callout" !== this.iconMetadata.context);
          },
          ConstructorOptions: Object.freeze(
            Object.assign({}, t.prototype.ConstructorOptions, {
              color: "ro",
              glyphColor: "ro",
              glyphImage: "ro",
              selectedGlyphImage: "ro",
              draggable: "ro",
              appearanceAnimation: "ro",
              anchorOffset: "ro",
              padding: "ro",
              size: "ro",
              glyphText: "ro"
            })
          ),
          loadGlyphImage: function (e, i, n, o) {
            (this.map || this.iconMetadata) && t.prototype.loadGlyphImage.call(this, e, i, n, o);
          },
          updateLayout: function (e) {
            (this.updateGlyphImages(), this.updateIconMetadata(!0), t.prototype.updateLayout.call(this, e));
          },
          addedToMap: function () {
            (t.prototype.addedToMap.call(this), this.updateIconMetadata(!1), this.updateGlyphImages());
          },
          updateIconMetadata: function (t) {
            if (!this.map) return;
            if (!this.styleAttributesHasIcon) return;
            const e = Uu(this.map.mapType, this.map._impl.tint),
              i = this._cachedIconMetadata[e.iconStyle + e.tint + e.emphasis];
            return this.iconMetadata && i === this.iconMetadata
              ? void 0
              : i && i !== qu
                ? ((this.iconMetadata = i), void this._sceneGraphNode.updateAppearance(t))
                : void this.fetchIconMetadata(this.map._impl.tint, this.map.mapType);
          },
          setIconMetadata(t, e) {
            if (((this._cachedIconMetadata[t.iconStyle + t.tint + t.emphasis] = t), !this.iconMetadata)) {
              if (((this.iconMetadata = t), this.iconMetadata.iconVisibility)) {
                const i = e || Wu.fillGraphImageUrlPath(this);
                let n = dt.getMadabaDomainFromStringHash(this.styleAttributes) + i;
                dt.proxyPrefixes && !dt.customMadabaUrl && (n = dt.proxyPrefixes[0] + n);
                const o = "Square" === t.calloutShape;
                ((this.selectedGlyphImage = new Hu(this._public, n, 4, t.context, o)),
                  "callout" !== t.context && (this.glyphImage = new Hu(this._public, n, 3, t.context, o)));
              } else (this._sceneGraphNode.updateSizeAndAppearance(), (this.enablesDefaultGlyphImage = !0));
              setTimeout(() => this._public.dispatchEvent(new Vu("load")));
            }
            this.updateIconMetadata(!!this.map);
          },
          fetchIconMetadata(t, e, i) {
            this.iconMetadata || (this.isLoadingIconMetadata = !0);
            const n = {
                colorScheme: t,
                styleAttributes: this.styleAttributes,
                iconContext: this.iconContext,
                mapType: e
              },
              o = Uu(n.mapType, n.colorScheme),
              s = o.iconStyle + o.tint + o.emphasis;
            this._cachedIconMetadata[s] !== qu &&
              ((this._cachedIconMetadata[s] = qu),
              ju.fetchDeferred(n, (t) => {
                ((this._cachedIconMetadata[s] = void 0),
                  t
                    ? this.setIconMetadata(t)
                    : (console.warn("[MapKit] Unable to fetch icon style for annotation."),
                      (this.iconMetadata = void 0),
                      (this.enablesDefaultGlyphImage = !0),
                      (this.glyphImage = this.selectedGlyphImage = null),
                      setTimeout(() => this._public.dispatchEvent(new Vu("error")))),
                  this.iconMetadataLoaded(),
                  "function" == typeof i && i(this._public));
              }));
          }
        })),
        e
      );
    })(Du);
  function Xu(t, e) {
    ((this._selected = e), (this._impl = e ? t.selectedGlyphImage : t.glyphImage));
  }
  const $u = function () {
    throw new Error("[MapKit] `MapFeatureAnnotationGlyphImage` may not be constructed directly.");
  };
  Xu.prototype = $u.prototype = {
    constructor: $u,
    getImageUrl: function (t, e) {
      if ((("number" != typeof t || isNaN(t)) && (t = qn.devicePixelRatio), "function" != typeof e))
        throw new Error("[MapKit] Expects a callback to be provided.");
      HTMLCanvasElement.prototype.toBlob
        ? this._impl.getImageUrl(t, (t) => {
            const i = new gs(I.Highest, {
                urlForImageLoader: t,
                loaderDidSucceed: (t) => {
                  const i = this._impl.annotation._impl.iconMetadata,
                    n = this._selected ? i.calloutColor : i.badgeColor,
                    o = t.image,
                    s = document.createElement("canvas");
                  ((s.width = o.naturalWidth), (s.height = o.naturalHeight));
                  const a = s.getContext("2d");
                  (n && ((a.fillStyle = n), a.fillRect(0, 0, s.width, s.height)),
                    a.drawImage(o, 0, 0),
                    s.toBlob(function (t) {
                      q(e, null, [URL.createObjectURL(t)]);
                    }));
                },
                loaderDidFail: function (t) {
                  setTimeout(function () {
                    q(e, null);
                  });
                }
              }),
              n = dt.withCredentials && !dt.customMadabaUrl;
            ((i.crossOrigin = ms.getCorsAttribute(n)), i.schedule());
          })
        : setTimeout(function () {
            q(e, null);
          });
    }
  };
  const Ju = Xu;
  function Qu(t, e) {
    bo(this, Qu) && Object.defineProperty(this, "_impl", {value: new Yu(this, t, e)});
  }
  Qu.prototype = r(Nu, Qu, {
    get element() {
      return this._impl.element;
    },
    get coordinate() {
      return this._impl.coordinate;
    },
    get draggable() {
      return this._impl.draggable;
    },
    get appearanceAnimation() {
      return this._impl.appearanceAnimation;
    },
    get anchorOffset() {
      return this._impl.anchorOffset;
    },
    get padding() {
      return this._impl.padding;
    },
    get size() {
      return this._impl.size;
    },
    get glyphText() {
      return this._impl.glyphText;
    },
    get color() {
      return this._impl.color;
    },
    get glyphColor() {
      return this._impl.glyphColor;
    },
    get glyphImage() {
      return this._impl.glyphImage
        ? (this._impl._glyphImagePublic || (this._impl._glyphImagePublic = new Ju(this._impl, !1)),
          this._impl._glyphImagePublic)
        : null;
    },
    get selectedGlyphImage() {
      return this._impl.selectedGlyphImage
        ? (this._impl._selectedGlyphImagePublic || (this._impl._selectedGlyphImagePublic = new Ju(this._impl, !0)),
          this._impl._selectedGlyphImagePublic)
        : null;
    }
  });
  const tp = Qu;
  function ep() {
    ((this._requests = {}), (this._types = {}), (this._counter = 1));
  }
  ep.prototype = {
    constructor: ep,
    add: function (t, e) {
      const i = this._counter;
      return ((this._counter += 1), (this._requests[i] = t), (this._types[i] = e), i);
    },
    get: function (t) {
      return this._requests[t];
    },
    typeForId: function (t) {
      return this._types[t];
    },
    idsByType: function (t) {
      return Object.keys(this._requests)
        .filter((e) => this._types[e] === t)
        .map((t) => parseInt(t));
    },
    remove: function (t) {
      return !!this.get(t) && (delete this._requests[t], delete this._types[t], !0);
    }
  };
  const ip = ep;
  for (
    ht.prototype.appendServiceAuthOptions = function (t) {
      return ((t.withCredentials = this.withCredentials), this.appendAuthOptions(t));
    },
      ht.prototype._checkJwtToken = Gl;
    dt._jwtTokensToCheck.length;
  ) {
    const t = dt._jwtTokensToCheck.shift();
    dt._checkJwtToken(t);
  }
  const np = j,
    op = {enableHighAccuracy: !1, timeout: 8e3, maximumAge: 9e5};
  function sp(t, e) {
    ((this._name = t),
      (this._requestMap = new ip()),
      dt.state === dt.States.ERROR && (this._configFailed = !0),
      (this.language = e.language),
      void 0 !== e.getsUserLocation && (this.getsUserLocation = !!e.getsUserLocation));
  }
  ((sp.prototype = {
    constructor: sp,
    _getsUserLocation: !1,
    get getsUserLocation() {
      return this._getsUserLocation;
    },
    set getsUserLocation(t) {
      this._getsUserLocation = !!t;
    },
    get language() {
      return this._language;
    },
    set language(t) {
      this._language = null == t ? null : this._bestLanguage(t);
    },
    cancel: function (t) {
      (h(t, "[MapKit] Missing `id` in call to `" + this._name + ".cancel()`."),
        c(t, "number", "[MapKit] `id` passed to `" + this._name + ".cancel()` is not a number."));
      const e = this._requestMap.typeForId(t);
      if (e)
        switch (e) {
          case "query":
          case "geo":
            return this._requestMap.remove(t);
          case "xhr": {
            const e = this._requestMap.get(t);
            if (e) return (e.unschedule(), this._requestMap.remove(t));
            break;
          }
          default:
            throw new Error("Unknown type: " + e);
        }
      return !1;
    },
    handleEvent: function (t) {
      switch (t.type) {
        case dt.Events.Error:
          this._configFailed = !0;
        case dt.Events.Changed:
          this._requestMap.idsByType("query").forEach(function (t) {
            const e = this._requestMap.get(t);
            (this._send(e.path, e.parameters, e.callback, e.transform, e.name), this._requestMap.remove(t));
          }, this);
      }
      0 === this._requestMap.idsByType("query").length && this._stopWatchingConfiguration();
    },
    _watchingConfiguration: !1,
    _watchConfiguration: function () {
      this._watchingConfiguration ||
        ((this._watchingConfiguration = !0),
        dt.addEventListener(dt.Events.Changed, this),
        dt.addEventListener(dt.Events.Error, this));
    },
    _stopWatchingConfiguration: function () {
      this._watchingConfiguration &&
        ((this._watchingConfiguration = !1),
        dt.removeEventListener(dt.Events.Changed, this),
        dt.removeEventListener(dt.Events.Error, this));
    },
    _logNetworkEvent: function (t, e) {
      let i;
      switch (t) {
        case "search":
          i = ke.Events.Search;
          break;
        case "autocomplete":
          i = ke.Events.SearchAC;
          break;
        case "placeLookup":
          i = ke.Events.PlaceLookup;
          break;
        case "geocode":
          i = ke.Events.ForwardGeocoder;
          break;
        case "reverseGeocode":
          i = ke.Events.ReverseGeocoder;
          break;
        case "directions":
          i = ke.Events.Directions;
          break;
        case "nearbyPoi":
          i = ke.Events.PointsOfInterestSearch;
          break;
        default:
          return;
      }
      ke.log(i, e);
    },
    _send: function (t, e, n, o, s) {
      const a = this._requestMap;
      if (!dt.apiBaseUrl || dt.state === dt.States.PENDING)
        return this._configFailed
          ? (setTimeout(function () {
              q(n, null, [new Error("MapKit failed to initialize.")]);
            }),
            0)
          : (this._watchConfiguration(), a.add({path: t, parameters: e, callback: n, transform: o, name: s}, "query"));
      let r;
      ((r = 0 === t.search(/\/v?[0-9]+\//) ? dt.apiBaseUrl.replace(/\/v?[0-9]+\//, "") + t : dt.apiBaseUrl + t),
        ((e = e || {}).mkjsVersion = i.version));
      const l = g(e);
      "" !== l && (r += (t.indexOf("?") > -1 ? "&" : "?") + l);
      const h = {
          loaderDidSucceed: (t, i) => {
            let r;
            if (
              (this._logNetworkEvent(s, {responseCode: i.status}), a.remove(t.id), i.status < 200 || i.status >= 300)
            ) {
              try {
                r = JSON.parse(i.responseText);
              } catch (t) {
                return void q(n, null, [new Error("HTTP error: " + i.status)]);
              }
              r && r.error && r.error.message
                ? (/categor(y|ies)/i.test(r.error.message) &&
                    console.warn("[MapKit] The version of MapKit may be deprecated."),
                  q(n, null, [new Error("HTTP error: " + i.status + ". Message: " + r.error.message + ".")]))
                : q(n, null, [new Error("HTTP error: " + i.status)]);
            } else {
              try {
                r = JSON.parse(i.responseText);
              } catch (t) {
                return void q(n, null, [new Error("Failed to parse response: " + i.responseText)]);
              }
              q(n, null, [null, o(e, r)]);
            }
          },
          loaderDidFail: (t, e) => {
            (this._logNetworkEvent(s, {responseCode: e.status}), a.remove(t.id));
            let i = dt.ErrorStatus.Unknown;
            (0 === e.status
              ? (i = dt.ErrorStatus.NetworkError)
              : e.status === dt.HTTP.UNAUTHORIZED
                ? (i = dt.ErrorStatus.Unauthorized)
                : e.status === dt.HTTP.TOO_MANY_REQUESTS
                  ? (i = dt.ErrorStatus.TooManyRequests)
                  : e.status === dt.HTTP.BAD_REQUEST && (i = dt.ErrorStatus.BadRequest),
              q(n, null, [new Error(i)]));
          }
        },
        c = new np(r, h, dt.appendServiceAuthOptions({}));
      return (c.schedule(), (c.id = a.add(c, "xhr")), c.id);
    },
    _sendImmediatelyOrWithUserLocation: function (t, e, i, n, o) {
      return this.getsUserLocation || e.getsUserLocation
        ? this._sendWithUserLocation.apply(this, arguments)
        : this._send.apply(this, arguments);
    },
    _sendWithUserLocation: function (t, e, i, n, o) {
      const s = this._requestMap.add({path: t, parameters: e, callback: i, transform: n, name: o}, "geo");
      return (
        this._locate((t, e) => {
          const i = this._requestMap.get(s);
          i &&
            (t
              ? console.warn("[MapKit] Unable to get current location:", t.message)
              : (i.parameters.userLocation = [e.latitude, e.longitude].join(",")),
            this._send(i.path, i.parameters, i.callback, i.transform, i.name),
            this._requestMap.remove(s));
        }),
        s
      );
    },
    _checkOptions: function (t, e) {
      (c(t, "object", "[MapKit] The `options` object is invalid."),
        Object.keys(t).forEach(function (t) {
          -1 === e.indexOf(t) && console.warn("[MapKit] `" + t + "` is not a valid option.");
        }));
    },
    _bestLanguage: function (t) {
      (c(t, "string", "[MapKit] `language` is not a string."),
        "zh" === t.toLowerCase() &&
          (console.warn(
            "[MapKit] `zh` is an ambiguous language ID. Please specify a script or reginal variant: `zh-Hans`, `zh-Hant`, or `zh-HK`."
          ),
          dt.countryCode && (t = "zh-" + dt.countryCode)));
      const e = b.bestMatch(t);
      return (null === e && console.warn("[MapKit] " + this._name + ": “" + t + "” is not supported."), e);
    },
    _locate: function (t) {
      (h(t, "Missing callback"),
        c(t, "function"),
        sp.userLocation.locate(
          function (e) {
            const i = e.coords;
            t(null, new We(i.latitude, i.longitude));
          },
          function (e) {
            let i;
            switch (e.code) {
              case e.PERMISSION_DENIED:
                i = "PERMISSION_DENIED";
                break;
              case e.POSITION_UNAVAILABLE:
                i = "POSITION_UNAVAILABLE";
                break;
              case e.TIMEOUT:
                i = "TIMEOUT";
                break;
              default:
                throw new Error("Unknown PositionError code: " + e.code);
            }
            t(new Error(i));
          },
          op
        ));
    }
  }),
    L.jsModules.userLocation
      ? (sp.userLocation = L.jsModules.userLocation)
      : L.addEventListener("load", function t(e) {
          e.jsModules.userLocation && ((sp.userLocation = e.jsModules.userLocation), L.removeEventListener("load", t));
        }));
  const ap = sp;
  function rp() {
    ap.call(this, "PlaceData", {});
  }
  rp.prototype = r(ap, rp, {
    fetch: function (t, e) {
      if ("CN" === dt.countryCode)
        return void setTimeout(function () {
          const t = new Error("[MapKit] MapFeatureAnnotation.fetch() is not supported in China yet.");
          q(e, null, [t]);
        });
      const i = {mapsId: JSON.stringify({muid: t}), lang: dt.language};
      return this._send(
        "placedata",
        i,
        e,
        function (t, e) {
          if (e && e.result) return new ti(e.result);
        },
        "placedata"
      );
    }
  });
  const lp = rp,
    hp = (function (t) {
      function e(e, i, n) {
        (t.call(this, e, i, n), (this._cachedIconMetadata = {}));
      }
      return (
        (e.StaticStyles = t.StaticStyles),
        (e.prototype = r(t, e, {
          featureType: "",
          pointOfInterestCategory: null,
          fetchPlace: function (t) {
            return (
              h(t, "[MapKit] Missing `callback` in call to `MapFeatureAnnotation.fetch()`."),
              c(t, "function", "[MapKit] `callback` passed to `MapFeatureAnnotation.fetch()` is not a function."),
              new lp().fetch(this.muid, t)
            );
          },
          get isAppStyle() {
            return !0;
          },
          ConstructorOptions: Object.freeze(
            Object.assign({}, t.prototype.ConstructorOptions, {
              color: "rw",
              glyphColor: "rw",
              glyphImage: "rw",
              selectedGlyphImage: "rw",
              draggable: "rw",
              appearanceAnimation: "rw",
              anchorOffset: "rw",
              padding: "rw",
              size: "rw",
              glyphText: "rw"
            })
          )
        })),
        e
      );
    })(Yu),
    cp = {PointOfInterest: "PointOfInterest", Territory: "Territory", PhysicalFeature: "PhysicalFeature"};
  function dp(t, e) {
    Object.defineProperty(this, "_impl", {value: new hp(this, t, e)});
  }
  dp.isConstructable = !1;
  const up = function (t, e) {
    if (dp.isConstructable) return dp.call(this, t, e);
    throw new TypeError("[MapKit] MapFeatureAnnotation may not be constructed.");
  };
  function pp() {
    L.jsModules.fromStyleAttributes &&
      ((dp.isConstructable = !0),
      (up.fromStyleAttributes = L.jsModules.fromStyleAttributes),
      (up.IconContext = L.jsModules.IconContext),
      L.removeEventListener("load", pp));
  }
  ((dp.prototype = up.prototype =
    r(tp, up, {
      get featureType() {
        return this._impl.featureType;
      },
      fetchPlace: function (t) {
        return this._impl.fetchPlace(t);
      },
      get pointOfInterestCategory() {
        return this._impl.pointOfInterestCategory;
      },
      get map() {
        return this._impl.map;
      },
      get collisionMode() {
        return this._impl.collisionMode;
      },
      get title() {
        return this._impl.title;
      },
      get subtitle() {
        return this._impl.subtitle;
      },
      get titleVisibility() {
        return this._impl.titleVisibility;
      },
      get subtitleVisibility() {
        return this._impl.subtitleVisibility;
      },
      get accessibilityLabel() {
        return this._impl.accessibilityLabel;
      }
    })),
    (dp.fromMapFeatureRegion = function (t, e, i) {
      const n = !!(t.calloutGlyphImageUrlTemplate && t.metadata && t.metadata.calloutColor),
        o = new dp(new Ye.MapPoint(t.position[0], t.position[1]).toCoordinate(), {
          selected: !0,
          id: cd({muid: t.muid}),
          title: t.title
        });
      switch (
        (t.annotation && (o._impl.subtitle = t.annotation),
        (o._impl.muid = t.muid),
        (o._impl.styleAttributes = t.styleAttributes),
        t.category)
      ) {
        case "Poi":
          o._impl.featureType = cp.PointOfInterest;
          break;
        case "Territory":
          o._impl.featureType = cp.Territory;
          break;
        case "PhysicalFeature":
          o._impl.featureType = cp.PhysicalFeature;
      }
      if (n) {
        o._impl.styleAttributesHasIcon = !0;
        const n = t.metadata;
        ((n.iconVisibility = !("labelIconSource" in n) || 0 !== n.labelIconSource),
          (n.labelVisibility = !("labelTextVisibility" in n) || "Never" !== n.labelTextVisibility),
          (n.styleAttributes = t.styleAttributes),
          (n.context = (t.calloutGlyphImageUrlTemplate.match(/context=(\w+)/) || [])[1]),
          (o._impl.iconContext = n.context));
        const {iconStyle: s, tint: a, emphasis: r} = Uu(e, i);
        ((n.iconStyle = s), (n.tint = a), (n.emphasis = r));
        const l = t.calloutGlyphImageUrlTemplate.replace(/emphasis=(standard|muted)/, "emphasis={{emphasis}}");
        (o._impl.setIconMetadata(n, l),
          (o._impl.enablesDefaultGlyphImage = !1),
          t.poiType && mt[t.poiType] && (o._impl.pointOfInterestCategory = t.poiType));
      }
      return o;
    }),
    L.addEventListener("load", pp),
    pp());
  const mp = dp;
  function gp(t) {
    this._annotationsController = t;
  }
  gp.prototype = {
    getMapFeatureAnnotationForRegion: function (t, e) {
      const i = this._annotationsController.map;
      let n = mp.fromMapFeatureRegion(t, i.mapType, i.tileTint);
      const o = i.annotationForMapFeature;
      return (
        "function" == typeof o && (n = q(o, i.public, [n]) || n),
        (n._impl.selected = !0),
        e && (n._impl.selectionAccessory = e),
        n
      );
    },
    mapFeatureDidSelect: function (t) {
      (this._annotationsController.addItem(t, 0), (t._impl.isMapFeature = !0));
    },
    mapTypeDidChange: function () {
      const t = this._annotationsController.selectedItem;
      t &&
        t._impl.isMapFeature &&
        this._annotationsController.items.indexOf(t) >= 0 &&
        this._annotationsController.removeItem(t);
    },
    annotationSelectionDidChange: function (t) {
      !t.selected &&
        t._impl.isMapFeature &&
        this._annotationsController.items.indexOf(t) >= 0 &&
        this._annotationsController.removeItem(t);
    }
  };
  const _p = gp,
    fp = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
  function yp(t, e, i, n) {
    ((this._memberAnnotations = i), Du.call(this, t, e, n));
  }
  yp.prototype = r(Du, yp, {
    get memberAnnotations() {
      return this._memberAnnotations;
    },
    get n() {
      return this._memberAnnotations.length;
    },
    get title() {
      return fp(this, "_title") ? this._title : this._topAnnotation.title;
    },
    set title(t) {
      Object.getOwnPropertyDescriptor(Sd.prototype, "title").set.call(this, t);
    },
    get subtitle() {
      const t = this.n - 1;
      return fp(this, "_subtitle")
        ? this._subtitle
        : fi.get("Annotation.Clustering.More" + (t > 1 ? ".Plural" : ""), {n: fi.digits(t)});
    },
    set subtitle(t) {
      Object.getOwnPropertyDescriptor(Sd.prototype, "subtitle").set.call(this, t);
    },
    get glyphText() {
      return fp(this, "_glyphText")
        ? this._glyphText
        : fp(this, "_glyphImage") || fp(this, "_selectedGlyphImage")
          ? ""
          : fi.digits(this.n);
    },
    set glyphText(t) {
      Object.getOwnPropertyDescriptor(Du.prototype, "glyphText").set.call(this, t);
    },
    get draggable() {
      return !1;
    },
    set draggable(t) {},
    get displayPriority() {
      return this._topAnnotation.displayPriority;
    },
    set displayPriority(t) {},
    get clusteringIdentifier() {
      return this._topAnnotation.clusteringIdentifier;
    },
    set clusteringIdentifier(t) {},
    get _topAnnotation() {
      return this._memberAnnotations[0];
    },
    get _showDefaultAltText() {
      return fp(this, "_glyphText") || fp(this, "_glyphImage") || fp(this, "_selectedGlyphImage");
    },
    get isAppStyle() {
      return !!this._topAnnotation._impl.isAppStyle;
    },
    get isPlaceStyle() {
      return this.isAppStyle || !1;
    },
    updateLocalizedText: function () {
      (Sd.prototype.updateLocalizedText.call(this), this.updateGlyph(), this._sceneGraphNode.updateAppearance(!0));
    },
    altText: function () {
      return this._showDefaultAltText
        ? Sd.prototype.altText.call(this)
        : this.title
          ? fi.get("Annotation.Clustering.AccessibilityLabel", {
              n: this.glyphText,
              title: this.title,
              subtitle: this.subtitle
            })
          : fi.get("Annotation.Clustering.NoTitle.AccessibilityLabel", {n: this.glyphText, subtitle: this.subtitle});
    }
  });
  const vp = yp;
  function wp(t, e, i) {
    Object.defineProperty(this, "_impl", {value: new vp(this, t, e, i)});
  }
  const bp = function () {
    throw new TypeError("[MapKit] ClusterAnnotation may not be constructed.");
  };
  wp.prototype = bp.prototype = r(Nu, bp, {
    get memberAnnotations() {
      return this._impl.memberAnnotations;
    }
  });
  const Cp = wp,
    kp = dt.performanceMarkers.frameUpdates;
  function Mp(t) {
    ((this._annotationsController = t),
      (this._clusters = []),
      (this._previousClusters = []),
      (this._previousOverlaps = []),
      (this._previousAnnotations = []),
      (this._frameCounter = 0));
  }
  function Sp(t, e) {
    const i = Ad.DisplayPriority.Required,
      n = t.selected ? i : t.displayPriority;
    return (e.selected ? i : e.displayPriority) - n || e._impl.boundingBox.y2 - t._impl.boundingBox.y2;
  }
  function Lp(t, e) {
    return e.displayPriority - t.displayPriority || t._impl.index - e._impl.index;
  }
  function Ap(t, e) {
    return t._impl.collisionMode === Ad.CollisionMode.None || e._impl.collisionMode === Ad.CollisionMode.None
      ? 0
      : t._impl.boundingBox.x1 - e._impl.boundingBox.x1;
  }
  function Ep(t) {
    const e = t._impl.node,
      i = t._impl.nodePosition(),
      n = t.padding,
      o = e.size,
      s = o.width,
      a = o.height,
      r = i.x + n.left,
      l = i.x + s - n.right,
      h = i.y + n.top,
      c = i.y + a - n.bottom;
    if (t._impl.isAppStyle && !t.selected) {
      const e = t._impl.iconRect(),
        i = t._impl.labelRect(),
        n = Math.min(e.size.width, e.size.height) / 2;
      return {
        boundType: "circle",
        x1: e.origin.x,
        x2: e.origin.x + e.size.width,
        y1: e.origin.y,
        y2: e.origin.y + e.size.height,
        cx: e.origin.x + e.size.width / 2,
        cy: e.origin.y + e.size.height / 2,
        r: n / 2,
        padding: 0,
        iconBoundingBox: {
          boundType: "circle",
          x1: e.origin.x,
          x2: e.origin.x + e.size.width,
          y1: e.origin.y,
          y2: e.origin.y + e.size.height,
          cx: e.origin.x + e.size.width / 2,
          cy: e.origin.y + e.size.height / 2,
          r: n,
          padding: 0
        },
        labelBoundingBox: {
          boundType: "rect",
          x1: i.origin.x,
          x2: i.origin.x + i.size.width,
          y1: i.origin.y,
          y2: i.origin.y + i.size.height,
          padding: 1
        }
      };
    }
    return t._impl.collisionMode === Ad.CollisionMode.Circle
      ? {
          boundType: "circle",
          x1: r,
          x2: l,
          y1: h,
          y2: c,
          cx: (r + l) / 2,
          cy: (h + c) / 2,
          r: Math.min(s, a) / 2,
          padding: 5
        }
      : {boundType: "rect", x1: r, x2: l, y1: h, y2: c, padding: 5};
  }
  function xp(t) {
    switch (t.boundType) {
      case "circle":
        return {
          boundType: t.boundType,
          x1: t.x1 - t.padding,
          x2: t.x2 + t.padding,
          y1: t.y1 - t.padding,
          y2: t.y2 + t.padding,
          cx: t.cx,
          cy: t.cy,
          r: t.r + t.padding,
          padding: 0
        };
      case "rect":
        return {
          boundType: t.boundType,
          x1: t.x1 - t.padding,
          x2: t.x2 + t.padding,
          y1: t.y1 - t.padding,
          y2: t.y2 + t.padding,
          padding: 0
        };
    }
  }
  function Tp(t, e) {
    const i = t.cx - a(t.cx, e.x1, e.x2),
      n = t.cy - a(t.cy, e.y1, e.y2);
    return i * i + n * n <= t.r * t.r;
  }
  function Ip(t, e) {
    if (!(e.x2 >= t.x1 && e.x1 <= t.x2 && e.y2 >= t.y1 && e.y1 <= t.y2)) return !1;
    if ("circle" === t.boundType) {
      if ("circle" === e.boundType) {
        const i = t.cx - e.cx,
          n = t.cy - e.cy,
          o = Math.sqrt(i * i + n * n);
        return t.r + e.r >= o;
      }
      return Tp(t, e);
    }
    return "circle" !== e.boundType || Tp(e, t);
  }
  function Rp(t, e) {
    ((t._impl.occluded = e), t._impl.updateVisibility(e));
  }
  Mp.prototype = {
    collideAnnotations: function (t, e, i, n) {
      this._locked ||
        ((this._annotations = t),
        (this._zoomLevel = e),
        (this._rotation = i),
        (this._changesSinceLastCollision = n),
        Qt.scheduleOnNextFrame(this));
    },
    setRequiredClusterAnnotationProperties: function (t, e) {
      return (
        t !== e &&
          (t || (t = e),
          (t.coordinate = e.coordinate),
          (t.draggable = !1),
          (t.displayPriority = e.memberAnnotations[0].displayPriority),
          (t.clusteringIdentifier = e.memberAnnotations[0].clusteringIdentifier),
          Object.defineProperty(t, "memberAnnotations", {
            enumerable: !0,
            get: function () {
              return this._impl.memberAnnotations;
            }
          }),
          Object.defineProperty(t._impl, "memberAnnotations", {enumerable: !0, value: e.memberAnnotations})),
        (t.animates = e.memberAnnotations.some(function (t) {
          return !t._impl.wasCollided;
        })),
        (t.selected = !1),
        t
      );
    },
    removedAnnotation: function (t) {
      t.memberAnnotations ||
        (this._previousClusters = this._previousClusters.filter(function (e) {
          if (e.memberAnnotations.indexOf(t) < 0) return !0;
          this._annotationsController.removeAnyItem(e);
        }, this));
    },
    mapWasDestroyed: function () {
      this._annotationsController = null;
    },
    performScheduledUpdate: function () {
      const t = kp ? performance.now() : void 0;
      if (!this._annotationsController) return;
      if (((this._frameCounter = (this._frameCounter + 1) % 10), 1 !== this._frameCounter))
        return void Qt.scheduleOnNextFrame(this);
      const e = this._needsUpdate();
      if (!e) return;
      ((this._changesSinceLastCollision = !1),
        (this._previousZoomLevel = this._zoomLevel),
        (this._previousRotation = this._rotation),
        (this._previousAnnotations = this._annotations.slice()),
        (this._locked = !0),
        this._annotationsController.willUpdateCollisions(),
        "region" === e && this._annotationsController.deselectClusterAnnotation(),
        (this._overlaps = []));
      let i = 0;
      for (let t = 0, e = this._annotations.length; t < e; ++t) {
        const e = this._annotations[t];
        if (e._impl.needsLayout)
          return ((this._frameCounter = 0), (this._locked = !1), void Qt.scheduleOnNextFrame(this));
        ((e._impl.index = t),
          (e._impl.occluded = !1),
          (e._impl.previousCluster = e._impl.cluster),
          delete e._impl.cluster,
          e._impl.collisionMode !== Ad.CollisionMode.None &&
            ((e._impl.boundingBox = Ep(e)), (i = Math.max(i, e._impl.boundingBox.x2 - e._impl.boundingBox.x1))));
      }
      const n = this._annotations.sort(Ap),
        o = {};
      n.forEach(function (t) {
        if (t.selected || t._impl.collisionMode === Ad.CollisionMode.None) return;
        const e = t.clusteringIdentifier;
        e && (o[e] ? o[e].push(t) : (o[e] = [t]));
      });
      const s = this._clusters;
      this._clusters = [];
      for (const t in o) o[t].length > 1 && (i = this._clusterAnnotationsWithMaxWidth(o[t], i));
      (s.forEach(function (t) {
        this._clusters.indexOf(t) < 0 && (Rp(t, !0), t.selected && (t.selected = !1));
      }, this),
        this._collideAnnotationsAndClusters(n, i),
        this._collideAnnotationLabels([...n, ...this._clusters]),
        (this._previousOverlaps = this._overlaps),
        this._annotationsController.didUpdateCollisions(),
        (this._locked = !1),
        kp && performance.measure("mapkit-map-collision", {start: t}));
    },
    _clusterAnnotationsWithMaxWidth: function (t, e) {
      for (let i = 0; i < t.length; ) {
        const n = t[i];
        if (n._impl.cluster) {
          ++i;
          continue;
        }
        const o = n._impl.boundingBox.x2;
        let s = [n],
          a = i + 1;
        if (n.memberAnnotations && i > 0) {
          const o = n._impl.boundingBox.x1 - e;
          for (a = i - 1; a > 0 && t[a]._impl.boundingBox.x1 >= o; ) a -= 1;
        }
        for (; a < t.length && t[a]._impl.boundingBox.x1 <= o; ++a) {
          const e = t[a];
          !e._impl.cluster && a !== i && this._annotationsOverlapExcludingSelected(n, e) && s.push(e);
        }
        if (s.length > 1) {
          s = s
            .reduce(function (t, e) {
              return (
                e.memberAnnotations
                  ? ((t = t.concat(e.memberAnnotations)), (e._impl.cluster = !0), Rp(e, !0))
                  : t.push(e),
                t
              );
            }, [])
            .sort(Lp);
          const n = this._clusterAnnotationForMemberAnnotations(s);
          for (
            n._impl.occluded = !1,
              n._impl.collisionMode !== Ad.CollisionMode.None &&
                ((n._impl.boundingBox = Ep(n)), (e = Math.max(e, n._impl.boundingBox.x2 - n._impl.boundingBox.x1))),
              delete n._impl.cluster,
              a = 0;
            a < s.length;
            ++a
          )
            ((s[a]._impl.occluded = !0), (s[a]._impl.cluster = n));
          for (a = 0; a < t.length && t[a]._impl.boundingBox.x1 < n._impl.boundingBox.x1; ) a += 1;
          (t.splice(a, 0, n), (i = Math.min(i + 1, a)));
        } else ++i;
      }
      return (
        t.forEach(function (t) {
          t.memberAnnotations &&
            !t._impl.cluster &&
            (this._clusters.push(t), t.map || this._annotationsController.addItem(t));
        }, this),
        e
      );
    },
    _collideAnnotationsAndClusters: function (t, e) {
      let i = !1;
      const n = [];
      for (let e = 0, o = 0, s = t.length, a = this._clusters.length; e < s || o < a; ) {
        const s = t[e],
          a = this._clusters[o];
        s
          ? s._impl.cluster || s._impl.collisionMode === Ad.CollisionMode.None
            ? ++e
            : a && a._impl.boundingBox.x1 < s._impl.boundingBox.x1
              ? (a._impl.isRequired() || (i = !0), n.push(a), ++o)
              : (s._impl.isRequired() || (i = !0), n.push(s), ++e)
          : (a._impl.isRequired() || (i = !0), n.push(a), ++o);
      }
      i && this._collideAnnotationsWithMaxWidth(n, e);
    },
    _collideAnnotationsWithMaxWidth: function (t, e) {
      const i = [];
      for (let e = 0, n = t.length; e < n; ++e) {
        const o = t[e],
          s = o._impl.boundingBox.x2;
        for (let a = e + 1; a < n; ++a) {
          const e = t[a];
          if (e._impl.boundingBox.x1 > s) break;
          (o._impl.isRequired() && e._impl.isRequired()) ||
            (this._annotationsOverlap(o, e) && i.push(Sp(o, e) <= 0 ? [o, e] : [e, o]));
        }
      }
      i.sort(function (t, e) {
        return Sp(t[0], e[0]);
      }).forEach(function (t) {
        t[0]._impl.occluded || (t[1]._impl.occluded = !0);
      });
    },
    _annotationsOverlapExcludingSelected: function (t, e) {
      return !t.selected && !e.selected && this._annotationsOverlap(t, e);
    },
    _annotationsOverlap: function (t, e) {
      if (t._impl.isLifted() || e._impl.isLifted()) return !1;
      const i = Lp(t, e) <= 0 ? [t, e] : [e, t];
      let n;
      for (let t = 0, e = this._previousOverlaps.length; t < e && !n; ++t) {
        const e = this._previousOverlaps[t];
        e[0] === i[0] && e[1] === i[1] && (n = e);
      }
      const o = (function (t, e, i) {
        let n = t._impl.boundingBox,
          o = e._impl.boundingBox;
        return (i && ((n = xp(n)), (o = xp(o))), Ip(n, o));
      })(t, e, n);
      return (o && this._overlaps.push(i), o);
    },
    _clusterAnnotationForMemberAnnotations: function (t) {
      let e;
      const i = (function (t, e) {
        for (let i = 0, n = t.length; i < n; ++i) {
          const n = t[i],
            o = e.length;
          if (n.memberAnnotations.length === o) {
            let t = 0;
            for (; t < o && e[t] === n.memberAnnotations[t]; ) t += 1;
            if (t === o) return i;
          }
        }
        return -1;
      })(this._previousClusters, t);
      if (i >= 0) ((e = this._previousClusters[i]), e._impl.resetNodeTransform());
      else {
        const i = (function (t) {
          let e = 0,
            i = 0,
            n = 0;
          t.forEach(function (t) {
            e += t.coordinate.latitude;
            const o = (Ye.wrapLongitude(t.coordinate.longitude) / 180) * Math.PI;
            ((i += Math.cos(o)), (n += Math.sin(o)));
          });
          const o = t.length,
            s = e / o,
            a = 0 === i ? (n < 0 ? -90 : 90) : (180 * Math.atan(n / i)) / Math.PI + (i < 0 ? 180 : 0);
          return new Ye.Coordinate(s, a);
        })(t);
        ((e = this._annotationsController.addCluster(new Cp(i, t))), this._previousClusters.push(e));
      }
      return e;
    },
    _collideAnnotationLabels(t) {
      for (const e of t) {
        if (e._impl.collisionMode === Ad.CollisionMode.None) {
          e._impl.labelOccluded = !1;
          continue;
        }
        const i = e._impl.boundingBox;
        if (e._impl.occluded) {
          e._impl.labelOccluded = !!i.labelBoundingBox;
          continue;
        }
        if (!i.labelBoundingBox) {
          e._impl.labelOccluded = !1;
          continue;
        }
        const n = xp(i.labelBoundingBox);
        let o = !1;
        for (const i of t)
          if (
            e !== i &&
            !e._impl.occluded &&
            e._impl.collisionMode !== Ad.CollisionMode.None &&
            !i._impl.occluded &&
            i._impl.collisionMode !== Ad.CollisionMode.None
          ) {
            if (
              Ip(n, i._impl.boundingBox.iconBoundingBox ? i._impl.boundingBox.iconBoundingBox : i._impl.boundingBox)
            ) {
              o = !0;
              break;
            }
            if (
              i._impl.boundingBox.labelBoundingBox &&
              !i._impl.labelOccluded &&
              Ip(n, xp(i._impl.boundingBox.labelBoundingBox))
            ) {
              o = !0;
              break;
            }
          }
        e._impl.labelOccluded = o;
      }
    },
    _needsUpdate: function () {
      if (this._zoomLevel !== this._previousZoomLevel || this._rotation !== this._previousRotation) return "region";
      if (this._changesSinceLastCollision) return "annotations";
      const t = this._annotations.length;
      if (this._previousAnnotations.length !== t) return "annotations";
      for (let e = 0; e < t; ++e) if (this._annotations[e] !== this._previousAnnotations[e]) return "annotations";
      return "";
    }
  };
  const Op = Mp;
  function Pp(t) {
    (so.call(this), (this._element = t));
  }
  Pp.prototype = r(so, Pp, {
    get element() {
      return this._element;
    },
    stringInfo: function () {
      return "AnnotationsControllerNode";
    }
  });
  const Dp = Pp;
  function zp(t) {
    ((this._element = qn.htmlElement("div", {class: "mk-style-helper"})), (this.delegate = t));
  }
  zp.prototype = {
    constructor: zp,
    delegate: null,
    get element() {
      return this._element;
    },
    sizeForElement: function (t) {
      const e = t.cloneNode(!0),
        i = [],
        n = [];
      (!(function (t, e, i) {
        if (qn.supportsShadowDOM) {
          if ("slot" === t.localName) (e.push(t), i.push(t.name));
          else {
            const n = t.getElementsByTagName("slot");
            0 !== n.length &&
              Array.prototype.forEach.call(n, function (t) {
                (e.push(t), i.push(t.name));
              });
          }
          e.forEach((t) => {
            t.name = "mk-slot-disabled";
          });
        }
      })(t, i, n),
        this._element.appendChild(e),
        this.delegate &&
          this.delegate.styleHelperNodeDidMoveToParent &&
          this.delegate.styleHelperNodeDidMoveToParent(e));
      let o = e;
      qn.supportsShadowDOM && "slot" === t.localName && (o = e.assignedNodes()[0]);
      const s = (function (t) {
        if (!t || t.nodeType !== window.Node.ELEMENT_NODE) return;
        const e = window.getComputedStyle(t),
          i = parseFloat(e.marginLeft),
          n = parseFloat(e.marginTop),
          o = parseFloat(e.marginRight),
          s = parseFloat(e.marginBottom);
        return Si.rectFromClientRect(t.getBoundingClientRect()).inset(-i, -n, -o, -s);
      })(o);
      return (
        this._element.removeChild(e),
        (function (t, e) {
          qn.supportsShadowDOM &&
            t.forEach((t, i) => {
              t.name = e[i];
            });
        })(i, n),
        s && s.size
      );
    },
    backgroundColorForElement: function (t, e) {
      (this._element.appendChild(t),
        this.delegate &&
          this.delegate.styleHelperNodeDidMoveToParent &&
          this.delegate.styleHelperNodeDidMoveToParent(t));
      let i = t;
      if (qn.supportsShadowDOM && "slot" === t.localName && ((i = t.assignedNodes()[0]), !i))
        return (this._element.removeChild(t), null);
      const n = window.getComputedStyle(i).backgroundColor;
      return (
        e && (i.style.backgroundColor = "transparent"),
        this._element.removeChild(t),
        /^transparent|initial|rgba\(.*, 0\)$/.test(n) ? null : n
      );
    },
    setAnimationForElement: function (t, e, i) {
      let n = t;
      if (qn.supportsShadowDOM && "slot" === t.localName && ((n = t.assignedNodes()[0]), !n)) return;
      n.style.animation = e;
      const o = function (t) {
        t.animationName === i && ((n.style.animation = ""), n.removeEventListener("animationend", o));
      };
      n.addEventListener("animationend", o);
    }
  };
  const Np = zp;
  class Fp extends Rn.Node {
    toString() {
      return this.stringInfo() + " →";
    }
  }
  function Up(t) {
    ((this.hostNode = t), (this._elementNodeMap = {}));
  }
  Up.prototype = {
    constructor: Up,
    appendAssignedElement: function (t, e) {
      const i = t.slot,
        n = new Fp(t);
      ((this._elementNodeMap[i] = n), this.hostNode.addChild(n), e || this.hostNode.element.appendChild(t));
    },
    removeAssignedElement: function (t, e) {
      const i = t.name,
        n = this._elementNodeMap[i];
      (delete this._elementNodeMap[i], this.hostNode.removeChild(n), e || this.hostNode.element.removeChild(n.element));
    },
    getAssignedElement: function (t) {
      return this._elementNodeMap[t.name] ? this._elementNodeMap[t.name].element : null;
    }
  };
  const Gp = Up,
    Bp = 12,
    Zp = 277 / 249,
    Wp = 237 / 249,
    Kp = new ki(243, 311),
    Hp = new ki(180, 70);
  function jp(t, {place: e, muid: i, uiStyle: n, side: o, rtl: s}) {
    (ed.call(this),
      (this.delegate = t),
      (this._node = new Rn.Node(qn.htmlElement("div", {class: `mk-selection-accessory mk-ui-style-${n}`}))));
    const a = this._node.element;
    ((this._tailScale = 1),
      (this._bubbleElement = qn.svgElement("path")),
      (this._svgElement = a.appendChild(
        qn.svgElement("svg", {class: "mk-selection-accessory-bubble"}, this._bubbleElement)
      )),
      (this._containerElement = qn.htmlElement("div")),
      (this._containerElementNode = new Rn.Node(this._containerElement)),
      (this._containerContentElement = this._containerElement.appendChild(qn.htmlElement("div"))),
      (this.uiStyle = n),
      (this._controller = new wi(this._containerContentElement, {
        get colorScheme() {
          return t.tint;
        },
        get place() {
          return e || {muid: i};
        },
        placeCardSizeDidChange: (t, e) => this._placeCardSizeDidChange(t, e),
        loadingDidFail: () => this._placeCardFrameLoadingDidFail(),
        uiStyle: n,
        placeCardDidReveal: (t) => this.delegate.placeCardDidReveal("full" === n ? "LARGE" : "MEDIUM", t),
        placeCardOpenInMapsClicked: (t) =>
          this.delegate.placeCardOpenInMapsClicked("full" === n ? "LARGE" : "MEDIUM", t)
      })),
      (this.side = o),
      this._controller.update(),
      this._containerElementNode.classList.add("mk-selection-accessory-content"),
      s && this._containerElementNode.classList.add("mk-rtl"),
      a.appendChild(this._containerElement),
      (this._rtl = s),
      (this._loadingCanvasElement = qn.htmlElement("canvas", {
        "aria-hidden": "true",
        class: "mk-selection-accessory-loading"
      })),
      this._containerElement.appendChild(this._loadingCanvasElement),
      (this._node.wantsHardwareCompositing = !0));
  }
  function Vp(t, e, i, n) {
    const o = 15 * e,
      s = Bp * e,
      a = t.width / 2 - o,
      r = t.height / 2 - o,
      l = 10 * e,
      h = 12 * e;
    return (
      "M0,18c0,-9.972 8.028,-18 18,-18" +
      ("bottom" === i
        ? "h" +
          (-n + a) +
          "c" +
          l +
          ",0 " +
          h +
          "," +
          -s +
          " " +
          o +
          "," +
          -s +
          "c" +
          (-h + o) +
          ",0 " +
          (-l + o) +
          "," +
          s +
          " " +
          o +
          "," +
          s +
          "h" +
          (n + a)
        : "h" + t.width) +
      "c9.972,0 18,8.028 18,18" +
      ("left" === i
        ? "v" +
          r +
          "c0," +
          l +
          " " +
          s +
          "," +
          h +
          " " +
          s +
          "," +
          o +
          "c0," +
          (-h + o) +
          " " +
          -s +
          "," +
          (-l + o) +
          " " +
          -s +
          "," +
          o +
          "v" +
          r
        : "v" + t.height) +
      "c0,9.972 -8.028,18 -18,18" +
      ("top" === i
        ? "h" +
          (-n - a) +
          "c" +
          -l +
          ",0 " +
          -h +
          "," +
          s +
          " " +
          -o +
          "," +
          s +
          "c" +
          (h - o) +
          ",0 " +
          (l - o) +
          "," +
          -s +
          " " +
          -o +
          "," +
          -s +
          "h" +
          (n - a)
        : "h" + -t.width) +
      "c-9.972,0 -18,-8.028 -18," +
      -18 +
      ("right" === i
        ? "v" +
          -r +
          "c0," +
          -l +
          " " +
          -s +
          "," +
          -h +
          " " +
          -s +
          "," +
          -o +
          "c0," +
          (h - o) +
          " " +
          s +
          "," +
          (l - o) +
          " " +
          s +
          "," +
          -o +
          "v" +
          -r
        : "z")
    );
  }
  ((jp.prototype = r(ed, jp, {
    _tailXAxisShift: 0,
    get node() {
      return this._node;
    },
    get boundingRect() {
      const t = this._node.position;
      return new Si(t.x, t.y, this._node.size.width, this._node.size.height);
    },
    delegate: null,
    willMoveToMap: function () {
      this._node.transform = new mn().scale(0);
    },
    setAnchorOffset: function (t) {},
    containsElement: function (t) {
      return t !== this._svgElement && !!this._containerElement.contains(t);
    },
    isCustomCallout: function () {
      return !1;
    },
    updateInfo: function (t, e) {
      const i = this.placeCardSize ? this.placeCardSize.copy() : "full" === this.uiStyle ? Kp.copy() : Hp.copy();
      return (this._updateSize(i), this.updatePosition(), !0);
    },
    setPositionWithSide(t, e) {
      switch (((this.side = e), e)) {
        case "top":
          t.y += -12 * this._tailScale;
          break;
        case "left":
          ((t.x -= this._node.size.width / 2 + Bp * this._tailScale), (t.y += this._node.size.height / 2));
          break;
        case "right":
          ((t.x += this._node.size.width / 2 + Bp * this._tailScale), (t.y += this._node.size.height / 2));
          break;
        case "bottom":
          t.y += this._node.size.height + Bp * this._tailScale;
      }
      return this.setPosition(t);
    },
    shiftTailBy: function (t) {
      if ("left" === this.side || "right" === this.side)
        return (
          (this._tailXAxisShift = 0),
          this._bubbleElement.setAttribute("d", Vp(this._bubbleSize, this._tailScale, this.side, this._tailXAxisShift)),
          0
        );
      const e = Math.max(0, (this._bubbleSize.width - 36) / 2);
      return (
        (this._tailXAxisShift = t < 0 ? Math.min(e, -t) : -Math.min(e, t)),
        this._bubbleElement.setAttribute("d", Vp(this._bubbleSize, this._tailScale, this.side, this._tailXAxisShift)),
        (this._node.position = new Mi(this._node.position.x + this._tailXAxisShift, this._node.position.y)),
        this._tailXAxisShift
      );
    },
    animateIn: function () {
      if (!this.animates) return ((this.animatedIn = !0), void (this._node.transform = new mn()));
      this.animatedIn ||
        ((this.animatedIn = !0),
        this._setScaleOffsets(),
        (this._scaleAnimationParameterIndex = 0),
        (this._scaleAnimationStartDate = Date.now()),
        Qt.scheduleOnNextFrame(this));
    },
    animateOut: function (t) {
      !t && this.visible
        ? (this._scaleAnimationStartDate && this._finishAnimatingScale(),
          (this._fadeoutAnimationStartDate = Date.now()),
          Qt.scheduleOnNextFrame(this))
        : this._node.remove();
    },
    mapNodeTintWasSet(t) {
      (this.updateInfo(), this._controller.update());
    },
    performScheduledUpdate: function () {
      (this._scaleAnimationStartDate && this._animateScale(),
        this._fadeoutAnimationStartDate && this._animateFadeout());
    },
    didRemoveFromParent: function () {
      this.delegate.accessoryNodeDidRemove(this);
    },
    setSize: function (t) {
      const e = Bp * this._tailScale,
        i = t.width + 20 + 2 * e,
        n = t.height + 20 + 2 * e,
        o = -10.5 - e,
        s = -10.5 - e;
      ((this._svgElement.style.width = i + "px"),
        (this._svgElement.style.height = n + "px"),
        (this._svgElement.style.top = o + "px"),
        (this._svgElement.style.left = s + "px"),
        this._svgElement.setAttribute("viewBox", `${s} ${o} ${i} ${n}`),
        ed.prototype.setSize.call(this, t));
    },
    _placeCardSizeDidChange(t, e) {
      if (0 === t || 0 === e) return;
      let i;
      switch ((this._placeCardDidLoad(), this.uiStyle)) {
        case "full":
          i = new ki(Kp.width, Math.min(600, this.delegate.getMaximumSizeForAccessory().height, e));
          break;
        case "compact":
          i = new ki(t, e);
          break;
        default:
          i = new ki();
      }
      ((this.placeCardSize = i.copy()), this._updateSize(i), this.delegate.accessorySizeDidChange(this));
    },
    _updateLoadingCanvas(t) {
      const e = this._loadingCanvasElement;
      if (!e) return;
      ((e.width = t.width * qn.devicePixelRatio), (e.height = t.height * qn.devicePixelRatio));
      const i = e.getContext("2d");
      if (
        (i.scale(qn.devicePixelRatio, qn.devicePixelRatio),
        this._rtl && (i.translate(t.width, 0), i.scale(-1, 1)),
        "full" === this.uiStyle)
      ) {
        const e = t.width - 18 - 0.2 * t.width * Math.random();
        i.roundRect(9, 12, e, 20, 5);
        const n = t.width - 18 - 0.2 * t.width * Math.random();
        (i.roundRect(9, 36, n, 13, 5),
          (i.fillStyle = this.delegate.tint === Vi ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"),
          i.fill());
        const o = t.width - 18,
          s = 61,
          a = 46,
          r = t.height - s - 12 - a - 12,
          l = s + r + 12;
        (i.beginPath(),
          i.roundRect(9, s, o, r, 10),
          i.roundRect(9, l, o, a, 10),
          (i.fillStyle = this.delegate.tint === Vi ? "#ffffff" : "#242628"),
          i.fill());
        const h = 50,
          c = [1, 1, 1, 1];
        ((c[Math.floor(4 * Math.random())] += 1), (c[Math.floor(4 * Math.random())] += 1));
        let d = s + 9;
        i.beginPath();
        for (const e of c) {
          (i.roundRect(21, d, h, 11, 5), (d += 13));
          for (let n = 0; n < e; n++)
            (i.roundRect(21, d, t.width - 42 - 0.2 * t.width * Math.random(), 13, 5),
              (d += 13 + (n + 1 === e ? 9 : 2)));
        }
        (i.arc(35, l + 9 + 14, 14, 0, 2 * Math.PI),
          i.roundRect(58, l + 9 + 7, t.width - 42 - 37 - 0.2 * t.width * Math.random(), 14, 5),
          (i.fillStyle = this.delegate.tint === Vi ? "rgba(0, 0, 0, 0.03)" : "rgba(255, 255, 255, 0.03)"),
          i.fill());
      } else {
        let e = 12;
        for (; e <= t.height - 12; ) {
          const n = t.width - 32 - 0.2 * t.width * Math.random();
          (i.roundRect(16, e, n, 12, 5), (e += 18));
        }
        ((i.fillStyle = this.delegate.tint === Vi ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"), i.fill());
      }
    },
    _placeCardDidLoad() {
      (this._removeLoadingCanvas(), this._removeLoadingFailureLabel());
    },
    _removeLoadingCanvas() {
      this._loadingCanvasElement &&
        (this._containerElement.removeChild(this._loadingCanvasElement), (this._loadingCanvasElement = null));
    },
    _placeCardFrameLoadingDidFail() {
      (this._removeLoadingCanvas(),
        (this._loadingFailureLabel = qn.htmlElement("div", {class: "mk-selection-accessory-failed"})),
        this._containerElement.appendChild(this._loadingFailureLabel));
      const t = this._loadingFailureLabel.appendChild(qn.htmlElement("div", {class: "mk-failed-labels"}));
      (t.appendChild(qn.htmlElement("p", fi.get("Place.Error.Title"))),
        t.appendChild(qn.htmlElement("p", fi.get("Place.Error.Message"))));
      const e = "full" === this.uiStyle ? Kp.copy() : Hp.copy();
      ((e.height = t.offsetHeight), this._updateSize(e), this.delegate.accessorySizeDidChange(this));
    },
    _removeLoadingFailureLabel() {
      this._loadingFailureLabel &&
        (this._containerElement.removeChild(this._loadingFailureLabel), (this._loadingFailureLabel = null));
    },
    _updateSize: function (t) {
      this._updateLoadingCanvas(t);
      const e = t.width - this.node.size.width;
      ((this._tailXAxisShift = Math.max(0, this._tailXAxisShift + Math.min(0, e))),
        (this._containerElement.style.width = t.width + "px"),
        (this._containerElement.style.height = t.height + "px"),
        (t.height += 36),
        (t.height -= 36),
        this.setSize(t),
        (this._bubbleSize = new ki(t.width - 36, t.height - 36)),
        this._bubbleElement.setAttribute("d", Vp(this._bubbleSize, this._tailScale, this.side, this._tailXAxisShift)),
        (this._scaleXOffset || this._scaleYOffset) && this._setScaleOffsets());
    },
    _setScaleOffsets() {
      const t = this._node.size,
        e = Bp * this._tailScale;
      switch (this.side) {
        case "top":
          ((this._scaleXOffset = -this._tailXAxisShift), (this._scaleYOffset = t.height / 2));
          break;
        case "left":
          ((this._scaleXOffset = t.width / 2 + e), (this._scaleYOffset = -e / 2));
          break;
        case "right":
          ((this._scaleXOffset = -t.width / 2 - e), (this._scaleYOffset = -e / 2));
          break;
        case "bottom":
          ((this._scaleXOffset = -this._tailXAxisShift), (this._scaleYOffset = -t.height / 2));
      }
    },
    _scaleAnimationParameters: [
      [8e3 / 60, 30 / 249, Zp],
      [5e3 / 60, Zp, Wp],
      [5e3 / 60, Wp, 1]
    ],
    _animateScale: function () {
      const t = this._scaleAnimationParameters[this._scaleAnimationParameterIndex],
        e = t[0],
        i = t[1],
        n = t[2],
        o = Date.now(),
        s = Math.min((o - this._scaleAnimationStartDate) / e, 1),
        a = i + (n - i) * s;
      if (
        ((this._node.transform = new mn()
          .translate(this._scaleXOffset, this._scaleYOffset)
          .scale(a)
          .translate(-this._scaleXOffset, -this._scaleYOffset)),
        1 === s)
      ) {
        if (
          (++this._scaleAnimationParameterIndex,
          !(this._scaleAnimationParameterIndex < this._scaleAnimationParameters.length))
        )
          return void this._finishAnimatingScale();
        this._scaleAnimationStartDate = o;
      }
      Qt.scheduleOnNextFrame(this);
    },
    _finishAnimatingScale: function () {
      (delete this._scaleXOffset,
        delete this._scaleYOffset,
        delete this._scaleAnimationStartDate,
        delete this._scaleAnimationParameterIndex);
    },
    _animateFadeout: function () {
      const t = (Date.now() - this._fadeoutAnimationStartDate) / 100,
        e = Math.max(0, 1 - t);
      0 !== e ? ((this._node.opacity = e), Qt.scheduleOnNextFrame(this)) : this._node.remove();
    },
    animateTailScale: function (t, e) {},
    animateAnchorOffset: function (t, e) {},
    getCenterOffset: function (t) {}
  })),
    (jp.DEFAULT_FULL_SIZE = Kp),
    (jp.DEFAULT_COMPACT_SIZE = Hp),
    (jp.TAIL_LENGTH = Bp),
    (jp.TAIL_DISTANCE_TO_ANCHOR = 8));
  const qp = jp,
    Yp = 10.5,
    Xp = 3.58028186,
    $p = 277 / 249,
    Jp = 237 / 249,
    Qp = "white",
    tm = 10,
    em = 10,
    im = {left: 4, right: 4},
    nm = 7.5,
    om = 10,
    sm = 7.5,
    am = 7.5,
    rm = "mk-no-subtitle";
  class lm extends Rn.Node {
    constructor(t) {
      (super(qn.htmlElement("div", {class: "mk-callout", style: "direction: ltr"})), (this._callout = t));
    }
    didMoveToParent(t) {
      null === t && this._callout.didRemoveFromParent();
    }
  }
  function hm(t, e) {
    (ed.call(this), (this.delegate = t), (this._rtl = e.rtl), (this._node = new lm(this)));
    const i = this._node.element;
    function n(e) {
      return t.backgroundColorForElement(e, !0);
    }
    function o(t, e) {
      const i = qn.htmlElement("div", {class: "mk-callout-accessory-content"}, t);
      return (
        (i.style.maxWidth = "186.5px"),
        e && (i.style.padding = "0"),
        qn.htmlElement("div", {class: "mk-callout-accessory"}, i)
      );
    }
    (e.customElement
      ? ((this._containerElement = this._customElement = e.customElement),
        this.setSize(this.delegate.sizeForElement(this._customElement)),
        i.appendChild(e.customElement))
      : ((this._ignoreCalloutCornerRadiusForLeftAccessory = e.ignoreCalloutCornerRadiusForLeftAccessory),
        (this._tailScale = e.tailScale || 1),
        (this._bubbleElement = qn.svgElement("path")),
        (this._svgElement = i.appendChild(qn.svgElement("svg", {class: "mk-bubble"}, this._bubbleElement))),
        (this._containerElement = qn.htmlElement("div")),
        (this._containerElementNode = new Rn.Node(this._containerElement)),
        e.leftAccessory &&
          ((this._leftAccessoryBackgroundColor = n(e.leftAccessory)),
          (this._leftAccessory = o(e.leftAccessory, !this._rtl && this._ignoreCalloutCornerRadiusForLeftAccessory)),
          this._containerElement.appendChild(this._leftAccessory)),
        (this._containerContentElement = this._containerElement.appendChild(qn.htmlElement("div"))),
        (this._containerContentElement.className = "mk-callout-content"),
        e.rightAccessory &&
          ((this._rightAccessoryBackgroundColor = n(e.rightAccessory)),
          (this._rightAccessory = o(e.rightAccessory, this._rtl && this._ignoreCalloutCornerRadiusForLeftAccessory)),
          this._containerElement.appendChild(this._rightAccessory)),
        (this._leftAccessoryBackgroundColor || this._rightAccessoryBackgroundColor) &&
          ((this._calloutId = dm()),
          (this._linearGradientElement = qn.svgElement("linearGradient", {id: this._calloutId})),
          this._svgElement.appendChild(qn.svgElement("defs", this._linearGradientElement))),
        e.contentElement
          ? this._setContentElement(e.contentElement)
          : (this._containerElementNode.classList.add("mk-standard"),
            e.rtl && (this._containerContentElement.className += " mk-rtl")),
        i.appendChild(this._containerElement)),
      e.position && this.setPosition(e.position),
      (this._node.wantsHardwareCompositing = !0));
  }
  function cm(t, e, i) {
    const n = 17 * e,
      o = 13 * e,
      s = t.width / 2 - n,
      a = 10 * e,
      r = 12 * e;
    return (
      "M0,10.5c0,-6.9197181400000005 3.5826363,-10.5 10.5,-10.5h" +
      t.width +
      "c6.9173637,0 10.5," +
      Xp +
      " 10.5,10.5v" +
      t.height +
      "c0,6.9197181400000005 " +
      "-3.5826363,10.5 -10.5,10.5h" +
      (-i - s) +
      "c" +
      -a +
      ",0 " +
      -r +
      "," +
      o +
      " " +
      -n +
      "," +
      o +
      "c" +
      (r - n) +
      ",0 " +
      (a - n) +
      "," +
      -o +
      " " +
      -n +
      "," +
      -o +
      "h" +
      (i - s) +
      "c-6.9173637,0 -10.5," +
      -Xp +
      " -10.5,-10.5z"
    );
  }
  function dm() {
    const t = Math.random().toString(36).substr(2);
    return document.getElementById(t) ? dm() : t;
  }
  hm.prototype = r(ed, hm, {
    _tailShift: 0,
    get node() {
      return this._node;
    },
    get boundingRect() {
      const t = this._node.position;
      return new Si(t.x, t.y, this._node.size.width, this._node.size.height);
    },
    delegate: null,
    willMoveToMap: function () {
      this._node.transform = new mn().scale(0);
    },
    setAnchorOffset: function (t) {
      this._anchorOffset = t ? new window.DOMPoint(t.x, t.y) : new window.DOMPoint();
    },
    containsElement: function (t) {
      if (t === this._svgElement) return !1;
      if (this._containerElement.contains(t)) return !0;
      if (!qn.supportsShadowDOM || !this.isCustomCallout()) return !1;
      const e = this.customOrContentElement.assignedNodes()[0];
      return !!e && e.contains(t);
    },
    isCustomCallout: function () {
      return !!this.customOrContentElement;
    },
    get customOrContentElement() {
      return this._customElement || this._contentElement;
    },
    get customLeftAccessory() {
      if (this._leftAccessory) return this._leftAccessory.firstChild.firstChild;
    },
    get customRightAccessory() {
      if (this._rightAccessory) return this._rightAccessory.firstChild.firstChild;
    },
    updateInfo: function (t, e) {
      if (this.isCustomCallout()) return !0;
      if (!t || !t.title) return !1;
      ((this._containerContentElement.innerHTML = ""),
        (this._containerElement.style.width = ""),
        this._containerContentElement.classList.add("mk-standard-content"),
        this._containerContentElement.appendChild(qn.htmlElement("div", {class: "mk-title", dir: "auto"}, t.title)),
        t.subtitle
          ? (this._containerContentElement.appendChild(
              qn.htmlElement("div", {class: "mk-subtitle", dir: "auto"}, t.subtitle)
            ),
            this._containerElementNode.classList.remove(rm))
          : (this._containerElementNode.classList.add(rm),
            this._containerElementNode.classList.toggle(
              "mk-no-accessories",
              !this._leftAccessory && !this._rightAccessory
            )),
        this._updateAccessoryViews(),
        (this._containerElement.className = this._containerElementNode.classList.toString()));
      const i = this.delegate.sizeForElement(this._containerElement),
        n =
          t.map._impl.ensureVisibleFrame().size.width -
          2 * e -
          this._extraWidth(this._ignoreCalloutCornerRadiusForLeftAccessory);
      return (
        (i.width = a(i.width, 74, a(n, 74, 373))),
        0 !== this._accessoryHeight && (i.height = Math.max(this._accessoryHeight, i.height)),
        this._updateSize(i, !1),
        this.updatePosition(),
        !0
      );
    },
    shiftTailBy: function (t) {
      if (this._customElement) return 0;
      const e = Math.max(0, (this._bubbleSize.width - 74 - Yp) / 2);
      return (
        (this._tailShift = t < 0 ? Math.min(e, -t) : -Math.min(e, t)),
        this._bubbleElement.setAttribute("d", cm(this._bubbleSize, this._tailScale, this._tailShift)),
        (this._node.position = new Mi(this._node.position.x + this._tailShift, this._node.position.y)),
        this._tailShift
      );
    },
    animateIn: function () {
      if (!this.animates || (this.animates && this._customElement && !this.appearanceAnimation))
        this._node.transform = new mn();
      else {
        if (this._appearanceAnimationName)
          return (
            (this._node.transform = new mn()),
            void this.delegate.setAnimationForElement(
              this._containerElement,
              this._appearanceAnimation,
              this._appearanceAnimationName
            )
          );
        ((this._scaleXOffset = -this._tailShift),
          (this._scaleYOffset = this._node.size.height / 2),
          (this._scaleAnimationParameterIndex = 0),
          (this._scaleAnimationStartDate = Date.now()),
          Qt.scheduleOnNextFrame(this));
      }
    },
    animateOut: function (t) {
      !t && this.visible
        ? (this._scaleAnimationStartDate && this._finishAnimatingScale(),
          (this._fadeoutAnimationStartDate = Date.now()),
          Qt.scheduleOnNextFrame(this))
        : this._node.remove();
    },
    mapNodeTintWasSet(t) {},
    performScheduledUpdate: function () {
      (this._scaleAnimationStartDate && this._animateScale(),
        this._fadeoutAnimationStartDate && this._animateFadeout(),
        this._tailAnimation && this._animateTail(),
        this._anchorOffsetAnimation && this._animateAnchorOffset());
    },
    didRemoveFromParent: function () {
      this.delegate.accessoryNodeDidRemove(this);
    },
    setSize: function (t) {
      (this._svgElement &&
        ((this._svgElement.style.width = t.width + "px"),
        (this._svgElement.style.height = t.height + "px"),
        this._svgElement.setAttribute("viewBox", "-0.5 -0.5 " + t.width + " " + t.height)),
        ed.prototype.setSize.call(this, t));
    },
    _updateSize: function (t, e) {
      const i = this._ignoreCalloutCornerRadiusForLeftAccessory,
        n = t.width - this.node.size.width - 22;
      ((this._tailShift = Math.max(0, this._tailShift + Math.min(0, n))),
        (this._containerElement.style.width = t.width + "px"));
      const o = this._extraWidth(i),
        s = 13 * this._tailScale,
        a = 22 + s;
      t.width += o;
      const r = t.height,
        l = (i ? 55 : 50) + s;
      ((t.height += a), (t.height -= Yp), (t.height = e ? t.height : Math.max(t.height, l)));
      const h = e ? 0 : 5.5,
        c = (t.height - r - s) / 2;
      this._containerElement.style.top = r / 2 + Math.max(h, c) + "px";
      const d = sm,
        u = am;
      let p;
      ((this._containerElement.style.left = d + "px"),
        this.setSize(t),
        (this._bubbleSize = new ki(t.width - 22, t.height - 22 - s)),
        this._bubbleElement.setAttribute("d", cm(this._bubbleSize, this._tailScale, this._tailShift)),
        this._leftAccessoryBackgroundColor &&
          ((p = (100 * (this._leftAccessoryWidth + d)) / t.width),
          this._updateAccessoryViewBackground(p, this._leftAccessoryBackgroundColor, Qp)),
        this._rightAccessoryBackgroundColor &&
          ((p = 100 - (100 * (this._rightAccessoryWidth + u)) / t.width),
          this._updateAccessoryViewBackground(p, Qp, this._rightAccessoryBackgroundColor)));
    },
    _extraWidth: function (t) {
      return t ? nm + om : tm + em - im.left;
    },
    _updateAccessoryViews: function () {
      if (((this._accessoryHeight = 0), this._leftAccessory)) {
        const t = this.delegate.sizeForElement(this._leftAccessory.children[0]);
        ((this._leftAccessoryWidth =
          (!this._rtl && this._ignoreCalloutCornerRadiusForLeftAccessory ? 0 : Yp) + t.width),
          (this._accessoryHeight = t.height),
          (this._leftAccessory.style.width = this._leftAccessoryWidth + "px"),
          this._ignoreCalloutCornerRadiusForLeftAccessory &&
            !this._rtl &&
            ((this._leftAccessory.style.height = this._leftAccessoryWidth + "px"),
            (this._leftAccessory.style.overflow = "visible")),
          (this._containerContentElement.style.marginLeft = this._leftAccessoryWidth + "px"));
      }
      if (this._rightAccessory) {
        const t = this.delegate.sizeForElement(this._rightAccessory.children[0]);
        ((this._rightAccessoryWidth =
          (this._rtl && this._ignoreCalloutCornerRadiusForLeftAccessory ? 0 : Yp) + t.width),
          (this._accessoryHeight = Math.max(this._accessoryHeight, t.height)),
          (this._rightAccessory.style.width = this._rightAccessoryWidth + "px"),
          this._ignoreCalloutCornerRadiusForLeftAccessory &&
            this._rtl &&
            ((this._rightAccessory.style.height = this._rightAccessoryWidth + "px"),
            (this._rightAccessory.style.overflow = "visible")),
          (this._containerContentElement.style.marginRight = this._rightAccessoryWidth + "px"));
      }
    },
    _updateAccessoryViewBackground: function (t, e, i) {
      (this._linearGradientElement.appendChild(qn.svgElement("stop", {offset: t + "%", "stop-color": "" + e})),
        this._linearGradientElement.appendChild(qn.svgElement("stop", {offset: t + "%", "stop-color": "" + i})),
        (this._bubbleElement.style.fill = "url(#" + this._calloutId + ")"));
    },
    _setContentElement: function (t) {
      (this._updateAccessoryViews(),
        (this._contentElement = t),
        this._containerContentElement.appendChild(qn.htmlElement("div", t)),
        this._containerElementNode.classList.add("mk-custom-content"),
        (this._containerElement.className = this._containerElementNode.classList.toString()));
      const e = this.delegate.sizeForElement(this._containerElement);
      ((e.height = Math.max(e.height, this._accessoryHeight)), this._updateSize(e, !0));
    },
    _scaleAnimationParameters: [
      [8e3 / 60, 30 / 249, $p],
      [5e3 / 60, $p, Jp],
      [5e3 / 60, Jp, 1]
    ],
    _animateScale: function () {
      const t = this._scaleAnimationParameters[this._scaleAnimationParameterIndex],
        e = t[0],
        i = t[1],
        n = t[2],
        o = Date.now(),
        s = Math.min((o - this._scaleAnimationStartDate) / e, 1),
        a = i + (n - i) * s;
      if (
        ((this._node.transform = new mn()
          .translate(this._scaleXOffset, this._scaleYOffset)
          .scale(a)
          .translate(-this._scaleXOffset, -this._scaleYOffset)),
        1 === s)
      ) {
        if (
          (++this._scaleAnimationParameterIndex,
          !(this._scaleAnimationParameterIndex < this._scaleAnimationParameters.length))
        )
          return void this._finishAnimatingScale();
        this._scaleAnimationStartDate = o;
      }
      Qt.scheduleOnNextFrame(this);
    },
    _finishAnimatingScale: function () {
      (delete this._scaleXOffset,
        delete this._scaleYOffset,
        delete this._scaleAnimationStartDate,
        delete this._scaleAnimationParameterIndex);
    },
    _animateFadeout: function () {
      const t = (Date.now() - this._fadeoutAnimationStartDate) / 100,
        e = Math.max(0, 1 - t);
      0 !== e ? ((this._node.opacity = e), Qt.scheduleOnNextFrame(this)) : this._node.remove();
    },
    animateTailScale: function (t, e) {
      const i = new Date().getTime();
      ((e = e || 0 === e ? e : 500),
        (this._tailAnimation = {timeStart: i, timeEnd: i + e, valueStart: this._tailScale, valueEnd: t}),
        this._animateTail());
    },
    _animateTail: function () {
      if (!this._tailAnimation) return;
      const t = new Date().getTime(),
        e = this._tailAnimation.timeStart,
        i = this._tailAnimation.timeEnd,
        n = this._tailAnimation.valueStart,
        o = this._tailAnimation.valueEnd,
        s = i <= e ? 1 : (t - e) / (i - e),
        r = qn.easeInOut(a(s, 0, 1)),
        l = qn.lerp(r, n, o),
        h = 13 * (l - this._tailScale);
      ((this._tailScale = l),
        this.setSize(new ki(this.node.size.width, this.node.size.height + h)),
        this._bubbleElement.setAttribute("d", cm(this._bubbleSize, this._tailScale, this._tailShift)),
        t < i ? Qt.scheduleOnNextFrame(this) : (this._tailAnimation = null));
    },
    animateAnchorOffset: function (t, e) {
      const i = new Date().getTime();
      ((e = e || 0 === e ? e : 500),
        (this._anchorOffsetAnimation = {
          timeStart: i,
          timeEnd: i + e,
          startX: this._anchorOffset.x,
          startY: this._anchorOffset.y,
          endX: t.x,
          endY: t.y
        }),
        this._animateAnchorOffset());
    },
    _animateAnchorOffset: function () {
      if (!this._anchorOffsetAnimation) return;
      const t = new Date().getTime(),
        e = this._anchorOffsetAnimation.timeStart,
        i = this._anchorOffsetAnimation.timeEnd,
        n = this._anchorOffsetAnimation.startX,
        o = this._anchorOffsetAnimation.endX,
        s = this._anchorOffsetAnimation.startY,
        r = this._anchorOffsetAnimation.endY,
        l = i <= e ? 1 : (t - e) / (i - e),
        h = qn.easeInOut(a(l, 0, 1)),
        c = qn.lerp(h, n, o),
        d = qn.lerp(h, s, r);
      ((this._anchorOffset.x = c),
        (this._anchorOffset.y = d),
        this.updatePosition(),
        t < i ? Qt.scheduleOnNextFrame(this) : (this._anchorOffsetAnimation = null));
    },
    getCenterOffset: function (t) {
      const e = 13 * this._tailScale,
        i = this._node.size;
      return new Mi(0, (e - i.height - (t ? 13 : 0)) / 2);
    }
  });
  const um = hm,
    pm = class extends ed {
      constructor(t, {place: e = {}, muid: i, coordinate: n, title: o}) {
        (super(),
          (this.style = ud.OpenInMaps),
          (this.placeUrl = this._getPlaceUrl(e, i, n, o)),
          (this.delegate = t),
          (this._node = new Rn.Node(qn.htmlElement("div", {class: "mk-selection-accessory-badge"}))));
        const s = this._node.element;
        ((this._containerElement = qn.htmlElement("button", {
          role: "link",
          dir: "auto",
          type: "button",
          class: "mk-selection-accessory-badge-content"
        })),
          (this.handleLinkClickedListener = (t) => this._handleLinkClicked()),
          this._containerElement.addEventListener("click", this.handleLinkClickedListener),
          (this._containerElementNode = new Rn.Node(this._containerElement)),
          (this._handleLocaleChangedListener = (t) => this._handleLocaleChanged(t)),
          fi.addEventListener(fi.Events.LocaleChanged, this._handleLocaleChangedListener),
          (this._textElement = this._containerElement.appendChild(qn.htmlElement("span"))),
          (this._textElement.textContent = fi.get("OpenInAppleMaps.Label")),
          s.appendChild(this._containerElement),
          this.setSize(this.delegate.sizeForElement(s)),
          (this._node.wantsHardwareCompositing = !0),
          (this.analyticsState = {place_action_details: {businessID: e.muid || i}}),
          this.delegate.placeCardDidReveal("SMALL", this.analyticsState));
      }
      get node() {
        return this._node;
      }
      get boundingRect() {
        const t = this._node.position;
        return new Si(t.x, t.y, this._node.size.width, this._node.size.height);
      }
      setPosition(t) {
        ((t.y += this._node.size.height), ed.prototype.setPosition.call(this, t));
      }
      willMoveToMap() {}
      setAnchorOffset(t) {
        this._anchorOffset = t ? new window.DOMPoint(t.x, t.y) : new window.DOMPoint();
      }
      containsElement(t) {
        return !!this._containerElement.contains(t);
      }
      isCustomCallout() {
        return !1;
      }
      updateInfo(t, e) {
        return !0;
      }
      shiftTailBy() {
        return 0;
      }
      animateIn() {}
      animateOut(t) {
        ((!t && this.visible) || this._node.remove(),
          this._containerElementNode.classList.add("mk-fade-out"),
          setTimeout(() => this._node.remove(), 500));
      }
      mapNodeTintWasSet(t) {}
      didRemoveFromParent() {
        (this.delegate.accessoryNodeDidRemove(this),
          fi.removeEventListener(fi.Events.LocaleChanged, this._handleLocaleChangedListener),
          this._containerElement.removeEventListener("click", this.handleLinkClickedListener));
      }
      _getPlaceUrl(t = {}, e, i, n) {
        const o = new URLSearchParams();
        return (
          (t.name || n) && o.append("q", t.name || n),
          (t.muid || e) && o.append("auid", t.muid || e),
          t.formattedAddress && o.append("address", t.formattedAddress),
          (i = t.coordinate || i),
          o.append("ll", `${i.latitude},${i.longitude}`),
          `https://maps.apple.com/?${o.toString()}`
        );
      }
      _handleLinkClicked() {
        (window.open(this.placeUrl, "_blank", "noopener"),
          this.delegate.placeCardOpenInMapsClicked("SMALL", this.analyticsState));
      }
      _handleLocaleChanged() {
        ((this._textElement.textContent = fi.get("OpenInAppleMaps.Label")),
          this.setSize(this.delegate.sizeForElement(this._containerElement)));
      }
      animateTailScale(t, e) {}
      animateAnchorOffset(t, e) {}
      getCenterOffset(t) {}
    },
    mm = "mk-selected";
  class gm {
    constructor(t) {
      ((this.delegate = t),
        (this._oldCenterMode = !1),
        (this.node = new Rn.Node(qn.htmlElement("div"))),
        this.node.classList.add("mk-selection-accessories"),
        (this._waitingForRegionChangeToEnd = 0));
    }
    get accessoryIsShown() {
      return !!this._accessory;
    }
    getAccessoryBoundingRect() {
      if (this._accessory) return this._accessory.boundingRect;
    }
    selectedAnnotationVisibilityDidChange(t) {
      this._accessory ? (this._accessory.visible = t.visible) : t.visible && this.showAccessoryForAnnotation(t, !0);
    }
    isElementInAccessory(t) {
      return !!this._accessory && this._accessory.containsElement(t);
    }
    isElementInCustomCallout(t) {
      return !!this._accessory && this._accessory.isCustomCallout() && this._accessory.node.element.contains(t);
    }
    showAccessoryForAnnotation(t, e) {
      this.hideAccessory(t, e);
      const {
        showsSelectionAccessory: i,
        showsCallout: n,
        calloutDelegate: o,
        customCalloutElement: s,
        customCalloutContentElement: a
      } = this._canShowSelectionAccessoryForAnnotation(t);
      if (!i && !n) return void t._impl.selectionAccessoryWillAppear(!1);
      t._impl.selectionAccessoryWillAppear(!0);
      let r = s;
      if (qn.supportsShadowDOM && r) {
        const t = "mk-slot-" + Math.random().toString(32).substring(2, 10);
        r.slot = t;
        const e = qn.htmlElement("slot");
        ((e.name = t), this.delegate.appendElementAssignedToSlot(r), (r = e));
      }
      if (n) {
        const {
          ignoreCalloutCornerRadiusForLeftAccessory: e,
          leftAccessory: i,
          rightAccessory: n
        } = this._getCalloutPartElements(t, o);
        this._accessory = new um(this, {
          customElement: r,
          contentElement: a,
          ignoreCalloutCornerRadiusForLeftAccessory: e,
          leftAccessory: this.delegate.rtl ? n : i,
          rightAccessory: this.delegate.rtl ? i : n,
          rtl: this.delegate.rtl
        });
      } else if (i) {
        const e = t._impl.selectionAccessory.style;
        if (e === ud.OpenInMaps)
          this._accessory = new pm(this, {
            place: t._impl.place,
            muid: t._impl.muid,
            coordinate: t.coordinate,
            title: t.title
          });
        else if (e === ud.CompactCallout || e === ud.FullCallout) {
          const i = e === ud.CompactCallout;
          this._accessory = new qp(this, {
            place: t._impl.place,
            muid: t._impl.muid,
            uiStyle: i ? "compact" : "full",
            side:
              this._findSideForAccessorySize(i ? qp.DEFAULT_COMPACT_SIZE : qp.DEFAULT_FULL_SIZE) ||
              (this.delegate.rtl ? "right" : "left"),
            rtl: this.delegate.rtl
          });
        } else {
          const i = this._findSideForAccessorySize(qp.DEFAULT_FULL_SIZE),
            n = this._findSideForAccessorySize(qp.DEFAULT_COMPACT_SIZE),
            o = i ? "full" : "compact",
            s = i || n;
          s || e === ud.Callout
            ? (this._accessory = new qp(this, {
                place: t._impl.place,
                muid: t._impl.muid,
                uiStyle: o,
                side: s || (this.delegate.rtl ? "right" : "left"),
                rtl: this.delegate.rtl
              }))
            : (this._accessory = new pm(this, {
                place: t._impl.place,
                muid: t._impl.muid,
                coordinate: t.coordinate,
                title: t.title
              }));
        }
      }
      this._accessory.animates = !(
        e ||
        (o &&
          "function" == typeof o.calloutShouldAnimateForAnnotation &&
          !q(o.calloutShouldAnimateForAnnotation, o, [t], !0))
      );
      const l =
        r && this._accessory.animates && o && "function" == typeof o.calloutAppearanceAnimationForAnnotation
          ? q(o.calloutAppearanceAnimationForAnnotation, o, [t], "")
          : "";
      if (
        (c(
          l,
          "string",
          "[MapKit] calloutAppearanceAnimationForAnnotation() must return a string, but returned `" + l + "` instead."
        ),
        (this._accessory.appearanceAnimation = l),
        r)
      ) {
        let e;
        (o &&
          "function" == typeof o.calloutAnchorOffsetForAnnotation &&
          ((e = q(o.calloutAnchorOffsetForAnnotation, o, [t, this._accessory.node.size])),
          d(
            e,
            window.DOMPoint,
            "[MapKit] calloutAnchorOffsetForAnnotation() must return a DOMPoint, but returned `" + e + "` instead."
          )),
          this._accessory.setAnchorOffset(e));
      }
      if ((this.updateAccessoryInfo(t), t === this.delegate.userLocationAnnotation)) {
        const t = this.delegate.constructor.AccuracyRingOverlay.getMode(this.delegate.map.worldSize, 100);
        if (((this._oldCenterMode = t), t)) {
          const t = this._accessory.getCenterOffset(!0);
          (this._accessory.animateAnchorOffset(t, -1), this._accessory.animateTailScale(0, -1));
        } else (this._accessory.animateAnchorOffset(new Mi(0, 0), -1), this._accessory.animateTailScale(1, -1));
      }
      this.updateAccessoryPositionWithTailShift(t, !1);
      const h = !e && this._nudgeMapToShowAccessory();
      (this._accessory.willMoveToMap(),
        this._accessory.node.classList.add(mm),
        this.node.addChild(this._accessory.node),
        this._accessory.appearanceAnimation && this.node.element.appendChild(this._accessory.node.element),
        h || this._accessory.animateIn());
    }
    hideAccessory(t, e) {
      (t._impl.selectionAccessoryWillDisappear(),
        this._accessory &&
          (this._accessory.node.classList.remove(mm), this._accessory.animateOut(e), delete this._accessory));
    }
    updateCenterMode() {
      const t = this.delegate.selectedItem === this.delegate.userLocationAnnotation,
        e = this.delegate.constructor.AccuracyRingOverlay.getMode(this.delegate.map.worldSize, 100),
        i = this._oldCenterMode !== e;
      if (((this._oldCenterMode = e), this._accessory && t && i))
        if ((this._accessory.animateTailScale(e ? 0 : 1), e)) {
          const t = this._accessory.getCenterOffset();
          ((t.y = t.y - this.delegate.userLocationAnnotation._impl._node.size.height / 4),
            this._accessory.animateAnchorOffset(t));
        } else this._accessory.animateAnchorOffset(new Mi(0, 0));
    }
    sizeForElement(t) {
      return this.delegate.sizeForElement(t);
    }
    backgroundColorForElement(t) {
      return this.delegate.backgroundColorForElement(t);
    }
    setAnimationForElement(t, e, i) {
      return this.delegate.setAnimationForElement(t, e, i);
    }
    annotationPropertyDidChange() {}
    accessorySizeDidChange(t) {
      this._nudgeMapToShowAccessory();
    }
    accessoryNodeDidRemove(t) {
      qn.supportsShadowDOM &&
        (t.isCustomCallout() &&
          "slot" === t.customOrContentElement.localName &&
          this.delegate.removeElementAssignedToSlot(t.customOrContentElement),
        t.customLeftAccessory &&
          "slot" === t.customLeftAccessory.localName &&
          this.delegate.removeElementAssignedToSlot(t.customLeftAccessory),
        t.customRightAccessory &&
          "slot" === t.customRightAccessory.localName &&
          this.delegate.removeElementAssignedToSlot(t.customRightAccessory));
    }
    updateAccessoryPositionWithTailShift(t, e) {
      if (this.delegate.selectedItem === t && this._accessory)
        return (
          this._accessory.setShown(t._impl.isShown()),
          this._accessory instanceof um
            ? this._accessory.setPosition(t._impl.positionForCallout())
            : this._accessory instanceof pm
              ? this._accessory.setPosition(t._impl.positionForSelectionAccessory("bottom", 4))
              : this._accessory.setPositionWithSide(
                  t._impl.positionForSelectionAccessory(this._accessory.side, qp.TAIL_DISTANCE_TO_ANCHOR),
                  this._accessory.side
                ),
          e ? this.updateAccessoryTailShift(e) : void 0
        );
    }
    updateAccessoryInfo(t) {
      this._accessory ? this._accessory.updateInfo(t, 12) || this.hideAccessory(t) : this.showAccessoryForAnnotation(t);
    }
    updateAccessoryTailShift(t) {
      if (!this._accessory) return !1;
      const e = t
          ? this._accessory.boundingRect.pad(12)
          : this._boundingRectForSelectedAnnotationAndAccessory().pad(12),
        i = this._totalMapNudgingTranslation(e, this.delegate.map.ensureVisibleFrame(), t),
        n = i.x,
        o = i.y,
        s = this._accessory.shiftTailBy(n);
      return 0 !== n || 0 !== o ? new Mi(-(n + s), -o) : void 0;
    }
    get tint() {
      return this.delegate.map.tint;
    }
    mapNodeTintWasSet(t) {
      this._accessory && this._accessory.mapNodeTintWasSet(t);
    }
    mapRegionChangeWillStart() {
      this._waitingForRegionChangeToStart && ((this._nudgeStarted = !0), this._waitingForRegionChangeToEnd++);
    }
    mapRegionChangeDidEnd() {
      this._waitingForRegionChangeToEnd &&
        (this._waitingForRegionChangeToEnd--,
        0 !== this._waitingForRegionChangeToEnd && this._nudgeMapToShowAccessory()
          ? (this._waitingForRegionChangeToEnd = 1)
          : ((this._waitingForRegionChangeToEnd = 0),
            this.updateAccessoryPositionWithTailShift(this.delegate.selectedItem, !0),
            this._accessory && this._accessory.animateIn()));
    }
    getMaximumSizeForAccessory() {
      if (!this.delegate.selectedItem) return;
      const t = this.delegate.selectedItem._impl._node.size,
        e = this.delegate.map.ensureVisibleFrame().size.copy();
      return (
        "left" === this._accessory.side || "right" === this._accessory.side
          ? ((e.width -= t.width + 50 + qp.TAIL_LENGTH + qp.TAIL_DISTANCE_TO_ANCHOR), (e.height -= 50))
          : ((e.width -= 50), (e.height -= t.height + 50 + qp.TAIL_LENGTH + qp.TAIL_DISTANCE_TO_ANCHOR)),
        e
      );
    }
    placeCardDidReveal(t, e) {
      this.delegate.placeCardDidReveal(t, e);
    }
    placeCardOpenInMapsClicked(t, e) {
      this.delegate.placeCardOpenInMapsClicked(t, e);
    }
    _findSideForAccessorySize(t) {
      if (!this.delegate.selectedItem) return;
      const e = this.delegate.selectedItem,
        i = e._impl._node,
        n = new Si(i.position.x, i.position.y, i.size.width, i.size.height).round(),
        o = this.delegate.map.ensureVisibleFrame(),
        s = e._impl.positionForSelectionAccessory("left", qp.TAIL_DISTANCE_TO_ANCHOR).y,
        a = n.minX() - o.minX(),
        r = o.maxX() - n.maxX();
      if (s + t.height / 2 < o.maxY() && s - t.height / 2 > o.minY()) {
        const e = t.width < a,
          i = t.width < r;
        if (e && i) return a === r ? (this.delegate.rtl ? "right" : "left") : a > r ? "left" : "right";
        if (e) return "left";
        if (i) return "right";
      }
      const l = n.minY() - o.minY();
      if (t.height < l) return "top";
      const h = o.maxY() - n.maxY();
      return t.height < h
        ? "bottom"
        : o.size.width - n.size.width > t.width + qp.TAIL_LENGTH + qp.TAIL_DISTANCE_TO_ANCHOR
          ? a >= r
            ? "left"
            : "right"
          : o.size.height - n.size.height > t.height + qp.TAIL_LENGTH + qp.TAIL_DISTANCE_TO_ANCHOR
            ? l >= h
              ? "top"
              : "bottom"
            : null;
    }
    _canShowSelectionAccessoryForAnnotation(t) {
      const e = t._impl.place;
      if (t._impl.selectionAccessory && ((e && e.name && e.coordinate) || (t.title && t._impl.muid && t.coordinate)))
        return t._impl.canShowSelectionAccessory()
          ? "CN" !== dt.countryCode || dt.customUiBaseUrl
            ? {showsSelectionAccessory: !0}
            : (console.warn("[MapKit] PlaceSelectionAccessory is not supported in China yet."),
              {showsSelectionAccessory: !1, showsCallout: !1})
          : {showsSelectionAccessory: !1, showsCallout: !1};
      if (!t._impl.canShowCallout()) return {showsSelectionAccessory: !1, showsCallout: !1};
      const i = t._impl.callout;
      if (
        i &&
        "function" == typeof i.calloutShouldAppearForAnnotation &&
        !q(i.calloutShouldAppearForAnnotation, i, [t], !0)
      )
        return {showsSelectionAccessory: !1, showsCallout: !1};
      let n, o;
      i &&
        "function" == typeof i.calloutElementForAnnotation &&
        ((n = q(i.calloutElementForAnnotation, i, [t])),
        G(n, "[MapKit] calloutElementForAnnotation() must return a DOM element, but returned `" + n + "` instead."));
      let s = !1;
      if (!n) {
        if (
          ((s = i && "function" == typeof i.calloutContentForAnnotation),
          s &&
            ((o = q(i.calloutContentForAnnotation, i, [t])),
            G(o, "[MapKit] contentElementForAnnotation() must return a DOM element, but returned `" + o + "` instead."),
            qn.supportsShadowDOM))
        ) {
          const t = "mk-slot-" + Math.random().toString(32).substring(2, 10);
          o.slot = t;
          const e = qn.htmlElement("slot");
          ((e.name = t), this.delegate.appendElementAssignedToSlot(o), (o = e));
        }
        if (!s && !t.title) return {showsSelectionAccessory: !1, showsCallout: !1};
      }
      return {
        showsSelectionAccessory: !1,
        showsCallout: !0,
        calloutDelegate: i,
        customCalloutElement: n,
        customCalloutContentElement: o
      };
    }
    _getCalloutPartElements(t, e) {
      let i;
      const n = e && "function" == typeof e.calloutLeftAccessoryForAnnotation;
      if (
        n &&
        ((i = q(e.calloutLeftAccessoryForAnnotation, e, [t])),
        G(
          i,
          "[MapKit] calloutLeftAccessoryForAnnotation() must return a DOM element, but returned `" + i + "` instead."
        ),
        qn.supportsShadowDOM)
      ) {
        const t = "mk-slot-" + Math.random().toString(32).substr(2, 8);
        i.slot = t;
        const e = qn.htmlElement("slot");
        ((e.name = t), this.delegate.appendElementAssignedToSlot(i), (i = e));
      }
      let o;
      const s = e && "function" == typeof e.calloutRightAccessoryForAnnotation;
      if (
        s &&
        ((o = q(e.calloutRightAccessoryForAnnotation, e, [t])),
        G(
          o,
          "[MapKit] calloutRightAccessoryForAnnotation() must return a DOM element, but returned `" + o + "` instead."
        ),
        qn.supportsShadowDOM)
      ) {
        const t = "mk-slot-" + Math.random().toString(32).substring(2, 10);
        o.slot = t;
        const e = qn.htmlElement("slot");
        ((e.name = t), this.delegate.appendElementAssignedToSlot(o), (o = e));
      }
      const a = t._impl.ignoreCalloutCornerRadiusForLeftAccessory && !n && !s;
      return (
        !n && t._impl.canvasForCalloutAccessory && (i = t._impl.canvasForCalloutAccessory()),
        {ignoreCalloutCornerRadiusForLeftAccessory: a, leftAccessory: i, rightAccessory: o}
      );
    }
    _boundingRectForSelectedAnnotationAndAccessory() {
      const t = this.getAccessoryBoundingRect(),
        e = this.delegate.selectedItem._impl.position(),
        i = Math.min(t.minX(), e.x),
        n = Math.min(t.minY(), e.y),
        o = Math.max(t.maxX(), e.x) - i,
        s = Math.max(t.maxY(), e.y) - n;
      return new Si(i, n, o, s);
    }
    _translationToFitInFrame(t, e) {
      const i = {x: 0, y: 0};
      return (
        (t.maxX() > e.maxX() || t.minX() < e.minX() || t.maxY() > e.maxY() || t.minY() < e.minY()) &&
          ((i.x = t.minX() < e.minX() ? t.minX() - e.minX() : t.maxX() > e.maxX() ? t.maxX() - e.maxX() : 0),
          (i.y = t.minY() < e.minY() ? t.minY() - e.minY() : t.maxY() > e.maxY() ? t.maxY() - e.maxY() : 0)),
        i
      );
    }
    _totalMapNudgingTranslation(t, e, i) {
      const n = this._translationToFitInFrame(t, e),
        o = this.delegate.map.getControlBounds(),
        s = e.midX(),
        a = e.midY();
      let r = 0,
        l = 0;
      return (
        (t = _m(t, n.x, n.y)),
        o.forEach(function (e) {
          if (t.minX() < e.maxX() && t.maxX() > e.minX() && t.minY() < e.maxY() && t.maxY() > e.minY()) {
            if (
              ((r += e.maxX() < s ? t.minX() - e.maxX() : t.maxX() - e.minX()),
              (l += e.maxY() < a ? t.minY() - e.maxY() : t.maxY() - e.minY()),
              i)
            )
              return;
            (0 !== l && Math.abs(r) > Math.abs(l) ? (r = 0) : (l = 0), (t = _m(t, r, l)));
          }
        }, this),
        (n.x += r),
        (n.y += l),
        n
      );
    }
    _nudgeMapToShowAccessory() {
      if (this.delegate.map.cameraIsMoving) return (this._waitingForRegionChangeToEnd++, !0);
      if (!this.delegate.selectedItem || !this.delegate.selectedItem._impl.isShown()) return !1;
      const t = this.updateAccessoryPositionWithTailShift(this.delegate.selectedItem, !0);
      if (!t) return !1;
      ((this._waitingForRegionChangeToStart = !0), this.delegate.map.translateCameraAnimated(t, !0));
      const e = this._nudgeStarted;
      return (delete this._nudgeStarted, (this._waitingForRegionChangeToStart = !1), e);
    }
  }
  function _m(t, e, i) {
    return new Si(t.origin.x - e, t.origin.y - i, t.size.width, t.size.height);
  }
  const fm = Ye.MapRect,
    ym = "mk-annotation-container",
    vm = "mk-annotations",
    wm = "mk-dragging",
    bm = "mk-selected",
    Cm = "mk-lifted",
    km = "mk-text-zoom";
  let Mm = null;
  function Sm(t) {
    (xh.call(this, t),
      (this._pendingAnnotations = []),
      (this._mapFeatureAnnotationController = new _p(this)),
      (this._clustersController = new Op(this)),
      fi.activeLocale && (this._rtl = fi.activeLocale.rtl),
      (this._node = new Rn.Node(qn.htmlElement("div", {class: ym}))),
      fi.activeLocale && this._node.element.setAttribute("lang", fi.localeId),
      (this._shadowDOMSlotController = new Gp(this._node)));
    const e = qn.htmlElement("div", {class: vm});
    ((this._sceneGraphNode = new Dp(e)),
      (this._shadowRootNode = qn.addShadowRootChild(
        this._node,
        dt.shadowDOMMode,
        ':host(.mk-annotation-container.mk-dragging) ::selection,div.mk-annotations ::selection{background:0 0}.mk-invisible{opacity:0;pointer-events:none}.mk-hidden{display:none}div.mk-annotations,div.mk-annotations>div,div.mk-selection-accessories,div.mk-style-helper{position:absolute;top:0;left:0}.mk-selected{z-index:1}.mk-lifted{z-index:2}.mk-callout,.mk-selection-accessory{position:absolute;top:0;left:0;pointer-events:auto;-webkit-user-select:auto;-moz-user-select:text;-ms-user-select:text}:host(.mk-annotation-container) .mk-selection-accessory,:host(.mk-annotation-container) .mk-selection-accessory-badge{font:16px sans-serif;--font-size-default:16}:host(.mk-dark-mode) .mk-callout,:host(.mk-dark-mode) .mk-selection-accessory{color:#fff}:host(.mk-annotation-container.mk-text-zoom) .mk-selection-accessory,:host(.mk-annotation-container.mk-text-zoom) .mk-selection-accessory-badge{font:initial}@supports (font:-apple-system-body) and (-webkit-touch-callout:default){:host(.mk-annotation-container.mk-text-zoom) .mk-selection-accessory,:host(.mk-annotation-container.mk-text-zoom) .mk-selection-accessory-badge{font:-apple-system-body;--font-size-default:17}}.mk-callout>*{position:absolute;top:0;left:0}svg.mk-bubble{display:block;width:100%;height:100%}svg.mk-selection-accessory-bubble{position:absolute;display:block;filter:drop-shadow(0 0 5px rgba(0, 0, 0, .3))}div.mk-callout-accessory{position:absolute;top:50%;transform:translateY(-50%);overflow:hidden}div.mk-callout-accessory-content{white-space:nowrap;position:relative;text-align:center;font-size:12px}div.mk-callout-accessory:first-child{left:0}div.mk-callout-accessory:last-child{right:0}div.mk-callout-accessory:first-child .mk-callout-accessory-content{padding-right:8px}div.mk-callout-accessory:last-child .mk-callout-accessory-content{padding-left:8px}div.mk-standard{font-family:"-apple-system",BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif;box-sizing:border-box;position:relative}:host(.mk-annotation-container) .mk-standard-content{font:16px sans-serif;--font-size-default:16}:host(.mk-annotation-container.mk-text-zoom) .mk-standard-content{font:initial}@supports (font:-apple-system-body) and (-webkit-touch-callout:default){:host(.mk-annotation-container.mk-text-zoom) .mk-standard-content{font:-apple-system-body;--font-size-default:17}}div.mk-selection-accessory-content{box-sizing:border-box;position:relative;overflow:auto;color-scheme:light;top:0;left:0;border-radius:18px}div.mk-selection-accessory-content.mk-rtl{direction:rtl}.mk-ui-style-compact div.mk-selection-accessory-content{overflow:hidden}:host(.mk-dark-mode) div.mk-selection-accessory-content{color-scheme:dark}:host(.mk-panning) div.mk-selection-accessory-content{pointer-events:none}.mk-ui-style-compact div.mk-selection-accessory-content>div{width:243px}div.mk-custom-content,div.mk-standard{transform:translateY(-50%)}div.mk-standard .mk-callout-content>div{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}div.mk-standard .mk-callout-content{padding:0 4px}.mk-callout-content.mk-rtl{direction:rtl}.mk-callout-content.mk-rtl *{text-align:right}div.mk-callout-accessory:first-child+.mk-callout-content{padding-left:8px}div.mk-standard .mk-callout-content:nth-last-child(2){padding-right:8px}div.mk-standard .mk-title{font-size:calc(100% * 17 / var(--font-size-default));font-family:"-apple-system",BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif;font-weight:500;color:#000;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;letter-spacing:.025em}:host(.mk-dark-mode) div.mk-standard .mk-title{color:#fff}div.mk-standard .mk-subtitle{font-size:calc(100% * 13 / var(--font-size-default));font-family:"-apple-system",BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif;color:rgba(0,0,0,.7);letter-spacing:.025em}:host(.mk-dark-mode) div.mk-standard .mk-subtitle{color:rgba(255,255,255,.7)}svg.mk-bubble path{fill:#fff;stroke:rgba(0,0,0,.2)}svg.mk-selection-accessory-bubble path{fill:#efefef;stroke:rgb(239,239,239,.7);stroke-width:2px}:host(.mk-dark-mode) svg.mk-bubble path{fill:#3e3e3e;stroke:rgba(0,0,0,.5)}:host(.mk-dark-mode) svg.mk-selection-accessory-bubble path{fill:#363636;stroke:rgb(54,54,54,.7);stroke-width:2px}.mk-selection-accessory-loading{display:block;width:100%;height:100%}.mk-selection-accessory-failed{display:flex;height:100%;align-items:center;justify-content:center;color:#000;opacity:.55;font-family:"-apple-system-font","Helvetica Neue",Helvetica,Arial,sans-serif}:host(.mk-dark-mode) .mk-selection-accessory-failed{color:#fff}.mk-selection-accessory-failed .mk-failed-labels{padding:0 20px}.mk-ui-style-compact .mk-selection-accessory-failed .mk-failed-labels{flex-grow:1}.mk-selection-accessory-failed p{margin:0;font-size:calc(100% * 12 / var(--font-size-default));font-weight:400}.mk-ui-style-full .mk-selection-accessory-failed p{margin:2px 0;text-align:center}.mk-selection-accessory-failed p:first-child{font-size:calc(100% * 14 / var(--font-size-default));font-weight:500}.mk-ui-style-compact .mk-selection-accessory-failed p:first-child{margin-top:10px}.mk-ui-style-compact .mk-selection-accessory-failed p:last-child{margin-bottom:10px}.mk-ui-style-full .mk-selection-accessory-failed p:first-child{margin-top:60px}.mk-ui-style-full .mk-selection-accessory-failed p:last-child{margin-bottom:60px}.mk-selection-accessory-badge-content{cursor:pointer;padding:4px 8px;font-size:calc(100% * 13 / var(--font-size-default));font-family:13px "-apple-system-font",HelveticaNeue-Medium,Helvetica,Arial,sans-serif;font-weight:500;border:1px solid rgba(0,0,0,.1);border-radius:13px;color:#007aff;background-color:#fff;box-shadow:0 0 5px 0 rgba(0,0,0,.3);animation:fade-in .5s}.mk-selection-accessory-badge-content.mk-fade-out{transition:visibility .5s,opacity .5s;opacity:0;visibility:hidden}.mk-selection-accessory-badge-content span{opacity:.8}.mk-selection-accessory-badge-content:hover span{opacity:1}.mk-selection-accessory-badge-content:active{background-color:#e5e5e5}.mk-selection-accessory-badge-content:focus-visible{outline:0;background-color:#cce5ff;box-shadow:0 0 5px 0 rgba(0,0,0,.3),0 0 0 2px #007cff}.mk-selection-accessory-badge-content:active:focus-visible{background-color:#7fbdff}@keyframes fade-in{from{opacity:0}to{opacity:1}}:host(.mk-dark-mode) .mk-selection-accessory-badge-content{color:#0a84ff;background-color:#363636}:host(.mk-dark-mode) .mk-selection-accessory-badge-content:active{background-color:#2a2a2a}:host(.mk-dark-mode) .mk-selection-accessory-badge-content:focus-visible{background-color:#0c3159}:host(.mk-dark-mode) .mk-selection-accessory-badge-content:active:focus-visible{color:#64b1ff;background-color:#0366cf}@supports ((backdrop-filter:blur(30px)) or (-webkit-backdrop-filter:blur(30px))){.mk-selection-accessory-badge-content{-webkit-backdrop-filter:blur(30px);backdrop-filter:blur(30px);background-color:rgba(255,255,255,.75)}.mk-selection-accessory-badge-content:active{background-color:rgba(229,229,229,.6)}.mk-selection-accessory-badge-content:focus-visible{background-color:rgba(204,229,255,.6)}.mk-selection-accessory-badge-content:active:focus-visible{background-color:rgb(127,189,255,.6)}:host(.mk-dark-mode) .mk-selection-accessory-badge-content{background-color:rgba(18,18,18,.6)}:host(.mk-dark-mode) .mk-selection-accessory-badge-content:active{background-color:rgba(42,42,42,.6)}:host(.mk-dark-mode) .mk-selection-accessory-badge-content:focus-visible{background-color:rgba(12,49,89,.6)}:host(.mk-dark-mode) .mk-selection-accessory-badge-content:active:focus-visible{background-color:rgb(3,102,207,.6)}}',
        dt.nonce
      )),
      (this._annotationsNode = this._shadowRootNode.addChild(new Rn.Node(e))),
      (this._selectionAccessoryController = new gm(this)),
      this._shadowRootNode.addChild(this._selectionAccessoryController.node),
      (this._styleHelper = new Np(this)),
      this._shadowRootNode.addChild(new Rn.Node(this._styleHelper.element)),
      (this._annotationDraggingMapPanningController = new Qc(t)),
      (this.textZoom = t.textZoom));
  }
  ((Sm.Annotation = Ad),
    (Sm.prototype = r(xh, Sm, {
      itemConstructor: Ad,
      itemName: "annotation",
      capitalizedItemName: "Annotation",
      _rtl: !1,
      _selectionDistance: Math.pow(xh.prototype._selectionDistance, 2),
      get sceneGraphNode() {
        return this._sceneGraphNode;
      },
      isItemExposed: function (t) {
        return t !== this._userLocationAnnotation && !t.memberAnnotations;
      },
      _userLocationAnnotation: null,
      get map() {
        return this._map;
      },
      get userLocationAnnotation() {
        return this._userLocationAnnotation;
      },
      get dragging() {
        return !!this._draggedAnnotation;
      },
      get rtl() {
        return this._rtl;
      },
      set rtl(t) {
        this._rtl !== t &&
          ((this._rtl = t),
          this._selectedItem &&
            this._selectionAccessoryController.accessoryIsShown &&
            this._selectionAccessoryController.showAccessoryForAnnotation(this._selectedItem, !0));
      },
      get textZoom() {
        return this._node.classList.contains(km);
      },
      set textZoom(t) {
        this._node.classList.toggle(km, t);
      },
      preAddedAnnotation: function (t) {
        if (!t._impl.updatedPosition()) return !1;
        const e = !t.map,
          i = qn.supportsShadowDOM && this._annotationsNode && t._impl.renderedByDOMElement && !t.element.parentNode;
        return (
          i && this._shadowDOMSlotController.appendAssignedElement(t.element, !1),
          e && t._impl.setDelegate(this),
          e || i
        );
      },
      resetAnnotation: function (t) {
        (qn.supportsShadowDOM &&
          this._annotationsNode &&
          t._impl.renderedByDOMElement &&
          t.element.parentNode &&
          this._shadowDOMSlotController.removeAssignedElement(t._impl.elementInAnnotationDOM, !1),
          -1 === this._items.indexOf(t) && delete t._impl.delegate);
      },
      addItems: function (t) {
        if (((t = xh.prototype.addItems.call(this, t)), this._shouldAnnotationBePending())) return t;
        t.sort(function (t, e) {
          return e.coordinate.latitude - t.coordinate.latitude;
        });
        const e = this._map.camera.toMapRect(),
          i = e.size.width,
          n = e.size.height,
          o = e.origin.x - i,
          s = o + 3 * i,
          a = e.origin.y - n,
          r = a + 3 * n;
        let l = 0;
        t.forEach(function (t) {
          t._impl.doesAnimate() &&
            t.visible &&
            t._impl.x + (t._impl.x < o ? 1 : 0) <= s &&
            t._impl.y >= a &&
            t._impl.y <= r &&
            ((t._impl.delayRank = l), ++l);
        });
        const h = Math.min(50 * l, 3e3),
          c = 0 === l ? 0 : h / l;
        return (
          t.forEach(function (t) {
            ((t._impl.delayMs = t._impl.delayRank * c), delete t._impl.delayRank);
          }, this),
          t
        );
      },
      addWaitingAnnotations: function (t) {
        const e = "function" == typeof t;
        this._waitingAnnotations
          ? (e && (this._completionCallback = t),
            window.clearTimeout(this._tileLoadingTimeout),
            delete this._tileLoadingTimeout,
            this._waitingAnnotations.forEach(function (t) {
              t.map && this._addAnnotationWaitingForTiles(t, !1, !e);
            }, this),
            this._updateSceneGraph(),
            delete this._waitingAnnotations,
            Qt.scheduleOnNextFrame(() => this._checkCompletion()))
          : e && t();
      },
      annotationsInMapRect: function (t) {
        d(t, fm, "[MapKit] Map.annotationsInMapRect expects a MapRect as its argument, got `" + t + "` instead.");
        const e = o(t.origin.x, 1),
          i = e + t.size.width,
          n = t.origin.y,
          s = n + t.size.height;
        return this._items.filter(function (t) {
          if (!this.isItemExposed(t)) return !1;
          const o = t._impl.x + (t._impl.x < e ? 1 : 0),
            a = t._impl.y;
          return o >= e && o <= i && a >= n && a <= s;
        }, this);
      },
      removeItem: function (t) {
        return t === this._userLocationAnnotation
          ? (console.warn(
              "[MapKit] Map.removeAnnotation: the user location annotation cannot be removed. Set showsUserLocation to false instead."
            ),
            t)
          : xh.prototype.removeItem.call(this, t);
      },
      removeUserLocationAnnotation: function () {
        this._userLocationAnnotation &&
          (this._userLocationAnnotation._impl.removedFromMap(),
          xh.prototype.removeAnyItem.call(this, this._userLocationAnnotation),
          delete this._userLocationAnnotation);
      },
      updateUserLocationAnnotation: function (t, e) {
        if (!t.coordinate) return;
        const i = this._userLocationAnnotation || new Sm.UserLocationAnnotation(t);
        if ((this._userLocationAnnotation || ((this._userLocationAnnotation = i), this.addItem(i, 0)), t.stale))
          return (
            delete this._lastGeocoderRequestCoordinate,
            delete this._lastUserLocationAnnotationSubtitle,
            void (i._impl.stale = !0)
          );
        if (((i._impl.stale = !1), i._impl.setCoordinate(t.coordinate), Mm)) {
          if (
            !e &&
            this._lastGeocoderRequestCoordinate &&
            this._lastGeocoderRequestCoordinate.latitude === i._impl.coordinate.latitude &&
            this._lastGeocoderRequestCoordinate.longitude === i._impl.coordinate.longitude
          )
            return void (this._userLocationAnnotation.subtitle = this._lastUserLocationAnnotationSubtitle);
        } else Mm = new Sm.Geocoder();
        ((this._lastGeocoderRequestCoordinate = i._impl.coordinate.copy()), Lm(Mm, i, this));
      },
      mapSizeDidUpdate: function () {
        if (0 === this._pendingAnnotations.length) return;
        const t = this._map.shouldWaitForTilesAndControls();
        (this._pendingAnnotations.forEach(function (e) {
          e._impl.isPending && this._addAnnotationWaitingForTiles(e, t);
        }, this),
          this._updateSceneGraph(),
          (this._pendingAnnotations = []));
      },
      updateVisibleAnnotations: function () {
        0 !== this._items.length && (this._updateVisibleAnnotations(this._items), this._updateSceneGraph());
      },
      startDraggingAnnotation: function (t, e) {
        (this._map.annotationDraggingWillStart(),
          (this._draggedAnnotation = t),
          (this._pendingDragStart = !0),
          t.selected && this._selectionAccessoryController.hideAccessory(t),
          this._node.classList.add(wm),
          this._draggedAnnotation._impl.node.classList.add(Cm),
          this._draggedAnnotation._impl.lift(),
          this._updateSceneGraph());
      },
      mapNodeTintWasSet: function (t) {
        (this._items.forEach((t) => {
          t._impl.updateLayout();
        }),
          this._selectionAccessoryController.mapNodeTintWasSet(t));
      },
      mapTypeDidChange: function () {
        this._mapFeatureAnnotationController.mapTypeDidChange();
      },
      fontSizeDidChange: function () {
        this._items.forEach(function (t) {
          t._impl.updateLayout(!1, !0);
        });
      },
      devicePixelRatioDidChange: function () {
        this._items.forEach(function (t) {
          "function" == typeof t._impl.updateGlyphImages && t._impl.updateGlyphImages();
        });
      },
      styleHelperNodeDidMoveToParent: function (t) {
        if (!qn.supportsShadowDOM) return;
        const e = t.assignedNodes ? t : t.querySelector("slot"),
          i = e && this._shadowDOMSlotController.getAssignedElement(e);
        e &&
          i &&
          i.parentNode &&
          0 === e.assignedNodes().length &&
          (this._node.element.removeChild(i), this._node.element.appendChild(i));
      },
      getShadowDOMTargetFromEvent: function (t) {
        if (this._shadowRootNode.domNode) return qn.getShadowDOMTargetFromEvent(this._shadowRootNode.domNode, t);
      },
      performScheduledUpdate: Am,
      addedItem: function (t, e) {
        for (const e of t._impl.getMuidList()) this.map.setPoiFiltered(e, !0);
        (xh.prototype.addedItem.call(this, t, e), (t._impl.isWaiting = !0), e && (t._impl.delayRank = 0));
        const i = this._shouldAnnotationBePending(t);
        (i && ((t._impl.isPending = !0), this._pendingAnnotations.push(t)),
          this._updateAnnotation(t),
          t._impl.selected && this._didSelectAnnotation(t),
          i || this._addAnnotationWaitingForTiles(t, this._map.shouldWaitForTilesAndControls()));
      },
      manyItemsAdded: function (t) {
        this._updateSceneGraph();
      },
      removedItem: function (t, e) {
        for (const e of t._impl.getMuidList()) this.map.setPoiFiltered(e, !1);
        (delete t._impl.wasCollided,
          "function" == typeof t._impl.node.remove &&
            (qn.supportsShadowDOM &&
              t._impl.node.parent &&
              this._shadowDOMSlotController.removeAssignedElement(
                t._impl.elementInAnnotationDOM,
                !t._impl.renderedByDOMElement
              ),
            t._impl.node.remove()),
          xh.prototype.removedItem.call(this, t),
          t._impl.labelRegion && this._removeLabelRegionForAnnotation(t),
          e || this._updateVisibleAnnotations([t]),
          this._clustersController.removedAnnotation(t),
          t.memberAnnotations || this._updateCollisions(this._items));
      },
      manyItemsRemoved: function (t) {
        (this._updateVisibleAnnotations(this.items), this._updateSceneGraph());
      },
      manyItemsChanged: function (t) {
        (this._updateVisibleAnnotations(this.items), this._updateSceneGraph());
      },
      removedReferenceToMap: function () {
        this._userLocationAnnotation && this._userLocationAnnotation._impl.removedFromMap();
      },
      pickableItemsCloseToPoint: function (t, e) {
        const i = t
          .filter(function (t, i) {
            const n = t._impl.distanceToPoint(e);
            return n <= this._selectionDistance && ((t._impl.distance = n), (t._impl.index = i), !0);
          }, this)
          .sort(function (t, e) {
            return t._impl.distance - e._impl.distance || e._impl.index - t._impl.index;
          });
        return (
          i.forEach(function (t) {
            (delete t._impl.distance, delete t._impl.index);
          }),
          i
        );
      },
      annotationDraggingDidChange: function (t) {
        this._draggedAnnotation &&
          !this._draggedAnnotation._impl.shouldPreventDrag &&
          (this._pendingDragStart &&
            (delete this._pendingDragStart,
            this._draggedAnnotation._impl.draggingDidStart(),
            this._map.dispatchEventWithAnnotation(bd.Events.DragStart, this._draggedAnnotation)),
          Qt.scheduleASAP(this),
          this._draggedAnnotation._impl.setDraggingTranslationForMapFrameSize(t, this._map.ensureRenderingFrame().size),
          this._annotationDraggingMapPanningController.update(
            this._draggedAnnotation,
            this._draggedAnnotation._impl.node
          ));
      },
      annotationDraggingDidEnd: function (t) {
        this._draggedAnnotation &&
          (this._annotationDraggingMapPanningController.stop(),
          this._draggedAnnotation._impl.dropAfterDraggingAndRevertPosition(!t),
          this._draggedAnnotation._impl.node.classList.remove(Cm),
          this._node.classList.remove(wm),
          this._map.annotationDraggingDidEnd(),
          this._map.dispatchEventWithAnnotation(bd.Events.DragEnd, this._draggedAnnotation),
          delete this._draggedAnnotation,
          this._updateSceneGraph());
      },
      annotationPropertyDidChange: function (t, e) {
        switch (e) {
          case "selected":
            t.selected ? this._didSelectAnnotation(t) : this._didDeselectAnnotation(t);
            break;
          case "coordinate":
            if (!t._impl.updatedPosition()) return;
            break;
          case "":
          case "displayPriority":
          case "collisionMode":
          case "clusteringIdentifier":
          case "padding":
          case "selectionAccessoryOffset":
          default:
            break;
          case "calloutOffset":
            this._selectionAccessoryController.updateAccessoryPositionWithTailShift(t, !0);
            break;
          case "visible":
            (this._selectedItem === t && this._selectionAccessoryController.selectedAnnotationVisibilityDidChange(t),
              (t._impl.needsColliding = !0));
            break;
          case "draggable":
            this._draggedAnnotation !== t || t.draggable || this._map.stopDraggingAnnotation();
            break;
          case "title":
          case "subtitle":
            this._selectedItem === t &&
              (this._selectionAccessoryController.updateAccessoryInfo(t),
              this._selectionAccessoryController.updateAccessoryTailShift());
        }
        t.map &&
          t.map === this._map.public &&
          ((this._annotationsDidChangeSinceLastCollision = !0),
          this._updateVisibleAnnotations([t]),
          this._updateSceneGraph(),
          this._updateLabelRegionForAnnotation(t));
      },
      mapForAnnotation: function (t) {
        return this._map ? this._map.public : null;
      },
      sizeForElement: function (t) {
        if (this._map.isRooted()) return this._styleHelper.sizeForElement(t);
      },
      backgroundColorForElement: function (t, e) {
        return this._styleHelper.backgroundColorForElement(t, e);
      },
      setAnimationForElement: function (t, e, i) {
        return this._styleHelper.setAnimationForElement(t, e, i);
      },
      selectedAnnotationDidMoveToMap: function (t) {
        (this._updateSceneGraph(), this._selectionAccessoryController.showAccessoryForAnnotation(t));
      },
      supportsLabelRegions: function () {
        return this._map.supportsLabelRegions();
      },
      annotationFinishedAnimating: function (t) {
        this._checkCompletion();
      },
      isElementInAccessory: function (t) {
        return this._selectionAccessoryController.isElementInAccessory(t);
      },
      isElementInCustomCallout: function (t) {
        return this._selectionAccessoryController.isElementInCustomCallout(t);
      },
      mapPanningDuringAnnotationDrag: Am,
      mapSupportForLabelRegionsChanged: function () {
        this._items.forEach(function (t) {
          const e = t._impl;
          (e.updateLayout(), delete e.labelRegion, this._updateLabelRegionForAnnotation(t));
        }, this);
      },
      containsMarkerAnnotation: function () {
        return this._items.some((t) => "string" == typeof t.glyphText);
      },
      paddingForAnnotation: function (t) {
        let e = 0,
          i = 0;
        t.size
          ? ((e = t.size.width), (i = t.size.height))
          : console.warn(
              "[MapKit] Computing padding for showItems() when an annotation was not yet added the DOM can cause the annotation to not be entirely visible. The `size` property of the annotation can be changed to ensure that it shows up properly."
            );
        const n = {
          top: t._impl._anchorPoint.y,
          right: e - t._impl._anchorPoint.x,
          bottom: i - t._impl._anchorPoint.y,
          left: t._impl._anchorPoint.x
        };
        if (t === this.selectedItem && this._selectionAccessoryController.accessoryIsShown) {
          const e = this._selectionAccessoryController.getAccessoryBoundingRect(),
            i = t._impl.position();
          ((n.top = Math.max(n.top, i.y - e.minY())),
            (n.right = Math.max(n.right, e.maxX() - i.x)),
            (n.bottom = Math.max(n.bottom, e.maxY() - i.y)),
            (n.left = Math.max(n.left, i.x - e.minX())));
        }
        return n;
      },
      appendElementAssignedToSlot(t) {
        this._shadowDOMSlotController.appendAssignedElement(t);
      },
      removeElementAssignedToSlot(t) {
        this._shadowDOMSlotController.removeAssignedElement(t);
      },
      mapFeatureRegionCloseToPoint(t, e) {
        if (!e.length) return;
        let i,
          n,
          o = 1 / 0;
        for (const s of e) {
          const e = new Ye.MapPoint(s.position[0], s.position[1]);
          e.x < this.map.camera.minX() && (e.x += 1);
          const a = this.map.camera.transformMapPoint(e);
          for (const e of s.rects) {
            const r = e.size,
              l = a.x + e.offset[0],
              h = a.y + e.offset[1];
            if (l < t.x && t.x < l + r[0] && h < t.y && t.y < h + r[1]) {
              i = s;
              break;
            }
            const c = l,
              d = c + r[0],
              u = c - t.x,
              p = d - t.x,
              m = u <= 0 && p >= 0 ? 0 : Math.min(Math.abs(u), Math.abs(p)),
              g = h,
              _ = g + r[1],
              f = g - t.y,
              y = _ - t.y,
              v = f <= 0 && y >= 0 ? 0 : Math.min(Math.abs(f), Math.abs(y)),
              w = m * m + v * v;
            o > w && ((o = w), (n = s));
          }
          if (i) break;
          if (s.circles && s.circles.length) {
            const e = this.map.ensureVisibleFrame().size.height;
            for (const a of s.circles) {
              const r = a.x,
                l = e - a.y,
                h = a.radius,
                c = Math.abs(t.x - r),
                d = Math.abs(t.y - l),
                u = c * c + d * d;
              if (u < h * h) {
                i = s;
                break;
              }
              o > u && ((o = u), (n = s));
            }
          }
          if (i) break;
        }
        return i || (n && o < this._selectionDistance ? n : void 0);
      },
      getMapFeatureAnnotationForRegion: function (t, e) {
        return this._mapFeatureAnnotationController.getMapFeatureAnnotationForRegion(t, e);
      },
      mapFeatureDidSelect: function (t) {
        this._mapFeatureAnnotationController.mapFeatureDidSelect(t);
      },
      mapRegionChangeWillStart() {
        this._selectionAccessoryController.mapRegionChangeWillStart();
      },
      mapRegionChangeDidEnd() {
        this._selectionAccessoryController.mapRegionChangeDidEnd();
      },
      localeChanged() {
        (this._node.setAttribute("lang", fi.localeId), (this.rtl = fi.activeLocale.rtl));
      },
      placeCardDidReveal(t, e) {
        this._map.annotationPlaceSelectionAccessoryDidReveal(t, e);
      },
      placeCardOpenInMapsClicked(t, e) {
        this._map.annotationPlaceSelectionAccessoryOpenInMapsClicked(t, e);
      },
      _addAnnotationToMapAsync: function (t) {
        (this._addAnnotationToMap(t, !1), this._updateSceneGraph());
      },
      _addAnnotationToMap: function (t, e) {
        if (this._shouldAnnotationBePending()) return void (t._impl.isPending = !0);
        (qn.supportsShadowDOM &&
          this._annotationsNode &&
          this._shadowDOMSlotController.appendAssignedElement(t.element, !t._impl.renderedByDOMElement),
          t._impl.willMoveToMap(t._impl.canAnimate && !e),
          delete t._impl.timeout,
          delete t._impl.isWaiting,
          delete t._impl.canAnimate,
          delete t._impl.delayMs);
        const i = this._items.indexOf(t);
        (this._annotationsNode && this._annotationsNode.addChild(t._impl.node, i),
          t._impl.sceneGraphNode && this._sceneGraphNode.addChild(t._impl.sceneGraphNode, i),
          this._updateAnnotation(t),
          t.selected && this._selectionAccessoryController.showAccessoryForAnnotation(t),
          this._updateLabelRegionForAnnotation(t),
          t._impl.didMoveToMap());
      },
      _addAnnotationWaitingForTiles: function (t, e, i) {
        (Object.prototype.hasOwnProperty.call(t._impl, "canAnimate") || (t._impl.canAnimate = !t._impl.isPending),
          delete t._impl.isPending,
          !e ||
          t === this._userLocationAnnotation ||
          this._items.some((t) => t !== this._userLocationAnnotation && t._impl.mayBeDrawn())
            ? !i && t._impl.doesAnimate() && t._impl.delayMs > 0
              ? (t._impl.timeout = window.setTimeout(() => this._addAnnotationToMapAsync(t), t._impl.delayMs))
              : this._addAnnotationToMap(t, i)
            : this._waitingAnnotations
              ? this._waitingAnnotations.push(t)
              : ((this._waitingAnnotations = [t]),
                (this._tileLoadingTimeout = window.setTimeout(() => this.addWaitingAnnotations(n), 3e3))));
      },
      _didDeselectAnnotation: function (t) {
        (t._impl.node.classList.remove(bm),
          (this.selectedItem = null),
          this._selectionAccessoryController.hideAccessory(t),
          this._map.annotationSelectionDidChange(t),
          this._mapFeatureAnnotationController.annotationSelectionDidChange(t));
      },
      _didSelectAnnotation: function (t) {
        (t._impl.node.classList.add(bm),
          (this.selectedItem = t),
          this._map.annotationSelectionDidChange(t),
          this._mapFeatureAnnotationController.annotationSelectionDidChange(t),
          t._impl.visible && this._selectionAccessoryController.showAccessoryForAnnotation(t));
      },
      _shouldAnnotationBePending: function () {
        return !this._map.isRooted();
      },
      mapWasDestroyed: function () {
        (xh.prototype.mapWasDestroyed.call(this),
          this._annotationDraggingMapPanningController &&
            this._annotationDraggingMapPanningController.mapWasDestroyed(),
          this._clustersController.mapWasDestroyed(),
          (this._mapWasDestroyed = !0));
      },
      _updateLabelRegionForAnnotation: function (t) {
        const e = t._impl;
        if (!e.shouldHideLabels) return;
        e.labelRegion || (e.labelRegion = this._map.createLabelRegion());
        const i = e.labelRegion;
        if (i) {
          const t = e.node.size,
            n = t.width,
            o = t.height;
          ((i.x = null == e.visibleX ? e.x : e.visibleX),
            (i.y = 1 - e.y),
            (i.width = n),
            (i.height = o),
            (i.xOffset = n / 2 - e._anchorPoint.x - e._anchorOffset.x),
            (i.yOffset = e._anchorPoint.y + e._anchorOffset.y - o / 2),
            this._map.updatedLabelRegion());
        }
      },
      _removeLabelRegionForAnnotation: function (t) {
        (this._map.unregisterLabelRegion(t._impl.labelRegion), delete t._impl.labelRegion);
      },
      _updateVisibleAnnotations: function (t, e) {
        e || this._deletePreviousPointForPickingItem();
        const i = this._userLocationAnnotation,
          n = this._map;
        if (i) {
          const t = Sm.AccuracyRingOverlay.getMode(n.worldSize);
          ((i._impl.isRingMode = t), this._selectionAccessoryController.updateCenterMode());
        }
        const o = n.camera.toRenderingMapRect(),
          s = o.size.width,
          a = Math.min(1.5 * s, 0.5),
          r = o.midX(),
          l = o.size.height,
          h = o.minY() - l,
          c = h + 3 * l;
        (t.forEach(function (t) {
          if (t === this._draggedAnnotation && this._annotationDraggingMapPanningController.panning) return;
          let e = NaN;
          const i = t._impl.y;
          if (s > 0 && l > 0 && i >= h && i <= c) {
            const i = t._impl.x,
              o = t.anchorOffset.x / n.worldSize;
            let s = a;
            for (let t = -1; t <= 1; ++t) {
              const n = Math.abs(i - o + t - r);
              n < s && ((s = n), (e = i + t));
            }
          }
          isNaN(e)
            ? t._impl.setShown(!1)
            : (t._impl.isShown() ||
                t !== this._selectedItem ||
                this._selectionAccessoryController.showAccessoryForAnnotation(t, !0),
              t._impl.setShown(!0),
              t._impl.setPosition(n.adjustMapItemPoint(n.camera.transformMapPoint(new Mi(e, i)))),
              t._impl.visibleX !== e && ((t._impl.visibleX = e), this._updateLabelRegionForAnnotation(t)));
        }, this),
          this._selectionAccessoryController.updateAccessoryPositionWithTailShift(this._selectedItem, !0),
          e || this._updateCollisions(t));
      },
      _updateCollisions: function (t) {
        let e = !1;
        const i = this._items.filter(function (t) {
          const i = t.visible && t._impl.isShown(),
            n = i || t._impl.needsColliding;
          return (
            delete t._impl.needsColliding,
            n && (t.displayPriority < Ad.DisplayPriority.Required || t.clusteringIdentifier) && (e = !0),
            n && i && !t.memberAnnotations
          );
        }, this);
        if (e) {
          const t = this._map;
          this._clustersController.collideAnnotations(
            i,
            t.zoomLevel,
            t.rotation,
            this._annotationsDidChangeSinceLastCollision
          );
        }
        this._annotationsDidChangeSinceLastCollision = !1;
      },
      addCluster: function (t) {
        let e =
          "function" == typeof this._map.annotationForCluster
            ? q(this._map._annotationForCluster, this._map.public, [t], null)
            : t;
        return (
          (e && e instanceof Ad) ||
            (console.warn("[MapKit] Expects Map.annotationForCluster to return an annotation."), (e = t)),
          (e = this._clustersController.setRequiredClusterAnnotationProperties(e, t)),
          this.addItem(e),
          (e._impl.customCluster = e !== t),
          e._impl.updateLayout(!0),
          this._updateLabelRegionForAnnotation(e),
          e
        );
      },
      willUpdateCollisions: function () {
        this._items.forEach(function (t) {
          ((t._impl.wasOccluded = t._impl.occluded), (t._impl.previousCluster = t._impl.cluster));
        });
      },
      didUpdateCollisions: function () {
        (this._items.forEach(function (t) {
          const e = t._impl;
          (e.wasCollided || e.occluded || (e.wasCollided = !0),
            t.memberAnnotations &&
              t.memberAnnotations[0]._impl.cluster !== t &&
              (e.cluster = e.memberAnnotations[0]._impl.cluster),
            e.updateVisibility(e.occluded),
            e.occluded !== e.wasOccluded && e.animateOcclusion(),
            delete e.previousCluster,
            e.shouldHideLabels &&
              (e.occluded || e.labelRegion
                ? e.occluded && e.labelRegion && this._removeLabelRegionForAnnotation(t)
                : this._updateLabelRegionForAnnotation(t)));
        }, this),
          this._items.forEach((t) => {
            delete t._impl.wasOccluded;
          }),
          this._updateVisibleAnnotations(this._items, !0),
          this._updateSceneGraph());
      },
      deselectClusterAnnotation: function () {
        this._selectedItem && this._selectedItem.memberAnnotations && (this._selectedItem.selected = !1);
      },
      _updateAnnotation: function (t) {
        t._impl.updatedPosition() && this._updateVisibleAnnotations([t]);
      },
      _updateSceneGraph: function () {
        const t = this._selectedItem,
          e = this._draggedAnnotation,
          i = this._items
            .filter(function (i) {
              return i._impl.isDrawn() && i !== t && i !== e;
            })
            .map((t) => t._impl.sceneGraphNode);
        (t && t._impl.isDrawn() && i.push(t._impl.sceneGraphNode),
          e && e._impl.isDrawn() && i.push(e._impl.sceneGraphNode),
          (this._sceneGraphNode.children = i));
      },
      _checkCompletion: function () {
        this._mapWasDestroyed ||
          ((this._annotationsDidChangeSinceLastCollision = !0),
          this._updateVisibleAnnotations(this._items),
          this._updateSceneGraph(),
          this._completionCallback &&
            (this._items.some((t) => !t._impl.isStable()) ||
              "function" != typeof this._completionCallback ||
              (this._completionCallback(), delete this._completionCallback)));
      }
    })));
  const Lm = te(function (t, e, i) {
    i._geocoderRequestId && t.cancel(i._geocoderRequestId);
    const n = t.reverseLookup(e._impl.coordinate, function (t, o) {
      n === i._geocoderRequestId &&
        (delete i._geocoderRequestId,
        t
          ? (console.error("[MapKit] Error getting address for user location: " + t.message), (e.subtitle = null))
          : o.results.length > 0
            ? (i._lastUserLocationAnnotationSubtitle = e.subtitle = o.results[0].formattedAddress)
            : (e.subtitle = null));
    });
    i._geocoderRequestId = n;
  }, 1e3);
  function Am() {
    if (!this._draggedAnnotation || this._mapWasDestroyed) return;
    const t = this._draggedAnnotation._impl.dispatchDraggingEvent();
    this._map.dispatchEventWithAnnotation(t.type, this._draggedAnnotation, {coordinate: t.coordinate});
  }
  const Em = ["UserLocationAnnotation", "AccuracyRingOverlay", "Geocoder"];
  function xm() {
    let t = !0;
    for (let e = 0; e < Em.length; e++) {
      const i = Em[e];
      !Sm[i] && L.jsModules[i] ? (Sm[i] = L.jsModules[i]) : (t = !1);
    }
    t && L.removeEventListener("load", xm);
  }
  (L.addEventListener("load", xm), xm());
  const Tm = Sm,
    Im = Ye.MapPoint;
  function Rm(t) {
    ((this.map = t),
      window.document &&
        ((this.node = new Rn.Node(qn.htmlElement("div", {class: "mk-map-features-container"}))),
        (this._shadowRootNode = qn.addShadowRootChild(
          this.node,
          dt.shadowDOMMode,
          ":host(.mk-map-features-container) .mk-map-features>div{position:absolute;top:0;left:0}",
          dt.nonce
        )),
        (this._featuresContainer = this._shadowRootNode.addChild(
          new Rn.Node(qn.htmlElement("div", {class: "mk-map-features"}))
        ))));
  }
  Rm.prototype = {
    constructor: Rm,
    update: function (t, e) {
      this._featuresContainer.children = [];
      for (let i = 0; i < t.length; i++) {
        const n = t[i];
        let o, s;
        const a = new Im(n.position[0], n.position[1]);
        a.x < e.minX() && (a.x += 1);
        const r = e.transformMapPoint(a);
        if (n.rects && n.rects.length) {
          let t = 1 / 0,
            e = 0,
            i = 1 / 0,
            a = 0;
          for (const o of n.rects) {
            const n = r.x + o.offset[0],
              s = n + o.size[0],
              l = r.y + o.offset[1],
              h = l + o.size[1];
            (t > n && (t = n), e < s && (e = s), i > l && (i = l), a < h && (a = h));
          }
          ((o = new ki(e - t, a - i)), (s = new Mi(t, i)));
        } else if (n.circles && n.circles.length) {
          let t = 1 / 0,
            e = 0,
            i = 1 / 0,
            a = 0;
          const r = this.map.ensureVisibleFrame().size.height;
          for (const o of n.circles) {
            const n = o.x - o.radius,
              s = o.x + o.radius,
              r = o.y - o.radius,
              l = o.y + o.radius;
            (t > n && (t = n), e < s && (e = s), i > r && (i = r), a < l && (a = l));
          }
          ((o = new ki(e - t, a - i)), (s = new Mi(t, r - a)));
        }
        if (!o) continue;
        const l = new Rn.Node(qn.htmlElement("div", {"aria-label": n.title}));
        ((l.position = s), (l.size = o), this._featuresContainer.addChild(l));
      }
    }
  };
  const Om = Rm;
  function Pm(t) {
    (ho.call(this), (this._annotation = t));
  }
  Pm.prototype = r(ho, Pm, {
    get position() {
      return this._annotation.nodePosition();
    }
  });
  const Dm = Pm;
  function zm(t) {
    this._realAnnotation = t;
  }
  function Nm(t) {
    (Hi.call(this), (this._realAnnotation = t), (this.annotation = new zm(t)), (this._renderer = new Zd(this)));
    const e = 2 * this.params.balloonRadius;
    ((this.size = new ki(e, this.params.height + this.params.offset)),
      this._renderer.isFallbackGlyphTextPending && this._renderer.addPendingNode(this),
      (this.needsDisplay = !0));
  }
  ((zm.prototype = {
    constructor: zm,
    glyphText: "",
    get glyphColor() {
      const t = this._realAnnotation.map;
      return t ? Pu.DefaultGlyphColor[t._impl.currentColorScheme] : Pu.DefaultGlyphColor.light;
    },
    isAppStyle: !1,
    isPlaceStyle: !1,
    balloonVisible: !0,
    get fillColor() {
      const t = this._realAnnotation.map;
      return t ? Pu.DefaultColor[t._impl.currentColorScheme] : Pu.DefaultColor.light;
    },
    get haloColor() {
      return null;
    },
    useSquareBalloon: !1
  }),
    (Nm.prototype = r(Hi, Nm, {
      enablesDefaultGlyphImage: !0,
      get position() {
        return this._realAnnotation.nodePosition();
      },
      frozen: !0,
      state: "default",
      params: Su.Params.default,
      stringInfo: function () {
        return "ImageAnnotationFallbackNode";
      },
      freeze: function () {}
    })));
  const Fm = Nm,
    Um = (function (t) {
      function e(e, i, n) {
        if (((this._sceneGraphNode = new Dm(this)), t.call(this, e, i, t.div, n), !this.url))
          throw new Error("[MapKit] No URL for image of ImageAnnotation");
        ((this._waitingForImageSize = !this._userSetSize), this._setSceneGraphNode());
      }
      return (
        (e.prototype = r(t, e, {
          renderedByDOMElement: !1,
          get url() {
            return this._url;
          },
          set url(t) {
            ((this._pendingGlyphImage = t),
              Eu(t, (e) => {
                if (this._pendingGlyphImage !== t) return;
                if ((delete this._pendingGlyphImage, !e))
                  throw new Error("[MapKit] No URL for image of ImageAnnotation");
                const i = e.ratio,
                  n = e.glyphImageUrl;
                ((this._ratio = i),
                  (this._url = t),
                  this._setSceneGraphNode(),
                  this._removeImageEventListener(),
                  (this._sceneGraphNode.image = qn.htmlElement("img", {src: n})).complete
                    ? this.updateSize()
                    : (this._userSetSize || (this._waitingForImageSize = !0), this._addImageEventListener()));
              }),
              (this._url = t));
          },
          centerOffsetForSelectionAccessory() {
            return this._sceneGraphNode instanceof Dm
              ? t.prototype.centerOffsetForSelectionAccessory.call(this)
              : new Mi(-this._sceneGraphNode.params.balloonRadius, -this._sceneGraphNode.params.balloonRadius);
          },
          positionForCallout: function () {
            if (this._sceneGraphNode instanceof Dm) return t.prototype.positionForCallout.call(this);
            const e = this._node.size,
              i = new Mi(-e.width / 2, 0),
              n = this.nodePosition(),
              o = new Mi(0, 1);
            return new Mi(n.x - i.x - o.x, n.y - i.y - o.y);
          },
          calculateNodePosition: function () {
            return this._sceneGraphNode instanceof Dm
              ? t.prototype.calculateNodePosition.call(this)
              : new Mi(this._position.x - this._anchorPoint.x, this._position.y - this._anchorPoint.y);
          },
          handleEvent: function (e) {
            switch (e.type) {
              case "load":
                (this._removeImageEventListener(), this._handleImageLoaded());
                break;
              case "error":
                (this._removeImageEventListener(), this._handleImageError());
                break;
              default:
                return void t.prototype.handleEvent.call(this, e);
            }
          },
          resetNodeTransform: function () {
            this.sceneGraphNode.transform = new Li();
          },
          updateSize: function () {
            let e;
            if (((this._waitingForImageSize = !1), this._sceneGraphNode instanceof Dm)) {
              if (this._userSetSize) e = this._node.size;
              else {
                const t = this._sceneGraphNode.image;
                ((e = new ki(t.naturalWidth / this._ratio, t.naturalHeight / this._ratio)), this.setSize(e));
              }
              this._sceneGraphNode.size = e;
            } else
              ((e = this._sceneGraphNode.size),
                this._userSetSize && console.warn("[MapKit] Size set on the ImageAnnotation is removed."),
                this.setSize(e),
                (this._userSetSize = !1));
            (this._setElementSize(e), t.prototype.updateSize.call(this));
          },
          ConstructorOptions: Object.freeze(Object.assign({}, t.prototype.ConstructorOptions, {url: "rw"})),
          willMoveToMap: function () {
            this._isMoving = this.doesAnimate();
          },
          canShowCallout: function () {
            return !this._waitingForImageSize && t.prototype.canShowCallout.call(this);
          },
          _addImageEventListener: function () {
            (this._sceneGraphNode.image.addEventListener("load", this),
              this._sceneGraphNode.image.addEventListener("error", this));
          },
          _removeImageEventListener: function () {
            this._sceneGraphNode.image &&
              (this._sceneGraphNode.image.removeEventListener("load", this),
              this._sceneGraphNode.image.removeEventListener("error", this));
          },
          _handleImageLoaded: function () {
            this.updateSize();
          },
          _handleImageError: function () {
            (this._sceneGraphNode.image &&
              console.error(
                "[MapKit] Could not load image for ImageAnnotation at URL: " + this._sceneGraphNode.image.src
              ),
              this._setSceneGraphNodeToFallback(),
              this.updatePosition(),
              this.updateSize());
          },
          _setElementSize: function (t) {
            ((this._element.style.width = t.width + "px"), (this._element.style.height = t.height + "px"));
          },
          _setSceneGraphNode: function () {
            if (this._sceneGraphNode instanceof Dm) return;
            const t = this._sceneGraphNode;
            ((this._sceneGraphNode = new Dm(this)), t.parent && t.parent.replaceChild(this._sceneGraphNode, t));
          },
          _setSceneGraphNodeToFallback: function () {
            if (this._sceneGraphNode instanceof Fm) return;
            this._removeImageEventListener();
            const t = this._sceneGraphNode;
            ((this._sceneGraphNode = new Fm(this)), t.parent && t.parent.replaceChild(this._sceneGraphNode, t));
          }
        })),
        e
      );
    })(Sd);
  function Gm(t, e) {
    bo(this, Gm) && Object.defineProperty(this, "_impl", {value: new Um(this, t, e)});
  }
  Gm.prototype = r(Ad, Gm, {
    get url() {
      return this._impl._url;
    },
    set url(t) {
      this._impl.url = t;
    }
  });
  const Bm = {
      AnnotationsController: Tm,
      MapFeaturesLayerController: Om,
      LayerItemsController: xh,
      ItemCollection: Kh,
      PlaceSelectionAccessory: pd,
      MapFeatureType: cp,
      mapkit: {
        MapFeatureType: cp,
        Annotation: Ad,
        PlaceAnnotation: tp,
        PlaceSelectionAccessory: pd,
        ImageAnnotation: Gm,
        MarkerAnnotation: Nu,
        MapFeatureAnnotation: mp.prototype.constructor
      }
    },
    Zm = j,
    Wm = Math.pow(2, 21);
  function Km(t) {
    const e = t.toMapPoint(),
      i = Wm * xe;
    return {x: Math.floor(e.x * i), y: Math.floor(e.y * i), z: 21};
  }
  const Hm = {
      shift: function (t, e) {
        const i = dt.locationShiftUrl;
        !(function (t, e, i) {
          new Zm(
            e,
            {
              getDataToSend: function () {
                return t;
              },
              loaderDidSucceed: function (t, e) {
                if (e.status < 200 || e.status >= 300) i(new Error("HTTP error:" + e.status));
                else
                  try {
                    i(null, JSON.parse(e.responseText));
                  } catch (t) {
                    return void i(new Error("Failed to parse response: " + e.responseText));
                  }
              },
              loaderDidFail: function (t, e) {
                i(new Error("Network error"));
              }
            },
            {method: "POST", withCredentials: dt.withCredentials}
          ).schedule();
        })(JSON.stringify({pixelPoint: Km(t)}), i, function (t, i) {
          t
            ? e(new Error())
            : i && i.shiftedPixelPoint
              ? e(
                  null,
                  (function (t) {
                    function e(t) {
                      return t / Wm / xe;
                    }
                    return new He(e(t.x), e(t.y)).toCoordinate();
                  })(i.shiftedPixelPoint)
                )
              : e(new Error());
        });
      }
    },
    jm = Hm,
    Vm = Ye.MapRect,
    qm = Ye.Coordinate,
    Ym = {Change: "user-location-change", Error: "user-location-error"};
  let Xm = null;
  function $m() {
    ((this._location = null),
      (this._coordinate = null),
      (this._stale = !1),
      (this._watchers = 0),
      dt.addEventListener(dt.Events.Changed, this),
      dt.addEventListener(dt.Events.Error, this));
  }
  $m.prototype = r(M.EventTarget, $m, {
    Events: Ym,
    get location() {
      return this._location;
    },
    get coordinate() {
      return this._coordinate;
    },
    get stale() {
      return this._stale;
    },
    get mapAccuracyRadius() {
      const t = this.location;
      return !this.stale && t.accuracy > 0 ? t.accuracy : 0;
    },
    get isAvailable() {
      return (
        window.navigator.geolocation &&
        "function" == typeof window.navigator.geolocation.watchPosition &&
        "function" == typeof window.navigator.geolocation.getCurrentPosition
      );
    },
    getMapRect: function () {
      const t = (this.location && this.location.accuracy) || 0,
        e = this.coordinate.latitude,
        i = this.coordinate.toMapPoint(),
        n = t * Ye.mapUnitsPerMeterAtLatitude(e);
      return new Vm(i.x - n, i.y - n, 2 * n, 2 * n);
    },
    watch: function () {
      this._watchId ||
        (window.navigator.geolocation.watchPosition
          ? (eg(),
            (this._watchId = window.navigator.geolocation.watchPosition(ng, sg)),
            (Xm = setTimeout(function () {
              (eg(), sg({code: 3, message: "Timeout expired"}));
            }, 15e3)))
          : console.warn("[MapKit] User location is unavailable."));
    },
    locate: function (t, e, i) {
      window.navigator.geolocation.getCurrentPosition
        ? tg && this._watchId
          ? ig(tg, t, e)
          : window.navigator.geolocation.getCurrentPosition(
              function (i) {
                ig(i, t, e);
              },
              e,
              i
            )
        : console.warn("[MapKit] User location is unavailable.");
    },
    addEventListener: function () {
      M.EventTarget.prototype.addEventListener.apply(this, arguments) && ++this._watchers;
    },
    removeEventListener: function () {
      M.EventTarget.prototype.removeEventListener.apply(this, arguments) &&
        (--this._watchers,
        0 === this._watchers &&
          this._watchId &&
          (window.navigator.geolocation.clearWatch(this._watchId), (this._watchId = null)));
    },
    handleEvent: function (t) {
      switch (t.type) {
        case dt.Events.Changed:
        case dt.Events.Error:
          if ((Jm && ((tg = Jm), (Jm = null)), !tg)) return;
          ng(tg);
      }
    },
    reset: function () {
      (eg(), (this._watchers = 0), (this._watchId = null), (tg = null));
    }
  });
  let Jm = null;
  const Qm = new $m();
  let tg;
  function eg() {
    (clearTimeout(Xm), (Xm = null));
  }
  function ig(t, e, i) {
    if ("AutoNavi" === dt.tileProvider) {
      const n = new qm(t.coords.latitude, t.coords.longitude);
      jm.shift(n, function (n, o) {
        if (n) return void (i && i(n));
        const s = {coords: {latitude: o.latitude, longitude: o.longitude}};
        ("accuracy" in t.coords && (s.coords.accuracy = t.coords.accuracy), e && e(s));
      });
    } else e && e(t);
  }
  function ng(t) {
    (eg(),
      (tg = t),
      dt.error
        ? sg({code: 4, message: "MapKit not initialized."})
        : dt.ready
          ? (!Qm._stale &&
              Qm._coordinate &&
              t.coords.latitude === Qm._coordinate.latitude &&
              t.coords.longitude === Qm._coordinate.longitude) ||
            ig(t, og, sg)
          : (Jm = t));
  }
  function og(t) {
    ((Qm._stale = !1),
      (Qm._location = t.coords),
      (Qm._coordinate = new qm(t.coords.latitude, t.coords.longitude)),
      Qm.dispatchEvent(new ag(Qm._coordinate, t.coords.floorLevel)));
  }
  function sg(t) {
    ((Jm = null), (tg = null), (Qm._stale = !0), Qm.dispatchEvent(new rg(t)));
  }
  class ag extends M.Event {
    constructor(t, e) {
      (super(Ym.Change), (this.coordinate = t), (this.floorLevel = e), (this.timestamp = new Date()));
    }
  }
  class rg extends M.Event {
    constructor(t) {
      (super(Ym.Error), (this.code = t.code), (this.message = t.message));
    }
  }
  const lg = Qm;
  function hg(t) {
    ((this._delegate = t), (this._showsUserLocation = !1), (this._tracksUserLocation = !1));
  }
  hg.prototype = {
    constructor: hg,
    get showsUserLocation() {
      return this._showsUserLocation;
    },
    set showsUserLocation(t) {
      !t || lg.isAvailable
        ? ((this._showsUserLocation = t),
          t
            ? (lg.addEventListener(lg.Events.Change, this), lg.addEventListener(lg.Events.Error, this), lg.watch())
            : (lg.removeEventListener(lg.Events.Change, this), lg.removeEventListener(lg.Events.Error, this)))
        : console.warn("[MapKit] User location is unavailable.");
    },
    get tracksUserLocation() {
      return this._tracksUserLocation;
    },
    set tracksUserLocation(t) {
      !t || lg.isAvailable
        ? ((this._tracksUserLocation = t),
          t
            ? (lg.addEventListener(lg.Events.Change, this), lg.addEventListener(lg.Events.Error, this), lg.watch())
            : (lg.removeEventListener(lg.Events.Change, this), lg.removeEventListener(lg.Events.Error, this)))
        : console.warn("[MapKit] User location is unavailable.");
    },
    get userLocation() {
      return lg;
    },
    handleEvent: function (t) {
      switch (t.type) {
        case lg.Events.Change:
          this._handleUserLocationChange(t);
          break;
        case lg.Events.Error:
          this._handleUserLocationError(t);
      }
    },
    mapWasDestroyed: function () {
      (delete this._delegate,
        lg.removeEventListener(lg.Events.Change, this),
        lg.removeEventListener(lg.Events.Error, this));
    },
    _handleUserLocationChange: function (t) {
      ((lg.errorCode = 0), this._delegate.userLocationDidChange(t));
    },
    _handleUserLocationError: function (t) {
      ((lg.errorCode = t.code), this._delegate.userLocationDidError(t));
    }
  };
  const cg = hg,
    dg = [],
    ug = function t() {
      const e = dg.length;
      if (e > 0) {
        for (let t = 0; t < e; ++t) Qt.scheduleASAP(dg[t]);
        Qt.scheduleOnNextFrame(t);
      }
    },
    pg = {
      setIsAnimated: function (t, e) {
        const i = dg.indexOf(t);
        (e && i < 0 && (dg.push(t), 1 === dg.length && Qt.scheduleASAP(ug)), !e && i > -1 && dg.splice(i, 1));
      },
      getIsAnimated: function (t) {
        return dg.indexOf(t) > -1;
      }
    },
    mg = new nc({lineWidth: 2, strokeColor: "white"}),
    gg = function (t, e) {
      const i = lg.location,
        n = void 0 === e ? 56 : e,
        o = ((i && i.accuracy) || 0) <= 3e4;
      return lg.getMapRect().size.width * t >= n && o;
    },
    _g = qn.lerp,
    fg = function (t, e, i) {
      return a((t - e) / (i - e), 0, 1);
    },
    yg = function () {
      const t = lg.location,
        e = (t && t.accuracy) || 0;
      return e > 3e4 ? 0 : e;
    };
  function vg(t) {
    const e = t.coordinate,
      i = yg();
    (xc.call(this, e, i, {style: mg}),
      pg.setIsAnimated(this, !0),
      (this._isRingMode = !1),
      (this._isShown = !1),
      (this._fadeClock = 0));
  }
  ((vg.prototype = r(xc, vg, {
    updateIsShown: function (t, e, i) {
      const n = Date.now(),
        o = gg(e),
        s = o !== this._isRingMode ? n : this._fadeClock,
        a = n - s < 1e3,
        r = this._impl.shown && (o || a);
      (r !== this._isShown && pg.setIsAnimated(this, r),
        (this._impl.shown = r),
        (this._fadeClock = s),
        (this._isRingMode = o),
        (this._isShown = r),
        (this._mapRegion = t),
        (this._worldSize = e),
        (this._colorSchemeOrSatellite = i));
    },
    performScheduledUpdate: function () {
      const t = Date.now(),
        e = lg.stale,
        i = this._mapRegion && this._mapRegion.toMapRect(),
        n = i ? i.size.width * this._worldSize : 0,
        o = lg.getMapRect().size.width * this._worldSize,
        s = sn[Vi],
        a = sn[ji],
        r = this._colorSchemeOrSatellite === Vi ? (e ? s.gray : s.blue) : e ? a.gray : a.blue;
      ((this.style.fillColor = "rgb(" + r.join(",") + ")"),
        (this.style.strokeColor =
          this._colorSchemeOrSatellite === ji ? "rgba(" + s.gray3.join(",") + ", 0.5)" : "white"));
      const l = fg(o, 56, 940),
        h = (e ? 0.2 : 0.14) * ("satellite" === this._colorSchemeOrSatellite ? 2 : 1);
      this.style.fillOpacity = Math.pow(1 - l, 2) * h;
      const c = t - this._fadeClock,
        d = fg(c, 0, 1e3),
        u = this._isRingMode ? d : 1 - d;
      this._impl.node.opacity = u;
      const p = fg(o, 56, n),
        m = _g(p, 2, 2.5),
        g = _g(p, 4, 5),
        _ = (t % 2e3) / 2e3,
        f = qn.easeInOut(1 - Math.abs(2 * _ - 1));
      this.style.lineWidth = _g(f, m, g);
    },
    updateForUserLocation: function (t) {
      ((this.coordinate = lg.coordinate), (this.radius = yg()));
    }
  })),
    Object.defineProperties(vg, {getMode: {value: gg}}));
  const wg = vg;
  function bg(t) {
    (Jn.call(this, t), (this.opacity = null), (this.opacityTime = 0));
  }
  bg.prototype = r(Jn, bg, {
    draw: function (t) {
      const e = this._node._annotation.stale,
        i = this._node._annotation.style,
        n = Date.now(),
        o = n - this.opacityTime,
        s = Math.min(o, 500) / 500,
        a = qn.lerp(s, 1 - this.opacity, this.opacity);
      if (a > 0) {
        const o = i.ANIMATION_HALF_DURATION_MS,
          s = n % i.ANIMATION_DURATION_MS,
          c = qn.easeInOut(s < o ? 1 - s / o : (s - o) / o),
          d = qn.lerp(c, i.ANIMATION_SCALE_TO, i.ANIMATION_SCALE_FROM),
          u = t.globalAlpha,
          p = i.INNER_RADIUS * d,
          m = i.OUTER_RADIUS - p,
          g = p + m / 2,
          _ = i.TOTAL_RADIUS,
          f = i.TOTAL_RADIUS;
        (t.save(),
          (t.globalAlpha = a),
          t.beginPath(),
          t.arc(_, f, g, 0, 2 * Math.PI),
          (t.strokeStyle = "rgb(" + i.OUTER_FILL.join(",") + ")"),
          (t.shadowColor = "rgba(" + i.SHADOW_COLOR.join(",") + ")"),
          (t.shadowBlur = i.SHADOW_BLUR),
          (t.lineWidth = m),
          t.stroke(),
          t.restore(),
          (t.globalAlpha = a),
          t.beginPath(),
          t.arc(_, f, p, 0, 2 * Math.PI),
          (t.fillStyle = e
            ? "rgb(" + i.STALE_FILL.join(",") + ")"
            : ((r = i.ANIMATION_FILL_FROM),
              (l = i.ANIMATION_FILL_TO),
              (h = c),
              "rgb(" + r.map((t, e) => Math.round(t + (l[e] - t) * h)).join(", ") + ")")),
          t.fill(),
          (t.globalAlpha = u));
      }
      var r, l, h;
    }
  });
  const Cg = bg;
  function kg(t) {
    (Hi.call(this), (this._annotation = t), (this._renderer = new Cg(this)));
  }
  kg.prototype = r(Hi, kg, {
    stringInfo: function () {
      return (
        "UserLocationAnnotationNode< " +
        (this._renderer.stale ? "stale " : "live ") +
        (1 !== this._renderer.opacity ? `opacity: ${this._renderer.opacity} ` : "") +
        ">"
      );
    },
    get size() {
      return this._annotation.node.size;
    },
    get position() {
      return this._annotation.nodePosition();
    }
  });
  const Mg = kg;
  function Sg(t, e) {
    const i = sn.default,
      n = {
        INNER_RADIUS: 8,
        OUTER_RADIUS: 11,
        SHADOW_BLUR: 10,
        TOTAL_RADIUS: 0,
        OUTER_FILL: [255, 255, 255],
        STALE_FILL: i.gray2,
        SHADOW_COLOR: [0, 0, 0, 0.25],
        ANIMATION_DURATION_MS: 3e3,
        ANIMATION_HALF_DURATION_MS: 0,
        ANIMATION_SCALE_FROM: 1,
        ANIMATION_SCALE_TO: 0.81,
        ANIMATION_FILL_FROM: i.blue,
        ANIMATION_FILL_TO: i.blue
      };
    ((n.TOTAL_RADIUS = n.OUTER_RADIUS + n.SHADOW_BLUR), (n.ANIMATION_HALF_DURATION_MS = n.ANIMATION_DURATION_MS / 2));
    const o = n.TOTAL_RADIUS,
      s = n.SHADOW_BLUR,
      a = window.DOMPoint;
    ((this.style = n),
      (this.stale = !1),
      (this._animationScheduler = pg),
      (this._anchorOffset = new a(0, -o)),
      (this._calloutAnchorPoint = new a(-o, -s)),
      Sd.call(this, t, e.coordinate, Sd.div),
      this._updateTitleAndSubtitleForLocale());
    const r = 2 * o;
    (this.setSize(new ki(r, r)),
      (this._userSetSize = !0),
      (this._sceneGraphNode = new Mg(this)),
      this.shownPropertyWasUpdated(!0));
  }
  Sg.prototype = r(Sd, Sg, {
    _collisionMode: Sd.CollisionMode.None,
    renderedByDOMElement: !1,
    get coordinate() {
      return this._coordinate;
    },
    set coordinate(t) {
      Object.prototype.hasOwnProperty.call(this, "_coordinate")
        ? console.warn("[MapKit] The `coordinate` property of the user location annotation cannot be set.")
        : (this._coordinate = t.copy());
    },
    get draggable() {
      return !1;
    },
    set draggable(t) {
      console.warn("[MapKit] The `draggable` property of the user location annotation cannot be set.");
    },
    get size() {
      return this._node.size.copy();
    },
    set size(t) {
      console.warn("[MapKit] The `size` property of the user location annotation cannot be set.");
    },
    get node() {
      return this._node;
    },
    handleEvent: function (t) {
      t.type === fi.Events.LocaleChanged && this._updateTitleAndSubtitleForLocale();
    },
    set isRingMode(t) {
      this.enabled = !t;
      const e = this._sceneGraphNode._renderer,
        i = t ? 0 : 1;
      i !== e.opacity && ((e.opacity = i), (e.opacityTime = Date.now()));
    },
    shownPropertyWasUpdated: function (t) {
      pg.setIsAnimated(this, t);
    },
    removedFromMap: function () {
      (pg.setIsAnimated(this, !1), fi.removeEventListener(fi.Events.LocaleChanged, this));
    },
    setCoordinate: function (t) {
      Object.getOwnPropertyDescriptor(Sd.prototype, "coordinate").set.call(this, t);
    },
    performScheduledUpdate: function () {
      const t = this.map && this.map._impl.tint,
        e = this.map && this.map.mapType,
        i = sn[Vi],
        n = sn[ji],
        o = sn[t] || sn.default,
        s = e === Xi.Satellite || e === Xi.Hybrid ? "satellite" : t;
      ((this.style.OUTER_FILL = s === ji ? i.gray3 : [255, 255, 255]),
        (this.style.STALE_FILL = s === Vi ? i.gray : n.gray2),
        (this.style.ANIMATION_FILL_FROM = o.blue),
        (this.style.ANIMATION_FILL_TO = o.blue),
        (this.style.SHADOW_COLOR = [0, 0, 0, s === Vi ? 0.25 : 0.3]),
        (this._sceneGraphNode.needsDisplay = !0));
    },
    _updateTitleAndSubtitleForLocale: function () {
      ((this.title = fi.get("Location.Title")), (this.subtitle = fi.get("Location.Subtitle")));
    }
  });
  const Lg = Sg;
  function Ag(t) {
    Object.defineProperty(this, "_impl", {value: new Lg(this, t)});
  }
  const Eg = function () {
    throw new TypeError("[MapKit] UserLocationAnnotation may not be constructed.");
  };
  Ag.prototype = Eg.prototype = r(Ad, Eg, {
    set coordinate(t) {
      this._impl.coordinate = t;
    },
    get coordinate() {
      return this._impl.coordinate;
    },
    get draggable() {
      return this._impl.draggable;
    },
    set draggable(t) {
      this._impl.draggable = t;
    },
    get size() {
      return this._impl.size;
    },
    set size(t) {
      this._impl.size = t;
    }
  });
  const xg = Ag;
  function Tg(t, e) {
    Object.defineProperty(this, "_impl", {value: new ap(t, e)});
  }
  Tg.prototype = {
    constructor: Tg,
    get getsUserLocation() {
      return this._impl.getsUserLocation;
    },
    set getsUserLocation(t) {
      this._impl.getsUserLocation = t;
    },
    get language() {
      return this._impl.language;
    },
    set language(t) {
      this._impl.language = t;
    },
    cancel: function (t) {
      return this._impl.cancel(t);
    }
  };
  const Ig = Tg,
    Rg = Ye.Coordinate,
    Og = ["language", "getsUserLocation"],
    Pg = ["language", "region", "coordinate", "limitToCountries"],
    Dg = ["language"];
  function zg(t) {
    ((t = p(t)), this._checkOptions(t, Og), ap.call(this, "Geocoder", t));
  }
  zg.prototype = r(ap, zg, {
    constructor: zg,
    lookup: function (t, e, i) {
      const n = {};
      ((i = p(i)),
        this._checkOptions(i, Pg),
        h(t, "[MapKit] Missing `address` in call to `Geocoder.lookup()`."),
        c(t, "string", "[MapKit] `address` passed to `Geocoder.lookup()` is not a string."),
        h(e, "[MapKit] Missing `callback` in call to `Geocoder.lookup()`."),
        c(e, "function", "[MapKit] `callback` passed to `Geocoder.lookup()` is not a function."),
        (n.q = t));
      const o = i.region,
        s = i.coordinate,
        a = i.limitToCountries;
      let r = this.language || dt.language;
      if (o) {
        const t = o.toBoundingRegion();
        n.searchRegion = [t.northLatitude, t.eastLongitude, t.southLatitude, t.westLongitude].join(",");
      } else s && (n.searchLocation = [s.latitude, s.longitude].join(","));
      return (
        i.language && (r = this._bestLanguage(i.language)),
        r && (n.lang = r),
        a && (c(a, "string", "[MapKit] `limitToCountries` is not a string."), (n.limitToCountries = a)),
        this._sendImmediatelyOrWithUserLocation("geocode", n, e, this._transform, "geocode")
      );
    },
    reverseLookup: function (t, e, i) {
      const n = {};
      let o = this.language || dt.language;
      return (
        (i = p(i)),
        this._checkOptions(i, Dg),
        h(t, "[MapKit] Missing `coordinate` in call to `Geocoder.reverseLookup()`."),
        d(t, Rg, "[MapKit] `coordinate` passed to `Geocoder.reverseLookup()` is not a Coordinate."),
        h(e, "[MapKit] Missing `callback` in call to `Geocoder.reverseLookup()`."),
        c(e, "function", "[MapKit] `callback` passed to `Geocoder.reverseLookup()` is not a function."),
        (n.loc = t.latitude + "," + t.longitude),
        i.language && (o = this._bestLanguage(i.language)),
        o && (n.lang = o),
        this._send("reverseGeocode", n, e, this._transform, "reverseGeocode")
      );
    },
    _transform: function (t, e) {
      const i = {status: e.status, results: []};
      return (e.results && (i.results = e.results.map((t) => new ti(t))), i);
    }
  });
  const Ng = zg;
  function Fg(t) {
    bo(this, Fg) && Object.defineProperty(this, "_impl", {value: new Ng(t)});
  }
  Fg.prototype = r(Ig, Fg, {
    constructor: Fg,
    lookup: function (t, e, i) {
      return this._impl.lookup(t, e, i);
    },
    reverseLookup: function (t, e, i) {
      return this._impl.reverseLookup(t, e, i);
    }
  });
  const Ug = Fg,
    Gg = {mapkit: {}};
  [
    Ch,
    $c,
    Bm,
    {
      AnnotationsController: Tm,
      MapFeaturesLayerController: Om,
      OverlaysController: Gh,
      UserLocationController: cg,
      LayerItemsController: xh,
      ItemCollection: Kh,
      AccuracyRingOverlay: wg,
      UserLocationAnnotation: xg,
      Geocoder: Ug,
      userLocation: lg,
      mapkit: {}
    }
  ].forEach(function (t) {
    Object.keys(t).forEach(function (e) {
      "mapkit" !== e
        ? Object.defineProperty(Gg, e, Object.getOwnPropertyDescriptor(t, e))
        : Object.keys(t.mapkit).forEach(function (e) {
            Object.defineProperty(Gg.mapkit, e, Object.getOwnPropertyDescriptor(t.mapkit, e));
          });
    });
  });
  const Bg = Gg,
    Zg = Object.freeze({
      Country: "Country",
      AdministrativeArea: "AdministrativeArea",
      SubAdministrativeArea: "SubAdministrativeArea",
      Locality: "Locality",
      SubLocality: "SubLocality",
      PostalCode: "PostalCode"
    });
  function Wg(t) {
    return t.map(function (t) {
      if (!l(t, Zg)) throw new Error("[MapKit] Unknown category `" + t + "`. Choose from mapkit.AddressCategory.");
      return t;
    });
  }
  function Kg(t) {
    if (void 0 !== (t = p(t)).includes && void 0 !== t.excludes)
      throw new Error("[MapKit] `includes` and `excludes` may not be specified at the same time.");
    if (void 0 === t.includes && void 0 === t.excludes)
      throw new Error("[MapKit] Either `includes` or `excludes` should be specified.");
    (void 0 !== t.includes && (this._includes = Wg(t.includes)),
      void 0 !== t.excludes && (this._excludes = Wg(t.excludes)));
  }
  const Hg = function () {
    throw new Error(
      "[MapKit] `AddressFilter` may not be constructed directly. Use the mapkit.AddressFilter.including or the mapkit.AddressFilter.excluding methods."
    );
  };
  ((Kg.prototype = Hg.prototype =
    {
      constructor: Hg,
      _includes: null,
      _excludes: null,
      includesCategory: function (t) {
        if (!l(t, Zg)) throw new Error("[MapKit] Unknown category `" + t + "`. Choose from mapkit.AddressCategory.");
        return this._includes
          ? -1 !== this._includes.indexOf(t)
          : this._excludes
            ? -1 === this._excludes.indexOf(t)
            : void 0;
      },
      excludesCategory: function (t) {
        if (!l(t, Zg)) throw new Error("[MapKit] Unknown category `" + t + "`. Choose from mapkit.AddressCategory.");
        return this._includes
          ? -1 === this._includes.indexOf(t)
          : this._excludes
            ? -1 !== this._excludes.indexOf(t)
            : void 0;
      }
    }),
    (Kg.including = function (t) {
      return (u(t, "[MapKit] AddressFilter.including expected an array of categories."), new Kg({includes: t}));
    }),
    (Kg.excluding = function (t) {
      return (u(t, "[MapKit] AddressFilter.excluding expected an array of categories."), new Kg({excludes: t}));
    }),
    (Kg.exposedConstructor = Hg),
    Object.defineProperties(Kg, {
      filterIncludingAllCategories: {
        get: function () {
          const t = this.excluding([]);
          return (Object.defineProperty(this, "filterIncludingAllCategories", {value: t, configurable: !0}), t);
        },
        configurable: !0
      },
      filterExcludingAllCategories: {
        get: function () {
          const t = this.including([]);
          return (Object.defineProperty(this, "filterExcludingAllCategories", {value: t, configurable: !0}), t);
        },
        configurable: !0
      }
    }),
    Object.defineProperties(Hg, {
      including: {
        get: function () {
          return Kg.including;
        },
        configurable: !0
      },
      excluding: {
        get: function () {
          return Kg.excluding;
        },
        configurable: !0
      },
      includingAllCategories: {
        get: function () {
          return Kg.filterIncludingAllCategories;
        },
        configurable: !0
      },
      excludingAllCategories: {
        get: function () {
          return Kg.filterExcludingAllCategories;
        },
        configurable: !0
      }
    }));
  const jg = Kg,
    Vg = Object.freeze({Default: "Default", Required: "Required"}),
    qg = Ye.BoundingRegion,
    Yg = Ye.CoordinateRegion,
    Xg = Ye.Coordinate,
    $g = [
      "language",
      "getsUserLocation",
      "coordinate",
      "region",
      "includeAddresses",
      "includePointsOfInterest",
      "includePhysicalFeatures",
      "includeQueries",
      "pointOfInterestFilter",
      "addressFilter",
      "limitToCountries",
      "regionPriority"
    ],
    Jg = [
      "language",
      "region",
      "coordinate",
      "includeAddresses",
      "includePointsOfInterest",
      "includePhysicalFeatures",
      "pointOfInterestFilter",
      "addressFilter",
      "limitToCountries",
      "regionPriority"
    ],
    Qg = Jg.concat(["includeQueries"]);
  function t_(t) {
    ((t = p(t)),
      this._checkOptions(t, $g),
      ap.call(this, "Search", t),
      (this.coordinate = t.coordinate),
      (this.region = t.region),
      void 0 !== t.includeAddresses && (this.includeAddresses = t.includeAddresses),
      void 0 !== t.includePointsOfInterest && (this.includePointsOfInterest = t.includePointsOfInterest),
      void 0 !== t.includePhysicalFeatures && (this.includePhysicalFeatures = t.includePhysicalFeatures),
      void 0 !== t.includeQueries && (this.includeQueries = t.includeQueries),
      void 0 !== t.pointOfInterestFilter && (this.pointOfInterestFilter = t.pointOfInterestFilter),
      void 0 !== t.addressFilter && (this.addressFilter = t.addressFilter),
      void 0 !== t.limitToCountries && (this.limitToCountries = t.limitToCountries),
      void 0 !== t.regionPriority && (this.regionPriority = t.regionPriority));
  }
  ((t_.prototype = r(ap, t_, {
    constructor: t_,
    _coordinate: null,
    _region: null,
    _includeAddresses: !0,
    _includePointsOfInterest: !0,
    _includePhysicalFeatures: void 0,
    _includeQueries: !0,
    _pointOfInterestFilter: null,
    _addressFilter: null,
    _limitToCountries: null,
    _regionPriority: Vg.Default,
    get coordinate() {
      return this._coordinate;
    },
    set coordinate(t) {
      (null != t && (d(t, Xg, "[MapKit] Search.coordinate expected a Coordinate value."), (t = t.copy())),
        (this._coordinate = t || null));
    },
    get region() {
      return this._region;
    },
    set region(t) {
      (null != t && (d(t, Yg, "[MapKit] Search.region expected a CoordinateRegion value."), (t = t.copy())),
        (this._region = t || null));
    },
    get includeAddresses() {
      return this._includeAddresses;
    },
    set includeAddresses(t) {
      this._includeAddresses = !!t;
    },
    get includePointsOfInterest() {
      return this._includePointsOfInterest;
    },
    set includePointsOfInterest(t) {
      this._includePointsOfInterest = !!t;
    },
    get includePhysicalFeatures() {
      return void 0 === this._includePhysicalFeatures ? this._includePointsOfInterest : this._includePhysicalFeatures;
    },
    set includePhysicalFeatures(t) {
      this._includePhysicalFeatures = !!t;
    },
    get includeQueries() {
      return this._includeQueries;
    },
    set includeQueries(t) {
      this._includeQueries = !!t;
    },
    get pointOfInterestFilter() {
      return this._pointOfInterestFilter;
    },
    set pointOfInterestFilter(t) {
      (t &&
        d(
          t,
          yt,
          "[MapKit] Unknown value for `pointOfInterestFilter`. It must be an instance of mapkit.PointOfInterestFilter."
        ),
        (this._pointOfInterestFilter = t || null));
    },
    get addressFilter() {
      return this._addressFilter;
    },
    set addressFilter(t) {
      (t && d(t, jg, "[MapKit] Unknown value for `addressFilter`. It must be an instance of mapkit.AddressFilter."),
        (this._addressFilter = t || null));
    },
    get limitToCountries() {
      return this._limitToCountries;
    },
    set limitToCountries(t) {
      (t && c(t, "string", "[MapKit] `limitToCountries` is not a string."), (this._limitToCountries = t || null));
    },
    get regionPriority() {
      return this._regionPriority;
    },
    set regionPriority(t) {
      if (t && !l(t, Vg))
        throw new Error("[MapKit] Unknown value for `Search.regionPriority`. Choose from Search.RegionPriority.");
      this._regionPriority = t;
    },
    search: function (t, e, i) {
      return ((i = p(i)), this._checkOptions(i, Jg), this._request("search", "search", this._searchTransform, t, e, i));
    },
    autocomplete: function (t, e, i) {
      return (
        (i = p(i)),
        this._checkOptions(i, Qg),
        this._request("autocomplete", "searchAutocomplete", this._autocompleteTransform, t, e, i)
      );
    },
    _request: function (t, e, i, n, o, s) {
      if ("object" == typeof o) {
        const e = o;
        o = function (i, n) {
          const o = "search" === t ? e.searchDidError : e.autocompleteDidError,
            s = "search" === t ? e.searchDidComplete : e.autocompleteDidComplete;
          i ? "function" == typeof o && o.call(e, i) : "function" == typeof s && s.call(e, n);
        };
      }
      const a = {},
        r = "Search." + t + "()";
      if (
        (h(n, "[MapKit] Missing `query` in call to `" + r + "`."),
        h(o, "[MapKit] Missing `callback` in call to `" + r + "`."),
        c(o, "function", "[MapKit] `callback` passed to `" + r + "` is not a function."),
        n instanceof rd)
      )
        e = n._completionUrl;
      else {
        if ("string" != typeof n)
          throw new TypeError(
            "[MapKit] `query` passed to `" + r + "` is neither a string nor SearchAutocompleteResult."
          );
        a.q = n;
      }
      const u = s.region || this.region,
        p = s.coordinate || this.coordinate;
      let m = this.language || dt.language;
      if (u) {
        const t = u.toBoundingRegion();
        a.searchRegion = [t.northLatitude, t.eastLongitude, t.southLatitude, t.westLongitude].join(",");
      } else p && (a.searchLocation = [p.latitude, p.longitude].join(","));
      if (
        (s.language && (m = this._bestLanguage(s.language)),
        m && (a.lang = m),
        s.pointOfInterestFilter &&
          d(
            s.pointOfInterestFilter,
            yt,
            "[MapKit] Unknown value for `pointOfInterestFilter`. It must be an instance of mapkit.PointOfInterestFilter."
          ),
        s.addressFilter &&
          d(
            s.addressFilter,
            jg,
            "[MapKit] Unknown value for `addressFilter`. It must be an instance of mapkit.AddressFilter."
          ),
        s.limitToCountries && c(s.limitToCountries, "string", "[MapKit] `limitToCountries` is not a string."),
        (s.limitToCountries || this.limitToCountries) &&
          (a.limitToCountries = s.limitToCountries || this.limitToCountries),
        s.regionPriority && !l(s.regionPriority, Vg))
      )
        throw new Error("[MapKit] Unknown value for `regionPriority`. Choose from Search.RegionPriority.");
      a.searchRegionPriority = s.regionPriority || this.regionPriority;
      const g = s.pointOfInterestFilter || this.pointOfInterestFilter;
      let _ = !0;
      g &&
        (s.includePointsOfInterest ||
          this.includePointsOfInterest ||
          console.warn("[MapKit] `includePointsOfInterest` is false but `pointOfInterestFilter` is set."),
        g._includes && (0 === g._includes.length ? (_ = !1) : (a.includePoiCategories = g._includes.join(","))),
        g._excludes && (a.excludePoiCategories = g._excludes.join(",")));
      const f = s.addressFilter || this.addressFilter;
      let y = !0;
      f &&
        (s.includeAddresses ||
          this.includeAddresses ||
          console.warn("[MapKit] `includeAddresses` is false but `addressFilter` is set."),
        f._includes && (0 === f._includes.length ? (y = !1) : (a.includeAddressCategories = f._includes.join(","))),
        f._excludes && (a.excludeAddressCategories = f._excludes.join(",")));
      const v = [],
        w = t_.ResultTypeFilterValueMap;
      if (
        (f
          ? y && v.push(w.address)
          : void 0 !== s.includeAddresses
            ? s.includeAddresses && v.push(w.address)
            : this.includeAddresses && v.push(w.address),
        g
          ? _ && v.push(w.poi)
          : void 0 !== s.includePointsOfInterest
            ? s.includePointsOfInterest && v.push(w.poi)
            : this.includePointsOfInterest && v.push(w.poi),
        void 0 !== s.includePhysicalFeatures)
      )
        s.includePhysicalFeatures && v.push(w.physicalFeature);
      else
        switch (this._includePhysicalFeatures) {
          case !0:
            v.push(w.physicalFeature);
            break;
          case !1:
            break;
          case void 0:
            g
              ? _ && v.push(w.physicalFeature)
              : void 0 !== s.includePointsOfInterest
                ? s.includePointsOfInterest && v.push(w.physicalFeature)
                : this.includePointsOfInterest && v.push(w.physicalFeature);
        }
      if (
        ("searchAutocomplete" === e &&
          (void 0 !== s.includeQueries ? s.includeQueries && v.push(w.query) : this.includeQueries && v.push(w.query)),
        0 === v.length)
      )
        throw new Error("[MapKit] At least one of the types needs to be included in the search/autocomplete request.");
      return ((a.resultTypeFilter = v.join(",")), this._sendImmediatelyOrWithUserLocation(e, a, o, i, t));
    },
    _searchTransform: function (t, e) {
      const i = {places: []};
      if ((t.q && (i.query = t.q), e.displayMapRegion)) {
        const t = new qg(
          e.displayMapRegion.northLat,
          e.displayMapRegion.eastLng,
          e.displayMapRegion.southLat,
          e.displayMapRegion.westLng
        );
        i.boundingRegion = t.toCoordinateRegion();
      }
      return (e.results && (i.places = e.results.map((t) => new ti(t))), i);
    },
    _autocompleteTransform: function (t, e) {
      const i = {query: t.q, results: []};
      return (e.results && (i.results = e.results.map((t) => new rd(t))), i);
    }
  })),
    (t_.ResultTypeFilterValueMap = Object.freeze({
      address: "Address",
      poi: "PointOfInterest",
      physicalFeature: "PhysicalFeature",
      query: "Query"
    })));
  const e_ = t_;
  function i_(t) {
    bo(this, i_) && Object.defineProperty(this, "_impl", {value: new e_(t)});
  }
  ((i_.prototype = r(Ig, i_, {
    constructor: i_,
    get coordinate() {
      return this._impl.coordinate;
    },
    set coordinate(t) {
      this._impl.coordinate = t;
    },
    get region() {
      return this._impl.region;
    },
    set region(t) {
      this._impl.region = t;
    },
    get regionPriority() {
      return this._impl.regionPriority;
    },
    set regionPriority(t) {
      this._impl.regionPriority = t;
    },
    get includeAddresses() {
      return this._impl.includeAddresses;
    },
    set includeAddresses(t) {
      this._impl.includeAddresses = t;
    },
    get includePointsOfInterest() {
      return this._impl.includePointsOfInterest;
    },
    set includePointsOfInterest(t) {
      this._impl.includePointsOfInterest = t;
    },
    get includePhysicalFeatures() {
      return this._impl.includePhysicalFeatures;
    },
    set includePhysicalFeatures(t) {
      this._impl.includePhysicalFeatures = t;
    },
    get includeQueries() {
      return this._impl.includeQueries;
    },
    set includeQueries(t) {
      this._impl.includeQueries = t;
    },
    get addressFilter() {
      return this._impl.addressFilter;
    },
    set addressFilter(t) {
      this._impl.addressFilter = t;
    },
    get pointOfInterestFilter() {
      return this._impl.pointOfInterestFilter;
    },
    set pointOfInterestFilter(t) {
      this._impl.pointOfInterestFilter = t;
    },
    get limitToCountries() {
      return this._impl.limitToCountries;
    },
    set limitToCountries(t) {
      this._impl.limitToCountries = t;
    },
    search: function (t, e, i) {
      return this._impl.search(t, e, i);
    },
    autocomplete: function (t, e, i) {
      return this._impl.autocomplete(t, e, i);
    }
  })),
    (i_.RegionPriority = Vg));
  const n_ = i_,
    o_ = ["language"],
    s_ = ["language"];
  function a_(t) {
    ((t = p(t)), this._checkOptions(t, o_), ap.call(this, "PlaceLookup", t));
  }
  a_.prototype = r(ap, a_, {
    constructor: a_,
    getPlace: function (t, e, i) {
      if (((i = p(i)), this._checkOptions(i, s_), "string" != typeof t))
        throw new Error("[MapKit] `id` argument is not a string.");
      const n = i.language ? this._bestLanguage(i.language) : this.language || dt.language,
        o = n ? {lang: n} : {};
      return this._send("place/" + t, o, e, this._transform, "placeLookup");
    },
    _transform: function (t, e) {
      return new ti(e);
    }
  });
  const r_ = a_;
  function l_(t) {
    bo(this, l_) && Object.defineProperty(this, "_impl", {value: new r_(t)});
  }
  l_.prototype = r(Ig, l_, {
    constructor: l_,
    getPlace: function (t, e, i) {
      return this._impl.getPlace(t, e, i);
    }
  });
  const h_ = l_,
    c_ = ["language"],
    d_ = [
      "origin",
      "destination",
      "transportType",
      "requestsAlternateRoutes",
      "arrivalDate",
      "departureDate",
      "avoidTolls"
    ],
    u_ = ["origin", "destinations", "transportType", "departureDate"];
  function p_(t) {
    ((t = p(t)), this._checkOptions(t, c_), ap.call(this, "Directions", t));
  }
  function m_(t, e) {
    if (!(t instanceof Date) || isNaN(t.getTime()))
      throw new TypeError("[MapKit] Expected a `Date` object for `" + e + "`, but got `" + t + "` instead.");
  }
  function g_(t) {
    if ("string" == typeof t) return {q: t};
    if ("object" == typeof t && t.muid) return {muid: t.muid};
    const e = t.coordinate || t;
    if (e instanceof We) return {loc: {lat: e.latitude, lng: e.longitude}};
    throw new Error("[MapKit] Location must be an address (string), Coordinate object or Place object.");
  }
  function __(t, e) {
    return e ? new ti(e) : t instanceof ti ? t : t instanceof We ? t.copy() : void 0;
  }
  function f_(t, e, i) {
    ((this.name = t.name),
      (this.distance = t.distanceMeters),
      (this.expectedTravelTime = t.durationSeconds),
      (this.transportType = t.transportType));
    const n = t.avoidTolls;
    ((this.hasTolls = "boolean" == typeof n ? !n : void 0),
      (this._path = t.stepIndexes.map((t) => i[t])),
      (this.steps = t.stepIndexes.map((t) => e[t])));
  }
  ((p_.Transport = {Automobile: "AUTOMOBILE", Walking: "WALKING"}),
    (p_.prototype = r(ap, p_, {
      constructor: p_,
      eta: function (t, e) {
        if (
          (h(t, "[MapKit] Missing `request` in call to `Directions.eta()`."),
          p(t, "[MapKit] `request` is not a valid object."),
          h(e, "[MapKit] Missing `callback` in call to `Directions.eta()`."),
          c(e, "function", "[MapKit] `callback` passed to `Directions.eta()` is not a function."),
          this._checkOptions(t, u_),
          h(t.origin, "[MapKit] Missing required property `origin` in `request` object."),
          h(t.destinations, "[MapKit] Missing required property `destinations` in `request` object."),
          !Array.isArray(t.destinations))
        )
          throw new Error("[MapKit] Required property `destinations` in `request` object must be an array.");
        if (t.destinations.length > 10)
          throw new Error("[MapKit] `destinations` array must be less than 10 destinations.");
        if (
          (d(t.origin, We, "[MapKit] `origin` property in `request` is not a Coordinate."),
          t.destinations.forEach(function (t) {
            d(t, We, "[MapKit] One of the values in `destinations` property in `request` is not a Coordinate.");
          }),
          "CN" === dt.countryCode)
        )
          return void setTimeout(function () {
            const t = new Error("[MapKit] ETA Requests are not supported in China yet.");
            q(e, null, [t]);
          });
        const i = {
            origin: t.origin.latitude + "," + t.origin.longitude,
            destinations: t.destinations.map((t) => t.latitude + "," + t.longitude).join("|")
          },
          n = t.transportType;
        if (n) {
          for (const t in p_.Transport) n === p_.Transport[t] && (i.transportType = p_.Transport[t]);
          if (!i.transportType)
            throw new TypeError("[MapKit] transportType must be a value of `Directions.Transport`.");
        }
        const o = t.departureDate;
        o && (m_(o, "departureDate"), (i.departureDate = o.toISOString()));
        const s = this.language || dt.language;
        return (s && (i.lang = s), this._send("etas", i, e, (e, i) => this._handleEtaResponse(t, e, i), "etas"));
      },
      route: function (t, e) {
        (h(t, "[MapKit] Missing `request` in call to `Directions.route()`."),
          p(t, "[MapKit] `request` is not a valid object."),
          h(e, "[MapKit] Missing `callback` in call to `Directions.route()`."),
          c(e, "function", "[MapKit] `callback` passed to `Directions.route()` is not a function."),
          this._checkOptions(t, d_));
        const i = {},
          n = t.origin,
          o = t.destination,
          s = t.transportType,
          a = t.arrivalDate,
          r = t.departureDate,
          l = t.avoidTolls,
          d = s === p_.Transport.Automobile,
          u = s === p_.Transport.Walking;
        if (
          (h(n, "[MapKit] Missing required property `origin` in `request` object."),
          h(o, "[MapKit] Missing required property `destination` in `request` object."),
          (i.wps = JSON.stringify([g_(n), g_(o)])),
          s)
        ) {
          if (!d && !u)
            throw new TypeError(
              "[MapKit] transportType must be either Directions.Transport.Automobile or Directions.Transport.Walking."
            );
          i.transport = s;
        }
        var m;
        (a && r
          ? console.warn(
              "[MapKit] `Directions.route()` should not be sent an `arrivalDate` and `departureDate` in the same request. These parameters have been dropped from the request."
            )
          : "CN" === dt.countryCode && (a || r)
            ? console.warn(
                "[MapKit] `arrivalDate` and `departureDate` are not supported in China yet. These parameters have been dropped from the request."
              )
            : a
              ? (m_(a, "arrivalDate"), (i.arrivalDate = a.toISOString()))
              : r && (m_(r, "departureDate"), (i.departureDate = r.toISOString())),
          (m = t),
          Object.prototype.hasOwnProperty.call(m, "requestsAlternateRoutes")
            ? (i.n = t.requestsAlternateRoutes ? "3" : "1")
            : (i.n = "1"));
        const g = this.language || dt.language;
        return (
          g && (i.lang = g),
          l && u
            ? console.warn(
                "[MapKit] When `transportType` is `Directions.Transport.Walking`, the `avoidTolls` parameter has no effect. The `avoidTolls` parameter has been dropped from the request."
              )
            : l && "CN" === dt.countryCode
              ? console.warn(
                  "[MapKit] `avoidTolls` is not supported in China yet. This parameter has been dropped from the request."
                )
              : l && (i.avoid = "tolls"),
          this._send("directions", i, e, (e, i) => this._handleResponse(t, e, i), "directions")
        );
      },
      _handleEtaResponse: function (t, e, i) {
        return {
          request: e,
          origin: t.origin.copy(),
          etas: i.etas.map(function (e, i) {
            return {
              destination: t.destinations[i] ? t.destinations[i].copy() : void 0,
              transportType: e.transportType,
              distance: e.distanceMeters,
              expectedTravelTime: e.expectedTravelTimeSeconds,
              staticTravelTime: e.staticTravelTimeSeconds
            };
          })
        };
      },
      _handleResponse: function (t, e, i) {
        const n = i.stepPaths.map(function (t) {
            return t.map((t) => new We(t.lat, t.lng));
          }),
          o = i.steps.map((t) => new b_(t, n, i.shieldDomains)),
          s = i.routes.map((t) => new f_(t, o, n));
        return {request: e, origin: __(t.origin, i.origin), destination: __(t.destination, i.destination), routes: s};
      }
    })));
  const y_ = function () {
    throw new TypeError("[MapKit] Route may not be constructed.");
  };
  function v_(t) {
    (delete f_.prototype.polyline,
      Object.defineProperty(f_.prototype, "polyline", {
        enumerable: !0,
        configurable: !0,
        get: function () {
          return (
            this._polyline ||
              (this._polyline = new t(
                this._path.reduce(function (t, e) {
                  return t.concat(e);
                }, [])
              )),
            this._polyline
          );
        }
      }));
  }
  ((y_.prototype = f_.prototype =
    {
      constructor: y_,
      get path() {
        return (
          console.warn("[MapKit] The `Route.path` property is deprecated and will be removed in a future release."),
          this._path
        );
      },
      get polyline() {
        throw new Error("[MapKit] Route.polyline is available after loading the following library: overlays.");
      }
    }),
    L.jsModules.mapkit.PolylineOverlay
      ? v_(L.jsModules.mapkit.PolylineOverlay)
      : L.addEventListener("load", function t(e) {
          e.jsModules.mapkit &&
            e.jsModules.mapkit.PolylineOverlay &&
            (L.removeEventListener("load", t), v_(L.jsModules.mapkit.PolylineOverlay));
        }),
    (p_.Route = f_));
  const w_ = [
    "ON_RAMP",
    "OFF_RAMP",
    "HIGHWAY_OFF_RAMP_LEFT",
    "HIGHWAY_OFF_RAMP_RIGHT",
    "CHANGE_HIGHWAY",
    "CHANGE_HIGHWAY_LEFT",
    "CHANGE_HIGHWAY_RIGHT"
  ];
  function b_(t, e, i) {
    if (
      ((this.instructions = t.instructions),
      (this.pathIndex = t.stepPathIndex),
      (this.distance = t.distanceMeters),
      (this.transportType = t.transportType),
      (this.path = e[t.stepPathIndex]),
      !i || !i.length || !t.maneuver)
    )
      return;
    const n = i[t.stepPathIndex % i.length],
      o = t.maneuver;
    let s, a;
    if (o.names && o.names.length) {
      const t = o.names.filter((t) => t.type && t.shieldUrl);
      t.length && (s = "//" + n + t[0].shieldUrl);
    }
    o.arrowUrl && (a = "//" + n + o.arrowUrl);
    const r = s && -1 !== w_.indexOf(o.type);
    this._imageUrl = r ? s : a;
  }
  const C_ = function () {
    throw new TypeError("[MapKit] Step may not be constructed.");
  };
  C_.prototype = b_.prototype = {constructor: C_};
  const k_ = p_;
  function M_(t) {
    bo(this, M_) && Object.defineProperty(this, "_impl", {value: new k_(t)});
  }
  ((M_.Transport = k_.Transport),
    (M_.prototype = r(Ig, M_, {
      constructor: M_,
      eta: function (t, e) {
        return this._impl.eta(t, e);
      },
      route: function (t, e) {
        return this._impl.route(t, e);
      }
    })));
  const S_ = M_,
    L_ = Ye.CoordinateRegion,
    A_ = Ye.Coordinate,
    E_ = ["language", "getsUserLocation", "center", "radius", "region", "pointOfInterestFilter"];
  function x_(t) {
    ((t = p(t)),
      this._checkOptions(t, E_),
      ap.call(this, "PointsOfInterestsSearch", t),
      void 0 !== t.center && (this.center = t.center),
      void 0 !== t.radius && (this.radius = t.radius),
      void 0 !== t.region && (this.region = t.region),
      t.pointOfInterestFilter && (this.pointOfInterestFilter = t.pointOfInterestFilter));
  }
  x_.prototype = r(ap, x_, {
    constructor: x_,
    _center: null,
    _radius: null,
    _region: null,
    _pointOfInterestFilter: null,
    get center() {
      return this._center;
    },
    set center(t) {
      (null != t && (d(t, A_, "[MapKit] PointsOfInterestSearch.center expected a Coordinate value."), (t = t.copy())),
        (this._center = t || null));
    },
    get radius() {
      return this._radius;
    },
    set radius(t) {
      (null != t && c(t, "number", "[MapKit] PointsOfInterestSearch.radius expected a number value."),
        (this._radius = t || null));
    },
    get region() {
      return this._region;
    },
    set region(t) {
      (null != t &&
        (d(t, L_, "[MapKit] PointsOfInterestSearch.region expected a CoordinateRegion value."), (t = t.copy())),
        (this._region = t || null));
    },
    get getsUserLocation() {
      return !1;
    },
    set getsUserLocation(t) {
      throw new TypeError("[MapKit] getsUserLocation on PointsOfInterestSearch has not effect.");
    },
    get pointOfInterestFilter() {
      return this._pointOfInterestFilter;
    },
    set pointOfInterestFilter(t) {
      (t &&
        d(
          t,
          yt,
          "[MapKit] Unknown value for `pointOfInterestFilter`. It must be an instance of mapkit.PointOfInterestFilter."
        ),
        (this._pointOfInterestFilter = t || null));
    },
    search: function (t, e) {
      if (((e = p(e)), this._checkOptions(e, E_), "object" == typeof t)) {
        const e = t;
        t = function (t, i) {
          const n = e.searchDidError,
            o = e.searchDidComplete;
          t ? "function" == typeof n && n.call(e, t) : "function" == typeof o && o.call(e, i);
        };
      }
      if ("CN" === dt.countryCode)
        return void setTimeout(function () {
          const e = new Error("[MapKit] PointsOfInterestSearch is not supported in China yet.");
          q(t, null, [e]);
        });
      const i = {};
      (e.pointOfInterestFilter &&
        d(
          e.pointOfInterestFilter,
          yt,
          "[MapKit] Unknown value for `pointOfInterestFilter`. It must be an instance of mapkit.PointOfInterestFilter."
        ),
        h(t, "[MapKit] Missing `callback` in call to `search`."),
        c(t, "function", "[MapKit] `callback` passed to `search` is not a function."));
      const n = e.center || this.center,
        o = e.radius || this.radius,
        s = e.region || this.region;
      if ((n || o) && s)
        return void setTimeout(function () {
          const e = new Error(
            "[MapKit] Setting both `center`/`radius` and region are not allowed. Expects either a circular region defined by `center`/`radius` or a rectangular region defined by `region`."
          );
          q(t, null, [e]);
        });
      if (!n && !o && !s)
        return void setTimeout(function () {
          const e = new Error(
            "[MapKit] No search region specified. Expects either a circular region defined by `center`/`radius` or a rectangular region defined by `region`."
          );
          q(t, null, [e]);
        });
      if (n || o)
        (d(n, A_, "[MapKit] `center` should be a Coordinate when specify a circular search region."),
          (i.center = [n.latitude, n.longitude].join(",")),
          o && (i.radius = o.toString(10)));
      else if (s) {
        d(s, L_, "[MapKit] `region` should be a CoordinateRegion when specify a rectangular search region.");
        const t = s.toBoundingRegion();
        i.mapRegion = [t.northLatitude, t.eastLongitude, t.southLatitude, t.westLongitude].join(",");
      }
      if (void 0 !== e.getsUserLocation)
        throw Error("[MapKit] getsUserLocation on PointsOfInterestSearch has not effect.");
      let a = this.language || dt.language;
      (e.language && (a = this._bestLanguage(e.language)), a && (i.lang = a));
      const r = e.pointOfInterestFilter || this.pointOfInterestFilter;
      if (r) {
        if (r._includes) {
          if (0 === r._includes.length)
            return void setTimeout(() => q(t, null, [null, this._nearbyPoiTransform(void 0, {})]));
          i.includePoiCategories = r._includes.join(",");
        }
        r._excludes && (i.excludePoiCategories = r._excludes.join(","));
      }
      return this._send("nearbyPoi", i, t, this._nearbyPoiTransform, "nearbyPoi");
    },
    _checkOptions: function (t, e) {
      if ((void 0 !== t.center || void 0 !== t.radius) && void 0 !== t.region)
        throw new Error(
          "[MapKit] Setting both `center`/`radius` and region are not allowed. Expects either a circular region defined by `center`/`radius` or a rectangular region defined by `region`."
        );
      return ap.prototype._checkOptions.call(this, t, e);
    },
    _nearbyPoiTransform: function (t, e) {
      const i = {places: []};
      return (e.results && (i.places = e.results.map((t) => new ti(t))), i);
    }
  });
  const T_ = x_;
  function I_(t) {
    bo(this, I_) && Object.defineProperty(this, "_impl", {value: new T_(t)});
  }
  ((I_.prototype = r(Ig, I_, {
    constructor: I_,
    get center() {
      return this._impl.center;
    },
    set center(t) {
      this._impl.center = t;
    },
    get radius() {
      return this._impl.radius;
    },
    set radius(t) {
      this._impl.radius = t;
    },
    get region() {
      return this._impl.region;
    },
    set region(t) {
      this._impl.region = t;
    },
    get pointOfInterestFilter() {
      return this._impl.pointOfInterestFilter;
    },
    set pointOfInterestFilter(t) {
      this._impl.pointOfInterestFilter = t;
    },
    search: function (t, e) {
      return this._impl.search(t, e);
    }
  })),
    Object.defineProperty(I_, "MaxRadius", {enumerable: !0, value: 2e3}));
  const R_ = I_,
    O_ = {
      userLocation: lg,
      mapkit: {
        CoordinateRegion: Ye.CoordinateRegion,
        CoordinateSpan: Ye.CoordinateSpan,
        Coordinate: Ye.Coordinate,
        BoundingRegion: Ye.BoundingRegion,
        MapPoint: Ye.MapPoint,
        MapRect: Ye.MapRect,
        MapSize: Ye.MapSize,
        Geocoder: Ug,
        Search: n_,
        PlaceLookup: h_,
        Directions: S_,
        PointsOfInterestSearch: R_,
        Place: ti.prototype.constructor,
        SearchAutocompleteResult: rd.prototype.constructor,
        PointOfInterestCategory: mt,
        PointOfInterestFilter: yt.exposedConstructor,
        AddressCategory: Zg,
        AddressFilter: jg.exposedConstructor,
        get filterIncludingAllCategories() {
          return yt.filterIncludingAllCategories;
        },
        get filterExcludingAllCategories() {
          return yt.filterExcludingAllCategories;
        }
      }
    },
    P_ = {
      Feature: "Feature",
      FeatureCollection: "FeatureCollection",
      GeometryCollection: "GeometryCollection",
      MultiPoint: "MultiPoint",
      MultiLineString: "MultiLineString",
      MultiPolygon: "MultiPolygon",
      Point: "Point",
      LineString: "LineString",
      Polygon: "Polygon",
      Position: "Position"
    },
    D_ = {
      Feature: function (t) {
        return z_(t, t.geometry && t.geometry.type);
      },
      FeatureCollection: function (t) {
        if (!(t instanceof Object && t.features instanceof Array)) return !1;
        for (const e in t.features) {
          const i = t.features[e];
          if (i.geometry && !z_(i, i.geometry.type)) return !1;
        }
        return !0;
      },
      Position: function (t) {
        return (function (t) {
          if (!Array.isArray(t) || t.length < 2) return !1;
          for (let e = 0; e < 2; ++e) if ("number" != typeof t[e] || isNaN(t[e])) return !1;
          return !0;
        })(t);
      },
      Point: function (t) {
        return N_(t, P_.Point);
      },
      MultiPoint: function (t) {
        return N_(t, P_.MultiPoint);
      },
      LineString: function (t) {
        return N_(t, P_.LineString);
      },
      MultiLineString: function (t) {
        return N_(t, P_.MultiLineString);
      },
      Polygon: function (t) {
        return N_(t, P_.Polygon);
      },
      MultiPolygon: function (t) {
        return N_(t, P_.MultiPolygon);
      },
      GeometryCollection: function (t) {
        if (!(t instanceof Object && t.geometries instanceof Array)) return !1;
        for (const e in t.features) if (!N_(t, t.geometries[e].type)) return !1;
        return !0;
      }
    };
  function z_(t, e) {
    return t instanceof Object && t.type === P_.Feature && !!N_(t.geometry, e);
  }
  function N_(t, e) {
    return (
      t instanceof Object &&
      (!e || t.type === e) &&
      ((i = t.type) instanceof String || "string" == typeof i) &&
      (t.type === P_.GeometryCollection
        ? D_.GeometryCollection(t)
        : t.type === P_.MultiLineString || t.type === P_.MultiPolygon || t.type === P_.MultiPoint
          ? (function (t) {
              for (let e = 0; e < t.length; e += 1) if (!(t[e] instanceof Array)) return !1;
              return !0;
            })(t.coordinates)
          : t.coordinates instanceof Array)
    );
    var i;
  }
  const F_ = {
      isValid: function (t) {
        return !!D_[t.type] && D_[t.type](t);
      },
      isPosition: function (t) {
        return D_.Position(t);
      }
    },
    U_ = {Point: Nu, LineString: Zc, Polygon: Xc},
    G_ = {MultiPoint: P_.Point, MultiLineString: P_.LineString, MultiPolygon: P_.Polygon},
    B_ = [P_.MultiPoint, P_.MultiLineString, P_.MultiPolygon];
  function Z_(t) {
    this.message = t;
  }
  function W_(t, e, i) {
    const n = function () {
      const e = i(n.collection ? n.collection.items[n.index] : t.scheduledTaskItem);
      n.collection ? (n.collection.items[n.index] = e) : (t.scheduledTaskItem = e);
    };
    return (e && ((n.collection = e), (n.index = e.items.length)), Qt.scheduleInBackground(n, Qt.Priority.Highest), n);
  }
  function K_(t) {
    if (!F_.isPosition(t)) throw new Z_("[MapKit] Expected a GeoJSON Position type, instead got " + t);
    return new We(t[1], t[0]);
  }
  function H_(t, e, i) {
    const n = B_.indexOf(t.type) > -1,
      o = "GeometryCollection" === t.type;
    let s;
    if (n || o) {
      const a = n ? t.coordinates : t.geometries;
      if (n)
        switch (t.type) {
          case P_.MultiPoint:
            s = e.delegate.itemForMultiPoint;
            break;
          case P_.MultiLineString:
            s = e.delegate.itemForMultiLineString;
            break;
          case P_.MultiPolygon:
            s = e.delegate.itemForMultiPolygon;
        }
      o && (s = e.delegate.itemForPoint);
      const r = new Kh([], t);
      return (
        a.forEach(function (i) {
          (n && (i = {type: G_[t.type], coordinates: i}), r.items.push(H_(i, e, r)));
        }),
        e.hasCallbackOrDelegate &&
          W_(e, i, function () {
            return (
              (r._impl.items = r.items.filter(function (t) {
                return !!t;
              })),
              s ? q(s, e.delegate, [r, t], r) : r
            );
          }),
        r
      );
    }
    const a = U_[t.type];
    if (!a) throw new Z_("[MapKit] Expected a GeoJSON " + t.type + " type, instead got " + t);
    const r = (function (t, e) {
      switch (e) {
        case P_.MultiPoint:
        case P_.LineString:
          return t.map((t) => K_(t));
        case P_.Polygon:
          return t.map(function (t) {
            return t.map((t) => K_(t));
          });
        default:
          return K_(t);
      }
    })(t.coordinates, t.type);
    let l, h;
    switch (t.type) {
      case P_.Point:
        ((s = e.delegate.itemForPoint), (l = r));
        break;
      case P_.LineString:
        ((s = e.delegate.itemForLineString), (h = e.delegate.styleForOverlay));
        break;
      case P_.Polygon:
        ((s = e.delegate.itemForPolygon), (h = e.delegate.styleForOverlay));
    }
    function c() {
      const i = new a(r, {data: t}),
        n = s ? q(s, e.delegate, [l || i, t], i) : i;
      return n ? (++e.itemCount, h && (n.style = q(h, e.delegate, [i, t], i)), n) : null;
    }
    return e.hasCallbackOrDelegate ? W_(e, i, c) : c();
  }
  function j_(t, e, i) {
    let n;
    switch (t.type) {
      case P_.Feature:
        return (
          (n = (function (t, e, i) {
            if (null === t.geometry)
              return e.hasCallbackOrDelegate
                ? W_(e, i, function () {
                    return null;
                  })
                : null;
            if (!F_.isValid(t)) throw new Z_("[MapKit] Expected a GeoJSON " + t.type + " type, instead got " + t);
            const n = H_(t.geometry, e, i);
            if (!n) throw new Z_("[MapKit] " + t + " is an unknown GeoJSON type");
            return n;
          })(t, e, i)),
          e.delegate.itemForFeature &&
            W_(e, i, function (i) {
              return q(e.delegate.itemForFeature, e.delegate, [i, t], i);
            }),
          n
        );
      case P_.FeatureCollection:
        return (
          (n = new Kh([], t)),
          t.features.forEach(function (t) {
            const i = j_(t, e, n);
            i && n.items.push(i);
          }),
          e.hasCallbackOrDelegate &&
            W_(e, i, function () {
              return (
                (n._impl.items = n.items.filter((t) => !!t)),
                e.delegate.itemForFeatureCollection ? q(e.delegate.itemForFeatureCollection, e.delegate, [n, t], n) : n
              );
            }),
          n
        );
      case P_.GeometryCollection:
      case P_.MultiPoint:
      case P_.MultiLineString:
      case P_.MultiPolygon:
      case P_.Point:
      case P_.LineString:
      case P_.Polygon:
      case P_.Position:
        return H_(t, e, i);
      default:
        throw "string" == typeof t.type
          ? new Z_('[MapKit] "' + t.type + '" is an unknown GeoJSON type.')
          : new Z_("[MapKit] importGeoJSON expects an object with a known GeoJSON `type` property.");
    }
  }
  Z_.prototype = Object.create(Error.prototype);
  const V_ = function (t, e) {
      const i = {delegate: {}, itemCount: 0, hasCallbackOrDelegate: !1};
      e && ((i.delegate = e), (i.hasCallbackOrDelegate = !0));
      try {
        const n = "[MapKit] importGeoJSON expects an Object and was passed ";
        if (!t) throw new Z_(n + "a falsy value");
        if (!(t instanceof Object)) throw new Z_(n + t);
        if (Array.isArray(t)) throw new Z_(n + "an array");
        let o = j_(t, i);
        return i.hasCallbackOrDelegate
          ? void Qt.scheduleInBackground(function () {
              let n = void 0 === i.scheduledTaskItem ? o : i.scheduledTaskItem;
              (n instanceof Kh || (n = new Kh(n, t)),
                "function" == typeof e
                  ? q(e, null, [null, n])
                  : i.delegate.geoJSONDidComplete
                    ? (0 === i.itemCount &&
                        console.warn(
                          "[MapKit] No item is imported with importGeoJSON, either because GeoJSON has no geometries, or the delegate methods did not return any item."
                        ),
                      q(i.delegate.geoJSONDidComplete, i.delegate, [n, t]))
                    : console.warn(
                        "[MapKit] importGeoJSON was called asynchronously with a delegate object but no `geoJSONDidComplete` method was defined."
                      ));
            }, Qt.Priority.Highest)
          : (o instanceof Kh || (o = new Kh(o, t)), o);
      } catch (n) {
        if (!(n instanceof Z_)) throw n;
        "function" == typeof i.delegate.geoJSONDidError
          ? q(i.delegate.geoJSONDidError, i.delegate, [n, t])
          : "function" == typeof e
            ? q(e, null, [n])
            : console.error(n.message);
      }
    },
    q_ = j,
    Y_ = {
      mapkit: {
        importGeoJSON: function (t, e) {
          const i = "function" == typeof e,
            n = "object" == typeof e && null !== e,
            o = "string" == typeof t;
          if (o && !i && !n)
            throw new Error("[MapKit] For GeoJSON file imports, a callback must be provided as a second argument");
          return o
            ? (function (t, e) {
                const i = new q_(t, {
                  loaderDidSucceed: function (i, n) {
                    let o;
                    try {
                      o = JSON.parse(n.responseText);
                    } catch (i) {
                      return void e(
                        new Error(
                          "[MapKit] The response of " + t + " does not appear to be valid JSON:" + n.responseText
                        )
                      );
                    }
                    e(null, o);
                  },
                  loaderDidFail: function (i, n) {
                    e(new Error("[MapKit] Failed to load " + t));
                  }
                });
                return (i.schedule(), i.id);
              })(t, function (t, o) {
                if (!t) return V_(o, e);
                n && e.geoJSONDidError ? q(e.geoJSONDidError, e, [t]) : i && q(e, null, [t]);
              })
            : V_(t, e);
        }
      }
    },
    X_ = Math.min(qn.devicePixelRatio, 3),
    $_ = (X_ > 1 ? "_" + X_ + "x" : "") + ".png";
  let J_;
  const Q_ = {};
  let tf = [],
    ef = !1;
  function nf(t) {
    (Jn.call(this, t),
      sf ||
        ((sf = !0),
        dt.state !== dt.States.PENDING && dt.state !== dt.States.READY
          ? dt.addEventListener(dt.Events.Initialized, function t() {
              (dt.removeEventListener(dt.Events.Initialized, t), of());
            })
          : of()));
  }
  function of() {
    const t = {};
    function e(e, n) {
      const o = oe.createImageUrl("pins/pin" + (e ? "-" : "") + e + "-" + n + $_),
        s = qn.htmlElement("img", {src: o}),
        a = {
          handleEvent: function (o) {
            switch ((s.removeEventListener("load", a), s.removeEventListener("error", a), o.type)) {
              case "load":
                t[e][n] = s;
                break;
              case "error":
                (console.warn(
                  "[MapKit] Error loading pin annotation image " +
                    o.target.src +
                    "; pin annotations may not display correctly."
                ),
                  (ef = !0));
            }
            (--i,
              0 === i &&
                ((J_ = t),
                tf.forEach((t) => {
                  t.needsDisplay = !0;
                }),
                (tf = void 0)));
          }
        };
      ((s.crossOrigin = ms.getCorsAttribute(dt.distUrlWithCredentials)),
        s.addEventListener("load", a),
        s.addEventListener("error", a));
    }
    let i = ["", "floating", "down1", "down2", "down3"].reduce(function (i, n) {
      return ((t[n] = {}), e(n, "base"), e(n, "head"), i + 2);
    }, 1);
    e("", "shadow");
  }
  nf.prototype = r(Jn, nf, {
    draw: function (t) {
      if (!J_) return void (tf.indexOf(this._node) < 0 && tf.push(this._node));
      const e = this._node,
        i = e.size.width,
        n = e.size.height;
      if (ef)
        return void (function (t, e, i, n) {
          ((t.strokeStyle = "#ff4040"),
            (t.lineWidth = 2),
            t.strokeRect(0, e, i, n - e),
            t.beginPath(),
            t.moveTo(0, e),
            t.lineTo(i, n),
            t.moveTo(0, n),
            t.lineTo(i, e),
            t.stroke());
        })(t, n - e._annotation.size.height, e._annotation.size.width, n);
      const o = e._state,
        s = e._annotation.color;
      if ((Q_[s] || (Q_[s] = {}), !Q_[s][o])) {
        const t = document.createElement("canvas");
        ((t.width = i * X_), (t.height = n * X_));
        const e = t.getContext("2d");
        ((e.fillStyle = s),
          e.fillRect(0, 0, t.width, t.height),
          e.save(),
          (e.globalCompositeOperation = "destination-in"),
          e.drawImage(J_[o].head, 0, 0),
          e.restore(),
          e.drawImage(J_[o].base, 0, 0),
          (Q_[s][o] = t));
      }
      (e.shadowTransform && t.drawImage(J_[""].shadow, e.shadowTransform.e, e.shadowTransform.f, i, n),
        t.drawImage(Q_[s][o], 0, 0, i, n));
    }
  });
  let sf = !1;
  const af = nf;
  function rf(t) {
    (Hi.call(this),
      (this.size = new ki(32, 39)),
      (this._annotation = t),
      (this._renderer = new af(this)),
      this.updateState());
  }
  rf.prototype = r(Hi, rf, {
    get position() {
      return this._annotation.nodePosition();
    },
    stringInfo: function () {
      return "PinAnnotationNode" + (this._state ? "<" + this._state + ">" : "");
    },
    updateState: function (t) {
      ((t = this._annotation.floating ? "floating" : t || ""),
        this._state !== t && ((this._state = t), (this.needsDisplay = !0)));
    }
  });
  const lf = rf,
    hf = [1, 2, 3, 2, 1],
    cf = Math.tan(0.820304748437335);
  function df(t) {
    kd.call(this, t);
  }
  df.prototype = r(kd, df, {
    get isBouncing() {
      return this._bounceAnimationFrameIndex >= 0;
    },
    animateDropAfterLift: function () {
      const t = Math.max(
        this._dropAnimationStartP -
          Math.min((Date.now() - this._dropAfterLiftAnimationStartDate) / this.liftDurationMs, 1),
        0
      );
      let e = this.liftAmount * t;
      ((this._annotation.sceneGraphNode.transform = new Li().translate(0, -e)),
        this._dropAnimationRevert || (e *= 1.25),
        (this._annotation.sceneGraphNode.shadowTransform = new Li().translate(cf * e, -e)),
        0 === t &&
          (delete this._annotation.floating,
          this._annotation.sceneGraphNode.updateState(),
          delete this._dropAfterLiftAnimationStartDate,
          delete this._dropAnimationStartP,
          delete this._dropAnimationRevert,
          this._dequeueNextAnimation()),
        Qt.scheduleOnNextFrame(this));
    },
    animateLift: function () {
      const t = Math.min((Date.now() - this._liftAnimationStartDate) / this.liftDurationMs, 1);
      let e = this.liftAmount * t;
      ((this._annotation.sceneGraphNode.transform = new Li().translate(this.translation.x, this.translation.y - e)),
        this._shadowLiftDamping && (e = this.liftAmount * (1 + 0.25 * t)),
        (this._annotation.sceneGraphNode.shadowTransform = new Li().translate(cf * e, -e)),
        t < 1
          ? (Qt.scheduleOnNextFrame(this), (this._liftAnimationProgress = t))
          : (delete this._liftAnimationStartDate,
            delete this._liftAnimationProgress,
            delete this._shadowLiftDamping,
            this._dequeueNextAnimation()));
    },
    drop: function () {
      const t = this._annotation.position().y;
      ((this._pinVerticalTranslation = -t - 4),
        (this._shadowHorizontalTranslation = cf * -this._pinVerticalTranslation),
        (this._shadowVerticalTranslation = this._pinVerticalTranslation));
      const e =
        t /
        this._annotation.delegate.mapForAnnotation(this._annotation._public)._impl.ensureRenderingFrame().size.height;
      ((this._dropDurationMs = 1e3 * Math.min(0.35 * (e + (1 - e) / 2), 3)),
        (this._dropAnimationStartDate = Date.now()),
        (this._annotation.floating = !0),
        this._annotation.sceneGraphNode.updateState(),
        this._animateDrop(),
        (this._annotation._isAnimating = !0),
        (this._animationQueue = [this._bounce, () => this._annotation.finishedAnimating()]),
        Qt.scheduleOnNextFrame(this));
    },
    dropAnnotationAfterDraggingAndRevertPosition: function (t) {
      const e = () => this._annotation.droppedAfterLift();
      this._bounceAnimationFrameIndex >= 0
        ? (this._animationQueue = [e])
        : (this._liftAnimationStartDate
            ? ((this._dropAnimationStartP = this._liftAnimationProgress),
              delete this._liftAnimationStartDate,
              delete this._liftAnimationProgress)
            : (this._dropAnimationStartP = 1),
          t
            ? (this._dropAfterLift(), (this._animationQueue = [this._bounce, e]))
            : (this._annotation.draggingDidEnd(),
              (this._shadowLiftDamping = !0),
              (this._animationQueue = [this._dropAfterLift, this._bounce, e]),
              kd.prototype.lift.call(this, this.nominalLiftAmount)),
          (this._dropAnimationRevert = t),
          Qt.scheduleOnNextFrame(this));
    },
    lift: function (t) {
      ((this.nominalLiftAmount = t),
        (this._animationQueue = [this._liftAfterBounce]),
        this._bounce(),
        Qt.scheduleOnNextFrame(this));
    },
    setTranslation: function (t) {
      ((this.translation = t),
        this._bounceAnimationFrameIndex >= 0 ||
          this._liftAnimationStartDate ||
          ((this._annotation.sceneGraphNode.transform = new Li().translate(t.x, t.y - this.liftAmount)),
          (this._annotation.sceneGraphNode.shadowTransform = new Li().translate(
            cf * this.liftAmount,
            -this.liftAmount
          ))));
    },
    performScheduledUpdate: function () {
      this._dropAnimationStartDate
        ? this._animateDrop()
        : this._bounceAnimationFrameIndex >= 0
          ? this._animateBounce()
          : kd.prototype.performScheduledUpdate.call(this);
    },
    _animateBounce: function () {
      (this._bounceAnimationFrameIndex < hf.length
        ? (this._annotation.sceneGraphNode.updateState("down" + hf[this._bounceAnimationFrameIndex]),
          ++this._bounceAnimationFrameIndex)
        : (delete this._bounceAnimationFrameIndex, this._dequeueNextAnimation()),
        Qt.scheduleOnNextFrame(this));
    },
    _animateDrop: function () {
      const t = Math.min((Date.now() - this._dropAnimationStartDate) / this._dropDurationMs, 1),
        e = 1 - t;
      ((this._annotation.sceneGraphNode.transform = new Li().translate(0, e * this._pinVerticalTranslation)),
        (this._annotation.sceneGraphNode.shadowTransform = new Li().translate(
          e * this._shadowHorizontalTranslation,
          e * this._shadowVerticalTranslation
        )),
        1 === t &&
          (delete this._pinVerticalTranslation,
          delete this._shadowHorizontalTranslation,
          delete this._shadowVerticalTranslation,
          delete this._dropAnimationStartDate,
          delete this._dropDurationMs,
          (this._annotation.floating = !1),
          this._annotation.sceneGraphNode.updateState(),
          this._dequeueNextAnimation()),
        Qt.scheduleOnNextFrame(this));
    },
    _bounce: function () {
      this._bounceAnimationFrameIndex = 0;
    },
    _dequeueNextAnimation: function () {
      this._animationQueue.length > 0 && this._animationQueue.shift().call(this);
    },
    _dropAfterLift: function () {
      (delete this.translation, (this._dropAfterLiftAnimationStartDate = Date.now()), Qt.scheduleOnNextFrame(this));
    },
    _liftAfterBounce: function () {
      (kd.prototype.lift.call(this, this.nominalLiftAmount),
        (this._annotation.floating = !0),
        this._annotation.sceneGraphNode.updateState());
    }
  });
  const uf = df,
    pf = new ki(15, 36),
    mf = {Red: "#ff3d38", Green: "#54d669", Purple: "#c969e0"},
    gf = new window.DOMPoint(8, 35),
    _f = new window.DOMPoint(-8, 0);
  function ff(t) {
    function e(e, i, n) {
      ((this._animationController = new uf(this)),
        (this._dragController = this._animationController),
        (this._sceneGraphNode = new lf(this)),
        t.call(this, e, i, t.div, n),
        this.setSize(pf));
    }
    return (
      (e.Colors = mf),
      (e.prototype = r(t, e, {
        _animates: !0,
        _color: mf.Red,
        _anchorPoint: gf,
        _calloutAnchorPoint: _f,
        renderedByDOMElement: !1,
        get size() {
          return pf.copy();
        },
        set size(t) {
          console.warn("[MapKit] The `size` property of a pin annotation cannot be set.");
        },
        get color() {
          return this._color;
        },
        set color(t) {
          (c(t, "string", "[MapKit] Expected a string value for PinAnnotation.color, but got `" + t + "` instead"),
            t !== this._color &&
              ((this._color = t), this.updateLocalizedText(), (this._sceneGraphNode.needsDisplay = !0)));
        },
        centerOffsetForSelectionAccessory: () => new Mi(-8, -2),
        get shouldPreventDrag() {
          return this._animationController.isBouncing;
        },
        doesAnimate: function () {
          return this._animates;
        },
        willMoveToMap: function (t) {
          this._isMoving = t && this.animates;
        },
        didMoveToMap: function () {
          const e = this._isMoving;
          (t.prototype.didMoveToMap.call(this),
            this.delegate &&
              e &&
              this.visible &&
              !this._appearanceAnimation &&
              this._shown &&
              ((this._isAnimating = !0), this._animationController.drop()));
        },
        droppedAfterLift: function () {
          (this.resetNodeTransform(), this._sceneGraphNode.updateState(), t.prototype.droppedAfterLift.call(this));
        },
        finishedAnimating: function () {
          (this._sceneGraphNode.updateState(), t.prototype.finishedAnimating.call(this));
        },
        altText: function () {
          return (
            t.prototype.altText.call(this) ||
            (this._color === mf.Green
              ? fi.get("Annotation.Pin.Green.AccessibilityLabel")
              : this._color === mf.Purple
                ? fi.get("Annotation.Pin.Purple.AccessibilityLabel")
                : this._color === mf.Red
                  ? fi.get("Annotation.Pin.Red.AccessibilityLabel")
                  : fi.get("Annotation.Pin.AccessibilityLabel"))
          );
        },
        draggingDidEnd: function () {
          (t.prototype.draggingDidEnd.call(this), t.prototype.updatePosition.call(this));
        },
        dragOffset: new Mi(0, 2),
        ConstructorOptions: Object.freeze(Object.assign({}, t.prototype.ConstructorOptions, {color: "rw"})),
        resetNodeTransform: function () {
          this.sceneGraphNode.transform = new Li();
        }
      })),
      e
    );
  }
  ff.Colors = mf;
  const yf = ff,
    vf = yf(Sd);
  function wf(t, e) {
    bo(this, wf) &&
      (console.warn(
        "[MapKit] mapkit.PinAnnotation is deprecated and will be removed in a future release. Please use the newer mapkit.MarkerAnnotation class instead."
      ),
      Object.defineProperty(this, "_impl", {value: new vf(this, t, e)}));
  }
  ((wf.Colors = yf.Colors),
    (wf.prototype = r(Ad, wf, {
      get size() {
        return this._impl.size;
      },
      set size(t) {
        this._impl.size = t;
      },
      get color() {
        return this._impl._color;
      },
      set color(t) {
        this._impl.color = t;
      }
    })));
  const bf = {mapkit: {}};
  [Bg, {mapkit: {PinAnnotation: wf}}, Y_, O_].forEach(function (t) {
    Object.keys(t).forEach(function (e) {
      "mapkit" !== e
        ? (bf[e] = t[e])
        : Object.keys(t.mapkit).forEach((e) => {
            bf.mapkit[e] = t.mapkit[e];
          });
    });
  });
  const Cf = bf;
  function kf() {
    throw new TypeError("[MapKit] MapKit may not be constructed.");
  }
  const Mf = function (t) {
    const e = new pt.Event(t.type);
    ((e.status = t.status),
      t.message && (e.message = t.message),
      t.responseIdentifier && (e.responseIdentifier = t.responseIdentifier),
      Ef.dispatchEvent(e));
  };
  kf.prototype = r(pt.EventTarget, kf, {
    init: function (t) {
      (dt.init(t), dt.addEventListener(dt.Events.Changed, Mf), dt.addEventListener(dt.Events.Error, Mf));
    },
    get version() {
      return i.version;
    },
    get build() {
      return i.build + "" + dt.buildTags;
    },
    get language() {
      return dt.language;
    },
    set language(t) {
      dt.language = t;
    },
    toString: function () {
      return ["MapKit JS", this.version, "(" + this.build + ")"].join(" ");
    },
    get _tileProvider() {
      return dt.tileProvider;
    },
    get _countryCode() {
      return dt.countryCode;
    },
    set _countryCode(t) {
      dt._c(T).setForcedCountryCode(t);
    },
    _login() {
      dt.login();
    },
    _restore: function () {
      dt._restore();
    },
    get _environment() {
      return dt.environment;
    }
  });
  const Sf = Object.keys({
    importGeoJSON: ["geojson"],
    FeatureVisibility: ["map"],
    CoordinateRegion: ["map", "services"],
    CoordinateSpan: ["map", "services"],
    Coordinate: ["map", "services"],
    BoundingRegion: ["map", "services"],
    MapPoint: ["map", "services"],
    MapRect: ["map", "services"],
    MapSize: ["map", "services"],
    Padding: ["map"],
    CameraZoomRange: ["map"],
    MapFeatureType: ["annotations"],
    Style: ["overlays"],
    LineGradient: ["overlays"],
    CircleOverlay: ["overlays"],
    PolylineOverlay: ["overlays"],
    PolygonOverlay: ["overlays"],
    Geocoder: ["services"],
    Search: ["services"],
    PlaceLookup: ["services"],
    Directions: ["services"],
    PointsOfInterestSearch: ["services"],
    Map: ["map"],
    maps: ["map"],
    Annotation: ["annotations"],
    PinAnnotation: ["annotations"],
    ImageAnnotation: ["annotations"],
    MarkerAnnotation: ["annotations"],
    MapFeatureAnnotation: ["annotations"],
    TileOverlay: ["overlays"],
    Place: ["services"],
    SearchAutocompleteResult: ["services"],
    PointOfInterestCategory: ["map", "services"],
    PointOfInterestFilter: ["map", "services"],
    filterIncludingAllCategories: ["map", "services"],
    filterExcludingAllCategories: ["map", "services"],
    AddressCategory: ["services"],
    AddressFilter: ["services"],
    PlaceDetail: ["map"],
    PlaceSelectionAccessory: ["annotations"]
  });
  let Lf = !1;
  (!(function (t) {
    t.loadAll = function () {
      this._chunkLoaded(Cf, () => this._dispatchLoadEndEvent(["all"]));
    };
  })(L),
    L.addEventListener(L.Events.LOAD, function (t) {
      const e = t.jsModules;
      if (e.mapkit)
        for (const t of Object.keys(e.mapkit)) {
          const i = Sf.indexOf(t);
          (-1 !== i && (delete kf.prototype[t], Sf.splice(i, 1)),
            Object.defineProperty(kf.prototype, t, Object.getOwnPropertyDescriptor(e.mapkit, t)));
        }
      if (!Lf && L.jsModules.css && L.jsModules.utils) {
        const t = L.jsModules.utils.htmlElement("style", L.jsModules.css);
        ((t.nonce = dt.nonce), document.head.appendChild(t), (Lf = !0));
      }
    }));
  const Af = oe.findScriptAndSetBasePath();
  (Af && Af.nonce && ((dt.nonce = Af.nonce), (dt.scriptBaseUrl = oe.scriptBaseUrl)),
    L.loadAll(),
    (function (t) {
      if (!t) return;
      const e = t.dataset.callback,
        i = t.dataset.language,
        n = t.dataset.libraries,
        o = void 0 !== t.dataset.token ? t.dataset.token : t.dataset.initialToken,
        s = t.dataset.distUrl,
        a = t.dataset.proxyPrefix,
        r = t.dataset.countryCode,
        l = !("false" === t.dataset.shouldLogin),
        h = t.dataset.teamId,
        c = {_shouldLogin: l, _teamId: h};
      (t.src && -1 !== t.src.indexOf("sourcemap=1") && (dt.enableSourceMap = !0),
        dt.setPerformanceMarkers(t.dataset.performanceMarkers),
        (e || i || n || void 0 !== o || s || a || r || h) &&
          (i && (c.language = i),
          (o || ("" === o && a)) &&
            (c.authorizationCallback = function (t) {
              t(o);
            }),
          s && (c._distUrl = s),
          a && (c._proxyPrefixes = [a]),
          r && (c.countryCode = r),
          dt.init(c, !0),
          e &&
            setTimeout(function () {
              "function" == typeof window[e] && window[e]();
            })));
    })(Af),
    dt.state !== dt.States.UNINITIALIZED &&
      (dt.addEventListener(dt.Events.Changed, Mf), dt.addEventListener(dt.Events.Error, Mf)));
  const Ef = Object.create(kf.prototype);
  dt.performanceMarkers.loading && performance.mark("mapkit-core-load");
  const xf = Ef;
  (window.mapkit &&
    window.mapkit.init &&
    console.warn("[MapKit] Mapkit namespace already exists; did you import MapKit more than once?"),
    (window.mapkit = xf));
})();
/* eslint-enable */
